var Up = Object.defineProperty;
var Hp = (e, t, n) => t in e ? Up(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var t1 = (e, t, n) => Hp(e, typeof t != "symbol" ? t + "" : t, n);
import * as n1 from "vue";
import { defineComponent as re, computed as P, watch as De, h as et, createApp as Gp, toRef as r1, resolveDynamicComponent as rf, toValue as ce, unref as x, onMounted as Ue, getCurrentInstance as Ar, provide as Wn, isRef as Ht, onBeforeUnmount as Oi, ref as N, reactive as Fn, readonly as qp, inject as da, watchEffect as Er, nextTick as We, shallowRef as Wp, getCurrentScope as Yp, onScopeDispose as Kp, createElementBlock as T, openBlock as C, createCommentVNode as K, createElementVNode as S, toDisplayString as H, withDirectives as ct, createVNode as U, withKeys as wt, withModifiers as Se, vModelText as er, normalizeClass as z, createTextVNode as rt, Fragment as Oe, renderList as Fe, Transition as vr, withCtx as fe, createBlock as ve, useSlots as Bl, renderSlot as Ce, warn as Zp, normalizeStyle as en, mergeProps as zn, vShow as gr, vModelDynamic as Xp, onUnmounted as Ti, cloneVNode as Jp, toRaw as Rt, onBeforeMount as Do, TransitionGroup as a1, createSlots as af, Teleport as Qp, onUpdated as sf, onBeforeUpdate as e8, normalizeProps as i1, guardReactiveProps as s1, markRaw as t8, toHandlers as n8, resolveComponent as Vl, vModelSelect as o1 } from "vue";
import { useRoute as of } from "vue-router";
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
function r8(e, t, n) {
  return (t = i8(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function l1(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function q(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? l1(Object(n), !0).forEach(function(r) {
      r8(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : l1(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function a8(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function i8(e) {
  var t = a8(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
const u1 = () => {
};
let Ul = {}, lf = {}, uf = null, cf = {
  mark: u1,
  measure: u1
};
try {
  typeof window < "u" && (Ul = window), typeof document < "u" && (lf = document), typeof MutationObserver < "u" && (uf = MutationObserver), typeof performance < "u" && (cf = performance);
} catch {
}
const {
  userAgent: c1 = ""
} = Ul.navigator || {}, Pn = Ul, Ve = lf, d1 = uf, _a = cf;
Pn.document;
const $n = !!Ve.documentElement && !!Ve.head && typeof Ve.addEventListener == "function" && typeof Ve.createElement == "function", df = ~c1.indexOf("MSIE") || ~c1.indexOf("Trident/");
var s8 = /fa(s|r|l|t|d|dr|dl|dt|b|k|kd|ss|sr|sl|st|sds|sdr|sdl|sdt)?[\-\ ]/, o8 = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i, ff = {
  classic: {
    fa: "solid",
    fas: "solid",
    "fa-solid": "solid",
    far: "regular",
    "fa-regular": "regular",
    fal: "light",
    "fa-light": "light",
    fat: "thin",
    "fa-thin": "thin",
    fab: "brands",
    "fa-brands": "brands"
  },
  duotone: {
    fa: "solid",
    fad: "solid",
    "fa-solid": "solid",
    "fa-duotone": "solid",
    fadr: "regular",
    "fa-regular": "regular",
    fadl: "light",
    "fa-light": "light",
    fadt: "thin",
    "fa-thin": "thin"
  },
  sharp: {
    fa: "solid",
    fass: "solid",
    "fa-solid": "solid",
    fasr: "regular",
    "fa-regular": "regular",
    fasl: "light",
    "fa-light": "light",
    fast: "thin",
    "fa-thin": "thin"
  },
  "sharp-duotone": {
    fa: "solid",
    fasds: "solid",
    "fa-solid": "solid",
    fasdr: "regular",
    "fa-regular": "regular",
    fasdl: "light",
    "fa-light": "light",
    fasdt: "thin",
    "fa-thin": "thin"
  }
}, l8 = {
  GROUP: "duotone-group",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, pf = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], dt = "classic", Mi = "duotone", u8 = "sharp", c8 = "sharp-duotone", hf = [dt, Mi, u8, c8], d8 = {
  classic: {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  duotone: {
    900: "fad",
    400: "fadr",
    300: "fadl",
    100: "fadt"
  },
  sharp: {
    900: "fass",
    400: "fasr",
    300: "fasl",
    100: "fast"
  },
  "sharp-duotone": {
    900: "fasds",
    400: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, f8 = {
  "Font Awesome 6 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 6 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  "Font Awesome 6 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 6 Duotone": {
    900: "fad",
    400: "fadr",
    normal: "fadr",
    300: "fadl",
    100: "fadt"
  },
  "Font Awesome 6 Sharp": {
    900: "fass",
    400: "fasr",
    normal: "fasr",
    300: "fasl",
    100: "fast"
  },
  "Font Awesome 6 Sharp Duotone": {
    900: "fasds",
    400: "fasdr",
    normal: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, p8 = /* @__PURE__ */ new Map([["classic", {
  defaultShortPrefixId: "fas",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin", "brands"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp", {
  defaultShortPrefixId: "fass",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["duotone", {
  defaultShortPrefixId: "fad",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp-duotone", {
  defaultShortPrefixId: "fasds",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}]]), h8 = {
  classic: {
    solid: "fas",
    regular: "far",
    light: "fal",
    thin: "fat",
    brands: "fab"
  },
  duotone: {
    solid: "fad",
    regular: "fadr",
    light: "fadl",
    thin: "fadt"
  },
  sharp: {
    solid: "fass",
    regular: "fasr",
    light: "fasl",
    thin: "fast"
  },
  "sharp-duotone": {
    solid: "fasds",
    regular: "fasdr",
    light: "fasdl",
    thin: "fasdt"
  }
}, m8 = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], f1 = {
  kit: {
    fak: "kit",
    "fa-kit": "kit"
  },
  "kit-duotone": {
    fakd: "kit-duotone",
    "fa-kit-duotone": "kit-duotone"
  }
}, v8 = ["kit"], g8 = {
  kit: {
    "fa-kit": "fak"
  }
}, b8 = ["fak", "fakd"], $8 = {
  kit: {
    fak: "fa-kit"
  }
}, p1 = {
  kit: {
    kit: "fak"
  },
  "kit-duotone": {
    "kit-duotone": "fakd"
  }
}, wa = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, y8 = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], x8 = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], _8 = {
  "Font Awesome Kit": {
    400: "fak",
    normal: "fak"
  },
  "Font Awesome Kit Duotone": {
    400: "fakd",
    normal: "fakd"
  }
}, w8 = {
  classic: {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
  },
  duotone: {
    "fa-regular": "fadr",
    "fa-light": "fadl",
    "fa-thin": "fadt"
  },
  sharp: {
    "fa-solid": "fass",
    "fa-regular": "fasr",
    "fa-light": "fasl",
    "fa-thin": "fast"
  },
  "sharp-duotone": {
    "fa-solid": "fasds",
    "fa-regular": "fasdr",
    "fa-light": "fasdl",
    "fa-thin": "fasdt"
  }
}, S8 = {
  classic: ["fas", "far", "fal", "fat", "fad"],
  duotone: ["fadr", "fadl", "fadt"],
  sharp: ["fass", "fasr", "fasl", "fast"],
  "sharp-duotone": ["fasds", "fasdr", "fasdl", "fasdt"]
}, Ro = {
  classic: {
    fab: "fa-brands",
    fad: "fa-duotone",
    fal: "fa-light",
    far: "fa-regular",
    fas: "fa-solid",
    fat: "fa-thin"
  },
  duotone: {
    fadr: "fa-regular",
    fadl: "fa-light",
    fadt: "fa-thin"
  },
  sharp: {
    fass: "fa-solid",
    fasr: "fa-regular",
    fasl: "fa-light",
    fast: "fa-thin"
  },
  "sharp-duotone": {
    fasds: "fa-solid",
    fasdr: "fa-regular",
    fasdl: "fa-light",
    fasdt: "fa-thin"
  }
}, C8 = ["fa-solid", "fa-regular", "fa-light", "fa-thin", "fa-duotone", "fa-brands"], jo = ["fa", "fas", "far", "fal", "fat", "fad", "fadr", "fadl", "fadt", "fab", "fass", "fasr", "fasl", "fast", "fasds", "fasdr", "fasdl", "fasdt", ...y8, ...C8], A8 = ["solid", "regular", "light", "thin", "duotone", "brands"], mf = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], E8 = mf.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), O8 = [...Object.keys(S8), ...A8, "2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", wa.GROUP, wa.SWAP_OPACITY, wa.PRIMARY, wa.SECONDARY].concat(mf.map((e) => "".concat(e, "x"))).concat(E8.map((e) => "w-".concat(e))), T8 = {
  "Font Awesome 5 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 5 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal"
  },
  "Font Awesome 5 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 5 Duotone": {
    900: "fad"
  }
};
const pn = "___FONT_AWESOME___", Bo = 16, vf = "fa", gf = "svg-inline--fa", Yn = "data-fa-i2svg", Vo = "data-fa-pseudo-element", M8 = "data-fa-pseudo-element-pending", Hl = "data-prefix", Gl = "data-icon", h1 = "fontawesome-i2svg", k8 = "async", L8 = ["HTML", "HEAD", "STYLE", "SCRIPT"], bf = (() => {
  try {
    return !0;
  } catch {
    return !1;
  }
})();
function fa(e) {
  return new Proxy(e, {
    get(t, n) {
      return n in t ? t[n] : t[dt];
    }
  });
}
const $f = q({}, ff);
$f[dt] = q(q(q(q({}, {
  "fa-duotone": "duotone"
}), ff[dt]), f1.kit), f1["kit-duotone"]);
const F8 = fa($f), Uo = q({}, h8);
Uo[dt] = q(q(q(q({}, {
  duotone: "fad"
}), Uo[dt]), p1.kit), p1["kit-duotone"]);
const m1 = fa(Uo), Ho = q({}, Ro);
Ho[dt] = q(q({}, Ho[dt]), $8.kit);
const ql = fa(Ho), Go = q({}, w8);
Go[dt] = q(q({}, Go[dt]), g8.kit);
fa(Go);
const z8 = s8, yf = "fa-layers-text", P8 = o8, I8 = q({}, d8);
fa(I8);
const N8 = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], ls = l8, D8 = [...v8, ...O8], Yr = Pn.FontAwesomeConfig || {};
function R8(e) {
  var t = Ve.querySelector("script[" + e + "]");
  if (t)
    return t.getAttribute(e);
}
function j8(e) {
  return e === "" ? !0 : e === "false" ? !1 : e === "true" ? !0 : e;
}
Ve && typeof Ve.querySelector == "function" && [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]].forEach((t) => {
  let [n, r] = t;
  const a = j8(R8(n));
  a != null && (Yr[r] = a);
});
const xf = {
  styleDefault: "solid",
  familyDefault: dt,
  cssPrefix: vf,
  replacementClass: gf,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
Yr.familyPrefix && (Yr.cssPrefix = Yr.familyPrefix);
const br = q(q({}, xf), Yr);
br.autoReplaceSvg || (br.observeMutations = !1);
const le = {};
Object.keys(xf).forEach((e) => {
  Object.defineProperty(le, e, {
    enumerable: !0,
    set: function(t) {
      br[e] = t, Kr.forEach((n) => n(le));
    },
    get: function() {
      return br[e];
    }
  });
});
Object.defineProperty(le, "familyPrefix", {
  enumerable: !0,
  set: function(e) {
    br.cssPrefix = e, Kr.forEach((t) => t(le));
  },
  get: function() {
    return br.cssPrefix;
  }
});
Pn.FontAwesomeConfig = le;
const Kr = [];
function B8(e) {
  return Kr.push(e), () => {
    Kr.splice(Kr.indexOf(e), 1);
  };
}
const Sn = Bo, Xt = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function V8(e) {
  if (!e || !$n)
    return;
  const t = Ve.createElement("style");
  t.setAttribute("type", "text/css"), t.innerHTML = e;
  const n = Ve.head.childNodes;
  let r = null;
  for (let a = n.length - 1; a > -1; a--) {
    const i = n[a], s = (i.tagName || "").toUpperCase();
    ["STYLE", "LINK"].indexOf(s) > -1 && (r = i);
  }
  return Ve.head.insertBefore(t, r), e;
}
const U8 = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function Qr() {
  let e = 12, t = "";
  for (; e-- > 0; )
    t += U8[Math.random() * 62 | 0];
  return t;
}
function Or(e) {
  const t = [];
  for (let n = (e || []).length >>> 0; n--; )
    t[n] = e[n];
  return t;
}
function Wl(e) {
  return e.classList ? Or(e.classList) : (e.getAttribute("class") || "").split(" ").filter((t) => t);
}
function _f(e) {
  return "".concat(e).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function H8(e) {
  return Object.keys(e || {}).reduce((t, n) => t + "".concat(n, '="').concat(_f(e[n]), '" '), "").trim();
}
function ki(e) {
  return Object.keys(e || {}).reduce((t, n) => t + "".concat(n, ": ").concat(e[n].trim(), ";"), "");
}
function Yl(e) {
  return e.size !== Xt.size || e.x !== Xt.x || e.y !== Xt.y || e.rotate !== Xt.rotate || e.flipX || e.flipY;
}
function G8(e) {
  let {
    transform: t,
    containerWidth: n,
    iconWidth: r
  } = e;
  const a = {
    transform: "translate(".concat(n / 2, " 256)")
  }, i = "translate(".concat(t.x * 32, ", ").concat(t.y * 32, ") "), s = "scale(".concat(t.size / 16 * (t.flipX ? -1 : 1), ", ").concat(t.size / 16 * (t.flipY ? -1 : 1), ") "), o = "rotate(".concat(t.rotate, " 0 0)"), l = {
    transform: "".concat(i, " ").concat(s, " ").concat(o)
  }, u = {
    transform: "translate(".concat(r / 2 * -1, " -256)")
  };
  return {
    outer: a,
    inner: l,
    path: u
  };
}
function q8(e) {
  let {
    transform: t,
    width: n = Bo,
    height: r = Bo,
    startCentered: a = !1
  } = e, i = "";
  return a && df ? i += "translate(".concat(t.x / Sn - n / 2, "em, ").concat(t.y / Sn - r / 2, "em) ") : a ? i += "translate(calc(-50% + ".concat(t.x / Sn, "em), calc(-50% + ").concat(t.y / Sn, "em)) ") : i += "translate(".concat(t.x / Sn, "em, ").concat(t.y / Sn, "em) "), i += "scale(".concat(t.size / Sn * (t.flipX ? -1 : 1), ", ").concat(t.size / Sn * (t.flipY ? -1 : 1), ") "), i += "rotate(".concat(t.rotate, "deg) "), i;
}
var W8 = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Pro";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Pro";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-regular: normal 400 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-light: normal 300 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-thin: normal 100 1em/1 "Font Awesome 6 Duotone";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-duotone-solid: normal 900 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-regular: normal 400 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-light: normal 300 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-thin: normal 100 1em/1 "Font Awesome 6 Sharp Duotone";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-counter-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(-1 * var(--fa-li-width, 2em));
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  animation-name: fa-beat;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  animation-name: fa-bounce;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  animation-name: fa-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  animation-name: fa-beat-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  animation-name: fa-flip;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  animation-name: fa-shake;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  animation-name: fa-spin;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 2s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  animation-name: fa-spin;
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    animation-delay: -1ms;
    animation-duration: 1ms;
    animation-iteration-count: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }
}
@keyframes fa-beat {
  0%, 90% {
    transform: scale(1);
  }
  45% {
    transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-bounce {
  0% {
    transform: scale(1, 1) translateY(0);
  }
  10% {
    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    transform: scale(1, 1) translateY(0);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-flip {
  50% {
    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-shake {
  0% {
    transform: rotate(-15deg);
  }
  4% {
    transform: rotate(15deg);
  }
  8%, 24% {
    transform: rotate(-18deg);
  }
  12%, 28% {
    transform: rotate(18deg);
  }
  16% {
    transform: rotate(-22deg);
  }
  20% {
    transform: rotate(22deg);
  }
  32% {
    transform: rotate(-12deg);
  }
  36% {
    transform: rotate(12deg);
  }
  40%, 100% {
    transform: rotate(0deg);
  }
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  transform: rotate(90deg);
}

.fa-rotate-180 {
  transform: rotate(180deg);
}

.fa-rotate-270 {
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  transform: scale(-1, -1);
}

.fa-rotate-by {
  transform: rotate(var(--fa-rotate-angle, 0));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}`;
function wf() {
  const e = vf, t = gf, n = le.cssPrefix, r = le.replacementClass;
  let a = W8;
  if (n !== e || r !== t) {
    const i = new RegExp("\\.".concat(e, "\\-"), "g"), s = new RegExp("\\--".concat(e, "\\-"), "g"), o = new RegExp("\\.".concat(t), "g");
    a = a.replace(i, ".".concat(n, "-")).replace(s, "--".concat(n, "-")).replace(o, ".".concat(r));
  }
  return a;
}
let v1 = !1;
function us() {
  le.autoAddCss && !v1 && (V8(wf()), v1 = !0);
}
var Y8 = {
  mixout() {
    return {
      dom: {
        css: wf,
        insertCss: us
      }
    };
  },
  hooks() {
    return {
      beforeDOMElementCreation() {
        us();
      },
      beforeI2svg() {
        us();
      }
    };
  }
};
const hn = Pn || {};
hn[pn] || (hn[pn] = {});
hn[pn].styles || (hn[pn].styles = {});
hn[pn].hooks || (hn[pn].hooks = {});
hn[pn].shims || (hn[pn].shims = []);
var Jt = hn[pn];
const Sf = [], Cf = function() {
  Ve.removeEventListener("DOMContentLoaded", Cf), ti = 1, Sf.map((e) => e());
};
let ti = !1;
$n && (ti = (Ve.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(Ve.readyState), ti || Ve.addEventListener("DOMContentLoaded", Cf));
function K8(e) {
  $n && (ti ? setTimeout(e, 0) : Sf.push(e));
}
function pa(e) {
  const {
    tag: t,
    attributes: n = {},
    children: r = []
  } = e;
  return typeof e == "string" ? _f(e) : "<".concat(t, " ").concat(H8(n), ">").concat(r.map(pa).join(""), "</").concat(t, ">");
}
function g1(e, t, n) {
  if (e && e[t] && e[t][n])
    return {
      prefix: t,
      iconName: n,
      icon: e[t][n]
    };
}
var cs = function(t, n, r, a) {
  var i = Object.keys(t), s = i.length, o = n, l, u, c;
  for (r === void 0 ? (l = 1, c = t[i[0]]) : (l = 0, c = r); l < s; l++)
    u = i[l], c = o(c, t[u], u, t);
  return c;
};
function Z8(e) {
  const t = [];
  let n = 0;
  const r = e.length;
  for (; n < r; ) {
    const a = e.charCodeAt(n++);
    if (a >= 55296 && a <= 56319 && n < r) {
      const i = e.charCodeAt(n++);
      (i & 64512) == 56320 ? t.push(((a & 1023) << 10) + (i & 1023) + 65536) : (t.push(a), n--);
    } else
      t.push(a);
  }
  return t;
}
function qo(e) {
  const t = Z8(e);
  return t.length === 1 ? t[0].toString(16) : null;
}
function X8(e, t) {
  const n = e.length;
  let r = e.charCodeAt(t), a;
  return r >= 55296 && r <= 56319 && n > t + 1 && (a = e.charCodeAt(t + 1), a >= 56320 && a <= 57343) ? (r - 55296) * 1024 + a - 56320 + 65536 : r;
}
function b1(e) {
  return Object.keys(e).reduce((t, n) => {
    const r = e[n];
    return !!r.icon ? t[r.iconName] = r.icon : t[n] = r, t;
  }, {});
}
function Wo(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const {
    skipHooks: r = !1
  } = n, a = b1(t);
  typeof Jt.hooks.addPack == "function" && !r ? Jt.hooks.addPack(e, b1(t)) : Jt.styles[e] = q(q({}, Jt.styles[e] || {}), a), e === "fas" && Wo("fa", t);
}
const {
  styles: ea,
  shims: J8
} = Jt, Af = Object.keys(ql), Q8 = Af.reduce((e, t) => (e[t] = Object.keys(ql[t]), e), {});
let Kl = null, Ef = {}, Of = {}, Tf = {}, Mf = {}, kf = {};
function eh(e) {
  return ~D8.indexOf(e);
}
function th(e, t) {
  const n = t.split("-"), r = n[0], a = n.slice(1).join("-");
  return r === e && a !== "" && !eh(a) ? a : null;
}
const Lf = () => {
  const e = (r) => cs(ea, (a, i, s) => (a[s] = cs(i, r, {}), a), {});
  Ef = e((r, a, i) => (a[3] && (r[a[3]] = i), a[2] && a[2].filter((o) => typeof o == "number").forEach((o) => {
    r[o.toString(16)] = i;
  }), r)), Of = e((r, a, i) => (r[i] = i, a[2] && a[2].filter((o) => typeof o == "string").forEach((o) => {
    r[o] = i;
  }), r)), kf = e((r, a, i) => {
    const s = a[2];
    return r[i] = i, s.forEach((o) => {
      r[o] = i;
    }), r;
  });
  const t = "far" in ea || le.autoFetchSvg, n = cs(J8, (r, a) => {
    const i = a[0];
    let s = a[1];
    const o = a[2];
    return s === "far" && !t && (s = "fas"), typeof i == "string" && (r.names[i] = {
      prefix: s,
      iconName: o
    }), typeof i == "number" && (r.unicodes[i.toString(16)] = {
      prefix: s,
      iconName: o
    }), r;
  }, {
    names: {},
    unicodes: {}
  });
  Tf = n.names, Mf = n.unicodes, Kl = Li(le.styleDefault, {
    family: le.familyDefault
  });
};
B8((e) => {
  Kl = Li(e.styleDefault, {
    family: le.familyDefault
  });
});
Lf();
function Zl(e, t) {
  return (Ef[e] || {})[t];
}
function nh(e, t) {
  return (Of[e] || {})[t];
}
function Gn(e, t) {
  return (kf[e] || {})[t];
}
function Ff(e) {
  return Tf[e] || {
    prefix: null,
    iconName: null
  };
}
function rh(e) {
  const t = Mf[e], n = Zl("fas", e);
  return t || (n ? {
    prefix: "fas",
    iconName: n
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function In() {
  return Kl;
}
const zf = () => ({
  prefix: null,
  iconName: null,
  rest: []
});
function ah(e) {
  let t = dt;
  const n = Af.reduce((r, a) => (r[a] = "".concat(le.cssPrefix, "-").concat(a), r), {});
  return hf.forEach((r) => {
    (e.includes(n[r]) || e.some((a) => Q8[r].includes(a))) && (t = r);
  }), t;
}
function Li(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    family: n = dt
  } = t, r = F8[n][e];
  if (n === Mi && !e)
    return "fad";
  const a = m1[n][e] || m1[n][r], i = e in Jt.styles ? e : null;
  return a || i || null;
}
function ih(e) {
  let t = [], n = null;
  return e.forEach((r) => {
    const a = th(le.cssPrefix, r);
    a ? n = a : r && t.push(r);
  }), {
    iconName: n,
    rest: t
  };
}
function $1(e) {
  return e.sort().filter((t, n, r) => r.indexOf(t) === n);
}
function Fi(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    skipLookups: n = !1
  } = t;
  let r = null;
  const a = jo.concat(x8), i = $1(e.filter((d) => a.includes(d))), s = $1(e.filter((d) => !jo.includes(d))), o = i.filter((d) => (r = d, !pf.includes(d))), [l = null] = o, u = ah(i), c = q(q({}, ih(s)), {}, {
    prefix: Li(l, {
      family: u
    })
  });
  return q(q(q({}, c), uh({
    values: e,
    family: u,
    styles: ea,
    config: le,
    canonical: c,
    givenPrefix: r
  })), sh(n, r, c));
}
function sh(e, t, n) {
  let {
    prefix: r,
    iconName: a
  } = n;
  if (e || !r || !a)
    return {
      prefix: r,
      iconName: a
    };
  const i = t === "fa" ? Ff(a) : {}, s = Gn(r, a);
  return a = i.iconName || s || a, r = i.prefix || r, r === "far" && !ea.far && ea.fas && !le.autoFetchSvg && (r = "fas"), {
    prefix: r,
    iconName: a
  };
}
const oh = hf.filter((e) => e !== dt || e !== Mi), lh = Object.keys(Ro).filter((e) => e !== dt).map((e) => Object.keys(Ro[e])).flat();
function uh(e) {
  const {
    values: t,
    family: n,
    canonical: r,
    givenPrefix: a = "",
    styles: i = {},
    config: s = {}
  } = e, o = n === Mi, l = t.includes("fa-duotone") || t.includes("fad"), u = s.familyDefault === "duotone", c = r.prefix === "fad" || r.prefix === "fa-duotone";
  if (!o && (l || u || c) && (r.prefix = "fad"), (t.includes("fa-brands") || t.includes("fab")) && (r.prefix = "fab"), !r.prefix && oh.includes(n) && (Object.keys(i).find((f) => lh.includes(f)) || s.autoFetchSvg)) {
    const f = p8.get(n).defaultShortPrefixId;
    r.prefix = f, r.iconName = Gn(r.prefix, r.iconName) || r.iconName;
  }
  return (r.prefix === "fa" || a === "fa") && (r.prefix = In() || "fas"), r;
}
class ch {
  constructor() {
    this.definitions = {};
  }
  add() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    const a = n.reduce(this._pullDefinitions, {});
    Object.keys(a).forEach((i) => {
      this.definitions[i] = q(q({}, this.definitions[i] || {}), a[i]), Wo(i, a[i]);
      const s = ql[dt][i];
      s && Wo(s, a[i]), Lf();
    });
  }
  reset() {
    this.definitions = {};
  }
  _pullDefinitions(t, n) {
    const r = n.prefix && n.iconName && n.icon ? {
      0: n
    } : n;
    return Object.keys(r).map((a) => {
      const {
        prefix: i,
        iconName: s,
        icon: o
      } = r[a], l = o[2];
      t[i] || (t[i] = {}), l.length > 0 && l.forEach((u) => {
        typeof u == "string" && (t[i][u] = o);
      }), t[i][s] = o;
    }), t;
  }
}
let y1 = [], fr = {};
const mr = {}, dh = Object.keys(mr);
function fh(e, t) {
  let {
    mixoutsTo: n
  } = t;
  return y1 = e, fr = {}, Object.keys(mr).forEach((r) => {
    dh.indexOf(r) === -1 && delete mr[r];
  }), y1.forEach((r) => {
    const a = r.mixout ? r.mixout() : {};
    if (Object.keys(a).forEach((i) => {
      typeof a[i] == "function" && (n[i] = a[i]), typeof a[i] == "object" && Object.keys(a[i]).forEach((s) => {
        n[i] || (n[i] = {}), n[i][s] = a[i][s];
      });
    }), r.hooks) {
      const i = r.hooks();
      Object.keys(i).forEach((s) => {
        fr[s] || (fr[s] = []), fr[s].push(i[s]);
      });
    }
    r.provides && r.provides(mr);
  }), n;
}
function Yo(e, t) {
  for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), a = 2; a < n; a++)
    r[a - 2] = arguments[a];
  return (fr[e] || []).forEach((s) => {
    t = s.apply(null, [t, ...r]);
  }), t;
}
function Kn(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  (fr[e] || []).forEach((i) => {
    i.apply(null, n);
  });
}
function Nn() {
  const e = arguments[0], t = Array.prototype.slice.call(arguments, 1);
  return mr[e] ? mr[e].apply(null, t) : void 0;
}
function Ko(e) {
  e.prefix === "fa" && (e.prefix = "fas");
  let {
    iconName: t
  } = e;
  const n = e.prefix || In();
  if (t)
    return t = Gn(n, t) || t, g1(Pf.definitions, n, t) || g1(Jt.styles, n, t);
}
const Pf = new ch(), ph = () => {
  le.autoReplaceSvg = !1, le.observeMutations = !1, Kn("noAuto");
}, hh = {
  i2svg: function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return $n ? (Kn("beforeI2svg", e), Nn("pseudoElements2svg", e), Nn("i2svg", e)) : Promise.reject(new Error("Operation requires a DOM of some kind."));
  },
  watch: function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      autoReplaceSvgRoot: t
    } = e;
    le.autoReplaceSvg === !1 && (le.autoReplaceSvg = !0), le.observeMutations = !0, K8(() => {
      vh({
        autoReplaceSvgRoot: t
      }), Kn("watch", e);
    });
  }
}, mh = {
  icon: (e) => {
    if (e === null)
      return null;
    if (typeof e == "object" && e.prefix && e.iconName)
      return {
        prefix: e.prefix,
        iconName: Gn(e.prefix, e.iconName) || e.iconName
      };
    if (Array.isArray(e) && e.length === 2) {
      const t = e[1].indexOf("fa-") === 0 ? e[1].slice(3) : e[1], n = Li(e[0]);
      return {
        prefix: n,
        iconName: Gn(n, t) || t
      };
    }
    if (typeof e == "string" && (e.indexOf("".concat(le.cssPrefix, "-")) > -1 || e.match(z8))) {
      const t = Fi(e.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: t.prefix || In(),
        iconName: Gn(t.prefix, t.iconName) || t.iconName
      };
    }
    if (typeof e == "string") {
      const t = In();
      return {
        prefix: t,
        iconName: Gn(t, e) || e
      };
    }
  }
}, Ot = {
  noAuto: ph,
  config: le,
  dom: hh,
  parse: mh,
  library: Pf,
  findIconDefinition: Ko,
  toHtml: pa
}, vh = function() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const {
    autoReplaceSvgRoot: t = Ve
  } = e;
  (Object.keys(Jt.styles).length > 0 || le.autoFetchSvg) && $n && le.autoReplaceSvg && Ot.dom.i2svg({
    node: t
  });
};
function zi(e, t) {
  return Object.defineProperty(e, "abstract", {
    get: t
  }), Object.defineProperty(e, "html", {
    get: function() {
      return e.abstract.map((n) => pa(n));
    }
  }), Object.defineProperty(e, "node", {
    get: function() {
      if (!$n) return;
      const n = Ve.createElement("div");
      return n.innerHTML = e.html, n.children;
    }
  }), e;
}
function gh(e) {
  let {
    children: t,
    main: n,
    mask: r,
    attributes: a,
    styles: i,
    transform: s
  } = e;
  if (Yl(s) && n.found && !r.found) {
    const {
      width: o,
      height: l
    } = n, u = {
      x: o / l / 2,
      y: 0.5
    };
    a.style = ki(q(q({}, i), {}, {
      "transform-origin": "".concat(u.x + s.x / 16, "em ").concat(u.y + s.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: a,
    children: t
  }];
}
function bh(e) {
  let {
    prefix: t,
    iconName: n,
    children: r,
    attributes: a,
    symbol: i
  } = e;
  const s = i === !0 ? "".concat(t, "-").concat(le.cssPrefix, "-").concat(n) : i;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: q(q({}, a), {}, {
        id: s
      }),
      children: r
    }]
  }];
}
function Xl(e) {
  const {
    icons: {
      main: t,
      mask: n
    },
    prefix: r,
    iconName: a,
    transform: i,
    symbol: s,
    title: o,
    maskId: l,
    titleId: u,
    extra: c,
    watchable: d = !1
  } = e, {
    width: f,
    height: p
  } = n.found ? n : t, h = b8.includes(r), m = [le.replacementClass, a ? "".concat(le.cssPrefix, "-").concat(a) : ""].filter((A) => c.classes.indexOf(A) === -1).filter((A) => A !== "" || !!A).concat(c.classes).join(" ");
  let v = {
    children: [],
    attributes: q(q({}, c.attributes), {}, {
      "data-prefix": r,
      "data-icon": a,
      class: m,
      role: c.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(f, " ").concat(p)
    })
  };
  const g = h && !~c.classes.indexOf("fa-fw") ? {
    width: "".concat(f / p * 16 * 0.0625, "em")
  } : {};
  d && (v.attributes[Yn] = ""), o && (v.children.push({
    tag: "title",
    attributes: {
      id: v.attributes["aria-labelledby"] || "title-".concat(u || Qr())
    },
    children: [o]
  }), delete v.attributes.title);
  const b = q(q({}, v), {}, {
    prefix: r,
    iconName: a,
    main: t,
    mask: n,
    maskId: l,
    transform: i,
    symbol: s,
    styles: q(q({}, g), c.styles)
  }), {
    children: $,
    attributes: y
  } = n.found && t.found ? Nn("generateAbstractMask", b) || {
    children: [],
    attributes: {}
  } : Nn("generateAbstractIcon", b) || {
    children: [],
    attributes: {}
  };
  return b.children = $, b.attributes = y, s ? bh(b) : gh(b);
}
function x1(e) {
  const {
    content: t,
    width: n,
    height: r,
    transform: a,
    title: i,
    extra: s,
    watchable: o = !1
  } = e, l = q(q(q({}, s.attributes), i ? {
    title: i
  } : {}), {}, {
    class: s.classes.join(" ")
  });
  o && (l[Yn] = "");
  const u = q({}, s.styles);
  Yl(a) && (u.transform = q8({
    transform: a,
    startCentered: !0,
    width: n,
    height: r
  }), u["-webkit-transform"] = u.transform);
  const c = ki(u);
  c.length > 0 && (l.style = c);
  const d = [];
  return d.push({
    tag: "span",
    attributes: l,
    children: [t]
  }), i && d.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [i]
  }), d;
}
function $h(e) {
  const {
    content: t,
    title: n,
    extra: r
  } = e, a = q(q(q({}, r.attributes), n ? {
    title: n
  } : {}), {}, {
    class: r.classes.join(" ")
  }), i = ki(r.styles);
  i.length > 0 && (a.style = i);
  const s = [];
  return s.push({
    tag: "span",
    attributes: a,
    children: [t]
  }), n && s.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [n]
  }), s;
}
const {
  styles: ds
} = Jt;
function Zo(e) {
  const t = e[0], n = e[1], [r] = e.slice(4);
  let a = null;
  return Array.isArray(r) ? a = {
    tag: "g",
    attributes: {
      class: "".concat(le.cssPrefix, "-").concat(ls.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(le.cssPrefix, "-").concat(ls.SECONDARY),
        fill: "currentColor",
        d: r[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(le.cssPrefix, "-").concat(ls.PRIMARY),
        fill: "currentColor",
        d: r[1]
      }
    }]
  } : a = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: r
    }
  }, {
    found: !0,
    width: t,
    height: n,
    icon: a
  };
}
const yh = {
  found: !1,
  width: 512,
  height: 512
};
function xh(e, t) {
  !bf && !le.showMissingIcons && e && console.error('Icon with name "'.concat(e, '" and prefix "').concat(t, '" is missing.'));
}
function Xo(e, t) {
  let n = t;
  return t === "fa" && le.styleDefault !== null && (t = In()), new Promise((r, a) => {
    if (n === "fa") {
      const i = Ff(e) || {};
      e = i.iconName || e, t = i.prefix || t;
    }
    if (e && t && ds[t] && ds[t][e]) {
      const i = ds[t][e];
      return r(Zo(i));
    }
    xh(e, t), r(q(q({}, yh), {}, {
      icon: le.showMissingIcons && e ? Nn("missingIconAbstract") || {} : {}
    }));
  });
}
const _1 = () => {
}, Jo = le.measurePerformance && _a && _a.mark && _a.measure ? _a : {
  mark: _1,
  measure: _1
}, Ur = 'FA "6.7.2"', _h = (e) => (Jo.mark("".concat(Ur, " ").concat(e, " begins")), () => If(e)), If = (e) => {
  Jo.mark("".concat(Ur, " ").concat(e, " ends")), Jo.measure("".concat(Ur, " ").concat(e), "".concat(Ur, " ").concat(e, " begins"), "".concat(Ur, " ").concat(e, " ends"));
};
var Jl = {
  begin: _h,
  end: If
};
const Ga = () => {
};
function w1(e) {
  return typeof (e.getAttribute ? e.getAttribute(Yn) : null) == "string";
}
function wh(e) {
  const t = e.getAttribute ? e.getAttribute(Hl) : null, n = e.getAttribute ? e.getAttribute(Gl) : null;
  return t && n;
}
function Sh(e) {
  return e && e.classList && e.classList.contains && e.classList.contains(le.replacementClass);
}
function Ch() {
  return le.autoReplaceSvg === !0 ? qa.replace : qa[le.autoReplaceSvg] || qa.replace;
}
function Ah(e) {
  return Ve.createElementNS("http://www.w3.org/2000/svg", e);
}
function Eh(e) {
  return Ve.createElement(e);
}
function Nf(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    ceFn: n = e.tag === "svg" ? Ah : Eh
  } = t;
  if (typeof e == "string")
    return Ve.createTextNode(e);
  const r = n(e.tag);
  return Object.keys(e.attributes || []).forEach(function(i) {
    r.setAttribute(i, e.attributes[i]);
  }), (e.children || []).forEach(function(i) {
    r.appendChild(Nf(i, {
      ceFn: n
    }));
  }), r;
}
function Oh(e) {
  let t = " ".concat(e.outerHTML, " ");
  return t = "".concat(t, "Font Awesome fontawesome.com "), t;
}
const qa = {
  replace: function(e) {
    const t = e[0];
    if (t.parentNode)
      if (e[1].forEach((n) => {
        t.parentNode.insertBefore(Nf(n), t);
      }), t.getAttribute(Yn) === null && le.keepOriginalSource) {
        let n = Ve.createComment(Oh(t));
        t.parentNode.replaceChild(n, t);
      } else
        t.remove();
  },
  nest: function(e) {
    const t = e[0], n = e[1];
    if (~Wl(t).indexOf(le.replacementClass))
      return qa.replace(e);
    const r = new RegExp("".concat(le.cssPrefix, "-.*"));
    if (delete n[0].attributes.id, n[0].attributes.class) {
      const i = n[0].attributes.class.split(" ").reduce((s, o) => (o === le.replacementClass || o.match(r) ? s.toSvg.push(o) : s.toNode.push(o), s), {
        toNode: [],
        toSvg: []
      });
      n[0].attributes.class = i.toSvg.join(" "), i.toNode.length === 0 ? t.removeAttribute("class") : t.setAttribute("class", i.toNode.join(" "));
    }
    const a = n.map((i) => pa(i)).join(`
`);
    t.setAttribute(Yn, ""), t.innerHTML = a;
  }
};
function S1(e) {
  e();
}
function Df(e, t) {
  const n = typeof t == "function" ? t : Ga;
  if (e.length === 0)
    n();
  else {
    let r = S1;
    le.mutateApproach === k8 && (r = Pn.requestAnimationFrame || S1), r(() => {
      const a = Ch(), i = Jl.begin("mutate");
      e.map(a), i(), n();
    });
  }
}
let Ql = !1;
function Rf() {
  Ql = !0;
}
function Qo() {
  Ql = !1;
}
let ni = null;
function C1(e) {
  if (!d1 || !le.observeMutations)
    return;
  const {
    treeCallback: t = Ga,
    nodeCallback: n = Ga,
    pseudoElementsCallback: r = Ga,
    observeMutationsRoot: a = Ve
  } = e;
  ni = new d1((i) => {
    if (Ql) return;
    const s = In();
    Or(i).forEach((o) => {
      if (o.type === "childList" && o.addedNodes.length > 0 && !w1(o.addedNodes[0]) && (le.searchPseudoElements && r(o.target), t(o.target)), o.type === "attributes" && o.target.parentNode && le.searchPseudoElements && r(o.target.parentNode), o.type === "attributes" && w1(o.target) && ~N8.indexOf(o.attributeName))
        if (o.attributeName === "class" && wh(o.target)) {
          const {
            prefix: l,
            iconName: u
          } = Fi(Wl(o.target));
          o.target.setAttribute(Hl, l || s), u && o.target.setAttribute(Gl, u);
        } else Sh(o.target) && n(o.target);
    });
  }), $n && ni.observe(a, {
    childList: !0,
    attributes: !0,
    characterData: !0,
    subtree: !0
  });
}
function Th() {
  ni && ni.disconnect();
}
function Mh(e) {
  const t = e.getAttribute("style");
  let n = [];
  return t && (n = t.split(";").reduce((r, a) => {
    const i = a.split(":"), s = i[0], o = i.slice(1);
    return s && o.length > 0 && (r[s] = o.join(":").trim()), r;
  }, {})), n;
}
function kh(e) {
  const t = e.getAttribute("data-prefix"), n = e.getAttribute("data-icon"), r = e.innerText !== void 0 ? e.innerText.trim() : "";
  let a = Fi(Wl(e));
  return a.prefix || (a.prefix = In()), t && n && (a.prefix = t, a.iconName = n), a.iconName && a.prefix || (a.prefix && r.length > 0 && (a.iconName = nh(a.prefix, e.innerText) || Zl(a.prefix, qo(e.innerText))), !a.iconName && le.autoFetchSvg && e.firstChild && e.firstChild.nodeType === Node.TEXT_NODE && (a.iconName = e.firstChild.data)), a;
}
function Lh(e) {
  const t = Or(e.attributes).reduce((a, i) => (a.name !== "class" && a.name !== "style" && (a[i.name] = i.value), a), {}), n = e.getAttribute("title"), r = e.getAttribute("data-fa-title-id");
  return le.autoA11y && (n ? t["aria-labelledby"] = "".concat(le.replacementClass, "-title-").concat(r || Qr()) : (t["aria-hidden"] = "true", t.focusable = "false")), t;
}
function Fh() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: Xt,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function A1(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  };
  const {
    iconName: n,
    prefix: r,
    rest: a
  } = kh(e), i = Lh(e), s = Yo("parseNodeAttributes", {}, e);
  let o = t.styleParser ? Mh(e) : [];
  return q({
    iconName: n,
    title: e.getAttribute("title"),
    titleId: e.getAttribute("data-fa-title-id"),
    prefix: r,
    transform: Xt,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: a,
      styles: o,
      attributes: i
    }
  }, s);
}
const {
  styles: zh
} = Jt;
function jf(e) {
  const t = le.autoReplaceSvg === "nest" ? A1(e, {
    styleParser: !1
  }) : A1(e);
  return ~t.extra.classes.indexOf(yf) ? Nn("generateLayersText", e, t) : Nn("generateSvgReplacementMutation", e, t);
}
function Ph() {
  return [...m8, ...jo];
}
function E1(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!$n) return Promise.resolve();
  const n = Ve.documentElement.classList, r = (c) => n.add("".concat(h1, "-").concat(c)), a = (c) => n.remove("".concat(h1, "-").concat(c)), i = le.autoFetchSvg ? Ph() : pf.concat(Object.keys(zh));
  i.includes("fa") || i.push("fa");
  const s = [".".concat(yf, ":not([").concat(Yn, "])")].concat(i.map((c) => ".".concat(c, ":not([").concat(Yn, "])"))).join(", ");
  if (s.length === 0)
    return Promise.resolve();
  let o = [];
  try {
    o = Or(e.querySelectorAll(s));
  } catch {
  }
  if (o.length > 0)
    r("pending"), a("complete");
  else
    return Promise.resolve();
  const l = Jl.begin("onTree"), u = o.reduce((c, d) => {
    try {
      const f = jf(d);
      f && c.push(f);
    } catch (f) {
      bf || f.name === "MissingIcon" && console.error(f);
    }
    return c;
  }, []);
  return new Promise((c, d) => {
    Promise.all(u).then((f) => {
      Df(f, () => {
        r("active"), r("complete"), a("pending"), typeof t == "function" && t(), l(), c();
      });
    }).catch((f) => {
      l(), d(f);
    });
  });
}
function Ih(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  jf(e).then((n) => {
    n && Df([n], t);
  });
}
function Nh(e) {
  return function(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = (t || {}).icon ? t : Ko(t || {});
    let {
      mask: a
    } = n;
    return a && (a = (a || {}).icon ? a : Ko(a || {})), e(r, q(q({}, n), {}, {
      mask: a
    }));
  };
}
const Dh = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    transform: n = Xt,
    symbol: r = !1,
    mask: a = null,
    maskId: i = null,
    title: s = null,
    titleId: o = null,
    classes: l = [],
    attributes: u = {},
    styles: c = {}
  } = t;
  if (!e) return;
  const {
    prefix: d,
    iconName: f,
    icon: p
  } = e;
  return zi(q({
    type: "icon"
  }, e), () => (Kn("beforeDOMElementCreation", {
    iconDefinition: e,
    params: t
  }), le.autoA11y && (s ? u["aria-labelledby"] = "".concat(le.replacementClass, "-title-").concat(o || Qr()) : (u["aria-hidden"] = "true", u.focusable = "false")), Xl({
    icons: {
      main: Zo(p),
      mask: a ? Zo(a.icon) : {
        found: !1,
        width: null,
        height: null,
        icon: {}
      }
    },
    prefix: d,
    iconName: f,
    transform: q(q({}, Xt), n),
    symbol: r,
    title: s,
    maskId: i,
    titleId: o,
    extra: {
      attributes: u,
      styles: c,
      classes: l
    }
  })));
};
var Rh = {
  mixout() {
    return {
      icon: Nh(Dh)
    };
  },
  hooks() {
    return {
      mutationObserverCallbacks(e) {
        return e.treeCallback = E1, e.nodeCallback = Ih, e;
      }
    };
  },
  provides(e) {
    e.i2svg = function(t) {
      const {
        node: n = Ve,
        callback: r = () => {
        }
      } = t;
      return E1(n, r);
    }, e.generateSvgReplacementMutation = function(t, n) {
      const {
        iconName: r,
        title: a,
        titleId: i,
        prefix: s,
        transform: o,
        symbol: l,
        mask: u,
        maskId: c,
        extra: d
      } = n;
      return new Promise((f, p) => {
        Promise.all([Xo(r, s), u.iconName ? Xo(u.iconName, u.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then((h) => {
          let [m, v] = h;
          f([t, Xl({
            icons: {
              main: m,
              mask: v
            },
            prefix: s,
            iconName: r,
            transform: o,
            symbol: l,
            maskId: c,
            title: a,
            titleId: i,
            extra: d,
            watchable: !0
          })]);
        }).catch(p);
      });
    }, e.generateAbstractIcon = function(t) {
      let {
        children: n,
        attributes: r,
        main: a,
        transform: i,
        styles: s
      } = t;
      const o = ki(s);
      o.length > 0 && (r.style = o);
      let l;
      return Yl(i) && (l = Nn("generateAbstractTransformGrouping", {
        main: a,
        transform: i,
        containerWidth: a.width,
        iconWidth: a.width
      })), n.push(l || a.icon), {
        children: n,
        attributes: r
      };
    };
  }
}, jh = {
  mixout() {
    return {
      layer(e) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          classes: n = []
        } = t;
        return zi({
          type: "layer"
        }, () => {
          Kn("beforeDOMElementCreation", {
            assembler: e,
            params: t
          });
          let r = [];
          return e((a) => {
            Array.isArray(a) ? a.map((i) => {
              r = r.concat(i.abstract);
            }) : r = r.concat(a.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(le.cssPrefix, "-layers"), ...n].join(" ")
            },
            children: r
          }];
        });
      }
    };
  }
}, Bh = {
  mixout() {
    return {
      counter(e) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          title: n = null,
          classes: r = [],
          attributes: a = {},
          styles: i = {}
        } = t;
        return zi({
          type: "counter",
          content: e
        }, () => (Kn("beforeDOMElementCreation", {
          content: e,
          params: t
        }), $h({
          content: e.toString(),
          title: n,
          extra: {
            attributes: a,
            styles: i,
            classes: ["".concat(le.cssPrefix, "-layers-counter"), ...r]
          }
        })));
      }
    };
  }
}, Vh = {
  mixout() {
    return {
      text(e) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          transform: n = Xt,
          title: r = null,
          classes: a = [],
          attributes: i = {},
          styles: s = {}
        } = t;
        return zi({
          type: "text",
          content: e
        }, () => (Kn("beforeDOMElementCreation", {
          content: e,
          params: t
        }), x1({
          content: e,
          transform: q(q({}, Xt), n),
          title: r,
          extra: {
            attributes: i,
            styles: s,
            classes: ["".concat(le.cssPrefix, "-layers-text"), ...a]
          }
        })));
      }
    };
  },
  provides(e) {
    e.generateLayersText = function(t, n) {
      const {
        title: r,
        transform: a,
        extra: i
      } = n;
      let s = null, o = null;
      if (df) {
        const l = parseInt(getComputedStyle(t).fontSize, 10), u = t.getBoundingClientRect();
        s = u.width / l, o = u.height / l;
      }
      return le.autoA11y && !r && (i.attributes["aria-hidden"] = "true"), Promise.resolve([t, x1({
        content: t.innerHTML,
        width: s,
        height: o,
        transform: a,
        title: r,
        extra: i,
        watchable: !0
      })]);
    };
  }
};
const Uh = new RegExp('"', "ug"), O1 = [1105920, 1112319], T1 = q(q(q(q({}, {
  FontAwesome: {
    normal: "fas",
    400: "fas"
  }
}), f8), T8), _8), el = Object.keys(T1).reduce((e, t) => (e[t.toLowerCase()] = T1[t], e), {}), Hh = Object.keys(el).reduce((e, t) => {
  const n = el[t];
  return e[t] = n[900] || [...Object.entries(n)][0][1], e;
}, {});
function Gh(e) {
  const t = e.replace(Uh, ""), n = X8(t, 0), r = n >= O1[0] && n <= O1[1], a = t.length === 2 ? t[0] === t[1] : !1;
  return {
    value: qo(a ? t[0] : t),
    isSecondary: r || a
  };
}
function qh(e, t) {
  const n = e.replace(/^['"]|['"]$/g, "").toLowerCase(), r = parseInt(t), a = isNaN(r) ? "normal" : r;
  return (el[n] || {})[a] || Hh[n];
}
function M1(e, t) {
  const n = "".concat(M8).concat(t.replace(":", "-"));
  return new Promise((r, a) => {
    if (e.getAttribute(n) !== null)
      return r();
    const s = Or(e.children).filter((f) => f.getAttribute(Vo) === t)[0], o = Pn.getComputedStyle(e, t), l = o.getPropertyValue("font-family"), u = l.match(P8), c = o.getPropertyValue("font-weight"), d = o.getPropertyValue("content");
    if (s && !u)
      return e.removeChild(s), r();
    if (u && d !== "none" && d !== "") {
      const f = o.getPropertyValue("content");
      let p = qh(l, c);
      const {
        value: h,
        isSecondary: m
      } = Gh(f), v = u[0].startsWith("FontAwesome");
      let g = Zl(p, h), b = g;
      if (v) {
        const $ = rh(h);
        $.iconName && $.prefix && (g = $.iconName, p = $.prefix);
      }
      if (g && !m && (!s || s.getAttribute(Hl) !== p || s.getAttribute(Gl) !== b)) {
        e.setAttribute(n, b), s && e.removeChild(s);
        const $ = Fh(), {
          extra: y
        } = $;
        y.attributes[Vo] = t, Xo(g, p).then((A) => {
          const E = Xl(q(q({}, $), {}, {
            icons: {
              main: A,
              mask: zf()
            },
            prefix: p,
            iconName: b,
            extra: y,
            watchable: !0
          })), L = Ve.createElementNS("http://www.w3.org/2000/svg", "svg");
          t === "::before" ? e.insertBefore(L, e.firstChild) : e.appendChild(L), L.outerHTML = E.map((D) => pa(D)).join(`
`), e.removeAttribute(n), r();
        }).catch(a);
      } else
        r();
    } else
      r();
  });
}
function Wh(e) {
  return Promise.all([M1(e, "::before"), M1(e, "::after")]);
}
function Yh(e) {
  return e.parentNode !== document.head && !~L8.indexOf(e.tagName.toUpperCase()) && !e.getAttribute(Vo) && (!e.parentNode || e.parentNode.tagName !== "svg");
}
function k1(e) {
  if ($n)
    return new Promise((t, n) => {
      const r = Or(e.querySelectorAll("*")).filter(Yh).map(Wh), a = Jl.begin("searchPseudoElements");
      Rf(), Promise.all(r).then(() => {
        a(), Qo(), t();
      }).catch(() => {
        a(), Qo(), n();
      });
    });
}
var Kh = {
  hooks() {
    return {
      mutationObserverCallbacks(e) {
        return e.pseudoElementsCallback = k1, e;
      }
    };
  },
  provides(e) {
    e.pseudoElements2svg = function(t) {
      const {
        node: n = Ve
      } = t;
      le.searchPseudoElements && k1(n);
    };
  }
};
let L1 = !1;
var Zh = {
  mixout() {
    return {
      dom: {
        unwatch() {
          Rf(), L1 = !0;
        }
      }
    };
  },
  hooks() {
    return {
      bootstrap() {
        C1(Yo("mutationObserverCallbacks", {}));
      },
      noAuto() {
        Th();
      },
      watch(e) {
        const {
          observeMutationsRoot: t
        } = e;
        L1 ? Qo() : C1(Yo("mutationObserverCallbacks", {
          observeMutationsRoot: t
        }));
      }
    };
  }
};
const F1 = (e) => {
  let t = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return e.toLowerCase().split(" ").reduce((n, r) => {
    const a = r.toLowerCase().split("-"), i = a[0];
    let s = a.slice(1).join("-");
    if (i && s === "h")
      return n.flipX = !0, n;
    if (i && s === "v")
      return n.flipY = !0, n;
    if (s = parseFloat(s), isNaN(s))
      return n;
    switch (i) {
      case "grow":
        n.size = n.size + s;
        break;
      case "shrink":
        n.size = n.size - s;
        break;
      case "left":
        n.x = n.x - s;
        break;
      case "right":
        n.x = n.x + s;
        break;
      case "up":
        n.y = n.y - s;
        break;
      case "down":
        n.y = n.y + s;
        break;
      case "rotate":
        n.rotate = n.rotate + s;
        break;
    }
    return n;
  }, t);
};
var Xh = {
  mixout() {
    return {
      parse: {
        transform: (e) => F1(e)
      }
    };
  },
  hooks() {
    return {
      parseNodeAttributes(e, t) {
        const n = t.getAttribute("data-fa-transform");
        return n && (e.transform = F1(n)), e;
      }
    };
  },
  provides(e) {
    e.generateAbstractTransformGrouping = function(t) {
      let {
        main: n,
        transform: r,
        containerWidth: a,
        iconWidth: i
      } = t;
      const s = {
        transform: "translate(".concat(a / 2, " 256)")
      }, o = "translate(".concat(r.x * 32, ", ").concat(r.y * 32, ") "), l = "scale(".concat(r.size / 16 * (r.flipX ? -1 : 1), ", ").concat(r.size / 16 * (r.flipY ? -1 : 1), ") "), u = "rotate(".concat(r.rotate, " 0 0)"), c = {
        transform: "".concat(o, " ").concat(l, " ").concat(u)
      }, d = {
        transform: "translate(".concat(i / 2 * -1, " -256)")
      }, f = {
        outer: s,
        inner: c,
        path: d
      };
      return {
        tag: "g",
        attributes: q({}, f.outer),
        children: [{
          tag: "g",
          attributes: q({}, f.inner),
          children: [{
            tag: n.icon.tag,
            children: n.icon.children,
            attributes: q(q({}, n.icon.attributes), f.path)
          }]
        }]
      };
    };
  }
};
const fs = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function z1(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return e.attributes && (e.attributes.fill || t) && (e.attributes.fill = "black"), e;
}
function Jh(e) {
  return e.tag === "g" ? e.children : [e];
}
var Qh = {
  hooks() {
    return {
      parseNodeAttributes(e, t) {
        const n = t.getAttribute("data-fa-mask"), r = n ? Fi(n.split(" ").map((a) => a.trim())) : zf();
        return r.prefix || (r.prefix = In()), e.mask = r, e.maskId = t.getAttribute("data-fa-mask-id"), e;
      }
    };
  },
  provides(e) {
    e.generateAbstractMask = function(t) {
      let {
        children: n,
        attributes: r,
        main: a,
        mask: i,
        maskId: s,
        transform: o
      } = t;
      const {
        width: l,
        icon: u
      } = a, {
        width: c,
        icon: d
      } = i, f = G8({
        transform: o,
        containerWidth: c,
        iconWidth: l
      }), p = {
        tag: "rect",
        attributes: q(q({}, fs), {}, {
          fill: "white"
        })
      }, h = u.children ? {
        children: u.children.map(z1)
      } : {}, m = {
        tag: "g",
        attributes: q({}, f.inner),
        children: [z1(q({
          tag: u.tag,
          attributes: q(q({}, u.attributes), f.path)
        }, h))]
      }, v = {
        tag: "g",
        attributes: q({}, f.outer),
        children: [m]
      }, g = "mask-".concat(s || Qr()), b = "clip-".concat(s || Qr()), $ = {
        tag: "mask",
        attributes: q(q({}, fs), {}, {
          id: g,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [p, v]
      }, y = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: b
          },
          children: Jh(d)
        }, $]
      };
      return n.push(y, {
        tag: "rect",
        attributes: q({
          fill: "currentColor",
          "clip-path": "url(#".concat(b, ")"),
          mask: "url(#".concat(g, ")")
        }, fs)
      }), {
        children: n,
        attributes: r
      };
    };
  }
}, em = {
  provides(e) {
    let t = !1;
    Pn.matchMedia && (t = Pn.matchMedia("(prefers-reduced-motion: reduce)").matches), e.missingIconAbstract = function() {
      const n = [], r = {
        fill: "currentColor"
      }, a = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      n.push({
        tag: "path",
        attributes: q(q({}, r), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      const i = q(q({}, a), {}, {
        attributeName: "opacity"
      }), s = {
        tag: "circle",
        attributes: q(q({}, r), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return t || s.children.push({
        tag: "animate",
        attributes: q(q({}, a), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: q(q({}, i), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), n.push(s), n.push({
        tag: "path",
        attributes: q(q({}, r), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: t ? [] : [{
          tag: "animate",
          attributes: q(q({}, i), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), t || n.push({
        tag: "path",
        attributes: q(q({}, r), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: q(q({}, i), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: n
      };
    };
  }
}, tm = {
  hooks() {
    return {
      parseNodeAttributes(e, t) {
        const n = t.getAttribute("data-fa-symbol"), r = n === null ? !1 : n === "" ? !0 : n;
        return e.symbol = r, e;
      }
    };
  }
}, nm = [Y8, Rh, jh, Bh, Vh, Kh, Zh, Xh, Qh, em, tm];
fh(nm, {
  mixoutsTo: Ot
});
Ot.noAuto;
const Bf = Ot.config, rm = Ot.library;
Ot.dom;
const ri = Ot.parse;
Ot.findIconDefinition;
Ot.toHtml;
const am = Ot.icon;
Ot.layer;
const im = Ot.text;
Ot.counter;
/*!
 * Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2024 Fonticons, Inc.
 */
const sm = {
  prefix: "fas",
  iconName: "trash-can",
  icon: [448, 512, [61460, "trash-alt"], "f2ed", "M135.2 17.7C140.6 6.8 151.7 0 163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3zM32 128l384 0 0 320c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-320zm96 64c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16z"]
}, Vf = {
  prefix: "fas",
  iconName: "info",
  icon: [192, 512, [], "f129", "M48 80a48 48 0 1 1 96 0A48 48 0 1 1 48 80zM0 224c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 224 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-192-32 0c-17.7 0-32-14.3-32-32z"]
}, om = {
  prefix: "fas",
  iconName: "house-building",
  icon: [640, 512, [], "e1b1", "M368 0c-26.5 0-48 21.5-48 48l0 105.9 64 58.7 0-4.6c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-18.8 0c1.9 6.8 2.8 13.9 2.8 21.1l0 10.9 16 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-16 0 0 112c0 18-6 34.6-16 48l192 0c26.5 0 48-21.5 48-48l0-416c0-26.5-21.5-48-48-48L368 0zM512 208c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM400 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM0 277.1L0 464c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-186.9c0-13.5-5.6-26.3-15.6-35.4l-144-132c-18.4-16.8-46.5-16.8-64.9 0l-144 132C5.6 250.8 0 263.7 0 277.1zM144 296c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48z"]
}, lm = {
  prefix: "fas",
  iconName: "pencil",
  icon: [512, 512, [9999, 61504, "pencil-alt"], "f303", "M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1 0 32c0 8.8 7.2 16 16 16l32 0zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
}, um = {
  prefix: "fas",
  iconName: "gavel",
  icon: [512, 512, ["legal"], "f0e3", "M318.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-120 120c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l4-4L325.4 293.4l-4 4c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l120-120c12.5-12.5 12.5-32.8 0-45.3l-16-16c-12.5-12.5-32.8-12.5-45.3 0l-4 4L330.6 74.6l4-4c12.5-12.5 12.5-32.8 0-45.3l-16-16zm-152 288c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l48 48c12.5 12.5 32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-1.4-1.4L272 285.3 226.7 240 168 298.7l-1.4-1.4z"]
}, cm = {
  prefix: "fas",
  iconName: "arrow-right-from-bracket",
  icon: [512, 512, ["sign-out"], "f08b", "M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 192 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l210.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128zM160 96c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 32C43 32 0 75 0 128L0 384c0 53 43 96 96 96l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l64 0z"]
}, dm = {
  prefix: "fas",
  iconName: "flag",
  icon: [448, 512, [127988, 61725], "f024", "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32L0 64 0 368 0 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 64.3-16.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30l0-247.7c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L64 48l0-16z"]
}, fm = {
  prefix: "fas",
  iconName: "display-chart-up",
  icon: [576, 512, [], "e5e3", "M0 64C0 28.7 28.7 0 64 0L512 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-176 0 10.7 32 69.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l69.3 0L240 416 64 416c-35.3 0-64-28.7-64-64L0 64zm64 0l0 288 448 0 0-288L64 64zM376 96l80 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-22.1L321 289c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7l-63-63-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 175c9.4-9.4 24.6-9.4 33.9 0l63 63L398.1 144 376 144c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
}, pm = {
  prefix: "fas",
  iconName: "users",
  icon: [640, 512, [], "f0c0", "M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192l42.7 0c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0L21.3 320C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7l42.7 0C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3l-213.3 0zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352l117.3 0C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7l-330.7 0c-14.7 0-26.7-11.9-26.7-26.7z"]
}, hm = {
  prefix: "fas",
  iconName: "chevron-up",
  icon: [512, 512, [], "f077", "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"]
}, mm = {
  prefix: "fas",
  iconName: "triangle",
  icon: [512, 512, [9650], "f2ec", "M290.5 51.8C283.3 39.5 270.2 32 256 32s-27.3 7.5-34.5 19.8l-216 368c-7.3 12.4-7.3 27.7-.2 40.1S25.7 480 40 480l432 0c14.3 0 27.6-7.7 34.7-20.1s7-27.8-.2-40.1l-216-368z"]
}, vm = {
  prefix: "fas",
  iconName: "gauge",
  icon: [512, 512, ["dashboard", "gauge-med", "tachometer-alt-average"], "f624", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-26.9-16.5-49.9-40-59.3L280 88c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 204.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64zM144 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM400 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
}, gm = {
  prefix: "fas",
  iconName: "user",
  icon: [448, 512, [128100, 62144], "f007", "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0z"]
}, bm = {
  prefix: "fas",
  iconName: "chart-line-up",
  icon: [512, 512, [], "e0e5", "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 400c0 44.2 35.8 80 80 80l400 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 416c-8.8 0-16-7.2-16-16L64 64zM439 279c15.1 15.1 41 4.4 41-17L480 152c0-13.3-10.7-24-24-24l-110.1 0c-21.4 0-32.1 25.9-17 41l32.4 32.4L304 258.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L208 253.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0l80-80L439 279z"]
}, $m = {
  prefix: "fas",
  iconName: "camera-rotate",
  icon: [640, 512, [], "e0d8", "M213.1 64.8L202.7 96 128 96c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-74.7 0L426.9 64.8C420.4 45.2 402.1 32 381.4 32L258.6 32c-20.7 0-39 13.2-45.5 32.8zM448 256c0 8.8-7.2 16-16 16l-76.7 0c-6.2 0-11.3-5.1-11.3-11.3c0-3 1.2-5.9 3.3-8L371 229c-13.6-13.4-31.9-21-51-21c-19.2 0-37.7 7.6-51.3 21.3L249 249c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l19.7-19.7C257.4 172.7 288 160 320 160c31.8 0 62.4 12.6 85 35l23.7-23.7c2.1-2.1 5-3.3 8-3.3c6.2 0 11.3 5.1 11.3 11.3l0 76.7zM192 320c0-8.8 7.2-16 16-16l76.7 0c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8L269 347c13.6 13.4 31.9 21 51 21c19.2 0 37.7-7.6 51.3-21.3L391 327c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-19.7 19.7C382.6 403.3 352 416 320 416c-31.8 0-62.4-12.6-85-35l-23.7 23.7c-2.1 2.1-5 3.3-8 3.3c-6.2 0-11.3-5.1-11.3-11.3l0-76.7z"]
}, ym = {
  prefix: "fas",
  iconName: "star",
  icon: [576, 512, [11088, 61446], "f005", "M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"]
}, xm = {
  prefix: "fas",
  iconName: "arrow-up-from-square",
  icon: [512, 512, [], "e09c", "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 109.3 224 320c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96zM64 112c0-8.8 7.2-16 16-16l8 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-8 0C35.8 32 0 67.8 0 112L0 432c0 44.2 35.8 80 80 80l352 0c44.2 0 80-35.8 80-80l0-320c0-44.2-35.8-80-80-80l-8 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l8 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16l0-320z"]
}, _m = {
  prefix: "fas",
  iconName: "right-to-bracket",
  icon: [512, 512, ["sign-in-alt"], "f2f6", "M217.9 105.9L340.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L217.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1L32 320c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM352 416l64 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c53 0 96 43 96 96l0 256c0 53-43 96-96 96l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
}, wm = {
  prefix: "fas",
  iconName: "objects-column",
  icon: [448, 512, [], "e3c1", "M48 32C21.5 32 0 53.5 0 80L0 240c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48L48 32zM304 224c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-96 0zM0 400l0 32c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48zM304 32c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48l-96 0z"]
}, Sm = {
  prefix: "fas",
  iconName: "rotate-left",
  icon: [512, 512, ["rotate-back", "rotate-backward", "undo-alt"], "f2ea", "M48.5 224L40 224c-13.3 0-24-10.7-24-24L16 72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8L48.5 224z"]
}, Cm = {
  prefix: "fas",
  iconName: "circle-play",
  icon: [512, 512, [61469, "play-circle"], "f144", "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c-7.6 4.2-12.3 12.3-12.3 20.9l0 176c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z"]
}, P1 = {
  prefix: "fas",
  iconName: "euro-sign",
  icon: [320, 512, [8364, "eur", "euro"], "f153", "M48.1 240c-.1 2.7-.1 5.3-.1 8l0 16c0 2.7 0 5.3 .1 8L32 272c-17.7 0-32 14.3-32 32s14.3 32 32 32l28.3 0C89.9 419.9 170 480 264 480l24 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-24 0c-57.9 0-108.2-32.4-133.9-80L256 336c17.7 0 32-14.3 32-32s-14.3-32-32-32l-143.8 0c-.1-2.6-.2-5.3-.2-8l0-16c0-2.7 .1-5.4 .2-8L256 240c17.7 0 32-14.3 32-32s-14.3-32-32-32l-125.9 0c25.7-47.6 76-80 133.9-80l24 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-24 0C170 32 89.9 92.1 60.3 176L32 176c-17.7 0-32 14.3-32 32s14.3 32 32 32l16.1 0z"]
}, Am = {
  prefix: "fas",
  iconName: "circle-check",
  icon: [512, 512, [61533, "check-circle"], "f058", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
}, I1 = {
  prefix: "fas",
  iconName: "address-card",
  icon: [576, 512, [62140, "contact-card", "vcard"], "f2bb", "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm80 256l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16L80 384c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm256-32l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
}, Em = {
  prefix: "fas",
  iconName: "arrows-left-right",
  icon: [512, 512, ["arrows-h"], "f07e", "M406.6 374.6l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224l-293.5 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288l293.5 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"]
}, Om = {
  prefix: "fas",
  iconName: "list-tree",
  icon: [512, 512, [], "e1d2", "M24 48C10.7 48 0 58.7 0 72l0 48c0 13.3 10.7 24 24 24l0 112 0 128c0 30.9 25.1 56 56 56l48 0c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l-48 0c-4.4 0-8-3.6-8-8l0-104 56 0c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l-56 0 0-88c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24L24 48zM160 96c0 17.7 14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 64c-17.7 0-32 14.3-32 32zM288 256c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-160 0c-17.7 0-32 14.3-32 32zm0 160c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-160 0c-17.7 0-32 14.3-32 32z"]
}, Tm = {
  prefix: "fas",
  iconName: "arrows-rotate",
  icon: [512, 512, [128472, "refresh", "sync"], "f021", "M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160 352 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l111.5 0c0 0 0 0 0 0l.4 0c17.7 0 32-14.3 32-32l0-112c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 35.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5zM39 289.3c-5 1.5-9.8 4.2-13.7 8.2c-4 4-6.7 8.8-8.1 14c-.3 1.2-.6 2.5-.8 3.8c-.3 1.7-.4 3.4-.4 5.1L16 432c0 17.7 14.3 32 32 32s32-14.3 32-32l0-35.1 17.6 17.5c0 0 0 0 0 0c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.8c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0l-.1-.1L125.6 352l34.4 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L48.4 288c-1.6 0-3.2 .1-4.8 .3s-3.1 .5-4.6 1z"]
}, Mm = Tm, km = {
  prefix: "fas",
  iconName: "user-group-crown",
  icon: [640, 512, ["users-crown"], "f6a5", "M144 144l0-16 160 0 0 16c0 44.2-35.8 80-80 80s-80-35.8-80-80zm-.1-124.9c-.3-.2-.6-.4-.8-.6L140 16 124.4 3.5C121.5 1.2 118 0 114.4 0L112 0c-8.8 0-16 7.2-16 16l0 23 0 3.2c0 0 0 .1 0 .1L96 144c0 70.7 57.3 128 128 128s128-57.3 128-128l0-101.7c0 0 0-.1 0-.1l0-3.2 0-23c0-8.8-7.2-16-16-16l-2.4 0c-3.6 0-7.2 1.2-10 3.5L308 16l-3 2.4c-.3 .2-.6 .4-.8 .6l-.1 .1c-10.2 7.5-23.8 8.3-34.9 2L238.9 4c-4.6-2.6-9.7-4-14.9-4s-10.4 1.4-14.9 4L178.9 21.2c-11 6.3-24.7 5.5-34.9-2l-.1-.1zM168 304C75.2 304 0 379.2 0 472l0 8c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-8c0-92.8-75.2-168-168-168l-112 0zm264-48c61.9 0 112-50.1 112-112s-50.1-112-112-112c-17.2 0-33.5 3.9-48 10.8L384 144c0 5.4-.3 10.7-.8 16c-2.4 24.3-10.3 47.1-22.4 67c-.5 .8-1 1.6-1.4 2.3C379 245.9 404.3 256 432 256zm39.4 256l137.8 0c17 0 30.7-13.8 30.7-30.7C640 392.2 567.8 320 478.7 320l-61.4 0c-2.4 0-4.8 .1-7.1 .2C452.9 356.8 480 411.3 480 472l0 8c0 11.7-3.1 22.6-8.6 32z"]
}, Lm = {
  prefix: "fas",
  iconName: "arrow-right",
  icon: [448, 512, [8594], "f061", "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"]
}, Fm = {
  prefix: "fas",
  iconName: "heart",
  icon: [512, 512, [128153, 128154, 128155, 128156, 128420, 129293, 129294, 129505, 9829, 10084, 61578], "f004", "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z"]
}, zm = {
  prefix: "fas",
  iconName: "badge-check",
  icon: [512, 512, [], "f336", "M256 0c36.8 0 68.8 20.7 84.9 51.1C373.8 41 411 49 437 75s34 63.3 23.9 96.1C491.3 187.2 512 219.2 512 256s-20.7 68.8-51.1 84.9C471 373.8 463 411 437 437s-63.3 34-96.1 23.9C324.8 491.3 292.8 512 256 512s-68.8-20.7-84.9-51.1C138.2 471 101 463 75 437s-34-63.3-23.9-96.1C20.7 324.8 0 292.8 0 256s20.7-68.8 51.1-84.9C41 138.2 49 101 75 75s63.3-34 96.1-23.9C187.2 20.7 219.2 0 256 0zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"]
}, Pm = {
  prefix: "fas",
  iconName: "files",
  icon: [448, 512, [], "e178", "M320 0L160 0C124.7 0 96 28.7 96 64l0 288c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-224-96 0c-17.7 0-32-14.3-32-32l0-96zM448 96L416 64 384 32 352 0l0 45.3L352 64l0 32 32 0 18.7 0L448 96zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 376c0 75.1 60.9 136 136 136l192 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-192 0c-48.6 0-88-39.4-88-88l0-256z"]
}, Im = {
  prefix: "fas",
  iconName: "eye",
  icon: [576, 512, [128065], "f06e", "M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"]
}, Nm = {
  prefix: "fas",
  iconName: "hand-holding-dollar",
  icon: [576, 512, ["hand-holding-usd"], "f4c0", "M312 24l0 10.5c6.4 1.2 12.6 2.7 18.2 4.2c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5c-7.3-.1-14.7 1.7-19.4 4.4c-2.1 1.3-3.1 2.4-3.5 3c-.3 .5-.7 1.2-.7 2.8c0 .3 0 .5 0 .6c.2 .2 .9 1.2 3.3 2.6c5.8 3.5 14.4 6.2 27.4 10.1l.9 .3s0 0 0 0c11.1 3.3 25.9 7.8 37.9 15.3c13.7 8.6 26.1 22.9 26.4 44.9c.3 22.5-11.4 38.9-26.7 48.5c-6.7 4.1-13.9 7-21.3 8.8l0 10.6c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-11.4c-9.5-2.3-18.2-5.3-25.6-7.8c-2.1-.7-4.1-1.4-6-2c-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6 .9 5 1.7 7.3 2.5c13.6 4.6 23.4 7.9 33.9 8.3c8 .3 15.1-1.6 19.2-4.1c1.9-1.2 2.8-2.2 3.2-2.9c.4-.6 .9-1.8 .8-4.1l0-.2c0-1 0-2.1-4-4.6c-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4c-13.5-8.1-26.5-22-26.6-44.1c-.1-22.9 12.9-38.6 27.7-47.4c6.4-3.8 13.3-6.4 20.2-8.2L264 24c0-13.3 10.7-24 24-24s24 10.7 24 24zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5L192 512 32 512c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l36.8 0 44.9-36c22.7-18.2 50.9-28 80-28l78.3 0 16 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l120.6 0 119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384c0 0 0 0 0 0l-.9 0c.3 0 .6 0 .9 0z"]
}, Dm = {
  prefix: "fas",
  iconName: "spinner-third",
  icon: [512, 512, [], "f3f4", "M224 32c0-17.7 14.3-32 32-32C397.4 0 512 114.6 512 256c0 46.6-12.5 90.4-34.3 128c-8.8 15.3-28.4 20.5-43.7 11.7s-20.5-28.4-11.7-43.7c16.3-28.2 25.7-61 25.7-96c0-106-86-192-192-192c-17.7 0-32-14.3-32-32z"]
}, Rm = {
  prefix: "fas",
  iconName: "phone",
  icon: [512, 512, [128222, 128379], "f095", "M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z"]
}, jm = {
  prefix: "fas",
  iconName: "pen-fancy",
  icon: [512, 512, [128395, 10002], "f5ac", "M373.5 27.1C388.5 9.9 410.2 0 433 0c43.6 0 79 35.4 79 79c0 22.8-9.9 44.6-27.1 59.6L277.7 319l-10.3-10.3-64-64L193 234.3 373.5 27.1zM170.3 256.9l10.4 10.4 64 64 10.4 10.4-19.2 83.4c-3.9 17.1-16.9 30.7-33.8 35.4L24.3 510.3l95.4-95.4c2.6 .7 5.4 1.1 8.3 1.1c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32c0 2.9 .4 5.6 1.1 8.3L1.7 487.6 51.5 310c4.7-16.9 18.3-29.9 35.4-33.8l83.4-19.2z"]
}, Bm = {
  prefix: "fas",
  iconName: "phone-arrow-down-left",
  icon: [512, 512, ["phone-arrow-down", "phone-incoming"], "e223", "M505 41l-135 135 46.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-104 0c-13.3 0-24-10.7-24-24l0-104c0-13.3 10.7-24 24-24s24 10.7 24 24l0 46.1L471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7L345 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512C200.6 512 0 311.4 0 64C0 46 12.1 30.2 29.5 25.4l88-24z"]
}, Vm = {
  prefix: "fas",
  iconName: "trash",
  icon: [448, 512, [], "f1f8", "M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"]
}, Um = {
  prefix: "fas",
  iconName: "arrow-left",
  icon: [448, 512, [8592], "f060", "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"]
}, N1 = {
  prefix: "fas",
  iconName: "file-pdf",
  icon: [512, 512, [], "f1c1", "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z"]
}, Hm = {
  prefix: "fas",
  iconName: "envelope",
  icon: [512, 512, [128386, 9993, 61443], "f0e0", "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48L48 64zM0 176L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-208L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"]
}, Gm = {
  prefix: "fas",
  iconName: "paperclip",
  icon: [448, 512, [128206], "f0c6", "M364.2 83.8c-24.4-24.4-64-24.4-88.4 0l-184 184c-42.1 42.1-42.1 110.3 0 152.4s110.3 42.1 152.4 0l152-152c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-152 152c-64 64-167.6 64-231.6 0s-64-167.6 0-231.6l184-184c46.3-46.3 121.3-46.3 167.6 0s46.3 121.3 0 167.6l-176 176c-28.6 28.6-75 28.6-103.6 0s-28.6-75 0-103.6l144-144c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-144 144c-6.7 6.7-6.7 17.7 0 24.4s17.7 6.7 24.4 0l176-176c24.4-24.4 24.4-64 0-88.4z"]
}, qm = {
  prefix: "fas",
  iconName: "circle-small",
  icon: [320, 512, [], "e122", "M0 256a160 160 0 1 1 320 0A160 160 0 1 1 0 256z"]
}, Wm = {
  prefix: "fas",
  iconName: "hourglass",
  icon: [384, 512, [9203, 62032, "hourglass-empty"], "f254", "M0 32C0 14.3 14.3 0 32 0L64 0 320 0l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 11c0 42.4-16.9 83.1-46.9 113.1L237.3 256l67.9 67.9c30 30 46.9 70.7 46.9 113.1l0 11c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0L64 512l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-11c0-42.4 16.9-83.1 46.9-113.1L146.7 256 78.9 188.1C48.9 158.1 32 117.4 32 75l0-11C14.3 64 0 49.7 0 32zM96 64l0 11c0 25.5 10.1 49.9 28.1 67.9L192 210.7l67.9-67.9c18-18 28.1-42.4 28.1-67.9l0-11L96 64zm0 384l192 0 0-11c0-25.5-10.1-49.9-28.1-67.9L192 301.3l-67.9 67.9c-18 18-28.1 42.4-28.1 67.9l0 11z"]
}, Ym = {
  prefix: "fas",
  iconName: "circle-info",
  icon: [512, 512, ["info-circle"], "f05a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
}, Km = {
  prefix: "fas",
  iconName: "camera",
  icon: [512, 512, [62258, "camera-alt"], "f030", "M149.1 64.8L138.7 96 64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-74.7 0L362.9 64.8C356.4 45.2 338.1 32 317.4 32L194.6 32c-20.7 0-39 13.2-45.5 32.8zM256 192a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
}, Zm = {
  prefix: "fas",
  iconName: "gear",
  icon: [512, 512, [9881, "cog"], "f013", "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"]
}, Xm = {
  prefix: "fas",
  iconName: "coins",
  icon: [512, 512, [], "f51e", "M512 80c0 18-14.3 34.6-38.4 48c-29.1 16.1-72.5 27.5-122.3 30.9c-3.7-1.8-7.4-3.5-11.3-5C300.6 137.4 248.2 128 192 128c-8.3 0-16.4 .2-24.5 .6l-1.1-.6C142.3 114.6 128 98 128 80c0-44.2 86-80 192-80S512 35.8 512 80zM160.7 161.1c10.2-.7 20.7-1.1 31.3-1.1c62.2 0 117.4 12.3 152.5 31.4C369.3 204.9 384 221.7 384 240c0 4-.7 7.9-2.1 11.7c-4.6 13.2-17 25.3-35 35.5c0 0 0 0 0 0c-.1 .1-.3 .1-.4 .2c0 0 0 0 0 0s0 0 0 0c-.3 .2-.6 .3-.9 .5c-35 19.4-90.8 32-153.6 32c-59.6 0-112.9-11.3-148.2-29.1c-1.9-.9-3.7-1.9-5.5-2.9C14.3 274.6 0 258 0 240c0-34.8 53.4-64.5 128-75.4c10.5-1.5 21.4-2.7 32.7-3.5zM416 240c0-21.9-10.6-39.9-24.1-53.4c28.3-4.4 54.2-11.4 76.2-20.5c16.3-6.8 31.5-15.2 43.9-25.5l0 35.4c0 19.3-16.5 37.1-43.8 50.9c-14.6 7.4-32.4 13.7-52.4 18.5c.1-1.8 .2-3.5 .2-5.3zm-32 96c0 18-14.3 34.6-38.4 48c-1.8 1-3.6 1.9-5.5 2.9C304.9 404.7 251.6 416 192 416c-62.8 0-118.6-12.6-153.6-32C14.3 370.6 0 354 0 336l0-35.4c12.5 10.3 27.6 18.7 43.9 25.5C83.4 342.6 135.8 352 192 352s108.6-9.4 148.1-25.9c7.8-3.2 15.3-6.9 22.4-10.9c6.1-3.4 11.8-7.2 17.2-11.2c1.5-1.1 2.9-2.3 4.3-3.4l0 3.4 0 5.7 0 26.3zm32 0l0-32 0-25.9c19-4.2 36.5-9.5 52.1-16c16.3-6.8 31.5-15.2 43.9-25.5l0 35.4c0 10.5-5 21-14.9 30.9c-16.3 16.3-45 29.7-81.3 38.4c.1-1.7 .2-3.5 .2-5.3zM192 448c56.2 0 108.6-9.4 148.1-25.9c16.3-6.8 31.5-15.2 43.9-25.5l0 35.4c0 44.2-86 80-192 80S0 476.2 0 432l0-35.4c12.5 10.3 27.6 18.7 43.9 25.5C83.4 438.6 135.8 448 192 448z"]
}, Jm = {
  prefix: "fas",
  iconName: "download",
  icon: [512, 512, [], "f019", "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 242.7-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7 288 32zM64 352c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-101.5 0-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352 64 352zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
}, Qm = {
  prefix: "fas",
  iconName: "forward",
  icon: [512, 512, [9193], "f04e", "M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416L0 96C0 83.6 7.2 72.3 18.4 67s24.5-3.6 34.1 4.4L224 214.3l0 41.7 0 41.7L52.5 440.6zM256 352l0-96 0-128 0-32c0-12.4 7.2-23.7 18.4-29s24.5-3.6 34.1 4.4l192 160c7.3 6.1 11.5 15.1 11.5 24.6s-4.2 18.5-11.5 24.6l-192 160c-9.5 7.9-22.8 9.7-34.1 4.4s-18.4-16.6-18.4-29l0-64z"]
}, e5 = {
  prefix: "fas",
  iconName: "id-card",
  icon: [576, 512, [62147, "drivers-license"], "f2c2", "M0 96l576 0c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm0 32L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-288L0 128zM64 405.3c0-29.5 23.9-53.3 53.3-53.3l117.3 0c29.5 0 53.3 23.9 53.3 53.3c0 5.9-4.8 10.7-10.7 10.7L74.7 416c-5.9 0-10.7-4.8-10.7-10.7zM176 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm176 16c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z"]
}, t5 = {
  prefix: "fas",
  iconName: "house",
  icon: [576, 512, [127968, 63498, 63500, "home", "home-alt", "home-lg-alt"], "f015", "M575.8 255.5c0 18-15 32.1-32 32.1l-32 0 .7 160.2c0 2.7-.2 5.4-.5 8.1l0 16.2c0 22.1-17.9 40-40 40l-16 0c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1L416 512l-24 0c-22.1 0-40-17.9-40-40l0-24 0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 64 0 24c0 22.1-17.9 40-40 40l-24 0-31.9 0c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2l-16 0c-22.1 0-40-17.9-40-40l0-112c0-.9 0-1.9 .1-2.8l0-69.7-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"]
}, n5 = {
  prefix: "fas",
  iconName: "upload",
  icon: [512, 512, [], "f093", "M288 109.3L288 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-242.7-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3zM64 352l128 0c0 35.3 28.7 64 64 64s64-28.7 64-64l128 0c35.3 0 64 28.7 64 64l0 32c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64l0-32c0-35.3 28.7-64 64-64zM432 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
}, r5 = {
  prefix: "fas",
  iconName: "file-arrow-down",
  icon: [384, 512, ["file-download"], "f56d", "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM216 232l0 102.1 31-31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0l-72-72c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l31 31L168 232c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
}, a5 = {
  prefix: "fas",
  iconName: "arrow-up-arrow-down",
  icon: [576, 512, ["sort-up-down"], "e099", "M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L128 141.3 128 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-306.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96zm352 333.3c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L448 370.7 448 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96z"]
}, i5 = {
  prefix: "fas",
  iconName: "chart-mixed",
  icon: [512, 512, ["analytics"], "f643", "M500 89c13.8-11 16-31.2 5-45s-31.2-16-45-5L319.4 151.5 211.2 70.4c-11.7-8.8-27.8-8.5-39.2 .6L12 199c-13.8 11-16 31.2-5 45s31.2 16 45 5L192.6 136.5l108.2 81.1c11.7 8.8 27.8 8.5 39.2-.6L500 89zM160 256l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192c0-17.7-14.3-32-32-32s-32 14.3-32 32zM32 352l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32zm288-64c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128c0-17.7-14.3-32-32-32zm96-32l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192c0-17.7-14.3-32-32-32s-32 14.3-32 32z"]
}, s5 = {
  prefix: "fas",
  iconName: "bell",
  icon: [448, 512, [128276, 61602], "f0f3", "M224 0c-17.7 0-32 14.3-32 32l0 19.2C119 66 64 130.6 64 208l0 18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416l384 0c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8l0-18.8c0-77.4-55-142-128-156.8L256 32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z"]
}, o5 = {
  prefix: "fas",
  iconName: "location-dot",
  icon: [384, 512, ["map-marker-alt"], "f3c5", "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
}, D1 = {
  prefix: "fas",
  iconName: "file",
  icon: [384, 512, [128196, 128459, 61462], "f15b", "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128z"]
}, l5 = {
  prefix: "fas",
  iconName: "arrow-down",
  icon: [384, 512, [8595], "f063", "M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"]
}, u5 = {
  prefix: "fas",
  iconName: "timer",
  icon: [512, 512, [], "e29e", "M256 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-29.3C378.8 81.9 448 160.9 448 256c0 106-86 192-192 192S64 362 64 256c0-53.7 22-102.3 57.6-137.1c12.6-12.4 12.8-32.6 .5-45.3S89.5 60.8 76.8 73.1C29.5 119.6 0 184.4 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0zM193 159c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80z"]
}, R1 = {
  prefix: "fas",
  iconName: "magnifying-glass",
  icon: [512, 512, [128269, "search"], "f002", "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"]
}, c5 = {
  prefix: "fas",
  iconName: "chevron-down",
  icon: [512, 512, [], "f078", "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"]
}, d5 = {
  prefix: "fas",
  iconName: "arrow-up",
  icon: [384, 512, [8593], "f062", "M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2 160 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-306.7L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z"]
}, f5 = {
  prefix: "fas",
  iconName: "list-check",
  icon: [512, 512, ["tasks"], "f0ae", "M152.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 113C-2.3 103.6-2.3 88.4 7 79s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM224 96c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32zM160 416c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
}, p5 = {
  prefix: "fas",
  iconName: "copy",
  icon: [448, 512, [], "f0c5", "M208 0L332.1 0c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9L448 336c0 26.5-21.5 48-48 48l-192 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48zM48 128l80 0 0 64-64 0 0 256 192 0 0-32 64 0 0 48c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 176c0-26.5 21.5-48 48-48z"]
}, h5 = {
  prefix: "fas",
  iconName: "plus",
  icon: [448, 512, [10133, 61543, "add"], "2b", "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z"]
}, tl = {
  prefix: "fas",
  iconName: "xmark",
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"]
}, m5 = {
  prefix: "fas",
  iconName: "chevron-left",
  icon: [320, 512, [9001], "f053", "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"]
}, Uf = {
  prefix: "fas",
  iconName: "chevron-right",
  icon: [320, 512, [9002], "f054", "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"]
}, j1 = {
  prefix: "fas",
  iconName: "percent",
  icon: [384, 512, [62101, 62785, "percentage"], "25", "M374.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-320 320c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l320-320zM128 128A64 64 0 1 0 0 128a64 64 0 1 0 128 0zM384 384a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
}, v5 = {
  prefix: "fas",
  iconName: "spinner",
  icon: [512, 512, [], "f110", "M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"]
}, g5 = {
  prefix: "fas",
  iconName: "building",
  icon: [384, 512, [127970, 61687], "f1ad", "M48 0C21.5 0 0 21.5 0 48L0 464c0 26.5 21.5 48 48 48l96 0 0-80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80 96 0c26.5 0 48-21.5 48-48l0-416c0-26.5-21.5-48-48-48L48 0zM64 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm112-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM80 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM272 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16z"]
}, b5 = {
  prefix: "fas",
  iconName: "diagram-cells",
  icon: [512, 512, [], "e475", "M512 160c0 35.3-28.7 64-64 64L64 224c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 64zM448 416l0-64L64 352l0 64 384 0zm0 64L64 480c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64z"]
}, $5 = {
  prefix: "fas",
  iconName: "infinity",
  icon: [640, 512, [8734, 9854], "f534", "M0 241.1C0 161 65 96 145.1 96c38.5 0 75.4 15.3 102.6 42.5L320 210.7l72.2-72.2C419.5 111.3 456.4 96 494.9 96C575 96 640 161 640 241.1l0 29.7C640 351 575 416 494.9 416c-38.5 0-75.4-15.3-102.6-42.5L320 301.3l-72.2 72.2C220.5 400.7 183.6 416 145.1 416C65 416 0 351 0 270.9l0-29.7zM274.7 256l-72.2-72.2c-15.2-15.2-35.9-23.8-57.4-23.8C100.3 160 64 196.3 64 241.1l0 29.7c0 44.8 36.3 81.1 81.1 81.1c21.5 0 42.2-8.5 57.4-23.8L274.7 256zm90.5 0l72.2 72.2c15.2 15.2 35.9 23.8 57.4 23.8c44.8 0 81.1-36.3 81.1-81.1l0-29.7c0-44.8-36.3-81.1-81.1-81.1c-21.5 0-42.2 8.5-57.4 23.8L365.3 256z"]
}, Hf = {
  prefix: "fas",
  iconName: "check",
  icon: [448, 512, [10003, 10004], "f00c", "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"]
}, y5 = {
  prefix: "fas",
  iconName: "house-circle-check",
  icon: [640, 512, [], "e509", "M320.7 352c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1l32 0 0 69.7c-.1 .9-.1 1.8-.1 2.8l0 112c0 22.1 17.9 40 40 40l16 0c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2l31.9 0 24 0c22.1 0 40-17.9 40-40l0-24 0-64c0-17.7 14.3-32 32-32l64 0 .7 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
}, x5 = {
  prefix: "fas",
  iconName: "buildings",
  icon: [512, 512, [], "e0cc", "M256 0c-35.3 0-64 28.7-64 64l0 64L64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0 192 0c35.3 0 64-28.7 64-64l0-256 0-128c0-35.3-28.7-64-64-64L256 0zM64 304c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm208 16c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0zm112-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zM80 192l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM256 80c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM400 64l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM256 208l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zm144 16c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0z"]
}, _5 = {
  prefix: "fas",
  iconName: "briefcase",
  icon: [512, 512, [128188], "f0b1", "M184 48l144 0c4.4 0 8 3.6 8 8l0 40L176 96l0-40c0-4.4 3.6-8 8-8zm-56 8l0 40L64 96C28.7 96 0 124.7 0 160l0 96 192 0 128 0 192 0 0-96c0-35.3-28.7-64-64-64l-64 0 0-40c0-30.9-25.1-56-56-56L184 0c-30.9 0-56 25.1-56 56zM512 288l-192 0 0 32c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-32L0 288 0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-128z"]
}, w5 = {
  prefix: "fas",
  iconName: "circle-xmark",
  icon: [512, 512, [61532, "times-circle", "xmark-circle"], "f057", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
}, S5 = {
  prefix: "fas",
  iconName: "file-check",
  icon: [384, 512, [], "f316", "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zm49 281L177 409c-9.4 9.4-24.6 9.4-33.9 0L79 345c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L271 247c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
}, Gf = {
  prefix: "fas",
  iconName: "exclamation",
  icon: [128, 512, [10069, 10071, 61738], "21", "M96 64c0-17.7-14.3-32-32-32S32 46.3 32 64l0 256c0 17.7 14.3 32 32 32s32-14.3 32-32L96 64zM64 480a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
}, C5 = {
  prefix: "fas",
  iconName: "grid-2",
  icon: [512, 512, [], "e196", "M224 80c0-26.5-21.5-48-48-48L80 32C53.5 32 32 53.5 32 80l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96zm0 256c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96zM288 80l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48zM480 336c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96z"]
};
/*!
 * Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2024 Fonticons, Inc.
 */
const A5 = {
  prefix: "fad",
  iconName: "trash-can",
  icon: [448, 512, [61460, "trash-alt"], "f2ed", ["M32 96l0 352c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-352L32 96zm80 80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224zm96 0c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224zm96 0c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224z", "M163.8 0c-12.1 0-23.2 6.8-28.6 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0z"]]
}, E5 = {
  prefix: "fad",
  iconName: "file-lines",
  icon: [384, 512, [128441, 128462, 61686, "file-alt", "file-text"], "f15c", ["M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM96 272c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16z", "M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM112 256c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0z"]]
}, O5 = {
  prefix: "fad",
  iconName: "calendar-days",
  icon: [448, 512, ["calendar-alt"], "f073", ["M0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zm64 80l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM192 272l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM320 272l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z", "M160 32c0-17.7-14.3-32-32-32S96 14.3 96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 80 448 0 0-80c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32z"]]
}, T5 = {
  prefix: "fad",
  iconName: "house-building",
  icon: [640, 512, [], "e1b1", ["M320 48c0-26.5 21.5-48 48-48L592 0c26.5 0 48 21.5 48 48l0 416c0 26.5-21.5 48-48 48l-192 0c10-13.4 16-30 16-48l0-112 16 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-16 0 0-10.9c0-7.2-1-14.3-2.8-21.1l18.8 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 4.6-64-58.7L320 48zm64 64l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm128 0l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 96l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 96l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z", "M0 464L0 277.1c0-13.5 5.6-26.3 15.6-35.4l144-132c18.4-16.8 46.5-16.8 64.9 0l144 132c9.9 9.1 15.6 21.9 15.6 35.4L384 464c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48zM168 272c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0z"]]
}, M5 = {
  prefix: "fad",
  iconName: "address-book",
  icon: [512, 512, [62138, "contact-book"], "f2b9", ["M32 64C32 28.7 60.7 0 96 0L384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64L32 64zm96 304c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80zm48-176a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z", "M496 64c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm0 128c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm16 144l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16zM128 368c0-44.2 35.8-80 80-80l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zM240 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]]
}, k5 = {
  prefix: "fad",
  iconName: "pencil",
  icon: [512, 512, [9999, 61504, "pencil-alt"], "f303", ["M144 319.4c0 4.1 1.6 8.2 4.7 11.3s7.2 4.7 11.3 4.7s8.2-1.6 11.3-4.7c48-48 96-96 144-144c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0c-48 48-96 96-144 144c-3.1 3.1-4.7 7.2-4.7 11.3zM302.7 78.7c43.3 43.3 86.6 86.6 129.9 129.9c20-20 40-40 60-60c12.5-12.5 18.7-28.9 18.7-45.3s-6.2-32.8-18.7-45.3L453.3 18.7c-25-25-65.5-25-90.5 0l-60 60z", "M432.7 208.7L302.7 78.7 58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L432.7 208.7zM89.3 360.5l22.7-9.1 0 32c0 8.8 7.2 16 16 16l32 0-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3zm226-196.4c6.2 6.2 6.2 16.4 0 22.6l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0z"]]
}, L5 = {
  prefix: "fad",
  iconName: "comments",
  icon: [640, 512, [128490, 61670], "f086", ["M231.5 383C348.9 372.9 448 288.3 448 176c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 38.6-14.7 74.3-39.6 103.4c3.5 9.4 8.7 17.7 14.2 24.7c4.8 6.2 9.7 11 13.3 14.3c1.8 1.6 3.3 2.9 4.3 3.7c.5 .4 .9 .7 1.3 1c5.6 4.1 7.9 11.3 5.8 17.9c-2.1 6.6-8.3 11.1-15.2 11.1c-21.8 0-43.8-5.6-62.1-12.5c-9.2-3.5-17.8-7.4-25.3-11.4C505.9 503.3 470.2 512 432 512c-95.6 0-176.2-54.6-200.5-129z", "M416 176c0 97.2-93.1 176-208 176c-38.2 0-73.9-8.7-104.7-23.9c-7.5 4-16 7.9-25.2 11.4C59.8 346.4 37.8 352 16 352c-6.9 0-13.1-4.5-15.2-11.1s.2-13.8 5.8-17.9c0 0 0 0 0 0s0 0 0 0l.2-.2c.2-.2 .6-.4 1.1-.8c1-.8 2.5-2 4.3-3.7c3.6-3.3 8.5-8.1 13.3-14.3c5.5-7 10.7-15.4 14.2-24.7C14.7 250.3 0 214.6 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176z"]]
}, F5 = {
  prefix: "fad",
  iconName: "trowel-bricks",
  icon: [512, 512, [], "e58a", ["M0 416c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-64zm192 0c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32l0-64zm96-160c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-64z", "M256 32c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-192 96C6.8 104.8 0 115.9 0 128s6.8 23.2 17.7 28.6l192 96c9.9 5 21.7 4.4 31.1-1.4s15.2-16.1 15.2-27.2l0-72 89 0c3.6 13.8 16.1 24 31 24l88 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-88 0c-14.9 0-27.4 10.2-31 24l-89 0 0-72z"]]
}, z5 = {
  prefix: "fad",
  iconName: "compass",
  icon: [512, 512, [129517], "f14e", ["M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM129.7 358.3c0-2.8 .5-5.8 1.7-8.7c18.5-48.1 37-96.2 55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4c48.1-18.5 96.2-37 144.3-55.5c19.4-7.5 38.5 11.6 31 31c-18.5 48.1-37 96.2-55.5 144.3c-3.3 8.5-9.9 15.1-18.4 18.4c-48.1 18.5-96.2 37-144.3 55.5c-16.5 6.3-32.7-6.4-32.7-22.3z", "M162.4 380.6l144.3-55.5c8.5-3.3 15.1-9.9 18.4-18.4l55.5-144.3c7.5-19.4-11.6-38.5-31-31L205.3 186.9c-8.5 3.3-15.1 9.9-18.4 18.4L131.4 349.6c-7.5 19.4 11.6 38.5 31 31zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
}, P5 = {
  prefix: "fad",
  iconName: "bars",
  icon: [448, 512, ["navicon"], "f0c9", ["M0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32z", "M448 96c0-17.7-14.3-32-32-32L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32zm0 320c0-17.7-14.3-32-32-32L32 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32z"]]
}, I5 = {
  prefix: "fad",
  iconName: "users",
  icon: [640, 512, [], "f0c0", ["M0 298.7C0 310.4 9.6 320 21.3 320l213.3 0c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7l-42.7 0C47.8 192 0 239.8 0 298.7zM64 80a80 80 0 1 0 160 0A80 80 0 1 0 64 80zM404.7 320c.2 0 .4 0 .7 0l213.3 0c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192l-42.7 0c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 38.2-16.8 72.5-43.3 96zM432 80a80 80 0 1 0 160 0A80 80 0 1 0 432 80z", "M320 320a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-58.7 32C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7l330.7 0c14.7 0 26.7-11.9 26.7-26.7C512 411.7 452.3 352 378.7 352l-117.3 0z"]]
}, N5 = {
  prefix: "fad",
  iconName: "eye-slash",
  icon: [640, 512, [], "f070", ["M0 256c0 4.2 .8 8.4 2.5 12.3C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480c56.1 0 104.4-17.8 144.5-43.2l-71.7-56.5C339.4 392.8 314.6 400 288 400c-79.5 0-144-64.5-144-144c0-14.5 2.1-28.5 6.1-41.7L63.5 146c-29.4 34.7-49.9 70.8-61.1 97.6C.8 247.6 0 251.8 0 256zM135.2 80.7L207 136.9c23.1-15.7 51-24.9 81-24.9c79.5 0 144 64.5 144 144c0 17.7-3.2 34.6-9 50.2c28 22 56.1 44 84.1 65.9c32.3-36.6 54.6-75.4 66.4-103.9c1.6-3.9 2.5-8.1 2.5-12.3s-.8-8.4-2.5-12.3c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32c-60 0-111.1 20.3-152.8 48.7zm56.8 179.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9c1.9-.5 3.9-1.1 5.7-1.7l-120-94.6c-3.7 .8-6.7 3.7-6.5 7.7zm92.7-88.4c2.1 6.4 3.3 13.2 3.3 20.3c0 2.7-.2 5.4-.5 8c31.6 24.8 63.2 49.5 94.8 74.3c2.7-13.9 2.4-28.6-1.5-43.2c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
}, D5 = {
  prefix: "fad",
  iconName: "calendars",
  icon: [512, 512, [], "e0d7", ["M96 192l416 0 0 176c0 26.5-21.5 48-48 48l-320 0c-26.5 0-48-21.5-48-48l0-176z", "M224 0c-17.7 0-32 14.3-32 32l0 32-48 0c-26.5 0-48 21.5-48 48l0 80 416 0 0-80c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32-96 0 0-32c0-17.7-14.3-32-32-32zM48 184c0-13.3-10.7-24-24-24s-24 10.7-24 24L0 392c0 66.3 53.7 120 120 120l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-272 0c-39.8 0-72-32.2-72-72l0-208z"]]
}, R5 = {
  prefix: "fad",
  iconName: "shield-check",
  icon: [512, 512, [], "f2f7", ["M16 139.7c.5 99.5 41.3 281 213.6 363.5c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c0-26.4-16.4-47.9-38.3-57.2L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8C32.4 92.1 16 113.6 16 139.7zM136 256c0-6.1 2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l47 47c37-37 74-74 111-111c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c2.3 2.3 4.1 5 5.3 7.9c.6 1.4 1 2.9 1.3 4.4c.2 1.1 .3 2.2 .3 2.2c.1 1.2 .1 1.2 .1 2.5c-.1 1.5-.1 1.9-.1 2.3c-.1 .7-.2 1.5-.3 2.2c-.3 1.5-.7 3-1.3 4.4c-1.2 2.9-2.9 5.6-5.3 7.9c-42.7 42.7-85.3 85.3-128 128c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7c-21.3-21.3-42.7-42.7-64-64c-4.7-4.7-7-10.8-7-17z", "M369 175c9.4 9.4 9.4 24.6 0 33.9L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0z"]]
}, j5 = {
  prefix: "fad",
  iconName: "badge-percent",
  icon: [512, 512, [], "f646", ["M0 256c0 36.8 20.7 68.8 51.1 84.9C41 373.8 49 411 75 437s63.3 34 96.1 23.9C187.2 491.3 219.2 512 256 512s68.8-20.7 84.9-51.1C373.8 471 411 463 437 437s34-63.3 23.9-96.1C491.3 324.8 512 292.8 512 256s-20.7-68.8-51.1-84.9C471 138.2 463 101 437 75s-63.3-34-96.1-23.9C324.8 20.7 292.8 0 256 0s-68.8 20.7-84.9 51.1C138.2 41 101 49 75 75s-34 63.3-23.9 96.1C20.7 187.2 0 219.2 0 256zm224-64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM175 303L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L209 337c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9zm177 17a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z", "M224 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM352 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM337 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L175 303c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L337 209z"]]
}, B5 = {
  prefix: "fad",
  iconName: "user",
  icon: [448, 512, [128100, 62144], "f007", ["M96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128z", "M0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3z"]]
}, V5 = {
  prefix: "fad",
  iconName: "rectangle-history-circle-user",
  icon: [640, 512, [], "e4a4", ["M0 224L0 448c0 35.3 28.7 64 64 64l330.8 0C349.5 480.1 320 427.5 320 368c0-97.2 78.8-176 176-176c2.5 0 5 .1 7.5 .2c-11-19.2-31.8-32.2-55.5-32.2L64 160c-35.3 0-64 28.7-64 64zM48 104c0 13.3 10.7 24 24 24l368 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 80c-13.3 0-24 10.7-24 24zM96 24c0 13.3 10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L120 0C106.7 0 96 10.7 96 24z", "M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-32c-30.2 0-57.5-11.9-77.7-31.3c6.2-19 24-32.7 45.1-32.7l65.2 0c21 0 38.9 13.7 45.1 32.7C553.5 468.1 526.2 480 496 480zm0-192a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]]
}, U5 = {
  prefix: "fad",
  iconName: "star",
  icon: [576, 512, [11088, 61446], "f005", ["M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z", ""]]
}, H5 = {
  prefix: "fad",
  iconName: "shop-slash",
  icon: [640, 512, ["store-alt-slash"], "e070", ["M0 155.2c0-7.3 2.2-14.4 6.2-20.4L21 112.5 121.8 192l-85 0C16.5 192 0 175.5 0 155.2zM64 224l64 0 0 160 192 0 0-35.9 64 50.4 0 65.5c0 26.5-21.5 48-48 48l-224 0c-26.5 0-48-21.5-48-48l0-80 0-160zM74.1 32.8l7.6-11.4C90.7 8 105.6 0 121.7 0L518.3 0c16.1 0 31 8 39.9 21.4l75.6 113.3c4 6.1 6.2 13.2 6.2 20.4c0 20.3-16.5 36.8-36.8 36.8l-325.9 0C209.5 138.9 141.8 85.9 74.1 32.8zM320 224l64 0 0 51.7-64-50.2 0-1.5zm192 0l64 0 0 202.2c-21.3-16.7-42.7-33.4-64-50.2l0-152z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
}, G5 = {
  prefix: "fad",
  iconName: "farm",
  icon: [576, 512, ["barn-silo"], "f864", ["M160 270.3c0-4.2 .8-8.3 2.4-12.2l48.9-118.7c3-7.4 8.7-13.3 15.9-16.7L354.3 62.5c4.3-2.1 9-3.1 13.7-3.1s9.4 1 13.7 3.1l127.1 60.2c7.2 3.4 12.9 9.4 15.9 16.7l48.9 118.7c1.6 3.9 2.4 8 2.4 12.2L576 480c0 17.7-14.3 32-32 32l-112 0 0-64c0-26.5-21.5-48-48-48l-32 0c-26.5 0-48 21.5-48 48l0 64-112 0c-17.7 0-32-14.3-32-32l0-209.7zM320 248l0 48c0 13.3 10.7 24 24 24c16 0 32 0 48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24c-16 0-32 0-48 0c-13.3 0-24 10.7-24 24z", "M0 96l192 0c0-53-43-96-96-96S0 43 0 96zm181.4 32L0 128 0 464c0 26.5 21.5 48 48 48l88.6 0c-5.4-9.4-8.6-20.3-8.6-32l0-209.7c0-8.4 1.6-16.6 4.8-24.4l48.6-118zM344 224c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0z"]]
}, q5 = {
  prefix: "fad",
  iconName: "house-circle-exclamation",
  icon: [640, 512, [], "e50a", ["M0 255.5c0 18 14 32.1 32 32.1l32 0 0 69.7c-.1 .9-.1 1.8-.1 2.8l0 112c0 22.1 17.9 40 40 40l16 0c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2l31.9 0 24 0c22.1 0 40-17.9 40-40l0-24 0-64c0-17.7 14.3-32 32-32l64 0 .7 0c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24z", "M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-8-152c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80z"]]
}, W5 = {
  prefix: "fad",
  iconName: "mug-hot",
  icon: [512, 512, [9749], "f7b6", ["M64 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C120.5 112.3 128 119.9 128 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C119.5 47.7 112 40.1 112 24c0-13.3-10.7-24-24-24S64 10.7 64 24zm112 0c0 38.9 23.4 59.4 39.1 73.1l1.1 1C232.5 112.3 240 119.9 240 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C231.5 47.7 224 40.1 224 24c0-13.3-10.7-24-24-24s-24 10.7-24 24z", "M32 192c-17.7 0-32 14.3-32 32L0 416c0 53 43 96 96 96l192 0c53 0 96-43 96-96l16 0c61.9 0 112-50.1 112-112s-50.1-112-112-112l-48 0L32 192zm352 64l16 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-16 0 0-96z"]]
}, Y5 = {
  prefix: "fad",
  iconName: "handshake",
  icon: [640, 512, [], "f2b5", ["M208.3 186.4c-.1 .9-.2 1.9-.2 2.8c-.1 .9-.1 1.9-.1 2.8c0 9.7 2.9 19.4 8.9 27.9c15.4 21.6 45.4 26.6 67 11.2l57.2-40.8c4.4 4 8.8 8 13.1 12L496.4 332.6c5.5 5 9.5 11.1 12.1 17.5c.3 .6 .5 1.2 .7 1.8l2.7 0 0-224-1.5 0-71-47.3C423.2 69.8 404.1 64 384.5 64c-20.7 0-40.9 6.5-57.7 18.5c-3.1 2.2-6.2 4.4-9.3 6.7c-29.8 21.3-59.5 42.5-89.3 63.8c-.8 .6-1.6 1.2-2.4 1.8s-1.5 1.3-2.2 1.9c-1.4 1.3-2.8 2.7-4 4.2c-2.5 2.9-4.6 6.1-6.3 9.5s-3 6.9-3.8 10.5c-.4 1.8-.8 3.7-1 5.5zM544 128l0 224c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-208c0-8.8-7.2-16-16-16l-80 0zm64 208a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z", "M156.2 352L128 352l0-224 72-48c15.6-10.4 34-16 52.8-16c22.7 0 44.7 8.1 61.9 22.9l2.7 2.3-89.3 63.8c-21.6 15.4-26.6 45.4-11.2 67s45.4 26.6 67 11.2l57.2-40.8 13.1 12L496.4 332.6c5.5 5 9.6 11.1 12.1 17.5c6.6 16.6 3.7 36.2-9.2 50.3c-17.9 19.5-48.3 20.9-67.8 2.9l-7.8-7.1c-.9 10.1-5 20.1-12.4 28.2c-17.9 19.5-48.3 20.9-67.8 2.9l-17-15.6c-1.9 7.4-5.6 14.5-11.1 20.6c-17.9 19.6-48.2 21-67.8 3.1L156.2 352zM0 144c0-8.8 7.2-16 16-16l80 0 0 224c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32L0 144zM64 336a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]]
}, K5 = {
  prefix: "fad",
  iconName: "euro-sign",
  icon: [320, 512, [8364, "eur", "euro"], "f153", ["M0 208c0-17.7 14.3-32 32-32l28.3 0c-7.1 20.1-11.3 41.6-12.1 64L32 240c-17.7 0-32-14.3-32-32zm0 96c0-17.7 14.3-32 32-32l16.1 0c.8 22.4 5 43.9 12.1 64L32 336c-17.7 0-32-14.3-32-32zm112.2-64c1.2-23.1 7.5-44.8 17.9-64L256 176c17.7 0 32 14.3 32 32s-14.3 32-32 32l-143.8 0zm0 32L256 272c17.7 0 32 14.3 32 32s-14.3 32-32 32l-125.9 0c-10.4-19.2-16.7-40.9-17.9-64z", "M48 248C48 128.7 144.7 32 264 32l24 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-24 0c-83.9 0-152 68.1-152 152l0 16c0 83.9 68.1 152 152 152l24 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-24 0C144.7 480 48 383.3 48 264l0-16z"]]
}, Z5 = {
  prefix: "fad",
  iconName: "image-slash",
  icon: [640, 512, [], "e1b7", ["M64 146.4L64 416c0 35.3 28.7 64 64 64l359.4 0-81.2-64L320 416l-72 0-96 0c-9.3 0-17.8-5.4-21.8-13.9s-2.6-18.5 3.5-25.6l88-104c.3-.4 .6-.7 1-1.1L64 146.4zM89.5 44.9c23.1 18.1 46.2 36.2 69.3 54.3c5.3-2 11.1-3.2 17.2-3.2c26.5 0 48 21.5 48 48c0 2-.1 4-.4 6c34.8 27.3 69.7 54.6 104.5 81.9l20-29.4c4.5-6.6 11.9-10.5 19.8-10.5s15.4 3.9 19.8 10.5L499.4 366.1l75.9 59.5c.5-3.1 .7-6.3 .7-9.6l0-320c0-35.3-28.7-64-64-64L128 32c-14.4 0-27.8 4.8-38.5 12.9z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
}, X5 = {
  prefix: "fad",
  iconName: "user-tie",
  icon: [448, 512, [], "f508", ["M352 128A128 128 0 1 1 96 128a128 128 0 1 1 256 0z", "M190.5 328.2l18.6 31L175.8 483.1l-36-146.9c-2-8.1-9.8-13.4-17.9-11.3C51.9 342.4 0 405.8 0 481.3c0 17 13.8 30.7 30.7 30.7l131.7 0c2.1 0 4-.4 5.8-1.1L168 512l112 0-.3-1.1c1.8 .7 3.8 1.1 5.8 1.1l131.7 0c17 0 30.7-13.8 30.7-30.7c0-75.5-51.9-138.9-121.9-156.4c-8.1-2-15.9 3.3-17.9 11.3l-36 146.9L238.9 359.2l18.6-31c6.4-10.7-1.3-24.2-13.7-24.2L224 304l-19.7 0c-12.4 0-20.1 13.6-13.7 24.2z"]]
}, J5 = {
  prefix: "fad",
  iconName: "list-tree",
  icon: [512, 512, [], "e1d2", ["M160 96c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32zM288 256c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32z", "M24 48C10.7 48 0 58.7 0 72l0 48c0 13.3 10.7 24 24 24l0 112 0 128c0 30.9 25.1 56 56 56l48 0c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l-48 0c-4.4 0-8-3.6-8-8l0-104 56 0c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l-56 0 0-88c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24L24 48z"]]
}, Q5 = {
  prefix: "fad",
  iconName: "rabbit-running",
  icon: [576, 512, ["rabbit-fast"], "f709", ["M86.6 254.9c4.9 17.2 14.5 33.1 28.4 45.9L257.2 431.2C269 442 284.4 448 300.4 448L416 448c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-16.8 0L320 384l0-43.5c0-42.9-28.4-80.5-69.6-92.3l-30.8-8.8c-8.5-2.4-13.4-11.3-11-19.8s11.3-13.4 19.8-11l30.8 8.8c55 15.7 92.8 65.9 92.8 123.1l0 15.7 56-32.4 6.4-3.7 101.3 0c33.3 0 60.3-27 60.3-60.3c0-18.1-8.2-35.3-22.2-46.7l-34.6-28.2c-4.6-3.7-9.4-7.1-14.5-10c8.4-49.3-7.8-100-43.9-135.5l-2.2-2.1c-3.5-3.5-8.2-5.3-13-5.3c-1.6 0-3.2 .2-4.8 .6c-6.4 1.7-11.4 6.6-13.1 13l-.8 2.9c-3.3 11.8-5.1 23.7-5.5 35.6c24.3 20.6 42.9 47.8 53.3 78.8c-8.2-1.9-16.5-2.9-25-2.9c-.6 0-1.1 0-1.7 0c-18.4-44-56.5-77.4-103.6-89.3l-3.4-.9c-6.2-1.6-12.9-.6-18.5 2.6c-10.8 6.2-15.6 19.5-11.2 31.1c14.9 39.5 44.3 71.4 81.4 89.7c-3.7 6.6-6.4 14-7.6 21.8L279.7 154.9C248.8 137.3 213.8 128 178.2 128c-32.3 0-62.2 16.8-78.9 44.4l-.3 .4c-.7 1.1-1.4 2.3-2.1 3.4c-14.6 24.3-17.7 52.8-10.3 78.6zm46.8 210.8C139.5 475 149.7 480 160 480c6.1 0 12.3-1.7 17.7-5.4l46-30.7-48.6-44.5-32.9 22c-14.7 9.8-18.7 29.7-8.9 44.4zM512 240a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z", "M99 172.9l.3-.4C89 159.9 73.4 152 56 152c-30.9 0-56 25.1-56 56s25.1 56 56 56c11.3 0 21.8-3.3 30.6-9.1c-7.4-25.8-4.3-54.3 10.3-78.6l2.1-3.4zM496 256a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]]
}, e7 = {
  prefix: "fad",
  iconName: "mug-tea",
  icon: [576, 512, [], "f875", ["M96 189.3c0-8.5 3.4-16.6 9.4-22.6l29.3-29.3c6-6 9.4-14.1 9.4-22.6L144 64l32 0 0 50.7c0 8.5 3.4 16.6 9.4 22.6l29.3 29.3c6 6 9.4 14.1 9.4 22.6l0 66.7c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-66.7z", "M144 64l0 50.7c0 8.5-3.4 16.6-9.4 22.6l-29.3 29.3c-6 6-9.4 14.1-9.4 22.6L96 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-66.7c0-8.5-3.4-16.6-9.4-22.6l-29.3-29.3c-6-6-9.4-14.1-9.4-22.6L176 64l208 0 64 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-32 0 0 32c0 53-43 96-96 96l-192 0c-53 0-96-43-96-96L32 96c0-17.7 14.3-32 32-32l80 0zM416 256l32 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-32 0 0 128z"]]
}, t7 = {
  prefix: "fad",
  iconName: "whiskey-glass",
  icon: [512, 512, [129347, "glass-whiskey"], "f7a0", ["M.3 68.6l50 342.9c5.7 39.3 39.4 68.5 79.2 68.5l253 0c39.7 0 73.4-29.1 79.2-68.5l50-342.9c1.3-9.2-1.4-18.5-7.5-25.5S489.3 32 480 32L32 32c-9.3 0-18.1 4-24.2 11.1S-1 59.4 .3 68.6zM69 96l374 0c-6.2 42.7-12.4 85.3-18.7 128l-26 178.3c-1.1 7.9-7.9 13.7-15.8 13.7l-253 0c-7.9 0-14.7-5.8-15.8-13.7L87.7 224C81.5 181.3 75.2 138.7 69 96z", "M424.3 224L87.7 224l26 178.3c1.1 7.9 7.9 13.7 15.8 13.7l253 0c7.9 0 14.7-5.8 15.8-13.7l26-178.3z"]]
}, n7 = {
  prefix: "fad",
  iconName: "mobile-notch",
  icon: [384, 512, ["mobile-iphone"], "e1ee", ["M16 80C16 35.8 51.8 0 96 0L288 0c44.2 0 80 35.8 80 80l0 352c0 44.2-35.8 80-80 80L96 512c-44.2 0-80-35.8-80-80L16 80zm64 0l0 352c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16l0-352c0-8.8-7.2-16-16-16l-32 0 0 16c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-16L96 64c-8.8 0-16 7.2-16 16z", "M128 64H96c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H256V80c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V64z"]]
}, B1 = {
  prefix: "fad",
  iconName: "file-excel",
  icon: [384, 512, [], "f1c3", ["M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM116.3 277.8L162.7 344l-46.4 66.2c-7.6 10.9-5 25.8 5.9 33.4c4.2 2.9 9 4.3 13.7 4.3c7.6 0 15-3.6 19.7-10.2L192 385.8l36.3 51.9C233 444.4 240.5 448 248 448c4.8 0 9.6-1.4 13.7-4.3c10.9-7.6 13.5-22.6 5.9-33.4c-15.5-22.1-30.9-44.2-46.4-66.2c15.5-22.1 30.9-44.2 46.4-66.2c7.6-10.9 5-25.8-5.9-33.4s-25.8-5-33.4 5.9L192 302.1c-12.1-17.3-24.2-34.6-36.3-51.9c-7.6-10.9-22.6-13.5-33.4-5.9s-13.5 22.6-5.9 33.4z", "M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM155.7 250.2c-7.6-10.9-22.6-13.5-33.4-5.9s-13.5 22.6-5.9 33.4L162.7 344l-46.4 66.2c-7.6 10.9-5 25.8 5.9 33.4s25.8 5 33.4-5.9L192 385.8l36.3 51.9c7.6 10.9 22.6 13.5 33.4 5.9s13.5-22.6 5.9-33.4L221.3 344l46.4-66.2c7.6-10.9 5-25.8-5.9-33.4s-25.8-5-33.4 5.9L192 302.1l-36.3-51.9z"]]
}, r7 = {
  prefix: "fad",
  iconName: "screwdriver-wrench",
  icon: [512, 512, ["tools"], "f7d9", ["M0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L233.7 374.3c-7.8-20.9-9-43.6-3.6-65.1l-61.7-61.7L19.9 396.1C7.2 408.8 0 426.1 0 444.1zM104 432a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM224 144c0 .3 0 .5 0 .8l85.3 85.3c36-9.1 75.8 .5 104 28.7L429 274.5c49-23 83-72.8 83-130.5c0-10.5-1.1-20.7-3.2-30.5c-2.4-11.2-16.1-14.1-24.2-6l-63.9 63.9c-3 3-7.1 4.7-11.3 4.7L352 176c-8.8 0-16-7.2-16-16l0-57.4c0-4.2 1.7-8.3 4.7-11.3l63.9-63.9c8.1-8.1 5.2-21.8-6-24.2C388.7 1.1 378.5 0 368 0C288.5 0 224 64.5 224 144z", "M47 7c8.5-8.5 22-9.4 31.6-2.1l104 80c5.9 4.5 9.4 11.6 9.4 19l0 54.1 109 109c29-14.7 65.4-10 89.6 14.3l112 112c12.5 12.5 12.5 32.8 0 45.3l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-112-112c-24.2-24.2-29-60.6-14.3-89.6l-109-109L104 192c-7.5 0-14.5-3.5-19-9.4L5 78.6C-2.4 69.1-1.5 55.6 7 47L47 7z"]]
}, a7 = {
  prefix: "fad",
  iconName: "badge-check",
  icon: [512, 512, [], "f336", ["M0 256c0 36.8 20.7 68.8 51.1 84.9C41 373.8 49 411 75 437s63.3 34 96.1 23.9C187.2 491.3 219.2 512 256 512s68.8-20.7 84.9-51.1C373.8 471 411 463 437 437s34-63.3 23.9-96.1C491.3 324.8 512 292.8 512 256s-20.7-68.8-51.1-84.9C471 138.2 463 101 437 75s-63.3-34-96.1-23.9C324.8 20.7 292.8 0 256 0s-68.8 20.7-84.9 51.1C138.2 41 101 49 75 75s-34 63.3-23.9 96.1C20.7 187.2 0 219.2 0 256zm136 0c0-6.1 2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l47 47c37-37 74-74 111-111c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c2.3 2.3 4.1 5 5.3 7.9c.6 1.5 1 2.9 1.3 4.4c.2 1.1 .3 2.2 .3 2.2c.1 1.2 .1 1.2 .1 2.5c-.1 1.5-.1 1.9-.1 2.3c-.1 .7-.2 1.5-.3 2.2c-.3 1.5-.7 3-1.3 4.4c-1.2 2.9-2.9 5.6-5.3 7.9c-42.7 42.7-85.3 85.3-128 128c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7c-21.3-21.3-42.7-42.7-64-64c-4.7-4.7-7-10.8-7-17z", "M369 175c9.4 9.4 9.4 24.6 0 33.9L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0z"]]
}, i7 = {
  prefix: "fad",
  iconName: "wallet",
  icon: [512, 512, [], "f555", ["M0 80C0 53.5 21.5 32 48 32l384 0c26.5 0 48 21.5 48 48l0 16 0 32 0 8.6c-6.8-3.9-14.4-6.6-22.4-7.9c-2.7-.4-5.5-.6-8.2-.7c-.4 0-.9 0-1.3 0c-21.3 0-42.7 0-64 0c-96 0-192 0-288 0c-16 0-32 0-48 0C21.5 128 0 106.5 0 80z", "M48 128l48 0s0 0 0 0l352 0c.4 0 .9 0 1.3 0c11.2 .2 21.6 3.6 30.7 8.9l0-.3c19.1 11.1 32 31.7 32 55.4l0 224c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 240l0-48L0 80c0 26.5 21.5 48 48 48zM416 336a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
}, s7 = {
  prefix: "fad",
  iconName: "files",
  icon: [448, 512, [], "e178", ["M96 64l0 288c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-256-64 0c-17.7 0-32-14.3-32-32l0-64L160 0C124.7 0 96 28.7 96 64z", "M352 0l0 64c0 17.7 14.3 32 32 32l64 0L352 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 376c0 75.1 60.9 136 136 136l192 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-192 0c-48.6 0-88-39.4-88-88l0-256z"]]
}, o7 = {
  prefix: "fad",
  iconName: "eye",
  icon: [576, 512, [128065], "f06e", ["M0 256c0 4.2 .8 8.4 2.5 12.3C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c1.6-3.9 2.5-8.1 2.5-12.3s-.8-8.4-2.5-12.3c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32s-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7C.8 247.6 0 251.8 0 256zm432 0a144 144 0 1 1 -288 0 144 144 0 1 1 288 0z", "M224 256c35.3 0 64-28.7 64-64c0-7.1-1.2-13.9-3.3-20.3c-1.8-5.5 1.6-11.9 7.4-11.7c40.8 1.7 77.5 29.6 88.6 71.1c13.7 51.2-16.7 103.9-67.9 117.6s-103.9-16.7-117.6-67.9c-1.9-6.9-2.9-13.9-3.2-20.7c-.3-5.8 6.1-9.2 11.7-7.4c6.4 2.1 13.2 3.3 20.3 3.3z"]]
}, l7 = {
  prefix: "fad",
  iconName: "shop",
  icon: [640, 512, ["store-alt"], "f54f", ["M64 192l32 0 32 0 192 0 64 0 128 0 32 0 32 0 0 288c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-256-128 0 0 160 0 80c0 26.5-21.5 48-48 48l-224 0c-26.5 0-48-21.5-48-48l0-80 0-192zm64 32l0 160 192 0 0-160-192 0z", "M603.2 192H36.8C16.5 192 0 175.5 0 155.2c0-7.3 2.2-14.4 6.2-20.4L81.8 21.4C90.7 8 105.6 0 121.7 0H518.3c16.1 0 31 8 39.9 21.4l75.6 113.3c4 6.1 6.2 13.2 6.2 20.4c0 20.3-16.5 36.8-36.8 36.8z"]]
}, u7 = {
  prefix: "fad",
  iconName: "scale-unbalanced",
  icon: [640, 512, ["balance-scale-left"], "f515", ["M96.5 170.1c5.6 16.8 23.7 25.8 40.5 20.2l135.5-45.2c4.5 3.2 9.3 5.9 14.4 8.2l0 326.7c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-160 0 0-294.7c21-9.2 37.2-27 44.2-49L521 62.4c16.8-5.6 25.8-23.7 20.2-40.5C536.7 8.5 524.2 0 510.9 0c-3.4 0-6.8 .5-10.1 1.7l-113 37.7C373.8 15.8 348.2 0 318.8 0c-44.2 0-80 35.8-80 80c0 3 .2 5.9 .5 8.8L116.7 129.6c-16.8 5.6-25.8 23.7-20.2 40.5z", "M510.8 163.8L583.3 288l-144.9 0 72.4-124.2zm-126 141.3C395.7 350 448 384 510.8 384s115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L534.9 109.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L391.6 273.1c-5.7 9.8-9.3 21.1-6.7 32.1zM128 291.8L200.4 416 55.6 416 128 291.8zM2 433.1C12.8 478 65.1 512 128 512s115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L152.1 237.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L8.7 401.1C3 410.8-.6 422.1 2 433.1z"]]
}, V1 = {
  prefix: "fad",
  iconName: "hand-holding-dollar",
  icon: [576, 512, ["hand-holding-usd"], "f4c0", ["M0 416l0 64c0 17.7 14.3 32 32 32l160 0 160.5 0c29 0 57.3-9.3 80.7-26.5l126.6-93.3c10.6-7.8 16.3-20 16.3-32.2c0-8.2-2.5-16.6-7.8-23.7c-13.1-17.8-38.1-21.6-55.9-8.5L392.6 416 272 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-16 0-78.3 0c-29.1 0-57.3 9.9-80 28L68.8 384 32 384c-17.7 0-32 14.3-32 32z", "M288 0c13.3 0 24 10.7 24 24l0 10.5c6.4 1.2 12.6 2.7 18.2 4.2c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5c-7.3-.1-14.7 1.7-19.4 4.4c-2.1 1.3-3.1 2.4-3.5 3c-.3 .5-.7 1.2-.7 2.8c0 .3 0 .5 0 .6c.2 .2 .9 1.2 3.3 2.6c5.8 3.5 14.4 6.2 27.4 10.1l.9 .3s0 0 0 0c11.1 3.3 25.9 7.8 37.9 15.3c13.7 8.6 26.1 22.9 26.4 44.9c.3 22.5-11.4 38.9-26.7 48.5c-6.7 4.1-13.9 7-21.3 8.8l0 10.6c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-11.4c-9.5-2.3-18.2-5.3-25.6-7.8c-2.1-.7-4.1-1.4-6-2c-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6 .9 5 1.7 7.3 2.5c13.6 4.6 23.4 7.9 33.9 8.3c8 .3 15.1-1.6 19.2-4.1c1.9-1.2 2.8-2.2 3.2-2.9c.4-.6 .9-1.8 .8-4.1l0-.2c0-1 0-2.1-4-4.6c-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4c-13.5-8.1-26.5-22-26.6-44.1c-.1-22.9 12.9-38.6 27.7-47.4c6.4-3.8 13.3-6.4 20.2-8.2L264 24c0-13.3 10.7-24 24-24z"]]
}, c7 = {
  prefix: "fad",
  iconName: "spinner-third",
  icon: [512, 512, [], "f3f4", ["M0 256C0 114.9 114.1 .5 255.1 0C237.9 .5 224 14.6 224 32c0 17.7 14.3 32 32 32C150 64 64 150 64 256s86 192 192 192c69.7 0 130.7-37.1 164.5-92.6c-3 6.6-3.3 14.8-1 22.2c1.2 3.7 3 7.2 5.4 10.3c1.2 1.5 2.6 3 4.1 4.3c.8 .7 1.6 1.3 2.4 1.9c.4 .3 .8 .6 1.3 .9s.9 .6 1.3 .8c5 2.9 10.6 4.3 16 4.3c11 0 21.8-5.7 27.7-16c-44.3 76.5-127 128-221.7 128C114.6 512 0 397.4 0 256z", "M224 32c0-17.7 14.3-32 32-32C397.4 0 512 114.6 512 256c0 46.6-12.5 90.4-34.3 128c-8.8 15.3-28.4 20.5-43.7 11.7s-20.5-28.4-11.7-43.7c16.3-28.2 25.7-61 25.7-96c0-106-86-192-192-192c-17.7 0-32-14.3-32-32z"]]
}, d7 = {
  prefix: "fad",
  iconName: "phone",
  icon: [512, 512, [128222, 128379], "f095", ["M68.4 14.8c.3 2.3 .6 4.5 .9 6.7c.3 2.2 .6 4.5 1 6.7c.7 4.5 1.4 8.9 2.2 13.3c1.6 8.8 3.4 17.6 5.4 26.2c4.1 17.3 9 34.3 14.9 50.8c11.7 33.1 26.8 64.6 44.9 94c8.3-6.8 16.7-13.6 25-20.5C129.2 136.7 107.2 73.7 99.7 6.3L68.4 14.8zm231 359.6c58.9 36.2 125.9 60.4 197.8 69.1l8.5-31.2c-67.4-7.5-130.4-29.5-185.8-62.9l-20.5 25z", "M68.4 14.8l-39 10.6C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l10.6-39C273.2 416.4 95.6 238.8 68.4 14.8zM505.7 412.3l4.9-17.8c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6l-25.1 30.7c55.4 33.4 118.4 55.4 185.8 62.9zM162.6 192.1L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96c-7.7-18.6-28-28.5-47.4-23.2L99.7 6.3c7.5 67.4 29.5 130.4 62.9 185.8z"]]
}, f7 = {
  prefix: "fad",
  iconName: "pen-fancy",
  icon: [512, 512, [128395, 10002], "f5ac", ["M1.7 487.7l95.4-95.4c-.7-2.6-1.1-5.4-1.1-8.3c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32c-2.9 0-5.6-.4-8.3-1.1L24.3 510.3 211.2 458c11.3-3.2 19.9-12.2 22.6-23.6l21.9-94.7c.1-.6 .3-1.1 .4-1.7c-27.3-27.3-54.6-54.6-81.9-81.9c-.6 .1-1.1 .3-1.7 .4L77.7 278.3c-11.4 2.6-20.5 11.3-23.6 22.6L1.7 487.7z", "M373.5 27.1C388.5 9.9 410.2 0 433 0c43.6 0 79 35.4 79 79c0 22.8-9.9 44.6-27.1 59.6L256 337.9s0 0 0 0s0 0 0 0L174.1 256 373.5 27.1z"]]
}, p7 = {
  prefix: "fad",
  iconName: "arrow-left",
  icon: [448, 512, [8592], "f060", ["M77.3 256l32-32L416 224c17.7 0 32 14.3 32 32s-14.3 32-32 32l-306.7 0c-10.7-10.7-21.3-21.3-32-32z", "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L77.3 256 214.6 393.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-160-160z"]]
}, h7 = {
  prefix: "fad",
  iconName: "file-pdf",
  icon: [512, 512, [], "f1c1", ["M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64z", "M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zM176 352c-8.8 0-16 7.2-16 16l0 80 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 16 0c30.9 0 56-25.1 56-56s-25.1-56-56-56l-32 0zm32 80l-16 0 0-48 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24zm96-80c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16l32 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-32 0zm32 128l-16 0 0-96 16 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16zm80-112l0 64 0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16z"]]
}, m7 = {
  prefix: "fad",
  iconName: "comment",
  icon: [512, 512, [128489, 61669], "f075", ["M512 240c0 114.9-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.3-.3c.3-.3 .7-.7 1.3-1.4c1.1-1.2 2.8-3.1 4.9-5.7c4.1-5 9.6-12.4 15.2-21.6c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208z", ""]]
}, v7 = {
  prefix: "fad",
  iconName: "house-chimney-blank",
  icon: [576, 512, [], "e3b0", ["M64 270.5c74.7-65.3 149.3-130.7 224-196L512.1 270.6l.4 177.3c.1 35.4-28.6 64.1-64 64.1l-320.4 0c-35.3 0-64-28.6-64-64L64 270.5z", "M309.1 7.9C297-2.6 279-2.6 266.9 7.9l-256 224c-13.3 11.6-14.6 31.9-3 45.2s31.9 14.6 45.2 3L288 74.5 522.9 280.1c13.3 11.6 33.5 10.3 45.2-3s10.3-33.5-3-45.2L512 185.5 512 64c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32l0 37.5L309.1 7.9z"]]
}, g7 = {
  prefix: "fad",
  iconName: "calendar-clock",
  icon: [576, 512, ["calendar-time"], "e0d2", ["M0 112l0 48 448 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32S96 14.3 96 32l0 32L48 64C21.5 64 0 85.5 0 112zm0 80L0 464c0 26.5 21.5 48 48 48l282.8 0C285.6 480.1 256 427.5 256 368c0-97.2 78.8-176 176-176L0 192zm432 0c5.4 0 10.7 .2 16 .7l0-.7-16 0z", "M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z"]]
}, b7 = {
  prefix: "fad",
  iconName: "share-all",
  icon: [576, 512, [], "f367", ["M352 64l0 43.3 85.4 76.9c6.7 6.1 10.6 14.7 10.6 23.8s-3.8 17.7-10.6 23.8L352 308.7l0 43.3c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-6-5.4-13.7-8.2-21.4-8.2c-4.4 0-8.8 .9-13 2.8c-11.5 5.1-19 16.6-19 29.2z", "M243 34.8c-11.5 5.1-19 16.6-19 29.2l0 64-48 0C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96l32 0 0 64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4z"]]
}, $7 = {
  prefix: "fad",
  iconName: "clock",
  icon: [512, 512, [128339, "clock-four"], "f017", ["M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120c.1-13.4 10.8-24 24-24c6.6 0 12.6 2.7 17 7c2.2 2.2 3.9 4.8 5.1 7.6c.6 1.4 1.1 2.9 1.4 4.5c.2 .8 .3 1.6 .4 2.4s.1 1.6 .1 2.5c0 41 0 82.1 0 123.2L365.3 300c6.9 4.6 10.7 12.2 10.7 20c0 4.6-1.3 9.2-4 13.3c-4.6 6.9-12.2 10.7-20 10.7c-4.6 0-9.2-1.3-13.3-4c-32-21.3-64-42.7-96-64C236 271.5 232 264 232 256c0-45.3 0-90.7 0-136z", "M256 96c-13.3 0-24 10.7-24 24l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24z"]]
}, y7 = {
  prefix: "fad",
  iconName: "list-radio",
  icon: [512, 512, [], "e1d0", ["M160 96c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32z", "M64 160A64 64 0 1 0 64 32a64 64 0 1 0 0 128zm0 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 88a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 88a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]]
}, x7 = {
  prefix: "fad",
  iconName: "coins",
  icon: [512, 512, [], "f51e", ["M128 80c0 18 14.3 34.6 38.4 48c.4 .2 .7 .4 1.1 .6c8.1-.4 16.3-.6 24.5-.6c56.2 0 108.6 9.4 148.1 25.9c3.8 1.6 7.6 3.3 11.3 5c49.8-3.4 93.2-14.8 122.3-30.9C497.7 114.6 512 98 512 80c0-44.2-86-80-192-80S128 35.8 128 80zM391.9 186.6C405.4 200.1 416 218.1 416 240l0 5.3c19.9-4.8 37.6-11.1 52.2-18.4c1.9-.9 3.7-1.9 5.5-2.9c24.1-13.4 38.4-30 38.4-48l0-35.4c-12.5 10.3-27.6 18.7-43.9 25.5c-21.9 9.1-47.8 16.1-76.2 20.5zM416 278.1l0 63.2c57.4-13.8 96-39.7 96-69.3l0-35.4c-12.5 10.3-27.6 18.7-43.9 25.5c-15.6 6.5-33.1 11.9-52.1 16z", "M384 240c0 18-14.3 34.6-38.4 48c-35 19.4-90.8 32-153.6 32c-59.6 0-112.9-11.3-148.2-29.1c-1.9-.9-3.7-1.9-5.5-2.9C14.3 274.6 0 258 0 240c0-44.2 86-80 192-80s192 35.8 192 80zM192 352c56.2 0 108.6-9.4 148.1-25.9c16.3-6.8 31.5-15.2 43.9-25.5l0 35.4c0 18-14.3 34.6-38.4 48c-1.8 1-3.6 1.9-5.5 2.9C304.9 404.7 251.6 416 192 416c-62.8 0-118.6-12.6-153.6-32C14.3 370.6 0 354 0 336l0-35.4c12.5 10.3 27.6 18.7 43.9 25.5C83.4 342.6 135.8 352 192 352zm148.1 70.1c16.3-6.8 31.5-15.2 43.9-25.5l0 35.4c0 44.2-86 80-192 80S0 476.2 0 432l0-35.4c12.5 10.3 27.6 18.7 43.9 25.5C83.4 438.6 135.8 448 192 448s108.6-9.4 148.1-25.9z"]]
}, _7 = {
  prefix: "fad",
  iconName: "loader",
  icon: [512, 512, [], "e1d4", ["M65.6 414.4c0 8.2 3.1 16.4 9.4 22.6c12.5 12.5 32.8 12.5 45.3 0l45.3-45.3c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L75 391.8c-6.2 6.2-9.4 14.4-9.4 22.6zM224 416l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32zM346.5 120.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L437 120.2c12.5-12.5 12.5-32.8 0-45.3c-6.2-6.2-14.4-9.4-22.6-9.4s-16.4 3.1-22.6 9.4l-45.3 45.3zm0 226.3c-12.5 12.5-12.5 32.8 0 45.3L391.8 437c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-45.3-45.3c-12.5-12.5-32.8-12.5-45.3 0zM384 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32z", "M256 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-17.7-14.3-32-32-32zM0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zM120.2 75C107.7 62.5 87.5 62.5 75 75s-12.5 32.8 0 45.3l45.3 45.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L120.2 75z"]]
}, w7 = {
  prefix: "fad",
  iconName: "id-card",
  icon: [576, 512, [62147, "drivers-license"], "f2c2", ["M0 128L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-288L0 128zM64 405.3c0-29.5 23.9-53.3 53.3-53.3l117.3 0c29.5 0 53.3 23.9 53.3 53.3c0 5.9-4.8 10.7-10.7 10.7L74.7 416c-5.9 0-10.7-4.8-10.7-10.7zM240 256a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zm112-48c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z", "M64 32C28.7 32 0 60.7 0 96l0 32 576 0 0-32c0-35.3-28.7-64-64-64L64 32zM240 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM64 405.3c0 5.9 4.8 10.7 10.7 10.7l202.7 0c5.9 0 10.7-4.8 10.7-10.7c0-29.5-23.9-53.3-53.3-53.3l-117.3 0C87.9 352 64 375.9 64 405.3z"]]
}, S7 = {
  prefix: "fad",
  iconName: "house",
  icon: [576, 512, [127968, 63498, 63500, "home", "home-alt", "home-lg-alt"], "f015", ["M64 270.5c74.7-65.3 149.3-130.6 224-196L512.1 270.6l.4 201.3c0 22.1-17.9 40.1-40 40.1L392 512c-22.1 0-40-17.9-40-40l0-88.3c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 88.3c0 22.1-17.9 40-40 40l-79.9 0c-22.1 0-40-17.9-40-40L64 270.5z", "M266.9 7.9C279-2.6 297-2.6 309.1 7.9l256 224c13.3 11.6 14.6 31.9 3 45.2s-31.9 14.6-45.2 3L288 74.5 53.1 280.1c-13.3 11.6-33.5 10.3-45.2-3s-10.3-33.5 3-45.2l256-224z"]]
}, C7 = {
  prefix: "fad",
  iconName: "calendar-week",
  icon: [448, 512, [], "f784", ["M0 192L0 464c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-272L0 192zm64 80c0-8.8 7.2-16 16-16l288 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16L80 352c-8.8 0-16-7.2-16-16l0-64z", "M96 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 80L0 192l0-80C0 85.5 21.5 64 48 64l48 0 0-32z"]]
}, A7 = {
  prefix: "fad",
  iconName: "message-slash",
  icon: [640, 512, ["comment-alt-slash"], "f4a9", ["M64 146.4L406.2 416l-32.8 0L249.6 508.8c-2.8 2.1-6.2 3.2-9.6 3.2c-2.4 0-4.9-.6-7.2-1.7c-5.4-2.7-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64l0-205.6zM72.7 31.7C83.8 12.7 104.4 0 128 0L512 0c35.3 0 64 28.7 64 64l0 288c0 21.8-10.9 41-27.5 52.6C389.9 280.3 231.3 156 72.7 31.7z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
}, E7 = {
  prefix: "fad",
  iconName: "house-tree",
  icon: [640, 512, [], "e1b3", ["M282.9 119.9l107.2 98.3c16.5 15.2 25.9 36.5 25.9 59L416 464c0 18-6 34.6-16 48l208 0c12.3 0 23.5-7 28.8-18.1s3.8-24.2-3.9-33.9L546.6 352l29.4 0c12.3 0 23.5-7 28.8-18.1s3.8-24.2-3.9-33.9L514.6 192l29.4 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128C432.4 3.1 424.2 0 416 0s-16.4 3.1-22.6 9.4L282.9 119.9z", "M0 464L0 277.1c0-13.5 5.6-26.3 15.6-35.4l144-132c18.4-16.8 46.5-16.8 64.9 0l144 132c9.9 9.1 15.6 21.9 15.6 35.4L384 464c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48zM168 272c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0z"]]
}, U1 = {
  prefix: "fad",
  iconName: "chart-mixed",
  icon: [512, 512, ["analytics"], "f643", ["M32 352l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32zm128-96l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192c0-17.7-14.3-32-32-32s-32 14.3-32 32zm128 64l0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128c0-17.7-14.3-32-32-32s-32 14.3-32 32zm128-64l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192c0-17.7-14.3-32-32-32s-32 14.3-32 32z", "M505 44c11 13.8 8.8 33.9-5 45L340 217c-11.4 9.1-27.5 9.4-39.2 .6L192.6 136.5 52 249c-13.8 11-33.9 8.8-45-5s-8.8-33.9 5-45L172 71c11.4-9.1 27.5-9.4 39.2-.6l108.2 81.1L460 39c13.8-11 33.9-8.8 45 5z"]]
}, O7 = {
  prefix: "fad",
  iconName: "ellipsis",
  icon: [448, 512, ["ellipsis-h"], "f141", ["M168 256a56 56 0 1 0 112 0 56 56 0 1 0 -112 0z", "M64 312a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm320 0a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"]]
}, H1 = {
  prefix: "fad",
  iconName: "bell",
  icon: [448, 512, [128276, 61602], "f0f3", ["M0 384c0 4.4 .9 8.9 2.8 13.1C8 408.6 19.4 416 32 416l384 0c12.6 0 24-7.4 29.2-18.9c1.9-4.2 2.8-8.7 2.8-13.1c0-7.7-2.8-15.3-8.1-21.3l-7.4-8.3C401.3 319.2 384 273.9 384 226.8l0-18.8c0-77.4-55-142-128-156.8L256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 19.2C119 66 64 130.6 64 208l0 18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3C2.8 368.7 0 376.3 0 384z", "M288 448c0 17-6.7 33.3-18.7 45.3s-28.3 18.7-45.3 18.7s-33.3-6.7-45.3-18.7s-18.7-28.3-18.7-45.3l64 0h64z"]]
}, T7 = {
  prefix: "fad",
  iconName: "location-dot",
  icon: [384, 512, ["map-marker-alt"], "f3c5", ["M0 192c0 87.4 117 243 168.3 307.2c6.1 7.7 14.9 11.5 23.7 11.5s17.6-3.8 23.7-11.5C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192zm272 0a80 80 0 1 1 -160 0 80 80 0 1 1 160 0z", "M192 144a48 48 0 1 0 0 96 48 48 0 1 0 0-96z"]]
}, M7 = {
  prefix: "fad",
  iconName: "file",
  icon: [384, 512, [128196, 128459, 61462], "f15b", ["M0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0C28.7 0 0 28.7 0 64z", "M224 0L384 160H256c-17.7 0-32-14.3-32-32V0z"]]
}, k7 = {
  prefix: "fad",
  iconName: "star-half",
  icon: [576, 512, [61731], "f089", ["M288.1 0c12.3 0 23.5 7 28.8 18l64.3 132.3 143.6 21.2c12 1.8 22 10.2 25.7 21.7s.7 24.2-7.9 32.7L438.5 329l24.6 145.7c2 12-3 24.2-12.9 31.3c-5.1 3.7-11.1 5.7-17.1 6l-3.2 0c-4.6-.2-9.2-1.5-13.5-3.7c-42.8-22.8-85.6-45.7-128.5-68.4c0-146.7 0-293.3 .1-439.9z", "M288 0c-12.2 .1-23.3 7-28.6 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3L288 439.8 288 0zM429.9 512c1.1 .1 2.1 .1 3.2 0l-3.2 0z"]]
}, L7 = {
  prefix: "fad",
  iconName: "cup-togo",
  icon: [448, 512, ["coffee-togo"], "f6c5", ["M48 128l352 0-8.7 104L56.7 232 48 128zM70 392l308 0-5.1 61.3c-2.8 33.2-30.5 58.7-63.8 58.7l-170.2 0c-33.3 0-61-25.5-63.8-58.7c-1.7-20.4-3.4-40.9-5.1-61.3z", "M55.2 17.7L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L392.8 17.7C387.4 6.8 376.3 0 364.2 0L83.8 0C71.7 0 60.6 6.8 55.2 17.7zM378 392l13.3-160L56.7 232 70 392l308 0z"]]
}, F7 = {
  prefix: "fad",
  iconName: "magnifying-glass",
  icon: [512, 512, [128269, "search"], "f002", ["M0 208a208 208 0 1 0 416 0A208 208 0 1 0 0 208zm352 0A144 144 0 1 1 64 208a144 144 0 1 1 288 0z", "M330.7 376L457.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L376 330.7C363.3 348 348 363.3 330.7 376z"]]
}, z7 = {
  prefix: "fad",
  iconName: "receipt",
  icon: [384, 512, [129534], "f543", ["M0 24L0 488c0 9.4 5.5 17.9 14 21.8c3.2 1.5 6.6 2.2 10 2.2c5.6 0 11.2-2 15.6-5.8L80 471.6l40.4 34.6c9 7.7 22.3 7.7 31.2 0L192 471.6l40.4 34.6c9 7.7 22.3 7.7 31.2 0L304 471.6l40.4 34.6c4.4 3.8 10 5.8 15.6 5.8c3.4 0 6.8-.7 10-2.2c8.5-3.9 14-12.4 14-21.8l0-464c0-9.4-5.5-17.9-14-21.8C366.8 .7 363.4 0 360 0c-5.6 0-11.2 2-15.6 5.8L304 40.4 263.6 5.8c-9-7.7-22.3-7.7-31.2 0L192 40.4 151.6 5.8c-9-7.7-22.3-7.7-31.2 0L80 40.4 39.6 5.8C35.2 2 29.6 0 24 0c-3.4 0-6.8 .7-10 2.2C5.5 6.1 0 14.6 0 24zM80 160c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 176c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 272c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 368c-8.8 0-16-7.2-16-16z", "M80 160c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 176c-8.8 0-16-7.2-16-16zm0 192c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 368c-8.8 0-16-7.2-16-16zM96 240l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 272c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]]
}, P7 = {
  prefix: "fad",
  iconName: "chevron-down",
  icon: [512, 512, [], "f078", ["M278.6 406.6c-12.5 12.5-32.8 12.5-45.3 0l-192-192c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L256 338.7 425.4 169.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-192 192z", ""]]
}, I7 = {
  prefix: "fad",
  iconName: "envelopes",
  icon: [576, 512, [], "e170", ["M96 126c67.2 49.8 134.4 99.6 201.6 149.3c11.1 8.2 24.6 12.7 38.4 12.7s27.3-4.4 38.4-12.7C441.6 225.6 508.8 175.8 576 126l0 194c0 35.3-28.7 64-64 64l-352 0c-35.3 0-64-28.7-64-64l0-194zm.7-39.3C101.2 55.7 127.8 32 160 32l352 0c32.2 0 58.8 23.7 63.3 54.7c-73.3 54.3-146.6 108.6-220 163c-5.6 4.1-12.4 6.4-19.3 6.4s-13.7-2.2-19.3-6.4C243.3 195.3 170 141 96.7 86.7z", "M96 96l0 30L297.6 275.3c11.1 8.2 24.6 12.7 38.4 12.7s27.3-4.4 38.4-12.7L576 126l0-30c0-3.2-.2-6.3-.7-9.3l-220 163c-5.6 4.1-12.4 6.4-19.3 6.4s-13.7-2.2-19.3-6.4l-220-163c-.4 3-.7 6.2-.7 9.3zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 344c0 75.1 60.9 136 136 136l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-48.6 0-88-39.4-88-88l0-224z"]]
}, N7 = {
  prefix: "fad",
  iconName: "list-check",
  icon: [512, 512, ["tasks"], "f0ae", ["M160 416c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32zM224 96c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32z", "M153.8 72.1c8.9-9.9 8.1-25-1.8-33.9s-25-8.1-33.9 1.8L63.1 101.1 41 79C31.6 69.7 16.4 69.7 7 79s-9.4 24.6 0 33.9l40 40c4.7 4.7 11 7.2 17.6 7s12.8-3 17.2-7.9l72-80zm0 160c8.9-9.9 8.1-25-1.8-33.9s-25-8.1-33.9 1.8L63.1 261.1 41 239c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l40 40c4.7 4.7 11 7.2 17.6 7s12.8-3 17.2-7.9l72-80zM48 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]]
}, D7 = {
  prefix: "fad",
  iconName: "xmark",
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", ["M297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6z", ""]]
}, R7 = {
  prefix: "fad",
  iconName: "island-tropical",
  icon: [512, 512, [127965, "island-tree-palm"], "f811", ["M224 352l64 0c1 0 2 0 3 0s2 .1 3 .1c2 .1 3.9 .2 5.9 .4c3.9 .4 7.7 .9 11.5 1.6c11.3-55.9 18.2-146.2-9.9-226.1l-24.7 0c-10 10-20 20-30 30c6.6 43.1 6.9 114.7-22.8 194z", "M108.7 96c2.1 0 4.2-.8 5.7-2.3l24-24c3.1-3.1 8.2-3.1 11.3 0l24 24c.3 .3 .6 .6 1 .8c-1.4 1.3-2.8 2.6-4.1 4c-54.7 54.7-50.8 114.1-32.3 145.7c4.5 7.6 14.7 7.6 21 1.4L276.8 128l103.9 0c2.1 0 4.2-.8 5.7-2.3l24-24c3.1-3.1 8.2-3.1 11.3 0l24 24c1.5 1.5 3.5 2.3 5.7 2.3l44.7 0c8.8 0 16.1-7.2 13.8-15.8C500.6 76.8 461.4 32 384 32c-33.8 0-60.4 8.6-80.3 21.2C285.2 25.5 248.6 0 190.2 0C112.8 0 73.6 44.8 64.4 80.2C62.2 88.8 69.4 96 78.2 96l30.4 0zM160 352C89.3 352 32 409.3 32 480c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32c0-70.7-57.3-128-128-128l-128 0z"]]
}, j7 = {
  prefix: "fad",
  iconName: "file-circle-info",
  icon: [576, 512, [58604], "e493", ["M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64z", "M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zm48 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-240a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-32 96c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 64c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16c0 0 0 0 0 0l0-48s0 0 0 0c-8.8 0-16-7.2-16-16z"]]
}, B7 = {
  prefix: "fad",
  iconName: "rocket",
  icon: [512, 512, [], "f135", ["M3.1 275.8C7.3 283.3 15.3 288 24 288l94.5 0c19.5-43.5 51.6-112.1 80.1-158l-80.8 0c-25.2 0-48.5 13.1-61.5 34.6L3.5 251.5c-4.5 7.4-4.7 16.7-.4 24.2zM224 391.8l0 96.2c0 8.7 4.7 16.7 12.2 20.9c3.7 2.1 7.7 3.1 11.8 3.1c4.3 0 8.6-1.2 12.5-3.5l86.9-52.8c21.5-13.1 34.6-36.4 34.6-61.5l0-80.8c-45.6 28.2-114 59.4-158 78.4z", "M166.5 394.8l-50.7-50.7c-9.2-9.2-11.9-23-6.7-34.9c18.3-41.9 62.7-140.2 98.1-192.5C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7C342.6 340.5 243 383.9 201 401.7c-11.8 5-25.4 2.2-34.5-6.9zM384 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]]
}, V7 = {
  prefix: "fad",
  iconName: "store",
  icon: [576, 512, [], "f54e", ["M64 219.1c2.5 1 5.2 1.8 7.9 2.5s5.5 1.2 8.4 1.6c4 .5 8.1 .8 12.1 .8c12.8 0 24.8-2.7 35.6-7.5L128 384l320 0 0-167.5c5.4 2.4 11.1 4.3 17 5.5c3 .6 6 1.1 9 1.4s6.2 .5 9.4 .5c4.1 0 8.1-.3 12.1-.8c5.8-.8 11.3-2.2 16.5-4.1L512 384l0 64c0 35.3-28.7 64-64 64l-320 0c-35.3 0-64-28.7-64-64l0-64 0-164.9z", "M490.3 13.1l57.3 90.7c29.7 46.9 3.4 112-52.1 119.4c-4 .5-7.9 .8-12.1 .8c-26.1 0-49.2-11.4-65.2-29c-15.9 17.6-39 29-65.2 29c-26.1 0-49.3-11.4-65.2-29c-15.9 17.6-39 29-65.2 29c-26.1 0-49.3-11.4-65.2-29c-15.9 17.6-39.1 29-65.2 29c-4.1 0-8.2-.3-12.1-.8c-55.3-7.4-81.5-72.6-51.9-119.4L85.7 13.1C90.8 5 99.9 0 109.6 0H466.4c9.7 0 18.8 5 23.9 13.1z"]]
}, qf = {
  prefix: "fad",
  iconName: "percent",
  icon: [384, 512, [62101, 62785, "percentage"], "25", ["M0 416c0 8.2 3.1 16.4 9.4 22.6c12.5 12.5 32.8 12.5 45.3 0l320-320c6.2-6.2 9.4-14.4 9.4-22.6s-3.1-16.4-9.4-22.6c-12.5-12.5-32.8-12.5-45.3 0l-320 320C3.1 399.6 0 407.8 0 416z", "M64 192A64 64 0 1 0 64 64a64 64 0 1 0 0 128zM320 448a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]]
}, U7 = qf, G1 = {
  prefix: "fad",
  iconName: "spinner",
  icon: [512, 512, [], "f110", ["M60.9 403.1a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM208 464a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM369.1 75A48 48 0 1 0 437 142.9 48 48 0 1 0 369.1 75zm0 294.2A48 48 0 1 0 437 437a48 48 0 1 0 -67.9-67.9zM416 256a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z", "M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 256A48 48 0 1 0 0 256a48 48 0 1 0 96 0zM75 142.9A48 48 0 1 0 142.9 75 48 48 0 1 0 75 142.9z"]]
}, H7 = {
  prefix: "fad",
  iconName: "building",
  icon: [384, 512, [127970, 61687], "f1ad", ["M0 48C0 21.5 21.5 0 48 0L336 0c26.5 0 48 21.5 48 48l0 416c0 26.5-21.5 48-48 48l-96 0 0-80c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 80-96 0c-26.5 0-48-21.5-48-48L0 48zm64 64l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L80 96c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm96-128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm96-128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 128l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z", "M80 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L80 96zm0 128c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm96 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm80 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM160 112l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM272 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0z"]]
}, G7 = {
  prefix: "fad",
  iconName: "clock-rotate-left",
  icon: [512, 512, ["history"], "f1da", ["M0 57.9L0 168c0 13.3 10.7 24 24 24l110.1 0c21.4 0 32.1-25.9 17-41l-30.8-30.8C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75L41 41C25.9 25.9 0 36.6 0 57.9z", "M256 128c13.3 0 24 10.7 24 24l0 94.1 65 65c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-72-72c-4.5-4.5-7-10.6-7-17l0-104c0-13.3 10.7-24 24-24z"]]
}, q7 = {
  prefix: "fad",
  iconName: "hashtag",
  icon: [448, 512, [62098], "23", ["M80.4 442.7c3.3-19.6 6.5-39.2 9.8-58.7c3.6-21.3 7.1-42.7 10.7-64c7.1-42.7 14.2-85.3 21.3-128c21.6 0 43.3 0 64.9 0c-7.1 42.7-14.2 85.3-21.3 128l-10.7 64c-3.8 23.1-7.7 46.2-11.5 69.3C141 468.9 127.4 480 112 480c-1.7 0-3.5-.1-5.3-.4c-17.4-2.9-29.2-19.4-26.3-36.8zM132.9 128l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3s29.2 19.4 26.3 36.8L197.8 128l-64.9 0zM240.4 442.7l9.8-58.7 64.9 0-11.5 69.3C301 468.9 287.4 480 272 480c-1.7 0-3.5-.1-5.3-.4c-17.4-2.9-29.2-19.4-26.3-36.8zM260.9 320c7.1-42.7 14.2-85.3 21.3-128l10.7-64c3.8-23.1 7.7-46.2 11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3C356.9 35.1 368 48.6 368 64c0 1.7-.1 3.5-.4 5.3c-3.3 19.6-6.5 39.2-9.8 58.7c-3.6 21.3-7.1 42.7-10.7 64c-7.1 42.7-14.2 85.3-21.3 128l-64.9 0z", "M292.9 128L64 128c-17.7 0-32 14.3-32 32s14.3 32 32 32l218.2 0 10.7-64zm54.2 64l68.9 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-58.2 0-10.7 64zm-192 192L384 384c17.7 0 32-14.3 32-32s-14.3-32-32-32l-218.2 0-10.7 64zm-54.2-64L32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32l58.2 0 10.7-64z"]]
}, q1 = {
  prefix: "fad",
  iconName: "calendar",
  icon: [448, 512, [128197, 128198], "f133", ["M0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192z", "M160 32c0-17.7-14.3-32-32-32S96 14.3 96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 80 448 0 0-80c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32z"]]
}, W7 = {
  prefix: "fad",
  iconName: "file-circle-plus",
  icon: [576, 512, [58606], "e494", ["M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64z", "M384 160L224 0l0 128c0 17.7 14.3 32 32 32l128 0zm48 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16z"]]
}, Y7 = {
  prefix: "fad",
  iconName: "circle-quarter",
  icon: [512, 512, [], "e11f", ["M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0l0 256L0 256z", "M0 256C0 114.6 114.6 0 256 0V256H0z"]]
}, K7 = {
  prefix: "fad",
  iconName: "face-viewfinder",
  icon: [512, 512, [], "e2ff", ["M0 56C0 25.1 25.1 0 56 0l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 48c-4.4 0-8 3.6-8 8l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 56zM0 376c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80c0 4.4 3.6 8 8 8l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-30.9 0-56-25.1-56-56l0-80zM352 24c0-13.3 10.7-24 24-24l80 0c30.9 0 56 25.1 56 56l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-4.4-3.6-8-8-8l-80 0c-13.3 0-24-10.7-24-24zm0 464c0-13.3 10.7-24 24-24l80 0c4.4 0 8-3.6 8-8l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80c0 30.9-25.1 56-56 56l-80 0c-13.3 0-24-10.7-24-24z", "M256 416a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM200 192a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm88 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-95.5 76.9C208.5 309.6 231 320 256 320s47.5-10.4 63.5-27.1c6.1-6.4 16.2-6.6 22.6-.5s6.6 16.2 .5 22.6C320.8 337.8 290 352 256 352s-64.8-14.2-86.6-36.9c-6.1-6.4-5.9-16.5 .5-22.6s16.5-5.9 22.6 .5z"]]
}, Z7 = {
  prefix: "fad",
  iconName: "check",
  icon: [448, 512, [10003, 10004], "f00c", ["", "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"]]
}, X7 = {
  prefix: "fad",
  iconName: "house-circle-check",
  icon: [640, 512, [], "e509", ["M0 255.5c0 18 14 32.1 32 32.1l32 0 0 69.7c-.1 .9-.1 1.8-.1 2.8l0 112c0 22.1 17.9 40 40 40l16 0c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2l31.9 0 24 0c22.1 0 40-17.9 40-40l0-24 0-64c0-17.7 14.3-32 32-32l64 0 .7 0c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24z", "M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]]
}, J7 = {
  prefix: "fad",
  iconName: "buildings",
  icon: [512, 512, [], "e0cc", ["M0 192L0 448c0 35.3 28.7 64 64 64l192 0 192 0c35.3 0 64-28.7 64-64l0-256 0-128c0-35.3-28.7-64-64-64L256 0c-35.3 0-64 28.7-64 64l0 64L64 128c-35.3 0-64 28.7-64 64zm64 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM256 80c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM384 80c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32z", "M256 80c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM80 192l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM272 320c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0zM80 288l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm304 16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zM400 64l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM256 208l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zm144 16c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0z"]]
}, Q7 = {
  prefix: "fad",
  iconName: "briefcase",
  icon: [512, 512, [128188], "f0b1", ["M0 288L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-128-192 0 0 32c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-32L0 288z", "M384 96l80 0c25.6 0 48 22.4 48 48l0 144L0 288 0 144c0-25.6 22.4-48 48-48l80 0 0-40 0-8c0-25.6 22.4-48 48-48l8 0L328 0l8 0c25.6 0 48 22.4 48 48l0 8 0 40zm-48 0l0-40c0-4.4-3.6-8-8-8L184 48c-4.4 0-8 3.6-8 8l0 40 160 0z"]]
}, ev = {
  prefix: "fad",
  iconName: "circle-xmark",
  icon: [512, 512, [61532, "times-circle", "xmark-circle"], "f057", ["M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm168.1 61.7c.1-.7 .2-1.5 .3-2.3c.3-1.5 .7-3 1.3-4.4c1.2-2.9 2.9-5.6 5.3-7.9c15.7-15.7 31.4-31.4 47-47c-15.7-15.7-31.3-31.3-47-47c-9.4-9.4-9.4-24.6 0-33.9c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c15.7 15.7 31.4 31.4 47 47c15.7-15.7 31.4-31.4 47-47c4.7-4.7 10.8-7 17-7s12.3 2.3 17 7c9.4 9.4 9.4 24.6 0 33.9c-15.7 15.7-31.3 31.3-47 47c15.7 15.7 31.4 31.4 47 47c4.7 4.7 7 10.8 7 17s-2.3 12.3-7 17s-10.8 7-17 7s-12.3-2.3-17-7l-47-47c-15.7 15.7-31.3 31.3-47 47c-4.7 4.7-10.8 7-17 7s-12.3-2.3-17-7c-2.3-2.3-4.1-5.1-5.3-7.9c-.6-1.4-1-2.9-1.3-4.4c-.2-1.1-.4-2.3-.3-2.2c-.1-1.2-.1-1.2-.1-2.4c0-1.5 .1-1.9 .1-2.3z", "M209 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47z"]]
}, W1 = {
  prefix: "fad",
  iconName: "sack",
  icon: [512, 512, [], "f81c", ["M0 416c0 53 43 96 96 96l320 0c53 0 96-43 96-96c0-165.1-122.3-243.3-179-279.6c-4.8-3.1-9.2-5.9-13-8.4l-128 0c-3.8 2.5-8.1 5.3-13 8.4C122.3 172.7 0 250.9 0 416zM144.6 24.9L192 96l128 0 47.4-71.1C374.5 14.2 366.9 0 354.1 0L157.9 0c-12.8 0-20.4 14.2-13.3 24.9z", "M176 112c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z"]]
}, tv = {
  prefix: "fad",
  iconName: "grid-2",
  icon: [512, 512, [], "e196", ["M32 328l0 112c0 22.1 17.9 40 40 40l112 0c22.1 0 40-17.9 40-40l0-112c0-22.1-17.9-40-40-40L72 288c-22.1 0-40 17.9-40 40zM288 72l0 112c0 22.1 17.9 40 40 40l112 0c22.1 0 40-17.9 40-40l0-112c0-22.1-17.9-40-40-40L328 32c-22.1 0-40 17.9-40 40z", "M224 80c0-26.5-21.5-48-48-48L80 32C53.5 32 32 53.5 32 80l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96zM480 336c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96z"]]
};
/*!
 * Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2024 Fonticons, Inc.
 */
const nv = {
  prefix: "fal",
  iconName: "fingerprint",
  icon: [512, 512, [], "f577", "M32 256C32 132.3 132.3 32 256 32c70.3 0 133 32.4 174.1 83c5.6 6.9 15.6 7.9 22.5 2.4s7.9-15.6 2.4-22.5C408.1 37 336.3 0 256 0C114.6 0 0 114.6 0 256l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48zm470.8-68.3c-2.4-8.5-11.2-13.5-19.7-11.2s-13.5 11.2-11.2 19.7c5.2 19 8.1 39 8.1 59.7l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48c0-23.6-3.2-46.5-9.2-68.3zM256 80c-22.8 0-44.6 4.3-64.6 12.2c-9.7 3.8-12 16.1-5.2 24.1c4.8 5.6 12.8 7.2 19.7 4.6c15.6-5.8 32.5-9 50.1-9c79.5 0 144 64.5 144 144l0 24.9c0 28.3-1.8 56.6-5.5 84.6c-1.3 9.7 6.2 18.5 16 18.5c7.9 0 14.6-5.8 15.6-13.6c3.9-29.6 5.8-59.5 5.8-89.5l0-24.9c0-97.2-78.8-176-176-176zM145.1 142.1c-6-7-16.8-7.6-22.8-.5C95.9 172.3 80 212.3 80 256l0 24.9c0 27.8-3.4 55.4-10.2 82.3c-2.6 10.4 5 20.8 15.7 20.8c7 0 13.2-4.6 15-11.4c7.7-29.9 11.6-60.7 11.6-91.7l0-24.9c0-34.7 12.3-66.5 32.7-91.4c5.4-6.5 5.8-16.1 .3-22.5zM256 160c-53 0-96 43-96 96l0 24.9c0 38.6-5.4 77-15.9 114c-3 10.4 4.7 21.1 15.5 21.1c6.9 0 13-4.5 14.9-11.1c11.6-40.2 17.5-82 17.5-124l0-24.9c0-35.3 28.7-64 64-64s64 28.7 64 64l0 24.9c0 38.8-3.9 77.5-11.7 115.4c-2.1 10.1 5.5 19.7 15.8 19.7c7.4 0 13.9-5.1 15.4-12.4c8.3-40.3 12.5-81.4 12.5-122.7l0-24.9c0-53-43-96-96-96zm16 96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 24.9c0 60.9-11.2 121.2-33.1 178.1l-5.9 15.3c-3.2 8.2 .9 17.5 9.2 20.7s17.5-.9 20.7-9.2l5.9-15.3C260.1 410 272 345.7 272 280.9l0-24.9z"]
}, rv = {
  prefix: "fal",
  iconName: "gavel",
  icon: [512, 512, ["legal"], "f0e3", "M315.3 4.7c6.2 6.2 6.2 16.4 0 22.6L302.6 40 472 209.4l12.7-12.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-24 24-96 96-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L353.4 328 184 158.6l-12.7 12.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24 96-96 24-24c6.2-6.2 16.4-6.2 22.6 0zM206.6 136L376 305.4 449.4 232 280 62.6 206.6 136zM144 320L32 432l48 48L192 368l-48-48zm-22.6-22.6c12.5-12.5 32.8-12.5 45.3 0l12.7 12.7 49.8-49.8 22.6 22.6-49.8 49.8 12.7 12.7c12.5 12.5 12.5 32.8 0 45.3l-112 112c-12.5 12.5-32.8 12.5-45.3 0l-48-48c-12.5-12.5-12.5-32.8 0-45.3l112-112z"]
}, av = {
  prefix: "fal",
  iconName: "arrow-right-from-bracket",
  icon: [512, 512, ["sign-out"], "f08b", "M507.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-128-128c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L457.4 240 176 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l281.4 0L356.7 372.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128zM176 64c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 32C35.8 32 0 67.8 0 112L0 400c0 44.2 35.8 80 80 80l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48l96 0z"]
}, iv = {
  prefix: "fal",
  iconName: "display-chart-up",
  icon: [576, 512, [], "e5e3", "M512 32c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-167.7 0c-.2 0-.4 0-.6 0l-111.5 0c-.2 0-.4 0-.6 0L64 384c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l448 0zM64 416l149.1 0-10.7 64L144 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l72 0 144 0 72 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-58.4 0-10.7-64L512 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64zm170.9 64l10.7-64 84.9 0 10.7 64-106.2 0zM368 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l57.4 0L304 249.4l-68.7-68.7c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 214.6l68.7 68.7c3 3 7.1 4.7 11.3 4.7s8.3-1.7 11.3-4.7L448 150.6l0 57.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16l-96 0z"]
}, sv = {
  prefix: "fal",
  iconName: "gauge",
  icon: [512, 512, ["dashboard", "gauge-med", "tachometer-alt-average"], "f624", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96c35.3 0 64-28.7 64-64c0-29.8-20.4-54.9-48-62l0-194c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 194c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64zM144 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-24 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm296 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM392 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
}, ov = {
  prefix: "fal",
  iconName: "user",
  icon: [448, 512, [128100, 62144], "f007", "M320 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM32 480l384 0c-1.2-79.7-66.2-144-146.3-144l-91.4 0c-80 0-145 64.3-146.3 144zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3z"]
}, lv = {
  prefix: "fal",
  iconName: "chart-line-up",
  icon: [512, 512, [], "e0e5", "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48L0 400c0 44.2 35.8 80 80 80l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 448c-26.5 0-48-21.5-48-48L32 48zm288 96c0 8.8 7.2 16 16 16l89.4 0L320 265.4l-84.7-84.7c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 214.6l84.7 84.7c6.2 6.2 16.4 6.2 22.6 0L448 182.6l0 89.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16z"]
}, uv = {
  prefix: "fal",
  iconName: "euro-sign",
  icon: [320, 512, [8364, "eur", "euro"], "f153", "M34.3 224c-1.5 10.5-2.3 21.1-2.3 32s.8 21.5 2.3 32L16 288c-8.8 0-16 7.2-16 16s7.2 16 16 16l25.3 0C68.8 412.5 154.5 480 256 480l49 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-49 0c-83.6 0-154.7-53.4-181.1-128L272 320c8.8 0 16-7.2 16-16s-7.2-16-16-16L66.7 288c-1.7-10.4-2.7-21.1-2.7-32s.9-21.6 2.7-32L272 224c8.8 0 16-7.2 16-16s-7.2-16-16-16L74.9 192C101.3 117.4 172.4 64 256 64l49 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-49 0C154.5 32 68.8 99.5 41.3 192L16 192c-8.8 0-16 7.2-16 16s7.2 16 16 16l18.3 0z"]
}, Y1 = {
  prefix: "fal",
  iconName: "address-card",
  icon: [576, 512, [62140, "contact-card", "vcard"], "f2bb", "M512 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l448 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm96 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM112 368c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16s16-7.2 16-16zM352 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0z"]
}, cv = {
  prefix: "fal",
  iconName: "face-smile-wink",
  icon: [512, 512, [128521, "smile-wink"], "f4da", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm164.1 69.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm148.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"]
}, dv = {
  prefix: "fal",
  iconName: "user-group-crown",
  icon: [640, 512, ["users-crown"], "f6a5", "M224 0c5.2 0 10.3 1.5 14.7 4.4l32.5 21.6c5.4 3.6 12.4 3.6 17.8 0L324 2.7c2.6-1.8 5.7-2.7 8.9-2.7L336 0c8.8 0 16 7.2 16 16l0 112 0 16c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-16L96 16c0-8.8 7.2-16 16-16l3.2 0c3.2 0 6.2 .9 8.9 2.7l35.1 23.4c5.4 3.6 12.4 3.6 17.8 0L209.3 4.4C213.7 1.5 218.8 0 224 0zm96 43.8l-13.4 8.9c-16.1 10.7-37.1 10.7-53.3 0L224 33.1 194.6 52.7c-16.1 10.7-37.1 10.7-53.3 0L128 43.8l0 68.2 192 0 0-68.2zM224 240c53 0 96-43 96-96l-192 0c0 53 43 96 96 96zM32 472l0 8 384 0 0-8c0-75.1-60.9-136-136-136l-112 0C92.9 336 32 396.9 32 472zM0 472c0-92.8 75.2-168 168-168l112 0c92.8 0 168 75.2 168 168l0 8c0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32l0-8zM432 256c-27.7 0-53-10.1-72.6-26.7c1.9-2.9 3.6-6 5.3-9c3.6-6.7 6.8-13.7 9.5-21C388.8 214.5 409.3 224 432 224c44.2 0 80-35.8 80-80s-35.8-80-80-80c-18 0-34.6 6-48 16l0-37.2C398.5 35.9 414.8 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112zM609.3 512l-137.8 0c5.4-9.4 8.6-20.3 8.6-32l128 0c-.7-70.8-58.3-128-129.3-128L440 352c-8.8-11.7-18.8-22.4-29.8-31.8c2.4-.1 4.7-.2 7.1-.2l61.4 0C567.8 320 640 392.2 640 481.3c0 17-13.8 30.7-30.7 30.7z"]
}, fv = {
  prefix: "fal",
  iconName: "files",
  icon: [448, 512, [], "e178", "M160 384c-17.7 0-32-14.3-32-32l0-288c0-17.7 14.3-32 32-32l144 0 0 80c0 17.7 14.3 32 32 32l80 0c0 .3 0 .5 0 .8L416 352c0 17.7-14.3 32-32 32l-224 0zM336 57.5L390 112l-54 0 0-54.5zM160 0C124.7 0 96 28.7 96 64l0 288c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-207.2c0-12.7-5-24.8-13.9-33.8l-96-96.8C329.1 5.1 316.8 0 304 0L160 0zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16L0 384c0 70.7 57.3 128 128 128l208 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-208 0c-53 0-96-43-96-96l0-272z"]
}, pv = {
  prefix: "fal",
  iconName: "hand-holding-dollar",
  icon: [576, 512, ["hand-holding-usd"], "f4c0", "M304 24l0 17.3c8.5 1.2 16.7 3.1 24.1 5.1c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-11.1-3-22-5.2-32.1-5.3c-8.4-.1-17.3 1.8-23.6 5.5c-5.7 3.4-8.1 7.3-8.1 12.8c0 3.7 1.3 6.5 7.3 10.1c6.9 4.1 16.6 7.1 29.2 10.9l.5 .1s0 0 0 0c11.3 3.4 25.3 7.6 36.3 14.6c12.1 7.6 22.4 19.7 22.7 38.2c.3 19.3-9.6 33.3-22.9 41.6c-7.7 4.8-16.4 7.6-25.1 9.1l0 17.1c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-17.8c-11.2-2.1-21.7-5.7-30.9-8.9c-2.1-.7-4.2-1.4-6.2-2.1c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c2.5 .8 4.8 1.6 7.1 2.4c0 0 0 0 0 0s0 0 0 0c13.6 4.6 24.6 8.4 36.3 8.7c9.1 .3 17.9-1.7 23.7-5.3c5.1-3.2 7.9-7.3 7.8-14c-.1-4.6-1.8-7.8-7.7-11.6c-6.8-4.3-16.5-7.4-29-11.2l-1.6-.5s0 0 0 0c-11-3.3-24.3-7.3-34.8-13.7c-12-7.2-22.6-18.9-22.7-37.3C224 71.1 234.9 57.7 247.9 50c7.5-4.4 15.8-7.2 24.1-8.7L272 24c0-8.8 7.2-16 16-16s16 7.2 16 16zM151 317.4c13.1-8.8 28.6-13.4 44.4-13.4L344 304c30.9 0 56 25.1 56 56c0 8.6-1.9 16.7-5.4 24l5.6 0 94.7-56.4c8.3-4.9 17.8-7.6 27.5-7.6l1.3 0c28.9 0 52.3 23.4 52.3 52.3c0 17.7-9 34.2-23.8 43.8L432.6 493.9c-18.2 11.8-39.4 18.1-61 18.1L16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l355.5 0c15.5 0 30.6-4.5 43.6-12.9l119.6-77.8c5.8-3.7 9.2-10.2 9.2-17c0-11.2-9.1-20.3-20.3-20.3l-1.3 0c-3.9 0-7.7 1.1-11.1 3l-98.5 58.7c-2.5 1.5-5.3 2.3-8.2 2.3L344 416l-24 0-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-148.6 0c-9.5 0-18.7 2.8-26.6 8.1L88.9 397.3l-4 2.7L80 400l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l59.2 0L151 317.4z"]
}, hv = {
  prefix: "fal",
  iconName: "phone-arrow-down-left",
  icon: [512, 512, ["phone-arrow-down", "phone-incoming"], "e223", "M507.3 27.3L342.6 192l89.4 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16l0 89.4L484.7 4.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM329 286.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6c0 0 0 0 0 0c-6.1 0-12.2-.1-18.3-.4c0 0 0 0-.1 0c0 0 0 0 0 0c-4.6-.2-9.1-.4-13.7-.8C183.5 494.5 0 300.7 0 64c0 0 0 0 0 0C0 45.1 13.2 28.8 31.6 24.9l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L329 286.7zM448 480c3.8 0 7-2.6 7.8-6.3l24-112c.8-3.7-1.2-7.5-4.7-9l-112-48c-3.3-1.4-7.1-.5-9.3 2.3l-33.2 40.6c-9.9 12.1-27.2 15.3-40.8 7.4c-50.9-29.5-93.3-71.9-122.7-122.7c-7.9-13.6-4.7-30.9 7.4-40.8l40.6-33.2c2.8-2.3 3.7-6.1 2.3-9.3l-48-112c-1.5-3.5-5.3-5.5-9-4.7l-112 24C34.6 57 32 60.2 32 64c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 229.6 186.1 415.8 415.7 416l.3 0z"]
}, mv = {
  prefix: "fal",
  iconName: "calendar-check",
  icon: [448, 512, [], "f274", "M128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L64 64C28.7 64 0 92.7 0 128l0 32 0 32L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-32 0-32c0-35.3-28.7-64-64-64l-32 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48L128 64l0-48zM32 192l384 0 0 256c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-256zM64 96l320 0c17.7 0 32 14.3 32 32l0 32L32 160l0-32c0-17.7 14.3-32 32-32zM331.3 283.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L208 361.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l112-112z"]
}, Wf = {
  prefix: "fal",
  iconName: "gear",
  icon: [512, 512, [9881, "cog"], "f013", "M223.3 37.8c.4-1.5 1.3-2.8 2.4-3.8c9.9-1.3 20-2 30.3-2s20.4 .7 30.3 2c1.1 1 1.9 2.3 2.4 3.8l13.7 47.7c3.5 12.1 12.2 21.1 22.5 26.1c7.6 3.6 14.8 7.8 21.7 12.5c9.4 6.5 21.7 9.5 33.9 6.5l48.2-12c1.5-.4 3-.3 4.4 .2c5.4 6.9 10.4 14.2 14.9 21.8l4.3 7.4c4.2 7.5 7.9 15.3 11.2 23.3c-.3 1.5-1 2.9-2.1 4L426.8 211c-8.7 9-12.2 21.1-11.3 32.5c.3 4.1 .5 8.3 .5 12.5s-.2 8.4-.5 12.5c-.9 11.4 2.6 23.5 11.3 32.5l34.5 35.7c1.1 1.1 1.8 2.5 2.1 4c-3.3 8-7 15.8-11.2 23.4l-4.2 7.3c-4.6 7.6-9.6 14.8-14.9 21.8c-1.4 .5-2.9 .5-4.4 .2l-48.2-12c-12.2-3-24.4 0-33.9 6.5c-6.9 4.7-14.1 8.9-21.7 12.5c-10.3 4.9-19.1 14-22.5 26.1l-13.7 47.7c-.4 1.5-1.3 2.8-2.4 3.8c-9.9 1.3-20 2-30.3 2s-20.4-.7-30.3-2c-1.1-1-1.9-2.3-2.4-3.8l-13.7-47.7c-3.5-12.1-12.2-21.1-22.5-26.1c-7.6-3.6-14.8-7.8-21.7-12.5c-9.4-6.5-21.7-9.5-33.9-6.5l-48.2 12c-1.5 .4-3 .3-4.4-.2c-5.4-7-10.4-14.2-15-21.8l-4.2-7.3c-4.2-7.5-7.9-15.3-11.2-23.4c.3-1.5 1-2.9 2.1-4L85.2 301c8.7-9 12.2-21.1 11.3-32.5c-.3-4.1-.5-8.3-.5-12.5s.2-8.4 .5-12.5c.9-11.4-2.6-23.5-11.3-32.5L50.7 175.2c-1.1-1.1-1.8-2.5-2.1-4c3.3-8 7-15.8 11.2-23.4l4.2-7.3c4.6-7.6 9.6-14.8 15-21.8c1.4-.5 2.9-.5 4.4-.2l48.2 12c12.2 3 24.4 0 33.9-6.5c6.9-4.7 14.1-8.9 21.7-12.5c10.3-4.9 19.1-14 22.5-26.1l13.7-47.7zM256 0c-13 0-25.9 1-38.4 2.9c-1.7 .3-3.4 .8-5 1.6c-9.5 4.9-16.9 13.6-20 24.5L178.9 76.7c-.6 2.2-2.5 4.5-5.6 6c-9.1 4.3-17.8 9.4-26 15c-2.8 1.9-5.8 2.4-8 1.8l-48.2-12C80.2 84.8 69 86.9 60 92.6c-1.5 .9-2.8 2.1-3.9 3.5C49 105 42.4 114.3 36.5 124.1l-.1 .3L32 132l-.1 .3c-5.4 9.8-10.2 19.9-14.3 30.4c-.6 1.6-1 3.3-1.1 5c-.5 10.8 3.3 21.6 11.2 29.8l34.5 35.7c1.6 1.7 2.7 4.4 2.4 7.8c-.4 5-.6 10-.6 15s.2 10.1 .6 15c.3 3.4-.8 6.2-2.4 7.8L27.7 314.6c-7.9 8.2-11.7 19-11.2 29.8c.1 1.7 .5 3.4 1.1 5c4.1 10.5 8.9 20.6 14.3 30.4l.1 .3 4.4 7.6 .1 .3c5.9 9.8 12.4 19.2 19.6 28.1c1.1 1.4 2.4 2.6 3.9 3.5c9 5.7 20.2 7.8 31.1 5.1l48.2-12c2.2-.6 5.2-.1 8 1.8c8.2 5.7 16.9 10.7 26 15c3.1 1.5 4.9 3.8 5.6 6L192.6 483c3.1 10.8 10.5 19.5 20 24.5c1.6 .8 3.2 1.4 5 1.6C230.1 511 243 512 256 512s25.9-1 38.4-2.9c1.7-.3 3.4-.8 5-1.6c9.5-4.9 16.9-13.6 20-24.5l13.7-47.7c.6-2.2 2.5-4.5 5.6-6c9.1-4.3 17.8-9.4 26-15c2.8-1.9 5.8-2.4 8-1.8l48.2 12c10.9 2.7 22.1 .7 31.1-5.1c1.5-.9 2.8-2.1 3.9-3.5c7.1-8.9 13.6-18.2 19.5-28l.2-.3L480 380l.1-.3c5.4-9.7 10.2-19.9 14.3-30.4c.6-1.6 1-3.3 1.1-5c.5-10.8-3.3-21.6-11.2-29.8l-34.5-35.7c-1.6-1.7-2.7-4.4-2.4-7.8c.4-5 .6-10 .6-15s-.2-10.1-.6-15c-.3-3.4 .8-6.2 2.4-7.8l34.5-35.7c7.9-8.2 11.7-19 11.2-29.8c-.1-1.7-.5-3.4-1.1-5c-4.1-10.5-8.9-20.6-14.3-30.4l-.1-.3-4.4-7.6-.2-.3c-5.9-9.8-12.4-19.2-19.5-28c-1.1-1.4-2.4-2.6-3.9-3.5c-9-5.7-20.2-7.8-31.1-5.1l-48.2 12c-2.2 .6-5.2 .1-8-1.8c-8.2-5.7-16.9-10.7-26-15c-3.1-1.5-4.9-3.8-5.6-6L319.4 29c-3.1-10.8-10.5-19.5-20-24.5c-1.6-.8-3.2-1.4-5-1.6C281.9 1 269 0 256 0zM200 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm144 0a88 88 0 1 0 -176 0 88 88 0 1 0 176 0z"]
}, vv = Wf, gv = {
  prefix: "fal",
  iconName: "delete-left",
  icon: [576, 512, [9003, "backspace"], "f55a", "M544 128c0-17.7-14.3-32-32-32L205.3 96c-8.5 0-16.6 3.4-22.6 9.4L32 256 182.6 406.6c6 6 14.1 9.4 22.6 9.4L512 416c17.7 0 32-14.3 32-32l0-256zM512 64c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64l-306.7 0c-17 0-33.3-6.7-45.3-18.7L9.4 278.6c-6-6-9.4-14.1-9.4-22.6s3.4-16.6 9.4-22.6L160 82.7c12-12 28.3-18.7 45.3-18.7L512 64zM427.3 180.7c6.2 6.2 6.2 16.4 0 22.6L374.6 256l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 278.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 256l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L352 233.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0z"]
}, K1 = {
  prefix: "fal",
  iconName: "house",
  icon: [576, 512, [127968, 63498, 63500, "home", "home-alt", "home-lg-alt"], "f015", "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235l0 197c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-197 37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L298.6 4zM96 432l0-225.3L288 37.3 480 206.7 480 432c0 26.5-21.5 48-48 48l-64 0 0-160c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32l0 160-64 0c-26.5 0-48-21.5-48-48zm144 48l0-160 96 0 0 160-96 0z"]
}, bv = {
  prefix: "fal",
  iconName: "chart-mixed",
  icon: [512, 512, ["analytics"], "f643", "M507.8 37.2c5.9 6.5 5.5 16.7-1.1 22.6l-176 160c-6.3 5.7-16 5.5-22.1-.5L190.4 101 25.4 220.9c-7.1 5.2-17.2 3.6-22.4-3.5s-3.6-17.2 3.5-22.4l176-128c6.4-4.6 15.2-3.9 20.7 1.6L320.5 185.9 485.2 36.2c6.5-5.9 16.7-5.5 22.6 1.1zM80 432l0-64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16zM64 320c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48zm144-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160zm-64 0c0-26.5 21.5-48 48-48s48 21.5 48 48l0 160c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-160zM336 432l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16zM320 288c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zm144-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160zm-64 0c0-26.5 21.5-48 48-48s48 21.5 48 48l0 160c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-160z"]
}, $v = {
  prefix: "fal",
  iconName: "bell",
  icon: [448, 512, [128276, 61602], "f0f3", "M208 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16.8c80.9 8 144 76.2 144 159.2l0 29.1c0 43.7 17.4 85.6 48.3 116.6l2.8 2.8c8.3 8.3 13 19.6 13 31.3c0 24.5-19.8 44.3-44.3 44.3L44.3 416C19.8 416 0 396.2 0 371.7c0-11.7 4.7-23 13-31.3l2.8-2.8C46.6 306.7 64 264.8 64 221.1L64 192c0-83 63.1-151.2 144-159.2L208 16zm16 48C153.3 64 96 121.3 96 192l0 29.1c0 52.2-20.7 102.3-57.7 139.2L35.6 363c-2.3 2.3-3.6 5.4-3.6 8.7c0 6.8 5.5 12.3 12.3 12.3l359.4 0c6.8 0 12.3-5.5 12.3-12.3c0-3.3-1.3-6.4-3.6-8.7l-2.8-2.8c-36.9-36.9-57.7-87-57.7-139.2l0-29.1c0-70.7-57.3-128-128-128zM193.8 458.7c4.4 12.4 16.3 21.3 30.2 21.3s25.8-8.9 30.2-21.3c2.9-8.3 12.1-12.7 20.4-9.8s12.7 12.1 9.8 20.4C275.6 494.2 251.9 512 224 512s-51.6-17.8-60.4-42.7c-2.9-8.3 1.4-17.5 9.8-20.4s17.5 1.4 20.4 9.8z"]
}, yv = {
  prefix: "fal",
  iconName: "file",
  icon: [384, 512, [128196, 128459, 61462], "f15b", "M352 448l0-256-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32zm-.5-288c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64z"]
}, xv = {
  prefix: "fal",
  iconName: "play",
  icon: [384, 512, [9654], "f04b", "M56.3 66.3c-4.9-3-11.1-3.1-16.2-.3s-8.2 8.2-8.2 14l0 352c0 5.8 3.1 11.1 8.2 14s11.2 2.7 16.2-.3l288-176c4.8-2.9 7.7-8.1 7.7-13.7s-2.9-10.7-7.7-13.7l-288-176zM24.5 38.1C39.7 29.6 58.2 30 73 39L361 215c14.3 8.7 23 24.2 23 41s-8.7 32.2-23 41L73 473c-14.8 9.1-33.4 9.4-48.5 .9S0 449.4 0 432L0 80C0 62.6 9.4 46.6 24.5 38.1z"]
}, _v = {
  prefix: "fal",
  iconName: "xmark",
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M324.5 411.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 256 347.1 123.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4 59.6 100.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 36.9 388.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 278.6 324.5 411.1z"]
}, wv = {
  prefix: "fal",
  iconName: "percent",
  icon: [384, 512, [62101, 62785, "percentage"], "25", "M64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 64 64a64 64 0 1 0 0 128zM320 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM379.3 91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-352 352c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l352-352z"]
}, Sv = wv, Cv = {
  prefix: "fal",
  iconName: "face-viewfinder",
  icon: [512, 512, [], "e2ff", "M48 0C21.5 0 0 21.5 0 48l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8 7.2-16 16-16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L48 0zM464 0L368 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16 7.2 16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-26.5-21.5-48-48-48zM0 464c0 26.5 21.5 48 48 48l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16-7.2-16-16l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96zm464 48c26.5 0 48-21.5 48-48l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0zM240 216a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM256 128a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 288a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM214.4 280c-4.4-7.6-14.2-10.3-21.9-5.8s-10.3 14.2-5.8 21.9c13.8 23.9 39.7 40 69.3 40s55.5-16.1 69.3-40c4.4-7.6 1.8-17.4-5.8-21.9s-17.4-1.8-21.9 5.8c-8.3 14.4-23.8 24-41.6 24s-33.3-9.6-41.6-24z"]
}, Av = {
  prefix: "fal",
  iconName: "house-circle-check",
  icon: [640, 512, [], "e509", "M277.4 4c6-5.3 15.1-5.3 21.2 0L512.5 192.8c-5.4-.5-10.9-.8-16.5-.8c-10.2 0-20.2 .9-29.9 2.5L288 37.3 96 206.7 96 432c0 26.5 21.5 48 48 48l64 0 0-160c0-17.7 14.3-32 32-32l96 0c1 0 2.1 .1 3.1 .1c-5.1 10.1-9.3 20.7-12.5 31.9L240 320l0 160 16 0 80 0 24.2 0c10 12.1 21.7 22.9 34.6 32L144 512c-44.2 0-80-35.8-80-80l0-197L26.6 268C20 273.8 9.8 273.2 4 266.6S-1.2 249.8 5.4 244L277.4 4zM496 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm67.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
}, Ev = {
  prefix: "fal",
  iconName: "briefcase",
  icon: [512, 512, [128188], "f0b1", "M160 48l0 48 192 0 0-48c0-8.8-7.2-16-16-16L176 32c-8.8 0-16 7.2-16 16zM128 96l0-48c0-26.5 21.5-48 48-48L336 0c26.5 0 48 21.5 48 48l0 48 64 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l64 0zm240 32l-224 0-80 0c-17.7 0-32 14.3-32 32l0 96 144 0 32 0 96 0 32 0 144 0 0-96c0-17.7-14.3-32-32-32l-80 0zM480 288l-144 0 0 48c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-48L32 288l0 128c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-128zm-272 0l0 48 96 0 0-48-96 0z"]
}, Ov = {
  prefix: "fal",
  iconName: "file-check",
  icon: [384, 512, [], "f316", "M320 480L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4L240 160zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0zM283.3 294c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-95.4 95.4-42-42c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L154 400.6c6.2 6.2 16.4 6.2 22.6 0L283.3 294z"]
}, Tv = {
  prefix: "fal",
  iconName: "grid-2",
  icon: [512, 512, [], "e196", "M80 64c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16L80 64zM32 80c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zM80 320c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16l-96 0zM32 336c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zM432 64l-96 0c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16zM336 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zm0 288c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16l-96 0zm-48 16c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96z"]
}, Mv = [
  Em,
  cm,
  av,
  _m,
  H1,
  _5,
  Ev,
  yv,
  H7,
  I1,
  J7,
  q1,
  g7,
  $7,
  Hf,
  c5,
  P7,
  hm,
  m5,
  Uf,
  O7,
  P1,
  o7,
  N5,
  cv,
  G5,
  Fm,
  S7,
  T5,
  v7,
  E7,
  N7,
  T7,
  k5,
  d7,
  Bm,
  g5,
  hv,
  h5,
  B7,
  r7,
  Dm,
  V7,
  l7,
  u5,
  A5,
  B5,
  I5,
  tl,
  x7,
  qf,
  Rm,
  j1,
  h7,
  B1,
  qm,
  Ym,
  tv,
  C5,
  Tv,
  G1,
  Gf,
  q1,
  P5,
  Lm,
  B1,
  M7,
  n5,
  F7,
  Jm,
  wm,
  b5,
  dm,
  W5,
  e7,
  L7,
  t7,
  Um,
  Z5,
  Qm,
  H1,
  ym,
  R7,
  z5,
  F5,
  r5,
  K1,
  U1,
  D1,
  Y1,
  N1,
  R1,
  V1,
  $5,
  U5,
  k7,
  c7,
  K1,
  $v,
  ov,
  sv,
  t5,
  s5,
  gm,
  vm,
  Wm,
  u7,
  D5,
  q5,
  S5,
  Ov,
  Sm,
  Q7,
  X7,
  W1,
  y5,
  Av,
  U1,
  D1,
  Y1,
  N1,
  R1,
  V1,
  _7,
  Am,
  w5,
  I7,
  Gm,
  Km,
  $m,
  Y7,
  Y5,
  X5,
  G7,
  s7,
  O5,
  j7,
  G1,
  W1,
  d5,
  l5,
  a5,
  q7,
  p7,
  H5,
  km,
  dv,
  Vf,
  mm,
  A7,
  a7,
  ev,
  v5,
  x5,
  y7,
  M5,
  E5,
  W7,
  Im,
  Q5,
  R5,
  Hm,
  b7,
  n7,
  V5,
  zm,
  Mm,
  sm,
  xv,
  L5,
  w7,
  J5,
  m7,
  f7,
  D7,
  K7,
  p5,
  j5,
  z7,
  Cm,
  lm,
  rv,
  um,
  Vm,
  Om,
  jm,
  f5,
  om,
  pm,
  e5,
  Xm,
  j1,
  U7,
  Sv,
  C7,
  Zm,
  Wf,
  Cv,
  gv,
  _v,
  Z7,
  K5,
  i7,
  uv,
  P1,
  nv,
  Pm,
  i5,
  bm,
  Nm,
  fm,
  fv,
  bv,
  lv,
  pv,
  iv,
  vv,
  xm,
  I1,
  o5,
  mv
];
function Z1(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function jt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Z1(Object(n), !0).forEach(function(r) {
      $t(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Z1(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function kv(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Lv(e) {
  var t = kv(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function ai(e) {
  "@babel/helpers - typeof";
  return ai = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ai(e);
}
function $t(e, t, n) {
  return t = Lv(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Fv(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function zv(e, t) {
  if (e == null) return {};
  var n = Fv(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function nl(e) {
  return Pv(e) || Iv(e) || Nv(e) || Dv();
}
function Pv(e) {
  if (Array.isArray(e)) return rl(e);
}
function Iv(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Nv(e, t) {
  if (e) {
    if (typeof e == "string") return rl(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return rl(e, t);
  }
}
function rl(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Dv() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Rv = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Yf = { exports: {} };
(function(e) {
  (function(t) {
    var n = function(g, b, $) {
      if (!u(b) || d(b) || f(b) || p(b) || l(b))
        return b;
      var y, A = 0, E = 0;
      if (c(b))
        for (y = [], E = b.length; A < E; A++)
          y.push(n(g, b[A], $));
      else {
        y = {};
        for (var L in b)
          Object.prototype.hasOwnProperty.call(b, L) && (y[g(L, $)] = n(g, b[L], $));
      }
      return y;
    }, r = function(g, b) {
      b = b || {};
      var $ = b.separator || "_", y = b.split || /(?=[A-Z])/;
      return g.split(y).join($);
    }, a = function(g) {
      return h(g) ? g : (g = g.replace(/[\-_\s]+(.)?/g, function(b, $) {
        return $ ? $.toUpperCase() : "";
      }), g.substr(0, 1).toLowerCase() + g.substr(1));
    }, i = function(g) {
      var b = a(g);
      return b.substr(0, 1).toUpperCase() + b.substr(1);
    }, s = function(g, b) {
      return r(g, b).toLowerCase();
    }, o = Object.prototype.toString, l = function(g) {
      return typeof g == "function";
    }, u = function(g) {
      return g === Object(g);
    }, c = function(g) {
      return o.call(g) == "[object Array]";
    }, d = function(g) {
      return o.call(g) == "[object Date]";
    }, f = function(g) {
      return o.call(g) == "[object RegExp]";
    }, p = function(g) {
      return o.call(g) == "[object Boolean]";
    }, h = function(g) {
      return g = g - 0, g === g;
    }, m = function(g, b) {
      var $ = b && "process" in b ? b.process : b;
      return typeof $ != "function" ? g : function(y, A) {
        return $(y, g, A);
      };
    }, v = {
      camelize: a,
      decamelize: s,
      pascalize: i,
      depascalize: s,
      camelizeKeys: function(g, b) {
        return n(m(a, b), g);
      },
      decamelizeKeys: function(g, b) {
        return n(m(s, b), g, b);
      },
      pascalizeKeys: function(g, b) {
        return n(m(i, b), g);
      },
      depascalizeKeys: function() {
        return this.decamelizeKeys.apply(this, arguments);
      }
    };
    e.exports ? e.exports = v : t.humps = v;
  })(Rv);
})(Yf);
var jv = Yf.exports, Bv = ["class", "style"];
function Vv(e) {
  return e.split(";").map(function(t) {
    return t.trim();
  }).filter(function(t) {
    return t;
  }).reduce(function(t, n) {
    var r = n.indexOf(":"), a = jv.camelize(n.slice(0, r)), i = n.slice(r + 1).trim();
    return t[a] = i, t;
  }, {});
}
function Uv(e) {
  return e.split(/\s+/).reduce(function(t, n) {
    return t[n] = !0, t;
  }, {});
}
function eu(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof e == "string")
    return e;
  var r = (e.children || []).map(function(l) {
    return eu(l);
  }), a = Object.keys(e.attributes || {}).reduce(function(l, u) {
    var c = e.attributes[u];
    switch (u) {
      case "class":
        l.class = Uv(c);
        break;
      case "style":
        l.style = Vv(c);
        break;
      default:
        l.attrs[u] = c;
    }
    return l;
  }, {
    attrs: {},
    class: {},
    style: {}
  });
  n.class;
  var i = n.style, s = i === void 0 ? {} : i, o = zv(n, Bv);
  return et(e.tag, jt(jt(jt({}, t), {}, {
    class: a.class,
    style: jt(jt({}, a.style), s)
  }, a.attrs), o), r);
}
var Kf = !1;
try {
  Kf = !0;
} catch {
}
function Hv() {
  if (!Kf && console && typeof console.error == "function") {
    var e;
    (e = console).error.apply(e, arguments);
  }
}
function Zr(e, t) {
  return Array.isArray(t) && t.length > 0 || !Array.isArray(t) && t ? $t({}, e, t) : {};
}
function Gv(e) {
  var t, n = (t = {
    "fa-spin": e.spin,
    "fa-pulse": e.pulse,
    "fa-fw": e.fixedWidth,
    "fa-border": e.border,
    "fa-li": e.listItem,
    "fa-inverse": e.inverse,
    "fa-flip": e.flip === !0,
    "fa-flip-horizontal": e.flip === "horizontal" || e.flip === "both",
    "fa-flip-vertical": e.flip === "vertical" || e.flip === "both"
  }, $t($t($t($t($t($t($t($t($t($t(t, "fa-".concat(e.size), e.size !== null), "fa-rotate-".concat(e.rotation), e.rotation !== null), "fa-pull-".concat(e.pull), e.pull !== null), "fa-swap-opacity", e.swapOpacity), "fa-bounce", e.bounce), "fa-shake", e.shake), "fa-beat", e.beat), "fa-fade", e.fade), "fa-beat-fade", e.beatFade), "fa-flash", e.flash), $t($t(t, "fa-spin-pulse", e.spinPulse), "fa-spin-reverse", e.spinReverse));
  return Object.keys(n).map(function(r) {
    return n[r] ? r : null;
  }).filter(function(r) {
    return r;
  });
}
function X1(e) {
  if (e && ai(e) === "object" && e.prefix && e.iconName && e.icon)
    return e;
  if (ri.icon)
    return ri.icon(e);
  if (e === null)
    return null;
  if (ai(e) === "object" && e.prefix && e.iconName)
    return e;
  if (Array.isArray(e) && e.length === 2)
    return {
      prefix: e[0],
      iconName: e[1]
    };
  if (typeof e == "string")
    return {
      prefix: "fas",
      iconName: e
    };
}
var te = re({
  name: "FontAwesomeIcon",
  props: {
    border: {
      type: Boolean,
      default: !1
    },
    fixedWidth: {
      type: Boolean,
      default: !1
    },
    flip: {
      type: [Boolean, String],
      default: !1,
      validator: function(t) {
        return [!0, !1, "horizontal", "vertical", "both"].indexOf(t) > -1;
      }
    },
    icon: {
      type: [Object, Array, String],
      required: !0
    },
    mask: {
      type: [Object, Array, String],
      default: null
    },
    maskId: {
      type: String,
      default: null
    },
    listItem: {
      type: Boolean,
      default: !1
    },
    pull: {
      type: String,
      default: null,
      validator: function(t) {
        return ["right", "left"].indexOf(t) > -1;
      }
    },
    pulse: {
      type: Boolean,
      default: !1
    },
    rotation: {
      type: [String, Number],
      default: null,
      validator: function(t) {
        return [90, 180, 270].indexOf(Number.parseInt(t, 10)) > -1;
      }
    },
    swapOpacity: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: null,
      validator: function(t) {
        return ["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"].indexOf(t) > -1;
      }
    },
    spin: {
      type: Boolean,
      default: !1
    },
    transform: {
      type: [String, Object],
      default: null
    },
    symbol: {
      type: [Boolean, String],
      default: !1
    },
    title: {
      type: String,
      default: null
    },
    titleId: {
      type: String,
      default: null
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    bounce: {
      type: Boolean,
      default: !1
    },
    shake: {
      type: Boolean,
      default: !1
    },
    beat: {
      type: Boolean,
      default: !1
    },
    fade: {
      type: Boolean,
      default: !1
    },
    beatFade: {
      type: Boolean,
      default: !1
    },
    flash: {
      type: Boolean,
      default: !1
    },
    spinPulse: {
      type: Boolean,
      default: !1
    },
    spinReverse: {
      type: Boolean,
      default: !1
    }
  },
  setup: function(t, n) {
    var r = n.attrs, a = P(function() {
      return X1(t.icon);
    }), i = P(function() {
      return Zr("classes", Gv(t));
    }), s = P(function() {
      return Zr("transform", typeof t.transform == "string" ? ri.transform(t.transform) : t.transform);
    }), o = P(function() {
      return Zr("mask", X1(t.mask));
    }), l = P(function() {
      return am(a.value, jt(jt(jt(jt({}, i.value), s.value), o.value), {}, {
        symbol: t.symbol,
        title: t.title,
        titleId: t.titleId,
        maskId: t.maskId
      }));
    });
    De(l, function(c) {
      if (!c)
        return Hv("Could not find one or more icon(s)", a.value, o.value);
    }, {
      immediate: !0
    });
    var u = P(function() {
      return l.value ? eu(l.value.abstract[0], {}, r) : null;
    });
    return function() {
      return u.value;
    };
  }
});
re({
  name: "FontAwesomeLayers",
  props: {
    fixedWidth: {
      type: Boolean,
      default: !1
    }
  },
  setup: function(t, n) {
    var r = n.slots, a = Bf.familyPrefix, i = P(function() {
      return ["".concat(a, "-layers")].concat(nl(t.fixedWidth ? ["".concat(a, "-fw")] : []));
    });
    return function() {
      return et("div", {
        class: i.value
      }, r.default ? r.default() : []);
    };
  }
});
re({
  name: "FontAwesomeLayersText",
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    transform: {
      type: [String, Object],
      default: null
    },
    counter: {
      type: Boolean,
      default: !1
    },
    position: {
      type: String,
      default: null,
      validator: function(t) {
        return ["bottom-left", "bottom-right", "top-left", "top-right"].indexOf(t) > -1;
      }
    }
  },
  setup: function(t, n) {
    var r = n.attrs, a = Bf.familyPrefix, i = P(function() {
      return Zr("classes", [].concat(nl(t.counter ? ["".concat(a, "-layers-counter")] : []), nl(t.position ? ["".concat(a, "-layers-").concat(t.position)] : [])));
    }), s = P(function() {
      return Zr("transform", typeof t.transform == "string" ? ri.transform(t.transform) : t.transform);
    }), o = P(function() {
      var u = im(t.value.toString(), jt(jt({}, s.value), i.value)), c = u.abstract;
      return t.counter && (c[0].attributes.class = c[0].attributes.class.replace("fa-layers-text", "")), c[0];
    }), l = P(function() {
      return eu(o.value, {}, r);
    });
    return function() {
      return l.value;
    };
  }
});
var En = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function yn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Zf = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(En, function() {
    var n = 1e3, r = 6e4, a = 36e5, i = "millisecond", s = "second", o = "minute", l = "hour", u = "day", c = "week", d = "month", f = "quarter", p = "year", h = "date", m = "Invalid Date", v = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, g = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, b = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(Q) {
      var W = ["th", "st", "nd", "rd"], O = Q % 100;
      return "[" + Q + (W[(O - 20) % 10] || W[O] || W[0]) + "]";
    } }, $ = function(Q, W, O) {
      var _ = String(Q);
      return !_ || _.length >= W ? Q : "" + Array(W + 1 - _.length).join(O) + Q;
    }, y = { s: $, z: function(Q) {
      var W = -Q.utcOffset(), O = Math.abs(W), _ = Math.floor(O / 60), w = O % 60;
      return (W <= 0 ? "+" : "-") + $(_, 2, "0") + ":" + $(w, 2, "0");
    }, m: function Q(W, O) {
      if (W.date() < O.date()) return -Q(O, W);
      var _ = 12 * (O.year() - W.year()) + (O.month() - W.month()), w = W.clone().add(_, d), F = O - w < 0, j = W.clone().add(_ + (F ? -1 : 1), d);
      return +(-(_ + (O - w) / (F ? w - j : j - w)) || 0);
    }, a: function(Q) {
      return Q < 0 ? Math.ceil(Q) || 0 : Math.floor(Q);
    }, p: function(Q) {
      return { M: d, y: p, w: c, d: u, D: h, h: l, m: o, s, ms: i, Q: f }[Q] || String(Q || "").toLowerCase().replace(/s$/, "");
    }, u: function(Q) {
      return Q === void 0;
    } }, A = "en", E = {};
    E[A] = b;
    var L = "$isDayjsObject", D = function(Q) {
      return Q instanceof ae || !(!Q || !Q[L]);
    }, ne = function Q(W, O, _) {
      var w;
      if (!W) return A;
      if (typeof W == "string") {
        var F = W.toLowerCase();
        E[F] && (w = F), O && (E[F] = O, w = F);
        var j = W.split("-");
        if (!w && j.length > 1) return Q(j[0]);
      } else {
        var Y = W.name;
        E[Y] = W, w = Y;
      }
      return !_ && w && (A = w), w || !_ && A;
    }, I = function(Q, W) {
      if (D(Q)) return Q.clone();
      var O = typeof W == "object" ? W : {};
      return O.date = Q, O.args = arguments, new ae(O);
    }, B = y;
    B.l = ne, B.i = D, B.w = function(Q, W) {
      return I(Q, { locale: W.$L, utc: W.$u, x: W.$x, $offset: W.$offset });
    };
    var ae = function() {
      function Q(O) {
        this.$L = ne(O.locale, null, !0), this.parse(O), this.$x = this.$x || O.x || {}, this[L] = !0;
      }
      var W = Q.prototype;
      return W.parse = function(O) {
        this.$d = function(_) {
          var w = _.date, F = _.utc;
          if (w === null) return /* @__PURE__ */ new Date(NaN);
          if (B.u(w)) return /* @__PURE__ */ new Date();
          if (w instanceof Date) return new Date(w);
          if (typeof w == "string" && !/Z$/i.test(w)) {
            var j = w.match(v);
            if (j) {
              var Y = j[2] - 1 || 0, ie = (j[7] || "0").substring(0, 3);
              return F ? new Date(Date.UTC(j[1], Y, j[3] || 1, j[4] || 0, j[5] || 0, j[6] || 0, ie)) : new Date(j[1], Y, j[3] || 1, j[4] || 0, j[5] || 0, j[6] || 0, ie);
            }
          }
          return new Date(w);
        }(O), this.init();
      }, W.init = function() {
        var O = this.$d;
        this.$y = O.getFullYear(), this.$M = O.getMonth(), this.$D = O.getDate(), this.$W = O.getDay(), this.$H = O.getHours(), this.$m = O.getMinutes(), this.$s = O.getSeconds(), this.$ms = O.getMilliseconds();
      }, W.$utils = function() {
        return B;
      }, W.isValid = function() {
        return this.$d.toString() !== m;
      }, W.isSame = function(O, _) {
        var w = I(O);
        return this.startOf(_) <= w && w <= this.endOf(_);
      }, W.isAfter = function(O, _) {
        return I(O) < this.startOf(_);
      }, W.isBefore = function(O, _) {
        return this.endOf(_) < I(O);
      }, W.$g = function(O, _, w) {
        return B.u(O) ? this[_] : this.set(w, O);
      }, W.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, W.valueOf = function() {
        return this.$d.getTime();
      }, W.startOf = function(O, _) {
        var w = this, F = !!B.u(_) || _, j = B.p(O), Y = function($e, be) {
          var qe = B.w(w.$u ? Date.UTC(w.$y, be, $e) : new Date(w.$y, be, $e), w);
          return F ? qe : qe.endOf(u);
        }, ie = function($e, be) {
          return B.w(w.toDate()[$e].apply(w.toDate("s"), (F ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(be)), w);
        }, Ae = this.$W, ge = this.$M, Pe = this.$D, ee = "set" + (this.$u ? "UTC" : "");
        switch (j) {
          case p:
            return F ? Y(1, 0) : Y(31, 11);
          case d:
            return F ? Y(1, ge) : Y(0, ge + 1);
          case c:
            var ue = this.$locale().weekStart || 0, ye = (Ae < ue ? Ae + 7 : Ae) - ue;
            return Y(F ? Pe - ye : Pe + (6 - ye), ge);
          case u:
          case h:
            return ie(ee + "Hours", 0);
          case l:
            return ie(ee + "Minutes", 1);
          case o:
            return ie(ee + "Seconds", 2);
          case s:
            return ie(ee + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, W.endOf = function(O) {
        return this.startOf(O, !1);
      }, W.$set = function(O, _) {
        var w, F = B.p(O), j = "set" + (this.$u ? "UTC" : ""), Y = (w = {}, w[u] = j + "Date", w[h] = j + "Date", w[d] = j + "Month", w[p] = j + "FullYear", w[l] = j + "Hours", w[o] = j + "Minutes", w[s] = j + "Seconds", w[i] = j + "Milliseconds", w)[F], ie = F === u ? this.$D + (_ - this.$W) : _;
        if (F === d || F === p) {
          var Ae = this.clone().set(h, 1);
          Ae.$d[Y](ie), Ae.init(), this.$d = Ae.set(h, Math.min(this.$D, Ae.daysInMonth())).$d;
        } else Y && this.$d[Y](ie);
        return this.init(), this;
      }, W.set = function(O, _) {
        return this.clone().$set(O, _);
      }, W.get = function(O) {
        return this[B.p(O)]();
      }, W.add = function(O, _) {
        var w, F = this;
        O = Number(O);
        var j = B.p(_), Y = function(ge) {
          var Pe = I(F);
          return B.w(Pe.date(Pe.date() + Math.round(ge * O)), F);
        };
        if (j === d) return this.set(d, this.$M + O);
        if (j === p) return this.set(p, this.$y + O);
        if (j === u) return Y(1);
        if (j === c) return Y(7);
        var ie = (w = {}, w[o] = r, w[l] = a, w[s] = n, w)[j] || 1, Ae = this.$d.getTime() + O * ie;
        return B.w(Ae, this);
      }, W.subtract = function(O, _) {
        return this.add(-1 * O, _);
      }, W.format = function(O) {
        var _ = this, w = this.$locale();
        if (!this.isValid()) return w.invalidDate || m;
        var F = O || "YYYY-MM-DDTHH:mm:ssZ", j = B.z(this), Y = this.$H, ie = this.$m, Ae = this.$M, ge = w.weekdays, Pe = w.months, ee = w.meridiem, ue = function(be, qe, He, Kt) {
          return be && (be[qe] || be(_, F)) || He[qe].slice(0, Kt);
        }, ye = function(be) {
          return B.s(Y % 12 || 12, be, "0");
        }, $e = ee || function(be, qe, He) {
          var Kt = be < 12 ? "AM" : "PM";
          return He ? Kt.toLowerCase() : Kt;
        };
        return F.replace(g, function(be, qe) {
          return qe || function(He) {
            switch (He) {
              case "YY":
                return String(_.$y).slice(-2);
              case "YYYY":
                return B.s(_.$y, 4, "0");
              case "M":
                return Ae + 1;
              case "MM":
                return B.s(Ae + 1, 2, "0");
              case "MMM":
                return ue(w.monthsShort, Ae, Pe, 3);
              case "MMMM":
                return ue(Pe, Ae);
              case "D":
                return _.$D;
              case "DD":
                return B.s(_.$D, 2, "0");
              case "d":
                return String(_.$W);
              case "dd":
                return ue(w.weekdaysMin, _.$W, ge, 2);
              case "ddd":
                return ue(w.weekdaysShort, _.$W, ge, 3);
              case "dddd":
                return ge[_.$W];
              case "H":
                return String(Y);
              case "HH":
                return B.s(Y, 2, "0");
              case "h":
                return ye(1);
              case "hh":
                return ye(2);
              case "a":
                return $e(Y, ie, !0);
              case "A":
                return $e(Y, ie, !1);
              case "m":
                return String(ie);
              case "mm":
                return B.s(ie, 2, "0");
              case "s":
                return String(_.$s);
              case "ss":
                return B.s(_.$s, 2, "0");
              case "SSS":
                return B.s(_.$ms, 3, "0");
              case "Z":
                return j;
            }
            return null;
          }(be) || j.replace(":", "");
        });
      }, W.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, W.diff = function(O, _, w) {
        var F, j = this, Y = B.p(_), ie = I(O), Ae = (ie.utcOffset() - this.utcOffset()) * r, ge = this - ie, Pe = function() {
          return B.m(j, ie);
        };
        switch (Y) {
          case p:
            F = Pe() / 12;
            break;
          case d:
            F = Pe();
            break;
          case f:
            F = Pe() / 3;
            break;
          case c:
            F = (ge - Ae) / 6048e5;
            break;
          case u:
            F = (ge - Ae) / 864e5;
            break;
          case l:
            F = ge / a;
            break;
          case o:
            F = ge / r;
            break;
          case s:
            F = ge / n;
            break;
          default:
            F = ge;
        }
        return w ? F : B.a(F);
      }, W.daysInMonth = function() {
        return this.endOf(d).$D;
      }, W.$locale = function() {
        return E[this.$L];
      }, W.locale = function(O, _) {
        if (!O) return this.$L;
        var w = this.clone(), F = ne(O, _, !0);
        return F && (w.$L = F), w;
      }, W.clone = function() {
        return B.w(this.$d, this);
      }, W.toDate = function() {
        return new Date(this.valueOf());
      }, W.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, W.toISOString = function() {
        return this.$d.toISOString();
      }, W.toString = function() {
        return this.$d.toUTCString();
      }, Q;
    }(), we = ae.prototype;
    return I.prototype = we, [["$ms", i], ["$s", s], ["$m", o], ["$H", l], ["$W", u], ["$M", d], ["$y", p], ["$D", h]].forEach(function(Q) {
      we[Q[1]] = function(W) {
        return this.$g(W, Q[0], Q[1]);
      };
    }), I.extend = function(Q, W) {
      return Q.$i || (Q(W, ae, I), Q.$i = !0), I;
    }, I.locale = ne, I.isDayjs = D, I.unix = function(Q) {
      return I(1e3 * Q);
    }, I.en = E[A], I.Ls = E, I.p = {}, I;
  });
})(Zf);
var Xf = Zf.exports;
const G = /* @__PURE__ */ yn(Xf);
var Jf = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(En, function() {
    var n = "minute", r = /[+-]\d\d(?::?\d\d)?/g, a = /([+-]|\d\d)/g;
    return function(i, s, o) {
      var l = s.prototype;
      o.utc = function(m) {
        var v = { date: m, utc: !0, args: arguments };
        return new s(v);
      }, l.utc = function(m) {
        var v = o(this.toDate(), { locale: this.$L, utc: !0 });
        return m ? v.add(this.utcOffset(), n) : v;
      }, l.local = function() {
        return o(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var u = l.parse;
      l.parse = function(m) {
        m.utc && (this.$u = !0), this.$utils().u(m.$offset) || (this.$offset = m.$offset), u.call(this, m);
      };
      var c = l.init;
      l.init = function() {
        if (this.$u) {
          var m = this.$d;
          this.$y = m.getUTCFullYear(), this.$M = m.getUTCMonth(), this.$D = m.getUTCDate(), this.$W = m.getUTCDay(), this.$H = m.getUTCHours(), this.$m = m.getUTCMinutes(), this.$s = m.getUTCSeconds(), this.$ms = m.getUTCMilliseconds();
        } else c.call(this);
      };
      var d = l.utcOffset;
      l.utcOffset = function(m, v) {
        var g = this.$utils().u;
        if (g(m)) return this.$u ? 0 : g(this.$offset) ? d.call(this) : this.$offset;
        if (typeof m == "string" && (m = function(A) {
          A === void 0 && (A = "");
          var E = A.match(r);
          if (!E) return null;
          var L = ("" + E[0]).match(a) || ["-", 0, 0], D = L[0], ne = 60 * +L[1] + +L[2];
          return ne === 0 ? 0 : D === "+" ? ne : -ne;
        }(m), m === null)) return this;
        var b = Math.abs(m) <= 16 ? 60 * m : m, $ = this;
        if (v) return $.$offset = b, $.$u = m === 0, $;
        if (m !== 0) {
          var y = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          ($ = this.local().add(b + y, n)).$offset = b, $.$x.$localOffset = y;
        } else $ = this.utc();
        return $;
      };
      var f = l.format;
      l.format = function(m) {
        var v = m || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return f.call(this, v);
      }, l.valueOf = function() {
        var m = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * m;
      }, l.isUTC = function() {
        return !!this.$u;
      }, l.toISOString = function() {
        return this.toDate().toISOString();
      }, l.toString = function() {
        return this.toDate().toUTCString();
      };
      var p = l.toDate;
      l.toDate = function(m) {
        return m === "s" && this.$offset ? o(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : p.call(this);
      };
      var h = l.diff;
      l.diff = function(m, v, g) {
        if (m && this.$u === m.$u) return h.call(this, m, v, g);
        var b = this.local(), $ = o(m).local();
        return h.call(b, $, v, g);
      };
    };
  });
})(Jf);
var qv = Jf.exports;
const Pi = /* @__PURE__ */ yn(qv);
/*!
 * maska v1.5.2
 * (c) 2019-2022 Alexander Shabunevich
 * Released under the MIT License.
 */
function J1(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Wa(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? J1(Object(n), !0).forEach(function(r) {
      Kv(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : J1(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Wv(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Yv(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, Qf(r.key), r);
  }
}
function Kv(e, t, n) {
  return (t = Qf(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Qf(e) {
  var t = function(n, r) {
    if (typeof n != "object" || n === null) return n;
    var a = n[Symbol.toPrimitive];
    if (a !== void 0) {
      var i = a.call(n, r);
      if (typeof i != "object") return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(n);
  }(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
var e3 = { "#": { pattern: /[0-9]/ }, X: { pattern: /[0-9a-zA-Z]/ }, S: { pattern: /[a-zA-Z]/ }, A: { pattern: /[a-zA-Z]/, uppercase: !0 }, a: { pattern: /[a-zA-Z]/, lowercase: !0 }, "!": { escape: !0 }, "*": { repeat: !0 } };
function Q1(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : e3, r = !(arguments.length > 3 && arguments[3] !== void 0) || arguments[3];
  return t3(t).length > 1 ? Zv(t)(e, t, n, r) : al(e, t, n, r);
}
function t3(e) {
  try {
    return JSON.parse(e);
  } catch {
    return [e];
  }
}
function Zv(e) {
  var t = t3(e).sort(function(r, a) {
    return r.length - a.length;
  });
  return function(r, a, i) {
    var s = !(arguments.length > 3 && arguments[3] !== void 0) || arguments[3], o = t.map(function(c) {
      return al(r, c, i, !1);
    }), l = o.pop();
    for (var u in t) if (n(l, t[u], i)) return al(r, t[u], i, s);
    return "";
  };
  function n(r, a, i) {
    for (var s in i) i[s].escape && (a = a.replace(new RegExp(s + ".{1}", "g"), ""));
    return a.split("").filter(function(o) {
      return i[o] && i[o].pattern;
    }).length >= r.length;
  }
}
function al(e, t, n) {
  for (var r = !(arguments.length > 3 && arguments[3] !== void 0) || arguments[3], a = 0, i = 0, s = "", o = ""; a < t.length && i < e.length; ) {
    var l = t[a], u = e[i], c = n[l];
    if (c && c.pattern) c.pattern.test(u) && (s += Xv(u, c), a++, r && t[a] && (n[t[a]] ? n[t[a]] && n[t[a]].escape && (s += t[a + 1], a += 2) : (s += t[a], a++))), i++;
    else if (c && c.repeat) {
      var d = n[t[a - 1]];
      d && !d.pattern.test(u) ? a++ : a--;
    } else c && c.escape && (l = t[++a]), r && (s += l), u === l && i++, a++;
  }
  for (; r && a < t.length; ) {
    var f = t[a];
    if (n[f]) {
      o = "";
      break;
    }
    o += f, a++;
  }
  return s + o;
}
function Xv(e, t) {
  return t.transform && (e = t.transform(e)), t.uppercase ? e.toLocaleUpperCase() : t.lowercase ? e.toLocaleLowerCase() : e;
}
function ec(e) {
  return e instanceof HTMLInputElement ? e : e.querySelector("input") || e;
}
function il(e) {
  return Object.prototype.toString.call(e) === "[object String]";
}
var Jv = function() {
  function e(r) {
    var a = this, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (Wv(this, e), !r) throw new Error("Maska: no element for mask");
    if (i.preprocessor != null && typeof i.preprocessor != "function") throw new Error("Maska: preprocessor must be a function");
    if (i.tokens) for (var s in i.tokens) i.tokens[s] = Wa({}, i.tokens[s]), i.tokens[s].pattern && il(i.tokens[s].pattern) && (i.tokens[s].pattern = new RegExp(i.tokens[s].pattern));
    this._opts = { mask: i.mask, tokens: Wa(Wa({}, e3), i.tokens), preprocessor: i.preprocessor }, this._el = il(r) ? document.querySelectorAll(r) : r.length ? r : [r], this.inputEvent = function(o) {
      return a.updateValue(o.target, o);
    }, this.init();
  }
  var t, n;
  return t = e, n = [{ key: "init", value: function() {
    for (var r = this, a = function(s) {
      var o = ec(r._el[s]);
      !r._opts.mask || o.dataset.mask && o.dataset.mask === r._opts.mask || (o.dataset.mask = r._opts.mask), setTimeout(function() {
        return r.updateValue(o);
      }, 0), o.dataset.maskInited || (o.dataset.maskInited = !0, o.addEventListener("input", r.inputEvent), o.addEventListener("beforeinput", r.beforeInput));
    }, i = 0; i < this._el.length; i++) a(i);
  } }, { key: "destroy", value: function() {
    for (var r = 0; r < this._el.length; r++) {
      var a = ec(this._el[r]);
      a.removeEventListener("input", this.inputEvent), a.removeEventListener("beforeinput", this.beforeInput), delete a.dataset.mask, delete a.dataset.maskInited;
    }
  } }, { key: "updateValue", value: function(r, a) {
    if (r && r.type) {
      var i = r.type.match(/^number$/i) && r.validity.badInput;
      if (!r.value && !i || !r.dataset.mask) return r.dataset.maskRawValue = "", void this.dispatch("maska", r, a);
      var s = r.selectionEnd, o = r.value, l = o[s - 1];
      r.dataset.maskRawValue = Q1(r.value, r.dataset.mask, this._opts.tokens, !1);
      var u = r.value;
      this._opts.preprocessor && (u = this._opts.preprocessor(u)), r.value = Q1(u, r.dataset.mask, this._opts.tokens), a && a.inputType === "insertText" && s === o.length && (s = r.value.length), function(c, d, f) {
        for (; d && d < c.value.length && c.value.charAt(d - 1) !== f; ) d++;
        (c.type ? c.type.match(/^(text|search|password|tel|url)$/i) : !c.type) && c === document.activeElement && (c.setSelectionRange(d, d), setTimeout(function() {
          c.setSelectionRange(d, d);
        }, 0));
      }(r, s, l), this.dispatch("maska", r, a), r.value !== o && this.dispatch("input", r, a);
    }
  } }, { key: "beforeInput", value: function(r) {
    r && r.target && r.target.type && r.target.type.match(/^number$/i) && r.data && isNaN(r.target.value + r.data) && r.preventDefault();
  } }, { key: "dispatch", value: function(r, a, i) {
    a.dispatchEvent(function(s) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, l = document.createEvent("Event");
      return l.initEvent(s, !0, !0), o && (l.inputType = o), l;
    }(r, i && i.inputType || null));
  } }], n && Yv(t.prototype, n), Object.defineProperty(t, "prototype", { writable: !1 }), e;
}(), ps, tu = (ps = /* @__PURE__ */ new WeakMap(), function(e, t) {
  t.value && (ps.has(e) && !function(n) {
    return !(il(n.value) && n.value === n.oldValue || Array.isArray(n.value) && JSON.stringify(n.value) === JSON.stringify(n.oldValue) || n.value && n.value.mask && n.oldValue && n.oldValue.mask && n.value.mask === n.oldValue.mask);
  }(t) || ps.set(e, new Jv(e, function(n) {
    var r = {};
    return n.mask ? (r.mask = Array.isArray(n.mask) ? JSON.stringify(n.mask) : n.mask, r.tokens = n.tokens ? Wa({}, n.tokens) : {}, r.preprocessor = n.preprocessor) : r.mask = Array.isArray(n) ? JSON.stringify(n) : n, r;
  }(t.value))));
});
function Qv(e) {
  e.directive("maska", tu);
}
typeof window < "u" && window.Vue && window.Vue.use && window.Vue.use(Qv);
var n3 = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(En, function() {
    var n = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, r = {};
    return function(a, i, s) {
      var o, l = function(f, p, h) {
        h === void 0 && (h = {});
        var m = new Date(f), v = function(g, b) {
          b === void 0 && (b = {});
          var $ = b.timeZoneName || "short", y = g + "|" + $, A = r[y];
          return A || (A = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: g, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: $ }), r[y] = A), A;
        }(p, h);
        return v.formatToParts(m);
      }, u = function(f, p) {
        for (var h = l(f, p), m = [], v = 0; v < h.length; v += 1) {
          var g = h[v], b = g.type, $ = g.value, y = n[b];
          y >= 0 && (m[y] = parseInt($, 10));
        }
        var A = m[3], E = A === 24 ? 0 : A, L = m[0] + "-" + m[1] + "-" + m[2] + " " + E + ":" + m[4] + ":" + m[5] + ":000", D = +f;
        return (s.utc(L).valueOf() - (D -= D % 1e3)) / 6e4;
      }, c = i.prototype;
      c.tz = function(f, p) {
        f === void 0 && (f = o);
        var h, m = this.utcOffset(), v = this.toDate(), g = v.toLocaleString("en-US", { timeZone: f }), b = Math.round((v - new Date(g)) / 1e3 / 60), $ = 15 * -Math.round(v.getTimezoneOffset() / 15) - b;
        if (!Number($)) h = this.utcOffset(0, p);
        else if (h = s(g, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset($, !0), p) {
          var y = h.utcOffset();
          h = h.add(m - y, "minute");
        }
        return h.$x.$timezone = f, h;
      }, c.offsetName = function(f) {
        var p = this.$x.$timezone || s.tz.guess(), h = l(this.valueOf(), p, { timeZoneName: f }).find(function(m) {
          return m.type.toLowerCase() === "timezonename";
        });
        return h && h.value;
      };
      var d = c.startOf;
      c.startOf = function(f, p) {
        if (!this.$x || !this.$x.$timezone) return d.call(this, f, p);
        var h = s(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
        return d.call(h, f, p).tz(this.$x.$timezone, !0);
      }, s.tz = function(f, p, h) {
        var m = h && p, v = h || p || o, g = u(+s(), v);
        if (typeof f != "string") return s(f).tz(v);
        var b = function(E, L, D) {
          var ne = E - 60 * L * 1e3, I = u(ne, D);
          if (L === I) return [ne, L];
          var B = u(ne -= 60 * (I - L) * 1e3, D);
          return I === B ? [ne, I] : [E - 60 * Math.min(I, B) * 1e3, Math.max(I, B)];
        }(s.utc(f, m).valueOf(), g, v), $ = b[0], y = b[1], A = s($).utcOffset(y);
        return A.$x.$timezone = v, A;
      }, s.tz.guess = function() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }, s.tz.setDefault = function(f) {
        o = f;
      };
    };
  });
})(n3);
var eg = n3.exports;
const r3 = /* @__PURE__ */ yn(eg);
G.extend(Pi);
G.extend(r3);
const tc = (e) => {
  const t = G().month(e - 1).daysInMonth();
  let n = G.tz(`${G().year()}-${e}-${t}`, "Europe/Amsterdam").startOf("day");
  for (; n.day() !== 0; )
    n = n.subtract(1, "day");
  return n = n.hour(2), n;
}, nu = G().isAfter(tc(3).hour(3)) && G().isBefore(tc(9).hour(3)) ? 2 : 1, tg = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-36-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|22"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "[24-689]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]]], BL: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "(?:[2-467]\\d\\d|8001)\\d{5}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[23]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "(?:[2-8]\\d|90)\\d{8}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|90[25])[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-36-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "[189]\\d{8}|[1-68]\\d{6}", [7, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "10(?:10|9[56])|2[0-57-9](?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}", [10, 11], [["(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-36-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:1[3-79]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "[56]94\\d{6}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], 0, 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[013-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "596\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "1(?:(?:22|44|7[27]|87|9[69])[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-689]|8[1-69]|9[1-578])|[2-9]\\d)\\d{8}", [10, 11], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], 0, 1], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], 0, 1], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 $3 $4", ["1"], 0, 1]], "01", 0, "0(?:[12]|4[45])|1", 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[047]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "2[0-24-9]\\d{8}|[78]\\d{10,13}|[7-9]\\d{9}|[1-9]\\d{7}|[124-7]\\d{6}", [7, 8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-6]|7(?:0[0-689]|[1-79])|8[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|80\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-5]|76(?:2[27]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "(?:[1-6]|[7-9]\\d\\d)\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "800\\d{4}|(?:[249]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|77|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-39]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|[69]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2679]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3[1-5]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:5056(?:[0-35-9]\\d|4[468])|7302[0-4]\\d)\\d{4}|(?:472[24]|505[2-57-9]|7306|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "810", "(?:20|33|[5-79]\\d|88)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[35-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, 0, 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function ru(e, t) {
  var n = Array.prototype.slice.call(t);
  return n.push(tg), e.apply(this, n);
}
function sl(e) {
  "@babel/helpers - typeof";
  return sl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, sl(e);
}
function ng(e, t, n) {
  return Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function rg(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ag(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && ta(e, t);
}
function ig(e) {
  var t = i3();
  return function() {
    var r = na(e), a;
    if (t) {
      var i = na(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return sg(this, a);
  };
}
function sg(e, t) {
  if (t && (sl(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return a3(e);
}
function a3(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function ol(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return ol = function(r) {
    if (r === null || !og(r)) return r;
    if (typeof r != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(r)) return t.get(r);
      t.set(r, a);
    }
    function a() {
      return Ya(r, arguments, na(this).constructor);
    }
    return a.prototype = Object.create(r.prototype, { constructor: { value: a, enumerable: !1, writable: !0, configurable: !0 } }), ta(a, r);
  }, ol(e);
}
function Ya(e, t, n) {
  return i3() ? Ya = Reflect.construct : Ya = function(a, i, s) {
    var o = [null];
    o.push.apply(o, i);
    var l = Function.bind.apply(a, o), u = new l();
    return s && ta(u, s.prototype), u;
  }, Ya.apply(null, arguments);
}
function i3() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function og(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function ta(e, t) {
  return ta = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, ta(e, t);
}
function na(e) {
  return na = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, na(e);
}
var fn = /* @__PURE__ */ function(e) {
  ag(n, e);
  var t = ig(n);
  function n(r) {
    var a;
    return rg(this, n), a = t.call(this, r), Object.setPrototypeOf(a3(a), n.prototype), a.name = a.constructor.name, a;
  }
  return ng(n);
}(/* @__PURE__ */ ol(Error)), au = 2, lg = 17, ug = 3, Gt = "0-9０-９٠-٩۰-۹", cg = "-‐-―−ー－", dg = "／/", fg = "．.", pg = "  ­​⁠　", hg = "()（）［］\\[\\]", mg = "~⁓∼～", ii = "".concat(cg).concat(dg).concat(fg).concat(pg).concat(hg).concat(mg), iu = "+＋";
function nc(e, t) {
  e = e.split("-"), t = t.split("-");
  for (var n = e[0].split("."), r = t[0].split("."), a = 0; a < 3; a++) {
    var i = Number(n[a]), s = Number(r[a]);
    if (i > s) return 1;
    if (s > i) return -1;
    if (!isNaN(i) && isNaN(s)) return 1;
    if (isNaN(i) && !isNaN(s)) return -1;
  }
  return e[1] && t[1] ? e[1] > t[1] ? 1 : e[1] < t[1] ? -1 : 0 : !e[1] && t[1] ? 1 : e[1] && !t[1] ? -1 : 0;
}
var vg = {}.constructor;
function Ka(e) {
  return e != null && e.constructor === vg;
}
function ll(e) {
  "@babel/helpers - typeof";
  return ll = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ll(e);
}
function Ii(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function gg(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Ni(e, t, n) {
  return t && gg(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var bg = "1.2.0", $g = "1.7.35", rc = " ext. ", yg = /^\d+$/, ft = /* @__PURE__ */ function() {
  function e(t) {
    Ii(this, e), Sg(t), this.metadata = t, s3.call(this, t);
  }
  return Ni(e, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(n) {
        return n !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(n) {
      return this.metadata.countries[n];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(n) {
      return this.getCountryMetadata(n) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(n) {
      if (this.getCountryCodesForCallingCode(n))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[n])
          return !0;
      } else {
        var r = this.countryCallingCodes()[n];
        if (r && r.length === 1 && r[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(n) {
      return this.nonGeographic() ? !!this.nonGeographic()[n] : !this.getCountryCodesForCallingCode(n);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(n, r) {
      if (n && yg.test(n) && (r = n, n = null), n && n !== "001") {
        if (!this.hasCountry(n))
          throw new Error("Unknown country: ".concat(n));
        this.numberingPlan = new ac(this.getCountryMetadata(n), this);
      } else if (r) {
        if (!this.hasCallingCode(r))
          throw new Error("Unknown calling code: ".concat(r));
        this.numberingPlan = new ac(this.getNumberingPlanMetadata(r), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(n) {
      var r = this.countryCallingCodes()[n];
      if (r)
        return r.length === 1 && r[0].length === 3 ? void 0 : r;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(n) {
      var r = this.getCountryCodesForCallingCode(n);
      if (r)
        return r[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(n) {
      var r = this.getCountryCodeForCallingCode(n);
      if (r)
        return this.getCountryMetadata(r);
      if (this.nonGeographic()) {
        var a = this.nonGeographic()[n];
        if (a)
          return a;
      } else {
        var i = this.countryCallingCodes()[n];
        if (i && i.length === 1 && i[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(n) {
      return this.numberingPlan.type(n);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), e;
}(), ac = /* @__PURE__ */ function() {
  function e(t, n) {
    Ii(this, e), this.globalMetadataObject = n, this.metadata = t, s3.call(this, n.metadata);
  }
  return Ni(e, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(n) {
      return n[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var n = this, r = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return r.map(function(a) {
        return new xg(a, n);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(n) {
      return n[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(n) {
      if (this.hasTypes() && ic(this.types(), n))
        return new wg(ic(this.types(), n), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? rc : this.metadata[13] || rc;
    }
  }]), e;
}(), xg = /* @__PURE__ */ function() {
  function e(t, n) {
    Ii(this, e), this._format = t, this.metadata = n;
  }
  return Ni(e, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !_g.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), e;
}(), _g = /^\(?\$1\)?$/, wg = /* @__PURE__ */ function() {
  function e(t, n) {
    Ii(this, e), this.type = t, this.metadata = n;
  }
  return Ni(e, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), e;
}();
function ic(e, t) {
  switch (t) {
    case "FIXED_LINE":
      return e[0];
    case "MOBILE":
      return e[1];
    case "TOLL_FREE":
      return e[2];
    case "PREMIUM_RATE":
      return e[3];
    case "PERSONAL_NUMBER":
      return e[4];
    case "VOICEMAIL":
      return e[5];
    case "UAN":
      return e[6];
    case "PAGER":
      return e[7];
    case "VOIP":
      return e[8];
    case "SHARED_COST":
      return e[9];
  }
}
function Sg(e) {
  if (!e)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!Ka(e) || !Ka(e.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(Ka(e) ? "an object of shape: { " + Object.keys(e).join(", ") + " }" : "a " + Cg(e) + ": " + e, "."));
}
var Cg = function(t) {
  return ll(t);
};
function Di(e, t) {
  if (t = new ft(t), t.hasCountry(e))
    return t.country(e).countryCallingCode();
  throw new Error("Unknown country: ".concat(e));
}
function Ag(e, t) {
  return t.countries.hasOwnProperty(e);
}
function s3(e) {
  var t = e.version;
  typeof t == "number" ? (this.v1 = t === 1, this.v2 = t === 2, this.v3 = t === 3, this.v4 = t === 4) : t ? nc(t, bg) === -1 ? this.v2 = !0 : nc(t, $g) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
var Eg = ";ext=", lr = function(t) {
  return "([".concat(Gt, "]{1,").concat(t, "})");
};
function o3(e) {
  var t = "20", n = "15", r = "9", a = "6", i = "[  \\t,]*", s = "[:\\.．]?[  \\t,-]*", o = "#?", l = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", u = "(?:[xｘ#＃~～]|int|ｉｎｔ)", c = "[- ]+", d = "[  \\t]*", f = "(?:,{2}|;)", p = Eg + lr(t), h = i + l + s + lr(t) + o, m = i + u + s + lr(r) + o, v = c + lr(a) + "#", g = d + f + s + lr(n) + o, b = d + "(?:,)+" + s + lr(r) + o;
  return p + "|" + h + "|" + m + "|" + v + "|" + g + "|" + b;
}
var Og = "[" + Gt + "]{" + au + "}", Tg = "[" + iu + "]{0,1}(?:[" + ii + "]*[" + Gt + "]){3,}[" + ii + Gt + "]*", Mg = new RegExp("^[" + iu + "]{0,1}(?:[" + ii + "]*[" + Gt + "]){1,2}$", "i"), kg = Tg + // Phone number extensions
"(?:" + o3() + ")?", Lg = new RegExp(
  // Either a short two-digit-only phone number
  "^" + Og + "$|^" + kg + "$",
  "i"
);
function Fg(e) {
  return e.length >= au && Lg.test(e);
}
function zg(e) {
  return Mg.test(e);
}
var sc = new RegExp("(?:" + o3() + ")$", "i");
function Pg(e) {
  var t = e.search(sc);
  if (t < 0)
    return {};
  for (var n = e.slice(0, t), r = e.match(sc), a = 1; a < r.length; ) {
    if (r[a])
      return {
        number: n,
        ext: r[a]
      };
    a++;
  }
}
var Ig = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function Ng(e) {
  return Ig[e];
}
function Dg(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Rg(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Rg(e, t) {
  if (e) {
    if (typeof e == "string") return oc(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return oc(e, t);
  }
}
function oc(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function lc(e) {
  for (var t = "", n = Dg(e.split("")), r; !(r = n()).done; ) {
    var a = r.value;
    t += jg(a, t) || "";
  }
  return t;
}
function jg(e, t, n) {
  return e === "+" ? t ? void 0 : "+" : Ng(e);
}
function su(e, t) {
  return Bg(e, void 0, t);
}
function Bg(e, t, n) {
  var r = n.type(t), a = r && r.possibleLengths() || n.possibleLengths();
  if (!a)
    return "IS_POSSIBLE";
  var i = e.length, s = a[0];
  return s === i ? "IS_POSSIBLE" : s > i ? "TOO_SHORT" : a[a.length - 1] < i ? "TOO_LONG" : a.indexOf(i, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function Vg(e, t, n) {
  if (t === void 0 && (t = {}), n = new ft(n), t.v2) {
    if (!e.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    n.selectNumberingPlan(e.countryCallingCode);
  } else {
    if (!e.phone)
      return !1;
    if (e.country) {
      if (!n.hasCountry(e.country))
        throw new Error("Unknown country: ".concat(e.country));
      n.country(e.country);
    } else {
      if (!e.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      n.selectNumberingPlan(e.countryCallingCode);
    }
  }
  if (n.possibleLengths())
    return l3(e.phone || e.nationalNumber, n);
  if (e.countryCallingCode && n.isNonGeographicCallingCode(e.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function l3(e, t) {
  switch (su(e, t)) {
    case "IS_POSSIBLE":
      return !0;
    default:
      return !1;
  }
}
function mn(e, t) {
  return e = e || "", new RegExp("^(?:" + t + ")$").test(e);
}
function Ug(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Hg(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Hg(e, t) {
  if (e) {
    if (typeof e == "string") return uc(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return uc(e, t);
  }
}
function uc(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var Gg = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function ou(e, t, n) {
  if (t = t || {}, !(!e.country && !e.countryCallingCode)) {
    n = new ft(n), n.selectNumberingPlan(e.country, e.countryCallingCode);
    var r = t.v2 ? e.nationalNumber : e.phone;
    if (mn(r, n.nationalNumberPattern())) {
      if (hs(r, "FIXED_LINE", n))
        return n.type("MOBILE") && n.type("MOBILE").pattern() === "" || !n.type("MOBILE") || hs(r, "MOBILE", n) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var a = Ug(Gg), i; !(i = a()).done; ) {
        var s = i.value;
        if (hs(r, s, n))
          return s;
      }
    }
  }
}
function hs(e, t, n) {
  return t = n.type(t), !t || !t.pattern() || t.possibleLengths() && t.possibleLengths().indexOf(e.length) < 0 ? !1 : mn(e, t.pattern());
}
function qg(e, t, n) {
  if (t = t || {}, n = new ft(n), n.selectNumberingPlan(e.country, e.countryCallingCode), n.hasTypes())
    return ou(e, t, n.metadata) !== void 0;
  var r = t.v2 ? e.nationalNumber : e.phone;
  return mn(r, n.nationalNumberPattern());
}
function Wg(e, t, n) {
  var r = new ft(n), a = r.getCountryCodesForCallingCode(e);
  return a ? a.filter(function(i) {
    return Yg(t, i, n);
  }) : [];
}
function Yg(e, t, n) {
  var r = new ft(n);
  return r.selectNumberingPlan(t), r.numberingPlan.possibleLengths().indexOf(e.length) >= 0;
}
function Kg(e) {
  return e.replace(new RegExp("[".concat(ii, "]+"), "g"), " ").trim();
}
var Zg = /(\$\d)/;
function Xg(e, t, n) {
  var r = n.useInternationalFormat, a = n.withNationalPrefix, i = e.replace(new RegExp(t.pattern()), r ? t.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    a && t.nationalPrefixFormattingRule() ? t.format().replace(Zg, t.nationalPrefixFormattingRule()) : t.format()
  ));
  return r ? Kg(i) : i;
}
var Jg = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function Qg(e, t, n) {
  var r = new ft(n);
  if (r.selectNumberingPlan(e, t), r.defaultIDDPrefix())
    return r.defaultIDDPrefix();
  if (Jg.test(r.IDDPrefix()))
    return r.IDDPrefix();
}
function e9(e) {
  var t = e.number, n = e.ext;
  if (!t)
    return "";
  if (t[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(t).concat(n ? ";ext=" + n : "");
}
function t9(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = n9(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function n9(e, t) {
  if (e) {
    if (typeof e == "string") return cc(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return cc(e, t);
  }
}
function cc(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function dc(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function fc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? dc(Object(n), !0).forEach(function(r) {
      r9(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : dc(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function r9(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var pc = {
  formatExtension: function(t, n, r) {
    return "".concat(t).concat(r.ext()).concat(n);
  }
};
function a9(e, t, n, r) {
  if (n ? n = fc(fc({}, pc), n) : n = pc, r = new ft(r), e.country && e.country !== "001") {
    if (!r.hasCountry(e.country))
      throw new Error("Unknown country: ".concat(e.country));
    r.country(e.country);
  } else if (e.countryCallingCode)
    r.selectNumberingPlan(e.countryCallingCode);
  else return e.phone || "";
  var a = r.countryCallingCode(), i = n.v2 ? e.nationalNumber : e.phone, s;
  switch (t) {
    case "NATIONAL":
      return i ? (s = si(i, e.carrierCode, "NATIONAL", r, n), ms(s, e.ext, r, n.formatExtension)) : "";
    case "INTERNATIONAL":
      return i ? (s = si(i, null, "INTERNATIONAL", r, n), s = "+".concat(a, " ").concat(s), ms(s, e.ext, r, n.formatExtension)) : "+".concat(a);
    case "E.164":
      return "+".concat(a).concat(i);
    case "RFC3966":
      return e9({
        number: "+".concat(a).concat(i),
        ext: e.ext
      });
    case "IDD":
      if (!n.fromCountry)
        return;
      var o = s9(i, e.carrierCode, a, n.fromCountry, r);
      return ms(o, e.ext, r, n.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(t, '"'));
  }
}
function si(e, t, n, r, a) {
  var i = i9(r.formats(), e);
  return i ? Xg(e, i, {
    useInternationalFormat: n === "INTERNATIONAL",
    withNationalPrefix: !(i.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && a && a.nationalPrefix === !1)
  }) : e;
}
function i9(e, t) {
  for (var n = t9(e), r; !(r = n()).done; ) {
    var a = r.value;
    if (a.leadingDigitsPatterns().length > 0) {
      var i = a.leadingDigitsPatterns()[a.leadingDigitsPatterns().length - 1];
      if (t.search(i) !== 0)
        continue;
    }
    if (mn(t, a.pattern()))
      return a;
  }
}
function ms(e, t, n, r) {
  return t ? r(e, t, n) : e;
}
function s9(e, t, n, r, a) {
  var i = Di(r, a.metadata);
  if (i === n) {
    var s = si(e, t, "NATIONAL", a);
    return n === "1" ? n + " " + s : s;
  }
  var o = Qg(r, void 0, a.metadata);
  if (o)
    return "".concat(o, " ").concat(n, " ").concat(si(e, null, "INTERNATIONAL", a));
}
function hc(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function mc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? hc(Object(n), !0).forEach(function(r) {
      o9(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : hc(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function o9(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function l9(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function u9(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function c9(e, t, n) {
  return t && u9(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var d9 = /* @__PURE__ */ function() {
  function e(t, n, r) {
    if (l9(this, e), !t)
      throw new TypeError("`country` or `countryCallingCode` not passed");
    if (!n)
      throw new TypeError("`nationalNumber` not passed");
    if (!r)
      throw new TypeError("`metadata` not passed");
    var a = p9(t, r), i = a.country, s = a.countryCallingCode;
    this.country = i, this.countryCallingCode = s, this.nationalNumber = n, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return r;
    };
  }
  return c9(e, [{
    key: "setExt",
    value: function(n) {
      this.ext = n;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : Wg(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return Vg(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return qg(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var n = new ft(this.getMetadata());
      return n.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(n) {
      return this.number === n.number && this.ext === n.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return ou(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(n, r) {
      return a9(this, n, r ? mc(mc({}, r), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(n) {
      return this.format("NATIONAL", n);
    }
  }, {
    key: "formatInternational",
    value: function(n) {
      return this.format("INTERNATIONAL", n);
    }
  }, {
    key: "getURI",
    value: function(n) {
      return this.format("RFC3966", n);
    }
  }]), e;
}(), f9 = function(t) {
  return /^[A-Z]{2}$/.test(t);
};
function p9(e, t) {
  var n, r, a = new ft(t);
  return f9(e) ? (n = e, a.selectNumberingPlan(n), r = a.countryCallingCode()) : r = e, {
    country: n,
    countryCallingCode: r
  };
}
var h9 = new RegExp("([" + Gt + "])");
function m9(e, t, n, r) {
  if (t) {
    var a = new ft(r);
    a.selectNumberingPlan(t, n);
    var i = new RegExp(a.IDDPrefix());
    if (e.search(i) === 0) {
      e = e.slice(e.match(i)[0].length);
      var s = e.match(h9);
      if (!(s && s[1] != null && s[1].length > 0 && s[1] === "0"))
        return e;
    }
  }
}
function v9(e, t) {
  if (e && t.numberingPlan.nationalPrefixForParsing()) {
    var n = new RegExp("^(?:" + t.numberingPlan.nationalPrefixForParsing() + ")"), r = n.exec(e);
    if (r) {
      var a, i, s = r.length - 1, o = s > 0 && r[s];
      if (t.nationalPrefixTransformRule() && o)
        a = e.replace(n, t.nationalPrefixTransformRule()), s > 1 && (i = r[1]);
      else {
        var l = r[0];
        a = e.slice(l.length), o && (i = r[1]);
      }
      var u;
      if (o) {
        var c = e.indexOf(r[1]), d = e.slice(0, c);
        d === t.numberingPlan.nationalPrefix() && (u = t.numberingPlan.nationalPrefix());
      } else
        u = r[0];
      return {
        nationalNumber: a,
        nationalPrefix: u,
        carrierCode: i
      };
    }
  }
  return {
    nationalNumber: e
  };
}
function ul(e, t) {
  var n = v9(e, t), r = n.carrierCode, a = n.nationalNumber;
  if (a !== e) {
    if (!g9(e, a, t))
      return {
        nationalNumber: e
      };
    if (t.possibleLengths() && !b9(a, t))
      return {
        nationalNumber: e
      };
  }
  return {
    nationalNumber: a,
    carrierCode: r
  };
}
function g9(e, t, n) {
  return !(mn(e, n.nationalNumberPattern()) && !mn(t, n.nationalNumberPattern()));
}
function b9(e, t) {
  switch (su(e, t)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function $9(e, t, n, r) {
  var a = t ? Di(t, r) : n;
  if (e.indexOf(a) === 0) {
    r = new ft(r), r.selectNumberingPlan(t, n);
    var i = e.slice(a.length), s = ul(i, r), o = s.nationalNumber, l = ul(e, r), u = l.nationalNumber;
    if (!mn(u, r.nationalNumberPattern()) && mn(o, r.nationalNumberPattern()) || su(u, r) === "TOO_LONG")
      return {
        countryCallingCode: a,
        number: i
      };
  }
  return {
    number: e
  };
}
function y9(e, t, n, r) {
  if (!e)
    return {};
  var a;
  if (e[0] !== "+") {
    var i = m9(e, t, n, r);
    if (i && i !== e)
      a = !0, e = "+" + i;
    else {
      if (t || n) {
        var s = $9(e, t, n, r), o = s.countryCallingCode, l = s.number;
        if (o)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: o,
            number: l
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: e
      };
    }
  }
  if (e[1] === "0")
    return {};
  r = new ft(r);
  for (var u = 2; u - 1 <= ug && u <= e.length; ) {
    var c = e.slice(1, u);
    if (r.hasCallingCode(c))
      return r.selectNumberingPlan(c), {
        countryCallingCodeSource: a ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: c,
        number: e.slice(u)
      };
    u++;
  }
  return {};
}
function x9(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = _9(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _9(e, t) {
  if (e) {
    if (typeof e == "string") return vc(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return vc(e, t);
  }
}
function vc(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function w9(e, t) {
  var n = t.countries, r = t.defaultCountry, a = t.metadata;
  a = new ft(a);
  for (var i = [], s = x9(n), o; !(o = s()).done; ) {
    var l = o.value;
    if (a.country(l), a.leadingDigits()) {
      if (e && e.search(a.leadingDigits()) === 0)
        return l;
    } else if (ou({
      phone: e,
      country: l
    }, void 0, a.metadata))
      if (r) {
        if (l === r)
          return l;
        i.push(l);
      } else
        return l;
  }
  if (i.length > 0)
    return i[0];
}
function S9(e, t) {
  var n = t.nationalNumber, r = t.defaultCountry, a = t.metadata, i = a.getCountryCodesForCallingCode(e);
  if (i)
    return i.length === 1 ? i[0] : w9(n, {
      countries: i,
      defaultCountry: r,
      metadata: a.metadata
    });
}
var u3 = "+", C9 = "[\\-\\.\\(\\)]?", gc = "([" + Gt + "]|" + C9 + ")", A9 = "^\\" + u3 + gc + "*[" + Gt + "]" + gc + "*$", E9 = new RegExp(A9, "g"), cl = Gt, O9 = "[" + cl + "]+((\\-)*[" + cl + "])*", T9 = "a-zA-Z", M9 = "[" + T9 + "]+((\\-)*[" + cl + "])*", k9 = "^(" + O9 + "\\.)*" + M9 + "\\.?$", L9 = new RegExp(k9, "g"), bc = "tel:", dl = ";phone-context=", F9 = ";isub=";
function z9(e) {
  var t = e.indexOf(dl);
  if (t < 0)
    return null;
  var n = t + dl.length;
  if (n >= e.length)
    return "";
  var r = e.indexOf(";", n);
  return r >= 0 ? e.substring(n, r) : e.substring(n);
}
function P9(e) {
  return e === null ? !0 : e.length === 0 ? !1 : E9.test(e) || L9.test(e);
}
function I9(e, t) {
  var n = t.extractFormattedPhoneNumber, r = z9(e);
  if (!P9(r))
    throw new fn("NOT_A_NUMBER");
  var a;
  if (r === null)
    a = n(e) || "";
  else {
    a = "", r.charAt(0) === u3 && (a += r);
    var i = e.indexOf(bc), s;
    i >= 0 ? s = i + bc.length : s = 0;
    var o = e.indexOf(dl);
    a += e.substring(s, o);
  }
  var l = a.indexOf(F9);
  if (l > 0 && (a = a.substring(0, l)), a !== "")
    return a;
}
var N9 = 250, D9 = new RegExp("[" + iu + Gt + "]"), R9 = new RegExp("[^" + Gt + "#]+$");
function j9(e, t, n) {
  if (t = t || {}, n = new ft(n), t.defaultCountry && !n.hasCountry(t.defaultCountry))
    throw t.v2 ? new fn("INVALID_COUNTRY") : new Error("Unknown country: ".concat(t.defaultCountry));
  var r = V9(e, t.v2, t.extract), a = r.number, i = r.ext, s = r.error;
  if (!a) {
    if (t.v2)
      throw s === "TOO_SHORT" ? new fn("TOO_SHORT") : new fn("NOT_A_NUMBER");
    return {};
  }
  var o = H9(a, t.defaultCountry, t.defaultCallingCode, n), l = o.country, u = o.nationalNumber, c = o.countryCallingCode, d = o.countryCallingCodeSource, f = o.carrierCode;
  if (!n.hasSelectedNumberingPlan()) {
    if (t.v2)
      throw new fn("INVALID_COUNTRY");
    return {};
  }
  if (!u || u.length < au) {
    if (t.v2)
      throw new fn("TOO_SHORT");
    return {};
  }
  if (u.length > lg) {
    if (t.v2)
      throw new fn("TOO_LONG");
    return {};
  }
  if (t.v2) {
    var p = new d9(c, u, n.metadata);
    return l && (p.country = l), f && (p.carrierCode = f), i && (p.ext = i), p.__countryCallingCodeSource = d, p;
  }
  var h = (t.extended ? n.hasSelectedNumberingPlan() : l) ? mn(u, n.nationalNumberPattern()) : !1;
  return t.extended ? {
    country: l,
    countryCallingCode: c,
    carrierCode: f,
    valid: h,
    possible: h ? !0 : !!(t.extended === !0 && n.possibleLengths() && l3(u, n)),
    phone: u,
    ext: i
  } : h ? U9(l, u, i) : {};
}
function B9(e, t, n) {
  if (e) {
    if (e.length > N9) {
      if (n)
        throw new fn("TOO_LONG");
      return;
    }
    if (t === !1)
      return e;
    var r = e.search(D9);
    if (!(r < 0))
      return e.slice(r).replace(R9, "");
  }
}
function V9(e, t, n) {
  var r = I9(e, {
    extractFormattedPhoneNumber: function(s) {
      return B9(s, n, t);
    }
  });
  if (!r)
    return {};
  if (!Fg(r))
    return zg(r) ? {
      error: "TOO_SHORT"
    } : {};
  var a = Pg(r);
  return a.ext ? a : {
    number: r
  };
}
function U9(e, t, n) {
  var r = {
    country: e,
    phone: t
  };
  return n && (r.ext = n), r;
}
function H9(e, t, n, r) {
  var a = y9(lc(e), t, n, r.metadata), i = a.countryCallingCodeSource, s = a.countryCallingCode, o = a.number, l;
  if (s)
    r.selectNumberingPlan(s);
  else if (o && (t || n))
    r.selectNumberingPlan(t, n), t && (l = t), s = n || Di(t, r.metadata);
  else return {};
  if (!o)
    return {
      countryCallingCodeSource: i,
      countryCallingCode: s
    };
  var u = ul(lc(o), r), c = u.nationalNumber, d = u.carrierCode, f = S9(s, {
    nationalNumber: c,
    defaultCountry: t,
    metadata: r
  });
  return f && (l = f, f === "001" || r.country(l)), {
    country: l,
    countryCallingCode: s,
    countryCallingCodeSource: i,
    nationalNumber: c,
    carrierCode: d
  };
}
function $c(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function yc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? $c(Object(n), !0).forEach(function(r) {
      G9(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $c(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function G9(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function q9(e, t, n) {
  return j9(e, yc(yc({}, t), {}, {
    v2: !0
  }), n);
}
function xc(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function W9(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? xc(Object(n), !0).forEach(function(r) {
      Y9(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : xc(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Y9(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function K9(e, t) {
  return Q9(e) || J9(e, t) || X9(e, t) || Z9();
}
function Z9() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function X9(e, t) {
  if (e) {
    if (typeof e == "string") return _c(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _c(e, t);
  }
}
function _c(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function J9(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], a = !0, i = !1, s, o;
    try {
      for (n = n.call(e); !(a = (s = n.next()).done) && (r.push(s.value), !(t && r.length === t)); a = !0)
        ;
    } catch (l) {
      i = !0, o = l;
    } finally {
      try {
        !a && n.return != null && n.return();
      } finally {
        if (i) throw o;
      }
    }
    return r;
  }
}
function Q9(e) {
  if (Array.isArray(e)) return e;
}
function eb(e) {
  var t = Array.prototype.slice.call(e), n = K9(t, 4), r = n[0], a = n[1], i = n[2], s = n[3], o, l, u;
  if (typeof r == "string")
    o = r;
  else throw new TypeError("A text for parsing must be a string.");
  if (!a || typeof a == "string")
    s ? (l = i, u = s) : (l = void 0, u = i), a && (l = W9({
      defaultCountry: a
    }, l));
  else if (Ka(a))
    i ? (l = a, u = i) : u = a;
  else throw new Error("Invalid second argument: ".concat(a));
  return {
    text: o,
    options: l,
    metadata: u
  };
}
function wc(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Sc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? wc(Object(n), !0).forEach(function(r) {
      tb(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : wc(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function tb(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function nb(e, t, n) {
  t && t.defaultCountry && !Ag(t.defaultCountry, n) && (t = Sc(Sc({}, t), {}, {
    defaultCountry: void 0
  }));
  try {
    return q9(e, t, n);
  } catch (r) {
    if (!(r instanceof fn)) throw r;
  }
}
function rb() {
  var e = eb(arguments), t = e.text, n = e.options, r = e.metadata;
  return nb(t, n, r);
}
function ab(e) {
  return new ft(e).getCountries();
}
function Za() {
  return ru(rb, arguments);
}
function ib() {
  return ru(ab, arguments);
}
function vs() {
  return ru(Di, arguments);
}
const Te = (e) => e ? e.replace(/\W+/g, "-").toLowerCase() : void 0, ra = (e = 0, t = 2, n = 2, r = "EUR", a = "nl-NL") => {
  const i = t;
  let s = n;
  return s > i && (s = i), Intl.NumberFormat(a, {
    style: "currency",
    minimumFractionDigits: s,
    maximumFractionDigits: i,
    currency: r
  }).format(e || 0).replace(/([,.])00$/, "$1-");
}, GW = (e = 0, t = 2, n = 0, r = "nl-NL") => Intl.NumberFormat(r, {
  style: "percent",
  minimumFractionDigits: n,
  maximumFractionDigits: t
}).format(e / 100), qW = (e) => `${e / 12} jaar`, WW = (e = null) => e === null ? "n.n.b." : `${e} maand${e > 1 ? "en" : ""}`, YW = (e) => G(e).format("YYYY-MM-DD"), KW = (e) => G(e).format("DD-MM-YYYY"), ZW = (e) => G(e).locale("nl").format("D MMMM YYYY"), XW = (e) => G(e).locale("nl").format("D MMMM YYYY HH:mm"), lu = (e) => {
  const t = [..."0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz"];
  return [...Array.from({ length: e })].map(() => t[Math.floor(Math.random() * t.length)]).join("");
}, JW = (e, [t]) => (e == null ? void 0 : e.length) >= t || `Het minimale aantal tekens van dit veld is ${t}`, QW = (e) => /[!"#$%&'()*+,./:;<=>?@[\\\]^_{|}~-]+/.test(e) || "Moet minimaal een speciaal teken bevatten", eY = (e) => !!e && /(?=.*\d)/.test(e) || "Moet minimaal een cijfer bevatten", tY = (e) => !!e && /(?=.*[A-Z])/.test(e) || "Moet minimaal een hoofdletter bevatten", nY = (e) => !!e && /(?=.*[a-z])/.test(e) || "Moet minimaal een klein letter bevatten", rY = (e) => (e.replace(/[^\da-z]/gi, "").toUpperCase().match(/.{1,4}/g) || []).join(" ").trim(), sb = /^(?:\+\d{11,12}|0\d{9,10}|[1-9]\d{9,10})$/, aY = /^(([^\s"(),.:;<>@[\\\]]+(\.[^\s"(),.:;<>@[\\\]]+)*)|(".+"))@((\[(?:\d{1,3}\.){3}\d{1,3}])|(([\dA-Za-z]+\.)+[A-Za-z]{2,}))$/, Cc = (e) => {
  const t = [
    ...e.toUpperCase()
  ].map((n) => 127397 + n.charCodeAt(0));
  return String.fromCodePoint(...t);
}, iY = (e, t) => {
  const n = Gp({
    render: () => et(e, t)
  }), r = document.createElement("div");
  return n.mount(r).$el.outerHTML;
};
/**
  * vee-validate v4.15.1
  * (c) 2025 Abdelrahman Awad
  * @license MIT
  */
function xt(e) {
  return typeof e == "function";
}
function c3(e) {
  return e == null;
}
const Zn = (e) => e !== null && !!e && typeof e == "object" && !Array.isArray(e);
function uu(e) {
  return Number(e) >= 0;
}
function ob(e) {
  const t = parseFloat(e);
  return isNaN(t) ? e : t;
}
function lb(e) {
  return typeof e == "object" && e !== null;
}
function ub(e) {
  return e == null ? e === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(e);
}
function Ac(e) {
  if (!lb(e) || ub(e) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(e) === null)
    return !0;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function aa(e, t) {
  return Object.keys(t).forEach((n) => {
    if (Ac(t[n]) && Ac(e[n])) {
      e[n] || (e[n] = {}), aa(e[n], t[n]);
      return;
    }
    e[n] = t[n];
  }), e;
}
function Hr(e) {
  const t = e.split(".");
  if (!t.length)
    return "";
  let n = String(t[0]);
  for (let r = 1; r < t.length; r++) {
    if (uu(t[r])) {
      n += `[${t[r]}]`;
      continue;
    }
    n += `.${t[r]}`;
  }
  return n;
}
const cb = {};
function db(e) {
  return cb[e];
}
function Ec(e, t, n) {
  typeof n.value == "object" && (n.value = Le(n.value)), !n.enumerable || n.get || n.set || !n.configurable || !n.writable || t === "__proto__" ? Object.defineProperty(e, t, n) : e[t] = n.value;
}
function Le(e) {
  if (typeof e != "object") return e;
  var t = 0, n, r, a, i = Object.prototype.toString.call(e);
  if (i === "[object Object]" ? a = Object.create(e.__proto__ || null) : i === "[object Array]" ? a = Array(e.length) : i === "[object Set]" ? (a = /* @__PURE__ */ new Set(), e.forEach(function(s) {
    a.add(Le(s));
  })) : i === "[object Map]" ? (a = /* @__PURE__ */ new Map(), e.forEach(function(s, o) {
    a.set(Le(o), Le(s));
  })) : i === "[object Date]" ? a = /* @__PURE__ */ new Date(+e) : i === "[object RegExp]" ? a = new RegExp(e.source, e.flags) : i === "[object DataView]" ? a = new e.constructor(Le(e.buffer)) : i === "[object ArrayBuffer]" ? a = e.slice(0) : i.slice(-6) === "Array]" && (a = new e.constructor(e)), a) {
    for (r = Object.getOwnPropertySymbols(e); t < r.length; t++)
      Ec(a, r[t], Object.getOwnPropertyDescriptor(e, r[t]));
    for (t = 0, r = Object.getOwnPropertyNames(e); t < r.length; t++)
      Object.hasOwnProperty.call(a, n = r[t]) && a[n] === e[n] || Ec(a, n, Object.getOwnPropertyDescriptor(e, n));
  }
  return a || e;
}
const Ri = Symbol("vee-validate-form"), fb = Symbol("vee-validate-form-context"), pb = Symbol("vee-validate-field-instance"), Oc = Symbol("Default empty value"), hb = typeof window < "u";
function fl(e) {
  return xt(e) && !!e.__locatorRef;
}
function Bt(e) {
  return !!e && xt(e.parse) && e.__type === "VVTypedSchema";
}
function oi(e) {
  return !!e && xt(e.validate);
}
function d3(e) {
  return e === "checkbox" || e === "radio";
}
function mb(e) {
  return Zn(e) || Array.isArray(e);
}
function vb(e) {
  return Array.isArray(e) ? e.length === 0 : Zn(e) && Object.keys(e).length === 0;
}
function ji(e) {
  return /^\[.+\]$/i.test(e);
}
function gb(e) {
  return f3(e) && e.multiple;
}
function f3(e) {
  return e.tagName === "SELECT";
}
function p3(e) {
  return cu(e) && e.target && "submit" in e.target;
}
function cu(e) {
  return e ? !!(typeof Event < "u" && xt(Event) && e instanceof Event || e && e.srcElement) : !1;
}
function mt(e, t) {
  if (e === t)
    return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor)
      return !1;
    var n, r, a;
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!mt(e[r], t[r]))
          return !1;
      return !0;
    }
    if (e instanceof Map && t instanceof Map) {
      if (e.size !== t.size)
        return !1;
      for (r of e.entries())
        if (!t.has(r[0]))
          return !1;
      for (r of e.entries())
        if (!mt(r[1], t.get(r[0])))
          return !1;
      return !0;
    }
    if (Mc(e) && Mc(t))
      return !(e.size !== t.size || e.name !== t.name || e.lastModified !== t.lastModified || e.type !== t.type);
    if (e instanceof Set && t instanceof Set) {
      if (e.size !== t.size)
        return !1;
      for (r of e.entries())
        if (!t.has(r[0]))
          return !1;
      return !0;
    }
    if (ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (e[r] !== t[r])
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === t.toString();
    if (e = Tc(e), t = Tc(t), a = Object.keys(e), n = a.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, a[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      var i = a[r];
      if (!mt(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Tc(e) {
  return Object.fromEntries(Object.entries(e).filter(([, t]) => t !== void 0));
}
function Mc(e) {
  return hb ? e instanceof File : !1;
}
function du(e) {
  return ji(e) ? e.replace(/\[|\]/gi, "") : e;
}
function _t(e, t, n) {
  return e ? ji(t) ? e[du(t)] : (t || "").split(/\.|\[(\d+)\]/).filter(Boolean).reduce((a, i) => mb(a) && i in a ? a[i] : n, e) : n;
}
function cn(e, t, n) {
  if (ji(t)) {
    e[du(t)] = n;
    return;
  }
  const r = t.split(/\.|\[(\d+)\]/).filter(Boolean);
  let a = e;
  for (let i = 0; i < r.length; i++) {
    if (i === r.length - 1) {
      a[r[i]] = n;
      return;
    }
    (!(r[i] in a) || c3(a[r[i]])) && (a[r[i]] = uu(r[i + 1]) ? [] : {}), a = a[r[i]];
  }
}
function gs(e, t) {
  if (Array.isArray(e) && uu(t)) {
    e.splice(Number(t), 1);
    return;
  }
  Zn(e) && delete e[t];
}
function kc(e, t) {
  if (ji(t)) {
    delete e[du(t)];
    return;
  }
  const n = t.split(/\.|\[(\d+)\]/).filter(Boolean);
  let r = e;
  for (let i = 0; i < n.length; i++) {
    if (i === n.length - 1) {
      gs(r, n[i]);
      break;
    }
    if (!(n[i] in r) || c3(r[n[i]]))
      break;
    r = r[n[i]];
  }
  const a = n.map((i, s) => _t(e, n.slice(0, s).join(".")));
  for (let i = a.length - 1; i >= 0; i--)
    if (vb(a[i])) {
      if (i === 0) {
        gs(e, n[0]);
        continue;
      }
      gs(a[i - 1], n[i - 1]);
    }
}
function At(e) {
  return Object.keys(e);
}
function fu(e, t = void 0) {
  const n = Ar();
  return (n == null ? void 0 : n.provides[e]) || da(e, t);
}
function Lc(e, t, n) {
  if (Array.isArray(e)) {
    const r = [...e], a = r.findIndex((i) => mt(i, t));
    return a >= 0 ? r.splice(a, 1) : r.push(t), r;
  }
  return mt(e, t) ? n : t;
}
function Fc(e, t = 0) {
  let n = null, r = [];
  return function(...a) {
    return n && clearTimeout(n), n = setTimeout(() => {
      const i = e(...a);
      r.forEach((s) => s(i)), r = [];
    }, t), new Promise((i) => r.push(i));
  };
}
function bb(e, t) {
  return Zn(t) && t.number ? ob(e) : e;
}
function pl(e, t) {
  let n;
  return async function(...a) {
    const i = e(...a);
    n = i;
    const s = await i;
    return i !== n ? s : (n = void 0, t(s, a));
  };
}
function hl(e) {
  return Array.isArray(e) ? e : e ? [e] : [];
}
function Sa(e, t) {
  const n = {};
  for (const r in e)
    t.includes(r) || (n[r] = e[r]);
  return n;
}
function $b(e) {
  let t = null, n = [];
  return function(...r) {
    const a = We(() => {
      if (t !== a)
        return;
      const i = e(...r);
      n.forEach((s) => s(i)), n = [], t = null;
    });
    return t = a, new Promise((i) => n.push(i));
  };
}
function yb(e, t, n) {
  return t.slots.default ? typeof e == "string" || !e ? t.slots.default(n()) : {
    default: () => {
      var r, a;
      return (a = (r = t.slots).default) === null || a === void 0 ? void 0 : a.call(r, n());
    }
  } : t.slots.default;
}
function bs(e) {
  if (h3(e))
    return e._value;
}
function h3(e) {
  return "_value" in e;
}
function xb(e) {
  return e.type === "number" || e.type === "range" ? Number.isNaN(e.valueAsNumber) ? e.value : e.valueAsNumber : e.value;
}
function li(e) {
  if (!cu(e))
    return e;
  const t = e.target;
  if (d3(t.type) && h3(t))
    return bs(t);
  if (t.type === "file" && t.files) {
    const n = Array.from(t.files);
    return t.multiple ? n : n[0];
  }
  if (gb(t))
    return Array.from(t.options).filter((n) => n.selected && !n.disabled).map(bs);
  if (f3(t)) {
    const n = Array.from(t.options).find((r) => r.selected);
    return n ? bs(n) : t.value;
  }
  return xb(t);
}
function m3(e) {
  const t = {};
  return Object.defineProperty(t, "_$$isNormalized", {
    value: !0,
    writable: !1,
    enumerable: !1,
    configurable: !1
  }), e ? Zn(e) && e._$$isNormalized ? e : Zn(e) ? Object.keys(e).reduce((n, r) => {
    const a = _b(e[r]);
    return e[r] !== !1 && (n[r] = zc(a)), n;
  }, t) : typeof e != "string" ? t : e.split("|").reduce((n, r) => {
    const a = wb(r);
    return a.name && (n[a.name] = zc(a.params)), n;
  }, t) : t;
}
function _b(e) {
  return e === !0 ? [] : Array.isArray(e) || Zn(e) ? e : [e];
}
function zc(e) {
  const t = (n) => typeof n == "string" && n[0] === "@" ? Sb(n.slice(1)) : n;
  return Array.isArray(e) ? e.map(t) : e instanceof RegExp ? [e] : Object.keys(e).reduce((n, r) => (n[r] = t(e[r]), n), {});
}
const wb = (e) => {
  let t = [];
  const n = e.split(":")[0];
  return e.includes(":") && (t = e.split(":").slice(1).join(":").split(",")), { name: n, params: t };
};
function Sb(e) {
  const t = (n) => {
    var r;
    return (r = _t(n, e)) !== null && r !== void 0 ? r : n[e];
  };
  return t.__locatorRef = e, t;
}
function Cb(e) {
  return Array.isArray(e) ? e.filter(fl) : At(e).filter((t) => fl(e[t])).map((t) => e[t]);
}
const Ab = {
  generateMessage: ({ field: e }) => `${e} is not valid.`,
  bails: !0,
  validateOnBlur: !0,
  validateOnChange: !0,
  validateOnInput: !1,
  validateOnModelUpdate: !0
};
let Eb = Object.assign({}, Ab);
const Gr = () => Eb;
async function v3(e, t, n = {}) {
  const r = n == null ? void 0 : n.bails, a = {
    name: (n == null ? void 0 : n.name) || "{field}",
    rules: t,
    label: n == null ? void 0 : n.label,
    bails: r ?? !0,
    formData: (n == null ? void 0 : n.values) || {}
  }, i = await Ob(a, e);
  return Object.assign(Object.assign({}, i), { valid: !i.errors.length });
}
async function Ob(e, t) {
  const n = e.rules;
  if (Bt(n) || oi(n))
    return Mb(t, Object.assign(Object.assign({}, e), { rules: n }));
  if (xt(n) || Array.isArray(n)) {
    const o = {
      field: e.label || e.name,
      name: e.name,
      label: e.label,
      form: e.formData,
      value: t
    }, l = Array.isArray(n) ? n : [n], u = l.length, c = [];
    for (let d = 0; d < u; d++) {
      const f = l[d], p = await f(t, o);
      if (!(typeof p != "string" && !Array.isArray(p) && p)) {
        if (Array.isArray(p))
          c.push(...p);
        else {
          const m = typeof p == "string" ? p : b3(o);
          c.push(m);
        }
        if (e.bails)
          return {
            errors: c
          };
      }
    }
    return {
      errors: c
    };
  }
  const r = Object.assign(Object.assign({}, e), { rules: m3(n) }), a = [], i = Object.keys(r.rules), s = i.length;
  for (let o = 0; o < s; o++) {
    const l = i[o], u = await kb(r, t, {
      name: l,
      params: r.rules[l]
    });
    if (u.error && (a.push(u.error), e.bails))
      return {
        errors: a
      };
  }
  return {
    errors: a
  };
}
function Tb(e) {
  return !!e && e.name === "ValidationError";
}
function g3(e) {
  return {
    __type: "VVTypedSchema",
    async parse(n, r) {
      var a;
      try {
        return {
          output: await e.validate(n, { abortEarly: !1, context: (r == null ? void 0 : r.formData) || {} }),
          errors: []
        };
      } catch (i) {
        if (!Tb(i))
          throw i;
        if (!(!((a = i.inner) === null || a === void 0) && a.length) && i.errors.length)
          return { errors: [{ path: i.path, errors: i.errors }] };
        const s = i.inner.reduce((o, l) => {
          const u = l.path || "";
          return o[u] || (o[u] = { errors: [], path: u }), o[u].errors.push(...l.errors), o;
        }, {});
        return { errors: Object.values(s) };
      }
    }
  };
}
async function Mb(e, t) {
  const r = await (Bt(t.rules) ? t.rules : g3(t.rules)).parse(e, { formData: t.formData }), a = [];
  for (const i of r.errors)
    i.errors.length && a.push(...i.errors);
  return {
    value: r.value,
    errors: a
  };
}
async function kb(e, t, n) {
  const r = db(n.name);
  if (!r)
    throw new Error(`No such validator '${n.name}' exists.`);
  const a = Lb(n.params, e.formData), i = {
    field: e.label || e.name,
    name: e.name,
    label: e.label,
    value: t,
    form: e.formData,
    rule: Object.assign(Object.assign({}, n), { params: a })
  }, s = await r(t, a, i);
  return typeof s == "string" ? {
    error: s
  } : {
    error: s ? void 0 : b3(i)
  };
}
function b3(e) {
  const t = Gr().generateMessage;
  return t ? t(e) : "Field is invalid";
}
function Lb(e, t) {
  const n = (r) => fl(r) ? r(t) : r;
  return Array.isArray(e) ? e.map(n) : Object.keys(e).reduce((r, a) => (r[a] = n(e[a]), r), {});
}
async function Fb(e, t) {
  const r = await (Bt(e) ? e : g3(e)).parse(Le(t), { formData: Le(t) }), a = {}, i = {};
  for (const s of r.errors) {
    const o = s.errors, l = (s.path || "").replace(/\["(\d+)"\]/g, (u, c) => `[${c}]`);
    a[l] = { valid: !o.length, errors: o }, o.length && (i[l] = o[0]);
  }
  return {
    valid: !r.errors.length,
    results: a,
    errors: i,
    values: r.value,
    source: "schema"
  };
}
async function zb(e, t, n) {
  const a = At(e).map(async (u) => {
    var c, d, f;
    const p = (c = n == null ? void 0 : n.names) === null || c === void 0 ? void 0 : c[u], h = await v3(_t(t, u), e[u], {
      name: (p == null ? void 0 : p.name) || u,
      label: p == null ? void 0 : p.label,
      values: t,
      bails: (f = (d = n == null ? void 0 : n.bailsMap) === null || d === void 0 ? void 0 : d[u]) !== null && f !== void 0 ? f : !0
    });
    return Object.assign(Object.assign({}, h), { path: u });
  });
  let i = !0;
  const s = await Promise.all(a), o = {}, l = {};
  for (const u of s)
    o[u.path] = {
      valid: u.valid,
      errors: u.errors
    }, u.valid || (i = !1, l[u.path] = u.errors[0]);
  return {
    valid: i,
    results: o,
    errors: l,
    source: "schema"
  };
}
let Pc = 0;
function Pb(e, t) {
  const { value: n, initialValue: r, setInitialValue: a } = Ib(e, t.modelValue, t.form);
  if (!t.form) {
    let l = function(p) {
      var h;
      "value" in p && (n.value = p.value), "errors" in p && c(p.errors), "touched" in p && (f.touched = (h = p.touched) !== null && h !== void 0 ? h : f.touched), "initialValue" in p && a(p.initialValue);
    };
    const { errors: u, setErrors: c } = Rb(), d = Pc >= Number.MAX_SAFE_INTEGER ? 0 : ++Pc, f = Db(n, r, u, t.schema);
    return {
      id: d,
      path: e,
      value: n,
      initialValue: r,
      meta: f,
      flags: { pendingUnmount: { [d]: !1 }, pendingReset: !1 },
      errors: u,
      setState: l
    };
  }
  const i = t.form.createPathState(e, {
    bails: t.bails,
    label: t.label,
    type: t.type,
    validate: t.validate,
    schema: t.schema
  }), s = P(() => i.errors);
  function o(l) {
    var u, c, d;
    "value" in l && (n.value = l.value), "errors" in l && ((u = t.form) === null || u === void 0 || u.setFieldError(x(e), l.errors)), "touched" in l && ((c = t.form) === null || c === void 0 || c.setFieldTouched(x(e), (d = l.touched) !== null && d !== void 0 ? d : !1)), "initialValue" in l && a(l.initialValue);
  }
  return {
    id: Array.isArray(i.id) ? i.id[i.id.length - 1] : i.id,
    path: e,
    value: n,
    errors: s,
    meta: i,
    initialValue: r,
    flags: i.__flags,
    setState: o
  };
}
function Ib(e, t, n) {
  const r = N(x(t));
  function a() {
    return n ? _t(n.initialValues.value, x(e), x(r)) : x(r);
  }
  function i(u) {
    if (!n) {
      r.value = u;
      return;
    }
    n.setFieldInitialValue(x(e), u, !0);
  }
  const s = P(a);
  if (!n)
    return {
      value: N(a()),
      initialValue: s,
      setInitialValue: i
    };
  const o = Nb(t, n, s, e);
  return n.stageInitialValue(x(e), o, !0), {
    value: P({
      get() {
        return _t(n.values, x(e));
      },
      set(u) {
        n.setFieldValue(x(e), u, !1);
      }
    }),
    initialValue: s,
    setInitialValue: i
  };
}
function Nb(e, t, n, r) {
  return Ht(e) ? x(e) : e !== void 0 ? e : _t(t.values, x(r), x(n));
}
function Db(e, t, n, r) {
  const a = P(() => {
    var s, o, l;
    return (l = (o = (s = ce(r)) === null || s === void 0 ? void 0 : s.describe) === null || o === void 0 ? void 0 : o.call(s).required) !== null && l !== void 0 ? l : !1;
  }), i = Fn({
    touched: !1,
    pending: !1,
    valid: !0,
    required: a,
    validated: !!x(n).length,
    initialValue: P(() => x(t)),
    dirty: P(() => !mt(x(e), x(t)))
  });
  return De(n, (s) => {
    i.valid = !s.length;
  }, {
    immediate: !0,
    flush: "sync"
  }), i;
}
function Rb() {
  const e = N([]);
  return {
    errors: e,
    setErrors: (t) => {
      e.value = hl(t);
    }
  };
}
function Tt(e, t, n) {
  return d3(n == null ? void 0 : n.type) ? Bb(e, t, n) : $3(e, t, n);
}
function $3(e, t, n) {
  const { initialValue: r, validateOnMount: a, bails: i, type: s, checkedValue: o, label: l, validateOnValueUpdate: u, uncheckedValue: c, controlled: d, keepValueOnUnmount: f, syncVModel: p, form: h } = jb(n), m = d ? fu(Ri) : void 0, v = h || m, g = P(() => Hr(ce(e))), b = P(() => {
    if (ce(v == null ? void 0 : v.schema))
      return;
    const ue = x(t);
    return oi(ue) || Bt(ue) || xt(ue) || Array.isArray(ue) ? ue : m3(ue);
  }), $ = !xt(b.value) && Bt(ce(t)), { id: y, value: A, initialValue: E, meta: L, setState: D, errors: ne, flags: I } = Pb(g, {
    modelValue: r,
    form: v,
    bails: i,
    label: l,
    type: s,
    validate: b.value ? O : void 0,
    schema: $ ? t : void 0
  }), B = P(() => ne.value[0]);
  p && Vb({
    value: A,
    prop: p,
    handleChange: _,
    shouldValidate: () => u && !I.pendingReset
  });
  const ae = (ee, ue = !1) => {
    L.touched = !0, ue && Q();
  };
  async function we(ee) {
    var ue, ye;
    if (v != null && v.validateSchema) {
      const { results: $e } = await v.validateSchema(ee);
      return (ue = $e[ce(g)]) !== null && ue !== void 0 ? ue : { valid: !0, errors: [] };
    }
    return b.value ? v3(A.value, b.value, {
      name: ce(g),
      label: ce(l),
      values: (ye = v == null ? void 0 : v.values) !== null && ye !== void 0 ? ye : {},
      bails: i
    }) : { valid: !0, errors: [] };
  }
  const Q = pl(async () => (L.pending = !0, L.validated = !0, we("validated-only")), (ee) => (I.pendingUnmount[ge.id] || (D({ errors: ee.errors }), L.pending = !1, L.valid = ee.valid), ee)), W = pl(async () => we("silent"), (ee) => (L.valid = ee.valid, ee));
  function O(ee) {
    return (ee == null ? void 0 : ee.mode) === "silent" ? W() : Q();
  }
  function _(ee, ue = !0) {
    const ye = li(ee);
    Y(ye, ue);
  }
  Ue(() => {
    if (a)
      return Q();
    (!v || !v.validateSchema) && W();
  });
  function w(ee) {
    L.touched = ee;
  }
  function F(ee) {
    var ue;
    const ye = ee && "value" in ee ? ee.value : E.value;
    D({
      value: Le(ye),
      initialValue: Le(ye),
      touched: (ue = ee == null ? void 0 : ee.touched) !== null && ue !== void 0 ? ue : !1,
      errors: (ee == null ? void 0 : ee.errors) || []
    }), L.pending = !1, L.validated = !1, W();
  }
  const j = Ar();
  function Y(ee, ue = !0) {
    A.value = j && p ? bb(ee, j.props.modelModifiers) : ee, (ue ? Q : W)();
  }
  function ie(ee) {
    D({ errors: Array.isArray(ee) ? ee : [ee] });
  }
  const Ae = P({
    get() {
      return A.value;
    },
    set(ee) {
      Y(ee, u);
    }
  }), ge = {
    id: y,
    name: g,
    label: l,
    value: Ae,
    meta: L,
    errors: ne,
    errorMessage: B,
    type: s,
    checkedValue: o,
    uncheckedValue: c,
    bails: i,
    keepValueOnUnmount: f,
    resetField: F,
    handleReset: () => F(),
    validate: O,
    handleChange: _,
    handleBlur: ae,
    setState: D,
    setTouched: w,
    setErrors: ie,
    setValue: Y
  };
  if (Wn(pb, ge), Ht(t) && typeof x(t) != "function" && De(t, (ee, ue) => {
    mt(ee, ue) || (L.validated ? Q() : W());
  }, {
    deep: !0
  }), !v)
    return ge;
  const Pe = P(() => {
    const ee = b.value;
    return !ee || xt(ee) || oi(ee) || Bt(ee) || Array.isArray(ee) ? {} : Object.keys(ee).reduce((ue, ye) => {
      const $e = Cb(ee[ye]).map((be) => be.__locatorRef).reduce((be, qe) => {
        const He = _t(v.values, qe) || v.values[qe];
        return He !== void 0 && (be[qe] = He), be;
      }, {});
      return Object.assign(ue, $e), ue;
    }, {});
  });
  return De(Pe, (ee, ue) => {
    if (!Object.keys(ee).length)
      return;
    !mt(ee, ue) && (L.validated ? Q() : W());
  }), Oi(() => {
    var ee;
    const ue = (ee = ce(ge.keepValueOnUnmount)) !== null && ee !== void 0 ? ee : ce(v.keepValuesOnUnmount), ye = ce(g);
    if (ue || !v || I.pendingUnmount[ge.id]) {
      v == null || v.removePathState(ye, y);
      return;
    }
    I.pendingUnmount[ge.id] = !0;
    const $e = v.getPathState(ye);
    if (Array.isArray($e == null ? void 0 : $e.id) && ($e != null && $e.multiple) ? $e != null && $e.id.includes(ge.id) : ($e == null ? void 0 : $e.id) === ge.id) {
      if ($e != null && $e.multiple && Array.isArray($e.value)) {
        const qe = $e.value.findIndex((He) => mt(He, ce(ge.checkedValue)));
        if (qe > -1) {
          const He = [...$e.value];
          He.splice(qe, 1), v.setFieldValue(ye, He);
        }
        Array.isArray($e.id) && $e.id.splice($e.id.indexOf(ge.id), 1);
      } else
        v.unsetPathValue(ce(g));
      v.removePathState(ye, y);
    }
  }), ge;
}
function jb(e) {
  const t = () => ({
    initialValue: void 0,
    validateOnMount: !1,
    bails: !0,
    label: void 0,
    validateOnValueUpdate: !0,
    keepValueOnUnmount: void 0,
    syncVModel: !1,
    controlled: !0
  }), n = !!(e != null && e.syncVModel), r = typeof (e == null ? void 0 : e.syncVModel) == "string" ? e.syncVModel : (e == null ? void 0 : e.modelPropName) || "modelValue", a = n && !("initialValue" in (e || {})) ? ml(Ar(), r) : e == null ? void 0 : e.initialValue;
  if (!e)
    return Object.assign(Object.assign({}, t()), { initialValue: a });
  const i = "valueProp" in e ? e.valueProp : e.checkedValue, s = "standalone" in e ? !e.standalone : e.controlled, o = (e == null ? void 0 : e.modelPropName) || (e == null ? void 0 : e.syncVModel) || !1;
  return Object.assign(Object.assign(Object.assign({}, t()), e || {}), {
    initialValue: a,
    controlled: s ?? !0,
    checkedValue: i,
    syncVModel: o
  });
}
function Bb(e, t, n) {
  const r = n != null && n.standalone ? void 0 : fu(Ri), a = n == null ? void 0 : n.checkedValue, i = n == null ? void 0 : n.uncheckedValue;
  function s(o) {
    const l = o.handleChange, u = P(() => {
      const d = ce(o.value), f = ce(a);
      return Array.isArray(d) ? d.findIndex((p) => mt(p, f)) >= 0 : mt(f, d);
    });
    function c(d, f = !0) {
      var p, h;
      if (u.value === ((p = d == null ? void 0 : d.target) === null || p === void 0 ? void 0 : p.checked)) {
        f && o.validate();
        return;
      }
      const m = ce(e), v = r == null ? void 0 : r.getPathState(m), g = li(d);
      let b = (h = ce(a)) !== null && h !== void 0 ? h : g;
      r && (v != null && v.multiple) && v.type === "checkbox" ? b = Lc(_t(r.values, m) || [], b, void 0) : (n == null ? void 0 : n.type) === "checkbox" && (b = Lc(ce(o.value), b, ce(i))), l(b, f);
    }
    return Object.assign(Object.assign({}, o), {
      checked: u,
      checkedValue: a,
      uncheckedValue: i,
      handleChange: c
    });
  }
  return s($3(e, t, n));
}
function Vb({ prop: e, value: t, handleChange: n, shouldValidate: r }) {
  const a = Ar();
  if (!a || !e)
    return;
  const i = typeof e == "string" ? e : "modelValue", s = `update:${i}`;
  i in a.props && (De(t, (o) => {
    mt(o, ml(a, i)) || a.emit(s, o);
  }), De(() => ml(a, i), (o) => {
    if (o === Oc && t.value === void 0)
      return;
    const l = o === Oc ? void 0 : o;
    mt(l, t.value) || n(l, r());
  }));
}
function ml(e, t) {
  if (e)
    return e.props[t];
}
let Ub = 0;
const Ca = ["bails", "fieldsCount", "id", "multiple", "type", "validate"];
function y3(e) {
  const t = (e == null ? void 0 : e.initialValues) || {}, n = Object.assign({}, ce(t)), r = x(e == null ? void 0 : e.validationSchema);
  return r && Bt(r) && xt(r.cast) ? Le(r.cast(n) || {}) : Le(n);
}
function Hb(e) {
  var t;
  const n = Ub++, r = (e == null ? void 0 : e.name) || "Form";
  let a = 0;
  const i = N(!1), s = N(!1), o = N(0), l = [], u = Fn(y3(e)), c = N([]), d = N({}), f = N({}), p = $b(() => {
    f.value = c.value.reduce((k, M) => (k[Hr(ce(M.path))] = M, k), {});
  });
  function h(k, M) {
    const R = _(k);
    if (!R) {
      typeof k == "string" && (d.value[Hr(k)] = hl(M));
      return;
    }
    if (typeof k == "string") {
      const J = Hr(k);
      d.value[J] && delete d.value[J];
    }
    R.errors = hl(M), R.valid = !R.errors.length;
  }
  function m(k) {
    At(k).forEach((M) => {
      h(M, k[M]);
    });
  }
  e != null && e.initialErrors && m(e.initialErrors);
  const v = P(() => {
    const k = c.value.reduce((M, R) => (R.errors.length && (M[ce(R.path)] = R.errors), M), {});
    return Object.assign(Object.assign({}, d.value), k);
  }), g = P(() => At(v.value).reduce((k, M) => {
    const R = v.value[M];
    return R != null && R.length && (k[M] = R[0]), k;
  }, {})), b = P(() => c.value.reduce((k, M) => (k[ce(M.path)] = { name: ce(M.path) || "", label: M.label || "" }, k), {})), $ = P(() => c.value.reduce((k, M) => {
    var R;
    return k[ce(M.path)] = (R = M.bails) !== null && R !== void 0 ? R : !0, k;
  }, {})), y = Object.assign({}, (e == null ? void 0 : e.initialErrors) || {}), A = (t = e == null ? void 0 : e.keepValuesOnUnmount) !== null && t !== void 0 ? t : !1, { initialValues: E, originalInitialValues: L, setInitialValues: D } = qb(c, u, e), ne = Gb(c, u, L, g), I = P(() => c.value.reduce((k, M) => {
    const R = _t(u, ce(M.path));
    return cn(k, ce(M.path), R), k;
  }, {})), B = e == null ? void 0 : e.validationSchema;
  function ae(k, M) {
    var R, J;
    const me = P(() => _t(E.value, ce(k))), xe = f.value[ce(k)], he = (M == null ? void 0 : M.type) === "checkbox" || (M == null ? void 0 : M.type) === "radio";
    if (xe && he) {
      xe.multiple = !0;
      const kt = a++;
      return Array.isArray(xe.id) ? xe.id.push(kt) : xe.id = [xe.id, kt], xe.fieldsCount++, xe.__flags.pendingUnmount[kt] = !1, xe;
    }
    const Ge = P(() => _t(u, ce(k))), Xe = ce(k), st = F.findIndex((kt) => kt === Xe);
    st !== -1 && F.splice(st, 1);
    const Re = P(() => {
      var kt, Rr, as, is;
      const ss = ce(B);
      if (Bt(ss))
        return (Rr = (kt = ss.describe) === null || kt === void 0 ? void 0 : kt.call(ss, ce(k)).required) !== null && Rr !== void 0 ? Rr : !1;
      const os = ce(M == null ? void 0 : M.schema);
      return Bt(os) && (is = (as = os.describe) === null || as === void 0 ? void 0 : as.call(os).required) !== null && is !== void 0 ? is : !1;
    }), ot = a++, bt = Fn({
      id: ot,
      path: k,
      touched: !1,
      pending: !1,
      valid: !0,
      validated: !!(!((R = y[Xe]) === null || R === void 0) && R.length),
      required: Re,
      initialValue: me,
      errors: Wp([]),
      bails: (J = M == null ? void 0 : M.bails) !== null && J !== void 0 ? J : !1,
      label: M == null ? void 0 : M.label,
      type: (M == null ? void 0 : M.type) || "default",
      value: Ge,
      multiple: !1,
      __flags: {
        pendingUnmount: { [ot]: !1 },
        pendingReset: !1
      },
      fieldsCount: 1,
      validate: M == null ? void 0 : M.validate,
      dirty: P(() => !mt(x(Ge), x(me)))
    });
    return c.value.push(bt), f.value[Xe] = bt, p(), g.value[Xe] && !y[Xe] && We(() => {
      V(Xe, { mode: "silent" });
    }), Ht(k) && De(k, (kt) => {
      p();
      const Rr = Le(Ge.value);
      f.value[kt] = bt, We(() => {
        cn(u, kt, Rr);
      });
    }), bt;
  }
  const we = Fc(gt, 5), Q = Fc(gt, 5), W = pl(async (k) => await (k === "silent" ? we() : Q()), (k, [M]) => {
    const R = At(ue.errorBag.value), me = [
      .../* @__PURE__ */ new Set([...At(k.results), ...c.value.map((xe) => xe.path), ...R])
    ].sort().reduce((xe, he) => {
      var Ge;
      const Xe = he, st = _(Xe) || w(Xe), Re = ((Ge = k.results[Xe]) === null || Ge === void 0 ? void 0 : Ge.errors) || [], ot = ce(st == null ? void 0 : st.path) || Xe, bt = Wb({ errors: Re, valid: !Re.length }, xe.results[ot]);
      return xe.results[ot] = bt, bt.valid || (xe.errors[ot] = bt.errors[0]), st && d.value[ot] && delete d.value[ot], st ? (st.valid = bt.valid, M === "silent" || M === "validated-only" && !st.validated || h(st, bt.errors), xe) : (h(ot, Re), xe);
    }, {
      valid: k.valid,
      results: {},
      errors: {},
      source: k.source
    });
    return k.values && (me.values = k.values, me.source = k.source), At(me.results).forEach((xe) => {
      var he;
      const Ge = _(xe);
      Ge && M !== "silent" && (M === "validated-only" && !Ge.validated || h(Ge, (he = me.results[xe]) === null || he === void 0 ? void 0 : he.errors));
    }), me;
  });
  function O(k) {
    c.value.forEach(k);
  }
  function _(k) {
    const M = typeof k == "string" ? Hr(k) : k;
    return typeof M == "string" ? f.value[M] : M;
  }
  function w(k) {
    return c.value.filter((R) => k.startsWith(ce(R.path))).reduce((R, J) => R ? J.path.length > R.path.length ? J : R : J, void 0);
  }
  let F = [], j;
  function Y(k) {
    return F.push(k), j || (j = We(() => {
      [...F].sort().reverse().forEach((R) => {
        kc(u, R);
      }), F = [], j = null;
    })), j;
  }
  function ie(k) {
    return function(R, J) {
      return function(xe) {
        return xe instanceof Event && (xe.preventDefault(), xe.stopPropagation()), O((he) => he.touched = !0), i.value = !0, o.value++, pt().then((he) => {
          const Ge = Le(u);
          if (he.valid && typeof R == "function") {
            const Xe = Le(I.value);
            let st = k ? Xe : Ge;
            return he.values && (st = he.source === "schema" ? he.values : Object.assign({}, st, he.values)), R(st, {
              evt: xe,
              controlledValues: Xe,
              setErrors: m,
              setFieldError: h,
              setTouched: It,
              setFieldTouched: He,
              setValues: be,
              setFieldValue: ye,
              resetForm: Mt,
              resetField: Ee
            });
          }
          !he.valid && typeof J == "function" && J({
            values: Ge,
            evt: xe,
            errors: he.errors,
            results: he.results
          });
        }).then((he) => (i.value = !1, he), (he) => {
          throw i.value = !1, he;
        });
      };
    };
  }
  const ge = ie(!1);
  ge.withControlled = ie(!0);
  function Pe(k, M) {
    const R = c.value.findIndex((me) => me.path === k && (Array.isArray(me.id) ? me.id.includes(M) : me.id === M)), J = c.value[R];
    if (!(R === -1 || !J)) {
      if (We(() => {
        V(k, { mode: "silent", warn: !1 });
      }), J.multiple && J.fieldsCount && J.fieldsCount--, Array.isArray(J.id)) {
        const me = J.id.indexOf(M);
        me >= 0 && J.id.splice(me, 1), delete J.__flags.pendingUnmount[M];
      }
      (!J.multiple || J.fieldsCount <= 0) && (c.value.splice(R, 1), X(k), p(), delete f.value[k]);
    }
  }
  function ee(k) {
    At(f.value).forEach((M) => {
      M.startsWith(k) && delete f.value[M];
    }), c.value = c.value.filter((M) => !M.path.startsWith(k)), We(() => {
      p();
    });
  }
  const ue = {
    name: r,
    formId: n,
    values: u,
    controlledValues: I,
    errorBag: v,
    errors: g,
    schema: B,
    submitCount: o,
    meta: ne,
    isSubmitting: i,
    isValidating: s,
    fieldArrays: l,
    keepValuesOnUnmount: A,
    validateSchema: x(B) ? W : void 0,
    validate: pt,
    setFieldError: h,
    validateField: V,
    setFieldValue: ye,
    setValues: be,
    setErrors: m,
    setFieldTouched: He,
    setTouched: It,
    resetForm: Mt,
    resetField: Ee,
    handleSubmit: ge,
    useFieldModel: ln,
    defineInputBinds: Zt,
    defineComponentBinds: or,
    defineField: Bn,
    stageInitialValue: Z,
    unsetInitialValue: X,
    setFieldInitialValue: _e,
    createPathState: ae,
    getPathState: _,
    unsetPathValue: Y,
    removePathState: Pe,
    initialValues: E,
    getAllPathStates: () => c.value,
    destroyPath: ee,
    isFieldTouched: Kt,
    isFieldDirty: it,
    isFieldValid: ke
  };
  function ye(k, M, R = !0) {
    const J = Le(M), me = typeof k == "string" ? k : k.path;
    _(me) || ae(me), cn(u, me, J), R && V(me);
  }
  function $e(k, M = !0) {
    At(u).forEach((R) => {
      delete u[R];
    }), At(k).forEach((R) => {
      ye(R, k[R], !1);
    }), M && pt();
  }
  function be(k, M = !0) {
    aa(u, k), l.forEach((R) => R && R.reset()), M && pt();
  }
  function qe(k, M) {
    const R = _(ce(k)) || ae(k);
    return P({
      get() {
        return R.value;
      },
      set(J) {
        var me;
        const xe = ce(k);
        ye(xe, J, (me = ce(M)) !== null && me !== void 0 ? me : !1);
      }
    });
  }
  function He(k, M) {
    const R = _(k);
    R && (R.touched = M);
  }
  function Kt(k) {
    const M = _(k);
    return M ? M.touched : c.value.filter((R) => R.path.startsWith(k)).some((R) => R.touched);
  }
  function it(k) {
    const M = _(k);
    return M ? M.dirty : c.value.filter((R) => R.path.startsWith(k)).some((R) => R.dirty);
  }
  function ke(k) {
    const M = _(k);
    return M ? M.valid : c.value.filter((R) => R.path.startsWith(k)).every((R) => R.valid);
  }
  function It(k) {
    if (typeof k == "boolean") {
      O((M) => {
        M.touched = k;
      });
      return;
    }
    At(k).forEach((M) => {
      He(M, !!k[M]);
    });
  }
  function Ee(k, M) {
    var R;
    const J = M && "value" in M ? M.value : _t(E.value, k), me = _(k);
    me && (me.__flags.pendingReset = !0), _e(k, Le(J), !0), ye(k, J, !1), He(k, (R = M == null ? void 0 : M.touched) !== null && R !== void 0 ? R : !1), h(k, (M == null ? void 0 : M.errors) || []), We(() => {
      me && (me.__flags.pendingReset = !1);
    });
  }
  function Mt(k, M) {
    let R = Le(k != null && k.values ? k.values : L.value);
    R = M != null && M.force ? R : aa(L.value, R), R = Bt(B) && xt(B.cast) ? B.cast(R) : R, D(R, { force: M == null ? void 0 : M.force }), O((J) => {
      var me;
      J.__flags.pendingReset = !0, J.validated = !1, J.touched = ((me = k == null ? void 0 : k.touched) === null || me === void 0 ? void 0 : me[ce(J.path)]) || !1, ye(ce(J.path), _t(R, ce(J.path)), !1), h(ce(J.path), void 0);
    }), M != null && M.force ? $e(R, !1) : be(R, !1), m((k == null ? void 0 : k.errors) || {}), o.value = (k == null ? void 0 : k.submitCount) || 0, We(() => {
      pt({ mode: "silent" }), O((J) => {
        J.__flags.pendingReset = !1;
      });
    });
  }
  async function pt(k) {
    const M = (k == null ? void 0 : k.mode) || "force";
    if (M === "force" && O((he) => he.validated = !0), ue.validateSchema)
      return ue.validateSchema(M);
    s.value = !0;
    const R = await Promise.all(c.value.map((he) => he.validate ? he.validate(k).then((Ge) => ({
      key: ce(he.path),
      valid: Ge.valid,
      errors: Ge.errors,
      value: Ge.value
    })) : Promise.resolve({
      key: ce(he.path),
      valid: !0,
      errors: [],
      value: void 0
    })));
    s.value = !1;
    const J = {}, me = {}, xe = {};
    for (const he of R)
      J[he.key] = {
        valid: he.valid,
        errors: he.errors
      }, he.value && cn(xe, he.key, he.value), he.errors.length && (me[he.key] = he.errors[0]);
    return {
      valid: R.every((he) => he.valid),
      results: J,
      errors: me,
      values: xe,
      source: "fields"
    };
  }
  async function V(k, M) {
    var R;
    const J = _(k);
    if (J && (M == null ? void 0 : M.mode) !== "silent" && (J.validated = !0), B) {
      const { results: me } = await W((M == null ? void 0 : M.mode) || "validated-only");
      return me[k] || { errors: [], valid: !0 };
    }
    return J != null && J.validate ? J.validate(M) : (!J && (R = M == null ? void 0 : M.warn), Promise.resolve({ errors: [], valid: !0 }));
  }
  function X(k) {
    kc(E.value, k);
  }
  function Z(k, M, R = !1) {
    _e(k, M), cn(u, k, M), R && !(e != null && e.initialValues) && cn(L.value, k, Le(M));
  }
  function _e(k, M, R = !1) {
    cn(E.value, k, Le(M)), R && cn(L.value, k, Le(M));
  }
  async function gt() {
    const k = x(B);
    if (!k)
      return { valid: !0, results: {}, errors: {}, source: "none" };
    s.value = !0;
    const M = oi(k) || Bt(k) ? await Fb(k, u) : await zb(k, u, {
      names: b.value,
      bailsMap: $.value
    });
    return s.value = !1, M;
  }
  const wn = ge((k, { evt: M }) => {
    p3(M) && M.target.submit();
  });
  Ue(() => {
    if (e != null && e.initialErrors && m(e.initialErrors), e != null && e.initialTouched && It(e.initialTouched), e != null && e.validateOnMount) {
      pt();
      return;
    }
    ue.validateSchema && ue.validateSchema("silent");
  }), Ht(B) && De(B, () => {
    var k;
    (k = ue.validateSchema) === null || k === void 0 || k.call(ue, "validated-only");
  }), Wn(Ri, ue);
  function Bn(k, M) {
    const R = xt(M) || M == null ? void 0 : M.label, J = _(ce(k)) || ae(k, { label: R }), me = () => xt(M) ? M(Sa(J, Ca)) : M || {};
    function xe() {
      var Re;
      J.touched = !0, ((Re = me().validateOnBlur) !== null && Re !== void 0 ? Re : Gr().validateOnBlur) && V(ce(J.path));
    }
    function he() {
      var Re;
      ((Re = me().validateOnInput) !== null && Re !== void 0 ? Re : Gr().validateOnInput) && We(() => {
        V(ce(J.path));
      });
    }
    function Ge() {
      var Re;
      ((Re = me().validateOnChange) !== null && Re !== void 0 ? Re : Gr().validateOnChange) && We(() => {
        V(ce(J.path));
      });
    }
    const Xe = P(() => {
      const Re = {
        onChange: Ge,
        onInput: he,
        onBlur: xe
      };
      return xt(M) ? Object.assign(Object.assign({}, Re), M(Sa(J, Ca)).props || {}) : M != null && M.props ? Object.assign(Object.assign({}, Re), M.props(Sa(J, Ca))) : Re;
    });
    return [qe(k, () => {
      var Re, ot, bt;
      return (bt = (Re = me().validateOnModelUpdate) !== null && Re !== void 0 ? Re : (ot = Gr()) === null || ot === void 0 ? void 0 : ot.validateOnModelUpdate) !== null && bt !== void 0 ? bt : !0;
    }), Xe];
  }
  function ln(k) {
    return Array.isArray(k) ? k.map((M) => qe(M, !0)) : qe(k);
  }
  function Zt(k, M) {
    const [R, J] = Bn(k, M);
    function me() {
      J.value.onBlur();
    }
    function xe(Ge) {
      const Xe = li(Ge);
      ye(ce(k), Xe, !1), J.value.onInput();
    }
    function he(Ge) {
      const Xe = li(Ge);
      ye(ce(k), Xe, !1), J.value.onChange();
    }
    return P(() => Object.assign(Object.assign({}, J.value), {
      onBlur: me,
      onInput: xe,
      onChange: he,
      value: R.value
    }));
  }
  function or(k, M) {
    const [R, J] = Bn(k, M), me = _(ce(k));
    function xe(he) {
      R.value = he;
    }
    return P(() => {
      const he = xt(M) ? M(Sa(me, Ca)) : M || {};
      return Object.assign({ [he.model || "modelValue"]: R.value, [`onUpdate:${he.model || "modelValue"}`]: xe }, J.value);
    });
  }
  const un = Object.assign(Object.assign({}, ue), { values: qp(u), handleReset: () => Mt(), submitForm: wn });
  return Wn(fb, un), un;
}
function Gb(e, t, n, r) {
  const a = {
    touched: "some",
    pending: "some",
    valid: "every"
  }, i = P(() => !mt(t, x(n)));
  function s() {
    const l = e.value;
    return At(a).reduce((u, c) => {
      const d = a[c];
      return u[c] = l[d]((f) => f[c]), u;
    }, {});
  }
  const o = Fn(s());
  return Er(() => {
    const l = s();
    o.touched = l.touched, o.valid = l.valid, o.pending = l.pending;
  }), P(() => Object.assign(Object.assign({ initialValues: x(n) }, o), { valid: o.valid && !At(r.value).length, dirty: i.value }));
}
function qb(e, t, n) {
  const r = y3(n), a = N(r), i = N(Le(r));
  function s(o, l) {
    l != null && l.force ? (a.value = Le(o), i.value = Le(o)) : (a.value = aa(Le(a.value) || {}, Le(o)), i.value = aa(Le(i.value) || {}, Le(o))), l != null && l.updateFields && e.value.forEach((u) => {
      if (u.touched)
        return;
      const d = _t(a.value, ce(u.path));
      cn(t, ce(u.path), Le(d));
    });
  }
  return {
    initialValues: a,
    originalInitialValues: i,
    setInitialValues: s
  };
}
function Wb(e, t) {
  return t ? {
    valid: e.valid && t.valid,
    errors: [...e.errors, ...t.errors]
  } : e;
}
const Yb = /* @__PURE__ */ re({
  name: "Form",
  inheritAttrs: !1,
  props: {
    as: {
      type: null,
      default: "form"
    },
    validationSchema: {
      type: Object,
      default: void 0
    },
    initialValues: {
      type: Object,
      default: void 0
    },
    initialErrors: {
      type: Object,
      default: void 0
    },
    initialTouched: {
      type: Object,
      default: void 0
    },
    validateOnMount: {
      type: Boolean,
      default: !1
    },
    onSubmit: {
      type: Function,
      default: void 0
    },
    onInvalidSubmit: {
      type: Function,
      default: void 0
    },
    keepValues: {
      type: Boolean,
      default: !1
    },
    name: {
      type: String,
      default: "Form"
    }
  },
  setup(e, t) {
    const n = r1(e, "validationSchema"), r = r1(e, "keepValues"), { errors: a, errorBag: i, values: s, meta: o, isSubmitting: l, isValidating: u, submitCount: c, controlledValues: d, validate: f, validateField: p, handleReset: h, resetForm: m, handleSubmit: v, setErrors: g, setFieldError: b, setFieldValue: $, setValues: y, setFieldTouched: A, setTouched: E, resetField: L } = Hb({
      validationSchema: n.value ? n : void 0,
      initialValues: e.initialValues,
      initialErrors: e.initialErrors,
      initialTouched: e.initialTouched,
      validateOnMount: e.validateOnMount,
      keepValuesOnUnmount: r,
      name: e.name
    }), D = v((O, { evt: _ }) => {
      p3(_) && _.target.submit();
    }, e.onInvalidSubmit), ne = e.onSubmit ? v(e.onSubmit, e.onInvalidSubmit) : D;
    function I(O) {
      cu(O) && O.preventDefault(), h(), typeof t.attrs.onReset == "function" && t.attrs.onReset();
    }
    function B(O, _) {
      return v(typeof O == "function" && !_ ? O : _, e.onInvalidSubmit)(O);
    }
    function ae() {
      return Le(s);
    }
    function we() {
      return Le(o.value);
    }
    function Q() {
      return Le(a.value);
    }
    function W() {
      return {
        meta: o.value,
        errors: a.value,
        errorBag: i.value,
        values: s,
        isSubmitting: l.value,
        isValidating: u.value,
        submitCount: c.value,
        controlledValues: d.value,
        validate: f,
        validateField: p,
        handleSubmit: B,
        handleReset: h,
        submitForm: D,
        setErrors: g,
        setFieldError: b,
        setFieldValue: $,
        setValues: y,
        setFieldTouched: A,
        setTouched: E,
        resetForm: m,
        resetField: L,
        getValues: ae,
        getMeta: we,
        getErrors: Q
      };
    }
    return t.expose({
      setFieldError: b,
      setErrors: g,
      setFieldValue: $,
      setValues: y,
      setFieldTouched: A,
      setTouched: E,
      resetForm: m,
      validate: f,
      validateField: p,
      resetField: L,
      getValues: ae,
      getMeta: we,
      getErrors: Q,
      values: s,
      meta: o,
      errors: a
    }), function() {
      const _ = e.as === "form" ? e.as : e.as ? rf(e.as) : null, w = yb(_, t, W);
      return _ ? et(_, Object.assign(Object.assign(Object.assign({}, _ === "form" ? {
        // Disables native validation as vee-validate will handle it.
        novalidate: !0
      } : {}), t.attrs), { onSubmit: ne, onReset: I }), w) : w;
    };
  }
}), Kb = Yb;
function Zb() {
  const e = fu(Ri);
  return P(() => (e == null ? void 0 : e.errors.value) || {});
}
var Ic;
const x3 = typeof window < "u", Xb = (e) => typeof e == "string", _3 = () => {
}, Jb = x3 && ((Ic = window == null ? void 0 : window.navigator) == null ? void 0 : Ic.userAgent) && /iP(ad|hone|od)/.test(window.navigator.userAgent);
function w3(e) {
  return typeof e == "function" ? e() : x(e);
}
function Qb(e) {
  return e;
}
function S3(e) {
  return Yp() ? (Kp(e), !0) : !1;
}
function C3(e, t = !0) {
  Ar() ? Ue(e) : t ? e() : We(e);
}
function On(e) {
  var t;
  const n = w3(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
const pu = x3 ? window : void 0;
function kn(...e) {
  let t, n, r, a;
  if (Xb(e[0]) || Array.isArray(e[0]) ? ([n, r, a] = e, t = pu) : [t, n, r, a] = e, !t)
    return _3;
  Array.isArray(n) || (n = [n]), Array.isArray(r) || (r = [r]);
  const i = [], s = () => {
    i.forEach((c) => c()), i.length = 0;
  }, o = (c, d, f, p) => (c.addEventListener(d, f, p), () => c.removeEventListener(d, f, p)), l = De(() => [On(t), w3(a)], ([c, d]) => {
    s(), c && i.push(...n.flatMap((f) => r.map((p) => o(c, f, p, d))));
  }, { immediate: !0, flush: "post" }), u = () => {
    l(), s();
  };
  return S3(u), u;
}
let Nc = !1;
function A3(e, t, n = {}) {
  const { window: r = pu, ignore: a = [], capture: i = !0, detectIframe: s = !1 } = n;
  if (!r)
    return;
  Jb && !Nc && (Nc = !0, Array.from(r.document.body.children).forEach((f) => f.addEventListener("click", _3)));
  let o = !0;
  const l = (f) => a.some((p) => {
    if (typeof p == "string")
      return Array.from(r.document.querySelectorAll(p)).some((h) => h === f.target || f.composedPath().includes(h));
    {
      const h = On(p);
      return h && (f.target === h || f.composedPath().includes(h));
    }
  }), c = [
    kn(r, "click", (f) => {
      const p = On(e);
      if (!(!p || p === f.target || f.composedPath().includes(p))) {
        if (f.detail === 0 && (o = !l(f)), !o) {
          o = !0;
          return;
        }
        t(f);
      }
    }, { passive: !0, capture: i }),
    kn(r, "pointerdown", (f) => {
      const p = On(e);
      p && (o = !f.composedPath().includes(p) && !l(f));
    }, { passive: !0 }),
    s && kn(r, "blur", (f) => {
      var p;
      const h = On(e);
      ((p = r.document.activeElement) == null ? void 0 : p.tagName) === "IFRAME" && !(h != null && h.contains(r.document.activeElement)) && t(f);
    })
  ].filter(Boolean);
  return () => c.forEach((f) => f());
}
function e$(e, t = !1) {
  const n = N(), r = () => n.value = !!e();
  return r(), C3(r, t), n;
}
const Dc = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Rc = "__vueuse_ssr_handlers__";
Dc[Rc] = Dc[Rc] || {};
var jc = Object.getOwnPropertySymbols, t$ = Object.prototype.hasOwnProperty, n$ = Object.prototype.propertyIsEnumerable, r$ = (e, t) => {
  var n = {};
  for (var r in e)
    t$.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && jc)
    for (var r of jc(e))
      t.indexOf(r) < 0 && n$.call(e, r) && (n[r] = e[r]);
  return n;
};
function a$(e, t, n = {}) {
  const r = n, { window: a = pu } = r, i = r$(r, ["window"]);
  let s;
  const o = e$(() => a && "ResizeObserver" in a), l = () => {
    s && (s.disconnect(), s = void 0);
  }, u = De(() => On(e), (d) => {
    l(), o.value && a && d && (s = new ResizeObserver(t), s.observe(d, i));
  }, { immediate: !0, flush: "post" }), c = () => {
    l(), u();
  };
  return S3(c), {
    isSupported: o,
    stop: c
  };
}
function i$(e, t = {}) {
  const {
    reset: n = !0,
    windowResize: r = !0,
    windowScroll: a = !0,
    immediate: i = !0
  } = t, s = N(0), o = N(0), l = N(0), u = N(0), c = N(0), d = N(0), f = N(0), p = N(0);
  function h() {
    const m = On(e);
    if (!m) {
      n && (s.value = 0, o.value = 0, l.value = 0, u.value = 0, c.value = 0, d.value = 0, f.value = 0, p.value = 0);
      return;
    }
    const v = m.getBoundingClientRect();
    s.value = v.height, o.value = v.bottom, l.value = v.left, u.value = v.right, c.value = v.top, d.value = v.width, f.value = v.x, p.value = v.y;
  }
  return a$(e, h), De(() => On(e), (m) => !m && h()), a && kn("scroll", h, { capture: !0, passive: !0 }), r && kn("resize", h, { passive: !0 }), C3(() => {
    i && h();
  }), {
    height: s,
    bottom: o,
    left: l,
    right: u,
    top: c,
    width: d,
    x: f,
    y: p,
    update: h
  };
}
var Bc;
(function(e) {
  e.UP = "UP", e.RIGHT = "RIGHT", e.DOWN = "DOWN", e.LEFT = "LEFT", e.NONE = "NONE";
})(Bc || (Bc = {}));
var s$ = Object.defineProperty, Vc = Object.getOwnPropertySymbols, o$ = Object.prototype.hasOwnProperty, l$ = Object.prototype.propertyIsEnumerable, Uc = (e, t, n) => t in e ? s$(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, u$ = (e, t) => {
  for (var n in t || (t = {}))
    o$.call(t, n) && Uc(e, n, t[n]);
  if (Vc)
    for (var n of Vc(t))
      l$.call(t, n) && Uc(e, n, t[n]);
  return e;
};
const c$ = {
  easeInSine: [0.12, 0, 0.39, 0],
  easeOutSine: [0.61, 1, 0.88, 1],
  easeInOutSine: [0.37, 0, 0.63, 1],
  easeInQuad: [0.11, 0, 0.5, 0],
  easeOutQuad: [0.5, 1, 0.89, 1],
  easeInOutQuad: [0.45, 0, 0.55, 1],
  easeInCubic: [0.32, 0, 0.67, 0],
  easeOutCubic: [0.33, 1, 0.68, 1],
  easeInOutCubic: [0.65, 0, 0.35, 1],
  easeInQuart: [0.5, 0, 0.75, 0],
  easeOutQuart: [0.25, 1, 0.5, 1],
  easeInOutQuart: [0.76, 0, 0.24, 1],
  easeInQuint: [0.64, 0, 0.78, 0],
  easeOutQuint: [0.22, 1, 0.36, 1],
  easeInOutQuint: [0.83, 0, 0.17, 1],
  easeInExpo: [0.7, 0, 0.84, 0],
  easeOutExpo: [0.16, 1, 0.3, 1],
  easeInOutExpo: [0.87, 0, 0.13, 1],
  easeInCirc: [0.55, 0, 1, 0.45],
  easeOutCirc: [0, 0.55, 0.45, 1],
  easeInOutCirc: [0.85, 0, 0.15, 1],
  easeInBack: [0.36, 0, 0.66, -0.56],
  easeOutBack: [0.34, 1.56, 0.64, 1],
  easeInOutBack: [0.68, -0.6, 0.32, 1.6]
};
u$({
  linear: Qb
}, c$);
const d$ = { class: "overflow-visible relative flex flex-col gap-0.5" }, f$ = ["for"], p$ = { class: "relative" }, h$ = ["id", "data-test-id", "name", "min", "max", "autocomplete", "disabled"], m$ = ["textContent"], v$ = { class: "flex w-full items-center justify-between relative gap-x-2" }, g$ = { class: "flex gap-x-px items-center justify-between text-center flex-1" }, b$ = ["disabled"], $$ = {
  key: 1,
  class: "font-semibold p-1 capitalize"
}, y$ = ["disabled"], x$ = {
  key: 0,
  class: "flex gap-x-px items-center"
}, _$ = ["disabled"], w$ = ["disabled"], S$ = { class: "grid grid-flow-row grid-cols-7 min-w-[245px] sm:min-w-[266px]" }, C$ = ["textContent"], A$ = ["onClick"], E$ = ["data-test-id", "disabled", "data-disabled", "onClick"], O$ = ["textContent"], T$ = ["onClick"], M$ = {
  key: 0,
  class: "absolute inset-0 bg-white p-3 rounded-xl flex flex-col flex-nowrap gap-4"
}, k$ = { class: "w-full flex items-center justify-between gap-4" }, L$ = { class: "flex gap-x-2 items-center" }, F$ = ["disabled", "data-test-id", "onClick"], z$ = {
  key: 1,
  class: "absolute inset-0 bg-white p-3 rounded-xl flex flex-col flex-nowrap gap-4"
}, P$ = { class: "w-full flex items-center justify-end" }, I$ = { class: "grid grid-flow-col grid-rows-4 grid-cols-3 flex-1" }, N$ = ["data-test-id", "onClick"], E3 = /* @__PURE__ */ re({
  __name: "DatePicker",
  props: {
    name: {},
    modelValue: {},
    minDate: { default: void 0 },
    maxDate: { default: void 0 },
    availableDates: { default: void 0 },
    required: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    inline: { type: Boolean, default: !0 },
    label: { default: "" },
    autocomplete: { default: "off" },
    placeholder: { default: "DD-MM-YYYY" },
    endOfDayHour: { default: 17 },
    endOfDayMinutes: { default: 15 },
    isOnlyWorkDays: { type: Boolean, default: !0 },
    hideCalendar: { type: Boolean, default: !1 },
    allowYearNavigation: { type: Boolean, default: !1 },
    displayFormat: { default: "DD-MM-YYYY" },
    emitFormat: { default: "YYYY-MM-DD" },
    locale: { default: "nl" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, r = t;
    G.extend(Pi);
    const a = tu, i = (V) => {
      if (!V) return "";
      const [X, Z, _e] = V.split("-");
      return (_e == null ? void 0 : _e.length) === 4 ? `${_e}-${Z}-${X}` : V;
    }, {
      errorMessage: s,
      value: o,
      meta: l,
      validate: u,
      setValue: c,
      handleChange: d
    } = Tt(n.name, void 0, {
      initialValue: G(i(n.modelValue)).isValid() ? G(i(n.modelValue)).format(n.displayFormat) : ""
    }), f = N(!1), p = G().utcOffset(nu), h = N(p.month()), m = N(p.year()), v = N(p.date()), g = N(p.year()), b = N(1), $ = N([1]), y = N(1), A = N(), E = N(!1), L = N(!1), D = [
      "bg-transparent text-blue-700 disabled:!text-blue-200 w-6 h-6",
      "rounded-full border-none hover:bg-blue-50 focus:shadow-active"
    ], ne = P(() => Array.from(Array.from({ length: 7 }).keys()).map((V) => G().day(V + 1).format("dd"))), I = P(() => {
      const V = m.value % 19, X = Math.floor(m.value / 100), Z = m.value % 100, _e = Math.floor(X / 4), gt = X % 4, wn = Math.floor((X + 8) / 25), Bn = Math.floor((X - wn + 1) / 3), ln = (19 * V + X - _e - Bn + 15) % 30, Zt = Math.floor(Z / 4), or = Z % 4, un = (32 + 2 * gt + 2 * Zt - ln - or) % 7, k = Math.floor((V + 11 * ln + 22 * un) / 451), M = Math.floor((ln + un - 7 * k + 114) / 31), R = (ln + un - 7 * k + 114) % 31;
      return new Date(m.value, M - 1, R + 1);
    }), B = (V) => {
      switch (V) {
        default:
          return 50;
        case "easter-monday":
          return 1;
        case "ascension-day":
          return 39;
        case "pentecost-sunday":
          return 49;
      }
    }, ae = (V) => G(new Date(
      I.value.getFullYear(),
      I.value.getMonth(),
      I.value.getDate() + B(V)
    )).format("YYYY-M-D"), we = P(() => {
      const V = m.value - 1945;
      return V % 5 === 0 && V / 5 % 5 === 0 ? m.value : Math.ceil(m.value / 5) * 5;
    }), Q = P(() => Array.from(Array.from({ length: 12 }).keys()).map((V) => G().month(V).format("MMMM"))), W = P(() => [
      `${m.value}-1-1`,
      // New Year's Day
      ae("easter-monday"),
      // Easter Monday
      `${m.value}-4-27`,
      // King's Day
      `${we.value}-5-05`,
      // Liberation Day
      ae("ascension-day"),
      // Ascension Day
      ae(""),
      // Whit Monday & pentecost sunday
      ae("pentecost-sunday"),
      // Pentecost Sunday
      `${m.value}-12-25`,
      // Christmas Day
      `${m.value}-12-26`
      // Boxing Day
    ]), O = P(() => i(o.value)), _ = (V) => G(V).isBefore(G(), "day"), w = () => {
      b.value = G(`${m.value}-${h.value + 1}-01`).daysInMonth();
      const V = (G(`${m.value}-${h.value + 1}-01`).day() + 6) % 7, X = G(`${m.value}-${h.value}-01`).daysInMonth(), Z = [];
      for (let gt = 0; gt < V; gt++)
        Z.push(X - V + gt + 1);
      $.value = Z;
      const _e = G(`${m.value}-${h.value + 1}-${b.value}`).day();
      _e > 0 ? y.value = 7 - _e : y.value = _e, h.value === G().month() && m.value === G().year() && (G(O.value).month() === h.value ? v.value = G(O.value).date() - 1 : v.value = G().date() - 1);
    }, F = (V) => {
      V === "next" ? h.value === 11 ? (h.value = 0, m.value++) : h.value++ : h.value === 0 ? (h.value = 11, m.value--) : h.value--, w(), G(O.value).year() === m.value && G(O.value).month() === h.value ? v.value = Number(O.value.split("-")[2]) - 1 : v.value = -1;
    }, j = (V) => {
      m.value = V, n.maxDate && G(`${m.value}-${h.value + 1}-01`).isAfter(n.maxDate, "month") && (h.value = G(n.maxDate).month()), n.minDate && G(`${m.value}-${h.value + 1}-01`).isBefore(n.minDate, "month") && (h.value = G(n.minDate).month()), w();
    }, Y = (V) => {
      h.value = V, n.maxDate && G(`${m.value}-${h.value + 1}-01`).isAfter(n.maxDate, "month") && (h.value = G(n.maxDate).month()), n.minDate && G(`${m.value}-${h.value + 1}-01`).isBefore(n.minDate, "month") && (h.value = G(n.minDate).month()), w();
    }, ie = () => {
      E.value = !E.value, L.value = !1, E.value && (g.value = Math.floor((m.value - 1) / 25) * 25);
    }, Ae = () => {
      L.value = !L.value, E.value = !1;
    }, ge = P(() => !n.minDate && !n.maxDate ? _(`${m.value}-${h.value + 1}-01`) : n.minDate ? G(`${m.value}-${h.value + 1}-01`, "month").isSame(n.minDate, "month") : !1), Pe = P(() => n.maxDate ? G(`${m.value}-${h.value + 1}-01`, "month").isSame(n.maxDate, "month") : !1), ee = P(() => n.minDate ? G(`${m.value}-${h.value + 1}-01`, "year").isSame(n.minDate, "year") : !1), ue = P(() => n.maxDate ? G(`${m.value}-${h.value + 1}-01`, "year").isSame(n.maxDate, "year") : !1), ye = (V) => V === 0 || V === 6, $e = (V, X) => V === p.month() && X === p.date() && p.isAfter(G().hour(n.endOfDayHour).minute(n.endOfDayMinutes)), be = (V) => {
      let X = !1;
      return n.minDate && (X = G(V).isBefore(n.minDate)), !X && n.maxDate && (X = G(V).isAfter(n.maxDate)), !X && n.isOnlyWorkDays && (!n.minDate && !n.maxDate && !n.availableDates && (X = _(V)), X || (X = ye(G(V).day()) || W.value.includes(V) || $e(G(V).month(), G(V).date()))), !X && Array.isArray(n.availableDates) && (X = !n.availableDates.includes(G(V).format("YYYY-MM-DD"))), X;
    }, qe = (V) => !n.minDate && !n.maxDate || n.minDate && !n.maxDate ? G(`${V}-12-31`).isBefore(n.minDate) : n.maxDate ? G(`${V}-01-01`).isAfter(n.maxDate) : !1, He = (V) => {
      c(G(V).format(n.displayFormat)), d(G(V).format(n.displayFormat)), r("update:modelValue", G(V).format(n.emitFormat));
    }, Kt = (V) => {
      V !== void 0 && V !== v.value && !be(`${m.value}-${h.value + 1}-${V + 1}`) && (v.value = V);
      let X = v.value + 1;
      if (n.maxDate && G(`${m.value}-${h.value}-${v.value + 1}`).isAfter(n.maxDate)) {
        m.value = G(n.maxDate).year(), h.value = G(n.maxDate).month(), v.value = G(n.maxDate).date();
        return;
      }
      for (; be(`${m.value}-${h.value + 1}-${X}`) || $e(h.value + 1, X); )
        X++, X > p.daysInMonth() && (X = 1, F("next"));
      n.inline || (f.value = !1);
      const Z = G(`${m.value}-${h.value + 1}-${X}`).format("YYYY-MM-DD");
      He(Z);
    }, it = (V) => {
      const X = G(V);
      v.value = X.date() - 1, h.value = X.month(), m.value = X.year(), w();
    }, ke = (V) => {
      n.inline || (f.value = !1), it(V), He(V);
    }, It = (V) => {
      let X = V;
      if (G(V).isValid() && G(V).year() >= 1e3) {
        if (n.isOnlyWorkDays && be(X)) {
          let Z = 10;
          for (; be(X) && Z > 0; )
            X = G(X).add(1, "day").format(n.emitFormat), Z--;
          be(X) && (X = n.maxDate ? G(n.maxDate).format(n.emitFormat) : G().format(n.emitFormat));
        }
        n.minDate && G(X).isBefore(n.minDate) && (X = n.minDate), n.maxDate && G(X).isAfter(n.maxDate) && (X = n.maxDate), it(X), He(X);
      }
    }, Ee = (V) => {
      const X = V.target instanceof HTMLInputElement ? V.target.value : "", Z = X.split("-").reverse().join("-");
      G(Z).isValid() && G(Z).year() >= 1e3 && X.length >= 8 && It(Z);
    }, Mt = () => {
      O.value && G(O.value).isValid() && It(O.value);
    }, pt = {
      mask: "##-##-####"
    };
    return w(), Ue(() => {
      n.locale && G.locale(n.locale);
      let V = !1;
      O.value && G(O.value).isValid() && (V = !0, it(O.value), u()), n.maxDate && (O.value && G(O.value).isValid() ? G(O.value).isAfter(G(n.maxDate)) ? (it(n.maxDate), V = !0) : it(O.value) : (it(n.maxDate), V = !0)), n.minDate && (O.value && G(O.value).isValid() ? G(n.modelValue).isBefore(G(n.minDate)) ? (it(n.minDate), V = !0) : it(O.value) : (it(n.minDate), V = !0)), n.availableDates && (it(n.availableDates[0]), V = !0), V || it(G().format("YYYY-MM-DD")), A3(A, () => {
        f.value && (f.value = !1, E.value = !1, L.value = !1, O.value && G(O.value).isValid() && it(O.value));
      });
    }), (V, X) => (C(), T("div", d$, [
      V.label.length > 0 ? (C(), T("label", {
        key: 0,
        class: "block",
        for: V.name
      }, H(V.label), 9, f$)) : K("", !0),
      S("div", p$, [
        V.inline ? K("", !0) : ct((C(), T("input", {
          key: 0,
          id: x(Te)(V.name),
          "onUpdate:modelValue": X[0] || (X[0] = (Z) => Ht(o) ? o.value = Z : null),
          "data-test-id": x(Te)(V.name),
          name: V.name,
          min: V.minDate,
          max: V.maxDate,
          autocomplete: V.autocomplete,
          disabled: V.disabled,
          type: "text",
          role: "presentation",
          placeholder: "DD-MM-YYYY",
          class: "w-full cursor-pointer rounded-xl border border-blue-300 px-4 py-2 focus:shadow-active disabled:bg-gray-100 disabled:border-gray-100 disabled:text-gray-700",
          onInput: Ee,
          onClick: X[1] || (X[1] = Se((Z) => f.value = !V.hideCalendar, ["prevent"])),
          onBlur: Mt,
          onKeydown: X[2] || (X[2] = wt((Z) => f.value = !1, ["escape"]))
        }, null, 40, h$)), [
          [er, x(o)],
          [x(a), pt]
        ]),
        U(x(te), {
          class: z(["absolute top-3 right-4 text-green-700 opacity-0 transition-opacity duration-300", {
            "!opacity-100": x(l).valid
          }]),
          icon: ["fas", "check"],
          size: "lg"
        }, null, 8, ["class"])
      ]),
      !f.value && !V.inline ? (C(), T("span", {
        key: 1,
        class: z(["text-sm text-orange-900 opacity-0 peer-focus:opacity-0", {
          "opacity-100": x(s)
        }]),
        textContent: H(x(s) ?? "error")
      }, null, 10, m$)) : K("", !0),
      f.value || V.inline ? (C(), T("div", {
        key: 2,
        ref_key: "datepicker",
        ref: A,
        class: "w-auto sm:w-fit"
      }, [
        S("div", {
          class: z(["rounded-xl bg-white p-3 shadow-md relative mb-4", { "w-auto sm:w-fit mt-2 -mx-5 sm:mx-0 max-w-[290px]": !V.inline }])
        }, [
          S("div", v$, [
            S("div", g$, [
              S("button", {
                role: "button",
                "data-test-id": "previous-month-button",
                class: z(D),
                disabled: ge.value,
                onClick: X[3] || (X[3] = Se((Z) => F("previous"), ["prevent"]))
              }, [
                U(x(te), {
                  icon: ["fas", "chevron-left"],
                  class: "w-3"
                })
              ], 8, b$),
              V.allowYearNavigation ? (C(), T("button", {
                key: 0,
                type: "button",
                class: "bg-transparent text-inherit font-semibold rounded-md p-2 hover:bg-blue-50 focus:shadow-active capitalize",
                "data-test-id": "open-month-view-button",
                onClick: Se(Ae, ["prevent"])
              }, [
                rt(H(Q.value[h.value]) + " ", 1),
                V.allowYearNavigation ? K("", !0) : (C(), T(Oe, { key: 0 }, [
                  rt(H(m.value), 1)
                ], 64))
              ])) : (C(), T("span", $$, H(Q.value[h.value]) + " " + H(m.value), 1)),
              S("button", {
                role: "button",
                "data-test-id": "next-month-button",
                class: z(D),
                disabled: Pe.value,
                onClick: X[4] || (X[4] = Se((Z) => F("next"), ["prevent"]))
              }, [
                U(x(te), {
                  icon: ["fas", "chevron-right"],
                  class: "w-3"
                })
              ], 8, y$)
            ]),
            V.allowYearNavigation ? (C(), T("div", x$, [
              S("button", {
                role: "button",
                "data-test-id": "prev-year-button",
                class: z(D),
                disabled: ee.value,
                onClick: X[5] || (X[5] = Se((Z) => j(m.value - 1), ["prevent"]))
              }, [
                U(x(te), {
                  icon: ["fas", "chevron-left"],
                  class: "w-3"
                })
              ], 8, _$),
              S("button", {
                type: "button",
                class: "bg-transparent text-inherit text-center font-semibold rounded-md p-2 hover:bg-blue-50 focus:shadow-active min-w-[52px]",
                "data-test-id": "open-year-view-button",
                onClick: Se(ie, ["prevent"])
              }, H(m.value), 1),
              S("button", {
                role: "button",
                "data-test-id": "next-year-button",
                class: z(D),
                disabled: ue.value,
                onClick: X[6] || (X[6] = Se((Z) => j(m.value + 1), ["prevent"]))
              }, [
                U(x(te), {
                  icon: ["fas", "chevron-right"],
                  class: "w-3"
                })
              ], 8, w$)
            ])) : K("", !0)
          ]),
          S("div", S$, [
            (C(!0), T(Oe, null, Fe(ne.value, (Z) => (C(), T("div", {
              key: Z,
              class: "flex justify-center items-center text-center font-semibold text-sm h-[calc(100%+1px)] pb-1",
              textContent: H(Z)
            }, null, 8, C$))), 128)),
            (C(!0), T(Oe, null, Fe($.value, (Z) => (C(), T("button", {
              key: Z,
              class: z(["flex justify-center items-center rounded-md border border-blue-200 focus:shadow-active flex-1 size-[calc(100%+1px)] -mt-px -!ml-px py-2 text-xs bg-blue-50 text-inherit", [
                { "!bg-blue-50 !text-blue-200 !cursor-default": be(`${m.value}-${h.value}-${Z}`) },
                { "hover:bg-blue-200": !be(`${m.value}-${h.value}-${Z}`) },
                {
                  "!bg-blue-100 text-white": v.value === Z && x(G)(O.value).month() === h.value - 1 && x(G)(O.value).year() === m.value
                }
              ]]),
              role: "button",
              onClick: Se((_e) => be(`${m.value}-${h.value}-${Z}`) ? null : ke(`${m.value}-${h.value}-${Z}`), ["prevent"])
            }, H(Z), 11, A$))), 128)),
            (C(!0), T(Oe, null, Fe(b.value, (Z, _e) => (C(), T("button", {
              key: Z,
              class: z(["flex justify-center items-center rounded-md border border-blue-200 bg-white cursor-pointer focus:shadow-active flex-1 size-[calc(100%+1px)] -mt-px -!ml-px py-2", [
                { "!bg-blue-50 text-blue-200 !cursor-default": be(`${m.value}-${h.value + 1}-${Z}`) },
                { "hover:bg-blue-200": !be(`${m.value}-${h.value + 1}-${Z}`) },
                {
                  "!bg-blue-700 text-white": x(G)(O.value).date() - 1 === _e && x(G)(O.value).month() === h.value && x(G)(O.value).year() === m.value
                }
              ]]),
              role: "button",
              "data-test-id": `select-day-${_e}`,
              disabled: be(`${m.value}-${h.value + 1}-${Z}`) || void 0,
              "data-disabled": be(`${m.value}-${h.value + 1}-${Z}`) || void 0,
              onClick: Se((gt) => be(`${m.value}-${h.value + 1}-${Z}`) ? null : Kt(_e), ["prevent"])
            }, [
              Z ? (C(), T("span", {
                key: 0,
                class: "bg-transparent text-xs",
                textContent: H(Z)
              }, null, 8, O$)) : K("", !0)
            ], 10, E$))), 128)),
            (C(!0), T(Oe, null, Fe(y.value, (Z) => (C(), T("button", {
              key: Z,
              class: z(["flex-1 flex justify-center items-center rounded-md border border-blue-200 focus:shadow-active size-[calc(100%+1px)] -mt-px -!ml-px py-2 text-xs bg-blue-50 text-inherit", [
                { "!bg-blue-50 !text-blue-200 !cursor-default": be(`${m.value}-${h.value + 2}-${Z}`) },
                { "hover:bg-blue-200": !be(`${m.value}-${h.value + 2}-${Z}`) },
                {
                  "!bg-blue-100 text-white": v.value === Z && x(G)(O.value).month() === h.value + 1 && x(G)(O.value).year() === m.value
                }
              ]]),
              role: "button",
              onClick: (_e) => be(`${m.value}-${h.value + 2}-${Z}`) ? null : ke(`${m.value}-${h.value + 2}-${Z}`)
            }, H(Z), 11, T$))), 128))
          ]),
          U(vr, {
            mode: "out-in",
            "enter-active-class": "duration-300 ease-out",
            "enter-from-class": "opacity-0",
            "enter-to-class": "opacity-100",
            "leave-active-class": "duration-200 ease-in",
            "leave-from-class": "opacity-100 scale-100",
            "leave-to-class": "transform opacity-0 scale-90"
          }, {
            default: fe(() => [
              E.value ? (C(), T("div", M$, [
                S("div", k$, [
                  S("div", L$, [
                    S("button", {
                      role: "button",
                      "data-test-id": "prev-year-view-button",
                      class: z(D),
                      onClick: X[7] || (X[7] = Se((Z) => g.value = g.value - 25, ["prevent"]))
                    }, [
                      U(x(te), {
                        icon: ["fas", "chevron-left"],
                        class: "w-3"
                      })
                    ]),
                    S("button", {
                      role: "button",
                      "data-test-id": "next-year-view-button",
                      class: z(D),
                      onClick: X[8] || (X[8] = Se((Z) => g.value = g.value + 25, ["prevent"]))
                    }, [
                      U(x(te), {
                        icon: ["fas", "chevron-right"],
                        class: "w-3"
                      })
                    ])
                  ]),
                  S("button", {
                    role: "button",
                    "data-test-id": "close-year-view-button",
                    class: z(D),
                    onClick: Se(ie, ["prevent"])
                  }, [
                    U(x(te), {
                      icon: ["fas", "times"],
                      class: "text-xl"
                    })
                  ])
                ]),
                U(vr, {
                  mode: "out-in",
                  "enter-active-class": "duration-100 ease-out",
                  "enter-from-class": "transform opacity-0 translate-x-2",
                  "enter-to-class": "opacity-100",
                  "leave-active-class": "duration-100 ease-in",
                  "leave-from-class": "opacity-100 scale-100",
                  "leave-to-class": "transform opacity-0 -translate-x-2"
                }, {
                  default: fe(() => [
                    (C(), T("div", {
                      key: g.value,
                      class: "grid grid-flow-col grid-rows-5 grid-cols-5 flex-1"
                    }, [
                      (C(), T(Oe, null, Fe(25, (Z) => S("button", {
                        key: Z,
                        class: z(["py-2 text-center font-normal text-xs bg-transparent flex-1 -mt-px -!ml-px flex justify-center items-center rounded-md border border-blue-200 hover:bg-blue-100 disabled:bg-blue-50 disabled:text-blue-200", [{ "!bg-blue-700 text-white": m.value === g.value + Z }]]),
                        disabled: qe(g.value + Z),
                        "data-test-id": `select-year-${Z}`,
                        role: "button",
                        onClick: Se((_e) => {
                          j(g.value + Z), ie();
                        }, ["prevent"])
                      }, H(g.value + Z), 11, F$)), 64))
                    ]))
                  ]),
                  _: 1
                })
              ])) : L.value ? (C(), T("div", z$, [
                S("div", P$, [
                  S("button", {
                    role: "button",
                    "data-test-id": "close-month-view-button",
                    class: z(D),
                    onClick: Se(Ae, ["prevent"])
                  }, [
                    U(x(te), {
                      icon: ["fas", "times"],
                      class: "text-xl"
                    })
                  ])
                ]),
                S("div", I$, [
                  (C(), T(Oe, null, Fe(12, (Z) => S("button", {
                    key: Z,
                    class: "font-normal text-xs bg-transparent flex-1 -mt-px -!ml-px flex justify-center items-center rounded-md py-2 border border-blue-200 hover:bg-blue-100 disabled:bg-blue-50 disabled:text-blue-200",
                    role: "button",
                    "data-test-id": `select-month-${Z}`,
                    onClick: Se((_e) => {
                      Y(Z - 1), Ae();
                    }, ["prevent"])
                  }, H(Q.value[Z - 1]), 9, N$)), 64))
                ])
              ])) : K("", !0)
            ]),
            _: 1
          })
        ], 2)
      ], 512)) : K("", !0)
    ]));
  }
}), D$ = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='72.001'%20height='59.999'%20viewBox='0%200%2072.001%2059.999'%3e%3cpath%20id='Union_1'%20data-name='Union%201'%20d='M-1894,121V102.071a21.856,21.856,0,0,0-1.729-8.563,21.923,21.923,0,0,0-4.715-6.993,21.944,21.944,0,0,0-6.992-4.715A21.873,21.873,0,0,0-1916,80.071a21.87,21.87,0,0,0-8.563,1.728,21.938,21.938,0,0,0-6.993,4.715,21.923,21.923,0,0,0-4.715,6.993,21.856,21.856,0,0,0-1.729,8.563V121a7,7,0,0,1-7,7,7,7,0,0,1-7-7v-5.18q0-.124,0-.248V104a35.767,35.767,0,0,1,2.83-14.013,35.879,35.879,0,0,1,7.715-11.444,35.87,35.87,0,0,1,11.443-7.715A35.759,35.759,0,0,1-1916,68a35.76,35.76,0,0,1,14.013,2.829,35.88,35.88,0,0,1,11.443,7.715,35.871,35.871,0,0,1,7.715,11.444A35.76,35.76,0,0,1-1880,104v.888c0,.037,0,.074,0,.111v16a7,7,0,0,1-7,7A7,7,0,0,1-1894,121Zm-29,0V104a7,7,0,0,1,7-7,7,7,0,0,1,7,7v17a7,7,0,0,1-7,7A7,7,0,0,1-1923,121Z'%20transform='translate(1952%20-68)'%20fill='%2381bfe5'%20opacity='0.998'/%3e%3c/svg%3e", R$ = ["src", "alt"], j$ = {
  key: 2,
  class: "bg-blue-200 size-full flex place-items-center"
}, B$ = ["src", "alt"], V$ = {
  name: "AppImage"
}, $r = /* @__PURE__ */ re({
  ...V$,
  props: {
    alt: {},
    source: { default: null },
    theme: { default: null },
    imageClasses: { default: "" }
  },
  setup(e) {
    const t = e, n = N(!1);
    return De(
      () => t.source,
      (r) => {
        typeof r == "string" && (n.value = !1);
      }
    ), (r, a) => (C(), T("div", {
      class: z({
        "flex size-full items-center justify-center": !r.source,
        "rounded-t-3xl": !r.theme && !r.source
      }),
      "data-test-id": "image-wrapper"
    }, [
      n.value ? (C(), T("div", {
        key: 0,
        class: z(["flex size-full items-center justify-center", { "bg-blue-200": !r.theme }]),
        "data-test-id": "fallback-wrapper"
      }, [
        U(x(te), {
          icon: ["fad", "image-slash"],
          size: r.theme ? "4x" : "2x",
          title: t.alt,
          "data-test-id": "fallback-icon"
        }, null, 8, ["size", "title"]),
        a[1] || (a[1] = S("span", { class: "sr-only" }, "Image not found", -1))
      ], 2)) : r.source ? (C(), T("img", {
        key: 1,
        src: r.source,
        alt: t.alt,
        class: z([r.imageClasses, "size-full"]),
        "data-test-id": "img",
        onError: a[0] || (a[0] = (i) => n.value = !0)
      }, null, 42, R$)) : (C(), T("div", j$, [
        S("img", {
          src: x(D$),
          alt: t.alt,
          class: "!w-20 h-min place-self-center mx-auto",
          "data-test-id": "img"
        }, null, 8, B$)
      ]))
    ], 2));
  }
}), U$ = /* @__PURE__ */ re({
  __name: "MogelijkLoader",
  setup(e) {
    return (t, n) => (C(), ve($r, {
      source: "https://res.cloudinary.com/mogelijk/image/upload/v1712140773/site-assets/Logo_Mogelijk_Loader_ilq4a2.png",
      alt: "Mogelijk loader",
      class: "size-full"
    }));
  }
}), H$ = ["disabled"], G$ = {
  key: 0,
  class: "relative mx-2 animate-spin"
}, q$ = {
  key: 1,
  class: "relative mr-2"
}, W$ = {
  key: 2,
  class: "relative"
}, Y$ = {
  key: 3,
  class: "relative ml-2"
}, K$ = {
  name: "AppButton"
}, St = /* @__PURE__ */ re({
  ...K$,
  props: {
    type: { default: "primary" },
    color: { default: "green" },
    isLoading: { type: Boolean, default: !1 },
    isDisabled: { type: Boolean, default: !1 },
    fullWidth: { type: Boolean, default: !1 },
    isIcon: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = Bl();
    return (n, r) => (C(), T("button", {
      disabled: n.isDisabled,
      class: z(["rounded-full inline-flex transition-all duration-150 ease-in-out justify-center items-center disabled:opacity-40", [
        // green
        { "primary-green-button": n.type === "primary" && n.color === "green" },
        { "secondary-green-button": n.type === "secondary" && n.color === "green" },
        { "secondary-outline-green-button": n.type === "secondary-outline" && n.color === "green" },
        { "!p-0 bg-transparent text-green-900 underline": n.type === "green-underline" },
        // blue
        { "primary-blue-button": n.type === "primary" && n.color === "blue" },
        { "secondary-blue-button": n.type === "secondary" && n.color === "blue" },
        { "secondary-outline-blue-button": n.type === "secondary-outline" && n.color === "blue" },
        // red
        { "primary-red-button": n.type === "primary" && n.color === "red" },
        { "secondary-red-button": n.type === "secondary" && n.color === "red" },
        { "secondary-outline-red-button": n.type === "secondary-outline" && n.color === "red" },
        // other
        { "!p-0 bg-transparent text-blue-900 hover:underline": n.type === "tertiary" },
        { "!p-0 bg-transparent text-blue-900 underline": n.type === "tertiary-underline" },
        n.isIcon ? "aspect-square size-10" : "px-12 py-3 text-intro",
        n.fullWidth ? "w-full" : "w-fit"
      ]]),
      type: "submit"
    }, [
      n.isLoading ? (C(), T("span", G$, [
        U(x(te), {
          icon: ["fas", "spinner"],
          size: "lg"
        })
      ])) : x(t)["icon-start"] ? (C(), T("span", q$, [
        Ce(n.$slots, "icon-start")
      ])) : K("", !0),
      n.isLoading ? K("", !0) : (C(), T("div", W$, [
        Ce(n.$slots, "default")
      ])),
      x(t)["icon-end"] ? (C(), T("span", Y$, [
        Ce(n.$slots, "icon-end")
      ])) : K("", !0)
    ], 10, H$));
  }
});
function $s(e, t = "px") {
  if (!(e == null || e === ""))
    return isNaN(e) ? String(e) : `${Number(e)}${t}`;
}
const Z$ = Symbol(), X$ = {
  shimmer: !0
};
function J$() {
  const e = da(Z$, X$);
  return e || Zp("Skeletor is not installed on this Vue application."), e;
}
const Hc = re({
  name: "Skeletor",
  props: {
    as: {
      type: String,
      default: "span"
    },
    circle: {
      type: Boolean,
      default: !1
    },
    pill: {
      type: Boolean,
      default: !1
    },
    size: {
      type: [String, Number],
      default: null
    },
    width: {
      type: [String, Number],
      default: null
    },
    height: {
      type: [String, Number],
      default: null
    },
    shimmer: {
      type: Boolean,
      default: void 0
    }
  },
  setup(e) {
    const t = J$(), n = P(() => !e.circle && (e.size || e.height)), r = P(() => !e.circle && !e.size && !e.height), a = P(() => e.shimmer !== void 0 ? !e.shimmer : !t.shimmer), i = P(() => ({
      "vue-skeletor": !0,
      "vue-skeletor--rect": n.value,
      "vue-skeletor--text": r.value,
      "vue-skeletor--shimmerless": a.value,
      "vue-skeletor--circle": e.circle,
      "vue-skeletor--pill": e.pill
    })), s = P(() => {
      const l = {};
      if (e.size) {
        const u = $s(e.size);
        l.width = u, l.height = u;
      }
      return !e.size && e.width && (l.width = $s(e.width)), !e.size && e.height && (l.height = $s(e.height)), l;
    }), o = r.value ? "‌" : null;
    return () => et(e.as, {
      class: i.value,
      style: s.value
    }, [o]);
  }
}), yt = /* @__PURE__ */ re({
  __name: "AppSkeleton",
  props: {
    fetching: { type: Boolean, default: !1 },
    height: { default: void 0 },
    width: { default: void 0 },
    text: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = N(), r = N(), a = N(!1), i = N(0), s = P(() => {
      var l;
      return (l = n.value) == null ? void 0 : l.firstElementChild;
    });
    Ue(() => {
      if (r.value = getComputedStyle(s.value), a.value = t.fetching, t.text) {
        const l = parseInt(s.value.offsetHeight, 10), u = parseInt(r.value.lineHeight, 10);
        i.value = l && u ? l / u : 0;
      }
    });
    const o = P(() => {
      var l, u, c, d, f, p, h, m, v, g, b;
      return {
        height: (l = r.value) == null ? void 0 : l.height,
        width: t.width ?? ((u = r.value) == null ? void 0 : u.width),
        borderRadius: (c = r.value) == null ? void 0 : c.borderRadius,
        aspectRatio: (d = r.value) == null ? void 0 : d.aspectRatio,
        margin: (f = r.value) == null ? void 0 : f.margin,
        marginTop: (p = r.value) == null ? void 0 : p.marginTop,
        marginBottom: (h = r.value) == null ? void 0 : h.marginBottom,
        marginRight: (m = r.value) == null ? void 0 : m.marginRight,
        marginLeft: (v = r.value) == null ? void 0 : v.marginLeft,
        padding: (g = r.value) == null ? void 0 : g.padding,
        fontSize: (b = r.value) == null ? void 0 : b.fontSize
      };
    });
    return De(
      () => t.fetching,
      (l) => {
        l || (a.value = l);
      }
    ), (l, u) => (C(), T(Oe, null, [
      t.text && a.value ? (C(), T("div", {
        key: 0,
        class: "flex flex-col justify-around",
        style: en(o.value)
      }, [
        (C(!0), T(Oe, null, Fe(i.value, (c) => (C(), ve(x(Hc), {
          key: c,
          style: en(`height:${o.value.fontSize};`),
          width: t.width ?? o.value.width
        }, null, 8, ["style", "width"]))), 128))
      ], 4)) : a.value ? (C(), ve(x(Hc), {
        key: 1,
        as: "div",
        style: en(o.value),
        height: t.height ?? o.value.height,
        width: t.width ?? o.value.width
      }, null, 8, ["style", "height", "width"])) : K("", !0),
      ct(S("div", zn({
        ref_key: "content",
        ref: n
      }, l.$attrs), [
        Ce(l.$slots, "default")
      ], 16), [
        [gr, !a.value]
      ])
    ], 64));
  }
}), Q$ = ["aria-disabled"], ey = {
  name: "AppSpecification"
}, qn = /* @__PURE__ */ re({
  ...ey,
  props: {
    label: {},
    text: { default: "" },
    icon: { default: void 0 },
    isTruncatable: { type: Boolean, default: !1 },
    isDisabled: { type: Boolean, default: !1 },
    fetching: { type: Boolean, default: !1 },
    size: { default: "base" },
    direction: { default: "default" },
    theme: { default: "default" }
  },
  setup(e) {
    const t = e, n = P(() => {
      if (t.theme === "white") return "#fff";
    });
    return (r, a) => (C(), T("section", {
      "data-test-id": "specification",
      "aria-disabled": t.isDisabled,
      class: z(["flex", {
        "flex-col": t.direction === "vertical",
        "items-center": t.direction !== "vertical",
        "w-full": t.direction === "horizontal",
        "opacity-50": t.isDisabled
      }])
    }, [
      r.icon ? (C(), T("div", {
        key: 0,
        class: z({
          "size-8 mr-4 shrink-0": t.size === "lg",
          "size-6 mr-2 w-5": t.size === "base",
          "mt-1 mr-2 size-4": t.size === "small",
          "mr-4": t.direction !== "vertical" && t.size === "lg",
          "mb-2": t.direction === "vertical"
        })
      }, [
        U(x(te), {
          icon: Array.isArray(t.icon) ? t.icon : ["fad", t.icon],
          class: z(["text-xl", {
            "size-8 shrink-0 mr-4 text-2xl": t.size === "lg",
            "w-5": t.size === "base"
          }]),
          style: en({ "--fa-primary-color": n.value, "--fa-secondary-color": n.value })
        }, null, 8, ["icon", "class", "style"])
      ], 2)) : K("", !0),
      S("dl", {
        class: z(["flex flex-col w-full", {
          truncate: r.isTruncatable,
          "grid grid-cols-2 gap-2 md:gap-4 items-center": t.direction === "horizontal"
        }])
      }, [
        U(yt, {
          fetching: t.fetching,
          text: ""
        }, {
          default: fe(() => [
            S("dt", {
              class: z(["text-sm", {
                "whitespace-nowrap": t.direction !== "vertical" && t.direction !== "compact",
                "text-gray-700": t.direction === "compact" && t.theme !== "dark"
              }])
            }, H(t.label), 3)
          ]),
          _: 1
        }, 8, ["fetching"]),
        U(yt, {
          fetching: t.fetching,
          text: ""
        }, {
          default: fe(() => [
            S("dd", {
              class: z(["font-semibold text-blue-900", [
                { "truncate whitespace-nowrap": r.isTruncatable },
                { "text-right text-base": t.direction === "horizontal" },
                { "text-lg": r.size === "lg" }
              ]])
            }, [
              Ce(r.$slots, "default", {}, () => [
                rt(H(t.text), 1)
              ])
            ], 2)
          ]),
          _: 3
        }, 8, ["fetching"])
      ], 2)
    ], 10, Q$));
  }
}), ty = { class: "mb-2 w-full" }, ny = ["for"], ry = ["id", "checked", "value", "name", "disabled", "data-test-id", "tabindex", "aria-checked"], ay = ["for"], iy = ["innerHTML"], sy = {
  key: 0,
  class: "text-sm"
}, oy = {
  key: 0,
  class: "text-sm text-orange-900"
}, ly = {
  name: "AppCheckbox"
}, uy = /* @__PURE__ */ re({
  ...ly,
  props: {
    label: { default: "" },
    subLabel: { default: "" },
    name: {},
    modelValue: { type: Boolean },
    tooltip: { default: "" },
    checkboxPosition: { default: "center" },
    disabled: { type: Boolean, default: !1 },
    tabindex: { default: "0" }
  },
  emits: ["update:modelValue", "update:error"],
  setup(e, { emit: t }) {
    const n = e, { errorMessage: r, setValue: a, value: i } = Tt(n.name, void 0, {
      initialValue: n.modelValue ? "1" : "0"
    }), s = t, o = N();
    De(
      () => r.value,
      (u) => {
        s("update:error", u);
      }
    );
    const l = () => {
      const u = !!Number(i.value);
      a(u ? "0" : "1"), s("update:modelValue", !u);
    };
    return (u, c) => (C(), T("div", ty, [
      S("div", {
        class: z(["relative flex flex-nowrap", `items-${n.checkboxPosition}`])
      }, [
        S("div", {
          for: x(Te)(n.name),
          class: z(["relative flex items-center gap-x-2 pr-2 cursor-pointer", { "!cursor-not-allowed": n.disabled }])
        }, [
          S("input", {
            id: x(Te)(n.name),
            ref_key: "input",
            ref: o,
            checked: n.modelValue,
            value: n.modelValue ? "1" : "0",
            name: n.name,
            disabled: n.disabled,
            "data-test-id": x(Te)(n.name),
            tabindex: n.tabindex,
            "aria-checked": n.modelValue,
            class: "m-0 flex size-6 shrink-0 appearance-none peer",
            type: "checkbox",
            onChange: l,
            onKeydown: wt(l, ["enter", "space"])
          }, null, 40, ry),
          S("div", {
            class: z(["absolute top-0 left-0 flex size-6 items-center justify-center rounded-lg border border-blue-700 bg-white outline-blue-300 outline-2 peer-checked:bg-blue-700 peer-focus:outline", { "opacity-30": n.disabled }])
          }, [
            n.modelValue ? (C(), ve(x(te), {
              key: 0,
              icon: ["fas", "check"],
              size: "1x",
              class: "z-1 relative text-white"
            })) : K("", !0)
          ], 2),
          Ce(u.$slots, "default")
        ], 10, ny),
        S("label", {
          for: x(Te)(n.name),
          class: z(["flex flex-col items-start cursor-pointer", { "!cursor-not-allowed": n.disabled }])
        }, [
          S("span", {
            "data-test-id": "label",
            innerHTML: n.label
          }, null, 8, iy),
          n.subLabel ? (C(), T("span", sy, H(n.subLabel), 1)) : K("", !0)
        ], 10, ay)
      ], 2),
      x(r) ? (C(), T("span", oy, H(x(r)), 1)) : K("", !0)
    ]));
  }
}), cy = { class: "w-full" }, dy = ["for"], fy = { class: "relative inline-block w-full" }, py = {
  key: 0,
  class: "absolute top-3 left-3 flex items-center"
}, hy = ["id", "data-test-id", "type", "name", "placeholder", "disabled", "min", "max", "autocomplete", "pattern", "required", "tabindex", "aria-required"], my = {
  key: 4,
  class: "absolute right-3 flex h-full items-center"
}, vy = ["textContent"], gy = {
  name: "AppInput"
}, ui = /* @__PURE__ */ re({
  ...gy,
  props: {
    name: {},
    label: { default: "" },
    disabled: { type: Boolean, default: !1 },
    type: { default: "text" },
    theme: { default: "outline" },
    placeholder: { default: "" },
    modelValue: { type: [String, Number, null, Boolean], default: "" },
    togglePassword: { type: Boolean, default: !1 },
    min: { default: 0 },
    max: { default: 0 },
    autocomplete: { default: "off" },
    required: { type: Boolean, default: void 0 },
    tabindex: { default: 0 },
    pattern: { default: void 0 },
    validateOnValueUpdate: { type: Boolean, default: !1 },
    ignoreValidation: { type: Boolean, default: !1 },
    iban: { type: Boolean, default: !1 },
    mask: { default: void 0 }
  },
  emits: ["update:modelValue", "focus"],
  setup(e, { expose: t, emit: n }) {
    const r = e, a = n, {
      errorMessage: i,
      value: s,
      meta: o,
      setValue: l,
      handleChange: u
    } = Tt(r.name, void 0, {
      initialValue: r.modelValue,
      validateOnValueUpdate: r.validateOnValueUpdate
    }), c = tu, d = Bl(), f = N(r.type), p = { mask: "AAXX XXXX XXXX XXXX XXXX XXXX XXXX XXXX" }, h = () => {
      var b;
      const g = Te(r.name);
      g && ((b = document.getElementById(g)) == null || b.focus());
    }, m = () => {
      a("focus", r.iban ? s.value.toUpperCase() : s.value);
    }, v = async (g) => {
      u(g), a("update:modelValue", r.iban ? s.value.toUpperCase() : s.value);
    };
    return De(
      () => r.modelValue,
      (g) => {
        l(g, r.validateOnValueUpdate);
      }
    ), t({ focus: h }), (g, b) => (C(), T("div", cy, [
      r.label ? (C(), T("label", {
        key: 0,
        class: "mb-0.5 inline-block",
        for: x(Te)(g.name)
      }, H(r.label), 9, dy)) : K("", !0),
      S("div", fy, [
        x(d)["icon-start"] ? (C(), T("span", py, [
          Ce(g.$slots, "icon-start")
        ])) : K("", !0),
        ct(S("input", {
          id: x(Te)(g.name),
          "onUpdate:modelValue": b[0] || (b[0] = ($) => Ht(s) ? s.value = $ : null),
          "data-test-id": x(Te)(g.name),
          type: f.value,
          name: g.name,
          placeholder: g.placeholder,
          disabled: g.disabled,
          min: g.min,
          max: g.max,
          autocomplete: g.autocomplete,
          pattern: g.pattern,
          required: g.required,
          tabindex: g.tabindex,
          "aria-required": g.required || !1,
          class: z([{
            // eslint-disable-next-line max-len
            "!bg-orange-100 !border-orange-900 !text-orange-900 shadow-activeError focus:!border-blue-300 focus:!text-gray-900 focus:!bg-white": x(i),
            "!border-green-700 focus:!shadow-activeSuccess": x(o).dirty && x(o).valid && !g.ignoreValidation,
            "pl-12": x(d)["icon-start"],
            "pr-10": x(d)["icon-end"] || !g.ignoreValidation,
            // eslint-disable-next-line max-len
            "border border-blue-300 rounded-lg focus:shadow-active transition-all duration-300 disabled:bg-gray-100 disabled:border-gray-100 disabled:text-gray-700": r.theme === "outline",
            // eslint-disable-next-line max-len
            "shadow-element focus:shadow-active rounded-lg bg-white disabled:bg-gray-100 disabled:border-gray-100 disabled:text-gray-700": r.theme === "solo",
            uppercase: g.iban
          }, "peer block w-full bg-white p-2"]),
          onBlur: v,
          onFocus: m
        }, null, 42, hy), [
          [Xp, x(s)],
          [x(c), g.iban ? p : g.mask ?? void 0]
        ]),
        !g.ignoreValidation && f.value !== "password" ? (C(), ve(x(te), {
          key: 1,
          class: z(["absolute top-3 right-4 text-green-700 opacity-0 transition-opacity duration-300", {
            "!opacity-100": x(o).valid
          }]),
          icon: ["fas", "check"],
          size: "lg"
        }, null, 8, ["class"])) : K("", !0),
        g.togglePassword && f.value === "password" ? (C(), ve(x(te), {
          key: 2,
          class: "absolute top-3 right-4",
          icon: ["fad", "eye"],
          size: "lg",
          title: "Bekijk wachtwoord",
          "data-test-id": `${g.name}-show-password`,
          onClick: b[1] || (b[1] = ($) => f.value = "text")
        }, null, 8, ["data-test-id"])) : K("", !0),
        g.togglePassword && f.value === "text" ? (C(), ve(x(te), {
          key: 3,
          class: "absolute top-3 right-4",
          icon: ["fad", "eye-slash"],
          size: "lg",
          title: "Verberg wachtwoord",
          "data-test-id": `${g.name}-hide-password`,
          onClick: b[2] || (b[2] = ($) => f.value = "password")
        }, null, 8, ["data-test-id"])) : K("", !0),
        x(d)["icon-end"] ? (C(), T("span", my, [
          Ce(g.$slots, "icon-end")
        ])) : K("", !0),
        g.ignoreValidation ? K("", !0) : (C(), T("span", {
          key: 5,
          class: z(["text-sm text-orange-900 opacity-0 peer-focus:opacity-0", {
            "opacity-100": x(i)
          }]),
          textContent: H(x(i) ?? "error")
        }, null, 10, vy))
      ])
    ]));
  }
}), by = { class: "mb-4 w-full" }, $y = ["for"], yy = { class: "relative inline-block w-full" }, xy = { class: "absolute left-3 flex h-full items-center" }, _y = { class: "flex size-6 items-center justify-center rounded-full" }, wy = ["id", "data-test-id", "name", "placeholder", "disabled", "min", "max", "onKeydown"], Sy = {
  key: 0,
  class: "text-sm text-orange-900"
}, Cy = {
  name: "AppCurrencyInput"
}, Ay = /* @__PURE__ */ re({
  ...Cy,
  props: {
    label: {},
    name: {},
    disabled: { type: Boolean, default: !1 },
    placeholder: { default: "" },
    modelValue: { default: "" },
    min: { default: 0 },
    max: { default: 0 },
    hideErrorMessage: { type: Boolean, default: !1 },
    validateOnValueUpdate: { type: Boolean, default: !1 },
    step: { default: void 0 },
    isInteger: { type: Boolean, default: !1 },
    locale: { default: "nl" }
  },
  emits: ["update:modelValue"],
  setup(e, { expose: t, emit: n }) {
    const r = e, a = n, i = (y) => y.replace(/[^\d,.]/g, ""), s = (y) => new Intl.NumberFormat(r.locale, Number.isInteger(y) ? {} : {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(y), o = (y, A = 2) => {
      const L = new Intl.NumberFormat(r.locale, Number.isInteger(y) ? {} : {
        minimumFractionDigits: A,
        maximumFractionDigits: A
      }).format(1234.56).split(/\d/).filter(Boolean), D = L[0], ne = L[1] || ".", I = String(y).split(D).join("").replace(ne, ".");
      return parseFloat(I);
    }, l = N(null), u = N(r.modelValue ?? ""), c = P(() => u.value ? r.isInteger ? o(u.value, 0) : o(u.value) : ""), {
      errorMessage: d,
      handleBlur: f,
      value: p,
      meta: h,
      setValue: m,
      handleChange: v
    } = Tt(r.name, void 0, {
      initialValue: r.modelValue,
      validateOnValueUpdate: r.validateOnValueUpdate
    }), g = (y, A = !1) => {
      if (y)
        if (r.step) {
          const E = Math.round(o(y) / r.step) * r.step;
          m(E), setTimeout(() => {
            m(E);
          }, 500);
        } else {
          const E = A ? Number(y) : o(y, r.isInteger ? 0 : 2);
          m(E.toString()), p.value = s(E);
        }
    }, b = (y) => {
      v(y);
      const A = y.target, E = A == null ? void 0 : A.value;
      g(E), f();
    }, $ = (y) => {
      const A = y.target;
      u.value = i((A == null ? void 0 : A.value) ?? ""), a("update:modelValue", c.value);
    };
    return t({
      onBlur: b,
      inputRef: l
    }), Ue(() => {
      g(r.modelValue, !0);
    }), (y, A) => (C(), T("div", by, [
      S("label", {
        class: "mb-0.5 inline-block",
        for: x(Te)(y.name)
      }, H(y.label), 9, $y),
      S("div", yy, [
        S("div", xy, [
          Ce(y.$slots, "icon", {}, () => [
            S("span", _y, [
              U(x(te), {
                size: "sm",
                class: z({ "text-blue-300": !0, "!text-orange-900": x(d) }),
                icon: ["fas", "euro-sign"]
              }, null, 8, ["class"])
            ])
          ])
        ]),
        ct(S("input", {
          id: x(Te)(y.name),
          ref_key: "inputRef",
          ref: l,
          "onUpdate:modelValue": A[0] || (A[0] = (E) => Ht(p) ? p.value = E : null),
          "data-test-id": x(Te)(y.name),
          type: "text",
          pattern: "\\.d*",
          name: y.name,
          placeholder: y.placeholder,
          class: z([{
            "!bg-orange-100 !border-orange-900 !text-orange-900 focus:!shadow-activeError": x(d),
            "!border-green-700 focus:!shadow-activeSuccess": x(h).dirty && x(h).valid
          }, "block w-full rounded-lg border border-blue-300 p-2 pl-11 pr-10 transition-all duration-300 focus:shadow-active disabled:!border-gray-100 disabled:bg-gray-100 disabled:text-gray-700"]),
          disabled: y.disabled,
          min: y.min,
          max: y.max,
          inputmode: "numeric",
          onBlur: b,
          onKeydown: wt(Se(b, ["prevent"]), ["enter"]),
          onInput: $
        }, null, 42, wy), [
          [er, x(p)]
        ]),
        U(x(te), {
          class: z(["absolute bottom-3 right-4 text-green-700 opacity-0 transition-opacity duration-300", {
            "!opacity-100": x(h).dirty && x(h).valid
          }]),
          icon: ["fas", "check"],
          size: "lg"
        }, null, 8, ["class"])
      ]),
      !y.hideErrorMessage && x(d) ? (C(), T("span", Sy, H(x(d)), 1)) : K("", !0)
    ]));
  }
}), Ey = { class: "relative mb-4 inline-block w-full" }, Oy = ["for"], Ty = { class: "relative" }, My = ["id", "name", "disabled", "aria-expanded", "onKeydown"], ky = {
  class: "absolute z-50 mt-1 w-full overflow-hidden overflow-y-auto rounded-lg border border-blue-300 bg-white shadow-element",
  "data-test-id": "location-autocomplete-options"
}, Ly = ["aria-hidden", "aria-label"], Fy = ["data-test-id", "aria-selected", "onClick"], zy = { class: "shrink truncate font-medium" }, Py = {
  key: 0,
  class: "shrink-0 text-gray-700"
}, Iy = {
  key: 1,
  "data-test-id": "location-autocomplete-error",
  class: "text-sm text-orange-900"
}, Ny = {
  key: 2,
  class: "text-sm text-orange-900"
}, Dy = {
  name: "AppAutocompleteInput"
}, Ry = /* @__PURE__ */ re({
  ...Dy,
  props: {
    label: {},
    name: {},
    options: {},
    disabled: { type: Boolean, default: !1 },
    showErrorMessage: { type: Boolean, default: !0 },
    value: { default: "" },
    hideMagnifyingGlass: { type: Boolean, default: !1 },
    ignoreValidation: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "update:modalOption", "selected"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = N(""), i = N(!0), s = N(0), {
      errorMessage: o,
      value: l,
      meta: u,
      setValue: c,
      handleChange: d
    } = Tt(n.name, void 0, {
      initialValue: n.value,
      validateOnValueUpdate: !1
    });
    De(
      () => n.value,
      (b) => {
        c(b);
      }
    );
    const f = () => {
      i.value = !1;
    }, p = (b) => {
      l.value = b.label, r("selected", b.label), r("update:modelValue", b.label), r("update:modalOption", b), f();
    }, h = (b) => {
      i.value = !0, s.value = 0, r("update:modelValue", b);
    };
    Ue(() => {
      document.body.addEventListener("click", f);
    }), Ti(() => {
      document.body.removeEventListener("click", f);
    });
    const m = (b) => {
      setTimeout(() => {
        f();
      }, 200), d(b);
    }, v = () => {
      s.value < n.options.length && (s.value += 1);
    }, g = () => {
      s.value !== 1 && (s.value -= 1);
    };
    return (b, $) => (C(), T("div", Ey, [
      n.label ? (C(), T("label", {
        key: 0,
        class: "mb-0.5 inline-block",
        for: x(Te)(n.name)
      }, H(n.label), 9, Oy)) : K("", !0),
      S("div", Ty, [
        b.hideMagnifyingGlass ? K("", !0) : (C(), ve(x(te), {
          key: 0,
          class: "absolute bottom-3 left-4",
          icon: ["fad", "magnifying-glass"],
          size: "lg"
        })),
        ct(S("input", {
          id: x(Te)(n.name),
          "onUpdate:modelValue": $[0] || ($[0] = (y) => Ht(l) ? l.value = y : null),
          name: n.name,
          class: z([{
            "!bg-orange-100 !border-orange-900 !text-orange-900 focus:!shadow-activeError": x(o),
            "!border-green-700 focus:!shadow-activeSuccess": x(u).dirty && x(u).valid && !b.ignoreValidation,
            "pl-10": !n.hideMagnifyingGlass
          }, "block w-full rounded-lg border border-blue-300 p-2 pr-10 transition-all duration-300 focus:shadow-active disabled:border-gray-100 disabled:bg-gray-100 disabled:text-gray-700"]),
          type: "text",
          autocomplete: "off",
          disabled: b.disabled,
          "data-test-id": "location-autocomplete-input",
          "aria-expanded": b.options.length > 0 && i.value,
          onBlur: m,
          onInput: $[1] || ($[1] = (y) => h(x(l))),
          onKeydown: [
            wt(Se(v, ["prevent"]), ["right", "down"]),
            wt(Se(g, ["prevent"]), ["left", "up"]),
            $[2] || ($[2] = wt(Se((y) => p(n.options[s.value - 1]), ["prevent"]), ["enter", "space"])),
            wt(Se(f, ["prevent", "stop"]), ["escape"])
          ]
        }, null, 42, My), [
          [er, x(l)]
        ]),
        U(x(te), {
          class: z(["absolute bottom-3 right-4 text-green-700 opacity-0 transition-opacity duration-300", {
            "!opacity-100": x(u).dirty && x(u).valid && !b.ignoreValidation
          }]),
          icon: ["fas", "check"],
          size: "lg"
        }, null, 8, ["class"])
      ]),
      ct(S("div", ky, [
        S("ul", {
          role: "listbox",
          "aria-hidden": b.options.length === 0 || !i.value,
          "aria-label": n.label,
          class: "py-1"
        }, [
          (C(!0), T(Oe, null, Fe(b.options, (y, A) => (C(), T("li", {
            key: A,
            "data-test-id": `location-item-${A.toString()}`,
            role: "option",
            "aria-selected": A === s.value - 1,
            class: z(["cursor-pointer truncate px-3 py-2 flex justify-between hover:bg-blue-200", { "bg-blue-200": A === s.value - 1 }]),
            onClick: Se(() => p(y), ["stop"])
          }, [
            S("div", zy, H(y.label), 1),
            y.value ? (C(), T("div", Py, H(y.value), 1)) : K("", !0)
          ], 10, Fy))), 128))
        ], 8, Ly)
      ], 512), [
        [gr, b.options.length > 0 && i.value]
      ]),
      a.value && b.showErrorMessage && !x(o) ? (C(), T("span", Iy, H(a.value), 1)) : K("", !0),
      x(o) ? (C(), T("span", Ny, H(x(o)), 1)) : K("", !0)
    ]));
  }
}), jy = { class: "flex items-center justify-center" }, By = {
  key: 0,
  class: "flex cursor-pointer items-center"
}, Vy = ["data-test-id", "title", "onClick"], Uy = {
  key: 0,
  class: "absolute top-1/2 -mt-3 -left-3 -translate-y-1/2 z-10 bg-orange-900 rounded-full flex place-items-center text-white size-6"
}, Hy = { class: "sr-only" }, Gy = {
  "aria-hidden": "true",
  class: "text-center h-fit w-full"
}, qy = ["data-test-id", "title", "onClick"], Wy = {
  name: "AppSidebar"
}, Yy = /* @__PURE__ */ re({
  ...Wy,
  props: {
    items: {},
    route: {},
    isMenuOpenMobile: { type: Boolean },
    matchExactRoute: { type: Boolean, default: !1 },
    isDashboardsSidebar: { type: Boolean, default: !1 }
  },
  emits: ["to", "isSidebarCollapsed", "logout"],
  setup(e, { expose: t, emit: n }) {
    const r = e, a = n, i = (u) => r.matchExactRoute ? r.route === u.to : r.route.includes(u.to), s = (u) => [i(u) ? "fas" : "fal", u.icon], o = N(!1), l = () => {
      o.value = !o.value, localStorage.setItem("isSidebarCollapsed", o.value.toString()), a("isSidebarCollapsed", o.value);
    };
    return t({
      toggleSidebar: l
    }), Ue(() => {
      o.value = localStorage.getItem("isSidebarCollapsed") === "true", a("isSidebarCollapsed", localStorage.getItem("isSidebarCollapsed") === "true");
    }), (u, c) => (C(), T("aside", {
      class: z(["hide-scroll animate-fadeDown absolute z-40 overflow-y-auto flex h-full flex-col bg-gradient-to-tr from-blue-900 to-blue-500 p-4 duration-300 ease-in-out", {
        "tablet:!relative tablet:animate-none tablet:rounded-3xl tablet:transition-width tablet:overflow-hidden": !u.isDashboardsSidebar,
        "lg:!relative lg:animate-none lg:rounded-3xl lg:transition-width lg:overflow-hidden": u.isDashboardsSidebar,
        "tablet:w-fit": !o.value && !u.isDashboardsSidebar,
        "hidden tablet:!flex": !u.isMenuOpenMobile && !u.isDashboardsSidebar,
        "lg:w-fit": !o.value && u.isDashboardsSidebar,
        "hidden lg:!flex": !u.isMenuOpenMobile && u.isDashboardsSidebar,
        "!fixed !inset-0 w-screen h-screen": u.isMenuOpenMobile,
        "3xl:w-full": !o.value
      }])
    }, [
      S("div", {
        class: z(["mb-10 flex justify-end", u.isDashboardsSidebar ? "lg:hidden" : "tablet:hidden"])
      }, [
        Ce(u.$slots, "hamburger")
      ], 2),
      Ce(u.$slots, "default"),
      S("div", {
        "data-test-id": "sidebar-toggle-button",
        class: z(["hidden grid-cols-[40px_auto] gap-x-2 p-4 text-white", {
          "tablet:grid-cols-[40px]": o.value && !u.isDashboardsSidebar,
          "tablet:grid": !u.isDashboardsSidebar,
          "lg:grid-cols-[40px]": o.value && u.isDashboardsSidebar,
          "lg:grid": u.isDashboardsSidebar
        }]),
        onClick: c[0] || (c[0] = Se((d) => l(), ["prevent"]))
      }, [
        S("div", jy, [
          U(St, {
            title: o.value ? "Uitvouwen" : "Samenvouwen",
            "is-icon": "",
            type: "secondary",
            color: "blue",
            class: "size-8 bg-white hover:text-blue-700"
          }, {
            default: fe(() => [
              U(x(te), {
                icon: ["fas", "chevron-left"],
                size: "sm",
                class: z(["transition-transform duration-150 ease-in-out", { "-scale-x-100": o.value }])
              }, null, 8, ["class"])
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        o.value ? K("", !0) : (C(), T("div", By, "Invouwen"))
      ], 2),
      S("nav", {
        class: z(["mt-4 grid grid-cols-[40px_auto] px-4 text-white", {
          "tablet:grid-cols-[40px]": o.value && !u.isDashboardsSidebar,
          "lg:grid-cols-[40px]": o.value && u.isDashboardsSidebar
        }])
      }, [
        (C(!0), T(Oe, null, Fe(u.items, (d, f) => {
          var p;
          return C(), T(Oe, {
            key: d.label
          }, [
            S("div", {
              "data-test-id": `sidebar-icon-${f.toString()}`,
              class: z(["relative flex h-24 w-full cursor-pointer items-center justify-center", {
                "before:content-[''] before:bg-black before:h-full before:w-screen before:absolute before:opacity-20 before:-left-8": i(d),
                "border-t border-gray-50": f > 0 && !i(d) && !i(u.items[f - 1]),
                "tablet:border-none": !u.isDashboardsSidebar,
                "lg:border-none": u.isDashboardsSidebar
              }]),
              title: d.label,
              onClick: (h) => d.label === "Uitloggen" ? a("logout") : a("to", d.to)
            }, [
              U(x(te), {
                class: "relative z-10 text-3xl",
                icon: s(d)
              }, null, 8, ["icon"]),
              (p = d.notificationCount) != null && p.value && d.notificationCount.value > 0 ? (C(), T("div", Uy, [
                S("span", Hy, H(d.label) + " - " + H(d.notificationCount), 1),
                S("p", Gy, H(d.notificationCount), 1)
              ])) : K("", !0)
            ], 10, Vy),
            S("div", {
              "data-test-id": `sidebar-link-${f.toString()}`,
              class: z(["relative z-10 flex h-24 cursor-pointer items-center pl-2", {
                "font-semibold": i(d),
                "border-t border-gray-50": f > 0 && !i(d) && !i(u.items[f - 1]),
                "tablet:hidden": o.value && !u.isDashboardsSidebar,
                "lg:hidden": o.value && u.isDashboardsSidebar,
                "tablet:border-none": !u.isDashboardsSidebar,
                "lg:border-none": u.isDashboardsSidebar
              }]),
              title: d.label,
              onClick: (h) => d.label === "Uitloggen" ? a("logout") : a("to", d.to)
            }, H(d.label), 11, qy)
          ], 64);
        }), 128))
      ], 2)
    ], 2));
  }
}), Ky = {
  name: "AppSidebarNavOption"
}, Zy = /* @__PURE__ */ re({
  ...Ky,
  setup(e) {
    const t = Bl(), n = da("isMenuCollapsed");
    return (r, a) => (C(), T("div", {
      "data-test-id": "app-sidebar-option",
      class: z(["sidebar-nav__option mb-2 overflow-hidden whitespace-nowrap rounded-full font-medium text-blue-900", {
        "flex justify-start sidebar-nav__option__collapsed": x(n)
      }])
    }, [
      Ce(r.$slots, "default", {}, () => [
        x(t).start ? (C(), T("span", {
          key: 0,
          class: z({ "mr-2": !x(n) })
        }, [
          Ce(r.$slots, "start", {}, void 0, !0)
        ], 2)) : K("", !0)
      ], !0)
    ], 2));
  }
}), Ct = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, a] of t)
    n[r] = a;
  return n;
}, Xy = /* @__PURE__ */ Ct(Zy, [["__scopeId", "data-v-426bc949"]]), Jy = { class: "relative mb-4 w-full" }, Qy = ["for"], ex = ["id", "value", "name", "min", "max", "step", "disabled"], tx = { class: "relative mb-6 h-12 w-full overflow-hidden rounded-lg border border-blue-300 bg-white" }, nx = { class: "absolute size-[26px] right-[-13px] rounded-full bg-green-700" }, rx = { class: "flex items-center justify-end h-full" }, ax = {
  name: "AppFinanceRange"
}, ix = /* @__PURE__ */ re({
  ...ax,
  props: {
    name: {},
    min: {},
    max: {},
    minPercentage: {},
    maxPercentage: {},
    label: { default: "" },
    step: { default: void 0 },
    value: { default: null },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = N(), {
      errorMessage: i,
      value: s,
      meta: o,
      setValue: l
    } = Tt(n.name, void 0, {
      initialValue: n.value
    });
    De(
      () => n.value,
      (p) => {
        l(p);
      }
    );
    const u = P(() => {
      if (s.value !== null) {
        const p = 100 * (Number(s.value) - n.min) / (n.max - n.min);
        return p > n.maxPercentage ? n.maxPercentage : p;
      }
      return 50;
    }), c = P(() => n.minPercentage / 100 * n.max), d = P(() => n.maxPercentage / 100 * n.max);
    Ue(() => {
      var p;
      (p = a.value) == null || p.addEventListener("input", () => {
        var m;
        const h = ((m = a == null ? void 0 : a.value) == null ? void 0 : m.value) || 0;
        Number(h) < c.value && a.value && (a.value.value = c.value.toString(), s.value = c.value), Number(h) > d.value && a.value && (a.value.value = d.value.toString(), s.value = d.value);
      });
    });
    const f = (p) => {
      const m = 100 * (Number(p.target.value) - n.min) / (n.max - n.min), g = Math.min(Math.max(m, n.minPercentage), n.maxPercentage) * (n.max - n.min) / 100 + n.min;
      s.value = Number(g.toFixed(2)), r("update:modelValue", s.value);
    };
    return (p, h) => (C(), T("div", Jy, [
      n.label ? (C(), T("label", {
        key: 0,
        class: "mb-0.5 inline-block",
        for: x(Te)(p.name)
      }, H(n.label), 9, Qy)) : K("", !0),
      S("input", {
        id: x(Te)(n.name),
        ref_key: "rangeInput",
        ref: a,
        value: x(s),
        name: n.name,
        type: "range",
        min: n.min,
        max: n.max,
        step: n.step,
        disabled: p.disabled,
        class: z([{
          "input-error": x(i),
          "input-success": x(o).dirty && x(o).valid
        }, "money-range absolute z-20 block w-full"]),
        "data-test-id": "finance-range-input",
        onInput: f
      }, null, 42, ex),
      S("div", tx, [
        U(x(te), {
          icon: ["fad", "coins"],
          class: z(["absolute left-4 top-[9px] z-10 text-2xl", {
            "fa-light": u.value > 3
          }])
        }, null, 8, ["class"]),
        U(x(te), {
          icon: ["fad", "house"],
          class: "absolute right-4 top-[9px] z-[8] text-2xl"
        }),
        S("div", {
          style: en({ width: `${u.value}%` }),
          class: "absolute top-0 left-0 z-[9] h-full bg-blue-700 flex justify-end items-center"
        }, [
          Ce(p.$slots, "rangeText", {}, void 0, !0),
          S("div", nx, [
            S("div", rx, [
              U(x(te), {
                size: "sm",
                icon: ["fas", "arrows-left-right"],
                class: "mx-auto z-10 text-white"
              })
            ])
          ])
        ], 4)
      ]),
      S("span", {
        class: "triangle absolute -bottom-4",
        style: en({ left: `calc(${n.minPercentage}% - 8px)` })
      }, null, 4),
      S("span", {
        class: "triangle absolute -bottom-4",
        style: en({ left: `calc(${n.maxPercentage}% - 8px)` })
      }, null, 4)
    ]));
  }
}), sx = /* @__PURE__ */ Ct(ix, [["__scopeId", "data-v-8ca680f8"]]), ox = ["innerHTML"], lx = {
  name: "AppRulesCheckList"
}, ux = /* @__PURE__ */ re({
  ...lx,
  props: {
    checklist: {},
    label: { default: "" }
  },
  setup(e) {
    const t = e;
    return (n, r) => (C(), T("div", null, [
      rt(H(t.label) + " ", 1),
      (C(!0), T(Oe, null, Fe(t.checklist, (a) => (C(), T("div", {
        key: a.label,
        class: "flex items-center justify-start"
      }, [
        U(x(te), {
          class: z([{ invisible: !a.value }, "mr-2 text-blue-500"]),
          icon: ["fas", "check"]
        }, null, 8, ["class"]),
        S("span", {
          innerHTML: a.label
        }, null, 8, ox)
      ]))), 128))
    ]));
  }
});
function cx(e, t, n) {
  let r = N(n == null ? void 0 : n.value), a = P(() => e.value !== void 0);
  return [P(() => a.value ? e.value : r.value), function(i) {
    return a.value || (r.value = i), t == null ? void 0 : t(i);
  }];
}
var Gc;
let dx = Symbol("headlessui.useid"), fx = 0;
const Bi = (Gc = n1.useId) != null ? Gc : function() {
  return n1.inject(dx, () => `${++fx}`)();
};
function Ze(e) {
  var t;
  if (e == null || e.value == null) return null;
  let n = (t = e.value.$el) != null ? t : e.value;
  return n instanceof Node ? n : null;
}
function Ut(e, t, ...n) {
  if (e in t) {
    let a = t[e];
    return typeof a == "function" ? a(...n) : a;
  }
  let r = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((a) => `"${a}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(r, Ut), r;
}
var px = Object.defineProperty, hx = (e, t, n) => t in e ? px(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, qc = (e, t, n) => (hx(e, typeof t != "symbol" ? t + "" : t, n), n);
let mx = class {
  constructor() {
    qc(this, "current", this.detect()), qc(this, "currentId", 0);
  }
  set(t) {
    this.current !== t && (this.currentId = 0, this.current = t);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
}, hu = new mx();
function vx(e) {
  if (hu.isServer) return null;
  if (e instanceof Node) return e.ownerDocument;
  if (e != null && e.hasOwnProperty("value")) {
    let t = Ze(e);
    if (t) return t.ownerDocument;
  }
  return document;
}
let Wc = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var gx = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e))(gx || {}), bx = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(bx || {}), $x = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))($x || {}), mu = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(mu || {});
function O3(e, t = 0) {
  var n;
  return e === ((n = vx(e)) == null ? void 0 : n.body) ? !1 : Ut(t, { 0() {
    return e.matches(Wc);
  }, 1() {
    let r = e;
    for (; r !== null; ) {
      if (r.matches(Wc)) return !0;
      r = r.parentElement;
    }
    return !1;
  } });
}
var yx = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(yx || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function xx(e, t = (n) => n) {
  return e.slice().sort((n, r) => {
    let a = t(n), i = t(r);
    if (a === null || i === null) return 0;
    let s = a.compareDocumentPosition(i);
    return s & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : s & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function _x() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function wx() {
  return /Android/gi.test(window.navigator.userAgent);
}
function Sx() {
  return _x() || wx();
}
function Aa(e, t, n) {
  hu.isServer || Er((r) => {
    document.addEventListener(e, t, n), r(() => document.removeEventListener(e, t, n));
  });
}
function Cx(e, t, n) {
  hu.isServer || Er((r) => {
    window.addEventListener(e, t, n), r(() => window.removeEventListener(e, t, n));
  });
}
function Ax(e, t, n = P(() => !0)) {
  function r(i, s) {
    if (!n.value || i.defaultPrevented) return;
    let o = s(i);
    if (o === null || !o.getRootNode().contains(o)) return;
    let l = function u(c) {
      return typeof c == "function" ? u(c()) : Array.isArray(c) || c instanceof Set ? c : [c];
    }(e);
    for (let u of l) {
      if (u === null) continue;
      let c = u instanceof HTMLElement ? u : Ze(u);
      if (c != null && c.contains(o) || i.composed && i.composedPath().includes(c)) return;
    }
    return !O3(o, mu.Loose) && o.tabIndex !== -1 && i.preventDefault(), t(i, o);
  }
  let a = N(null);
  Aa("pointerdown", (i) => {
    var s, o;
    n.value && (a.value = ((o = (s = i.composedPath) == null ? void 0 : s.call(i)) == null ? void 0 : o[0]) || i.target);
  }, !0), Aa("mousedown", (i) => {
    var s, o;
    n.value && (a.value = ((o = (s = i.composedPath) == null ? void 0 : s.call(i)) == null ? void 0 : o[0]) || i.target);
  }, !0), Aa("click", (i) => {
    Sx() || a.value && (r(i, () => a.value), a.value = null);
  }, !0), Aa("touchend", (i) => r(i, () => i.target instanceof HTMLElement ? i.target : null), !0), Cx("blur", (i) => r(i, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function Yc(e, t) {
  if (e) return e;
  let n = t ?? "button";
  if (typeof n == "string" && n.toLowerCase() === "button") return "button";
}
function Ex(e, t) {
  let n = N(Yc(e.value.type, e.value.as));
  return Ue(() => {
    n.value = Yc(e.value.type, e.value.as);
  }), Er(() => {
    var r;
    n.value || Ze(t) && Ze(t) instanceof HTMLButtonElement && !((r = Ze(t)) != null && r.hasAttribute("type")) && (n.value = "button");
  }), n;
}
function Kc(e) {
  return [e.screenX, e.screenY];
}
function Ox() {
  let e = N([-1, -1]);
  return { wasMoved(t) {
    let n = Kc(t);
    return e.value[0] === n[0] && e.value[1] === n[1] ? !1 : (e.value = n, !0);
  }, update(t) {
    e.value = Kc(t);
  } };
}
var vl = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(vl || {}), Tx = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(Tx || {});
function Tr({ visible: e = !0, features: t = 0, ourProps: n, theirProps: r, ...a }) {
  var i;
  let s = M3(r, n), o = Object.assign(a, { props: s });
  if (e || t & 2 && s.static) return ys(o);
  if (t & 1) {
    let l = (i = s.unmount) == null || i ? 0 : 1;
    return Ut(l, { 0() {
      return null;
    }, 1() {
      return ys({ ...a, props: { ...s, hidden: !0, style: { display: "none" } } });
    } });
  }
  return ys(o);
}
function ys({ props: e, attrs: t, slots: n, slot: r, name: a }) {
  var i, s;
  let { as: o, ...l } = k3(e, ["unmount", "static"]), u = (i = n.default) == null ? void 0 : i.call(n, r), c = {};
  if (r) {
    let d = !1, f = [];
    for (let [p, h] of Object.entries(r)) typeof h == "boolean" && (d = !0), h === !0 && f.push(p);
    d && (c["data-headlessui-state"] = f.join(" "));
  }
  if (o === "template") {
    if (u = T3(u ?? []), Object.keys(l).length > 0 || Object.keys(t).length > 0) {
      let [d, ...f] = u ?? [];
      if (!kx(d) || f.length > 0) throw new Error(['Passing props on "template"!', "", `The current component <${a} /> is rendering a "template".`, "However we need to passthrough the following props:", Object.keys(l).concat(Object.keys(t)).map((m) => m.trim()).filter((m, v, g) => g.indexOf(m) === v).sort((m, v) => m.localeCompare(v)).map((m) => `  - ${m}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "template".', "Render a single element as the child so that we can forward the props onto that element."].map((m) => `  - ${m}`).join(`
`)].join(`
`));
      let p = M3((s = d.props) != null ? s : {}, l, c), h = Jp(d, p, !0);
      for (let m in p) m.startsWith("on") && (h.props || (h.props = {}), h.props[m] = p[m]);
      return h;
    }
    return Array.isArray(u) && u.length === 1 ? u[0] : u;
  }
  return et(o, Object.assign({}, l, c), { default: () => u });
}
function T3(e) {
  return e.flatMap((t) => t.type === Oe ? T3(t.children) : [t]);
}
function M3(...e) {
  if (e.length === 0) return {};
  if (e.length === 1) return e[0];
  let t = {}, n = {};
  for (let r of e) for (let a in r) a.startsWith("on") && typeof r[a] == "function" ? (n[a] != null || (n[a] = []), n[a].push(r[a])) : t[a] = r[a];
  if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(n).map((r) => [r, void 0])));
  for (let r in n) Object.assign(t, { [r](a, ...i) {
    let s = n[r];
    for (let o of s) {
      if (a instanceof Event && a.defaultPrevented) return;
      o(a, ...i);
    }
  } });
  return t;
}
function Mx(e) {
  let t = Object.assign({}, e);
  for (let n in t) t[n] === void 0 && delete t[n];
  return t;
}
function k3(e, t = []) {
  let n = Object.assign({}, e);
  for (let r of t) r in n && delete n[r];
  return n;
}
function kx(e) {
  return e == null ? !1 : typeof e.type == "string" || typeof e.type == "object" || typeof e.type == "function";
}
var L3 = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(L3 || {});
let Lx = re({ name: "Hidden", props: { as: { type: [Object, String], default: "div" }, features: { type: Number, default: 1 } }, setup(e, { slots: t, attrs: n }) {
  return () => {
    var r;
    let { features: a, ...i } = e, s = { "aria-hidden": (a & 2) === 2 ? !0 : (r = i["aria-hidden"]) != null ? r : void 0, hidden: (a & 4) === 4 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(a & 4) === 4 && (a & 2) !== 2 && { display: "none" } } };
    return Tr({ ourProps: s, theirProps: i, slot: {}, attrs: n, slots: t, name: "Hidden" });
  };
} }), F3 = Symbol("Context");
var ia = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(ia || {});
function Fx() {
  return da(F3, null);
}
function zx(e) {
  Wn(F3, e);
}
var nt = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(nt || {});
function Px(e) {
  throw new Error("Unexpected object: " + e);
}
var ht = ((e) => (e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))(ht || {});
function Ix(e, t) {
  let n = t.resolveItems();
  if (n.length <= 0) return null;
  let r = t.resolveActiveIndex(), a = r ?? -1;
  switch (e.focus) {
    case 0: {
      for (let i = 0; i < n.length; ++i) if (!t.resolveDisabled(n[i], i, n)) return i;
      return r;
    }
    case 1: {
      a === -1 && (a = n.length);
      for (let i = a - 1; i >= 0; --i) if (!t.resolveDisabled(n[i], i, n)) return i;
      return r;
    }
    case 2: {
      for (let i = a + 1; i < n.length; ++i) if (!t.resolveDisabled(n[i], i, n)) return i;
      return r;
    }
    case 3: {
      for (let i = n.length - 1; i >= 0; --i) if (!t.resolveDisabled(n[i], i, n)) return i;
      return r;
    }
    case 4: {
      for (let i = 0; i < n.length; ++i) if (t.resolveId(n[i], i, n) === e.id) return i;
      return r;
    }
    case 5:
      return null;
    default:
      Px(e);
  }
}
function z3(e = {}, t = null, n = []) {
  for (let [r, a] of Object.entries(e)) I3(n, P3(t, r), a);
  return n;
}
function P3(e, t) {
  return e ? e + "[" + t + "]" : t;
}
function I3(e, t, n) {
  if (Array.isArray(n)) for (let [r, a] of n.entries()) I3(e, P3(t, r.toString()), a);
  else n instanceof Date ? e.push([t, n.toISOString()]) : typeof n == "boolean" ? e.push([t, n ? "1" : "0"]) : typeof n == "string" ? e.push([t, n]) : typeof n == "number" ? e.push([t, `${n}`]) : n == null ? e.push([t, ""]) : z3(n, t, e);
}
let Zc = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function Xc(e) {
  var t, n;
  let r = (t = e.innerText) != null ? t : "", a = e.cloneNode(!0);
  if (!(a instanceof HTMLElement)) return r;
  let i = !1;
  for (let o of a.querySelectorAll('[hidden],[aria-hidden],[role="img"]')) o.remove(), i = !0;
  let s = i ? (n = a.innerText) != null ? n : "" : r;
  return Zc.test(s) && (s = s.replace(Zc, "")), s;
}
function Nx(e) {
  let t = e.getAttribute("aria-label");
  if (typeof t == "string") return t.trim();
  let n = e.getAttribute("aria-labelledby");
  if (n) {
    let r = n.split(" ").map((a) => {
      let i = document.getElementById(a);
      if (i) {
        let s = i.getAttribute("aria-label");
        return typeof s == "string" ? s.trim() : Xc(i).trim();
      }
      return null;
    }).filter(Boolean);
    if (r.length > 0) return r.join(", ");
  }
  return Xc(e).trim();
}
function Dx(e) {
  let t = N(""), n = N("");
  return () => {
    let r = Ze(e);
    if (!r) return "";
    let a = r.innerText;
    if (t.value === a) return n.value;
    let i = Nx(r).trim().toLowerCase();
    return t.value = a, n.value = i, i;
  };
}
function Rx(e, t) {
  return e === t;
}
var jx = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(jx || {}), Bx = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(Bx || {}), Vx = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(Vx || {});
function Ux(e) {
  requestAnimationFrame(() => requestAnimationFrame(e));
}
let N3 = Symbol("ListboxContext");
function ha(e) {
  let t = da(N3, null);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, ha), n;
  }
  return t;
}
let Hx = re({ name: "Listbox", emits: { "update:modelValue": (e) => !0 }, props: { as: { type: [Object, String], default: "template" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], default: () => Rx }, horizontal: { type: [Boolean], default: !1 }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, multiple: { type: [Boolean], default: !1 } }, inheritAttrs: !1, setup(e, { slots: t, attrs: n, emit: r }) {
  let a = N(1), i = N(null), s = N(null), o = N(null), l = N([]), u = N(""), c = N(null), d = N(1);
  function f($ = (y) => y) {
    let y = c.value !== null ? l.value[c.value] : null, A = xx($(l.value.slice()), (L) => Ze(L.dataRef.domRef)), E = y ? A.indexOf(y) : null;
    return E === -1 && (E = null), { options: A, activeOptionIndex: E };
  }
  let p = P(() => e.multiple ? 1 : 0), [h, m] = cx(P(() => e.modelValue), ($) => r("update:modelValue", $), P(() => e.defaultValue)), v = P(() => h.value === void 0 ? Ut(p.value, { 1: [], 0: void 0 }) : h.value), g = { listboxState: a, value: v, mode: p, compare($, y) {
    if (typeof e.by == "string") {
      let A = e.by;
      return ($ == null ? void 0 : $[A]) === (y == null ? void 0 : y[A]);
    }
    return e.by($, y);
  }, orientation: P(() => e.horizontal ? "horizontal" : "vertical"), labelRef: i, buttonRef: s, optionsRef: o, disabled: P(() => e.disabled), options: l, searchQuery: u, activeOptionIndex: c, activationTrigger: d, closeListbox() {
    e.disabled || a.value !== 1 && (a.value = 1, c.value = null);
  }, openListbox() {
    e.disabled || a.value !== 0 && (a.value = 0);
  }, goToOption($, y, A) {
    if (e.disabled || a.value === 1) return;
    let E = f(), L = Ix($ === ht.Specific ? { focus: ht.Specific, id: y } : { focus: $ }, { resolveItems: () => E.options, resolveActiveIndex: () => E.activeOptionIndex, resolveId: (D) => D.id, resolveDisabled: (D) => D.dataRef.disabled });
    u.value = "", c.value = L, d.value = A ?? 1, l.value = E.options;
  }, search($) {
    if (e.disabled || a.value === 1) return;
    let y = u.value !== "" ? 0 : 1;
    u.value += $.toLowerCase();
    let A = (c.value !== null ? l.value.slice(c.value + y).concat(l.value.slice(0, c.value + y)) : l.value).find((L) => L.dataRef.textValue.startsWith(u.value) && !L.dataRef.disabled), E = A ? l.value.indexOf(A) : -1;
    E === -1 || E === c.value || (c.value = E, d.value = 1);
  }, clearSearch() {
    e.disabled || a.value !== 1 && u.value !== "" && (u.value = "");
  }, registerOption($, y) {
    let A = f((E) => [...E, { id: $, dataRef: y }]);
    l.value = A.options, c.value = A.activeOptionIndex;
  }, unregisterOption($) {
    let y = f((A) => {
      let E = A.findIndex((L) => L.id === $);
      return E !== -1 && A.splice(E, 1), A;
    });
    l.value = y.options, c.value = y.activeOptionIndex, d.value = 1;
  }, theirOnChange($) {
    e.disabled || m($);
  }, select($) {
    e.disabled || m(Ut(p.value, { 0: () => $, 1: () => {
      let y = Rt(g.value.value).slice(), A = Rt($), E = y.findIndex((L) => g.compare(A, Rt(L)));
      return E === -1 ? y.push(A) : y.splice(E, 1), y;
    } }));
  } };
  Ax([s, o], ($, y) => {
    var A;
    g.closeListbox(), O3(y, mu.Loose) || ($.preventDefault(), (A = Ze(s)) == null || A.focus());
  }, P(() => a.value === 0)), Wn(N3, g), zx(P(() => Ut(a.value, { 0: ia.Open, 1: ia.Closed })));
  let b = P(() => {
    var $;
    return ($ = Ze(s)) == null ? void 0 : $.closest("form");
  });
  return Ue(() => {
    De([b], () => {
      if (!b.value || e.defaultValue === void 0) return;
      function $() {
        g.theirOnChange(e.defaultValue);
      }
      return b.value.addEventListener("reset", $), () => {
        var y;
        (y = b.value) == null || y.removeEventListener("reset", $);
      };
    }, { immediate: !0 });
  }), () => {
    let { name: $, modelValue: y, disabled: A, form: E, ...L } = e, D = { open: a.value === 0, disabled: A, value: v.value };
    return et(Oe, [...$ != null && v.value != null ? z3({ [$]: v.value }).map(([ne, I]) => et(Lx, Mx({ features: L3.Hidden, key: ne, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: E, disabled: A, name: ne, value: I }))) : [], Tr({ ourProps: {}, theirProps: { ...n, ...k3(L, ["defaultValue", "onUpdate:modelValue", "horizontal", "multiple", "by"]) }, slot: D, slots: t, attrs: n, name: "Listbox" })]);
  };
} }), Gx = re({ name: "ListboxLabel", props: { as: { type: [Object, String], default: "label" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: n }) {
  var r;
  let a = (r = e.id) != null ? r : `headlessui-listbox-label-${Bi()}`, i = ha("ListboxLabel");
  function s() {
    var o;
    (o = Ze(i.buttonRef)) == null || o.focus({ preventScroll: !0 });
  }
  return () => {
    let o = { open: i.listboxState.value === 0, disabled: i.disabled.value }, { ...l } = e, u = { id: a, ref: i.labelRef, onClick: s };
    return Tr({ ourProps: u, theirProps: l, slot: o, attrs: t, slots: n, name: "ListboxLabel" });
  };
} }), qx = re({ name: "ListboxButton", props: { as: { type: [Object, String], default: "button" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: n, expose: r }) {
  var a;
  let i = (a = e.id) != null ? a : `headlessui-listbox-button-${Bi()}`, s = ha("ListboxButton");
  r({ el: s.buttonRef, $el: s.buttonRef });
  function o(d) {
    switch (d.key) {
      case nt.Space:
      case nt.Enter:
      case nt.ArrowDown:
        d.preventDefault(), s.openListbox(), We(() => {
          var f;
          (f = Ze(s.optionsRef)) == null || f.focus({ preventScroll: !0 }), s.value.value || s.goToOption(ht.First);
        });
        break;
      case nt.ArrowUp:
        d.preventDefault(), s.openListbox(), We(() => {
          var f;
          (f = Ze(s.optionsRef)) == null || f.focus({ preventScroll: !0 }), s.value.value || s.goToOption(ht.Last);
        });
        break;
    }
  }
  function l(d) {
    switch (d.key) {
      case nt.Space:
        d.preventDefault();
        break;
    }
  }
  function u(d) {
    s.disabled.value || (s.listboxState.value === 0 ? (s.closeListbox(), We(() => {
      var f;
      return (f = Ze(s.buttonRef)) == null ? void 0 : f.focus({ preventScroll: !0 });
    })) : (d.preventDefault(), s.openListbox(), Ux(() => {
      var f;
      return (f = Ze(s.optionsRef)) == null ? void 0 : f.focus({ preventScroll: !0 });
    })));
  }
  let c = Ex(P(() => ({ as: e.as, type: t.type })), s.buttonRef);
  return () => {
    var d, f;
    let p = { open: s.listboxState.value === 0, disabled: s.disabled.value, value: s.value.value }, { ...h } = e, m = { ref: s.buttonRef, id: i, type: c.value, "aria-haspopup": "listbox", "aria-controls": (d = Ze(s.optionsRef)) == null ? void 0 : d.id, "aria-expanded": s.listboxState.value === 0, "aria-labelledby": s.labelRef.value ? [(f = Ze(s.labelRef)) == null ? void 0 : f.id, i].join(" ") : void 0, disabled: s.disabled.value === !0 ? !0 : void 0, onKeydown: o, onKeyup: l, onClick: u };
    return Tr({ ourProps: m, theirProps: h, slot: p, attrs: t, slots: n, name: "ListboxButton" });
  };
} }), Wx = re({ name: "ListboxOptions", props: { as: { type: [Object, String], default: "ul" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: n, expose: r }) {
  var a;
  let i = (a = e.id) != null ? a : `headlessui-listbox-options-${Bi()}`, s = ha("ListboxOptions"), o = N(null);
  r({ el: s.optionsRef, $el: s.optionsRef });
  function l(d) {
    switch (o.value && clearTimeout(o.value), d.key) {
      case nt.Space:
        if (s.searchQuery.value !== "") return d.preventDefault(), d.stopPropagation(), s.search(d.key);
      case nt.Enter:
        if (d.preventDefault(), d.stopPropagation(), s.activeOptionIndex.value !== null) {
          let f = s.options.value[s.activeOptionIndex.value];
          s.select(f.dataRef.value);
        }
        s.mode.value === 0 && (s.closeListbox(), We(() => {
          var f;
          return (f = Ze(s.buttonRef)) == null ? void 0 : f.focus({ preventScroll: !0 });
        }));
        break;
      case Ut(s.orientation.value, { vertical: nt.ArrowDown, horizontal: nt.ArrowRight }):
        return d.preventDefault(), d.stopPropagation(), s.goToOption(ht.Next);
      case Ut(s.orientation.value, { vertical: nt.ArrowUp, horizontal: nt.ArrowLeft }):
        return d.preventDefault(), d.stopPropagation(), s.goToOption(ht.Previous);
      case nt.Home:
      case nt.PageUp:
        return d.preventDefault(), d.stopPropagation(), s.goToOption(ht.First);
      case nt.End:
      case nt.PageDown:
        return d.preventDefault(), d.stopPropagation(), s.goToOption(ht.Last);
      case nt.Escape:
        d.preventDefault(), d.stopPropagation(), s.closeListbox(), We(() => {
          var f;
          return (f = Ze(s.buttonRef)) == null ? void 0 : f.focus({ preventScroll: !0 });
        });
        break;
      case nt.Tab:
        d.preventDefault(), d.stopPropagation();
        break;
      default:
        d.key.length === 1 && (s.search(d.key), o.value = setTimeout(() => s.clearSearch(), 350));
        break;
    }
  }
  let u = Fx(), c = P(() => u !== null ? (u.value & ia.Open) === ia.Open : s.listboxState.value === 0);
  return () => {
    var d, f;
    let p = { open: s.listboxState.value === 0 }, { ...h } = e, m = { "aria-activedescendant": s.activeOptionIndex.value === null || (d = s.options.value[s.activeOptionIndex.value]) == null ? void 0 : d.id, "aria-multiselectable": s.mode.value === 1 ? !0 : void 0, "aria-labelledby": (f = Ze(s.buttonRef)) == null ? void 0 : f.id, "aria-orientation": s.orientation.value, id: i, onKeydown: l, role: "listbox", tabIndex: 0, ref: s.optionsRef };
    return Tr({ ourProps: m, theirProps: h, slot: p, attrs: t, slots: n, features: vl.RenderStrategy | vl.Static, visible: c.value, name: "ListboxOptions" });
  };
} }), Yx = re({ name: "ListboxOption", props: { as: { type: [Object, String], default: "li" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: null } }, setup(e, { slots: t, attrs: n, expose: r }) {
  var a;
  let i = (a = e.id) != null ? a : `headlessui-listbox-option-${Bi()}`, s = ha("ListboxOption"), o = N(null);
  r({ el: o, $el: o });
  let l = P(() => s.activeOptionIndex.value !== null ? s.options.value[s.activeOptionIndex.value].id === i : !1), u = P(() => Ut(s.mode.value, { 0: () => s.compare(Rt(s.value.value), Rt(e.value)), 1: () => Rt(s.value.value).some(($) => s.compare(Rt($), Rt(e.value))) })), c = P(() => Ut(s.mode.value, { 1: () => {
    var $;
    let y = Rt(s.value.value);
    return (($ = s.options.value.find((A) => y.some((E) => s.compare(Rt(E), Rt(A.dataRef.value))))) == null ? void 0 : $.id) === i;
  }, 0: () => u.value })), d = Dx(o), f = P(() => ({ disabled: e.disabled, value: e.value, get textValue() {
    return d();
  }, domRef: o }));
  Ue(() => s.registerOption(i, f)), Ti(() => s.unregisterOption(i)), Ue(() => {
    De([s.listboxState, u], () => {
      s.listboxState.value === 0 && u.value && Ut(s.mode.value, { 1: () => {
        c.value && s.goToOption(ht.Specific, i);
      }, 0: () => {
        s.goToOption(ht.Specific, i);
      } });
    }, { immediate: !0 });
  }), Er(() => {
    s.listboxState.value === 0 && l.value && s.activationTrigger.value !== 0 && We(() => {
      var $, y;
      return (y = ($ = Ze(o)) == null ? void 0 : $.scrollIntoView) == null ? void 0 : y.call($, { block: "nearest" });
    });
  });
  function p($) {
    if (e.disabled) return $.preventDefault();
    s.select(e.value), s.mode.value === 0 && (s.closeListbox(), We(() => {
      var y;
      return (y = Ze(s.buttonRef)) == null ? void 0 : y.focus({ preventScroll: !0 });
    }));
  }
  function h() {
    if (e.disabled) return s.goToOption(ht.Nothing);
    s.goToOption(ht.Specific, i);
  }
  let m = Ox();
  function v($) {
    m.update($);
  }
  function g($) {
    m.wasMoved($) && (e.disabled || l.value || s.goToOption(ht.Specific, i, 0));
  }
  function b($) {
    m.wasMoved($) && (e.disabled || l.value && s.goToOption(ht.Nothing));
  }
  return () => {
    let { disabled: $ } = e, y = { active: l.value, selected: u.value, disabled: $ }, { value: A, disabled: E, ...L } = e, D = { id: i, ref: o, role: "option", tabIndex: $ === !0 ? void 0 : -1, "aria-disabled": $ === !0 ? !0 : void 0, "aria-selected": u.value, disabled: void 0, onClick: p, onFocus: h, onPointerenter: v, onMouseenter: v, onPointermove: g, onMousemove: g, onPointerleave: b, onMouseleave: b };
    return Tr({ ourProps: D, theirProps: L, slot: y, attrs: n, slots: t, name: "ListboxOption" });
  };
} });
const Kx = { class: "mb-4 w-full" }, Zx = ["name"], Xx = { class: "relative" }, Jx = { class: "absolute top-3 left-3 z-[1] flex" }, Qx = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2" }, e_ = ["data-test-id"], t_ = {
  key: 1,
  class: "absolute inset-y-0 right-0 flex items-center pr-4"
}, n_ = {
  key: 0,
  class: "text-sm text-orange-900"
}, r_ = {
  name: "AppSelect"
}, a_ = /* @__PURE__ */ re({
  ...r_,
  props: {
    name: {},
    modelValue: {},
    options: {},
    label: { default: "" },
    placeholder: { default: "Selecteer..." },
    icon: { default: "" },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = P(() => {
      var l;
      return (l = n.options) == null ? void 0 : l.find((u) => u.value === n.modelValue);
    }), {
      errorMessage: i,
      value: s,
      meta: o
    } = Tt(n.name, void 0, {
      initialValue: n.modelValue
    });
    return De(
      () => n.modelValue,
      (l) => {
        s.value = l ?? "";
      }
    ), (l, u) => (C(), T("div", Kx, [
      ct(S("input", {
        "onUpdate:modelValue": u[0] || (u[0] = (c) => Ht(s) ? s.value = c : null),
        name: x(Te)(n.name),
        hidden: ""
      }, null, 8, Zx), [
        [er, x(s)]
      ]),
      U(x(Hx), {
        "model-value": n.modelValue,
        as: "div",
        "onUpdate:modelValue": u[1] || (u[1] = (c) => r("update:modelValue", c))
      }, {
        default: fe(() => [
          n.label ? (C(), ve(x(Gx), {
            key: 0,
            class: "mb-0.5 inline-block",
            "data-test-id": "select-label"
          }, {
            default: fe(() => [
              rt(H(n.label), 1)
            ]),
            _: 1
          })) : K("", !0),
          S("div", Xx, [
            S("div", Jx, [
              n.icon ? (C(), ve(x(te), {
                key: 0,
                icon: ["fad", n.icon],
                size: "lg"
              }, null, 8, ["icon"])) : K("", !0)
            ]),
            U(x(qx), {
              class: z(["relative w-full cursor-default rounded-lg border border-blue-300 bg-white py-2 pl-3 pr-10 text-left focus:shadow-active disabled:bg-gray-100 disabled:text-gray-700", {
                "input-error": x(i),
                "input-success": x(o).dirty && x(o).valid
              }]),
              "data-test-id": "select-button",
              disabled: n.disabled
            }, {
              default: fe(() => {
                var c;
                return [
                  S("span", {
                    class: z(["block truncate", {
                      "pl-6": n.icon
                    }])
                  }, H(((c = a.value) == null ? void 0 : c.name) ?? n.placeholder), 3),
                  S("span", Qx, [
                    U(x(te), {
                      icon: ["fas", "chevron-down"],
                      class: "text-blue-700"
                    })
                  ])
                ];
              }),
              _: 1
            }, 8, ["class", "disabled"]),
            U(vr, {
              "leave-active-class": "transition ease-in duration-100",
              "leave-from-class": "opacity-100",
              "leave-transitionto-class": "opacity-0"
            }, {
              default: fe(() => [
                U(x(Wx), {
                  class: "absolute z-10 mt-2 max-h-60 w-full overflow-auto rounded-lg bg-white shadow-element ring-1 ring-black ring-opacity-5 focus:outline-none",
                  name: n.name
                }, {
                  default: fe(() => [
                    (C(!0), T(Oe, null, Fe(n.options, (c, d) => (C(), ve(x(Yx), {
                      key: d,
                      as: "template",
                      value: c.value
                    }, {
                      default: fe(({ active: f }) => [
                        S("li", {
                          class: z(["flex items-center gap-2", [
                            f && "bg-blue-200",
                            n.modelValue === c.value && "bg-primary-200",
                            "cursor-default select-none relative py-2 pl-3 pr-9 border-b border-gray-100"
                          ]]),
                          "data-test-id": `list-option-${d}`
                        }, [
                          c.icon ? (C(), ve(x(te), {
                            key: 0,
                            icon: ["fad", c.icon]
                          }, null, 8, ["icon"])) : K("", !0),
                          S("span", {
                            class: z([
                              n.modelValue === c.value ? "font-semibold" : "font-normal",
                              "block truncate"
                            ])
                          }, H(c.name), 3),
                          n.modelValue === c.value ? (C(), T("span", t_, [
                            U(x(te), { icon: ["fas", "check"] })
                          ])) : K("", !0)
                        ], 10, e_)
                      ]),
                      _: 2
                    }, 1032, ["value"]))), 128))
                  ]),
                  _: 1
                }, 8, ["name"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["model-value"]),
      x(i) ? (C(), T("span", n_, H(x(i)), 1)) : K("", !0)
    ]));
  }
}), i_ = {
  key: 0,
  class: "relative flex w-full flex-row gap-1",
  "data-test-id": "timer"
}, s_ = { class: "border-b border-blue-200 py-1 px-2 font-semibold" }, o_ = { class: "py-1 px-2 text-xs" }, l_ = /* @__PURE__ */ re({
  __name: "AppTimer",
  props: {
    background: { default: "" },
    url: { default: "" }
  },
  setup(e) {
    const t = e;
    G.extend(Pi), G.extend(r3);
    const n = N(G().utcOffset(nu)), r = new EventSource(t.url ?? ""), a = N(t.url === ""), i = (c) => Math.floor(Math.max(c, 0)).toString().padStart(2, "0"), s = P(() => {
      let c = G(n.value).day(2).hour(11).minute(0).second(0);
      (n.value.day() > 2 || n.value.day() === 2 && n.value.hour() > 11) && (c = c.add(1, "week"));
      const d = c.diff(n.value, "second");
      return {
        days: i(Math.floor(d / 86400)),
        hours: i(Math.floor(d / 3600) % 24),
        minutes: i(Math.floor(d / 60) % 60),
        seconds: i(d % 60)
      };
    }), o = (c) => {
      try {
        return JSON.parse(c.data);
      } catch (d) {
        return console.log("parseEventDataAsJSON", d), null;
      }
    }, l = (c) => {
      const d = o(c);
      d && (n.value = G(d.time));
    };
    let u;
    return Do(() => {
      u = setInterval(() => {
        n.value = n.value.add(1, "second");
      }, 1e3), r.addEventListener("ping", l), r.addEventListener("open", () => {
        a.value = !0;
      });
    }), Oi(() => {
      clearInterval(u), r.close();
    }), (c, d) => a.value ? (C(), T("div", i_, [
      (C(!0), T(Oe, null, Fe(s.value, (f, p) => (C(), T("div", {
        key: p,
        class: "relative w-full rounded-lg text-center shadow bg-white"
      }, [
        S("div", s_, H(f), 1),
        S("div", o_, H(p.slice(0, 1).toUpperCase()), 1)
      ]))), 128))
    ])) : K("", !0);
  }
}), u_ = { class: "ml-3 flex w-full flex-col" }, c_ = {
  key: 0,
  class: "text-base font-medium leading-6"
}, d_ = ["innerHTML"], f_ = {
  name: "AppToast"
}, gl = /* @__PURE__ */ re({
  ...f_,
  props: {
    theme: { default: "info" },
    dismissible: { type: Boolean, default: !0 },
    title: { default: void 0 },
    message: {}
  },
  emits: ["close", "click"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = P(() => {
      switch (n.theme) {
        case "success":
          return Hf;
        case "info":
          return Vf;
        case "warning":
          return Gf;
        case "error":
        default:
          return tl;
      }
    });
    return (i, s) => (C(), T("div", {
      class: z(["pointer-events-auto w-full rounded-[16px] text-white shadow-[0_2px_4px_rgba(0,0,0,0.33)]", {
        "bg-green-900": n.theme === "success",
        "bg-blue-900": n.theme === "info",
        "bg-red-900": n.theme === "error",
        "bg-orange-900": n.theme === "warning"
      }]),
      role: "alert"
    }, [
      S("div", {
        class: "relative flex size-full shrink items-center p-1 pr-11",
        onClick: s[1] || (s[1] = Se((o) => r("click", o), ["stop"]))
      }, [
        S("div", {
          class: z(["flex size-14 shrink-0 items-center justify-center rounded-[14px]", {
            "bg-green-700": n.theme === "success",
            "bg-blue-700": n.theme === "info",
            "bg-red-700": n.theme === "error",
            "bg-orange-700": n.theme === "warning"
          }])
        }, [
          U(x(te), {
            icon: a.value,
            size: "lg"
          }, null, 8, ["icon"])
        ], 2),
        S("div", u_, [
          n.title ? (C(), T("div", c_, H(n.title), 1)) : K("", !0),
          S("div", {
            class: "text-xs font-normal",
            innerHTML: n.message
          }, null, 8, d_)
        ]),
        n.dismissible ? (C(), T("div", {
          key: 0,
          class: "absolute top-0 right-0 p-3",
          onClick: s[0] || (s[0] = Se((o) => r("close"), ["stop"]))
        }, [
          U(x(te), {
            icon: x(tl),
            class: "block size-4"
          }, null, 8, ["icon"])
        ])) : K("", !0)
      ])
    ], 2));
  }
}), yr = Fn({
  toasts: /* @__PURE__ */ new Map()
}), p_ = {
  theme: "info",
  position: "bottom",
  dismissible: !0,
  duration: 5e3
}, h_ = (e) => {
  const t = yr.toasts.get(e);
  if (!t) throw new Error("Toast does not exist anymore.");
  t.visible = !0, t.options.duration && (t.timeout = window.setTimeout(t.dismiss, t.options.duration));
}, m_ = (e) => {
  const t = yr.toasts.get(e);
  if (!t) throw new Error("Toast does not exist anymore.");
  t.timeout && window.clearTimeout(t.timeout), t.options.onClose && t.options.onClose(), t.visible = !1;
}, v_ = (e) => {
  if (!yr.toasts.get(e)) throw new Error("Toast does not exist anymore.");
  yr.toasts.delete(e);
}, oY = async (e) => {
  const t = lu(16), n = {
    id: t,
    options: { ...p_, ...e },
    present: () => h_(t),
    dismiss: () => m_(t),
    destroy: () => v_(t),
    visible: !1
  };
  return yr.toasts.set(t, n), await We(), { present: n.present, dismiss: n.dismiss };
}, g_ = () => P(() => yr.toasts), b_ = { class: "pointer-events-none fixed inset-3 z-[100] flex flex-col" }, $_ = {
  name: "AppToasts"
}, y_ = /* @__PURE__ */ re({
  ...$_,
  setup(e) {
    const t = g_(), n = P(() => [...t.value.values()].filter((o) => o.options.position === "top")), r = P(() => [...t.value.values()].filter((o) => o.options.position === "bottom")), a = {
      enterActiveClass: "duration-300 ease delay-100",
      enterFromClass: "opacity-0",
      enterToClass: "opacity-100",
      leaveActiveClass: "ease duration-300",
      leaveFromClass: "opacity-100",
      leaveToClass: "opacity-0",
      moveClass: "delay-200 duration-300"
    }, i = (o) => {
      var u, c;
      const l = (u = o.attributes.getNamedItem("data-toast-id")) == null ? void 0 : u.value;
      l && ((c = t.value.get(l)) == null || c.destroy());
    }, s = (o) => {
      const l = o, u = getComputedStyle(o);
      l.style.left = `${l.offsetLeft}px`, l.style.top = `calc(${l.offsetTop}px - ${u.marginTop})`, l.style.height = u.height, l.style.width = u.width, l.style.position = "absolute";
    };
    return (o, l) => (C(), T("div", b_, [
      U(a1, zn(a, {
        class: "absolute right-0 top-0 flex w-full max-w-md flex-col-reverse items-end justify-center",
        tag: "div",
        "data-test-id": "transition-group",
        onBeforeLeave: s,
        onAfterLeave: i
      }), {
        default: fe(() => [
          (C(!0), T(Oe, null, Fe(n.value, (u) => ct((C(), ve(gl, {
            key: u.id,
            class: "mb-3",
            theme: u.options.theme,
            title: u.options.title,
            message: u.options.message,
            dismissible: u.options.dismissible,
            "data-toast-id": u.id,
            "data-test-id": `toast-${u.options.title}`,
            onClose: u.dismiss
          }, null, 8, ["theme", "title", "message", "dismissible", "data-toast-id", "data-test-id", "onClose"])), [
            [gr, u.visible]
          ])), 128))
        ]),
        _: 1
      }, 16),
      U(a1, zn(a, {
        class: "absolute right-0 bottom-0 flex w-full max-w-md flex-col items-end justify-center",
        tag: "div",
        "data-test-id": "transition-group",
        onBeforeLeave: s,
        onAfterLeave: i
      }), {
        default: fe(() => [
          (C(!0), T(Oe, null, Fe(r.value, (u) => ct((C(), ve(gl, {
            key: u.id,
            class: "mt-3",
            theme: u.options.theme,
            title: u.options.title,
            message: u.options.message,
            dismissible: u.options.dismissible,
            "data-toast-id": u.id,
            "data-test-id": `toast-${u.options.title}`,
            onClose: u.dismiss,
            onClick: () => {
              var c;
              return ((c = u.options) == null ? void 0 : c.onClick) && u.options.onClick();
            }
          }, null, 8, ["theme", "title", "message", "dismissible", "data-toast-id", "data-test-id", "onClose", "onClick"])), [
            [gr, u.visible]
          ])), 128))
        ]),
        _: 1
      }, 16)
    ]));
  }
}), x_ = { class: "relative w-full" }, __ = { class: "whitespace-normal" }, w_ = ["innerHTML"], S_ = {
  name: "AppTooltip"
}, D3 = /* @__PURE__ */ re({
  ...S_,
  props: {
    content: {},
    elementLeft: {},
    elementTop: {},
    elementWidth: {},
    elementHeight: {}
  },
  setup(e) {
    const t = e, n = N(0), r = N(0), a = N(!0), i = N(!1), s = 320, o = 80, l = 12, u = () => {
      const p = t.elementTop - l, h = window.innerWidth;
      let m = p;
      a.value = m > o, a.value || (m = t.elementTop + t.elementHeight + l);
      let v = t.elementLeft + t.elementWidth / 2 - s / 2;
      v < 0 ? v = l : v + s > h && (v = h - s - l), n.value = v, r.value = m, i.value = !0;
    }, c = () => {
      u();
    }, d = (p) => {
      const h = p, m = h.clientX, v = h.clientY;
      m >= t.elementLeft && m <= t.elementLeft + t.elementWidth && v >= t.elementTop && v <= t.elementTop + t.elementHeight || (i.value = !1);
    }, f = async () => {
      await We(), u();
    };
    return Ue(() => {
      f(), window.addEventListener("mousemove", c), window.addEventListener("scroll", d), window.addEventListener("mouseleave", d);
    }), Ti(() => {
      window.removeEventListener("mousemove", c), window.removeEventListener("scroll", d), window.removeEventListener("mouseleave", d);
    }), (p, h) => i.value ? (C(), T("div", zn({
      key: 0,
      class: "fixed z-[450] w-80 text-center transition-opacity delay-500 duration-300 before:absolute before:border-x-[12px] before:border-x-transparent before:content-['']",
      style: { left: n.value + "px", top: r.value + "px" }
    }, p.$attrs), [
      S("div", x_, [
        S("div", {
          class: z(["absolute flex w-full items-center justify-center rounded-2xl bg-white p-4 text-sm font-normal leading-5 shadow-light", { "bottom-0": a.value, "top-0": !a.value }])
        }, [
          S("span", __, [
            t.content ? (C(), T("p", {
              key: 0,
              class: "text-left",
              innerHTML: t.content
            }, null, 8, w_)) : Ce(p.$slots, "content", { key: 1 })
          ])
        ], 2)
      ])
    ], 16)) : K("", !0);
  }
}), R3 = /* @__PURE__ */ re({
  __name: "FormWrapper",
  props: {
    schema: {},
    buttonText: { default: "Opslaan" },
    buttonType: { default: "primary" },
    buttonColor: { default: "green" },
    buttonFullWidth: { type: Boolean, default: !0 },
    buttonIcon: { default: "" },
    hideButton: { type: Boolean, default: !1 },
    initialValues: { default: void 0 },
    loading: { type: Boolean },
    extrasValidated: { type: Boolean, default: !0 },
    isSubmitDisabled: { type: Boolean, default: !1 }
  },
  emits: ["submit"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = (s) => {
      r("submit", s);
    }, i = () => {
      setTimeout(() => {
        const s = document.querySelector(
          "span.error:first-of-type"
        ), o = s ? s.parentNode : null;
        o && o.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "start"
        });
      }, 500);
    };
    return (s, o) => (C(), ve(x(Kb), {
      "validation-schema": n.schema.validation,
      "initial-values": n.schema.values || n.initialValues,
      "data-test-id": "form",
      onSubmit: a,
      onInvalidSubmit: i
    }, {
      default: fe(({ meta: l, errors: u }) => [
        Ce(s.$slots, "default", {
          meta: l,
          errors: u
        }),
        n.hideButton ? K("", !0) : (C(), ve(St, {
          key: 0,
          "data-test-id": "dynamic-form-button",
          type: n.buttonType,
          color: n.buttonColor,
          class: z(["min-h-fit self-end", s.buttonFullWidth ? "w-full" : " w-fit"]),
          "is-disabled": l.valid === !1 || !s.extrasValidated || n.isSubmitDisabled,
          "is-loading": n.loading
        }, af({
          default: fe(() => [
            rt(H(n.buttonText) + " ", 1)
          ]),
          _: 2
        }, [
          n.buttonIcon ? {
            name: "icon-end",
            fn: fe(() => [
              U(x(te), {
                icon: ["fas", n.buttonIcon]
              }, null, 8, ["icon"])
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["type", "color", "class", "is-disabled", "is-loading"]))
      ]),
      _: 3
    }, 8, ["validation-schema", "initial-values"]));
  }
}), Xa = Fn({
  tooltips: /* @__PURE__ */ new Map()
}), pr = (e) => {
  const t = lu(16);
  Er(() => {
    const n = x(e.ref);
    n && (kn(n, "mouseenter", async () => {
      await We();
      const { left: r, top: a, width: i, height: s } = i$(n), o = {
        id: t,
        options: {
          ref: n,
          content: x(e.content),
          left: x(r) + ((e == null ? void 0 : e.left) ?? 0),
          top: x(a) + ((e == null ? void 0 : e.top) ?? 0),
          elementWidth: x(i),
          elementHeight: x(s),
          isOutside: !1
        }
      };
      Xa.tooltips.set(t, o);
    }), kn(n, "mouseleave", () => {
      Xa.tooltips.delete(t);
    }), kn(n, "click", () => {
      Xa.tooltips.delete(t);
    }));
  });
}, C_ = () => P(() => Xa.tooltips), A_ = { class: "flex grow flex-col gap-y-3" }, E_ = { class: "flex grow flex-col gap-y-3" }, O_ = {
  name: "AppOfferSpecificationList"
}, T_ = /* @__PURE__ */ re({
  ...O_,
  props: {
    object: {},
    fetching: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = N(null), r = N(null);
    return pr({
      ref: n,
      content: "De Loan-to-Value is de leensom afgezet tegen de koopsom van het object."
    }), (a, i) => (C(), T("div", {
      ref_key: "specifcations",
      ref: r,
      class: "flex flex-wrap gap-x-2 gap-y-3"
    }, [
      S("div", A_, [
        U(qn, {
          icon: "coins",
          label: "Leensom",
          text: t.object.entity.loan ? x(ra)(t.object.entity.loan) : "..",
          fetching: a.fetching
        }, null, 8, ["text", "fetching"]),
        U(qn, {
          ref_key: "ltvElement",
          ref: n,
          icon: "percent",
          label: "Loan-to-Value",
          text: `${t.object.entity.loan_to_value}%`,
          fetching: a.fetching
        }, null, 8, ["text", "fetching"])
      ]),
      S("div", E_, [
        U(qn, {
          icon: "house",
          label: t.object.value_type,
          text: t.object.entity.value ? x(ra)(t.object.entity.value) : "..",
          fetching: a.fetching
        }, null, 8, ["label", "text", "fetching"]),
        U(qn, {
          icon: "bell",
          label: "Te ontvangen rente",
          text: t.object.interest_to_receive ? `${t.object.interest_to_receive}%` : "..",
          fetching: a.fetching
        }, null, 8, ["text", "fetching"])
      ])
    ], 512));
  }
}), M_ = {
  key: 1,
  class: "text-white"
}, k_ = {
  key: 0,
  class: "break-all"
}, L_ = {
  key: 1,
  class: "mr-4 flex flex-col"
}, F_ = { class: "flex items-center" }, z_ = { class: "relative h-1 w-16 rounded-full bg-blue-100" }, P_ = {
  name: "AppOfferStatus"
}, I_ = /* @__PURE__ */ re({
  ...P_,
  props: {
    status: {},
    personalStatus: { default: null },
    isClubdeal: { type: Boolean },
    claimsAndOptions: {},
    claimPositions: {},
    loan: {}
  },
  setup(e) {
    const t = e, n = {
      claimed: "Geclaimd",
      optioned: "In optie",
      available: "Beschikbaar"
    }, r = P(() => {
      const c = t.claimsAndOptions.map((d) => d.status).filter((d) => d === "claimed" || d === "optioned");
      return Math.min((c == null ? void 0 : c.length) ?? 0, t == null ? void 0 : t.claimPositions);
    }), a = P(() => r.value / t.claimPositions * 100), i = P(() => ra(t.loan / t.claimPositions)), s = P(() => t.personalStatus && t.personalStatus === "claimed" ? t.isClubdeal ? "U heeft een deel van dit object geclaimd" : "U heeft dit object geclaimd" : t.personalStatus && t.personalStatus === "optioned" ? t.isClubdeal ? "U heeft een deel van dit object geopteerd" : "U heeft een optie op dit object" : t.status), o = P(() => t.status === n.claimed || t.personalStatus === "claimed" ? "flag" : t.status === n.optioned || t.personalStatus === "optioned" ? "timer" : "check"), l = P(() => {
      if (t.personalStatus && t.personalStatus === "optioned") return "U heeft een optie op dit object";
      if (t.personalStatus && t.personalStatus === "claimed") return "U heeft dit object geclaimed";
      switch (t.status) {
        case n.available:
          return "Dit object is voor u beschikbaar om te opteren of claimen";
        case n.optioned:
          return "Dit object heeft een optant, u kunt nog steeds opteren";
        case n.claimed:
          return "Dit object is geclaimd, u kunt helaas niet meer claimen";
        default:
          return "";
      }
    }), u = N(null);
    return pr({
      ref: u,
      content: l.value
    }), (c, d) => (C(), T("div", {
      ref_key: "tooltipElement",
      ref: u,
      class: z(["flex items-center rounded-full p-2 pr-5 text-xs font-medium leading-6", {
        "bg-green-100 text-green-900": c.status === n.available,
        "bg-orange-100 text-orange-900": c.status === n.optioned || c.personalStatus === "optioned",
        "bg-red-100 text-red-900": c.status === n.claimed || c.personalStatus === "claimed"
      }])
    }, [
      S("div", {
        class: z(["mr-2 flex size-6 items-center justify-center rounded-full text-xs font-medium leading-6", {
          "bg-green-900": c.status === n.available,
          "bg-orange-900": c.status === n.optioned || c.personalStatus === "optioned",
          "bg-red-900": c.status === n.claimed || c.personalStatus === "claimed"
        }])
      }, [
        c.isClubdeal ? (C(), T("span", M_, H(r.value) + "/" + H(c.claimPositions), 1)) : (C(), ve(x(te), {
          key: 0,
          icon: ["fas", o.value],
          class: "text-white",
          size: o.value === "flag" ? "1x" : "lg"
        }, null, 8, ["icon", "size"]))
      ], 2),
      c.isClubdeal ? (C(), T("div", L_, [
        S("p", null, "Clubdeal " + H(i.value), 1),
        S("div", F_, [
          S("div", z_, [
            S("div", {
              class: "absolute top-0 left-0 h-1 rounded-full bg-green-900",
              style: en(`width: ${a.value}%;`)
            }, null, 4)
          ])
        ])
      ])) : (C(), T("div", k_, H(s.value), 1))
    ], 2));
  }
}), N_ = {
  name: "AppCard"
}, D_ = { class: "relative flex w-full flex-col overflow-hidden rounded-3xl bg-white shadow-light" };
function R_(e, t, n, r, a, i) {
  return C(), T("article", D_, [
    Ce(e.$slots, "default")
  ]);
}
const j3 = /* @__PURE__ */ Ct(N_, [["render", R_]]), j_ = {
  name: "AppCardContent"
}, B_ = { class: "relative w-full p-6 [&:not(:last-child)]:pb-0" };
function V_(e, t, n, r, a, i) {
  return C(), T("div", B_, [
    Ce(e.$slots, "default")
  ]);
}
const B3 = /* @__PURE__ */ Ct(j_, [["render", V_]]), U_ = (e, t, n = 300) => {
  window.timeouts || (window.timeouts = []), t in window.timeouts && clearTimeout(window.timeouts[t]), window.timeouts[t] = setTimeout(e, n);
}, H_ = {
  key: 0,
  class: "fixed inset-0 z-[100] bg-blue-700"
}, G_ = { class: "absolute inset-0 bg-black/75" }, q_ = {
  key: 1,
  class: "flex h-screen flex-col items-center justify-center sm:px-8 sm:py-12"
}, W_ = {
  name: "AppGalleryLightbox"
}, Y_ = /* @__PURE__ */ re({
  ...W_,
  props: {
    images: {},
    visible: { type: Boolean, default: !1 },
    initialSlide: { default: 0 },
    alt: { default: "" }
  },
  emits: ["hide"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = () => {
      r("hide");
    };
    return (i, s) => (C(), ve(vr, null, {
      default: fe(() => [
        i.visible ? (C(), T("div", H_, [
          S("div", {
            class: "absolute top-4 right-4 z-[9] size-8 cursor-pointer rounded-full bg-black text-center leading-8 text-white opacity-50",
            "data-test-id": "hide-gallery",
            onClick: a
          }, [
            U(x(te), {
              icon: ["fas", "xmark"],
              size: "2x"
            })
          ]),
          S("div", G_, [
            n.images.length > 0 ? (C(), ve(vu, {
              key: 0,
              images: n.images,
              "initial-index": i.initialSlide,
              alt: n.alt,
              "is-light-box-mode": ""
            }, null, 8, ["images", "initial-index", "alt"])) : (C(), T("div", q_, [
              U($r, {
                source: null,
                alt: "Geen foto beschikbaar",
                class: "flex max-h-screen max-w-full self-center bg-transparent object-contain shadow-xl",
                loading: "lazy"
              })
            ]))
          ])
        ])) : K("", !0)
      ]),
      _: 1
    }));
  }
}), V3 = /* @__PURE__ */ Ct(Y_, [["__scopeId", "data-v-1070ae97"]]), K_ = { class: "relative grid size-full grid-cols-2 grid-rows-1 items-center" }, Z_ = ["id", "data-test-id"], X_ = {
  key: 1,
  class: "col-span-full row-span-full flex size-full snap-x snap-mandatory overflow-hidden"
}, J_ = ["disabled"], Q_ = ["disabled"], ew = {
  name: "AppGallerySwiper"
}, tw = /* @__PURE__ */ re({
  ...ew,
  props: {
    images: {},
    imagesLarge: { default: () => [] },
    initialIndex: { default: 0 },
    isLightBoxMode: { type: Boolean, default: !1 },
    alt: { default: "" },
    teleport: { default: void 0 },
    isCarrousel: { type: Boolean, default: !0 }
  },
  emits: ["lightBox"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = N(0), i = N(!1), s = N(lu(12)), o = Ar(), l = (p = "smooth") => {
      const h = document.getElementById(`${s.value}-image-${a.value.toString()}`);
      h && h.scrollIntoView({ behavior: p, block: "nearest", inline: "nearest" });
    }, u = () => {
      a.value -= 1, l();
    }, c = () => {
      a.value += 1, l();
    }, d = () => {
      i.value || (i.value = !0);
    }, f = (p) => {
      o && U_(() => {
        const m = p.target, v = p.target.scrollLeft, g = m.scrollWidth / n.images.length;
        a.value = Math.round(v / g);
      }, o.uid);
    };
    return Ue(() => {
      n.isLightBoxMode && (a.value = n.initialIndex, l("auto"));
    }), (p, h) => (C(), T(Oe, null, [
      !p.isLightBoxMode && i.value ? (C(), ve(Qp, {
        key: 0,
        disabled: !n.teleport,
        to: n.teleport
      }, [
        U(V3, {
          images: n.imagesLarge.length > 0 ? n.imagesLarge : n.images,
          visible: i.value,
          "initial-slide": a.value,
          alt: n.alt,
          onHide: h[0] || (h[0] = (m) => (i.value = !1, r("lightBox", !1)))
        }, null, 8, ["images", "visible", "initial-slide", "alt"])
      ], 8, ["disabled", "to"])) : K("", !0),
      S("div", K_, [
        n.images.length > 0 ? (C(), T("div", {
          key: 0,
          "data-test-id": "gallery-swiper-images",
          class: "col-span-full row-span-full flex size-full overflow-x-scroll hide--scroll snap-x snap-mandatory",
          onScrollPassive: f
        }, [
          (C(!0), T(Oe, null, Fe(n.images, (m, v) => (C(), T("div", {
            id: s.value + "-image-" + v.toString(),
            key: s.value + "-" + v.toString(),
            "data-test-id": `gallery-swiper-image-${v.toString()}`,
            class: z(["size-full shrink-0 translate-x-0 -translate-y-0 snap-center", {
              "h-screen w-screen flex justify-center": p.isLightBoxMode,
              "cursor-pointer": !p.isLightBoxMode
            }])
          }, [
            U($r, {
              class: z({
                "flex max-h-screen max-w-full self-center object-contain shadow-xl": p.isLightBoxMode,
                "size-full object-cover object-center": !p.isLightBoxMode
              }),
              source: m,
              alt: n.alt,
              sizes: "100",
              loading: "eager",
              fetchpriority: "high",
              "data-test-id": `lightbox-image-${v.toString()}`,
              onClick: h[1] || (h[1] = () => {
                r("lightBox", !0), d();
              })
            }, null, 8, ["class", "source", "alt", "data-test-id"])
          ], 10, Z_))), 128))
        ], 32)) : (C(), T("div", X_, [
          U($r, {
            alt: "Mogelijk logo, geen foto beschikbaar",
            loading: "lazy"
          })
        ])),
        n.images.length > 1 && p.isCarrousel ? (C(), T("button", {
          key: 2,
          disabled: a.value === 0,
          "data-test-id": "slider-back-button",
          "aria-label": "Vorige",
          type: "button",
          class: z(["duration-400 group z-10 col-start-1 row-span-full flex size-12 cursor-pointer items-center justify-center rounded-r-lg bg-black/50 p-2 ease-in-out focus:outline-none", { "opacity-30": a.value === 0 }]),
          onClick: u
        }, h[2] || (h[2] = [
          S("span", { class: "inline-flex size-10 items-center justify-center rounded-full" }, [
            S("svg", {
              "aria-hidden": "true",
              class: "size-6 text-white",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              S("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M15 19l-7-7 7-7"
              })
            ]),
            S("span", { class: "sr-only" }, "Vorige")
          ], -1)
        ]), 10, J_)) : K("", !0),
        n.images.length > 1 && p.isCarrousel ? (C(), T("button", {
          key: 3,
          disabled: a.value === n.images.length - 1,
          "data-test-id": "slider-next-button",
          "aria-label": "Volgende",
          type: "button",
          class: z(["duration-400 group z-10 col-start-2 row-span-full flex size-12 cursor-pointer items-center justify-center justify-self-end rounded-l-lg bg-black/50 ease-in-out focus:outline-none", { "opacity-30": a.value === n.images.length - 1 }]),
          onClick: c
        }, h[3] || (h[3] = [
          S("span", { class: "inline-flex size-10 items-center justify-center rounded-full" }, [
            S("svg", {
              "aria-hidden": "true",
              class: "size-6 text-white",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              S("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M9 5l7 7-7 7"
              })
            ]),
            S("span", { class: "sr-only" }, "Volgende")
          ], -1)
        ]), 10, Q_)) : K("", !0)
      ])
    ], 64));
  }
}), vu = /* @__PURE__ */ Ct(tw, [["__scopeId", "data-v-059ba4b1"]]), nw = { class: "wrapper flex size-full overflow-hidden bg-gray-100" }, rw = {
  name: "AppGallery"
}, gu = /* @__PURE__ */ re({
  ...rw,
  props: {
    images: {},
    alt: { default: "" },
    teleport: { default: void 0 },
    isCarrousel: { type: Boolean, default: !0 }
  },
  emits: ["lightBox"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = (u, c, d, f, p) => u && u.toLowerCase().includes(f) ? u.replace(f, d.replace(":width", c)) : `${p}?crop=min`, i = "https://res.cloudinary.com/mogelijk/image/upload/c_scale,e_trim:30,f_auto,w_:width/assets/", s = "https://portal.mogelijk.nl/images/", o = P(() => n.images.map((u) => a(
      u.l,
      "1000",
      i,
      s,
      u.m
    ))), l = P(() => n.images.map((u) => a(
      u.l,
      "400",
      i,
      s,
      u.m
    )));
    return (u, c) => (C(), T("div", nw, [
      l.value.length > 0 ? (C(), ve(vu, {
        key: 0,
        images: l.value,
        "images-large": o.value,
        alt: u.alt,
        teleport: u.teleport,
        "is-carrousel": u.isCarrousel,
        onLightBox: c[0] || (c[0] = (d) => r("lightBox", d))
      }, null, 8, ["images", "images-large", "alt", "teleport", "is-carrousel"])) : (C(), ve($r, {
        key: 1,
        source: null,
        alt: "Mogelijk logo, geen foto beschikbaar",
        loading: "lazy"
      }))
    ]));
  }
}), aw = { class: "flex grow basis-1/2 flex-col justify-between gap-2" }, iw = { class: "mb-6 flex flex-wrap gap-4" }, sw = {
  key: 1,
  class: "w-full"
}, ow = { class: "mb-4 mt-6 flex items-center gap-4" }, lw = {
  key: 0,
  class: "whitespace-nowrap"
}, uw = {
  class: "flex grow gap-1 rounded-full relative flex-wrap space-y-2 2xs:!flex-nowrap 2xs:justify-end 2xs:space-y-0 max-w-full",
  "data-v-step": "offer-button"
}, cw = {
  key: 1,
  class: "flex items-center text-blue-500"
}, dw = {
  name: "AppOfferCard"
}, fw = /* @__PURE__ */ re({
  ...dw,
  props: {
    object: {},
    isGuest: { type: Boolean, default: !1 },
    isInvestor: { type: Boolean, default: !1 },
    userId: { default: 0 },
    isLoadingClaim: { type: Boolean, default: !1 },
    portalProxy: { default: "" },
    fetching: { type: Boolean, default: !1 },
    teleportLightbox: { default: void 0 },
    isHorizontal: { type: Boolean, default: !1 },
    isOnboardingPendingRequest: { type: Boolean, default: !1 },
    isOnboardingInExperienced: { type: Boolean, default: !1 },
    isOnboardingRequestRejected: { type: Boolean, default: !1 },
    index: {}
  },
  emits: ["claim", "option", "detail", "login", "callback", "lightBox"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = {
      claimed: "Geclaimd",
      optioned: "In optie",
      available: "Beschikbaar"
    }, i = P(
      () => n.object.claims_and_options.map((E) => E.person_id === n.userId ? E.status : null)
    ), s = P(() => n.object.claims_and_options.map((E) => E.status)), o = N(!1), l = (E) => {
      o.value = E;
    }, u = P(() => !n.isOnboardingPendingRequest && !n.isOnboardingInExperienced && !n.isOnboardingRequestRejected), c = P(() => {
      let E = "Uw verzoek is afgewezen", L = "Neem gerust contact op met ons via info@mogelijk.nl of 0346 - 250171";
      return n.isOnboardingPendingRequest && (E = "Uw verzoek is in behandeling genomen", L = "U kunt het aanbod bekijken maar nog niet claimen of opties nemen."), n.isOnboardingInExperienced && (E = "Het verzoek om u te kwalificeren als ervaren belegger is nog niet in behandeling genomen", L = "Klik op de link bovenaan deze pagina om uw verzoek in te dienen"), `<p class="text-gray-900 font-medium">${E}</p><p class="text-gray-700 mt-1">${L}</p>`;
    }), d = P(() => i.value.includes("claimed") ? "claimed" : i.value.includes("optioned") ? "optioned" : null), f = P(() => n.object.is_clubdeal ? s.value.includes("available") ? a.available : s.value.includes("optioned") ? a.optioned : a.claimed : s.value.includes("claimed") ? a.claimed : s.value.includes("optioned") ? a.optioned : a.available), p = P(() => {
      const E = n.object.claims_and_options.findIndex(
        (L) => L.status === "optioned" && L.person_id === n.userId
      );
      return E >= 0 && E < n.object.claim_positions;
    }), h = P(() => !u.value || f.value === a.claimed ? !0 : !(p.value || f.value === a.available)), m = P(() => f.value === a.claimed || d.value === "optioned" && !n.object.is_clubdeal || !u.value), v = P(() => G().isSame(n.object.publish_at, "day")), g = N(null), b = N(null), $ = N(null), y = N(null), A = P(() => p.value ? "U bent de eerste optant" : f.value === a.claimed ? "Helaas, u kunt geen optie nemen omdat het object al is geclaimd" : "U heeft al een optie op dit pand");
    return pr({
      ref: b,
      content: c
    }), pr({
      ref: g,
      content: "Investering opgedeeld in meerder delen met meerdere investeerders."
    }), pr({
      ref: $,
      content: "Helaas, u kunt niet meer claimen."
    }), pr({
      ref: y,
      content: A
    }), (E, L) => (C(), ve(j3, {
      class: z([[{ "shadow-new": v.value }, { isolate: !o.value }], "overflow-toggle-tour flex grow overflow-hidden"])
    }, {
      default: fe(() => [
        S("div", {
          class: z(["flex h-full", { "flex-col": !E.isHorizontal }])
        }, [
          S("div", {
            class: z(["relative flex bg-blue-50", E.isHorizontal ? "grow basis-1/3" : "w-full aspect-video h-[240px]"])
          }, [
            U(yt, {
              class: "absolute inset-0 bg-blue-100",
              fetching: E.fetching
            }, {
              default: fe(() => {
                var D, ne, I;
                return [
                  U(gu, {
                    images: (ne = (D = n.object) == null ? void 0 : D.entity) == null ? void 0 : ne.image_urls,
                    alt: (I = n.object) == null ? void 0 : I.title,
                    teleport: n.teleportLightbox,
                    onLightBox: L[0] || (L[0] = (B) => (l(B), E.$emit("lightBox", B)))
                  }, null, 8, ["images", "alt", "teleport"])
                ];
              }),
              _: 1
            }, 8, ["fetching"]),
            U(I_, {
              status: f.value,
              "personal-status": d.value,
              "is-clubdeal": E.object.is_clubdeal,
              "claims-and-options": E.object.claims_and_options,
              "claim-positions": E.object.claim_positions,
              loan: E.object.entity.loan,
              class: z(["absolute left-4 z-20", E.isHorizontal ? "top-4" : "-bottom-5"])
            }, null, 8, ["status", "personal-status", "is-clubdeal", "claims-and-options", "claim-positions", "loan", "class"])
          ], 2),
          U(B3, {
            class: z(["flex gap-4", E.isHorizontal ? "w-2/3 min-w-[567px]" : "flex-col grow"])
          }, {
            default: fe(() => [
              S("div", aw, [
                U(yt, {
                  fetching: E.fetching,
                  text: ""
                }, {
                  default: fe(() => [
                    S("p", {
                      class: z(["font-semibold leading-5", { "mt-4": !E.isHorizontal }])
                    }, H(n.object.title), 3),
                    ct(S("div", {
                      class: z(["mt-4 inline-block w-fit rounded-full bg-blue-200 px-4 py-1 text-xs text-blue-700", { "mb-4": E.isHorizontal }])
                    }, H(n.object.label), 3), [
                      [gr, n.object.label]
                    ])
                  ]),
                  _: 1
                }, 8, ["fetching"]),
                U(T_, {
                  object: n.object,
                  fetching: n.fetching,
                  class: z({ "border-y border-gray-100 py-4 mt-2": !E.isHorizontal })
                }, null, 8, ["object", "fetching", "class"])
              ]),
              S("div", {
                class: z({ "min-w-[40%] flex flex-col justify-between": E.isHorizontal })
              }, [
                S("div", iw, [
                  U(qn, {
                    label: "Locatie",
                    text: E.object.entity.city,
                    fetching: E.fetching
                  }, null, 8, ["text", "fetching"]),
                  U(qn, {
                    label: "Looptijd",
                    text: `${E.object.duration} maanden`,
                    fetching: E.fetching
                  }, null, 8, ["text", "fetching"])
                ]),
                S("div", null, [
                  Ce(E.$slots, "default"),
                  n.isGuest ? (C(), ve(yt, {
                    key: 0,
                    fetching: E.fetching
                  }, {
                    default: fe(() => [
                      U(St, {
                        "data-test-id": `geust-claim-button-${E.index.toString()}`,
                        type: "secondary",
                        color: "blue",
                        class: "mt-6 px-2 w-full",
                        onClick: L[1] || (L[1] = (D) => r("login"))
                      }, {
                        default: fe(() => L[5] || (L[5] = [
                          rt(" Login om te claimen ")
                        ])),
                        _: 1,
                        __: [5]
                      }, 8, ["data-test-id"])
                    ]),
                    _: 1
                  }, 8, ["fetching"])) : n.isInvestor ? (C(), T("div", sw, [
                    S("div", ow, [
                      n.object.is_interactable ? (C(), T("span", lw, [
                        U(yt, {
                          fetching: E.fetching,
                          text: ""
                        }, {
                          default: fe(() => L[6] || (L[6] = [
                            S("div", { class: "text-blue-700" }, "Ik wil direct:", -1)
                          ])),
                          _: 1,
                          __: [6]
                        }, 8, ["fetching"])
                      ])) : K("", !0),
                      L[7] || (L[7] = S("span", { class: "w-full border-b border-gray-100" }, null, -1))
                    ]),
                    n.object.is_interactable ? (C(), ve(yt, {
                      key: 0,
                      fetching: E.fetching
                    }, {
                      default: fe(() => [
                        S("div", uw, [
                          u.value ? K("", !0) : (C(), T("div", {
                            key: 0,
                            ref_key: "tooltipClaimAndOptionButtons",
                            ref: b,
                            class: "absolute top-0 left-0 z-10 size-full"
                          }, null, 512)),
                          h.value && u.value ? (C(), T("div", {
                            key: 1,
                            ref_key: "disabledClaimButton",
                            ref: $,
                            class: "absolute top-0 left-0 z-10 h-full w-1/2"
                          }, null, 512)) : K("", !0),
                          U(St, {
                            "data-test-id": `claim-button-${E.index.toString()}`,
                            class: z("w-full 2xs:w-auto 2xs:basis-1/2 2xs:!rounded-r-none px-4 py-2"),
                            "is-disabled": h.value || n.isLoadingClaim,
                            theme: "primary",
                            color: "green",
                            "is-loading": n.object.disable_claim,
                            onClick: L[2] || (L[2] = (D) => r("claim", n.object))
                          }, {
                            default: fe(() => L[8] || (L[8] = [
                              rt(" Claimen ")
                            ])),
                            _: 1,
                            __: [8]
                          }, 8, ["data-test-id", "is-disabled", "is-loading"]),
                          m.value && u.value ? (C(), T("div", {
                            key: 2,
                            ref_key: "disabledOptionButton",
                            ref: y,
                            class: "absolute top-0 right-0 z-10 h-full w-1/2"
                          }, null, 512)) : K("", !0),
                          U(St, {
                            "data-test-id": `option-button-${E.index.toString()}`,
                            class: z("w-full 2xs:w-auto 2xs:basis-1/2 2xs:!rounded-l-none px-4 py-2"),
                            type: "secondary",
                            color: "blue",
                            "is-disabled": m.value || n.isLoadingClaim,
                            "is-loading": n.object.disable_option,
                            onClick: L[3] || (L[3] = (D) => r("option", n.object))
                          }, {
                            default: fe(() => L[9] || (L[9] = [
                              rt(" Optie nemen ")
                            ])),
                            _: 1,
                            __: [9]
                          }, 8, ["data-test-id", "is-disabled", "is-loading"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["fetching"])) : (C(), T("div", cw, [
                      U(x(te), {
                        icon: ["fad", "clock"],
                        class: "mr-4 text-xl"
                      }),
                      L[10] || (L[10] = S("span", null, [
                        rt("U kunt "),
                        S("b", null, "vanaf 11:00 uur"),
                        S("br"),
                        rt("claimen of optie nemen")
                      ], -1))
                    ]))
                  ])) : (C(), ve(yt, {
                    key: 2,
                    fetching: E.fetching
                  }, {
                    default: fe(() => [
                      U(St, {
                        "data-test-id": `unauthorized-claim-button-${E.index.toString()}`,
                        type: "secondary",
                        color: "blue",
                        class: "mt-6 px-4 py-2 w-full",
                        onClick: L[4] || (L[4] = (D) => r("callback"))
                      }, {
                        default: fe(() => L[11] || (L[11] = [
                          rt(" Investeren? Bel mij terug ")
                        ])),
                        _: 1,
                        __: [11]
                      }, 8, ["data-test-id"])
                    ]),
                    _: 1
                  }, 8, ["fetching"]))
                ])
              ], 2)
            ]),
            _: 3
          }, 8, ["class"])
        ], 2)
      ]),
      _: 3
    }, 8, ["class"]));
  }
});
function Jc(e) {
  return e !== null && typeof e == "object" && "constructor" in e && e.constructor === Object;
}
function bu(e = {}, t = {}) {
  Object.keys(t).forEach((n) => {
    typeof e[n] > "u" ? e[n] = t[n] : Jc(t[n]) && Jc(e[n]) && Object.keys(t[n]).length > 0 && bu(e[n], t[n]);
  });
}
const U3 = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function vt() {
  const e = typeof document < "u" ? document : {};
  return bu(e, U3), e;
}
const pw = {
  document: U3,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(e) {
    return typeof setTimeout > "u" ? (e(), null) : setTimeout(e, 0);
  },
  cancelAnimationFrame(e) {
    typeof setTimeout > "u" || clearTimeout(e);
  }
};
function tt() {
  const e = typeof window < "u" ? window : {};
  return bu(e, pw), e;
}
function hw(e) {
  const t = e.__proto__;
  Object.defineProperty(e, "__proto__", {
    get() {
      return t;
    },
    set(n) {
      t.__proto__ = n;
    }
  });
}
class Tn extends Array {
  constructor(t) {
    typeof t == "number" ? super(t) : (super(...t || []), hw(this));
  }
}
function ma(e = []) {
  const t = [];
  return e.forEach((n) => {
    Array.isArray(n) ? t.push(...ma(n)) : t.push(n);
  }), t;
}
function H3(e, t) {
  return Array.prototype.filter.call(e, t);
}
function mw(e) {
  const t = [];
  for (let n = 0; n < e.length; n += 1)
    t.indexOf(e[n]) === -1 && t.push(e[n]);
  return t;
}
function vw(e, t) {
  if (typeof e != "string")
    return [e];
  const n = [], r = t.querySelectorAll(e);
  for (let a = 0; a < r.length; a += 1)
    n.push(r[a]);
  return n;
}
function se(e, t) {
  const n = tt(), r = vt();
  let a = [];
  if (!t && e instanceof Tn)
    return e;
  if (!e)
    return new Tn(a);
  if (typeof e == "string") {
    const i = e.trim();
    if (i.indexOf("<") >= 0 && i.indexOf(">") >= 0) {
      let s = "div";
      i.indexOf("<li") === 0 && (s = "ul"), i.indexOf("<tr") === 0 && (s = "tbody"), (i.indexOf("<td") === 0 || i.indexOf("<th") === 0) && (s = "tr"), i.indexOf("<tbody") === 0 && (s = "table"), i.indexOf("<option") === 0 && (s = "select");
      const o = r.createElement(s);
      o.innerHTML = i;
      for (let l = 0; l < o.childNodes.length; l += 1)
        a.push(o.childNodes[l]);
    } else
      a = vw(e.trim(), t || r);
  } else if (e.nodeType || e === n || e === r)
    a.push(e);
  else if (Array.isArray(e)) {
    if (e instanceof Tn) return e;
    a = e;
  }
  return new Tn(mw(a));
}
se.fn = Tn.prototype;
function gw(...e) {
  const t = ma(e.map((n) => n.split(" ")));
  return this.forEach((n) => {
    n.classList.add(...t);
  }), this;
}
function bw(...e) {
  const t = ma(e.map((n) => n.split(" ")));
  return this.forEach((n) => {
    n.classList.remove(...t);
  }), this;
}
function $w(...e) {
  const t = ma(e.map((n) => n.split(" ")));
  this.forEach((n) => {
    t.forEach((r) => {
      n.classList.toggle(r);
    });
  });
}
function yw(...e) {
  const t = ma(e.map((n) => n.split(" ")));
  return H3(this, (n) => t.filter((r) => n.classList.contains(r)).length > 0).length > 0;
}
function xw(e, t) {
  if (arguments.length === 1 && typeof e == "string")
    return this[0] ? this[0].getAttribute(e) : void 0;
  for (let n = 0; n < this.length; n += 1)
    if (arguments.length === 2)
      this[n].setAttribute(e, t);
    else
      for (const r in e)
        this[n][r] = e[r], this[n].setAttribute(r, e[r]);
  return this;
}
function _w(e) {
  for (let t = 0; t < this.length; t += 1)
    this[t].removeAttribute(e);
  return this;
}
function ww(e) {
  for (let t = 0; t < this.length; t += 1)
    this[t].style.transform = e;
  return this;
}
function Sw(e) {
  for (let t = 0; t < this.length; t += 1)
    this[t].style.transitionDuration = typeof e != "string" ? `${e}ms` : e;
  return this;
}
function Cw(...e) {
  let [t, n, r, a] = e;
  typeof e[1] == "function" && ([t, r, a] = e, n = void 0), a || (a = !1);
  function i(u) {
    const c = u.target;
    if (!c) return;
    const d = u.target.dom7EventData || [];
    if (d.indexOf(u) < 0 && d.unshift(u), se(c).is(n)) r.apply(c, d);
    else {
      const f = se(c).parents();
      for (let p = 0; p < f.length; p += 1)
        se(f[p]).is(n) && r.apply(f[p], d);
    }
  }
  function s(u) {
    const c = u && u.target ? u.target.dom7EventData || [] : [];
    c.indexOf(u) < 0 && c.unshift(u), r.apply(this, c);
  }
  const o = t.split(" ");
  let l;
  for (let u = 0; u < this.length; u += 1) {
    const c = this[u];
    if (n)
      for (l = 0; l < o.length; l += 1) {
        const d = o[l];
        c.dom7LiveListeners || (c.dom7LiveListeners = {}), c.dom7LiveListeners[d] || (c.dom7LiveListeners[d] = []), c.dom7LiveListeners[d].push({
          listener: r,
          proxyListener: i
        }), c.addEventListener(d, i, a);
      }
    else
      for (l = 0; l < o.length; l += 1) {
        const d = o[l];
        c.dom7Listeners || (c.dom7Listeners = {}), c.dom7Listeners[d] || (c.dom7Listeners[d] = []), c.dom7Listeners[d].push({
          listener: r,
          proxyListener: s
        }), c.addEventListener(d, s, a);
      }
  }
  return this;
}
function Aw(...e) {
  let [t, n, r, a] = e;
  typeof e[1] == "function" && ([t, r, a] = e, n = void 0), a || (a = !1);
  const i = t.split(" ");
  for (let s = 0; s < i.length; s += 1) {
    const o = i[s];
    for (let l = 0; l < this.length; l += 1) {
      const u = this[l];
      let c;
      if (!n && u.dom7Listeners ? c = u.dom7Listeners[o] : n && u.dom7LiveListeners && (c = u.dom7LiveListeners[o]), c && c.length)
        for (let d = c.length - 1; d >= 0; d -= 1) {
          const f = c[d];
          r && f.listener === r || r && f.listener && f.listener.dom7proxy && f.listener.dom7proxy === r ? (u.removeEventListener(o, f.proxyListener, a), c.splice(d, 1)) : r || (u.removeEventListener(o, f.proxyListener, a), c.splice(d, 1));
        }
    }
  }
  return this;
}
function Ew(...e) {
  const t = tt(), n = e[0].split(" "), r = e[1];
  for (let a = 0; a < n.length; a += 1) {
    const i = n[a];
    for (let s = 0; s < this.length; s += 1) {
      const o = this[s];
      if (t.CustomEvent) {
        const l = new t.CustomEvent(i, {
          detail: r,
          bubbles: !0,
          cancelable: !0
        });
        o.dom7EventData = e.filter((u, c) => c > 0), o.dispatchEvent(l), o.dom7EventData = [], delete o.dom7EventData;
      }
    }
  }
  return this;
}
function Ow(e) {
  const t = this;
  function n(r) {
    r.target === this && (e.call(this, r), t.off("transitionend", n));
  }
  return e && t.on("transitionend", n), this;
}
function Tw(e) {
  if (this.length > 0) {
    if (e) {
      const t = this.styles();
      return this[0].offsetWidth + parseFloat(t.getPropertyValue("margin-right")) + parseFloat(t.getPropertyValue("margin-left"));
    }
    return this[0].offsetWidth;
  }
  return null;
}
function Mw(e) {
  if (this.length > 0) {
    if (e) {
      const t = this.styles();
      return this[0].offsetHeight + parseFloat(t.getPropertyValue("margin-top")) + parseFloat(t.getPropertyValue("margin-bottom"));
    }
    return this[0].offsetHeight;
  }
  return null;
}
function kw() {
  if (this.length > 0) {
    const e = tt(), t = vt(), n = this[0], r = n.getBoundingClientRect(), a = t.body, i = n.clientTop || a.clientTop || 0, s = n.clientLeft || a.clientLeft || 0, o = n === e ? e.scrollY : n.scrollTop, l = n === e ? e.scrollX : n.scrollLeft;
    return {
      top: r.top + o - i,
      left: r.left + l - s
    };
  }
  return null;
}
function Lw() {
  const e = tt();
  return this[0] ? e.getComputedStyle(this[0], null) : {};
}
function Fw(e, t) {
  const n = tt();
  let r;
  if (arguments.length === 1)
    if (typeof e == "string") {
      if (this[0]) return n.getComputedStyle(this[0], null).getPropertyValue(e);
    } else {
      for (r = 0; r < this.length; r += 1)
        for (const a in e)
          this[r].style[a] = e[a];
      return this;
    }
  if (arguments.length === 2 && typeof e == "string") {
    for (r = 0; r < this.length; r += 1)
      this[r].style[e] = t;
    return this;
  }
  return this;
}
function zw(e) {
  return e ? (this.forEach((t, n) => {
    e.apply(t, [t, n]);
  }), this) : this;
}
function Pw(e) {
  const t = H3(this, e);
  return se(t);
}
function Iw(e) {
  if (typeof e > "u")
    return this[0] ? this[0].innerHTML : null;
  for (let t = 0; t < this.length; t += 1)
    this[t].innerHTML = e;
  return this;
}
function Nw(e) {
  if (typeof e > "u")
    return this[0] ? this[0].textContent.trim() : null;
  for (let t = 0; t < this.length; t += 1)
    this[t].textContent = e;
  return this;
}
function Dw(e) {
  const t = tt(), n = vt(), r = this[0];
  let a, i;
  if (!r || typeof e > "u") return !1;
  if (typeof e == "string") {
    if (r.matches) return r.matches(e);
    if (r.webkitMatchesSelector) return r.webkitMatchesSelector(e);
    if (r.msMatchesSelector) return r.msMatchesSelector(e);
    for (a = se(e), i = 0; i < a.length; i += 1)
      if (a[i] === r) return !0;
    return !1;
  }
  if (e === n)
    return r === n;
  if (e === t)
    return r === t;
  if (e.nodeType || e instanceof Tn) {
    for (a = e.nodeType ? [e] : e, i = 0; i < a.length; i += 1)
      if (a[i] === r) return !0;
    return !1;
  }
  return !1;
}
function Rw() {
  let e = this[0], t;
  if (e) {
    for (t = 0; (e = e.previousSibling) !== null; )
      e.nodeType === 1 && (t += 1);
    return t;
  }
}
function jw(e) {
  if (typeof e > "u") return this;
  const t = this.length;
  if (e > t - 1)
    return se([]);
  if (e < 0) {
    const n = t + e;
    return n < 0 ? se([]) : se([this[n]]);
  }
  return se([this[e]]);
}
function Bw(...e) {
  let t;
  const n = vt();
  for (let r = 0; r < e.length; r += 1) {
    t = e[r];
    for (let a = 0; a < this.length; a += 1)
      if (typeof t == "string") {
        const i = n.createElement("div");
        for (i.innerHTML = t; i.firstChild; )
          this[a].appendChild(i.firstChild);
      } else if (t instanceof Tn)
        for (let i = 0; i < t.length; i += 1)
          this[a].appendChild(t[i]);
      else
        this[a].appendChild(t);
  }
  return this;
}
function Vw(e) {
  const t = vt();
  let n, r;
  for (n = 0; n < this.length; n += 1)
    if (typeof e == "string") {
      const a = t.createElement("div");
      for (a.innerHTML = e, r = a.childNodes.length - 1; r >= 0; r -= 1)
        this[n].insertBefore(a.childNodes[r], this[n].childNodes[0]);
    } else if (e instanceof Tn)
      for (r = 0; r < e.length; r += 1)
        this[n].insertBefore(e[r], this[n].childNodes[0]);
    else
      this[n].insertBefore(e, this[n].childNodes[0]);
  return this;
}
function Uw(e) {
  return this.length > 0 ? e ? this[0].nextElementSibling && se(this[0].nextElementSibling).is(e) ? se([this[0].nextElementSibling]) : se([]) : this[0].nextElementSibling ? se([this[0].nextElementSibling]) : se([]) : se([]);
}
function Hw(e) {
  const t = [];
  let n = this[0];
  if (!n) return se([]);
  for (; n.nextElementSibling; ) {
    const r = n.nextElementSibling;
    e ? se(r).is(e) && t.push(r) : t.push(r), n = r;
  }
  return se(t);
}
function Gw(e) {
  if (this.length > 0) {
    const t = this[0];
    return e ? t.previousElementSibling && se(t.previousElementSibling).is(e) ? se([t.previousElementSibling]) : se([]) : t.previousElementSibling ? se([t.previousElementSibling]) : se([]);
  }
  return se([]);
}
function qw(e) {
  const t = [];
  let n = this[0];
  if (!n) return se([]);
  for (; n.previousElementSibling; ) {
    const r = n.previousElementSibling;
    e ? se(r).is(e) && t.push(r) : t.push(r), n = r;
  }
  return se(t);
}
function Ww(e) {
  const t = [];
  for (let n = 0; n < this.length; n += 1)
    this[n].parentNode !== null && (e ? se(this[n].parentNode).is(e) && t.push(this[n].parentNode) : t.push(this[n].parentNode));
  return se(t);
}
function Yw(e) {
  const t = [];
  for (let n = 0; n < this.length; n += 1) {
    let r = this[n].parentNode;
    for (; r; )
      e ? se(r).is(e) && t.push(r) : t.push(r), r = r.parentNode;
  }
  return se(t);
}
function Kw(e) {
  let t = this;
  return typeof e > "u" ? se([]) : (t.is(e) || (t = t.parents(e).eq(0)), t);
}
function Zw(e) {
  const t = [];
  for (let n = 0; n < this.length; n += 1) {
    const r = this[n].querySelectorAll(e);
    for (let a = 0; a < r.length; a += 1)
      t.push(r[a]);
  }
  return se(t);
}
function Xw(e) {
  const t = [];
  for (let n = 0; n < this.length; n += 1) {
    const r = this[n].children;
    for (let a = 0; a < r.length; a += 1)
      (!e || se(r[a]).is(e)) && t.push(r[a]);
  }
  return se(t);
}
function Jw() {
  for (let e = 0; e < this.length; e += 1)
    this[e].parentNode && this[e].parentNode.removeChild(this[e]);
  return this;
}
const Qc = {
  addClass: gw,
  removeClass: bw,
  hasClass: yw,
  toggleClass: $w,
  attr: xw,
  removeAttr: _w,
  transform: ww,
  transition: Sw,
  on: Cw,
  off: Aw,
  trigger: Ew,
  transitionEnd: Ow,
  outerWidth: Tw,
  outerHeight: Mw,
  styles: Lw,
  offset: kw,
  css: Fw,
  each: zw,
  html: Iw,
  text: Nw,
  is: Dw,
  index: Rw,
  eq: jw,
  append: Bw,
  prepend: Vw,
  next: Uw,
  nextAll: Hw,
  prev: Gw,
  prevAll: qw,
  parent: Ww,
  parents: Yw,
  closest: Kw,
  find: Zw,
  children: Xw,
  filter: Pw,
  remove: Jw
};
Object.keys(Qc).forEach((e) => {
  Object.defineProperty(se.fn, e, {
    value: Qc[e],
    writable: !0
  });
});
function Qw(e) {
  const t = e;
  Object.keys(t).forEach((n) => {
    try {
      t[n] = null;
    } catch {
    }
    try {
      delete t[n];
    } catch {
    }
  });
}
function bl(e, t = 0) {
  return setTimeout(e, t);
}
function sa() {
  return Date.now();
}
function eS(e) {
  const t = tt();
  let n;
  return t.getComputedStyle && (n = t.getComputedStyle(e, null)), !n && e.currentStyle && (n = e.currentStyle), n || (n = e.style), n;
}
function tS(e, t = "x") {
  const n = tt();
  let r, a, i;
  const s = eS(e);
  return n.WebKitCSSMatrix ? (a = s.transform || s.webkitTransform, a.split(",").length > 6 && (a = a.split(", ").map((o) => o.replace(",", ".")).join(", ")), i = new n.WebKitCSSMatrix(a === "none" ? "" : a)) : (i = s.MozTransform || s.OTransform || s.MsTransform || s.msTransform || s.transform || s.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), r = i.toString().split(",")), t === "x" && (n.WebKitCSSMatrix ? a = i.m41 : r.length === 16 ? a = parseFloat(r[12]) : a = parseFloat(r[4])), t === "y" && (n.WebKitCSSMatrix ? a = i.m42 : r.length === 16 ? a = parseFloat(r[13]) : a = parseFloat(r[5])), a || 0;
}
function Ea(e) {
  return typeof e == "object" && e !== null && e.constructor && Object.prototype.toString.call(e).slice(8, -1) === "Object";
}
function nS(e) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? e instanceof HTMLElement : e && (e.nodeType === 1 || e.nodeType === 11);
}
function Et(...e) {
  const t = Object(e[0]), n = ["__proto__", "constructor", "prototype"];
  for (let r = 1; r < e.length; r += 1) {
    const a = e[r];
    if (a != null && !nS(a)) {
      const i = Object.keys(Object(a)).filter((s) => n.indexOf(s) < 0);
      for (let s = 0, o = i.length; s < o; s += 1) {
        const l = i[s], u = Object.getOwnPropertyDescriptor(a, l);
        u !== void 0 && u.enumerable && (Ea(t[l]) && Ea(a[l]) ? a[l].__swiper__ ? t[l] = a[l] : Et(t[l], a[l]) : !Ea(t[l]) && Ea(a[l]) ? (t[l] = {}, a[l].__swiper__ ? t[l] = a[l] : Et(t[l], a[l])) : t[l] = a[l]);
      }
    }
  }
  return t;
}
function Oa(e, t, n) {
  e.style.setProperty(t, n);
}
function G3({
  swiper: e,
  targetPosition: t,
  side: n
}) {
  const r = tt(), a = -e.translate;
  let i = null, s;
  const o = e.params.speed;
  e.wrapperEl.style.scrollSnapType = "none", r.cancelAnimationFrame(e.cssModeFrameID);
  const l = t > a ? "next" : "prev", u = (d, f) => l === "next" && d >= f || l === "prev" && d <= f, c = () => {
    s = (/* @__PURE__ */ new Date()).getTime(), i === null && (i = s);
    const d = Math.max(Math.min((s - i) / o, 1), 0), f = 0.5 - Math.cos(d * Math.PI) / 2;
    let p = a + f * (t - a);
    if (u(p, t) && (p = t), e.wrapperEl.scrollTo({
      [n]: p
    }), u(p, t)) {
      e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        e.wrapperEl.style.overflow = "", e.wrapperEl.scrollTo({
          [n]: p
        });
      }), r.cancelAnimationFrame(e.cssModeFrameID);
      return;
    }
    e.cssModeFrameID = r.requestAnimationFrame(c);
  };
  c();
}
let xs;
function rS() {
  const e = tt(), t = vt();
  return {
    smoothScroll: t.documentElement && "scrollBehavior" in t.documentElement.style,
    touch: !!("ontouchstart" in e || e.DocumentTouch && t instanceof e.DocumentTouch),
    passiveListener: function() {
      let r = !1;
      try {
        const a = Object.defineProperty({}, "passive", {
          // eslint-disable-next-line
          get() {
            r = !0;
          }
        });
        e.addEventListener("testPassiveListener", null, a);
      } catch {
      }
      return r;
    }(),
    gestures: function() {
      return "ongesturestart" in e;
    }()
  };
}
function q3() {
  return xs || (xs = rS()), xs;
}
let _s;
function aS({
  userAgent: e
} = {}) {
  const t = q3(), n = tt(), r = n.navigator.platform, a = e || n.navigator.userAgent, i = {
    ios: !1,
    android: !1
  }, s = n.screen.width, o = n.screen.height, l = a.match(/(Android);?[\s\/]+([\d.]+)?/);
  let u = a.match(/(iPad).*OS\s([\d_]+)/);
  const c = a.match(/(iPod)(.*OS\s([\d_]+))?/), d = !u && a.match(/(iPhone\sOS|iOS)\s([\d_]+)/), f = r === "Win32";
  let p = r === "MacIntel";
  const h = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !u && p && t.touch && h.indexOf(`${s}x${o}`) >= 0 && (u = a.match(/(Version)\/([\d.]+)/), u || (u = [0, 1, "13_0_0"]), p = !1), l && !f && (i.os = "android", i.android = !0), (u || d || c) && (i.os = "ios", i.ios = !0), i;
}
function iS(e = {}) {
  return _s || (_s = aS(e)), _s;
}
let ws;
function sS() {
  const e = tt();
  function t() {
    const n = e.navigator.userAgent.toLowerCase();
    return n.indexOf("safari") >= 0 && n.indexOf("chrome") < 0 && n.indexOf("android") < 0;
  }
  return {
    isSafari: t(),
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent)
  };
}
function oS() {
  return ws || (ws = sS()), ws;
}
function lS({
  swiper: e,
  on: t,
  emit: n
}) {
  const r = tt();
  let a = null, i = null;
  const s = () => {
    !e || e.destroyed || !e.initialized || (n("beforeResize"), n("resize"));
  }, o = () => {
    !e || e.destroyed || !e.initialized || (a = new ResizeObserver((c) => {
      i = r.requestAnimationFrame(() => {
        const {
          width: d,
          height: f
        } = e;
        let p = d, h = f;
        c.forEach(({
          contentBoxSize: m,
          contentRect: v,
          target: g
        }) => {
          g && g !== e.el || (p = v ? v.width : (m[0] || m).inlineSize, h = v ? v.height : (m[0] || m).blockSize);
        }), (p !== d || h !== f) && s();
      });
    }), a.observe(e.el));
  }, l = () => {
    i && r.cancelAnimationFrame(i), a && a.unobserve && e.el && (a.unobserve(e.el), a = null);
  }, u = () => {
    !e || e.destroyed || !e.initialized || n("orientationchange");
  };
  t("init", () => {
    if (e.params.resizeObserver && typeof r.ResizeObserver < "u") {
      o();
      return;
    }
    r.addEventListener("resize", s), r.addEventListener("orientationchange", u);
  }), t("destroy", () => {
    l(), r.removeEventListener("resize", s), r.removeEventListener("orientationchange", u);
  });
}
function uS({
  swiper: e,
  extendParams: t,
  on: n,
  emit: r
}) {
  const a = [], i = tt(), s = (u, c = {}) => {
    const d = i.MutationObserver || i.WebkitMutationObserver, f = new d((p) => {
      if (p.length === 1) {
        r("observerUpdate", p[0]);
        return;
      }
      const h = function() {
        r("observerUpdate", p[0]);
      };
      i.requestAnimationFrame ? i.requestAnimationFrame(h) : i.setTimeout(h, 0);
    });
    f.observe(u, {
      attributes: typeof c.attributes > "u" ? !0 : c.attributes,
      childList: typeof c.childList > "u" ? !0 : c.childList,
      characterData: typeof c.characterData > "u" ? !0 : c.characterData
    }), a.push(f);
  }, o = () => {
    if (e.params.observer) {
      if (e.params.observeParents) {
        const u = e.$el.parents();
        for (let c = 0; c < u.length; c += 1)
          s(u[c]);
      }
      s(e.$el[0], {
        childList: e.params.observeSlideChildren
      }), s(e.$wrapperEl[0], {
        attributes: !1
      });
    }
  }, l = () => {
    a.forEach((u) => {
      u.disconnect();
    }), a.splice(0, a.length);
  };
  t({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), n("init", o), n("destroy", l);
}
const cS = {
  on(e, t, n) {
    const r = this;
    if (!r.eventsListeners || r.destroyed || typeof t != "function") return r;
    const a = n ? "unshift" : "push";
    return e.split(" ").forEach((i) => {
      r.eventsListeners[i] || (r.eventsListeners[i] = []), r.eventsListeners[i][a](t);
    }), r;
  },
  once(e, t, n) {
    const r = this;
    if (!r.eventsListeners || r.destroyed || typeof t != "function") return r;
    function a(...i) {
      r.off(e, a), a.__emitterProxy && delete a.__emitterProxy, t.apply(r, i);
    }
    return a.__emitterProxy = t, r.on(e, a, n);
  },
  onAny(e, t) {
    const n = this;
    if (!n.eventsListeners || n.destroyed || typeof e != "function") return n;
    const r = t ? "unshift" : "push";
    return n.eventsAnyListeners.indexOf(e) < 0 && n.eventsAnyListeners[r](e), n;
  },
  offAny(e) {
    const t = this;
    if (!t.eventsListeners || t.destroyed || !t.eventsAnyListeners) return t;
    const n = t.eventsAnyListeners.indexOf(e);
    return n >= 0 && t.eventsAnyListeners.splice(n, 1), t;
  },
  off(e, t) {
    const n = this;
    return !n.eventsListeners || n.destroyed || !n.eventsListeners || e.split(" ").forEach((r) => {
      typeof t > "u" ? n.eventsListeners[r] = [] : n.eventsListeners[r] && n.eventsListeners[r].forEach((a, i) => {
        (a === t || a.__emitterProxy && a.__emitterProxy === t) && n.eventsListeners[r].splice(i, 1);
      });
    }), n;
  },
  emit(...e) {
    const t = this;
    if (!t.eventsListeners || t.destroyed || !t.eventsListeners) return t;
    let n, r, a;
    return typeof e[0] == "string" || Array.isArray(e[0]) ? (n = e[0], r = e.slice(1, e.length), a = t) : (n = e[0].events, r = e[0].data, a = e[0].context || t), r.unshift(a), (Array.isArray(n) ? n : n.split(" ")).forEach((s) => {
      t.eventsAnyListeners && t.eventsAnyListeners.length && t.eventsAnyListeners.forEach((o) => {
        o.apply(a, [s, ...r]);
      }), t.eventsListeners && t.eventsListeners[s] && t.eventsListeners[s].forEach((o) => {
        o.apply(a, r);
      });
    }), t;
  }
};
function dS() {
  const e = this;
  let t, n;
  const r = e.$el;
  typeof e.params.width < "u" && e.params.width !== null ? t = e.params.width : t = r[0].clientWidth, typeof e.params.height < "u" && e.params.height !== null ? n = e.params.height : n = r[0].clientHeight, !(t === 0 && e.isHorizontal() || n === 0 && e.isVertical()) && (t = t - parseInt(r.css("padding-left") || 0, 10) - parseInt(r.css("padding-right") || 0, 10), n = n - parseInt(r.css("padding-top") || 0, 10) - parseInt(r.css("padding-bottom") || 0, 10), Number.isNaN(t) && (t = 0), Number.isNaN(n) && (n = 0), Object.assign(e, {
    width: t,
    height: n,
    size: e.isHorizontal() ? t : n
  }));
}
function fS() {
  const e = this;
  function t(I) {
    return e.isHorizontal() ? I : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[I];
  }
  function n(I, B) {
    return parseFloat(I.getPropertyValue(t(B)) || 0);
  }
  const r = e.params, {
    $wrapperEl: a,
    size: i,
    rtlTranslate: s,
    wrongRTL: o
  } = e, l = e.virtual && r.virtual.enabled, u = l ? e.virtual.slides.length : e.slides.length, c = a.children(`.${e.params.slideClass}`), d = l ? e.virtual.slides.length : c.length;
  let f = [];
  const p = [], h = [];
  let m = r.slidesOffsetBefore;
  typeof m == "function" && (m = r.slidesOffsetBefore.call(e));
  let v = r.slidesOffsetAfter;
  typeof v == "function" && (v = r.slidesOffsetAfter.call(e));
  const g = e.snapGrid.length, b = e.slidesGrid.length;
  let $ = r.spaceBetween, y = -m, A = 0, E = 0;
  if (typeof i > "u")
    return;
  typeof $ == "string" && $.indexOf("%") >= 0 && ($ = parseFloat($.replace("%", "")) / 100 * i), e.virtualSize = -$, s ? c.css({
    marginLeft: "",
    marginBottom: "",
    marginTop: ""
  }) : c.css({
    marginRight: "",
    marginBottom: "",
    marginTop: ""
  }), r.centeredSlides && r.cssMode && (Oa(e.wrapperEl, "--swiper-centered-offset-before", ""), Oa(e.wrapperEl, "--swiper-centered-offset-after", ""));
  const L = r.grid && r.grid.rows > 1 && e.grid;
  L && e.grid.initSlides(d);
  let D;
  const ne = r.slidesPerView === "auto" && r.breakpoints && Object.keys(r.breakpoints).filter((I) => typeof r.breakpoints[I].slidesPerView < "u").length > 0;
  for (let I = 0; I < d; I += 1) {
    D = 0;
    const B = c.eq(I);
    if (L && e.grid.updateSlide(I, B, d, t), B.css("display") !== "none") {
      if (r.slidesPerView === "auto") {
        ne && (c[I].style[t("width")] = "");
        const ae = getComputedStyle(B[0]), we = B[0].style.transform, Q = B[0].style.webkitTransform;
        if (we && (B[0].style.transform = "none"), Q && (B[0].style.webkitTransform = "none"), r.roundLengths)
          D = e.isHorizontal() ? B.outerWidth(!0) : B.outerHeight(!0);
        else {
          const W = n(ae, "width"), O = n(ae, "padding-left"), _ = n(ae, "padding-right"), w = n(ae, "margin-left"), F = n(ae, "margin-right"), j = ae.getPropertyValue("box-sizing");
          if (j && j === "border-box")
            D = W + w + F;
          else {
            const {
              clientWidth: Y,
              offsetWidth: ie
            } = B[0];
            D = W + O + _ + w + F + (ie - Y);
          }
        }
        we && (B[0].style.transform = we), Q && (B[0].style.webkitTransform = Q), r.roundLengths && (D = Math.floor(D));
      } else
        D = (i - (r.slidesPerView - 1) * $) / r.slidesPerView, r.roundLengths && (D = Math.floor(D)), c[I] && (c[I].style[t("width")] = `${D}px`);
      c[I] && (c[I].swiperSlideSize = D), h.push(D), r.centeredSlides ? (y = y + D / 2 + A / 2 + $, A === 0 && I !== 0 && (y = y - i / 2 - $), I === 0 && (y = y - i / 2 - $), Math.abs(y) < 1 / 1e3 && (y = 0), r.roundLengths && (y = Math.floor(y)), E % r.slidesPerGroup === 0 && f.push(y), p.push(y)) : (r.roundLengths && (y = Math.floor(y)), (E - Math.min(e.params.slidesPerGroupSkip, E)) % e.params.slidesPerGroup === 0 && f.push(y), p.push(y), y = y + D + $), e.virtualSize += D + $, A = D, E += 1;
    }
  }
  if (e.virtualSize = Math.max(e.virtualSize, i) + v, s && o && (r.effect === "slide" || r.effect === "coverflow") && a.css({
    width: `${e.virtualSize + r.spaceBetween}px`
  }), r.setWrapperSize && a.css({
    [t("width")]: `${e.virtualSize + r.spaceBetween}px`
  }), L && e.grid.updateWrapperSize(D, f, t), !r.centeredSlides) {
    const I = [];
    for (let B = 0; B < f.length; B += 1) {
      let ae = f[B];
      r.roundLengths && (ae = Math.floor(ae)), f[B] <= e.virtualSize - i && I.push(ae);
    }
    f = I, Math.floor(e.virtualSize - i) - Math.floor(f[f.length - 1]) > 1 && f.push(e.virtualSize - i);
  }
  if (f.length === 0 && (f = [0]), r.spaceBetween !== 0) {
    const I = e.isHorizontal() && s ? "marginLeft" : t("marginRight");
    c.filter((B, ae) => r.cssMode ? ae !== c.length - 1 : !0).css({
      [I]: `${$}px`
    });
  }
  if (r.centeredSlides && r.centeredSlidesBounds) {
    let I = 0;
    h.forEach((ae) => {
      I += ae + (r.spaceBetween ? r.spaceBetween : 0);
    }), I -= r.spaceBetween;
    const B = I - i;
    f = f.map((ae) => ae < 0 ? -m : ae > B ? B + v : ae);
  }
  if (r.centerInsufficientSlides) {
    let I = 0;
    if (h.forEach((B) => {
      I += B + (r.spaceBetween ? r.spaceBetween : 0);
    }), I -= r.spaceBetween, I < i) {
      const B = (i - I) / 2;
      f.forEach((ae, we) => {
        f[we] = ae - B;
      }), p.forEach((ae, we) => {
        p[we] = ae + B;
      });
    }
  }
  if (Object.assign(e, {
    slides: c,
    snapGrid: f,
    slidesGrid: p,
    slidesSizesGrid: h
  }), r.centeredSlides && r.cssMode && !r.centeredSlidesBounds) {
    Oa(e.wrapperEl, "--swiper-centered-offset-before", `${-f[0]}px`), Oa(e.wrapperEl, "--swiper-centered-offset-after", `${e.size / 2 - h[h.length - 1] / 2}px`);
    const I = -e.snapGrid[0], B = -e.slidesGrid[0];
    e.snapGrid = e.snapGrid.map((ae) => ae + I), e.slidesGrid = e.slidesGrid.map((ae) => ae + B);
  }
  if (d !== u && e.emit("slidesLengthChange"), f.length !== g && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")), p.length !== b && e.emit("slidesGridLengthChange"), r.watchSlidesProgress && e.updateSlidesOffset(), !l && !r.cssMode && (r.effect === "slide" || r.effect === "fade")) {
    const I = `${r.containerModifierClass}backface-hidden`, B = e.$el.hasClass(I);
    d <= r.maxBackfaceHiddenSlides ? B || e.$el.addClass(I) : B && e.$el.removeClass(I);
  }
}
function pS(e) {
  const t = this, n = [], r = t.virtual && t.params.virtual.enabled;
  let a = 0, i;
  typeof e == "number" ? t.setTransition(e) : e === !0 && t.setTransition(t.params.speed);
  const s = (o) => r ? t.slides.filter((l) => parseInt(l.getAttribute("data-swiper-slide-index"), 10) === o)[0] : t.slides.eq(o)[0];
  if (t.params.slidesPerView !== "auto" && t.params.slidesPerView > 1)
    if (t.params.centeredSlides)
      (t.visibleSlides || se([])).each((o) => {
        n.push(o);
      });
    else
      for (i = 0; i < Math.ceil(t.params.slidesPerView); i += 1) {
        const o = t.activeIndex + i;
        if (o > t.slides.length && !r) break;
        n.push(s(o));
      }
  else
    n.push(s(t.activeIndex));
  for (i = 0; i < n.length; i += 1)
    if (typeof n[i] < "u") {
      const o = n[i].offsetHeight;
      a = o > a ? o : a;
    }
  (a || a === 0) && t.$wrapperEl.css("height", `${a}px`);
}
function hS() {
  const e = this, t = e.slides;
  for (let n = 0; n < t.length; n += 1)
    t[n].swiperSlideOffset = e.isHorizontal() ? t[n].offsetLeft : t[n].offsetTop;
}
function mS(e = this && this.translate || 0) {
  const t = this, n = t.params, {
    slides: r,
    rtlTranslate: a,
    snapGrid: i
  } = t;
  if (r.length === 0) return;
  typeof r[0].swiperSlideOffset > "u" && t.updateSlidesOffset();
  let s = -e;
  a && (s = e), r.removeClass(n.slideVisibleClass), t.visibleSlidesIndexes = [], t.visibleSlides = [];
  for (let o = 0; o < r.length; o += 1) {
    const l = r[o];
    let u = l.swiperSlideOffset;
    n.cssMode && n.centeredSlides && (u -= r[0].swiperSlideOffset);
    const c = (s + (n.centeredSlides ? t.minTranslate() : 0) - u) / (l.swiperSlideSize + n.spaceBetween), d = (s - i[0] + (n.centeredSlides ? t.minTranslate() : 0) - u) / (l.swiperSlideSize + n.spaceBetween), f = -(s - u), p = f + t.slidesSizesGrid[o];
    (f >= 0 && f < t.size - 1 || p > 1 && p <= t.size || f <= 0 && p >= t.size) && (t.visibleSlides.push(l), t.visibleSlidesIndexes.push(o), r.eq(o).addClass(n.slideVisibleClass)), l.progress = a ? -c : c, l.originalProgress = a ? -d : d;
  }
  t.visibleSlides = se(t.visibleSlides);
}
function vS(e) {
  const t = this;
  if (typeof e > "u") {
    const u = t.rtlTranslate ? -1 : 1;
    e = t && t.translate && t.translate * u || 0;
  }
  const n = t.params, r = t.maxTranslate() - t.minTranslate();
  let {
    progress: a,
    isBeginning: i,
    isEnd: s
  } = t;
  const o = i, l = s;
  r === 0 ? (a = 0, i = !0, s = !0) : (a = (e - t.minTranslate()) / r, i = a <= 0, s = a >= 1), Object.assign(t, {
    progress: a,
    isBeginning: i,
    isEnd: s
  }), (n.watchSlidesProgress || n.centeredSlides && n.autoHeight) && t.updateSlidesProgress(e), i && !o && t.emit("reachBeginning toEdge"), s && !l && t.emit("reachEnd toEdge"), (o && !i || l && !s) && t.emit("fromEdge"), t.emit("progress", a);
}
function gS() {
  const e = this, {
    slides: t,
    params: n,
    $wrapperEl: r,
    activeIndex: a,
    realIndex: i
  } = e, s = e.virtual && n.virtual.enabled;
  t.removeClass(`${n.slideActiveClass} ${n.slideNextClass} ${n.slidePrevClass} ${n.slideDuplicateActiveClass} ${n.slideDuplicateNextClass} ${n.slideDuplicatePrevClass}`);
  let o;
  s ? o = e.$wrapperEl.find(`.${n.slideClass}[data-swiper-slide-index="${a}"]`) : o = t.eq(a), o.addClass(n.slideActiveClass), n.loop && (o.hasClass(n.slideDuplicateClass) ? r.children(`.${n.slideClass}:not(.${n.slideDuplicateClass})[data-swiper-slide-index="${i}"]`).addClass(n.slideDuplicateActiveClass) : r.children(`.${n.slideClass}.${n.slideDuplicateClass}[data-swiper-slide-index="${i}"]`).addClass(n.slideDuplicateActiveClass));
  let l = o.nextAll(`.${n.slideClass}`).eq(0).addClass(n.slideNextClass);
  n.loop && l.length === 0 && (l = t.eq(0), l.addClass(n.slideNextClass));
  let u = o.prevAll(`.${n.slideClass}`).eq(0).addClass(n.slidePrevClass);
  n.loop && u.length === 0 && (u = t.eq(-1), u.addClass(n.slidePrevClass)), n.loop && (l.hasClass(n.slideDuplicateClass) ? r.children(`.${n.slideClass}:not(.${n.slideDuplicateClass})[data-swiper-slide-index="${l.attr("data-swiper-slide-index")}"]`).addClass(n.slideDuplicateNextClass) : r.children(`.${n.slideClass}.${n.slideDuplicateClass}[data-swiper-slide-index="${l.attr("data-swiper-slide-index")}"]`).addClass(n.slideDuplicateNextClass), u.hasClass(n.slideDuplicateClass) ? r.children(`.${n.slideClass}:not(.${n.slideDuplicateClass})[data-swiper-slide-index="${u.attr("data-swiper-slide-index")}"]`).addClass(n.slideDuplicatePrevClass) : r.children(`.${n.slideClass}.${n.slideDuplicateClass}[data-swiper-slide-index="${u.attr("data-swiper-slide-index")}"]`).addClass(n.slideDuplicatePrevClass)), e.emitSlidesClasses();
}
function bS(e) {
  const t = this, n = t.rtlTranslate ? t.translate : -t.translate, {
    slidesGrid: r,
    snapGrid: a,
    params: i,
    activeIndex: s,
    realIndex: o,
    snapIndex: l
  } = t;
  let u = e, c;
  if (typeof u > "u") {
    for (let f = 0; f < r.length; f += 1)
      typeof r[f + 1] < "u" ? n >= r[f] && n < r[f + 1] - (r[f + 1] - r[f]) / 2 ? u = f : n >= r[f] && n < r[f + 1] && (u = f + 1) : n >= r[f] && (u = f);
    i.normalizeSlideIndex && (u < 0 || typeof u > "u") && (u = 0);
  }
  if (a.indexOf(n) >= 0)
    c = a.indexOf(n);
  else {
    const f = Math.min(i.slidesPerGroupSkip, u);
    c = f + Math.floor((u - f) / i.slidesPerGroup);
  }
  if (c >= a.length && (c = a.length - 1), u === s) {
    c !== l && (t.snapIndex = c, t.emit("snapIndexChange"));
    return;
  }
  const d = parseInt(t.slides.eq(u).attr("data-swiper-slide-index") || u, 10);
  Object.assign(t, {
    snapIndex: c,
    realIndex: d,
    previousIndex: s,
    activeIndex: u
  }), t.emit("activeIndexChange"), t.emit("snapIndexChange"), o !== d && t.emit("realIndexChange"), (t.initialized || t.params.runCallbacksOnInit) && t.emit("slideChange");
}
function $S(e) {
  const t = this, n = t.params, r = se(e).closest(`.${n.slideClass}`)[0];
  let a = !1, i;
  if (r) {
    for (let s = 0; s < t.slides.length; s += 1)
      if (t.slides[s] === r) {
        a = !0, i = s;
        break;
      }
  }
  if (r && a)
    t.clickedSlide = r, t.virtual && t.params.virtual.enabled ? t.clickedIndex = parseInt(se(r).attr("data-swiper-slide-index"), 10) : t.clickedIndex = i;
  else {
    t.clickedSlide = void 0, t.clickedIndex = void 0;
    return;
  }
  n.slideToClickedSlide && t.clickedIndex !== void 0 && t.clickedIndex !== t.activeIndex && t.slideToClickedSlide();
}
const yS = {
  updateSize: dS,
  updateSlides: fS,
  updateAutoHeight: pS,
  updateSlidesOffset: hS,
  updateSlidesProgress: mS,
  updateProgress: vS,
  updateSlidesClasses: gS,
  updateActiveIndex: bS,
  updateClickedSlide: $S
};
function xS(e = this.isHorizontal() ? "x" : "y") {
  const t = this, {
    params: n,
    rtlTranslate: r,
    translate: a,
    $wrapperEl: i
  } = t;
  if (n.virtualTranslate)
    return r ? -a : a;
  if (n.cssMode)
    return a;
  let s = tS(i[0], e);
  return r && (s = -s), s || 0;
}
function _S(e, t) {
  const n = this, {
    rtlTranslate: r,
    params: a,
    $wrapperEl: i,
    wrapperEl: s,
    progress: o
  } = n;
  let l = 0, u = 0;
  const c = 0;
  n.isHorizontal() ? l = r ? -e : e : u = e, a.roundLengths && (l = Math.floor(l), u = Math.floor(u)), a.cssMode ? s[n.isHorizontal() ? "scrollLeft" : "scrollTop"] = n.isHorizontal() ? -l : -u : a.virtualTranslate || i.transform(`translate3d(${l}px, ${u}px, ${c}px)`), n.previousTranslate = n.translate, n.translate = n.isHorizontal() ? l : u;
  let d;
  const f = n.maxTranslate() - n.minTranslate();
  f === 0 ? d = 0 : d = (e - n.minTranslate()) / f, d !== o && n.updateProgress(e), n.emit("setTranslate", n.translate, t);
}
function wS() {
  return -this.snapGrid[0];
}
function SS() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function CS(e = 0, t = this.params.speed, n = !0, r = !0, a) {
  const i = this, {
    params: s,
    wrapperEl: o
  } = i;
  if (i.animating && s.preventInteractionOnTransition)
    return !1;
  const l = i.minTranslate(), u = i.maxTranslate();
  let c;
  if (r && e > l ? c = l : r && e < u ? c = u : c = e, i.updateProgress(c), s.cssMode) {
    const d = i.isHorizontal();
    if (t === 0)
      o[d ? "scrollLeft" : "scrollTop"] = -c;
    else {
      if (!i.support.smoothScroll)
        return G3({
          swiper: i,
          targetPosition: -c,
          side: d ? "left" : "top"
        }), !0;
      o.scrollTo({
        [d ? "left" : "top"]: -c,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return t === 0 ? (i.setTransition(0), i.setTranslate(c), n && (i.emit("beforeTransitionStart", t, a), i.emit("transitionEnd"))) : (i.setTransition(t), i.setTranslate(c), n && (i.emit("beforeTransitionStart", t, a), i.emit("transitionStart")), i.animating || (i.animating = !0, i.onTranslateToWrapperTransitionEnd || (i.onTranslateToWrapperTransitionEnd = function(f) {
    !i || i.destroyed || f.target === this && (i.$wrapperEl[0].removeEventListener("transitionend", i.onTranslateToWrapperTransitionEnd), i.$wrapperEl[0].removeEventListener("webkitTransitionEnd", i.onTranslateToWrapperTransitionEnd), i.onTranslateToWrapperTransitionEnd = null, delete i.onTranslateToWrapperTransitionEnd, n && i.emit("transitionEnd"));
  }), i.$wrapperEl[0].addEventListener("transitionend", i.onTranslateToWrapperTransitionEnd), i.$wrapperEl[0].addEventListener("webkitTransitionEnd", i.onTranslateToWrapperTransitionEnd))), !0;
}
const AS = {
  getTranslate: xS,
  setTranslate: _S,
  minTranslate: wS,
  maxTranslate: SS,
  translateTo: CS
};
function ES(e, t) {
  const n = this;
  n.params.cssMode || n.$wrapperEl.transition(e), n.emit("setTransition", e, t);
}
function W3({
  swiper: e,
  runCallbacks: t,
  direction: n,
  step: r
}) {
  const {
    activeIndex: a,
    previousIndex: i
  } = e;
  let s = n;
  if (s || (a > i ? s = "next" : a < i ? s = "prev" : s = "reset"), e.emit(`transition${r}`), t && a !== i) {
    if (s === "reset") {
      e.emit(`slideResetTransition${r}`);
      return;
    }
    e.emit(`slideChangeTransition${r}`), s === "next" ? e.emit(`slideNextTransition${r}`) : e.emit(`slidePrevTransition${r}`);
  }
}
function OS(e = !0, t) {
  const n = this, {
    params: r
  } = n;
  r.cssMode || (r.autoHeight && n.updateAutoHeight(), W3({
    swiper: n,
    runCallbacks: e,
    direction: t,
    step: "Start"
  }));
}
function TS(e = !0, t) {
  const n = this, {
    params: r
  } = n;
  n.animating = !1, !r.cssMode && (n.setTransition(0), W3({
    swiper: n,
    runCallbacks: e,
    direction: t,
    step: "End"
  }));
}
const MS = {
  setTransition: ES,
  transitionStart: OS,
  transitionEnd: TS
};
function kS(e = 0, t = this.params.speed, n = !0, r, a) {
  if (typeof e != "number" && typeof e != "string")
    throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof e}] given.`);
  if (typeof e == "string") {
    const $ = parseInt(e, 10);
    if (!isFinite($))
      throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${e}] given.`);
    e = $;
  }
  const i = this;
  let s = e;
  s < 0 && (s = 0);
  const {
    params: o,
    snapGrid: l,
    slidesGrid: u,
    previousIndex: c,
    activeIndex: d,
    rtlTranslate: f,
    wrapperEl: p,
    enabled: h
  } = i;
  if (i.animating && o.preventInteractionOnTransition || !h && !r && !a)
    return !1;
  const m = Math.min(i.params.slidesPerGroupSkip, s);
  let v = m + Math.floor((s - m) / i.params.slidesPerGroup);
  v >= l.length && (v = l.length - 1);
  const g = -l[v];
  if (o.normalizeSlideIndex)
    for (let $ = 0; $ < u.length; $ += 1) {
      const y = -Math.floor(g * 100), A = Math.floor(u[$] * 100), E = Math.floor(u[$ + 1] * 100);
      typeof u[$ + 1] < "u" ? y >= A && y < E - (E - A) / 2 ? s = $ : y >= A && y < E && (s = $ + 1) : y >= A && (s = $);
    }
  if (i.initialized && s !== d && (!i.allowSlideNext && g < i.translate && g < i.minTranslate() || !i.allowSlidePrev && g > i.translate && g > i.maxTranslate() && (d || 0) !== s))
    return !1;
  s !== (c || 0) && n && i.emit("beforeSlideChangeStart"), i.updateProgress(g);
  let b;
  if (s > d ? b = "next" : s < d ? b = "prev" : b = "reset", f && -g === i.translate || !f && g === i.translate)
    return i.updateActiveIndex(s), o.autoHeight && i.updateAutoHeight(), i.updateSlidesClasses(), o.effect !== "slide" && i.setTranslate(g), b !== "reset" && (i.transitionStart(n, b), i.transitionEnd(n, b)), !1;
  if (o.cssMode) {
    const $ = i.isHorizontal(), y = f ? g : -g;
    if (t === 0) {
      const A = i.virtual && i.params.virtual.enabled;
      A && (i.wrapperEl.style.scrollSnapType = "none", i._immediateVirtual = !0), p[$ ? "scrollLeft" : "scrollTop"] = y, A && requestAnimationFrame(() => {
        i.wrapperEl.style.scrollSnapType = "", i._swiperImmediateVirtual = !1;
      });
    } else {
      if (!i.support.smoothScroll)
        return G3({
          swiper: i,
          targetPosition: y,
          side: $ ? "left" : "top"
        }), !0;
      p.scrollTo({
        [$ ? "left" : "top"]: y,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return i.setTransition(t), i.setTranslate(g), i.updateActiveIndex(s), i.updateSlidesClasses(), i.emit("beforeTransitionStart", t, r), i.transitionStart(n, b), t === 0 ? i.transitionEnd(n, b) : i.animating || (i.animating = !0, i.onSlideToWrapperTransitionEnd || (i.onSlideToWrapperTransitionEnd = function(y) {
    !i || i.destroyed || y.target === this && (i.$wrapperEl[0].removeEventListener("transitionend", i.onSlideToWrapperTransitionEnd), i.$wrapperEl[0].removeEventListener("webkitTransitionEnd", i.onSlideToWrapperTransitionEnd), i.onSlideToWrapperTransitionEnd = null, delete i.onSlideToWrapperTransitionEnd, i.transitionEnd(n, b));
  }), i.$wrapperEl[0].addEventListener("transitionend", i.onSlideToWrapperTransitionEnd), i.$wrapperEl[0].addEventListener("webkitTransitionEnd", i.onSlideToWrapperTransitionEnd)), !0;
}
function LS(e = 0, t = this.params.speed, n = !0, r) {
  if (typeof e == "string") {
    const s = parseInt(e, 10);
    if (!isFinite(s))
      throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${e}] given.`);
    e = s;
  }
  const a = this;
  let i = e;
  return a.params.loop && (i += a.loopedSlides), a.slideTo(i, t, n, r);
}
function FS(e = this.params.speed, t = !0, n) {
  const r = this, {
    animating: a,
    enabled: i,
    params: s
  } = r;
  if (!i) return r;
  let o = s.slidesPerGroup;
  s.slidesPerView === "auto" && s.slidesPerGroup === 1 && s.slidesPerGroupAuto && (o = Math.max(r.slidesPerViewDynamic("current", !0), 1));
  const l = r.activeIndex < s.slidesPerGroupSkip ? 1 : o;
  if (s.loop) {
    if (a && s.loopPreventsSlide) return !1;
    r.loopFix(), r._clientLeft = r.$wrapperEl[0].clientLeft;
  }
  return s.rewind && r.isEnd ? r.slideTo(0, e, t, n) : r.slideTo(r.activeIndex + l, e, t, n);
}
function zS(e = this.params.speed, t = !0, n) {
  const r = this, {
    params: a,
    animating: i,
    snapGrid: s,
    slidesGrid: o,
    rtlTranslate: l,
    enabled: u
  } = r;
  if (!u) return r;
  if (a.loop) {
    if (i && a.loopPreventsSlide) return !1;
    r.loopFix(), r._clientLeft = r.$wrapperEl[0].clientLeft;
  }
  const c = l ? r.translate : -r.translate;
  function d(v) {
    return v < 0 ? -Math.floor(Math.abs(v)) : Math.floor(v);
  }
  const f = d(c), p = s.map((v) => d(v));
  let h = s[p.indexOf(f) - 1];
  if (typeof h > "u" && a.cssMode) {
    let v;
    s.forEach((g, b) => {
      f >= g && (v = b);
    }), typeof v < "u" && (h = s[v > 0 ? v - 1 : v]);
  }
  let m = 0;
  if (typeof h < "u" && (m = o.indexOf(h), m < 0 && (m = r.activeIndex - 1), a.slidesPerView === "auto" && a.slidesPerGroup === 1 && a.slidesPerGroupAuto && (m = m - r.slidesPerViewDynamic("previous", !0) + 1, m = Math.max(m, 0))), a.rewind && r.isBeginning) {
    const v = r.params.virtual && r.params.virtual.enabled && r.virtual ? r.virtual.slides.length - 1 : r.slides.length - 1;
    return r.slideTo(v, e, t, n);
  }
  return r.slideTo(m, e, t, n);
}
function PS(e = this.params.speed, t = !0, n) {
  const r = this;
  return r.slideTo(r.activeIndex, e, t, n);
}
function IS(e = this.params.speed, t = !0, n, r = 0.5) {
  const a = this;
  let i = a.activeIndex;
  const s = Math.min(a.params.slidesPerGroupSkip, i), o = s + Math.floor((i - s) / a.params.slidesPerGroup), l = a.rtlTranslate ? a.translate : -a.translate;
  if (l >= a.snapGrid[o]) {
    const u = a.snapGrid[o], c = a.snapGrid[o + 1];
    l - u > (c - u) * r && (i += a.params.slidesPerGroup);
  } else {
    const u = a.snapGrid[o - 1], c = a.snapGrid[o];
    l - u <= (c - u) * r && (i -= a.params.slidesPerGroup);
  }
  return i = Math.max(i, 0), i = Math.min(i, a.slidesGrid.length - 1), a.slideTo(i, e, t, n);
}
function NS() {
  const e = this, {
    params: t,
    $wrapperEl: n
  } = e, r = t.slidesPerView === "auto" ? e.slidesPerViewDynamic() : t.slidesPerView;
  let a = e.clickedIndex, i;
  if (t.loop) {
    if (e.animating) return;
    i = parseInt(se(e.clickedSlide).attr("data-swiper-slide-index"), 10), t.centeredSlides ? a < e.loopedSlides - r / 2 || a > e.slides.length - e.loopedSlides + r / 2 ? (e.loopFix(), a = n.children(`.${t.slideClass}[data-swiper-slide-index="${i}"]:not(.${t.slideDuplicateClass})`).eq(0).index(), bl(() => {
      e.slideTo(a);
    })) : e.slideTo(a) : a > e.slides.length - r ? (e.loopFix(), a = n.children(`.${t.slideClass}[data-swiper-slide-index="${i}"]:not(.${t.slideDuplicateClass})`).eq(0).index(), bl(() => {
      e.slideTo(a);
    })) : e.slideTo(a);
  } else
    e.slideTo(a);
}
const DS = {
  slideTo: kS,
  slideToLoop: LS,
  slideNext: FS,
  slidePrev: zS,
  slideReset: PS,
  slideToClosest: IS,
  slideToClickedSlide: NS
};
function RS() {
  const e = this, t = vt(), {
    params: n,
    $wrapperEl: r
  } = e, a = r.children().length > 0 ? se(r.children()[0].parentNode) : r;
  a.children(`.${n.slideClass}.${n.slideDuplicateClass}`).remove();
  let i = a.children(`.${n.slideClass}`);
  if (n.loopFillGroupWithBlank) {
    const l = n.slidesPerGroup - i.length % n.slidesPerGroup;
    if (l !== n.slidesPerGroup) {
      for (let u = 0; u < l; u += 1) {
        const c = se(t.createElement("div")).addClass(`${n.slideClass} ${n.slideBlankClass}`);
        a.append(c);
      }
      i = a.children(`.${n.slideClass}`);
    }
  }
  n.slidesPerView === "auto" && !n.loopedSlides && (n.loopedSlides = i.length), e.loopedSlides = Math.ceil(parseFloat(n.loopedSlides || n.slidesPerView, 10)), e.loopedSlides += n.loopAdditionalSlides, e.loopedSlides > i.length && e.params.loopedSlidesLimit && (e.loopedSlides = i.length);
  const s = [], o = [];
  i.each((l, u) => {
    se(l).attr("data-swiper-slide-index", u);
  });
  for (let l = 0; l < e.loopedSlides; l += 1) {
    const u = l - Math.floor(l / i.length) * i.length;
    o.push(i.eq(u)[0]), s.unshift(i.eq(i.length - u - 1)[0]);
  }
  for (let l = 0; l < o.length; l += 1)
    a.append(se(o[l].cloneNode(!0)).addClass(n.slideDuplicateClass));
  for (let l = s.length - 1; l >= 0; l -= 1)
    a.prepend(se(s[l].cloneNode(!0)).addClass(n.slideDuplicateClass));
}
function jS() {
  const e = this;
  e.emit("beforeLoopFix");
  const {
    activeIndex: t,
    slides: n,
    loopedSlides: r,
    allowSlidePrev: a,
    allowSlideNext: i,
    snapGrid: s,
    rtlTranslate: o
  } = e;
  let l;
  e.allowSlidePrev = !0, e.allowSlideNext = !0;
  const c = -s[t] - e.getTranslate();
  t < r ? (l = n.length - r * 3 + t, l += r, e.slideTo(l, 0, !1, !0) && c !== 0 && e.setTranslate((o ? -e.translate : e.translate) - c)) : t >= n.length - r && (l = -n.length + t + r, l += r, e.slideTo(l, 0, !1, !0) && c !== 0 && e.setTranslate((o ? -e.translate : e.translate) - c)), e.allowSlidePrev = a, e.allowSlideNext = i, e.emit("loopFix");
}
function BS() {
  const e = this, {
    $wrapperEl: t,
    params: n,
    slides: r
  } = e;
  t.children(`.${n.slideClass}.${n.slideDuplicateClass},.${n.slideClass}.${n.slideBlankClass}`).remove(), r.removeAttr("data-swiper-slide-index");
}
const VS = {
  loopCreate: RS,
  loopFix: jS,
  loopDestroy: BS
};
function US(e) {
  const t = this;
  if (t.support.touch || !t.params.simulateTouch || t.params.watchOverflow && t.isLocked || t.params.cssMode) return;
  const n = t.params.touchEventsTarget === "container" ? t.el : t.wrapperEl;
  n.style.cursor = "move", n.style.cursor = e ? "grabbing" : "grab";
}
function HS() {
  const e = this;
  e.support.touch || e.params.watchOverflow && e.isLocked || e.params.cssMode || (e[e.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "");
}
const GS = {
  setGrabCursor: US,
  unsetGrabCursor: HS
};
function qS(e, t = this) {
  function n(r) {
    if (!r || r === vt() || r === tt()) return null;
    r.assignedSlot && (r = r.assignedSlot);
    const a = r.closest(e);
    return !a && !r.getRootNode ? null : a || n(r.getRootNode().host);
  }
  return n(t);
}
function WS(e) {
  const t = this, n = vt(), r = tt(), a = t.touchEventsData, {
    params: i,
    touches: s,
    enabled: o
  } = t;
  if (!o || t.animating && i.preventInteractionOnTransition)
    return;
  !t.animating && i.cssMode && i.loop && t.loopFix();
  let l = e;
  l.originalEvent && (l = l.originalEvent);
  let u = se(l.target);
  if (i.touchEventsTarget === "wrapper" && !u.closest(t.wrapperEl).length || (a.isTouchEvent = l.type === "touchstart", !a.isTouchEvent && "which" in l && l.which === 3) || !a.isTouchEvent && "button" in l && l.button > 0 || a.isTouched && a.isMoved) return;
  const c = !!i.noSwipingClass && i.noSwipingClass !== "", d = e.composedPath ? e.composedPath() : e.path;
  c && l.target && l.target.shadowRoot && d && (u = se(d[0]));
  const f = i.noSwipingSelector ? i.noSwipingSelector : `.${i.noSwipingClass}`, p = !!(l.target && l.target.shadowRoot);
  if (i.noSwiping && (p ? qS(f, u[0]) : u.closest(f)[0])) {
    t.allowClick = !0;
    return;
  }
  if (i.swipeHandler && !u.closest(i.swipeHandler)[0])
    return;
  s.currentX = l.type === "touchstart" ? l.targetTouches[0].pageX : l.pageX, s.currentY = l.type === "touchstart" ? l.targetTouches[0].pageY : l.pageY;
  const h = s.currentX, m = s.currentY, v = i.edgeSwipeDetection || i.iOSEdgeSwipeDetection, g = i.edgeSwipeThreshold || i.iOSEdgeSwipeThreshold;
  if (v && (h <= g || h >= r.innerWidth - g))
    if (v === "prevent")
      e.preventDefault();
    else
      return;
  if (Object.assign(a, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), s.startX = h, s.startY = m, a.touchStartTime = sa(), t.allowClick = !0, t.updateSize(), t.swipeDirection = void 0, i.threshold > 0 && (a.allowThresholdMove = !1), l.type !== "touchstart") {
    let b = !0;
    u.is(a.focusableElements) && (b = !1, u[0].nodeName === "SELECT" && (a.isTouched = !1)), n.activeElement && se(n.activeElement).is(a.focusableElements) && n.activeElement !== u[0] && n.activeElement.blur();
    const $ = b && t.allowTouchMove && i.touchStartPreventDefault;
    (i.touchStartForcePreventDefault || $) && !u[0].isContentEditable && l.preventDefault();
  }
  t.params.freeMode && t.params.freeMode.enabled && t.freeMode && t.animating && !i.cssMode && t.freeMode.onTouchStart(), t.emit("touchStart", l);
}
function YS(e) {
  const t = vt(), n = this, r = n.touchEventsData, {
    params: a,
    touches: i,
    rtlTranslate: s,
    enabled: o
  } = n;
  if (!o) return;
  let l = e;
  if (l.originalEvent && (l = l.originalEvent), !r.isTouched) {
    r.startMoving && r.isScrolling && n.emit("touchMoveOpposite", l);
    return;
  }
  if (r.isTouchEvent && l.type !== "touchmove") return;
  const u = l.type === "touchmove" && l.targetTouches && (l.targetTouches[0] || l.changedTouches[0]), c = l.type === "touchmove" ? u.pageX : l.pageX, d = l.type === "touchmove" ? u.pageY : l.pageY;
  if (l.preventedByNestedSwiper) {
    i.startX = c, i.startY = d;
    return;
  }
  if (!n.allowTouchMove) {
    se(l.target).is(r.focusableElements) || (n.allowClick = !1), r.isTouched && (Object.assign(i, {
      startX: c,
      startY: d,
      currentX: c,
      currentY: d
    }), r.touchStartTime = sa());
    return;
  }
  if (r.isTouchEvent && a.touchReleaseOnEdges && !a.loop) {
    if (n.isVertical()) {
      if (d < i.startY && n.translate <= n.maxTranslate() || d > i.startY && n.translate >= n.minTranslate()) {
        r.isTouched = !1, r.isMoved = !1;
        return;
      }
    } else if (c < i.startX && n.translate <= n.maxTranslate() || c > i.startX && n.translate >= n.minTranslate())
      return;
  }
  if (r.isTouchEvent && t.activeElement && l.target === t.activeElement && se(l.target).is(r.focusableElements)) {
    r.isMoved = !0, n.allowClick = !1;
    return;
  }
  if (r.allowTouchCallbacks && n.emit("touchMove", l), l.targetTouches && l.targetTouches.length > 1) return;
  i.currentX = c, i.currentY = d;
  const f = i.currentX - i.startX, p = i.currentY - i.startY;
  if (n.params.threshold && Math.sqrt(f ** 2 + p ** 2) < n.params.threshold) return;
  if (typeof r.isScrolling > "u") {
    let g;
    n.isHorizontal() && i.currentY === i.startY || n.isVertical() && i.currentX === i.startX ? r.isScrolling = !1 : f * f + p * p >= 25 && (g = Math.atan2(Math.abs(p), Math.abs(f)) * 180 / Math.PI, r.isScrolling = n.isHorizontal() ? g > a.touchAngle : 90 - g > a.touchAngle);
  }
  if (r.isScrolling && n.emit("touchMoveOpposite", l), typeof r.startMoving > "u" && (i.currentX !== i.startX || i.currentY !== i.startY) && (r.startMoving = !0), r.isScrolling) {
    r.isTouched = !1;
    return;
  }
  if (!r.startMoving)
    return;
  n.allowClick = !1, !a.cssMode && l.cancelable && l.preventDefault(), a.touchMoveStopPropagation && !a.nested && l.stopPropagation(), r.isMoved || (a.loop && !a.cssMode && n.loopFix(), r.startTranslate = n.getTranslate(), n.setTransition(0), n.animating && n.$wrapperEl.trigger("webkitTransitionEnd transitionend"), r.allowMomentumBounce = !1, a.grabCursor && (n.allowSlideNext === !0 || n.allowSlidePrev === !0) && n.setGrabCursor(!0), n.emit("sliderFirstMove", l)), n.emit("sliderMove", l), r.isMoved = !0;
  let h = n.isHorizontal() ? f : p;
  i.diff = h, h *= a.touchRatio, s && (h = -h), n.swipeDirection = h > 0 ? "prev" : "next", r.currentTranslate = h + r.startTranslate;
  let m = !0, v = a.resistanceRatio;
  if (a.touchReleaseOnEdges && (v = 0), h > 0 && r.currentTranslate > n.minTranslate() ? (m = !1, a.resistance && (r.currentTranslate = n.minTranslate() - 1 + (-n.minTranslate() + r.startTranslate + h) ** v)) : h < 0 && r.currentTranslate < n.maxTranslate() && (m = !1, a.resistance && (r.currentTranslate = n.maxTranslate() + 1 - (n.maxTranslate() - r.startTranslate - h) ** v)), m && (l.preventedByNestedSwiper = !0), !n.allowSlideNext && n.swipeDirection === "next" && r.currentTranslate < r.startTranslate && (r.currentTranslate = r.startTranslate), !n.allowSlidePrev && n.swipeDirection === "prev" && r.currentTranslate > r.startTranslate && (r.currentTranslate = r.startTranslate), !n.allowSlidePrev && !n.allowSlideNext && (r.currentTranslate = r.startTranslate), a.threshold > 0)
    if (Math.abs(h) > a.threshold || r.allowThresholdMove) {
      if (!r.allowThresholdMove) {
        r.allowThresholdMove = !0, i.startX = i.currentX, i.startY = i.currentY, r.currentTranslate = r.startTranslate, i.diff = n.isHorizontal() ? i.currentX - i.startX : i.currentY - i.startY;
        return;
      }
    } else {
      r.currentTranslate = r.startTranslate;
      return;
    }
  !a.followFinger || a.cssMode || ((a.freeMode && a.freeMode.enabled && n.freeMode || a.watchSlidesProgress) && (n.updateActiveIndex(), n.updateSlidesClasses()), n.params.freeMode && a.freeMode.enabled && n.freeMode && n.freeMode.onTouchMove(), n.updateProgress(r.currentTranslate), n.setTranslate(r.currentTranslate));
}
function KS(e) {
  const t = this, n = t.touchEventsData, {
    params: r,
    touches: a,
    rtlTranslate: i,
    slidesGrid: s,
    enabled: o
  } = t;
  if (!o) return;
  let l = e;
  if (l.originalEvent && (l = l.originalEvent), n.allowTouchCallbacks && t.emit("touchEnd", l), n.allowTouchCallbacks = !1, !n.isTouched) {
    n.isMoved && r.grabCursor && t.setGrabCursor(!1), n.isMoved = !1, n.startMoving = !1;
    return;
  }
  r.grabCursor && n.isMoved && n.isTouched && (t.allowSlideNext === !0 || t.allowSlidePrev === !0) && t.setGrabCursor(!1);
  const u = sa(), c = u - n.touchStartTime;
  if (t.allowClick) {
    const b = l.path || l.composedPath && l.composedPath();
    t.updateClickedSlide(b && b[0] || l.target), t.emit("tap click", l), c < 300 && u - n.lastClickTime < 300 && t.emit("doubleTap doubleClick", l);
  }
  if (n.lastClickTime = sa(), bl(() => {
    t.destroyed || (t.allowClick = !0);
  }), !n.isTouched || !n.isMoved || !t.swipeDirection || a.diff === 0 || n.currentTranslate === n.startTranslate) {
    n.isTouched = !1, n.isMoved = !1, n.startMoving = !1;
    return;
  }
  n.isTouched = !1, n.isMoved = !1, n.startMoving = !1;
  let d;
  if (r.followFinger ? d = i ? t.translate : -t.translate : d = -n.currentTranslate, r.cssMode)
    return;
  if (t.params.freeMode && r.freeMode.enabled) {
    t.freeMode.onTouchEnd({
      currentPos: d
    });
    return;
  }
  let f = 0, p = t.slidesSizesGrid[0];
  for (let b = 0; b < s.length; b += b < r.slidesPerGroupSkip ? 1 : r.slidesPerGroup) {
    const $ = b < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
    typeof s[b + $] < "u" ? d >= s[b] && d < s[b + $] && (f = b, p = s[b + $] - s[b]) : d >= s[b] && (f = b, p = s[s.length - 1] - s[s.length - 2]);
  }
  let h = null, m = null;
  r.rewind && (t.isBeginning ? m = t.params.virtual && t.params.virtual.enabled && t.virtual ? t.virtual.slides.length - 1 : t.slides.length - 1 : t.isEnd && (h = 0));
  const v = (d - s[f]) / p, g = f < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
  if (c > r.longSwipesMs) {
    if (!r.longSwipes) {
      t.slideTo(t.activeIndex);
      return;
    }
    t.swipeDirection === "next" && (v >= r.longSwipesRatio ? t.slideTo(r.rewind && t.isEnd ? h : f + g) : t.slideTo(f)), t.swipeDirection === "prev" && (v > 1 - r.longSwipesRatio ? t.slideTo(f + g) : m !== null && v < 0 && Math.abs(v) > r.longSwipesRatio ? t.slideTo(m) : t.slideTo(f));
  } else {
    if (!r.shortSwipes) {
      t.slideTo(t.activeIndex);
      return;
    }
    t.navigation && (l.target === t.navigation.nextEl || l.target === t.navigation.prevEl) ? l.target === t.navigation.nextEl ? t.slideTo(f + g) : t.slideTo(f) : (t.swipeDirection === "next" && t.slideTo(h !== null ? h : f + g), t.swipeDirection === "prev" && t.slideTo(m !== null ? m : f));
  }
}
function e0() {
  const e = this, {
    params: t,
    el: n
  } = e;
  if (n && n.offsetWidth === 0) return;
  t.breakpoints && e.setBreakpoint();
  const {
    allowSlideNext: r,
    allowSlidePrev: a,
    snapGrid: i
  } = e;
  e.allowSlideNext = !0, e.allowSlidePrev = !0, e.updateSize(), e.updateSlides(), e.updateSlidesClasses(), (t.slidesPerView === "auto" || t.slidesPerView > 1) && e.isEnd && !e.isBeginning && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0), e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.run(), e.allowSlidePrev = a, e.allowSlideNext = r, e.params.watchOverflow && i !== e.snapGrid && e.checkOverflow();
}
function ZS(e) {
  const t = this;
  t.enabled && (t.allowClick || (t.params.preventClicks && e.preventDefault(), t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation())));
}
function XS() {
  const e = this, {
    wrapperEl: t,
    rtlTranslate: n,
    enabled: r
  } = e;
  if (!r) return;
  e.previousTranslate = e.translate, e.isHorizontal() ? e.translate = -t.scrollLeft : e.translate = -t.scrollTop, e.translate === 0 && (e.translate = 0), e.updateActiveIndex(), e.updateSlidesClasses();
  let a;
  const i = e.maxTranslate() - e.minTranslate();
  i === 0 ? a = 0 : a = (e.translate - e.minTranslate()) / i, a !== e.progress && e.updateProgress(n ? -e.translate : e.translate), e.emit("setTranslate", e.translate, !1);
}
let t0 = !1;
function JS() {
}
const Y3 = (e, t) => {
  const n = vt(), {
    params: r,
    touchEvents: a,
    el: i,
    wrapperEl: s,
    device: o,
    support: l
  } = e, u = !!r.nested, c = t === "on" ? "addEventListener" : "removeEventListener", d = t;
  if (!l.touch)
    i[c](a.start, e.onTouchStart, !1), n[c](a.move, e.onTouchMove, u), n[c](a.end, e.onTouchEnd, !1);
  else {
    const f = a.start === "touchstart" && l.passiveListener && r.passiveListeners ? {
      passive: !0,
      capture: !1
    } : !1;
    i[c](a.start, e.onTouchStart, f), i[c](a.move, e.onTouchMove, l.passiveListener ? {
      passive: !1,
      capture: u
    } : u), i[c](a.end, e.onTouchEnd, f), a.cancel && i[c](a.cancel, e.onTouchEnd, f);
  }
  (r.preventClicks || r.preventClicksPropagation) && i[c]("click", e.onClick, !0), r.cssMode && s[c]("scroll", e.onScroll), r.updateOnWindowResize ? e[d](o.ios || o.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", e0, !0) : e[d]("observerUpdate", e0, !0);
};
function QS() {
  const e = this, t = vt(), {
    params: n,
    support: r
  } = e;
  e.onTouchStart = WS.bind(e), e.onTouchMove = YS.bind(e), e.onTouchEnd = KS.bind(e), n.cssMode && (e.onScroll = XS.bind(e)), e.onClick = ZS.bind(e), r.touch && !t0 && (t.addEventListener("touchstart", JS), t0 = !0), Y3(e, "on");
}
function eC() {
  Y3(this, "off");
}
const tC = {
  attachEvents: QS,
  detachEvents: eC
}, n0 = (e, t) => e.grid && t.grid && t.grid.rows > 1;
function nC() {
  const e = this, {
    activeIndex: t,
    initialized: n,
    loopedSlides: r = 0,
    params: a,
    $el: i
  } = e, s = a.breakpoints;
  if (!s || s && Object.keys(s).length === 0) return;
  const o = e.getBreakpoint(s, e.params.breakpointsBase, e.el);
  if (!o || e.currentBreakpoint === o) return;
  const u = (o in s ? s[o] : void 0) || e.originalParams, c = n0(e, a), d = n0(e, u), f = a.enabled;
  c && !d ? (i.removeClass(`${a.containerModifierClass}grid ${a.containerModifierClass}grid-column`), e.emitContainerClasses()) : !c && d && (i.addClass(`${a.containerModifierClass}grid`), (u.grid.fill && u.grid.fill === "column" || !u.grid.fill && a.grid.fill === "column") && i.addClass(`${a.containerModifierClass}grid-column`), e.emitContainerClasses()), ["navigation", "pagination", "scrollbar"].forEach((v) => {
    const g = a[v] && a[v].enabled, b = u[v] && u[v].enabled;
    g && !b && e[v].disable(), !g && b && e[v].enable();
  });
  const p = u.direction && u.direction !== a.direction, h = a.loop && (u.slidesPerView !== a.slidesPerView || p);
  p && n && e.changeDirection(), Et(e.params, u);
  const m = e.params.enabled;
  Object.assign(e, {
    allowTouchMove: e.params.allowTouchMove,
    allowSlideNext: e.params.allowSlideNext,
    allowSlidePrev: e.params.allowSlidePrev
  }), f && !m ? e.disable() : !f && m && e.enable(), e.currentBreakpoint = o, e.emit("_beforeBreakpoint", u), h && n && (e.loopDestroy(), e.loopCreate(), e.updateSlides(), e.slideTo(t - r + e.loopedSlides, 0, !1)), e.emit("breakpoint", u);
}
function rC(e, t = "window", n) {
  if (!e || t === "container" && !n) return;
  let r = !1;
  const a = tt(), i = t === "window" ? a.innerHeight : n.clientHeight, s = Object.keys(e).map((o) => {
    if (typeof o == "string" && o.indexOf("@") === 0) {
      const l = parseFloat(o.substr(1));
      return {
        value: i * l,
        point: o
      };
    }
    return {
      value: o,
      point: o
    };
  });
  s.sort((o, l) => parseInt(o.value, 10) - parseInt(l.value, 10));
  for (let o = 0; o < s.length; o += 1) {
    const {
      point: l,
      value: u
    } = s[o];
    t === "window" ? a.matchMedia(`(min-width: ${u}px)`).matches && (r = l) : u <= n.clientWidth && (r = l);
  }
  return r || "max";
}
const aC = {
  setBreakpoint: nC,
  getBreakpoint: rC
};
function iC(e, t) {
  const n = [];
  return e.forEach((r) => {
    typeof r == "object" ? Object.keys(r).forEach((a) => {
      r[a] && n.push(t + a);
    }) : typeof r == "string" && n.push(t + r);
  }), n;
}
function sC() {
  const e = this, {
    classNames: t,
    params: n,
    rtl: r,
    $el: a,
    device: i,
    support: s
  } = e, o = iC(["initialized", n.direction, {
    "pointer-events": !s.touch
  }, {
    "free-mode": e.params.freeMode && n.freeMode.enabled
  }, {
    autoheight: n.autoHeight
  }, {
    rtl: r
  }, {
    grid: n.grid && n.grid.rows > 1
  }, {
    "grid-column": n.grid && n.grid.rows > 1 && n.grid.fill === "column"
  }, {
    android: i.android
  }, {
    ios: i.ios
  }, {
    "css-mode": n.cssMode
  }, {
    centered: n.cssMode && n.centeredSlides
  }, {
    "watch-progress": n.watchSlidesProgress
  }], n.containerModifierClass);
  t.push(...o), a.addClass([...t].join(" ")), e.emitContainerClasses();
}
function oC() {
  const e = this, {
    $el: t,
    classNames: n
  } = e;
  t.removeClass(n.join(" ")), e.emitContainerClasses();
}
const lC = {
  addClasses: sC,
  removeClasses: oC
};
function uC(e, t, n, r, a, i) {
  const s = tt();
  let o;
  function l() {
    i && i();
  }
  !se(e).parent("picture")[0] && (!e.complete || !a) && t ? (o = new s.Image(), o.onload = l, o.onerror = l, r && (o.sizes = r), n && (o.srcset = n), t && (o.src = t)) : l();
}
function cC() {
  const e = this;
  e.imagesToLoad = e.$el.find("img");
  function t() {
    typeof e > "u" || e === null || !e || e.destroyed || (e.imagesLoaded !== void 0 && (e.imagesLoaded += 1), e.imagesLoaded === e.imagesToLoad.length && (e.params.updateOnImagesReady && e.update(), e.emit("imagesReady")));
  }
  for (let n = 0; n < e.imagesToLoad.length; n += 1) {
    const r = e.imagesToLoad[n];
    e.loadImage(r, r.currentSrc || r.getAttribute("src"), r.srcset || r.getAttribute("srcset"), r.sizes || r.getAttribute("sizes"), !0, t);
  }
}
const dC = {
  loadImage: uC,
  preloadImages: cC
};
function fC() {
  const e = this, {
    isLocked: t,
    params: n
  } = e, {
    slidesOffsetBefore: r
  } = n;
  if (r) {
    const a = e.slides.length - 1, i = e.slidesGrid[a] + e.slidesSizesGrid[a] + r * 2;
    e.isLocked = e.size > i;
  } else
    e.isLocked = e.snapGrid.length === 1;
  n.allowSlideNext === !0 && (e.allowSlideNext = !e.isLocked), n.allowSlidePrev === !0 && (e.allowSlidePrev = !e.isLocked), t && t !== e.isLocked && (e.isEnd = !1), t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
}
const pC = {
  checkOverflow: fC
}, r0 = {
  init: !0,
  direction: "horizontal",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: !1,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: !1,
  // Set wrapper width
  setWrapperSize: !1,
  // Virtual Translate
  virtualTranslate: !1,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: !0,
  // Round length
  roundLengths: !1,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 0,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  // Unique Navigation Elements
  uniqueNavElements: !0,
  // Resistance
  resistance: !0,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: !1,
  // Cursor
  grabCursor: !1,
  // Clicks
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  // Images
  preloadImages: !0,
  updateOnImagesReady: !0,
  // loop
  loop: !1,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopedSlidesLimit: !0,
  loopFillGroupWithBlank: !1,
  loopPreventsSlide: !0,
  // rewind
  rewind: !1,
  // Swiping/no swiping
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-invisible-blank",
  slideActiveClass: "swiper-slide-active",
  slideDuplicateActiveClass: "swiper-slide-duplicate-active",
  slideVisibleClass: "swiper-slide-visible",
  slideDuplicateClass: "swiper-slide-duplicate",
  slideNextClass: "swiper-slide-next",
  slideDuplicateNextClass: "swiper-slide-duplicate-next",
  slidePrevClass: "swiper-slide-prev",
  slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
  wrapperClass: "swiper-wrapper",
  // Callbacks
  runCallbacksOnInit: !0,
  // Internals
  _emitClasses: !1
};
function hC(e, t) {
  return function(r = {}) {
    const a = Object.keys(r)[0], i = r[a];
    if (typeof i != "object" || i === null) {
      Et(t, r);
      return;
    }
    if (["navigation", "pagination", "scrollbar"].indexOf(a) >= 0 && e[a] === !0 && (e[a] = {
      auto: !0
    }), !(a in e && "enabled" in i)) {
      Et(t, r);
      return;
    }
    e[a] === !0 && (e[a] = {
      enabled: !0
    }), typeof e[a] == "object" && !("enabled" in e[a]) && (e[a].enabled = !0), e[a] || (e[a] = {
      enabled: !1
    }), Et(t, r);
  };
}
const Ss = {
  eventsEmitter: cS,
  update: yS,
  translate: AS,
  transition: MS,
  slide: DS,
  loop: VS,
  grabCursor: GS,
  events: tC,
  breakpoints: aC,
  checkOverflow: pC,
  classes: lC,
  images: dC
}, Cs = {};
let xr = class dn {
  constructor(...t) {
    let n, r;
    if (t.length === 1 && t[0].constructor && Object.prototype.toString.call(t[0]).slice(8, -1) === "Object" ? r = t[0] : [n, r] = t, r || (r = {}), r = Et({}, r), n && !r.el && (r.el = n), r.el && se(r.el).length > 1) {
      const o = [];
      return se(r.el).each((l) => {
        const u = Et({}, r, {
          el: l
        });
        o.push(new dn(u));
      }), o;
    }
    const a = this;
    a.__swiper__ = !0, a.support = q3(), a.device = iS({
      userAgent: r.userAgent
    }), a.browser = oS(), a.eventsListeners = {}, a.eventsAnyListeners = [], a.modules = [...a.__modules__], r.modules && Array.isArray(r.modules) && a.modules.push(...r.modules);
    const i = {};
    a.modules.forEach((o) => {
      o({
        swiper: a,
        extendParams: hC(r, i),
        on: a.on.bind(a),
        once: a.once.bind(a),
        off: a.off.bind(a),
        emit: a.emit.bind(a)
      });
    });
    const s = Et({}, r0, i);
    return a.params = Et({}, s, Cs, r), a.originalParams = Et({}, a.params), a.passedParams = Et({}, r), a.params && a.params.on && Object.keys(a.params.on).forEach((o) => {
      a.on(o, a.params.on[o]);
    }), a.params && a.params.onAny && a.onAny(a.params.onAny), a.$ = se, Object.assign(a, {
      enabled: a.params.enabled,
      el: n,
      // Classes
      classNames: [],
      // Slides
      slides: se(),
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return a.params.direction === "horizontal";
      },
      isVertical() {
        return a.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: !0,
      isEnd: !1,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      // Locks
      allowSlideNext: a.params.allowSlideNext,
      allowSlidePrev: a.params.allowSlidePrev,
      // Touch Events
      touchEvents: function() {
        const l = ["touchstart", "touchmove", "touchend", "touchcancel"], u = ["pointerdown", "pointermove", "pointerup"];
        return a.touchEventsTouch = {
          start: l[0],
          move: l[1],
          end: l[2],
          cancel: l[3]
        }, a.touchEventsDesktop = {
          start: u[0],
          move: u[1],
          end: u[2]
        }, a.support.touch || !a.params.simulateTouch ? a.touchEventsTouch : a.touchEventsDesktop;
      }(),
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: a.params.focusableElements,
        // Last click time
        lastClickTime: sa(),
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        isTouchEvent: void 0,
        startMoving: void 0
      },
      // Clicks
      allowClick: !0,
      // Touches
      allowTouchMove: a.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }), a.emit("_swiper"), a.params.init && a.init(), a;
  }
  enable() {
    const t = this;
    t.enabled || (t.enabled = !0, t.params.grabCursor && t.setGrabCursor(), t.emit("enable"));
  }
  disable() {
    const t = this;
    t.enabled && (t.enabled = !1, t.params.grabCursor && t.unsetGrabCursor(), t.emit("disable"));
  }
  setProgress(t, n) {
    const r = this;
    t = Math.min(Math.max(t, 0), 1);
    const a = r.minTranslate(), s = (r.maxTranslate() - a) * t + a;
    r.translateTo(s, typeof n > "u" ? 0 : n), r.updateActiveIndex(), r.updateSlidesClasses();
  }
  emitContainerClasses() {
    const t = this;
    if (!t.params._emitClasses || !t.el) return;
    const n = t.el.className.split(" ").filter((r) => r.indexOf("swiper") === 0 || r.indexOf(t.params.containerModifierClass) === 0);
    t.emit("_containerClasses", n.join(" "));
  }
  getSlideClasses(t) {
    const n = this;
    return n.destroyed ? "" : t.className.split(" ").filter((r) => r.indexOf("swiper-slide") === 0 || r.indexOf(n.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const t = this;
    if (!t.params._emitClasses || !t.el) return;
    const n = [];
    t.slides.each((r) => {
      const a = t.getSlideClasses(r);
      n.push({
        slideEl: r,
        classNames: a
      }), t.emit("_slideClass", r, a);
    }), t.emit("_slideClasses", n);
  }
  slidesPerViewDynamic(t = "current", n = !1) {
    const r = this, {
      params: a,
      slides: i,
      slidesGrid: s,
      slidesSizesGrid: o,
      size: l,
      activeIndex: u
    } = r;
    let c = 1;
    if (a.centeredSlides) {
      let d = i[u].swiperSlideSize, f;
      for (let p = u + 1; p < i.length; p += 1)
        i[p] && !f && (d += i[p].swiperSlideSize, c += 1, d > l && (f = !0));
      for (let p = u - 1; p >= 0; p -= 1)
        i[p] && !f && (d += i[p].swiperSlideSize, c += 1, d > l && (f = !0));
    } else if (t === "current")
      for (let d = u + 1; d < i.length; d += 1)
        (n ? s[d] + o[d] - s[u] < l : s[d] - s[u] < l) && (c += 1);
    else
      for (let d = u - 1; d >= 0; d -= 1)
        s[u] - s[d] < l && (c += 1);
    return c;
  }
  update() {
    const t = this;
    if (!t || t.destroyed) return;
    const {
      snapGrid: n,
      params: r
    } = t;
    r.breakpoints && t.setBreakpoint(), t.updateSize(), t.updateSlides(), t.updateProgress(), t.updateSlidesClasses();
    function a() {
      const s = t.rtlTranslate ? t.translate * -1 : t.translate, o = Math.min(Math.max(s, t.maxTranslate()), t.minTranslate());
      t.setTranslate(o), t.updateActiveIndex(), t.updateSlidesClasses();
    }
    let i;
    t.params.freeMode && t.params.freeMode.enabled ? (a(), t.params.autoHeight && t.updateAutoHeight()) : ((t.params.slidesPerView === "auto" || t.params.slidesPerView > 1) && t.isEnd && !t.params.centeredSlides ? i = t.slideTo(t.slides.length - 1, 0, !1, !0) : i = t.slideTo(t.activeIndex, 0, !1, !0), i || a()), r.watchOverflow && n !== t.snapGrid && t.checkOverflow(), t.emit("update");
  }
  changeDirection(t, n = !0) {
    const r = this, a = r.params.direction;
    return t || (t = a === "horizontal" ? "vertical" : "horizontal"), t === a || t !== "horizontal" && t !== "vertical" || (r.$el.removeClass(`${r.params.containerModifierClass}${a}`).addClass(`${r.params.containerModifierClass}${t}`), r.emitContainerClasses(), r.params.direction = t, r.slides.each((i) => {
      t === "vertical" ? i.style.width = "" : i.style.height = "";
    }), r.emit("changeDirection"), n && r.update()), r;
  }
  changeLanguageDirection(t) {
    const n = this;
    n.rtl && t === "rtl" || !n.rtl && t === "ltr" || (n.rtl = t === "rtl", n.rtlTranslate = n.params.direction === "horizontal" && n.rtl, n.rtl ? (n.$el.addClass(`${n.params.containerModifierClass}rtl`), n.el.dir = "rtl") : (n.$el.removeClass(`${n.params.containerModifierClass}rtl`), n.el.dir = "ltr"), n.update());
  }
  mount(t) {
    const n = this;
    if (n.mounted) return !0;
    const r = se(t || n.params.el);
    if (t = r[0], !t)
      return !1;
    t.swiper = n;
    const a = () => `.${(n.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let s = (() => {
      if (t && t.shadowRoot && t.shadowRoot.querySelector) {
        const o = se(t.shadowRoot.querySelector(a()));
        return o.children = (l) => r.children(l), o;
      }
      return r.children ? r.children(a()) : se(r).children(a());
    })();
    if (s.length === 0 && n.params.createElements) {
      const l = vt().createElement("div");
      s = se(l), l.className = n.params.wrapperClass, r.append(l), r.children(`.${n.params.slideClass}`).each((u) => {
        s.append(u);
      });
    }
    return Object.assign(n, {
      $el: r,
      el: t,
      $wrapperEl: s,
      wrapperEl: s[0],
      mounted: !0,
      // RTL
      rtl: t.dir.toLowerCase() === "rtl" || r.css("direction") === "rtl",
      rtlTranslate: n.params.direction === "horizontal" && (t.dir.toLowerCase() === "rtl" || r.css("direction") === "rtl"),
      wrongRTL: s.css("display") === "-webkit-box"
    }), !0;
  }
  init(t) {
    const n = this;
    return n.initialized || n.mount(t) === !1 || (n.emit("beforeInit"), n.params.breakpoints && n.setBreakpoint(), n.addClasses(), n.params.loop && n.loopCreate(), n.updateSize(), n.updateSlides(), n.params.watchOverflow && n.checkOverflow(), n.params.grabCursor && n.enabled && n.setGrabCursor(), n.params.preloadImages && n.preloadImages(), n.params.loop ? n.slideTo(n.params.initialSlide + n.loopedSlides, 0, n.params.runCallbacksOnInit, !1, !0) : n.slideTo(n.params.initialSlide, 0, n.params.runCallbacksOnInit, !1, !0), n.attachEvents(), n.initialized = !0, n.emit("init"), n.emit("afterInit")), n;
  }
  destroy(t = !0, n = !0) {
    const r = this, {
      params: a,
      $el: i,
      $wrapperEl: s,
      slides: o
    } = r;
    return typeof r.params > "u" || r.destroyed || (r.emit("beforeDestroy"), r.initialized = !1, r.detachEvents(), a.loop && r.loopDestroy(), n && (r.removeClasses(), i.removeAttr("style"), s.removeAttr("style"), o && o.length && o.removeClass([a.slideVisibleClass, a.slideActiveClass, a.slideNextClass, a.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index")), r.emit("destroy"), Object.keys(r.eventsListeners).forEach((l) => {
      r.off(l);
    }), t !== !1 && (r.$el[0].swiper = null, Qw(r)), r.destroyed = !0), null;
  }
  static extendDefaults(t) {
    Et(Cs, t);
  }
  static get extendedDefaults() {
    return Cs;
  }
  static get defaults() {
    return r0;
  }
  static installModule(t) {
    dn.prototype.__modules__ || (dn.prototype.__modules__ = []);
    const n = dn.prototype.__modules__;
    typeof t == "function" && n.indexOf(t) < 0 && n.push(t);
  }
  static use(t) {
    return Array.isArray(t) ? (t.forEach((n) => dn.installModule(n)), dn) : (dn.installModule(t), dn);
  }
};
Object.keys(Ss).forEach((e) => {
  Object.keys(Ss[e]).forEach((t) => {
    xr.prototype[t] = Ss[e][t];
  });
});
xr.use([lS, uS]);
function mC({
  swiper: e,
  extendParams: t,
  on: n,
  emit: r
}) {
  const a = vt(), i = tt();
  e.keyboard = {
    enabled: !1
  }, t({
    keyboard: {
      enabled: !1,
      onlyInViewport: !0,
      pageUpDown: !0
    }
  });
  function s(u) {
    if (!e.enabled) return;
    const {
      rtlTranslate: c
    } = e;
    let d = u;
    d.originalEvent && (d = d.originalEvent);
    const f = d.keyCode || d.charCode, p = e.params.keyboard.pageUpDown, h = p && f === 33, m = p && f === 34, v = f === 37, g = f === 39, b = f === 38, $ = f === 40;
    if (!e.allowSlideNext && (e.isHorizontal() && g || e.isVertical() && $ || m) || !e.allowSlidePrev && (e.isHorizontal() && v || e.isVertical() && b || h))
      return !1;
    if (!(d.shiftKey || d.altKey || d.ctrlKey || d.metaKey) && !(a.activeElement && a.activeElement.nodeName && (a.activeElement.nodeName.toLowerCase() === "input" || a.activeElement.nodeName.toLowerCase() === "textarea"))) {
      if (e.params.keyboard.onlyInViewport && (h || m || v || g || b || $)) {
        let y = !1;
        if (e.$el.parents(`.${e.params.slideClass}`).length > 0 && e.$el.parents(`.${e.params.slideActiveClass}`).length === 0)
          return;
        const A = e.$el, E = A[0].clientWidth, L = A[0].clientHeight, D = i.innerWidth, ne = i.innerHeight, I = e.$el.offset();
        c && (I.left -= e.$el[0].scrollLeft);
        const B = [[I.left, I.top], [I.left + E, I.top], [I.left, I.top + L], [I.left + E, I.top + L]];
        for (let ae = 0; ae < B.length; ae += 1) {
          const we = B[ae];
          if (we[0] >= 0 && we[0] <= D && we[1] >= 0 && we[1] <= ne) {
            if (we[0] === 0 && we[1] === 0) continue;
            y = !0;
          }
        }
        if (!y) return;
      }
      e.isHorizontal() ? ((h || m || v || g) && (d.preventDefault ? d.preventDefault() : d.returnValue = !1), ((m || g) && !c || (h || v) && c) && e.slideNext(), ((h || v) && !c || (m || g) && c) && e.slidePrev()) : ((h || m || b || $) && (d.preventDefault ? d.preventDefault() : d.returnValue = !1), (m || $) && e.slideNext(), (h || b) && e.slidePrev()), r("keyPress", f);
    }
  }
  function o() {
    e.keyboard.enabled || (se(a).on("keydown", s), e.keyboard.enabled = !0);
  }
  function l() {
    e.keyboard.enabled && (se(a).off("keydown", s), e.keyboard.enabled = !1);
  }
  n("init", () => {
    e.params.keyboard.enabled && o();
  }), n("destroy", () => {
    e.keyboard.enabled && l();
  }), Object.assign(e.keyboard, {
    enable: o,
    disable: l
  });
}
function vC(e, t, n, r) {
  const a = vt();
  return e.params.createElements && Object.keys(r).forEach((i) => {
    if (!n[i] && n.auto === !0) {
      let s = e.$el.children(`.${r[i]}`)[0];
      s || (s = a.createElement("div"), s.className = r[i], e.$el.append(s)), n[i] = s, t[i] = s;
    }
  }), n;
}
function gC({
  swiper: e,
  extendParams: t,
  on: n,
  emit: r
}) {
  t({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: !1,
      disabledClass: "swiper-button-disabled",
      hiddenClass: "swiper-button-hidden",
      lockClass: "swiper-button-lock",
      navigationDisabledClass: "swiper-navigation-disabled"
    }
  }), e.navigation = {
    nextEl: null,
    $nextEl: null,
    prevEl: null,
    $prevEl: null
  };
  function a(p) {
    let h;
    return p && (h = se(p), e.params.uniqueNavElements && typeof p == "string" && h.length > 1 && e.$el.find(p).length === 1 && (h = e.$el.find(p))), h;
  }
  function i(p, h) {
    const m = e.params.navigation;
    p && p.length > 0 && (p[h ? "addClass" : "removeClass"](m.disabledClass), p[0] && p[0].tagName === "BUTTON" && (p[0].disabled = h), e.params.watchOverflow && e.enabled && p[e.isLocked ? "addClass" : "removeClass"](m.lockClass));
  }
  function s() {
    if (e.params.loop) return;
    const {
      $nextEl: p,
      $prevEl: h
    } = e.navigation;
    i(h, e.isBeginning && !e.params.rewind), i(p, e.isEnd && !e.params.rewind);
  }
  function o(p) {
    p.preventDefault(), !(e.isBeginning && !e.params.loop && !e.params.rewind) && (e.slidePrev(), r("navigationPrev"));
  }
  function l(p) {
    p.preventDefault(), !(e.isEnd && !e.params.loop && !e.params.rewind) && (e.slideNext(), r("navigationNext"));
  }
  function u() {
    const p = e.params.navigation;
    if (e.params.navigation = vC(e, e.originalParams.navigation, e.params.navigation, {
      nextEl: "swiper-button-next",
      prevEl: "swiper-button-prev"
    }), !(p.nextEl || p.prevEl)) return;
    const h = a(p.nextEl), m = a(p.prevEl);
    h && h.length > 0 && h.on("click", l), m && m.length > 0 && m.on("click", o), Object.assign(e.navigation, {
      $nextEl: h,
      nextEl: h && h[0],
      $prevEl: m,
      prevEl: m && m[0]
    }), e.enabled || (h && h.addClass(p.lockClass), m && m.addClass(p.lockClass));
  }
  function c() {
    const {
      $nextEl: p,
      $prevEl: h
    } = e.navigation;
    p && p.length && (p.off("click", l), p.removeClass(e.params.navigation.disabledClass)), h && h.length && (h.off("click", o), h.removeClass(e.params.navigation.disabledClass));
  }
  n("init", () => {
    e.params.navigation.enabled === !1 ? f() : (u(), s());
  }), n("toEdge fromEdge lock unlock", () => {
    s();
  }), n("destroy", () => {
    c();
  }), n("enable disable", () => {
    const {
      $nextEl: p,
      $prevEl: h
    } = e.navigation;
    p && p[e.enabled ? "removeClass" : "addClass"](e.params.navigation.lockClass), h && h[e.enabled ? "removeClass" : "addClass"](e.params.navigation.lockClass);
  }), n("click", (p, h) => {
    const {
      $nextEl: m,
      $prevEl: v
    } = e.navigation, g = h.target;
    if (e.params.navigation.hideOnClick && !se(g).is(v) && !se(g).is(m)) {
      if (e.pagination && e.params.pagination && e.params.pagination.clickable && (e.pagination.el === g || e.pagination.el.contains(g))) return;
      let b;
      m ? b = m.hasClass(e.params.navigation.hiddenClass) : v && (b = v.hasClass(e.params.navigation.hiddenClass)), r(b === !0 ? "navigationShow" : "navigationHide"), m && m.toggleClass(e.params.navigation.hiddenClass), v && v.toggleClass(e.params.navigation.hiddenClass);
    }
  });
  const d = () => {
    e.$el.removeClass(e.params.navigation.navigationDisabledClass), u(), s();
  }, f = () => {
    e.$el.addClass(e.params.navigation.navigationDisabledClass), c();
  };
  Object.assign(e.navigation, {
    enable: d,
    disable: f,
    update: s,
    init: u,
    destroy: c
  });
}
function Xn(e) {
  return typeof e == "object" && e !== null && e.constructor && Object.prototype.toString.call(e).slice(8, -1) === "Object";
}
function Mn(e, t) {
  const n = ["__proto__", "constructor", "prototype"];
  Object.keys(t).filter((r) => n.indexOf(r) < 0).forEach((r) => {
    typeof e[r] > "u" ? e[r] = t[r] : Xn(t[r]) && Xn(e[r]) && Object.keys(t[r]).length > 0 ? t[r].__swiper__ ? e[r] = t[r] : Mn(e[r], t[r]) : e[r] = t[r];
  });
}
function K3(e = {}) {
  return e.navigation && typeof e.navigation.nextEl > "u" && typeof e.navigation.prevEl > "u";
}
function Z3(e = {}) {
  return e.pagination && typeof e.pagination.el > "u";
}
function X3(e = {}) {
  return e.scrollbar && typeof e.scrollbar.el > "u";
}
function J3(e = "") {
  const t = e.split(" ").map((r) => r.trim()).filter((r) => !!r), n = [];
  return t.forEach((r) => {
    n.indexOf(r) < 0 && n.push(r);
  }), n.join(" ");
}
const Q3 = [
  "modules",
  "init",
  "_direction",
  "touchEventsTarget",
  "initialSlide",
  "_speed",
  "cssMode",
  "updateOnWindowResize",
  "resizeObserver",
  "nested",
  "focusableElements",
  "_enabled",
  "_width",
  "_height",
  "preventInteractionOnTransition",
  "userAgent",
  "url",
  "_edgeSwipeDetection",
  "_edgeSwipeThreshold",
  "_freeMode",
  "_autoHeight",
  "setWrapperSize",
  "virtualTranslate",
  "_effect",
  "breakpoints",
  "_spaceBetween",
  "_slidesPerView",
  "maxBackfaceHiddenSlides",
  "_grid",
  "_slidesPerGroup",
  "_slidesPerGroupSkip",
  "_slidesPerGroupAuto",
  "_centeredSlides",
  "_centeredSlidesBounds",
  "_slidesOffsetBefore",
  "_slidesOffsetAfter",
  "normalizeSlideIndex",
  "_centerInsufficientSlides",
  "_watchOverflow",
  "roundLengths",
  "touchRatio",
  "touchAngle",
  "simulateTouch",
  "_shortSwipes",
  "_longSwipes",
  "longSwipesRatio",
  "longSwipesMs",
  "_followFinger",
  "allowTouchMove",
  "_threshold",
  "touchMoveStopPropagation",
  "touchStartPreventDefault",
  "touchStartForcePreventDefault",
  "touchReleaseOnEdges",
  "uniqueNavElements",
  "_resistance",
  "_resistanceRatio",
  "_watchSlidesProgress",
  "_grabCursor",
  "preventClicks",
  "preventClicksPropagation",
  "_slideToClickedSlide",
  "_preloadImages",
  "updateOnImagesReady",
  "_loop",
  "_loopAdditionalSlides",
  "_loopedSlides",
  "_loopedSlidesLimit",
  "_loopFillGroupWithBlank",
  "loopPreventsSlide",
  "_rewind",
  "_allowSlidePrev",
  "_allowSlideNext",
  "_swipeHandler",
  "_noSwiping",
  "noSwipingClass",
  "noSwipingSelector",
  "passiveListeners",
  "containerModifierClass",
  "slideClass",
  "slideBlankClass",
  "slideActiveClass",
  "slideDuplicateActiveClass",
  "slideVisibleClass",
  "slideDuplicateClass",
  "slideNextClass",
  "slideDuplicateNextClass",
  "slidePrevClass",
  "slideDuplicatePrevClass",
  "wrapperClass",
  "runCallbacksOnInit",
  "observer",
  "observeParents",
  "observeSlideChildren",
  // modules
  "a11y",
  "_autoplay",
  "_controller",
  "coverflowEffect",
  "cubeEffect",
  "fadeEffect",
  "flipEffect",
  "creativeEffect",
  "cardsEffect",
  "hashNavigation",
  "history",
  "keyboard",
  "lazy",
  "mousewheel",
  "_navigation",
  "_pagination",
  "parallax",
  "_scrollbar",
  "_thumbs",
  "virtual",
  "zoom"
];
function a0(e = {}, t = !0) {
  const n = {
    on: {}
  }, r = {}, a = {};
  Mn(n, xr.defaults), Mn(n, xr.extendedDefaults), n._emitClasses = !0, n.init = !1;
  const i = {}, s = Q3.map((l) => l.replace(/_/, "")), o = Object.assign({}, e);
  return Object.keys(o).forEach((l) => {
    typeof e[l] > "u" || (s.indexOf(l) >= 0 ? Xn(e[l]) ? (n[l] = {}, a[l] = {}, Mn(n[l], e[l]), Mn(a[l], e[l])) : (n[l] = e[l], a[l] = e[l]) : l.search(/on[A-Z]/) === 0 && typeof e[l] == "function" ? t ? r[`${l[2].toLowerCase()}${l.substr(3)}`] = e[l] : n.on[`${l[2].toLowerCase()}${l.substr(3)}`] = e[l] : i[l] = e[l]);
  }), ["navigation", "pagination", "scrollbar"].forEach((l) => {
    n[l] === !0 && (n[l] = {}), n[l] === !1 && delete n[l];
  }), {
    params: n,
    passedParams: a,
    rest: i,
    events: r
  };
}
function bC({
  el: e,
  nextEl: t,
  prevEl: n,
  paginationEl: r,
  scrollbarEl: a,
  swiper: i
}, s) {
  K3(s) && t && n && (i.params.navigation.nextEl = t, i.originalParams.navigation.nextEl = t, i.params.navigation.prevEl = n, i.originalParams.navigation.prevEl = n), Z3(s) && r && (i.params.pagination.el = r, i.originalParams.pagination.el = r), X3(s) && a && (i.params.scrollbar.el = a, i.originalParams.scrollbar.el = a), i.init(e);
}
const e4 = (e, t) => {
  let n = t.slidesPerView;
  if (t.breakpoints) {
    const a = xr.prototype.getBreakpoint(t.breakpoints), i = a in t.breakpoints ? t.breakpoints[a] : void 0;
    i && i.slidesPerView && (n = i.slidesPerView);
  }
  let r = Math.ceil(parseFloat(t.loopedSlides || n, 10));
  return r += t.loopAdditionalSlides, r > e.length && t.loopedSlidesLimit && (r = e.length), r;
};
function $C(e, t, n) {
  const r = t.map((l, u) => (l.props || (l.props = {}), l.props.swiperRef = e, l.props["data-swiper-slide-index"] = u, l));
  function a(l, u, c) {
    return l.props || (l.props = {}), et(l.type, {
      ...l.props,
      key: `${l.key}-duplicate-${u}-${c}`,
      class: `${l.props.className || ""} ${n.slideDuplicateClass} ${l.props.class || ""}`
    }, l.children);
  }
  if (n.loopFillGroupWithBlank) {
    const l = n.slidesPerGroup - r.length % n.slidesPerGroup;
    if (l !== n.slidesPerGroup)
      for (let u = 0; u < l; u += 1) {
        const c = et("div", {
          class: `${n.slideClass} ${n.slideBlankClass}`
        });
        r.push(c);
      }
  }
  n.slidesPerView === "auto" && !n.loopedSlides && (n.loopedSlides = r.length);
  const i = e4(r, n), s = [], o = [];
  for (let l = 0; l < i; l += 1) {
    const u = l - Math.floor(l / r.length) * r.length;
    o.push(a(r[u], l, "append")), s.unshift(a(r[r.length - u - 1], l, "prepend"));
  }
  return e.value && (e.value.loopedSlides = i), [...s, ...r, ...o];
}
function yC(e, t, n, r, a) {
  const i = [];
  if (!t) return i;
  const s = (l) => {
    i.indexOf(l) < 0 && i.push(l);
  };
  if (n && r) {
    const l = r.map(a), u = n.map(a);
    l.join("") !== u.join("") && s("children"), r.length !== n.length && s("children");
  }
  return Q3.filter((l) => l[0] === "_").map((l) => l.replace(/_/, "")).forEach((l) => {
    if (l in e && l in t)
      if (Xn(e[l]) && Xn(t[l])) {
        const u = Object.keys(e[l]), c = Object.keys(t[l]);
        u.length !== c.length ? s(l) : (u.forEach((d) => {
          e[l][d] !== t[l][d] && s(l);
        }), c.forEach((d) => {
          e[l][d] !== t[l][d] && s(l);
        }));
      } else e[l] !== t[l] && s(l);
  }), i;
}
function As(e, t, n) {
  e === void 0 && (e = {});
  const r = [], a = {
    "container-start": [],
    "container-end": [],
    "wrapper-start": [],
    "wrapper-end": []
  }, i = (s, o) => {
    Array.isArray(s) && s.forEach((l) => {
      const u = typeof l.type == "symbol";
      o === "default" && (o = "container-end"), u && l.children ? i(l.children, "default") : l.type && (l.type.name === "SwiperSlide" || l.type.name === "AsyncComponentWrapper") ? r.push(l) : a[o] && a[o].push(l);
    });
  };
  return Object.keys(e).forEach((s) => {
    if (typeof e[s] != "function") return;
    const o = e[s]();
    i(o, s);
  }), n.value = t.value, t.value = r, {
    slides: r,
    slots: a
  };
}
function xC({
  swiper: e,
  slides: t,
  passedParams: n,
  changedParams: r,
  nextEl: a,
  prevEl: i,
  scrollbarEl: s,
  paginationEl: o
}) {
  const l = r.filter((A) => A !== "children" && A !== "direction"), {
    params: u,
    pagination: c,
    navigation: d,
    scrollbar: f,
    virtual: p,
    thumbs: h
  } = e;
  let m, v, g, b, $;
  r.includes("thumbs") && n.thumbs && n.thumbs.swiper && u.thumbs && !u.thumbs.swiper && (m = !0), r.includes("controller") && n.controller && n.controller.control && u.controller && !u.controller.control && (v = !0), r.includes("pagination") && n.pagination && (n.pagination.el || o) && (u.pagination || u.pagination === !1) && c && !c.el && (g = !0), r.includes("scrollbar") && n.scrollbar && (n.scrollbar.el || s) && (u.scrollbar || u.scrollbar === !1) && f && !f.el && (b = !0), r.includes("navigation") && n.navigation && (n.navigation.prevEl || i) && (n.navigation.nextEl || a) && (u.navigation || u.navigation === !1) && d && !d.prevEl && !d.nextEl && ($ = !0);
  const y = (A) => {
    e[A] && (e[A].destroy(), A === "navigation" ? (u[A].prevEl = void 0, u[A].nextEl = void 0, e[A].prevEl = void 0, e[A].nextEl = void 0) : (u[A].el = void 0, e[A].el = void 0));
  };
  l.forEach((A) => {
    if (Xn(u[A]) && Xn(n[A]))
      Mn(u[A], n[A]);
    else {
      const E = n[A];
      (E === !0 || E === !1) && (A === "navigation" || A === "pagination" || A === "scrollbar") ? E === !1 && y(A) : u[A] = n[A];
    }
  }), l.includes("controller") && !v && e.controller && e.controller.control && u.controller && u.controller.control && (e.controller.control = u.controller.control), r.includes("children") && t && p && u.virtual.enabled ? (p.slides = t, p.update(!0)) : r.includes("children") && e.lazy && e.params.lazy.enabled && e.lazy.load(), m && h.init() && h.update(!0), v && (e.controller.control = u.controller.control), g && (o && (u.pagination.el = o), c.init(), c.render(), c.update()), b && (s && (u.scrollbar.el = s), f.init(), f.updateSize(), f.setTranslate()), $ && (a && (u.navigation.nextEl = a), i && (u.navigation.prevEl = i), d.init(), d.update()), r.includes("allowSlideNext") && (e.allowSlideNext = n.allowSlideNext), r.includes("allowSlidePrev") && (e.allowSlidePrev = n.allowSlidePrev), r.includes("direction") && e.changeDirection(n.direction, !1), e.update();
}
function _C(e, t, n) {
  if (!n) return null;
  const r = e.value.isHorizontal() ? {
    [e.value.rtlTranslate ? "right" : "left"]: `${n.offset}px`
  } : {
    top: `${n.offset}px`
  };
  return t.filter((a, i) => i >= n.from && i <= n.to).map((a) => (a.props || (a.props = {}), a.props.style || (a.props.style = {}), a.props.swiperRef = e, a.props.style = r, et(a.type, {
    ...a.props
  }, a.children)));
}
const wC = (e) => {
  !e || e.destroyed || !e.params.virtual || e.params.virtual && !e.params.virtual.enabled || (e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), e.lazy && e.params.lazy.enabled && e.lazy.load(), e.parallax && e.params.parallax && e.params.parallax.enabled && e.parallax.setTranslate());
}, SC = {
  name: "Swiper",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    wrapperTag: {
      type: String,
      default: "div"
    },
    modules: {
      type: Array,
      default: void 0
    },
    init: {
      type: Boolean,
      default: void 0
    },
    direction: {
      type: String,
      default: void 0
    },
    touchEventsTarget: {
      type: String,
      default: void 0
    },
    initialSlide: {
      type: Number,
      default: void 0
    },
    speed: {
      type: Number,
      default: void 0
    },
    cssMode: {
      type: Boolean,
      default: void 0
    },
    updateOnWindowResize: {
      type: Boolean,
      default: void 0
    },
    resizeObserver: {
      type: Boolean,
      default: void 0
    },
    nested: {
      type: Boolean,
      default: void 0
    },
    focusableElements: {
      type: String,
      default: void 0
    },
    width: {
      type: Number,
      default: void 0
    },
    height: {
      type: Number,
      default: void 0
    },
    preventInteractionOnTransition: {
      type: Boolean,
      default: void 0
    },
    userAgent: {
      type: String,
      default: void 0
    },
    url: {
      type: String,
      default: void 0
    },
    edgeSwipeDetection: {
      type: [Boolean, String],
      default: void 0
    },
    edgeSwipeThreshold: {
      type: Number,
      default: void 0
    },
    autoHeight: {
      type: Boolean,
      default: void 0
    },
    setWrapperSize: {
      type: Boolean,
      default: void 0
    },
    virtualTranslate: {
      type: Boolean,
      default: void 0
    },
    effect: {
      type: String,
      default: void 0
    },
    breakpoints: {
      type: Object,
      default: void 0
    },
    spaceBetween: {
      type: Number,
      default: void 0
    },
    slidesPerView: {
      type: [Number, String],
      default: void 0
    },
    maxBackfaceHiddenSlides: {
      type: Number,
      default: void 0
    },
    slidesPerGroup: {
      type: Number,
      default: void 0
    },
    slidesPerGroupSkip: {
      type: Number,
      default: void 0
    },
    slidesPerGroupAuto: {
      type: Boolean,
      default: void 0
    },
    centeredSlides: {
      type: Boolean,
      default: void 0
    },
    centeredSlidesBounds: {
      type: Boolean,
      default: void 0
    },
    slidesOffsetBefore: {
      type: Number,
      default: void 0
    },
    slidesOffsetAfter: {
      type: Number,
      default: void 0
    },
    normalizeSlideIndex: {
      type: Boolean,
      default: void 0
    },
    centerInsufficientSlides: {
      type: Boolean,
      default: void 0
    },
    watchOverflow: {
      type: Boolean,
      default: void 0
    },
    roundLengths: {
      type: Boolean,
      default: void 0
    },
    touchRatio: {
      type: Number,
      default: void 0
    },
    touchAngle: {
      type: Number,
      default: void 0
    },
    simulateTouch: {
      type: Boolean,
      default: void 0
    },
    shortSwipes: {
      type: Boolean,
      default: void 0
    },
    longSwipes: {
      type: Boolean,
      default: void 0
    },
    longSwipesRatio: {
      type: Number,
      default: void 0
    },
    longSwipesMs: {
      type: Number,
      default: void 0
    },
    followFinger: {
      type: Boolean,
      default: void 0
    },
    allowTouchMove: {
      type: Boolean,
      default: void 0
    },
    threshold: {
      type: Number,
      default: void 0
    },
    touchMoveStopPropagation: {
      type: Boolean,
      default: void 0
    },
    touchStartPreventDefault: {
      type: Boolean,
      default: void 0
    },
    touchStartForcePreventDefault: {
      type: Boolean,
      default: void 0
    },
    touchReleaseOnEdges: {
      type: Boolean,
      default: void 0
    },
    uniqueNavElements: {
      type: Boolean,
      default: void 0
    },
    resistance: {
      type: Boolean,
      default: void 0
    },
    resistanceRatio: {
      type: Number,
      default: void 0
    },
    watchSlidesProgress: {
      type: Boolean,
      default: void 0
    },
    grabCursor: {
      type: Boolean,
      default: void 0
    },
    preventClicks: {
      type: Boolean,
      default: void 0
    },
    preventClicksPropagation: {
      type: Boolean,
      default: void 0
    },
    slideToClickedSlide: {
      type: Boolean,
      default: void 0
    },
    preloadImages: {
      type: Boolean,
      default: void 0
    },
    updateOnImagesReady: {
      type: Boolean,
      default: void 0
    },
    loop: {
      type: Boolean,
      default: void 0
    },
    loopAdditionalSlides: {
      type: Number,
      default: void 0
    },
    loopedSlides: {
      type: Number,
      default: void 0
    },
    loopedSlidesLimit: {
      type: Boolean,
      default: !0
    },
    loopFillGroupWithBlank: {
      type: Boolean,
      default: void 0
    },
    loopPreventsSlide: {
      type: Boolean,
      default: void 0
    },
    rewind: {
      type: Boolean,
      default: void 0
    },
    allowSlidePrev: {
      type: Boolean,
      default: void 0
    },
    allowSlideNext: {
      type: Boolean,
      default: void 0
    },
    swipeHandler: {
      type: Boolean,
      default: void 0
    },
    noSwiping: {
      type: Boolean,
      default: void 0
    },
    noSwipingClass: {
      type: String,
      default: void 0
    },
    noSwipingSelector: {
      type: String,
      default: void 0
    },
    passiveListeners: {
      type: Boolean,
      default: void 0
    },
    containerModifierClass: {
      type: String,
      default: void 0
    },
    slideClass: {
      type: String,
      default: void 0
    },
    slideBlankClass: {
      type: String,
      default: void 0
    },
    slideActiveClass: {
      type: String,
      default: void 0
    },
    slideDuplicateActiveClass: {
      type: String,
      default: void 0
    },
    slideVisibleClass: {
      type: String,
      default: void 0
    },
    slideDuplicateClass: {
      type: String,
      default: void 0
    },
    slideNextClass: {
      type: String,
      default: void 0
    },
    slideDuplicateNextClass: {
      type: String,
      default: void 0
    },
    slidePrevClass: {
      type: String,
      default: void 0
    },
    slideDuplicatePrevClass: {
      type: String,
      default: void 0
    },
    wrapperClass: {
      type: String,
      default: void 0
    },
    runCallbacksOnInit: {
      type: Boolean,
      default: void 0
    },
    observer: {
      type: Boolean,
      default: void 0
    },
    observeParents: {
      type: Boolean,
      default: void 0
    },
    observeSlideChildren: {
      type: Boolean,
      default: void 0
    },
    a11y: {
      type: [Boolean, Object],
      default: void 0
    },
    autoplay: {
      type: [Boolean, Object],
      default: void 0
    },
    controller: {
      type: Object,
      default: void 0
    },
    coverflowEffect: {
      type: Object,
      default: void 0
    },
    cubeEffect: {
      type: Object,
      default: void 0
    },
    fadeEffect: {
      type: Object,
      default: void 0
    },
    flipEffect: {
      type: Object,
      default: void 0
    },
    creativeEffect: {
      type: Object,
      default: void 0
    },
    cardsEffect: {
      type: Object,
      default: void 0
    },
    hashNavigation: {
      type: [Boolean, Object],
      default: void 0
    },
    history: {
      type: [Boolean, Object],
      default: void 0
    },
    keyboard: {
      type: [Boolean, Object],
      default: void 0
    },
    lazy: {
      type: [Boolean, Object],
      default: void 0
    },
    mousewheel: {
      type: [Boolean, Object],
      default: void 0
    },
    navigation: {
      type: [Boolean, Object],
      default: void 0
    },
    pagination: {
      type: [Boolean, Object],
      default: void 0
    },
    parallax: {
      type: [Boolean, Object],
      default: void 0
    },
    scrollbar: {
      type: [Boolean, Object],
      default: void 0
    },
    thumbs: {
      type: Object,
      default: void 0
    },
    virtual: {
      type: [Boolean, Object],
      default: void 0
    },
    zoom: {
      type: [Boolean, Object],
      default: void 0
    },
    grid: {
      type: [Object],
      default: void 0
    },
    freeMode: {
      type: [Boolean, Object],
      default: void 0
    },
    enabled: {
      type: Boolean,
      default: void 0
    }
  },
  emits: ["_beforeBreakpoint", "_containerClasses", "_slideClass", "_slideClasses", "_swiper", "_freeModeNoMomentumRelease", "activeIndexChange", "afterInit", "autoplay", "autoplayStart", "autoplayStop", "autoplayPause", "autoplayResume", "beforeDestroy", "beforeInit", "beforeLoopFix", "beforeResize", "beforeSlideChangeStart", "beforeTransitionStart", "breakpoint", "changeDirection", "click", "disable", "doubleTap", "doubleClick", "destroy", "enable", "fromEdge", "hashChange", "hashSet", "imagesReady", "init", "keyPress", "lazyImageLoad", "lazyImageReady", "lock", "loopFix", "momentumBounce", "navigationHide", "navigationShow", "navigationPrev", "navigationNext", "observerUpdate", "orientationchange", "paginationHide", "paginationRender", "paginationShow", "paginationUpdate", "progress", "reachBeginning", "reachEnd", "realIndexChange", "resize", "scroll", "scrollbarDragEnd", "scrollbarDragMove", "scrollbarDragStart", "setTransition", "setTranslate", "slideChange", "slideChangeTransitionEnd", "slideChangeTransitionStart", "slideNextTransitionEnd", "slideNextTransitionStart", "slidePrevTransitionEnd", "slidePrevTransitionStart", "slideResetTransitionStart", "slideResetTransitionEnd", "sliderMove", "sliderFirstMove", "slidesLengthChange", "slidesGridLengthChange", "snapGridLengthChange", "snapIndexChange", "swiper", "tap", "toEdge", "touchEnd", "touchMove", "touchMoveOpposite", "touchStart", "transitionEnd", "transitionStart", "unlock", "update", "virtualUpdate", "zoomChange"],
  setup(e, t) {
    let {
      slots: n,
      emit: r
    } = t;
    const {
      tag: a,
      wrapperTag: i
    } = e, s = N("swiper"), o = N(null), l = N(!1), u = N(!1), c = N(null), d = N(null), f = N(null), p = {
      value: []
    }, h = {
      value: []
    }, m = N(null), v = N(null), g = N(null), b = N(null), {
      params: $,
      passedParams: y
    } = a0(e, !1);
    As(n, p, h), f.value = y, h.value = p.value;
    const A = () => {
      As(n, p, h), l.value = !0;
    };
    if ($.onAny = function(L) {
      for (var D = arguments.length, ne = new Array(D > 1 ? D - 1 : 0), I = 1; I < D; I++)
        ne[I - 1] = arguments[I];
      r(L, ...ne);
    }, Object.assign($.on, {
      _beforeBreakpoint: A,
      _containerClasses(L, D) {
        s.value = D;
      }
    }), d.value = new xr($), d.value.loopCreate = () => {
    }, d.value.loopDestroy = () => {
    }, $.loop && (d.value.loopedSlides = e4(p.value, $)), d.value.virtual && d.value.params.virtual.enabled) {
      d.value.virtual.slides = p.value;
      const L = {
        cache: !1,
        slides: p.value,
        renderExternal: (D) => {
          o.value = D;
        },
        renderExternalUpdate: !1
      };
      Mn(d.value.params.virtual, L), Mn(d.value.originalParams.virtual, L);
    }
    sf(() => {
      !u.value && d.value && (d.value.emitSlidesClasses(), u.value = !0);
      const {
        passedParams: L
      } = a0(e, !1), D = yC(L, f.value, p.value, h.value, (ne) => ne.props && ne.props.key);
      f.value = L, (D.length || l.value) && d.value && !d.value.destroyed && xC({
        swiper: d.value,
        slides: p.value,
        passedParams: L,
        changedParams: D,
        nextEl: m.value,
        prevEl: v.value,
        scrollbarEl: b.value,
        paginationEl: g.value
      }), l.value = !1;
    }), Wn("swiper", d), De(o, () => {
      We(() => {
        wC(d.value);
      });
    }), Ue(() => {
      c.value && (bC({
        el: c.value,
        nextEl: m.value,
        prevEl: v.value,
        paginationEl: g.value,
        scrollbarEl: b.value,
        swiper: d.value
      }, $), r("swiper", d.value));
    }), Oi(() => {
      d.value && !d.value.destroyed && d.value.destroy(!0, !1);
    });
    function E(L) {
      return $.virtual ? _C(d, L, o.value) : !$.loop || d.value && d.value.destroyed ? (L.forEach((D) => {
        D.props || (D.props = {}), D.props.swiperRef = d;
      }), L) : $C(d, L, $);
    }
    return () => {
      const {
        slides: L,
        slots: D
      } = As(n, p, h);
      return et(a, {
        ref: c,
        class: J3(s.value)
      }, [D["container-start"], et(i, {
        class: "swiper-wrapper"
      }, [D["wrapper-start"], E(L), D["wrapper-end"]]), K3(e) && [et("div", {
        ref: v,
        class: "swiper-button-prev"
      }), et("div", {
        ref: m,
        class: "swiper-button-next"
      })], X3(e) && et("div", {
        ref: b,
        class: "swiper-scrollbar"
      }), Z3(e) && et("div", {
        ref: g,
        class: "swiper-pagination"
      }), D["container-end"]]);
    };
  }
}, CC = {
  name: "SwiperSlide",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    swiperRef: {
      type: Object,
      required: !1
    },
    zoom: {
      type: Boolean,
      default: void 0
    },
    virtualIndex: {
      type: [String, Number],
      default: void 0
    }
  },
  setup(e, t) {
    let {
      slots: n
    } = t, r = !1;
    const {
      swiperRef: a
    } = e, i = N(null), s = N("swiper-slide");
    function o(u, c, d) {
      c === i.value && (s.value = d);
    }
    Ue(() => {
      !a || !a.value || (a.value.on("_slideClass", o), r = !0);
    }), e8(() => {
      r || !a || !a.value || (a.value.on("_slideClass", o), r = !0);
    }), sf(() => {
      !i.value || !a || !a.value || a.value.destroyed && s.value !== "swiper-slide" && (s.value = "swiper-slide");
    }), Oi(() => {
      !a || !a.value || a.value.off("_slideClass", o);
    });
    const l = P(() => ({
      isActive: s.value.indexOf("swiper-slide-active") >= 0 || s.value.indexOf("swiper-slide-duplicate-active") >= 0,
      isVisible: s.value.indexOf("swiper-slide-visible") >= 0,
      isDuplicate: s.value.indexOf("swiper-slide-duplicate") >= 0,
      isPrev: s.value.indexOf("swiper-slide-prev") >= 0 || s.value.indexOf("swiper-slide-duplicate-prev") >= 0,
      isNext: s.value.indexOf("swiper-slide-next") >= 0 || s.value.indexOf("swiper-slide-duplicate-next") >= 0
    }));
    return Wn("swiperSlide", l), () => et(e.tag, {
      class: J3(`${s.value}`),
      ref: i,
      "data-swiper-slide-index": e.virtualIndex
    }, e.zoom ? et("div", {
      class: "swiper-zoom-container",
      "data-swiper-zoom": typeof e.zoom == "number" ? e.zoom : void 0
    }, n.default && n.default(l.value)) : n.default && n.default(l.value));
  }
}, AC = {
  key: 0,
  class: "fixed inset-0 z-[100] bg-blue-50 opacity-80"
}, EC = { class: "absolute inset-0 bg-black/75" }, OC = {
  name: "AppLightbox"
}, TC = /* @__PURE__ */ re({
  ...OC,
  props: {
    slideCount: {},
    visible: { type: Boolean, default: !1 },
    initialSlide: { default: 0 },
    slidesPerView: { default: 5 },
    spaceBetween: { default: 0 }
  },
  emits: ["hide"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = () => {
      r("hide");
    };
    return (i, s) => (C(), ve(vr, null, {
      default: fe(() => [
        i.visible ? (C(), T("div", AC, [
          S("div", {
            class: "absolute top-4 right-4 z-[9] size-8 cursor-pointer rounded-full bg-black text-center leading-8 text-white opacity-50",
            "data-test-id": "hide-ligthbox",
            onClick: a
          }, [
            U(x(te), {
              icon: ["fas", "xmark"],
              size: "2x"
            })
          ]),
          S("div", EC, [
            U(x(SC), {
              "initial-slide": n.initialSlide,
              "slides-per-view": 1,
              "space-between": 0,
              modules: [x(gC), x(mC)],
              "data-test-id": "swiper-slides",
              navigation: "",
              keyboard: ""
            }, {
              default: fe(() => [
                (C(!0), T(Oe, null, Fe(n.slideCount, (o) => (C(), ve(x(CC), {
                  key: o,
                  "data-test-id": `swiper-slide-${o.toString()}`,
                  "is-active": "",
                  class: "flex h-screen flex-col items-center justify-center sm:px-8 sm:py-12",
                  keyboard: "",
                  navigation: ""
                }, {
                  default: fe(() => [
                    Ce(i.$slots, `slide-${o}`, {}, void 0, !0)
                  ]),
                  _: 2
                }, 1032, ["data-test-id"]))), 128))
              ]),
              _: 3
            }, 8, ["initial-slide", "modules"])
          ])
        ])) : K("", !0)
      ]),
      _: 3
    }));
  }
}), MC = /* @__PURE__ */ Ct(TC, [["__scopeId", "data-v-db1916ea"]]), kC = {
  key: 0,
  class: "mr-6 flex size-6 shrink-0 items-center justify-center"
}, LC = { class: "flex grow flex-col overflow-hidden text-intro-strong" }, FC = {
  name: "AppCardHeader"
}, zC = /* @__PURE__ */ re({
  ...FC,
  props: {
    icon: {},
    link: { type: Boolean }
  },
  setup(e) {
    const t = e;
    return (n, r) => (C(), T("header", {
      role: "group",
      class: z(["flex items-center justify-between p-6 [&:not(:last-child)]:pb-0", { "cursor-pointer": t.link }])
    }, [
      Ce(n.$slots, "icon"),
      t.icon ? (C(), T("div", kC, [
        U(x(te), {
          icon: t.icon,
          size: "2x"
        }, null, 8, ["icon"])
      ])) : K("", !0),
      S("span", LC, [
        Ce(n.$slots, "default")
      ]),
      Ce(n.$slots, "link", {}, () => [
        t.link ? (C(), ve(x(te), {
          key: 0,
          icon: x(Uf),
          size: "2x",
          class: "justify-self-end pl-6 text-blue-700"
        }, null, 8, ["icon"])) : K("", !0)
      ])
    ], 2));
  }
}), PC = {
  role: "group",
  class: "relative flex flex-col overflow-hidden rounded-t-3xl [&:not(:last-child)]:pb-0"
}, IC = { class: "flex aspect-[25/14] w-full grow items-stretch bg-blue-50" }, NC = {
  name: "AppCardGalleryHeader"
}, DC = /* @__PURE__ */ re({
  ...NC,
  props: {
    images: {},
    alt: { default: "" },
    portalProxy: { default: "" },
    fetching: { type: Boolean, default: !1 },
    teleport: { default: void 0 }
  },
  setup(e) {
    const t = e;
    return (n, r) => (C(), T("header", PC, [
      U(yt, {
        fetching: t.fetching
      }, {
        default: fe(() => [
          S("div", IC, [
            U(gu, i1(s1(t)), {
              image: fe((a) => [
                Ce(n.$slots, "image", i1(s1(a)))
              ]),
              _: 3
            }, 16)
          ])
        ]),
        _: 3
      }, 8, ["fetching"])
    ]));
  }
}), RC = {
  name: "AppCardSeperator"
}, jC = { class: "relative w-full p-6 [&:not(:last-child)]:pb-0" };
function BC(e, t, n, r, a, i) {
  return C(), T("div", jC, t[0] || (t[0] = [
    S("div", { class: "w-full border-t-DEFAULT border-gray-100" }, null, -1)
  ]));
}
const VC = /* @__PURE__ */ Ct(RC, [["render", BC]]), UC = { class: "w-full" }, HC = {
  key: 0,
  class: "ml-2 text-white"
}, GC = {
  key: 0,
  class: "ml-2 text-blue-300"
}, qC = { key: 0 }, WC = { key: 1 }, YC = {
  name: "AppProgressBar"
}, KC = /* @__PURE__ */ re({
  ...YC,
  props: {
    value: {},
    minLabel: { default: "" },
    maxLabel: { default: "" },
    theme: { default: "default" }
  },
  setup(e) {
    const t = e, n = P(() => t.theme === "sharp" || t.theme === "sharp-thin");
    return (r, a) => (C(), T("div", UC, [
      S("div", {
        class: z(["relative w-full overflow-hidden", {
          "h-3 rounded-full bg-blue-50": r.theme === "default",
          "flex h-8 items-center rounded-md border border-blue-300 p-1": r.theme === "sharp",
          "flex h-4 items-center rounded-full border border-blue-300 p-1": r.theme === "sharp-thin"
        }])
      }, [
        S("div", {
          "data-test-id": "progress-bar__bar",
          class: z({
            "gradient-mask h-full rounded-full before:absolute before:inset-0 before:bg-gradient-to-r before:from-blue-700 before:to-green-700 before:content-['']": r.theme === "default",
            "h-full rounded-md text-end": r.theme === "default",
            "h-full bg-blue-300": n.value && r.value < 100,
            "h-full bg-green-700": n.value && r.value === 100,
            "rounded-md": r.theme === "sharp",
            "rounded-full": r.theme === "sharp-thin"
          }),
          style: en({ width: `${t.value}%` })
        }, [
          r.theme === "sharp" && r.value > 10 ? (C(), T("p", HC, H(r.value) + "%", 1)) : K("", !0)
        ], 6),
        r.theme === "sharp" && r.value <= 10 ? (C(), T("p", GC, H(r.value) + "%", 1)) : K("", !0)
      ], 2),
      S("div", {
        class: z(["mt-1 flex w-full justify-between leading-[20px]", {
          "text-gray-900": r.theme === "default",
          "text-blue-500": n.value
        }])
      }, [
        t.minLabel ? (C(), T("span", qC, H(t.minLabel), 1)) : K("", !0),
        t.maxLabel ? (C(), T("span", WC, H(t.maxLabel), 1)) : K("", !0)
      ], 2)
    ]));
  }
}), ZC = /* @__PURE__ */ Ct(KC, [["__scopeId", "data-v-70ab16fd"]]), XC = { class: "mb-4 w-full" }, JC = ["for"], QC = { class: "relative inline-block w-full" }, eA = ["id", "name", "placeholder", "rows", "disabled"], tA = {
  key: 0,
  class: "text-sm text-orange-900"
}, nA = {
  name: "AppTextAreaInput"
}, rA = /* @__PURE__ */ re({
  ...nA,
  props: {
    label: {},
    name: {},
    placeholder: { default: "" },
    modelValue: {},
    rows: { default: 6 },
    isValidatingOnMount: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "blur"],
  setup(e, { emit: t }) {
    const n = e, r = t, {
      errorMessage: a,
      value: i,
      meta: s,
      setValue: o
    } = Tt(n.name, void 0, {
      initialValue: n.modelValue,
      validateOnMount: n.isValidatingOnMount
    }), l = (u) => {
      const c = u.target, d = c == null ? void 0 : c.value;
      r("update:modelValue", d), o(d);
    };
    return De(
      () => n.modelValue,
      (u) => {
        o(u);
      }
    ), (u, c) => (C(), T("div", XC, [
      S("label", {
        class: "mb-0.5 inline-block",
        for: x(Te)(u.name)
      }, H(u.label), 9, JC),
      Ce(u.$slots, "default"),
      S("div", QC, [
        ct(S("textarea", {
          id: x(Te)(u.name),
          "onUpdate:modelValue": c[0] || (c[0] = (d) => Ht(i) ? i.value = d : null),
          type: "text",
          name: u.name,
          placeholder: u.placeholder,
          rows: u.rows,
          disabled: u.disabled,
          class: z([{
            "!bg-orange-100 !border-orange-900 !text-orange-900 focus:!shadow-activeError": x(a) && !u.disabled,
            "!border-green-700 focus:!shadow-activeSuccess": x(s).dirty && x(s).valid && !u.disabled
          }, "block w-full rounded-lg border border-blue-300 p-2 pr-10 transition-all duration-300 focus:shadow-active disabled:border-gray-100 disabled:bg-gray-100 disabled:text-gray-700"]),
          "data-test-id": "text-area-input",
          onInput: l,
          onBlur: c[1] || (c[1] = (d) => r("blur", x(i)))
        }, null, 42, eA), [
          [er, x(i)]
        ])
      ]),
      x(a) ? (C(), T("span", tA, H(x(a)), 1)) : K("", !0)
    ]));
  }
}), $u = {
  component: null,
  props: {},
  events: {},
  title: "",
  subtitle: "",
  isCloseable: !0,
  isClosingOnOutside: !0
}, yu = Fn({
  modal: $u
}), lt = P(() => yu.modal), lY = (e) => {
  const t = document.body;
  t && (t.style.overflow = "hidden");
  const n = { ...$u, ...e };
  n.component = t8(n.component), yu.modal = n;
}, aA = () => {
  yu.modal = $u;
  const e = document.body;
  e && (e.style.overflow = "auto");
}, iA = { class: "w-full h-min grid grid-cols-12 gap-x-2 empty:hidden" }, sA = {
  key: 0,
  "data-test-id": "modal-title",
  class: "text-h3 col-span-11"
}, oA = { class: "flex flex-col flex-1 basis-full gap-6 overflow-y-auto hide-scroll" }, lA = {
  key: 0,
  "data-test-id": "modal-subtitle",
  class: "text-body"
}, uA = {
  name: "AppModal"
}, cA = /* @__PURE__ */ re({
  ...uA,
  emits: ["closeModal"],
  setup(e, { emit: t }) {
    const n = t, r = (s) => {
      aA(), s != null && s.closeModal && s.closeModal(), n("closeModal");
    }, a = () => {
      lt.value.isClosingOnOutside && lt.value.isCloseable && r(lt.value.events);
    }, i = (s) => {
      s.code === "Escape" && lt.value.isCloseable && r(lt.value.events);
    };
    return Ue(() => {
      document.addEventListener("keydown", i);
    }), Ti(() => {
      document.removeEventListener("keydown", i);
    }), (s, o) => (C(), ve(vr, null, {
      default: fe(() => [
        x(lt).component ? (C(), T("div", {
          key: 0,
          "data-test-id": "modal-overlay",
          class: "overlay fixed top-0 left-0 z-50 h-screen w-screen grid place-items-center",
          "aria-modal": "true",
          role: "dialog",
          tabindex: "-1",
          onClick: Se(a, ["self"])
        }, [
          S("div", {
            class: z([x(lt).props.maxWidth === "md" ? "max-w-md" : "lg:w-[31.25rem]", "bg-white p-6 rounded-3xl shadow-light w-screen max-h-screen flex flex-col gap-6 relative lg:p-8"])
          }, [
            S("div", iA, [
              x(lt).title ? (C(), T("p", sA, H(x(lt).title), 1)) : K("", !0),
              x(lt).isCloseable ? (C(), ve(x(te), {
                key: 1,
                "data-test-id": "modal-close-button",
                icon: "close",
                class: "col-span-1 text-2xl cursor-pointer col-start-12 justify-self-end",
                onClick: o[0] || (o[0] = (l) => r(x(lt).events))
              })) : K("", !0)
            ]),
            S("div", oA, [
              x(lt).subtitle ? (C(), T("p", lA, H(x(lt).subtitle), 1)) : K("", !0),
              (C(), ve(rf(x(lt).component), zn({ "data-test-id": "modal-component" }, x(lt).props, n8(x(lt).events), { onCloseModal: r }), null, 16))
            ])
          ], 2)
        ])) : K("", !0)
      ]),
      _: 1
    }));
  }
}), dA = /* @__PURE__ */ Ct(cA, [["__scopeId", "data-v-63c365b5"]]), fA = {
  name: "AppTooltips"
}, pA = /* @__PURE__ */ re({
  ...fA,
  setup(e) {
    const t = C_();
    return (n, r) => (C(!0), T(Oe, null, Fe(x(t).values(), (a) => (C(), ve(D3, {
      key: a.id,
      content: a.options.content,
      "element-height": a.options.elementHeight ?? 0,
      "element-left": a.options.left ?? 0,
      "element-top": a.options.top ?? 0,
      "element-width": a.options.elementWidth ?? 0
    }, null, 8, ["content", "element-height", "element-left", "element-top", "element-width"]))), 128));
  }
}), hA = /* @__PURE__ */ re({
  __name: "AppPill",
  props: {
    theme: { default: "primary" }
  },
  setup(e) {
    return (t, n) => (C(), T("p", {
      class: z(["inline-block rounded-full px-4 py-2 text-center text-sm lg:text-base", {
        "bg-green-100 text-green-900": t.theme === "primary",
        "bg-blue-200 text-blue-700": t.theme === "secondary",
        "bg-orange-100 text-orange-1000": t.theme === "warning",
        "bg-red-100 text-red-900": t.theme === "error"
      }])
    }, [
      Ce(t.$slots, "default")
    ], 2));
  }
}), mA = { class: "relative mb-4 h-11 w-full rounded-lg bg-gradient-to-l from-blue-50 to-blue-50" }, vA = { class: "absolute flex size-full items-center justify-end p-3" }, gA = {
  name: "AppLtvBar"
}, bA = /* @__PURE__ */ re({
  ...gA,
  props: {
    percentage: {}
  },
  setup(e) {
    const t = e, n = N(), r = N(0), a = (i, s, o) => {
      let l = 0;
      const u = Math.random() * 2e3 + 500, c = (d) => {
        l === 0 && (l = d);
        const f = Math.min((d - l) / u, 1), p = Math.floor(f * (o - s) + s);
        i.innerHTML = `${p}%`, r.value = p, f < 1 && window.requestAnimationFrame(c);
      };
      window.requestAnimationFrame(c);
    };
    return Ue(() => {
      a(n.value, 0, t.percentage);
    }), (i, s) => (C(), T("div", mA, [
      S("div", vA, [
        U(x(te), {
          icon: ["fad", "house"],
          size: "1x"
        })
      ]),
      S("div", {
        class: "absolute z-10 flex h-full items-center justify-between rounded-lg bg-gradient-to-l from-blue-300 to-[#8EC9EE] px-3 font-medium",
        style: en(`min-width: ${r.value}%;`)
      }, [
        U(x(te), {
          icon: ["fad", "coins"],
          size: "1x",
          class: "mr-2"
        }),
        S("div", null, [
          s[0] || (s[0] = rt(" LTV ")),
          S("span", {
            ref_key: "progressBar",
            ref: n,
            class: "text-xl font-semibold text-blue-900"
          }, H(t.percentage) + "%", 513)
        ])
      ], 4)
    ]));
  }
}), $A = { class: "flex items-center justify-between gap-x-4" }, yA = { class: "w-14 text-center text-xl font-semibold text-blue-900" }, xA = {
  name: "AppNumberInput"
}, _A = /* @__PURE__ */ re({
  ...xA,
  props: {
    modelValue: {},
    fetching: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = P(() => {
      var s;
      return (s = n.modelValue) == null ? void 0 : s.toLocaleString("nl-NL");
    }), i = (s) => {
      r("update:modelValue", n.modelValue + s);
    };
    return (s, o) => (C(), T("div", $A, [
      U(yt, {
        fetching: s.fetching,
        text: ""
      }, {
        default: fe(() => o[2] || (o[2] = [
          S("div", null, " Rente ", -1)
        ])),
        _: 1,
        __: [2]
      }, 8, ["fetching"]),
      U(yt, { fetching: s.fetching }, {
        default: fe(() => [
          S("div", {
            class: "flex size-11 cursor-pointer select-none items-center justify-center rounded-lg bg-blue-200 text-2xl text-blue-900 transition-all duration-150 ease-in-out hover:bg-blue-300 active:bg-blue-200",
            onClick: o[0] || (o[0] = (l) => i(-0.25))
          }, " - ")
        ]),
        _: 1
      }, 8, ["fetching"]),
      U(yt, {
        fetching: s.fetching,
        text: ""
      }, {
        default: fe(() => [
          S("div", yA, H(a.value) + "% ", 1)
        ]),
        _: 1
      }, 8, ["fetching"]),
      U(yt, { fetching: s.fetching }, {
        default: fe(() => [
          S("div", {
            class: "flex size-11 cursor-pointer select-none items-center justify-center rounded-lg bg-blue-200 text-2xl text-blue-900 transition-all duration-150 ease-in-out hover:bg-blue-300 active:bg-blue-200",
            onClick: o[1] || (o[1] = (l) => i(0.25))
          }, " + ")
        ]),
        _: 1
      }, 8, ["fetching"])
    ]));
  }
}), wA = {
  name: "AppHamburger"
}, SA = /* @__PURE__ */ re({
  ...wA,
  props: {
    isActive: { type: Boolean, default: !1 },
    size: { default: "small" }
  },
  setup(e) {
    return (t, n) => (C(), T("div", {
      class: z(["relative z-20 flex w-6 cursor-pointer flex-col items-center justify-between", t.isActive ? "h-6" : "h-5"])
    }, [
      S("div", {
        "data-test-id": "rotate",
        class: z(["h-1 w-full rounded-full bg-blue-700 transition-all duration-300 ease-in-out shrink-0", {
          "rotate-45 !bg-white mt-2": t.isActive,
          "h-[3px]": t.size === "small"
        }])
      }, null, 2),
      S("div", {
        class: z(["w-full rounded-full bg-[#9CBAD8] transition-all duration-300 ease-in-out shrink-0", {
          "-rotate-45 !bg-white mt-[-3px]": t.isActive,
          "h-[3px] bottom-2": t.size === "small"
        }])
      }, null, 2),
      S("div", {
        class: z(["h-[3px] w-full rounded-full bg-blue-700 transition-all duration-300 ease-in-out", {
          "!w-0 mb-5 !bg-white opacity-0": t.isActive,
          "h-[3px]": t.size === "small",
          "!mb-3": t.size === "small" && t.isActive
        }])
      }, null, 2)
    ], 2));
  }
});
function t4() {
  return {
    async: !1,
    baseUrl: null,
    breaks: !1,
    extensions: null,
    gfm: !0,
    headerIds: !0,
    headerPrefix: "",
    highlight: null,
    hooks: null,
    langPrefix: "language-",
    mangle: !0,
    pedantic: !1,
    renderer: null,
    sanitize: !1,
    sanitizer: null,
    silent: !1,
    smartypants: !1,
    tokenizer: null,
    walkTokens: null,
    xhtml: !1
  };
}
let tr = t4();
function CA(e) {
  tr = e;
}
const n4 = /[&<>"']/, AA = new RegExp(n4.source, "g"), r4 = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/, EA = new RegExp(r4.source, "g"), OA = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
}, i0 = (e) => OA[e];
function ut(e, t) {
  if (t) {
    if (n4.test(e))
      return e.replace(AA, i0);
  } else if (r4.test(e))
    return e.replace(EA, i0);
  return e;
}
const TA = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;
function a4(e) {
  return e.replace(TA, (t, n) => (n = n.toLowerCase(), n === "colon" ? ":" : n.charAt(0) === "#" ? n.charAt(1) === "x" ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1)) : ""));
}
const MA = /(^|[^\[])\^/g;
function ze(e, t) {
  e = typeof e == "string" ? e : e.source, t = t || "";
  const n = {
    replace: (r, a) => (a = a.source || a, a = a.replace(MA, "$1"), e = e.replace(r, a), n),
    getRegex: () => new RegExp(e, t)
  };
  return n;
}
const kA = /[^\w:]/g, LA = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;
function s0(e, t, n) {
  if (e) {
    let r;
    try {
      r = decodeURIComponent(a4(n)).replace(kA, "").toLowerCase();
    } catch {
      return null;
    }
    if (r.indexOf("javascript:") === 0 || r.indexOf("vbscript:") === 0 || r.indexOf("data:") === 0)
      return null;
  }
  t && !LA.test(n) && (n = IA(t, n));
  try {
    n = encodeURI(n).replace(/%25/g, "%");
  } catch {
    return null;
  }
  return n;
}
const Ta = {}, FA = /^[^:]+:\/*[^/]*$/, zA = /^([^:]+:)[\s\S]*$/, PA = /^([^:]+:\/*[^/]*)[\s\S]*$/;
function IA(e, t) {
  Ta[" " + e] || (FA.test(e) ? Ta[" " + e] = e + "/" : Ta[" " + e] = Ja(e, "/", !0)), e = Ta[" " + e];
  const n = e.indexOf(":") === -1;
  return t.substring(0, 2) === "//" ? n ? t : e.replace(zA, "$1") + t : t.charAt(0) === "/" ? n ? t : e.replace(PA, "$1") + t : e + t;
}
const ci = { exec: function() {
} };
function o0(e, t) {
  const n = e.replace(/\|/g, (i, s, o) => {
    let l = !1, u = s;
    for (; --u >= 0 && o[u] === "\\"; ) l = !l;
    return l ? "|" : " |";
  }), r = n.split(/ \|/);
  let a = 0;
  if (r[0].trim() || r.shift(), r.length > 0 && !r[r.length - 1].trim() && r.pop(), r.length > t)
    r.splice(t);
  else
    for (; r.length < t; ) r.push("");
  for (; a < r.length; a++)
    r[a] = r[a].trim().replace(/\\\|/g, "|");
  return r;
}
function Ja(e, t, n) {
  const r = e.length;
  if (r === 0)
    return "";
  let a = 0;
  for (; a < r; ) {
    const i = e.charAt(r - a - 1);
    if (i === t && !n)
      a++;
    else if (i !== t && n)
      a++;
    else
      break;
  }
  return e.slice(0, r - a);
}
function NA(e, t) {
  if (e.indexOf(t[1]) === -1)
    return -1;
  const n = e.length;
  let r = 0, a = 0;
  for (; a < n; a++)
    if (e[a] === "\\")
      a++;
    else if (e[a] === t[0])
      r++;
    else if (e[a] === t[1] && (r--, r < 0))
      return a;
  return -1;
}
function DA(e) {
  e && e.sanitize && !e.silent && console.warn("marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options");
}
function l0(e, t) {
  if (t < 1)
    return "";
  let n = "";
  for (; t > 1; )
    t & 1 && (n += e), t >>= 1, e += e;
  return n + e;
}
function u0(e, t, n, r) {
  const a = t.href, i = t.title ? ut(t.title) : null, s = e[1].replace(/\\([\[\]])/g, "$1");
  if (e[0].charAt(0) !== "!") {
    r.state.inLink = !0;
    const o = {
      type: "link",
      raw: n,
      href: a,
      title: i,
      text: s,
      tokens: r.inlineTokens(s)
    };
    return r.state.inLink = !1, o;
  }
  return {
    type: "image",
    raw: n,
    href: a,
    title: i,
    text: ut(s)
  };
}
function RA(e, t) {
  const n = e.match(/^(\s+)(?:```)/);
  if (n === null)
    return t;
  const r = n[1];
  return t.split(`
`).map((a) => {
    const i = a.match(/^\s+/);
    if (i === null)
      return a;
    const [s] = i;
    return s.length >= r.length ? a.slice(r.length) : a;
  }).join(`
`);
}
class xu {
  constructor(t) {
    this.options = t || tr;
  }
  space(t) {
    const n = this.rules.block.newline.exec(t);
    if (n && n[0].length > 0)
      return {
        type: "space",
        raw: n[0]
      };
  }
  code(t) {
    const n = this.rules.block.code.exec(t);
    if (n) {
      const r = n[0].replace(/^ {1,4}/gm, "");
      return {
        type: "code",
        raw: n[0],
        codeBlockStyle: "indented",
        text: this.options.pedantic ? r : Ja(r, `
`)
      };
    }
  }
  fences(t) {
    const n = this.rules.block.fences.exec(t);
    if (n) {
      const r = n[0], a = RA(r, n[3] || "");
      return {
        type: "code",
        raw: r,
        lang: n[2] ? n[2].trim().replace(this.rules.inline._escapes, "$1") : n[2],
        text: a
      };
    }
  }
  heading(t) {
    const n = this.rules.block.heading.exec(t);
    if (n) {
      let r = n[2].trim();
      if (/#$/.test(r)) {
        const a = Ja(r, "#");
        (this.options.pedantic || !a || / $/.test(a)) && (r = a.trim());
      }
      return {
        type: "heading",
        raw: n[0],
        depth: n[1].length,
        text: r,
        tokens: this.lexer.inline(r)
      };
    }
  }
  hr(t) {
    const n = this.rules.block.hr.exec(t);
    if (n)
      return {
        type: "hr",
        raw: n[0]
      };
  }
  blockquote(t) {
    const n = this.rules.block.blockquote.exec(t);
    if (n) {
      const r = n[0].replace(/^ *>[ \t]?/gm, ""), a = this.lexer.state.top;
      this.lexer.state.top = !0;
      const i = this.lexer.blockTokens(r);
      return this.lexer.state.top = a, {
        type: "blockquote",
        raw: n[0],
        tokens: i,
        text: r
      };
    }
  }
  list(t) {
    let n = this.rules.block.list.exec(t);
    if (n) {
      let r, a, i, s, o, l, u, c, d, f, p, h, m = n[1].trim();
      const v = m.length > 1, g = {
        type: "list",
        raw: "",
        ordered: v,
        start: v ? +m.slice(0, -1) : "",
        loose: !1,
        items: []
      };
      m = v ? `\\d{1,9}\\${m.slice(-1)}` : `\\${m}`, this.options.pedantic && (m = v ? m : "[*+-]");
      const b = new RegExp(`^( {0,3}${m})((?:[	 ][^\\n]*)?(?:\\n|$))`);
      for (; t && (h = !1, !(!(n = b.exec(t)) || this.rules.block.hr.test(t))); ) {
        if (r = n[0], t = t.substring(r.length), c = n[2].split(`
`, 1)[0].replace(/^\t+/, (y) => " ".repeat(3 * y.length)), d = t.split(`
`, 1)[0], this.options.pedantic ? (s = 2, p = c.trimLeft()) : (s = n[2].search(/[^ ]/), s = s > 4 ? 1 : s, p = c.slice(s), s += n[1].length), l = !1, !c && /^ *$/.test(d) && (r += d + `
`, t = t.substring(d.length + 1), h = !0), !h) {
          const y = new RegExp(`^ {0,${Math.min(3, s - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`), A = new RegExp(`^ {0,${Math.min(3, s - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`), E = new RegExp(`^ {0,${Math.min(3, s - 1)}}(?:\`\`\`|~~~)`), L = new RegExp(`^ {0,${Math.min(3, s - 1)}}#`);
          for (; t && (f = t.split(`
`, 1)[0], d = f, this.options.pedantic && (d = d.replace(/^ {1,4}(?=( {4})*[^ ])/g, "  ")), !(E.test(d) || L.test(d) || y.test(d) || A.test(t))); ) {
            if (d.search(/[^ ]/) >= s || !d.trim())
              p += `
` + d.slice(s);
            else {
              if (l || c.search(/[^ ]/) >= 4 || E.test(c) || L.test(c) || A.test(c))
                break;
              p += `
` + d;
            }
            !l && !d.trim() && (l = !0), r += f + `
`, t = t.substring(f.length + 1), c = d.slice(s);
          }
        }
        g.loose || (u ? g.loose = !0 : /\n *\n *$/.test(r) && (u = !0)), this.options.gfm && (a = /^\[[ xX]\] /.exec(p), a && (i = a[0] !== "[ ] ", p = p.replace(/^\[[ xX]\] +/, ""))), g.items.push({
          type: "list_item",
          raw: r,
          task: !!a,
          checked: i,
          loose: !1,
          text: p
        }), g.raw += r;
      }
      g.items[g.items.length - 1].raw = r.trimRight(), g.items[g.items.length - 1].text = p.trimRight(), g.raw = g.raw.trimRight();
      const $ = g.items.length;
      for (o = 0; o < $; o++)
        if (this.lexer.state.top = !1, g.items[o].tokens = this.lexer.blockTokens(g.items[o].text, []), !g.loose) {
          const y = g.items[o].tokens.filter((E) => E.type === "space"), A = y.length > 0 && y.some((E) => /\n.*\n/.test(E.raw));
          g.loose = A;
        }
      if (g.loose)
        for (o = 0; o < $; o++)
          g.items[o].loose = !0;
      return g;
    }
  }
  html(t) {
    const n = this.rules.block.html.exec(t);
    if (n) {
      const r = {
        type: "html",
        raw: n[0],
        pre: !this.options.sanitizer && (n[1] === "pre" || n[1] === "script" || n[1] === "style"),
        text: n[0]
      };
      if (this.options.sanitize) {
        const a = this.options.sanitizer ? this.options.sanitizer(n[0]) : ut(n[0]);
        r.type = "paragraph", r.text = a, r.tokens = this.lexer.inline(a);
      }
      return r;
    }
  }
  def(t) {
    const n = this.rules.block.def.exec(t);
    if (n) {
      const r = n[1].toLowerCase().replace(/\s+/g, " "), a = n[2] ? n[2].replace(/^<(.*)>$/, "$1").replace(this.rules.inline._escapes, "$1") : "", i = n[3] ? n[3].substring(1, n[3].length - 1).replace(this.rules.inline._escapes, "$1") : n[3];
      return {
        type: "def",
        tag: r,
        raw: n[0],
        href: a,
        title: i
      };
    }
  }
  table(t) {
    const n = this.rules.block.table.exec(t);
    if (n) {
      const r = {
        type: "table",
        header: o0(n[1]).map((a) => ({ text: a })),
        align: n[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
        rows: n[3] && n[3].trim() ? n[3].replace(/\n[ \t]*$/, "").split(`
`) : []
      };
      if (r.header.length === r.align.length) {
        r.raw = n[0];
        let a = r.align.length, i, s, o, l;
        for (i = 0; i < a; i++)
          /^ *-+: *$/.test(r.align[i]) ? r.align[i] = "right" : /^ *:-+: *$/.test(r.align[i]) ? r.align[i] = "center" : /^ *:-+ *$/.test(r.align[i]) ? r.align[i] = "left" : r.align[i] = null;
        for (a = r.rows.length, i = 0; i < a; i++)
          r.rows[i] = o0(r.rows[i], r.header.length).map((u) => ({ text: u }));
        for (a = r.header.length, s = 0; s < a; s++)
          r.header[s].tokens = this.lexer.inline(r.header[s].text);
        for (a = r.rows.length, s = 0; s < a; s++)
          for (l = r.rows[s], o = 0; o < l.length; o++)
            l[o].tokens = this.lexer.inline(l[o].text);
        return r;
      }
    }
  }
  lheading(t) {
    const n = this.rules.block.lheading.exec(t);
    if (n)
      return {
        type: "heading",
        raw: n[0],
        depth: n[2].charAt(0) === "=" ? 1 : 2,
        text: n[1],
        tokens: this.lexer.inline(n[1])
      };
  }
  paragraph(t) {
    const n = this.rules.block.paragraph.exec(t);
    if (n) {
      const r = n[1].charAt(n[1].length - 1) === `
` ? n[1].slice(0, -1) : n[1];
      return {
        type: "paragraph",
        raw: n[0],
        text: r,
        tokens: this.lexer.inline(r)
      };
    }
  }
  text(t) {
    const n = this.rules.block.text.exec(t);
    if (n)
      return {
        type: "text",
        raw: n[0],
        text: n[0],
        tokens: this.lexer.inline(n[0])
      };
  }
  escape(t) {
    const n = this.rules.inline.escape.exec(t);
    if (n)
      return {
        type: "escape",
        raw: n[0],
        text: ut(n[1])
      };
  }
  tag(t) {
    const n = this.rules.inline.tag.exec(t);
    if (n)
      return !this.lexer.state.inLink && /^<a /i.test(n[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && /^<\/a>/i.test(n[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(n[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(n[0]) && (this.lexer.state.inRawBlock = !1), {
        type: this.options.sanitize ? "text" : "html",
        raw: n[0],
        inLink: this.lexer.state.inLink,
        inRawBlock: this.lexer.state.inRawBlock,
        text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(n[0]) : ut(n[0]) : n[0]
      };
  }
  link(t) {
    const n = this.rules.inline.link.exec(t);
    if (n) {
      const r = n[2].trim();
      if (!this.options.pedantic && /^</.test(r)) {
        if (!/>$/.test(r))
          return;
        const s = Ja(r.slice(0, -1), "\\");
        if ((r.length - s.length) % 2 === 0)
          return;
      } else {
        const s = NA(n[2], "()");
        if (s > -1) {
          const l = (n[0].indexOf("!") === 0 ? 5 : 4) + n[1].length + s;
          n[2] = n[2].substring(0, s), n[0] = n[0].substring(0, l).trim(), n[3] = "";
        }
      }
      let a = n[2], i = "";
      if (this.options.pedantic) {
        const s = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(a);
        s && (a = s[1], i = s[3]);
      } else
        i = n[3] ? n[3].slice(1, -1) : "";
      return a = a.trim(), /^</.test(a) && (this.options.pedantic && !/>$/.test(r) ? a = a.slice(1) : a = a.slice(1, -1)), u0(n, {
        href: a && a.replace(this.rules.inline._escapes, "$1"),
        title: i && i.replace(this.rules.inline._escapes, "$1")
      }, n[0], this.lexer);
    }
  }
  reflink(t, n) {
    let r;
    if ((r = this.rules.inline.reflink.exec(t)) || (r = this.rules.inline.nolink.exec(t))) {
      let a = (r[2] || r[1]).replace(/\s+/g, " ");
      if (a = n[a.toLowerCase()], !a) {
        const i = r[0].charAt(0);
        return {
          type: "text",
          raw: i,
          text: i
        };
      }
      return u0(r, a, r[0], this.lexer);
    }
  }
  emStrong(t, n, r = "") {
    let a = this.rules.inline.emStrong.lDelim.exec(t);
    if (!a || a[3] && r.match(/[\p{L}\p{N}]/u)) return;
    const i = a[1] || a[2] || "";
    if (!i || i && (r === "" || this.rules.inline.punctuation.exec(r))) {
      const s = a[0].length - 1;
      let o, l, u = s, c = 0;
      const d = a[0][0] === "*" ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
      for (d.lastIndex = 0, n = n.slice(-1 * t.length + s); (a = d.exec(n)) != null; ) {
        if (o = a[1] || a[2] || a[3] || a[4] || a[5] || a[6], !o) continue;
        if (l = o.length, a[3] || a[4]) {
          u += l;
          continue;
        } else if ((a[5] || a[6]) && s % 3 && !((s + l) % 3)) {
          c += l;
          continue;
        }
        if (u -= l, u > 0) continue;
        l = Math.min(l, l + u + c);
        const f = t.slice(0, s + a.index + (a[0].length - o.length) + l);
        if (Math.min(s, l) % 2) {
          const h = f.slice(1, -1);
          return {
            type: "em",
            raw: f,
            text: h,
            tokens: this.lexer.inlineTokens(h)
          };
        }
        const p = f.slice(2, -2);
        return {
          type: "strong",
          raw: f,
          text: p,
          tokens: this.lexer.inlineTokens(p)
        };
      }
    }
  }
  codespan(t) {
    const n = this.rules.inline.code.exec(t);
    if (n) {
      let r = n[2].replace(/\n/g, " ");
      const a = /[^ ]/.test(r), i = /^ /.test(r) && / $/.test(r);
      return a && i && (r = r.substring(1, r.length - 1)), r = ut(r, !0), {
        type: "codespan",
        raw: n[0],
        text: r
      };
    }
  }
  br(t) {
    const n = this.rules.inline.br.exec(t);
    if (n)
      return {
        type: "br",
        raw: n[0]
      };
  }
  del(t) {
    const n = this.rules.inline.del.exec(t);
    if (n)
      return {
        type: "del",
        raw: n[0],
        text: n[2],
        tokens: this.lexer.inlineTokens(n[2])
      };
  }
  autolink(t, n) {
    const r = this.rules.inline.autolink.exec(t);
    if (r) {
      let a, i;
      return r[2] === "@" ? (a = ut(this.options.mangle ? n(r[1]) : r[1]), i = "mailto:" + a) : (a = ut(r[1]), i = a), {
        type: "link",
        raw: r[0],
        text: a,
        href: i,
        tokens: [
          {
            type: "text",
            raw: a,
            text: a
          }
        ]
      };
    }
  }
  url(t, n) {
    let r;
    if (r = this.rules.inline.url.exec(t)) {
      let a, i;
      if (r[2] === "@")
        a = ut(this.options.mangle ? n(r[0]) : r[0]), i = "mailto:" + a;
      else {
        let s;
        do
          s = r[0], r[0] = this.rules.inline._backpedal.exec(r[0])[0];
        while (s !== r[0]);
        a = ut(r[0]), r[1] === "www." ? i = "http://" + r[0] : i = r[0];
      }
      return {
        type: "link",
        raw: r[0],
        text: a,
        href: i,
        tokens: [
          {
            type: "text",
            raw: a,
            text: a
          }
        ]
      };
    }
  }
  inlineText(t, n) {
    const r = this.rules.inline.text.exec(t);
    if (r) {
      let a;
      return this.lexer.state.inRawBlock ? a = this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(r[0]) : ut(r[0]) : r[0] : a = ut(this.options.smartypants ? n(r[0]) : r[0]), {
        type: "text",
        raw: r[0],
        text: a
      };
    }
  }
}
const de = {
  newline: /^(?: *(?:\n|$))+/,
  code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
  fences: /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
  hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/,
  heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
  blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
  list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/,
  html: "^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))",
  def: /^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
  table: ci,
  lheading: /^((?:.|\n(?!\n))+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
  // regex template, placeholders will be replaced according to different paragraph
  // interruption rules of commonmark and the original markdown spec:
  _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
  text: /^[^\n]+/
};
de._label = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
de._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
de.def = ze(de.def).replace("label", de._label).replace("title", de._title).getRegex();
de.bullet = /(?:[*+-]|\d{1,9}[.)])/;
de.listItemStart = ze(/^( *)(bull) */).replace("bull", de.bullet).getRegex();
de.list = ze(de.list).replace(/bull/g, de.bullet).replace("hr", "\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))").replace("def", "\\n+(?=" + de.def.source + ")").getRegex();
de._tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
de._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
de.html = ze(de.html, "i").replace("comment", de._comment).replace("tag", de._tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
de.paragraph = ze(de._paragraph).replace("hr", de.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", de._tag).getRegex();
de.blockquote = ze(de.blockquote).replace("paragraph", de.paragraph).getRegex();
de.normal = { ...de };
de.gfm = {
  ...de.normal,
  table: "^ *([^\\n ].*\\|.*)\\n {0,3}(?:\\| *)?(:?-+:? *(?:\\| *:?-+:? *)*)(?:\\| *)?(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)"
  // Cells
};
de.gfm.table = ze(de.gfm.table).replace("hr", de.hr).replace("heading", " {0,3}#{1,6} ").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", de._tag).getRegex();
de.gfm.paragraph = ze(de._paragraph).replace("hr", de.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "").replace("table", de.gfm.table).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", de._tag).getRegex();
de.pedantic = {
  ...de.normal,
  html: ze(
    `^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`
  ).replace("comment", de._comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
  def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
  heading: /^(#{1,6})(.*)(?:\n+|$)/,
  fences: ci,
  // fences not supported
  lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
  paragraph: ze(de.normal._paragraph).replace("hr", de.hr).replace("heading", ` *#{1,6} *[^
]`).replace("lheading", de.lheading).replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").getRegex()
};
const oe = {
  escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
  autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
  url: ci,
  tag: "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>",
  // CDATA section
  link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
  reflink: /^!?\[(label)\]\[(ref)\]/,
  nolink: /^!?\[(ref)\](?:\[\])?/,
  reflinkSearch: "reflink|nolink(?!\\()",
  emStrong: {
    lDelim: /^(?:\*+(?:([punct_])|[^\s*]))|^_+(?:([punct*])|([^\s_]))/,
    //        (1) and (2) can only be a Right Delimiter. (3) and (4) can only be Left.  (5) and (6) can be either Left or Right.
    //          () Skip orphan inside strong                                      () Consume to delim     (1) #***                (2) a***#, a***                             (3) #***a, ***a                 (4) ***#              (5) #***#                 (6) a***a
    rDelimAst: /^(?:[^_*\\]|\\.)*?\_\_(?:[^_*\\]|\\.)*?\*(?:[^_*\\]|\\.)*?(?=\_\_)|(?:[^*\\]|\\.)+(?=[^*])|[punct_](\*+)(?=[\s]|$)|(?:[^punct*_\s\\]|\\.)(\*+)(?=[punct_\s]|$)|[punct_\s](\*+)(?=[^punct*_\s])|[\s](\*+)(?=[punct_])|[punct_](\*+)(?=[punct_])|(?:[^punct*_\s\\]|\\.)(\*+)(?=[^punct*_\s])/,
    rDelimUnd: /^(?:[^_*\\]|\\.)*?\*\*(?:[^_*\\]|\\.)*?\_(?:[^_*\\]|\\.)*?(?=\*\*)|(?:[^_\\]|\\.)+(?=[^_])|[punct*](\_+)(?=[\s]|$)|(?:[^punct*_\s\\]|\\.)(\_+)(?=[punct*\s]|$)|[punct*\s](\_+)(?=[^punct*_\s])|[\s](\_+)(?=[punct*])|[punct*](\_+)(?=[punct*])/
    // ^- Not allowed for _
  },
  code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
  br: /^( {2,}|\\)\n(?!\s*$)/,
  del: ci,
  text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
  punctuation: /^([\spunctuation])/
};
oe._punctuation = "!\"#$%&'()+\\-.,/:;<=>?@\\[\\]`^{|}~";
oe.punctuation = ze(oe.punctuation).replace(/punctuation/g, oe._punctuation).getRegex();
oe.blockSkip = /\[[^\]]*?\]\([^\)]*?\)|`[^`]*?`|<[^>]*?>/g;
oe.escapedEmSt = /(?:^|[^\\])(?:\\\\)*\\[*_]/g;
oe._comment = ze(de._comment).replace("(?:-->|$)", "-->").getRegex();
oe.emStrong.lDelim = ze(oe.emStrong.lDelim).replace(/punct/g, oe._punctuation).getRegex();
oe.emStrong.rDelimAst = ze(oe.emStrong.rDelimAst, "g").replace(/punct/g, oe._punctuation).getRegex();
oe.emStrong.rDelimUnd = ze(oe.emStrong.rDelimUnd, "g").replace(/punct/g, oe._punctuation).getRegex();
oe._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g;
oe._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
oe._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
oe.autolink = ze(oe.autolink).replace("scheme", oe._scheme).replace("email", oe._email).getRegex();
oe._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;
oe.tag = ze(oe.tag).replace("comment", oe._comment).replace("attribute", oe._attribute).getRegex();
oe._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
oe._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/;
oe._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;
oe.link = ze(oe.link).replace("label", oe._label).replace("href", oe._href).replace("title", oe._title).getRegex();
oe.reflink = ze(oe.reflink).replace("label", oe._label).replace("ref", de._label).getRegex();
oe.nolink = ze(oe.nolink).replace("ref", de._label).getRegex();
oe.reflinkSearch = ze(oe.reflinkSearch, "g").replace("reflink", oe.reflink).replace("nolink", oe.nolink).getRegex();
oe.normal = { ...oe };
oe.pedantic = {
  ...oe.normal,
  strong: {
    start: /^__|\*\*/,
    middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
    endAst: /\*\*(?!\*)/g,
    endUnd: /__(?!_)/g
  },
  em: {
    start: /^_|\*/,
    middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
    endAst: /\*(?!\*)/g,
    endUnd: /_(?!_)/g
  },
  link: ze(/^!?\[(label)\]\((.*?)\)/).replace("label", oe._label).getRegex(),
  reflink: ze(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", oe._label).getRegex()
};
oe.gfm = {
  ...oe.normal,
  escape: ze(oe.escape).replace("])", "~|])").getRegex(),
  _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
  url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
  _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
  del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
  text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
};
oe.gfm.url = ze(oe.gfm.url, "i").replace("email", oe.gfm._extended_email).getRegex();
oe.breaks = {
  ...oe.gfm,
  br: ze(oe.br).replace("{2,}", "*").getRegex(),
  text: ze(oe.gfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
};
function jA(e) {
  return e.replace(/---/g, "—").replace(/--/g, "–").replace(/(^|[-\u2014/(\[{"\s])'/g, "$1‘").replace(/'/g, "’").replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1“").replace(/"/g, "”").replace(/\.{3}/g, "…");
}
function c0(e) {
  let t = "", n, r;
  const a = e.length;
  for (n = 0; n < a; n++)
    r = e.charCodeAt(n), Math.random() > 0.5 && (r = "x" + r.toString(16)), t += "&#" + r + ";";
  return t;
}
class Dn {
  constructor(t) {
    this.tokens = [], this.tokens.links = /* @__PURE__ */ Object.create(null), this.options = t || tr, this.options.tokenizer = this.options.tokenizer || new xu(), this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
      inLink: !1,
      inRawBlock: !1,
      top: !0
    };
    const n = {
      block: de.normal,
      inline: oe.normal
    };
    this.options.pedantic ? (n.block = de.pedantic, n.inline = oe.pedantic) : this.options.gfm && (n.block = de.gfm, this.options.breaks ? n.inline = oe.breaks : n.inline = oe.gfm), this.tokenizer.rules = n;
  }
  /**
   * Expose Rules
   */
  static get rules() {
    return {
      block: de,
      inline: oe
    };
  }
  /**
   * Static Lex Method
   */
  static lex(t, n) {
    return new Dn(n).lex(t);
  }
  /**
   * Static Lex Inline Method
   */
  static lexInline(t, n) {
    return new Dn(n).inlineTokens(t);
  }
  /**
   * Preprocessing
   */
  lex(t) {
    t = t.replace(/\r\n|\r/g, `
`), this.blockTokens(t, this.tokens);
    let n;
    for (; n = this.inlineQueue.shift(); )
      this.inlineTokens(n.src, n.tokens);
    return this.tokens;
  }
  /**
   * Lexing
   */
  blockTokens(t, n = []) {
    this.options.pedantic ? t = t.replace(/\t/g, "    ").replace(/^ +$/gm, "") : t = t.replace(/^( *)(\t+)/gm, (o, l, u) => l + "    ".repeat(u.length));
    let r, a, i, s;
    for (; t; )
      if (!(this.options.extensions && this.options.extensions.block && this.options.extensions.block.some((o) => (r = o.call({ lexer: this }, t, n)) ? (t = t.substring(r.raw.length), n.push(r), !0) : !1))) {
        if (r = this.tokenizer.space(t)) {
          t = t.substring(r.raw.length), r.raw.length === 1 && n.length > 0 ? n[n.length - 1].raw += `
` : n.push(r);
          continue;
        }
        if (r = this.tokenizer.code(t)) {
          t = t.substring(r.raw.length), a = n[n.length - 1], a && (a.type === "paragraph" || a.type === "text") ? (a.raw += `
` + r.raw, a.text += `
` + r.text, this.inlineQueue[this.inlineQueue.length - 1].src = a.text) : n.push(r);
          continue;
        }
        if (r = this.tokenizer.fences(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.heading(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.hr(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.blockquote(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.list(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.html(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.def(t)) {
          t = t.substring(r.raw.length), a = n[n.length - 1], a && (a.type === "paragraph" || a.type === "text") ? (a.raw += `
` + r.raw, a.text += `
` + r.raw, this.inlineQueue[this.inlineQueue.length - 1].src = a.text) : this.tokens.links[r.tag] || (this.tokens.links[r.tag] = {
            href: r.href,
            title: r.title
          });
          continue;
        }
        if (r = this.tokenizer.table(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.lheading(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (i = t, this.options.extensions && this.options.extensions.startBlock) {
          let o = 1 / 0;
          const l = t.slice(1);
          let u;
          this.options.extensions.startBlock.forEach(function(c) {
            u = c.call({ lexer: this }, l), typeof u == "number" && u >= 0 && (o = Math.min(o, u));
          }), o < 1 / 0 && o >= 0 && (i = t.substring(0, o + 1));
        }
        if (this.state.top && (r = this.tokenizer.paragraph(i))) {
          a = n[n.length - 1], s && a.type === "paragraph" ? (a.raw += `
` + r.raw, a.text += `
` + r.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = a.text) : n.push(r), s = i.length !== t.length, t = t.substring(r.raw.length);
          continue;
        }
        if (r = this.tokenizer.text(t)) {
          t = t.substring(r.raw.length), a = n[n.length - 1], a && a.type === "text" ? (a.raw += `
` + r.raw, a.text += `
` + r.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = a.text) : n.push(r);
          continue;
        }
        if (t) {
          const o = "Infinite loop on byte: " + t.charCodeAt(0);
          if (this.options.silent) {
            console.error(o);
            break;
          } else
            throw new Error(o);
        }
      }
    return this.state.top = !0, n;
  }
  inline(t, n = []) {
    return this.inlineQueue.push({ src: t, tokens: n }), n;
  }
  /**
   * Lexing/Compiling
   */
  inlineTokens(t, n = []) {
    let r, a, i, s = t, o, l, u;
    if (this.tokens.links) {
      const c = Object.keys(this.tokens.links);
      if (c.length > 0)
        for (; (o = this.tokenizer.rules.inline.reflinkSearch.exec(s)) != null; )
          c.includes(o[0].slice(o[0].lastIndexOf("[") + 1, -1)) && (s = s.slice(0, o.index) + "[" + l0("a", o[0].length - 2) + "]" + s.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
    }
    for (; (o = this.tokenizer.rules.inline.blockSkip.exec(s)) != null; )
      s = s.slice(0, o.index) + "[" + l0("a", o[0].length - 2) + "]" + s.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
    for (; (o = this.tokenizer.rules.inline.escapedEmSt.exec(s)) != null; )
      s = s.slice(0, o.index + o[0].length - 2) + "++" + s.slice(this.tokenizer.rules.inline.escapedEmSt.lastIndex), this.tokenizer.rules.inline.escapedEmSt.lastIndex--;
    for (; t; )
      if (l || (u = ""), l = !1, !(this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some((c) => (r = c.call({ lexer: this }, t, n)) ? (t = t.substring(r.raw.length), n.push(r), !0) : !1))) {
        if (r = this.tokenizer.escape(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.tag(t)) {
          t = t.substring(r.raw.length), a = n[n.length - 1], a && r.type === "text" && a.type === "text" ? (a.raw += r.raw, a.text += r.text) : n.push(r);
          continue;
        }
        if (r = this.tokenizer.link(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.reflink(t, this.tokens.links)) {
          t = t.substring(r.raw.length), a = n[n.length - 1], a && r.type === "text" && a.type === "text" ? (a.raw += r.raw, a.text += r.text) : n.push(r);
          continue;
        }
        if (r = this.tokenizer.emStrong(t, s, u)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.codespan(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.br(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.del(t)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.autolink(t, c0)) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (!this.state.inLink && (r = this.tokenizer.url(t, c0))) {
          t = t.substring(r.raw.length), n.push(r);
          continue;
        }
        if (i = t, this.options.extensions && this.options.extensions.startInline) {
          let c = 1 / 0;
          const d = t.slice(1);
          let f;
          this.options.extensions.startInline.forEach(function(p) {
            f = p.call({ lexer: this }, d), typeof f == "number" && f >= 0 && (c = Math.min(c, f));
          }), c < 1 / 0 && c >= 0 && (i = t.substring(0, c + 1));
        }
        if (r = this.tokenizer.inlineText(i, jA)) {
          t = t.substring(r.raw.length), r.raw.slice(-1) !== "_" && (u = r.raw.slice(-1)), l = !0, a = n[n.length - 1], a && a.type === "text" ? (a.raw += r.raw, a.text += r.text) : n.push(r);
          continue;
        }
        if (t) {
          const c = "Infinite loop on byte: " + t.charCodeAt(0);
          if (this.options.silent) {
            console.error(c);
            break;
          } else
            throw new Error(c);
        }
      }
    return n;
  }
}
class _u {
  constructor(t) {
    this.options = t || tr;
  }
  code(t, n, r) {
    const a = (n || "").match(/\S*/)[0];
    if (this.options.highlight) {
      const i = this.options.highlight(t, a);
      i != null && i !== t && (r = !0, t = i);
    }
    return t = t.replace(/\n$/, "") + `
`, a ? '<pre><code class="' + this.options.langPrefix + ut(a) + '">' + (r ? t : ut(t, !0)) + `</code></pre>
` : "<pre><code>" + (r ? t : ut(t, !0)) + `</code></pre>
`;
  }
  /**
   * @param {string} quote
   */
  blockquote(t) {
    return `<blockquote>
${t}</blockquote>
`;
  }
  html(t) {
    return t;
  }
  /**
   * @param {string} text
   * @param {string} level
   * @param {string} raw
   * @param {any} slugger
   */
  heading(t, n, r, a) {
    if (this.options.headerIds) {
      const i = this.options.headerPrefix + a.slug(r);
      return `<h${n} id="${i}">${t}</h${n}>
`;
    }
    return `<h${n}>${t}</h${n}>
`;
  }
  hr() {
    return this.options.xhtml ? `<hr/>
` : `<hr>
`;
  }
  list(t, n, r) {
    const a = n ? "ol" : "ul", i = n && r !== 1 ? ' start="' + r + '"' : "";
    return "<" + a + i + `>
` + t + "</" + a + `>
`;
  }
  /**
   * @param {string} text
   */
  listitem(t) {
    return `<li>${t}</li>
`;
  }
  checkbox(t) {
    return "<input " + (t ? 'checked="" ' : "") + 'disabled="" type="checkbox"' + (this.options.xhtml ? " /" : "") + "> ";
  }
  /**
   * @param {string} text
   */
  paragraph(t) {
    return `<p>${t}</p>
`;
  }
  /**
   * @param {string} header
   * @param {string} body
   */
  table(t, n) {
    return n && (n = `<tbody>${n}</tbody>`), `<table>
<thead>
` + t + `</thead>
` + n + `</table>
`;
  }
  /**
   * @param {string} content
   */
  tablerow(t) {
    return `<tr>
${t}</tr>
`;
  }
  tablecell(t, n) {
    const r = n.header ? "th" : "td";
    return (n.align ? `<${r} align="${n.align}">` : `<${r}>`) + t + `</${r}>
`;
  }
  /**
   * span level renderer
   * @param {string} text
   */
  strong(t) {
    return `<strong>${t}</strong>`;
  }
  /**
   * @param {string} text
   */
  em(t) {
    return `<em>${t}</em>`;
  }
  /**
   * @param {string} text
   */
  codespan(t) {
    return `<code>${t}</code>`;
  }
  br() {
    return this.options.xhtml ? "<br/>" : "<br>";
  }
  /**
   * @param {string} text
   */
  del(t) {
    return `<del>${t}</del>`;
  }
  /**
   * @param {string} href
   * @param {string} title
   * @param {string} text
   */
  link(t, n, r) {
    if (t = s0(this.options.sanitize, this.options.baseUrl, t), t === null)
      return r;
    let a = '<a href="' + t + '"';
    return n && (a += ' title="' + n + '"'), a += ">" + r + "</a>", a;
  }
  /**
   * @param {string} href
   * @param {string} title
   * @param {string} text
   */
  image(t, n, r) {
    if (t = s0(this.options.sanitize, this.options.baseUrl, t), t === null)
      return r;
    let a = `<img src="${t}" alt="${r}"`;
    return n && (a += ` title="${n}"`), a += this.options.xhtml ? "/>" : ">", a;
  }
  text(t) {
    return t;
  }
}
class i4 {
  // no need for block level renderers
  strong(t) {
    return t;
  }
  em(t) {
    return t;
  }
  codespan(t) {
    return t;
  }
  del(t) {
    return t;
  }
  html(t) {
    return t;
  }
  text(t) {
    return t;
  }
  link(t, n, r) {
    return "" + r;
  }
  image(t, n, r) {
    return "" + r;
  }
  br() {
    return "";
  }
}
class s4 {
  constructor() {
    this.seen = {};
  }
  /**
   * @param {string} value
   */
  serialize(t) {
    return t.toLowerCase().trim().replace(/<[!\/a-z].*?>/ig, "").replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, "").replace(/\s/g, "-");
  }
  /**
   * Finds the next safe (unique) slug to use
   * @param {string} originalSlug
   * @param {boolean} isDryRun
   */
  getNextSafeSlug(t, n) {
    let r = t, a = 0;
    if (this.seen.hasOwnProperty(r)) {
      a = this.seen[t];
      do
        a++, r = t + "-" + a;
      while (this.seen.hasOwnProperty(r));
    }
    return n || (this.seen[t] = a, this.seen[r] = 0), r;
  }
  /**
   * Convert string to unique id
   * @param {object} [options]
   * @param {boolean} [options.dryrun] Generates the next unique slug without
   * updating the internal accumulator.
   */
  slug(t, n = {}) {
    const r = this.serialize(t);
    return this.getNextSafeSlug(r, n.dryrun);
  }
}
class Rn {
  constructor(t) {
    this.options = t || tr, this.options.renderer = this.options.renderer || new _u(), this.renderer = this.options.renderer, this.renderer.options = this.options, this.textRenderer = new i4(), this.slugger = new s4();
  }
  /**
   * Static Parse Method
   */
  static parse(t, n) {
    return new Rn(n).parse(t);
  }
  /**
   * Static Parse Inline Method
   */
  static parseInline(t, n) {
    return new Rn(n).parseInline(t);
  }
  /**
   * Parse Loop
   */
  parse(t, n = !0) {
    let r = "", a, i, s, o, l, u, c, d, f, p, h, m, v, g, b, $, y, A, E;
    const L = t.length;
    for (a = 0; a < L; a++) {
      if (p = t[a], this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[p.type] && (E = this.options.extensions.renderers[p.type].call({ parser: this }, p), E !== !1 || !["space", "hr", "heading", "code", "table", "blockquote", "list", "html", "paragraph", "text"].includes(p.type))) {
        r += E || "";
        continue;
      }
      switch (p.type) {
        case "space":
          continue;
        case "hr": {
          r += this.renderer.hr();
          continue;
        }
        case "heading": {
          r += this.renderer.heading(
            this.parseInline(p.tokens),
            p.depth,
            a4(this.parseInline(p.tokens, this.textRenderer)),
            this.slugger
          );
          continue;
        }
        case "code": {
          r += this.renderer.code(
            p.text,
            p.lang,
            p.escaped
          );
          continue;
        }
        case "table": {
          for (d = "", c = "", o = p.header.length, i = 0; i < o; i++)
            c += this.renderer.tablecell(
              this.parseInline(p.header[i].tokens),
              { header: !0, align: p.align[i] }
            );
          for (d += this.renderer.tablerow(c), f = "", o = p.rows.length, i = 0; i < o; i++) {
            for (u = p.rows[i], c = "", l = u.length, s = 0; s < l; s++)
              c += this.renderer.tablecell(
                this.parseInline(u[s].tokens),
                { header: !1, align: p.align[s] }
              );
            f += this.renderer.tablerow(c);
          }
          r += this.renderer.table(d, f);
          continue;
        }
        case "blockquote": {
          f = this.parse(p.tokens), r += this.renderer.blockquote(f);
          continue;
        }
        case "list": {
          for (h = p.ordered, m = p.start, v = p.loose, o = p.items.length, f = "", i = 0; i < o; i++)
            b = p.items[i], $ = b.checked, y = b.task, g = "", b.task && (A = this.renderer.checkbox($), v ? b.tokens.length > 0 && b.tokens[0].type === "paragraph" ? (b.tokens[0].text = A + " " + b.tokens[0].text, b.tokens[0].tokens && b.tokens[0].tokens.length > 0 && b.tokens[0].tokens[0].type === "text" && (b.tokens[0].tokens[0].text = A + " " + b.tokens[0].tokens[0].text)) : b.tokens.unshift({
              type: "text",
              text: A
            }) : g += A), g += this.parse(b.tokens, v), f += this.renderer.listitem(g, y, $);
          r += this.renderer.list(f, h, m);
          continue;
        }
        case "html": {
          r += this.renderer.html(p.text);
          continue;
        }
        case "paragraph": {
          r += this.renderer.paragraph(this.parseInline(p.tokens));
          continue;
        }
        case "text": {
          for (f = p.tokens ? this.parseInline(p.tokens) : p.text; a + 1 < L && t[a + 1].type === "text"; )
            p = t[++a], f += `
` + (p.tokens ? this.parseInline(p.tokens) : p.text);
          r += n ? this.renderer.paragraph(f) : f;
          continue;
        }
        default: {
          const D = 'Token with "' + p.type + '" type was not found.';
          if (this.options.silent) {
            console.error(D);
            return;
          } else
            throw new Error(D);
        }
      }
    }
    return r;
  }
  /**
   * Parse Inline Tokens
   */
  parseInline(t, n) {
    n = n || this.renderer;
    let r = "", a, i, s;
    const o = t.length;
    for (a = 0; a < o; a++) {
      if (i = t[a], this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[i.type] && (s = this.options.extensions.renderers[i.type].call({ parser: this }, i), s !== !1 || !["escape", "html", "link", "image", "strong", "em", "codespan", "br", "del", "text"].includes(i.type))) {
        r += s || "";
        continue;
      }
      switch (i.type) {
        case "escape": {
          r += n.text(i.text);
          break;
        }
        case "html": {
          r += n.html(i.text);
          break;
        }
        case "link": {
          r += n.link(i.href, i.title, this.parseInline(i.tokens, n));
          break;
        }
        case "image": {
          r += n.image(i.href, i.title, i.text);
          break;
        }
        case "strong": {
          r += n.strong(this.parseInline(i.tokens, n));
          break;
        }
        case "em": {
          r += n.em(this.parseInline(i.tokens, n));
          break;
        }
        case "codespan": {
          r += n.codespan(i.text);
          break;
        }
        case "br": {
          r += n.br();
          break;
        }
        case "del": {
          r += n.del(this.parseInline(i.tokens, n));
          break;
        }
        case "text": {
          r += n.text(i.text);
          break;
        }
        default: {
          const l = 'Token with "' + i.type + '" type was not found.';
          if (this.options.silent) {
            console.error(l);
            return;
          } else
            throw new Error(l);
        }
      }
    }
    return r;
  }
}
class di {
  constructor(t) {
    this.options = t || tr;
  }
  /**
   * Process markdown before marked
   */
  preprocess(t) {
    return t;
  }
  /**
   * Process HTML after marked is finished
   */
  postprocess(t) {
    return t;
  }
}
t1(di, "passThroughHooks", /* @__PURE__ */ new Set([
  "preprocess",
  "postprocess"
]));
function BA(e, t, n) {
  return (r) => {
    if (r.message += `
Please report this to https://github.com/markedjs/marked.`, e) {
      const a = "<p>An error occurred:</p><pre>" + ut(r.message + "", !0) + "</pre>";
      if (t)
        return Promise.resolve(a);
      if (n) {
        n(null, a);
        return;
      }
      return a;
    }
    if (t)
      return Promise.reject(r);
    if (n) {
      n(r);
      return;
    }
    throw r;
  };
}
function o4(e, t) {
  return (n, r, a) => {
    typeof r == "function" && (a = r, r = null);
    const i = { ...r };
    r = { ...pe.defaults, ...i };
    const s = BA(r.silent, r.async, a);
    if (typeof n > "u" || n === null)
      return s(new Error("marked(): input parameter is undefined or null"));
    if (typeof n != "string")
      return s(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(n) + ", string expected"));
    if (DA(r), r.hooks && (r.hooks.options = r), a) {
      const o = r.highlight;
      let l;
      try {
        r.hooks && (n = r.hooks.preprocess(n)), l = e(n, r);
      } catch (d) {
        return s(d);
      }
      const u = function(d) {
        let f;
        if (!d)
          try {
            r.walkTokens && pe.walkTokens(l, r.walkTokens), f = t(l, r), r.hooks && (f = r.hooks.postprocess(f));
          } catch (p) {
            d = p;
          }
        return r.highlight = o, d ? s(d) : a(null, f);
      };
      if (!o || o.length < 3 || (delete r.highlight, !l.length)) return u();
      let c = 0;
      pe.walkTokens(l, function(d) {
        d.type === "code" && (c++, setTimeout(() => {
          o(d.text, d.lang, function(f, p) {
            if (f)
              return u(f);
            p != null && p !== d.text && (d.text = p, d.escaped = !0), c--, c === 0 && u();
          });
        }, 0));
      }), c === 0 && u();
      return;
    }
    if (r.async)
      return Promise.resolve(r.hooks ? r.hooks.preprocess(n) : n).then((o) => e(o, r)).then((o) => r.walkTokens ? Promise.all(pe.walkTokens(o, r.walkTokens)).then(() => o) : o).then((o) => t(o, r)).then((o) => r.hooks ? r.hooks.postprocess(o) : o).catch(s);
    try {
      r.hooks && (n = r.hooks.preprocess(n));
      const o = e(n, r);
      r.walkTokens && pe.walkTokens(o, r.walkTokens);
      let l = t(o, r);
      return r.hooks && (l = r.hooks.postprocess(l)), l;
    } catch (o) {
      return s(o);
    }
  };
}
function pe(e, t, n) {
  return o4(Dn.lex, Rn.parse)(e, t, n);
}
pe.options = pe.setOptions = function(e) {
  return pe.defaults = { ...pe.defaults, ...e }, CA(pe.defaults), pe;
};
pe.getDefaults = t4;
pe.defaults = tr;
pe.use = function(...e) {
  const t = pe.defaults.extensions || { renderers: {}, childTokens: {} };
  e.forEach((n) => {
    const r = { ...n };
    if (r.async = pe.defaults.async || r.async || !1, n.extensions && (n.extensions.forEach((a) => {
      if (!a.name)
        throw new Error("extension name required");
      if (a.renderer) {
        const i = t.renderers[a.name];
        i ? t.renderers[a.name] = function(...s) {
          let o = a.renderer.apply(this, s);
          return o === !1 && (o = i.apply(this, s)), o;
        } : t.renderers[a.name] = a.renderer;
      }
      if (a.tokenizer) {
        if (!a.level || a.level !== "block" && a.level !== "inline")
          throw new Error("extension level must be 'block' or 'inline'");
        t[a.level] ? t[a.level].unshift(a.tokenizer) : t[a.level] = [a.tokenizer], a.start && (a.level === "block" ? t.startBlock ? t.startBlock.push(a.start) : t.startBlock = [a.start] : a.level === "inline" && (t.startInline ? t.startInline.push(a.start) : t.startInline = [a.start]));
      }
      a.childTokens && (t.childTokens[a.name] = a.childTokens);
    }), r.extensions = t), n.renderer) {
      const a = pe.defaults.renderer || new _u();
      for (const i in n.renderer) {
        const s = a[i];
        a[i] = (...o) => {
          let l = n.renderer[i].apply(a, o);
          return l === !1 && (l = s.apply(a, o)), l;
        };
      }
      r.renderer = a;
    }
    if (n.tokenizer) {
      const a = pe.defaults.tokenizer || new xu();
      for (const i in n.tokenizer) {
        const s = a[i];
        a[i] = (...o) => {
          let l = n.tokenizer[i].apply(a, o);
          return l === !1 && (l = s.apply(a, o)), l;
        };
      }
      r.tokenizer = a;
    }
    if (n.hooks) {
      const a = pe.defaults.hooks || new di();
      for (const i in n.hooks) {
        const s = a[i];
        di.passThroughHooks.has(i) ? a[i] = (o) => {
          if (pe.defaults.async)
            return Promise.resolve(n.hooks[i].call(a, o)).then((u) => s.call(a, u));
          const l = n.hooks[i].call(a, o);
          return s.call(a, l);
        } : a[i] = (...o) => {
          let l = n.hooks[i].apply(a, o);
          return l === !1 && (l = s.apply(a, o)), l;
        };
      }
      r.hooks = a;
    }
    if (n.walkTokens) {
      const a = pe.defaults.walkTokens;
      r.walkTokens = function(i) {
        let s = [];
        return s.push(n.walkTokens.call(this, i)), a && (s = s.concat(a.call(this, i))), s;
      };
    }
    pe.setOptions(r);
  });
};
pe.walkTokens = function(e, t) {
  let n = [];
  for (const r of e)
    switch (n = n.concat(t.call(pe, r)), r.type) {
      case "table": {
        for (const a of r.header)
          n = n.concat(pe.walkTokens(a.tokens, t));
        for (const a of r.rows)
          for (const i of a)
            n = n.concat(pe.walkTokens(i.tokens, t));
        break;
      }
      case "list": {
        n = n.concat(pe.walkTokens(r.items, t));
        break;
      }
      default:
        pe.defaults.extensions && pe.defaults.extensions.childTokens && pe.defaults.extensions.childTokens[r.type] ? pe.defaults.extensions.childTokens[r.type].forEach(function(a) {
          n = n.concat(pe.walkTokens(r[a], t));
        }) : r.tokens && (n = n.concat(pe.walkTokens(r.tokens, t)));
    }
  return n;
};
pe.parseInline = o4(Dn.lexInline, Rn.parseInline);
pe.Parser = Rn;
pe.parser = Rn.parse;
pe.Renderer = _u;
pe.TextRenderer = i4;
pe.Lexer = Dn;
pe.lexer = Dn.lex;
pe.Tokenizer = xu;
pe.Slugger = s4;
pe.Hooks = di;
pe.parse = pe;
pe.options;
pe.setOptions;
pe.use;
pe.walkTokens;
pe.parseInline;
Rn.parse;
Dn.lex;
const VA = ["innerHTML"], UA = {
  name: "AppMarkDown"
}, HA = /* @__PURE__ */ re({
  ...UA,
  props: {
    markdown: {}
  },
  setup(e) {
    const t = e, n = P(() => pe(t.markdown));
    return (r, a) => (C(), T("div", zn({ class: "markdown" }, r.$attrs, { innerHTML: n.value }), null, 16, VA));
  }
}), GA = /* @__PURE__ */ Ct(HA, [["__scopeId", "data-v-f8f22a48"]]), qA = { class: "relative flex gap-1" }, WA = {
  key: 1,
  class: "size-5"
}, YA = {
  key: 3,
  class: "size-5"
}, KA = ["checked", "disabled"], ZA = {
  name: "AppToggle"
}, XA = /* @__PURE__ */ re({
  ...ZA,
  props: {
    modelValue: { type: Boolean },
    theme: { default: "light" },
    disabled: { type: Boolean, default: !1 },
    leftIcon: { default: void 0 },
    rightIcon: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = () => {
      n.disabled || r("update:modelValue", !n.modelValue);
    };
    return (i, s) => (C(), T("div", {
      class: z(["relative h-fit cursor-pointer rounded-full p-1 transition-all focus-within:shadow-active", {
        "!bg-blue-200 !p-2": i.leftIcon,
        "bg-blue-700": i.modelValue,
        "bg-black/75": !i.leftIcon && i.theme === "dark",
        "bg-black": !i.modelValue && i.theme === "dark",
        "bg-gray-100": !i.modelValue && i.theme === "light",
        "opacity-50": i.disabled
      }]),
      "data-test-id": "toggle",
      onClick: s[0] || (s[0] = (o) => a())
    }, [
      S("div", qA, [
        S("div", {
          class: z(["absolute inset-y-0 z-0 w-[calc(50%-2px)] rounded-full drop-shadow-sm", {
            "right-0": i.modelValue,
            "bg-blue-700": i.leftIcon,
            "bg-white": !i.leftIcon,
            "!bg-blue-300": !i.modelValue && !i.leftIcon && i.theme === "dark"
          }])
        }, null, 2),
        i.leftIcon ? (C(), ve(x(te), {
          key: 0,
          size: "1x",
          icon: i.leftIcon,
          class: z(["z-10 my-2 w-10 transition-colors duration-300 ease-in-out", i.modelValue ? "text-blue-500" : "text-white"])
        }, null, 8, ["icon", "class"])) : (C(), T("div", WA)),
        i.rightIcon ? (C(), ve(x(te), {
          key: 2,
          size: "1x",
          icon: i.rightIcon,
          class: z(["z-10 my-2 w-10 transition-colors duration-300 ease-in-out", i.modelValue ? "text-white" : "text-blue-500"])
        }, null, 8, ["icon", "class"])) : (C(), T("div", YA))
      ]),
      S("input", {
        type: "checkbox",
        hidden: "",
        class: "absolute",
        "data-test-id": "toggle-input",
        checked: i.modelValue,
        disabled: i.disabled
      }, null, 8, KA)
    ], 2));
  }
}), JA = { class: "max-w-xl" }, QA = { class: "mb-4 text-base truncate" }, eE = { class: "mb-2 flex items-center justify-end gap-6" }, tE = /* @__PURE__ */ re({
  __name: "Confirmation",
  props: {
    content: { default: "Weet u het zeker?" },
    buttonText: { default: "Bevestigen" },
    buttonType: { default: "primary" },
    cancelButtonText: { default: "Annuleren" }
  },
  emits: ["closeModal", "confirm"],
  setup(e, { emit: t }) {
    const n = t;
    return (r, a) => {
      const i = Vl("FontAwesomeIcon");
      return C(), T("div", JA, [
        S("div", QA, H(r.content), 1),
        S("div", eE, [
          U(St, {
            type: "tertiary-underline",
            class: "w-full",
            "data-test-id": "close-confirmation-modal",
            onClick: a[0] || (a[0] = (s) => n("closeModal"))
          }, {
            default: fe(() => [
              rt(H(r.cancelButtonText), 1)
            ]),
            _: 1
          }),
          U(St, {
            type: r.buttonType,
            "data-test-id": "confirm-button",
            onClick: a[1] || (a[1] = (s) => {
              n("confirm"), n("closeModal");
            })
          }, {
            "icon-start": fe(() => [
              U(i, {
                icon: ["fas", "check"],
                size: "lg",
                class: "mr-1 text-white"
              })
            ]),
            default: fe(() => [
              rt(" " + H(r.buttonText), 1)
            ]),
            _: 1
          }, 8, ["type"])
        ])
      ]);
    };
  }
}), nE = {
  name: "InfiniteScroll"
}, rE = /* @__PURE__ */ re({
  ...nE,
  props: {
    iterableData: {},
    showCount: {},
    addCount: {}
  },
  setup(e) {
    const t = e, n = N(), r = N(), a = N(t.showCount), i = P(
      () => t.iterableData.slice(0, Math.min(t.iterableData.length, a.value))
    ), s = P(() => t.iterableData.length <= a.value), o = () => {
      a.value += t.addCount;
    };
    return Do(() => {
      r.value = new IntersectionObserver(o);
    }), Ue(() => {
      var l;
      return n.value && ((l = r.value) == null ? void 0 : l.observe(n.value));
    }), Do(() => {
      var l;
      return (l = r.value) == null ? void 0 : l.disconnect();
    }), (l, u) => (C(), T(Oe, null, [
      (C(!0), T(Oe, null, Fe(i.value, (c, d) => Ce(l.$slots, "default", {
        data: c,
        index: d
      })), 256)),
      S("div", zn({
        ref_key: "observable",
        ref: n,
        "data-test-id": "observable",
        class: ["h-48", { hidden: s.value }]
      }, l.$attrs), null, 16)
    ], 64));
  }
}), aE = ["for"], iE = ["id", "checked", "name"], sE = { class: "absolute top-0 left-0 flex size-6 items-center justify-center" }, oE = ["for"], lE = {
  name: "Radio"
}, uE = /* @__PURE__ */ re({
  ...lE,
  props: {
    id: { default: "" },
    label: {},
    name: {},
    modelValue: {},
    value: {},
    direction: { default: "vertical" },
    icon: { default: "" }
  },
  emits: ["update:modelValue", "update:error"],
  setup(e, { emit: t }) {
    const n = e, { errorMessage: r } = Tt(n.name, void 0, {
      initialValue: n.modelValue
    }), a = t, i = N();
    De(
      () => r.value,
      (o) => {
        a("update:error", o);
      }
    );
    const s = () => {
      a("update:modelValue", n.value);
    };
    return (o, l) => (C(), T("div", {
      class: z(["relative flex", n.direction === "vertical" ? "flex-col" : "flex-row"])
    }, [
      S("label", {
        class: "relative cursor-pointer",
        for: n.id || n.name
      }, [
        S("input", {
          id: n.id || n.name,
          ref_key: "input",
          ref: i,
          checked: n.modelValue === n.value,
          name: n.name,
          class: "m-0 flex size-6 shrink-0 appearance-none rounded-full border border-blue-700 bg-white checked:!bg-blue-700 focus:shadow-active mr-2",
          type: "radio",
          "data-test-id": "radio-input",
          onChange: s
        }, null, 40, iE),
        S("div", sE, [
          U(x(te), {
            class: z(["z-1 relative text-white opacity-0 transition-opacity duration-300", {
              "!opacity-100": n.modelValue === n.value
            }]),
            icon: ["fas", "check"],
            for: n.name
          }, null, 8, ["class", "for"])
        ])
      ], 8, aE),
      S("label", {
        class: z(["h-full items-center gap-3 overflow-hidden focus:shadow-active cursor-pointer", [
          { "border-danger": x(r) },
          { "w-full": n.direction !== "horizontal" }
        ]]),
        for: n.id || n.name,
        tabindex: "0",
        "data-test-id": "update-value",
        onKeydown: wt(s, ["enter"])
      }, [
        n.icon ? (C(), ve(x(te), {
          key: 0,
          icon: ["fad", n.icon],
          class: z(["radio-icon 2x", {
            "active-icon": n.modelValue === n.value
          }])
        }, null, 8, ["icon", "class"])) : K("", !0),
        S("p", null, H(n.label), 1)
      ], 42, oE)
    ], 2));
  }
}), cE = /* @__PURE__ */ Ct(uE, [["__scopeId", "data-v-e68bd4c9"]]), dE = { class: "relative flex items-start" }, fE = { class: "flex size-full items-center" }, pE = ["for"], hE = ["id", "checked", "name"], mE = ["for"], vE = {
  name: "RadioSelect"
}, gE = /* @__PURE__ */ re({
  ...vE,
  props: {
    id: { default: "" },
    label: {},
    name: {},
    modelValue: {},
    value: {},
    direction: { default: "vertical" },
    icon: { default: "" }
  },
  emits: ["update:modelValue", "update:error"],
  setup(e, { emit: t }) {
    const n = e, { errorMessage: r } = Tt(n.name, void 0, {
      initialValue: n.modelValue
    }), a = t, i = N();
    De(
      () => r.value,
      (o) => {
        a("update:error", o);
      }
    );
    const s = () => {
      a("update:modelValue", n.value);
    };
    return (o, l) => (C(), T("div", dE, [
      Ce(o.$slots, "default", {}, void 0, !0),
      S("div", fE, [
        S("label", {
          class: "relative",
          for: n.id || x(Te)(n.name)
        }, [
          S("input", {
            id: n.id || x(Te)(n.name),
            ref_key: "input",
            ref: i,
            checked: n.modelValue === n.value,
            name: n.name,
            class: "m-0 size-6 shrink-0 appearance-none rounded-lg border border-blue-700 bg-white checked:!bg-blue-700 focus:shadow-active hidden",
            type: "radio",
            "data-test-id": "select-input",
            onChange: s
          }, null, 40, hE)
        ], 8, pE),
        S("label", {
          class: z(["bg-white p-3 pl-4 rounded-lg cursor-pointer hover:text-blue-700 border border-blue-300 flex size-full flex-nowrap items-center overflow-hidden checked:bg-blue-700 focus:shadow-active", { "!bg-blue-700 text-white hover:text-white": n.modelValue === n.value }]),
          for: n.id || x(Te)(n.name),
          tabindex: "0",
          onKeydown: wt(s, ["enter"])
        }, [
          n.icon ? (C(), ve(x(te), {
            key: 0,
            icon: ["fad", n.icon],
            class: z(["radio-icon", {
              "active-icon": n.modelValue === n.value
            }]),
            size: "2x"
          }, null, 8, ["icon", "class"])) : K("", !0),
          S("p", null, H(n.label), 1)
        ], 42, mE)
      ])
    ]));
  }
}), bE = /* @__PURE__ */ Ct(gE, [["__scopeId", "data-v-0a841ea4"]]), $E = { class: "relative items-start w-full" }, yE = { class: "flex size-full items-center justify-center flex-col-reverse" }, xE = ["for"], _E = ["id", "checked", "name", "data-test-id"], wE = ["for"], SE = {
  name: "RadioSquare"
}, CE = /* @__PURE__ */ re({
  ...SE,
  props: {
    id: { default: "" },
    label: {},
    name: {},
    modelValue: {},
    value: {},
    direction: { default: "vertical" },
    icon: { default: "" }
  },
  emits: ["update:modelValue", "update:error"],
  setup(e, { emit: t }) {
    const n = e, { errorMessage: r } = Tt(n.name, void 0, {
      initialValue: n.modelValue
    }), a = t, i = N();
    De(
      () => r.value,
      (o) => {
        a("update:error", o);
      }
    );
    const s = () => {
      a("update:modelValue", n.value);
    };
    return (o, l) => (C(), T("div", $E, [
      Ce(o.$slots, "default", {}, void 0, !0),
      S("div", yE, [
        S("label", {
          class: "relative",
          for: n.id || x(Te)(n.name)
        }, [
          S("input", {
            id: n.id || x(Te)(n.name),
            ref_key: "input",
            ref: i,
            checked: n.modelValue === n.value,
            name: n.name,
            class: "m-0 size-6 shrink-0 appearance-none rounded-lg border border-blue-700 bg-white checked:!bg-blue-700 focus:shadow-active hidden",
            type: "radio",
            "data-test-id": `radio-square-${n.value}`,
            onChange: s
          }, null, 40, _E)
        ], 8, xE),
        S("label", {
          class: z(["flex flex-nowrap items-center gap-3 overflow-hidden focus:shadow-active flex-row grow bg-white p-4 border-dashed border border-blue-300 rounded-lg cursor-pointer hover:shadow-md md:justify-center w-full", {
            "border-danger": x(r),
            "!bg-blue-700 text-white hover:text-white": n.modelValue === n.value
          }]),
          for: n.id || x(Te)(n.name),
          tabindex: "0",
          onKeydown: wt(s, ["enter"])
        }, [
          n.icon ? (C(), ve(x(te), {
            key: 0,
            icon: ["fad", n.icon],
            class: z(["radio-icon", {
              "active-icon": n.modelValue === n.value
            }]),
            size: "lg"
          }, null, 8, ["icon", "class"])) : K("", !0),
          S("p", null, H(n.label), 1)
        ], 42, wE)
      ])
    ]));
  }
}), AE = /* @__PURE__ */ Ct(CE, [["__scopeId", "data-v-faae85f4"]]), EE = { class: "w-full" }, OE = { class: "relative inline-block w-full" }, TE = { class: "absolute left-3 flex h-full items-center" }, ME = { class: "flex size-6 items-center justify-center rounded-full" }, kE = { class: "flex size-6 items-center justify-center rounded-full" }, LE = ["id", "name"], FE = {
  name: "AppProgressBar"
}, zE = /* @__PURE__ */ re({
  ...FE,
  props: {
    name: {},
    modelValue: { default: "" },
    isLoading: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = t, r = N(""), a = () => {
      r.value = "", n("update:modelValue", r.value);
    };
    return (i, s) => (C(), T("div", EE, [
      S("div", OE, [
        S("div", TE, [
          S("span", ME, [
            U(x(te), {
              size: "sm",
              icon: ["fas", "search"],
              class: "text-blue-300"
            })
          ])
        ]),
        r.value.length > 0 ? (C(), T("div", {
          key: 0,
          "data-test-id": "xmark",
          class: "absolute right-3 flex h-full items-center",
          onClick: a
        }, [
          S("span", kE, [
            U(x(te), {
              size: "sm",
              icon: ["fas", i.isLoading ? "spinner" : "times"],
              class: z(["text-gray-700 cursor-pointer", { "animate-spin": i.isLoading }])
            }, null, 8, ["icon", "class"])
          ])
        ])) : K("", !0),
        ct(S("input", {
          id: x(Te)(i.name),
          "onUpdate:modelValue": s[0] || (s[0] = (o) => r.value = o),
          name: i.name,
          placeholder: "Zoeken",
          class: "block w-full rounded-lg border border-blue-300 p-2 pl-11 pr-10 transition-all duration-300 focus:shadow-active disabled:border-gray-100 disabled:bg-gray-100 disabled:text-gray-700",
          "data-test-id": "search-bar-input",
          onKeyup: s[1] || (s[1] = (o) => n("update:modelValue", r.value)),
          onPaste: s[2] || (s[2] = (o) => n("update:modelValue", r.value))
        }, null, 40, LE), [
          [er, r.value]
        ])
      ])
    ]));
  }
}), PE = { class: "mt-8" }, IE = ["data-test-id", "title", "onClick"], NE = {
  key: 0,
  class: "absolute top-1/2 -mt-3 -left-3 -translate-y-1/2 z-10 bg-orange-900 rounded-full flex place-items-center text-white size-6"
}, DE = { class: "sr-only" }, RE = {
  "aria-hidden": "true",
  class: "text-center h-fit w-full"
}, jE = {
  "aria-hidden": "true",
  class: "relative z-20 w-auto"
}, BE = /* @__PURE__ */ re({
  __name: "MobileMenu",
  props: {
    items: {},
    route: {},
    isMenuOpenMobile: { type: Boolean },
    matchExactRoute: { type: Boolean, default: !1 }
  },
  emits: ["to", "openOrCloseMenu", "logout"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = (s) => n.matchExactRoute ? n.route === s.to : n.route.includes(s.to), i = (s) => [a(s) ? "fas" : "fal", s.icon];
    return (s, o) => (C(), T("div", null, [
      S("div", {
        id: "open-hamburger-menu",
        class: "sticky overflow-y-hidden inset-0 z-80 lg:hidden",
        onClick: o[0] || (o[0] = (l) => r("openOrCloseMenu", !0))
      }, [
        U(x(te), {
          icon: ["fad", "bars"],
          size: "xl"
        })
      ]),
      S("div", {
        class: z(["z-40 flex flex-col overflow-scroll bg-gradient-to-tr from-blue-900 to-blue-500 px-8 pt-16 pb-8 fixed inset-0 w-screen h-screen", {
          "!hidden lg:flex": !s.isMenuOpenMobile
        }])
      }, [
        Ce(s.$slots, "default"),
        S("nav", PE, [
          S("div", {
            class: "fixed top-2 right-4 text-white",
            onClick: o[1] || (o[1] = (l) => r("openOrCloseMenu", !1))
          }, [
            U(x(te), {
              icon: ["fas", "xmark"],
              size: "2x"
            })
          ]),
          (C(!0), T(Oe, null, Fe(s.items, (l, u) => {
            var c;
            return C(), T("div", {
              key: l.label,
              class: z(["flex flex-row text-white relative h-24 cursor-pointer items-center lg:border-none z-10", {
                "before:bg-black before:h-full before:w-screen before:absolute before:opacity-20 before:-left-8": a(l),
                "border-t border-gray-50": u > 0 && !a(l) && !a(s.items[u - 1])
              }]),
              "data-test-id": `mobile-menu-link-${u.toString()}`,
              title: l.label,
              onClick: Se((d) => l.label === "Uitloggen" ? r("logout") : r("to", l.to), ["prevent"])
            }, [
              U(x(te), {
                class: "relative z-10 text-3xl mr-4 min-w-[30px]",
                icon: i(l)
              }, null, 8, ["icon"]),
              (c = l.notificationCount) != null && c.value && l.notificationCount.value > 0 ? (C(), T("div", NE, [
                S("span", DE, H(l.label) + " - " + H(l.notificationCount), 1),
                S("p", RE, H(l.notificationCount), 1)
              ])) : K("", !0),
              S("span", jE, H(l.label), 1)
            ], 10, IE);
          }), 128))
        ])
      ], 2)
    ]));
  }
}), VE = { class: "flex items-center justify-center" }, UE = {
  key: 0,
  class: "flex cursor-pointer items-center"
}, HE = { class: "mt-6" }, GE = ["data-test-id", "title", "onClick"], qE = {
  key: 0,
  class: "absolute top-1/2 -mt-3 -left-3 -translate-y-1/2 z-10 bg-orange-900 rounded-full flex place-items-center text-white size-6"
}, WE = { class: "sr-only" }, YE = {
  "aria-hidden": "true",
  class: "text-center h-fit w-full"
}, KE = /* @__PURE__ */ re({
  __name: "SidebarMenu",
  props: {
    items: {},
    route: {},
    matchExactRoute: { type: Boolean, default: !1 },
    collapseLabel: { default: "Invouwen" }
  },
  emits: ["to", "isSidebarCollapsed", "logout"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = (l) => n.matchExactRoute ? n.route === l.to : n.route.includes(l.to), i = (l) => [a(l) ? "fas" : "fal", l.icon], s = N(!1), o = () => {
      s.value = !s.value, localStorage.setItem("isSidebarCollapsed", s.value.toString()), r("isSidebarCollapsed", s.value);
    };
    return Ue(() => {
      s.value = localStorage.getItem("isSidebarCollapsed") === "true", r("isSidebarCollapsed", localStorage.getItem("isSidebarCollapsed") === "true");
    }), (l, u) => (C(), T("aside", {
      class: z(["z-40 flex-col h-full overflow-hidden bg-gradient-to-tr from-blue-900 to-blue-500 p-4 rounded-3xl hidden lg:flex", {
        "lg:flex": s.value,
        "lg:w-fit 3xl:w-full": !s.value
      }])
    }, [
      Ce(l.$slots, "default"),
      S("div", {
        "data-test-id": "sidebar-toggle-button",
        class: z(["hidden grid-cols-[40px_auto] gap-x-2 p-4 text-white lg:grid", { "lg:grid-cols-[40px]": s.value }]),
        onClick: u[0] || (u[0] = Se((c) => o(), ["prevent"]))
      }, [
        S("div", VE, [
          U(St, {
            title: s.value ? "Uitvouwen" : "Samenvouwen",
            "is-icon": "",
            type: "secondary",
            color: "blue",
            class: "size-8 bg-white hover:text-blue-700"
          }, {
            default: fe(() => [
              U(x(te), {
                icon: ["fas", "chevron-left"],
                size: "sm",
                class: z(["transition-transform duration-150 ease-in-out", { "-scale-x-100": s.value }])
              }, null, 8, ["class"])
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        s.value ? K("", !0) : (C(), T("div", UE, H(l.collapseLabel), 1))
      ], 2),
      S("nav", HE, [
        (C(!0), T(Oe, null, Fe(l.items, (c, d) => {
          var f;
          return C(), T("div", {
            key: c.label,
            class: z(["flex flex-row text-white justify-center relative h-24 cursor-pointer items-center lg:border-none z-10", {
              // eslint-disable-next-line max-len
              "font-bold before:bg-black before:h-full before:w-screen before:font-bold before:absolute before:opacity-20 before:-left-8": a(c),
              "border-t border-gray-50": d > 0 && !a(c) && !a(l.items[d - 1]),
              "ml-4 !justify-start": !s.value
            }]),
            "data-test-id": `sidebar-link-${d.toString()}`,
            title: c.label,
            onClick: (p) => c.label === "Uitloggen" ? r("logout") : r("to", c.to)
          }, [
            U(x(te), {
              class: z(["relative z-10 text-3xl mr-4 w-8", s.value ? "!mr-0" : ""]),
              icon: i(c)
            }, null, 8, ["class", "icon"]),
            (f = c.notificationCount) != null && f.value && c.notificationCount.value > 0 ? (C(), T("div", qE, [
              S("span", WE, H(c.label) + " - " + H(c.notificationCount), 1),
              S("p", YE, H(c.notificationCount), 1)
            ])) : K("", !0),
            S("span", {
              "aria-hidden": "true",
              class: z(["relative z-20 w-auto", s.value ? "hidden" : ""])
            }, H(c.label), 3)
          ], 10, GE);
        }), 128))
      ])
    ], 2));
  }
}), ZE = ["for"], XE = ["id", "disabled", "data-test-id", "aria-expanded", "onKeydown"], JE = { class: "flex items-center gap-2 w-[calc(100%-1rem)]" }, QE = ["textContent"], eO = ["aria-label", "aria-hidden"], tO = ["id", "aria-selected", "data-test-id", "onClick"], nO = ["textContent"], l4 = /* @__PURE__ */ re({
  __name: "DropDown",
  props: {
    options: {},
    modelValue: {},
    name: {},
    label: { default: "" },
    ariaLabel: { default: "" },
    placeholder: { default: "" },
    isAbsolute: { type: Boolean, default: !0 },
    disabled: { type: Boolean, default: !1 },
    additionalCssContainer: { default: "" },
    additionalCssButton: { default: "" },
    additionalCssDropdown: { default: "" },
    additionalCssDropdownOptions: { default: "" },
    validatable: { type: Boolean, default: !0 },
    validateOnValueUpdate: { type: Boolean, default: !0 },
    additionalCssLabel: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = N(null), i = N(null), s = N(!1), o = N(null), {
      errorMessage: l,
      meta: u,
      setValue: c,
      validate: d
    } = Tt(n.name, void 0, {
      initialValue: n.modelValue,
      validateOnValueUpdate: n.validateOnValueUpdate
    }), f = () => {
      s.value = !s.value, s.value && We(() => {
        var $;
        if (!i.value) return;
        const b = i.value.querySelector('[aria-selected="true"]');
        ($ = i.value) == null || $.scrollTo({ top: b != null && b.offsetTop ? b.scrollTop - 50 : 0 });
      });
    }, p = (b) => {
      if (o.value = b, i.value) {
        const $ = i.value.querySelector(`#${Te(b.label)}`);
        i.value.scrollTo({
          top: $ != null && $.offsetTop ? $.scrollTop - 50 : 0,
          behavior: "smooth"
        });
      }
    }, h = (b, $ = !0) => {
      b.isSubTitle || (o.value = b, c(b), r("update:modelValue", b), $ && (s.value = !1));
    }, m = () => {
      const b = n.options.findIndex((y) => {
        var A;
        return y.label === ((A = o.value) == null ? void 0 : A.label);
      }), $ = n.options[b + 1] ?? n.options[n.options.length - 1];
      p($);
    }, v = () => {
      const b = n.options.findIndex((y) => {
        var A;
        return y.label === ((A = o.value) == null ? void 0 : A.label);
      }), $ = n.options[b - 1] ?? n.options[0];
      p($);
    }, g = () => {
      if (!s.value) {
        s.value = !0;
        return;
      }
      const b = n.options.find(($) => {
        var y;
        return $.label === ((y = o.value) == null ? void 0 : y.label);
      });
      b && h(b);
    };
    return Ue(() => {
      o.value = n.modelValue, n.validatable && d(), A3(a, () => {
        s.value = !1;
      });
    }), (b, $) => {
      var A, E, L, D;
      const y = Vl("AppInput");
      return C(), T("div", null, [
        S("div", {
          ref_key: "dropDown",
          ref: a,
          class: z(["relative", n.additionalCssContainer])
        }, [
          n.label ? (C(), T("label", {
            key: 0,
            for: `dropdown-${b.name}`,
            class: z(n.additionalCssLabel)
          }, H(n.label), 11, ZE)) : K("", !0),
          S("button", {
            id: `dropdown-${b.name}`,
            "aria-haspopup": "listbox",
            class: z(["flex items-center justify-between rounded-xl border border-blue-300 bg-white p-2 px-4 w-full focus:shadow-active disabled:bg-gray-100 disabled:border-gray-100 disabled:text-gray-700", [
              {
                // eslint-disable-next-line max-len
                "!bg-orange-100 !border-orange-900 !text-orange-900 shadow-activeError focus:!border-blue-300 focus:!text-gray-900 focus:!bg-white": x(l),
                // eslint-disable-next-line max-len
                "!border-green-700 focus:!shadow-activeSuccess": ((A = n.modelValue) == null ? void 0 : A.value.length) > 0 && x(u).valid && b.validatable
              },
              n.additionalCssButton
            ]]),
            disabled: n.disabled,
            "data-test-id": `dropdown-${b.name}`,
            "aria-expanded": s.value,
            onClick: Se(f, ["prevent"]),
            onKeydown: [
              wt(Se(m, ["prevent"]), ["arrow-down", "arrow-right"]),
              wt(Se(v, ["prevent"]), ["arrow-up", "arrow-left"]),
              wt(Se(g, ["prevent"]), ["enter", "space"]),
              wt(Se(f, ["prevent"]), ["escape", "tab"])
            ]
          }, [
            S("div", JE, [
              Ce(b.$slots, "before-label"),
              S("span", {
                class: z(["label mb-0 mr-4 text-left truncate", { "text-gray-400": !b.modelValue && b.placeholder }]),
                textContent: H(((E = b.modelValue) == null ? void 0 : E.label) ?? b.placeholder ?? "")
              }, null, 10, QE)
            ]),
            ((L = n.modelValue) == null ? void 0 : L.value.length) > 0 && x(u).valid && b.validatable ? (C(), ve(x(te), {
              key: 0,
              class: z(["text-green-700 opacity-0 transition-opacity duration-300", {
                "!opacity-100": x(u).valid
              }]),
              icon: ["fas", "check"],
              size: "lg"
            }, null, 8, ["class"])) : (C(), ve(x(te), {
              key: 1,
              class: "size-4 font-light",
              icon: ["fas", "chevron-down"]
            }))
          ], 42, XE),
          (C(), ve(y, {
            key: b.name,
            name: b.name,
            "model-value": ((D = b.modelValue) == null ? void 0 : D.value) ?? "",
            type: "hidden",
            class: "hidden"
          }, null, 8, ["name", "model-value"])),
          S("div", {
            class: z(["w-full z-10", n.additionalCssDropdown, { absolute: b.isAbsolute }])
          }, [
            ct(S("ul", {
              ref_key: "dropDownOptions",
              ref: i,
              role: "listbox",
              "aria-label": b.label ?? b.ariaLabel,
              "aria-hidden": !s.value,
              tabindex: "-1",
              class: z(["z-10 inset-x-0 mt-2 max-h-48 overflow-y-auto scroll-smooth rounded-xl border border-blue-300 bg-white shadow-xl user-select-none", n.additionalCssDropdownOptions])
            }, [
              (C(!0), T(Oe, null, Fe(n.options, (ne, I) => {
                var B;
                return C(), T("li", {
                  id: x(Te)(ne.label),
                  key: ne.label,
                  role: "option",
                  "aria-selected": ne.value === b.modelValue.value,
                  class: z(["relative flex items-center gap-3 px-4 py-3 text-left hover:bg-blue-200 focus:bg-blue-100", [
                    { "bg-blue-200 font-medium": ne.value === ((B = o.value) == null ? void 0 : B.value) },
                    { "font-medium": ne.isSubTitle },
                    { "hover:font-medium hover:cursor-pointer": !ne.isSubTitle }
                  ]]),
                  "data-test-id": `dropdown-${b.name}-option-${I}`,
                  onClick: Se(() => h(ne), ["prevent"])
                }, [
                  Ce(b.$slots, `before-option-label-${I}`),
                  ne.iconName ? (C(), ve(x(te), {
                    key: 0,
                    class: "pr-2",
                    icon: ["fas", ne.iconName]
                  }, null, 8, ["icon"])) : K("", !0),
                  Ce(b.$slots, `option-label-${I}`, {}, () => [
                    rt(H(ne.label), 1)
                  ]),
                  Ce(b.$slots, `after-option-label-${I}`)
                ], 10, tO);
              }), 128))
            ], 10, eO), [
              [gr, s.value]
            ])
          ], 2)
        ], 2),
        b.validatable ? (C(), T("span", {
          key: 0,
          class: z(["text-sm text-orange-900 opacity-0 peer-focus:opacity-0", {
            "opacity-100": x(l)
          }]),
          textContent: H(x(l) ?? "error")
        }, null, 10, nO)) : K("", !0)
      ]);
    };
  }
}), rO = { class: "relative" }, aO = ["for"], iO = { class: "relative flex items-start gap-2" }, sO = { class: "mr-2" }, oO = { class: "mr-2" }, lO = { class: "w-full" }, uO = { class: "relative inline-block w-full" }, cO = ["id", "name", "placeholder", "autocomplete", "disabled", "data-test-id", "aria-required", "tabindex"], dO = ["textContent"], fO = { class: "hidden" }, pO = /* @__PURE__ */ re({
  __name: "AppPhoneInput",
  props: {
    name: {},
    label: { default: "" },
    labelClass: { default: "" },
    disabled: { type: Boolean, default: !1 },
    theme: { default: "outline" },
    placeholder: { default: "" },
    modelValue: { default: "" },
    autocomplete: { default: "off" },
    validateOnValueUpdate: { type: Boolean, default: !1 },
    ignoreValidation: { type: Boolean, default: !1 },
    defaultCountry: { default: "NL" },
    locale: { default: "nl" },
    required: { type: Boolean },
    tabindex: { default: "0" }
  },
  emits: ["update:modelValue", "update:countryCode"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = ($) => `before-option-label-${$}`, i = ($) => {
      var y;
      return (y = Za($)) == null ? void 0 : y.country;
    }, s = N(i(n.modelValue) ?? n.defaultCountry), o = ($, y) => {
      var A, E;
      return ((E = (A = Za($, {
        defaultCountry: y ?? s.value ?? "NL"
      })) == null ? void 0 : A.formatInternational()) == null ? void 0 : E.split(" ").join("")) ?? "";
    }, l = ($) => {
      var y;
      return ((y = Za($, {
        defaultCountry: s.value ?? "NL"
      })) == null ? void 0 : y.formatNational()) ?? "";
    }, u = P(() => {
      const $ = ["NL", "BE"], y = new Intl.DisplayNames([n.locale], { type: "region" });
      return ib().map((A) => ({
        value: A,
        label: `${y.of(A)} (+${vs(A)})`,
        countryCallingCode: vs(A)
      })).sort((A, E) => $.includes(A.value) ? -100 : $.includes(E.value) ? 100 : A.label.localeCompare(E.label));
    }), c = P(() => ({
      value: s.value,
      label: `+${vs(s.value)}`
    })), d = N(l(n.modelValue ?? "") || n.modelValue), {
      value: f,
      meta: p,
      setValue: h
    } = Tt(n.name, void 0, {
      initialValue: n.modelValue,
      validateOnValueUpdate: n.validateOnValueUpdate
    }), m = ($) => {
      const y = o(d.value, $);
      s.value = $, h(y, n.validateOnValueUpdate), r("update:countryCode", $), r("update:modelValue", y);
    }, v = Zb(), g = () => {
      const $ = o(d.value), y = i(d.value);
      h($, n.validateOnValueUpdate), y && m(y), $ && (h($, n.validateOnValueUpdate), r("update:modelValue", $));
    }, b = () => {
      const $ = o(f.value);
      d.value = l($) ?? d.value, h($), $ !== f.value && r("update:modelValue", $);
    };
    return ($, y) => {
      var A, E;
      return C(), T("div", rO, [
        $.label ? (C(), T("label", {
          key: 0,
          class: z(["mb-0.5 inline-block", $.labelClass]),
          for: `${x(Te)($.name)}_localnumber`
        }, H($.label), 11, aO)) : K("", !0),
        S("div", iO, [
          U(l4, {
            options: u.value,
            "model-value": c.value,
            name: `${$.name}_countrycode`,
            "data-test-id": `${x(Te)($.name)}_countrycode`,
            disabled: n.disabled,
            class: "max-w-screen-xs min-w-[136px]",
            "aria-label": "Kies een landcode",
            "additional-css-dropdown": "min-w-[240px]",
            "onUpdate:modelValue": y[0] || (y[0] = (L) => m(L.value))
          }, af({
            "before-label": fe(() => [
              S("span", sO, H(x(Cc)(c.value.value)), 1)
            ]),
            _: 2
          }, [
            Fe(u.value, (L, D) => ({
              name: a(D),
              fn: fe(() => [
                S("span", oO, H(x(Cc)(L.value)), 1)
              ])
            }))
          ]), 1032, ["options", "model-value", "name", "data-test-id", "disabled"]),
          S("div", lO, [
            S("div", uO, [
              ct(S("input", {
                id: `${x(Te)($.name)}_localnumber`,
                ref: "phoneInput",
                "onUpdate:modelValue": y[1] || (y[1] = (L) => d.value = L),
                type: "tel",
                name: `${$.name}_localnumber`,
                placeholder: n.placeholder,
                autocomplete: n.autocomplete,
                disabled: n.disabled,
                "data-test-id": x(Te)($.name),
                "aria-required": $.required,
                tabindex: $.tabindex,
                class: z([{
                  // eslint-disable-next-line max-len
                  "!bg-orange-100 !border-orange-900 !text-orange-900 shadow-activeError focus:!border-blue-300 focus:!text-gray-900 focus:!bg-white": !x(p).valid && !$.ignoreValidation,
                  "!border-green-700 focus:!shadow-activeSuccess": x(p).dirty && x(p).valid && !$.ignoreValidation,
                  "pr-10": !$.ignoreValidation,
                  // eslint-disable-next-line max-len
                  "border border-blue-300 rounded-lg focus:shadow-active transition-all duration-300 disabled:bg-gray-100 disabled:border-gray-100 disabled:text-gray-700": n.theme === "outline",
                  // eslint-disable-next-line max-len
                  "shadow-element focus:shadow-active rounded-lg bg-white disabled:bg-gray-100 disabled:border-gray-100 disabled:text-gray-700": n.theme === "solo"
                }, "peer block w-full bg-white p-2"]),
                onInput: g,
                onBlur: b
              }, null, 42, cO), [
                [er, d.value]
              ]),
              $.ignoreValidation ? K("", !0) : (C(), ve(x(te), {
                key: 0,
                class: z(["absolute top-3 right-4 text-green-700 opacity-0 transition-opacity duration-300", {
                  "!opacity-100": x(p).valid
                }]),
                icon: ["fas", "check"],
                size: "lg"
              }, null, 8, ["class"])),
              S("span", {
                class: z(["text-sm text-orange-900 opacity-0 peer-focus:opacity-0", {
                  "opacity-100": (A = x(v)) == null ? void 0 : A[$.name]
                }]),
                textContent: H(((E = x(v)) == null ? void 0 : E[$.name]) ?? "error")
              }, null, 10, dO)
            ])
          ])
        ]),
        S("div", fO, [
          U(ui, {
            modelValue: x(f),
            "onUpdate:modelValue": y[2] || (y[2] = (L) => Ht(f) ? f.value = L : null),
            name: $.name,
            type: "hidden",
            class: "pointer-events-none"
          }, null, 8, ["modelValue", "name"])
        ])
      ]);
    };
  }
}), hO = { class: "flex flex-wrap items-center gap-y-2" }, mO = {
  href: "/",
  "data-test-id": "breadcrumb-home",
  class: "pr-2"
}, vO = ["data-test-id"], gO = ["href"], bO = ["textContent"], $O = /* @__PURE__ */ re({
  __name: "BreadCrumbs",
  props: {
    isLastHidden: { type: Boolean, default: !1 },
    customPathNames: { default: null },
    customPathIndexes: { default: null }
  },
  setup(e) {
    const t = of(), n = e, r = P(() => {
      const a = t.path.split("/").filter((s) => s), i = [];
      for (const [s, o] of a.entries()) {
        const l = `/${a.slice(0, s + 1).join("/")}`, u = o.replaceAll("-", " ").replace(/^\w/, (c) => c.toUpperCase());
        i.push({ path: l, title: u, to: l });
      }
      if (n.isLastHidden && i.pop(), n.customPathNames)
        for (const [s, o] of n.customPathNames.entries()) {
          const l = n.customPathIndexes ? n.customPathIndexes[s] : i.length - 1;
          i[l].title = o;
        }
      return i;
    });
    return (a, i) => (C(), T("ol", hO, [
      S("li", null, [
        S("a", mO, [
          U(x(te), {
            icon: ["fal", "house"],
            size: "xs",
            class: "scale-150 text-gray-700"
          })
        ])
      ]),
      (C(!0), T(Oe, null, Fe(r.value, (s, o) => (C(), T("li", {
        key: o,
        "data-test-id": `breadcrumb-${o}`
      }, [
        i[0] || (i[0] = S("span", {
          class: "text-gray-700",
          textContent: ">"
        }, null, -1)),
        S("a", {
          href: o < r.value.length - 1 ? `${s.to}` : void 0,
          class: z([o < r.value.length - 1 ? "text-gray-700 underline cursor-pointer" : "cursor-text", "p-2"])
        }, [
          S("span", {
            textContent: H(s.title)
          }, null, 8, bO)
        ], 10, gO)
      ], 8, vO))), 128))
    ]));
  }
}), yO = ["multiple", "accept"], xO = { class: "text-center" }, _O = { class: "text-gray-700 text-xs" }, wO = {
  class: "-mt-6",
  "aria-live": "polite"
}, SO = /* @__PURE__ */ re({
  __name: "DragAndDrop",
  props: {
    accept: { default: ".doc, .docx, application/msword, application/pdf, .jpg, .jpeg, .png" },
    multiple: { type: Boolean, default: !1 },
    maxSize: { default: 5e6 },
    label: { default: "Sleep hier uw bestand(en) of" },
    manualSelectLabel: { default: "zoek op mijn apparaat" },
    maxFileSizeLabel: { default: "Max [size] MB per bestand" },
    fileTooBigLabel: { default: "[file] is te groot" }
  },
  emits: ["upload"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = N(!1), i = N([]), s = N(), o = P(
      () => n.maxFileSizeLabel.replace("[size]", `${Math.floor(n.maxSize / 1e6).toString()} MB`)
    ), l = (c) => {
      i.value = [];
      const d = c, f = d == null ? void 0 : d.files;
      if (f) {
        for (const p of [...Array.from(f)])
          p.size > n.maxSize && i.value.push(n.fileTooBigLabel.replace("[file]", p.name));
        r("upload", [...Array.from(f)]), a.value = !1, s.value && (s.value.value = "");
      }
    }, u = async () => {
      var c;
      (c = s.value) == null || c.click();
    };
    return (c, d) => {
      const f = Vl("FontAwesomeIcon");
      return C(), T(Oe, null, [
        S("label", {
          class: z([{
            "!bg-blue-200": a.value
          }, "flex w-full flex-col items-center rounded-xl border border-dashed border-blue-500 bg-blue-50 p-6 transition-colors duration-150 ease-in-out mb-4"]),
          "data-test-id": "drag-and-drop",
          onDrop: d[2] || (d[2] = Se((p) => l(p.dataTransfer), ["prevent"])),
          onDragover: d[3] || (d[3] = Se((p) => a.value = !0, ["prevent"])),
          onDragleave: d[4] || (d[4] = Se((p) => a.value = !1, ["prevent"]))
        }, [
          S("input", {
            ref_key: "upload",
            ref: s,
            type: "file",
            multiple: c.multiple,
            accept: c.accept,
            hidden: "",
            onChange: d[0] || (d[0] = (p) => l(p.target))
          }, null, 40, yO),
          U(f, {
            icon: ["fas", "upload"],
            size: "2x",
            class: "mb-2 text-blue-700",
            "aria-hidden": "true"
          }),
          S("p", xO, [
            rt(H(c.label) + " ", 1),
            S("button", {
              type: "button",
              "data-test-id": "upload-click",
              class: "text-blue-500 underline hover:text-blue-900 bg-transparent px-1 py-0",
              onClick: d[1] || (d[1] = (p) => u())
            }, H(c.manualSelectLabel), 1)
          ]),
          S("span", _O, H(o.value), 1)
        ], 34),
        S("div", wO, [
          (C(!0), T(Oe, null, Fe(i.value, (p) => (C(), T("p", {
            key: p,
            class: "text-red-400"
          }, H(p), 1))), 128))
        ])
      ], 64);
    };
  }
});
var CO = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(Xf);
  })(En, function(n) {
    function r(s) {
      return s && typeof s == "object" && "default" in s ? s : { default: s };
    }
    var a = r(n), i = { name: "nl", weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"), weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"), weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"), months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"), monthsShort: "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"), ordinal: function(s) {
      return "[" + s + (s === 1 || s === 8 || s >= 20 ? "ste" : "de") + "]";
    }, weekStart: 1, yearStart: 4, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD-MM-YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd D MMMM YYYY HH:mm" }, relativeTime: { future: "over %s", past: "%s geleden", s: "een paar seconden", m: "een minuut", mm: "%d minuten", h: "een uur", hh: "%d uur", d: "een dag", dd: "%d dagen", M: "een maand", MM: "%d maanden", y: "een jaar", yy: "%d jaar" } };
    return a.default.locale(i, null, !0), i;
  });
})(CO);
const AO = { class: "flex flex-col gap-y-6" }, EO = { class: "whitespace-pre-line" }, OO = { class: "bg-blue-50 p-6 rounded-lg flex flex-col gap-10" }, TO = { class: "flex items-center gap-4" }, MO = { class: "font-semibold text-blue-700" }, kO = { class: "flex items-center gap-4" }, LO = { class: "font-semibold text-blue-700" }, FO = {
  key: 0,
  class: "flex items-center gap-4"
}, zO = { class: "font-semibold text-blue-700" }, PO = /* @__PURE__ */ re({
  __name: "Summary",
  props: {
    callback: {},
    message: { default: "Beste," },
    phoneLabel: { default: "Telefoonnummer" },
    dateLabel: { default: "Datum" },
    timeLabel: { default: "Tijd" },
    time: { default: "" },
    locale: { default: "nl" }
  },
  setup(e) {
    const t = e;
    return (n, r) => (C(), T("div", AO, [
      S("p", EO, H(t.message), 1),
      S("div", OO, [
        S("div", TO, [
          U(x(te), {
            icon: ["fad", "phone"],
            class: "text-3xl"
          }),
          S("div", null, [
            S("p", null, H(t.phoneLabel), 1),
            S("p", MO, H(n.callback.phone), 1)
          ])
        ]),
        S("div", kO, [
          U(x(te), {
            icon: ["fad", "calendar"],
            class: "text-4xl"
          }),
          S("div", null, [
            S("p", null, H(t.dateLabel), 1),
            S("p", LO, H(x(G)(n.callback.callback_date).locale(t.locale).format("dddd D MMMM YYYY")), 1)
          ])
        ]),
        n.callback.callback_time ? (C(), T("div", FO, [
          U(x(te), {
            icon: ["fad", "clock"],
            class: "text-4xl"
          }),
          S("div", null, [
            S("p", null, H(t.timeLabel), 1),
            S("p", zO, H(t.time ?? `${n.callback.callback_time} uur`), 1)
          ])
        ])) : K("", !0)
      ])
    ]));
  }
}), IO = { class: "relative" }, NO = { class: "block" }, DO = { class: "w-fit inline-flex rounded-lg border border-blue-300 pr-2" }, RO = {
  class: "relative",
  role: "group"
}, jO = ["id", "name"], BO = ["value"], VO = {
  class: "relative",
  role: "group"
}, UO = ["id", "name"], HO = ["value"], GO = ["value", "name"], qO = {
  name: "TimePicker"
}, u4 = /* @__PURE__ */ re({
  ...qO,
  props: {
    modelValue: {},
    id: { default: "" },
    name: { default: "" },
    label: { default: "Kies tijd:" },
    availableTimes: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = t, r = e, a = N(0), i = N("0"), s = [...Array.from({ length: 10 })].map((f, p) => p + 8), o = N(["30", "45"]), l = P(
      () => {
        var f;
        return (f = r.availableTimes) == null ? void 0 : f.map((p) => parseInt(p.split(":")[0], 10)).filter((p, h, m) => m.indexOf(p) === h);
      }
    ), u = P(
      () => {
        var f;
        return (f = r.availableTimes) == null ? void 0 : f.filter((p) => parseInt(p.split(":")[0], 10) === a.value).map((p) => p.split(":")[1]);
      }
    ), c = () => {
      n("update:modelValue", `${String(a.value).padStart(2, "0")}:${i.value}`);
    }, d = () => {
      if (a.value && i.value)
        switch (!0) {
          case a.value <= 8:
            o.value = ["30", "45"];
            break;
          case a.value >= 17:
            o.value = ["00", "15"];
            break;
          default:
            o.value = ["00", "15", "30", "45"];
        }
      (i.value < o.value[0] || i.value > o.value[o.value.length - 1]) && (i.value = o.value[0]), c(), r.availableTimes && (o.value = u.value ?? []);
    };
    return Ue(() => {
      var f;
      if (r.modelValue) {
        const [p, h] = r.modelValue.split(":");
        a.value = parseInt(p, 10), i.value = h;
      } else if (r.availableTimes) {
        const p = (f = r.availableTimes) == null ? void 0 : f[0], [h, m] = p.split(":");
        a.value = parseInt(h, 10), i.value = m;
      }
      d();
    }), (f, p) => (C(), T("div", IO, [
      S("label", NO, H(f.label), 1),
      S("div", DO, [
        S("div", RO, [
          ct(S("select", {
            id: f.id + "-hours",
            "onUpdate:modelValue": p[0] || (p[0] = (h) => a.value = h),
            name: f.name + "-hours",
            "aria-label": "Uur",
            class: "block w-full rounded-l-md bg-transparent py-2 pl-3 pr-9 text-base focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm",
            onChange: d
          }, [
            (C(!0), T(Oe, null, Fe(l.value ?? x(s), (h) => (C(), T("option", {
              key: h,
              value: h
            }, H(h), 9, BO))), 128))
          ], 40, jO), [
            [o1, a.value]
          ])
        ]),
        S("div", VO, [
          ct(S("select", {
            id: f.id + "-minutes",
            "onUpdate:modelValue": p[1] || (p[1] = (h) => i.value = h),
            name: f.name + "-minutes",
            "aria-label": "Minuten",
            class: "block w-full rounded-r-md bg-transparent py-2 pl-3 pr-9 text-base focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm",
            onChange: c
          }, [
            (C(!0), T(Oe, null, Fe(o.value, (h) => (C(), T("option", {
              key: h,
              value: h
            }, H(h), 9, HO))), 128))
          ], 40, UO), [
            [o1, i.value]
          ])
        ])
      ]),
      S("input", {
        type: "hidden",
        value: f.modelValue,
        name: f.name,
        "data-test-id": "selected-time"
      }, null, 8, GO)
    ]));
  }
});
var $l;
try {
  $l = Map;
} catch {
}
var yl;
try {
  yl = Set;
} catch {
}
function c4(e, t, n) {
  if (!e || typeof e != "object" || typeof e == "function")
    return e;
  if (e.nodeType && "cloneNode" in e)
    return e.cloneNode(!0);
  if (e instanceof Date)
    return new Date(e.getTime());
  if (e instanceof RegExp)
    return new RegExp(e);
  if (Array.isArray(e))
    return e.map(xl);
  if ($l && e instanceof $l)
    return new Map(Array.from(e.entries()));
  if (yl && e instanceof yl)
    return new Set(Array.from(e.values()));
  if (e instanceof Object) {
    t.push(e);
    var r = Object.create(e);
    n.push(r);
    for (var a in e) {
      var i = t.findIndex(function(s) {
        return s === e[a];
      });
      r[a] = i > -1 ? n[i] : c4(e[a], t, n);
    }
    return r;
  }
  return e;
}
function xl(e) {
  return c4(e, [], []);
}
const WO = Object.prototype.toString, YO = Error.prototype.toString, KO = RegExp.prototype.toString, ZO = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", XO = /^Symbol\((.*)\)(.*)$/;
function JO(e) {
  return e != +e ? "NaN" : e === 0 && 1 / e < 0 ? "-0" : "" + e;
}
function d0(e, t = !1) {
  if (e == null || e === !0 || e === !1) return "" + e;
  const n = typeof e;
  if (n === "number") return JO(e);
  if (n === "string") return t ? `"${e}"` : e;
  if (n === "function") return "[Function " + (e.name || "anonymous") + "]";
  if (n === "symbol") return ZO.call(e).replace(XO, "Symbol($1)");
  const r = WO.call(e).slice(8, -1);
  return r === "Date" ? isNaN(e.getTime()) ? "" + e : e.toISOString(e) : r === "Error" || e instanceof Error ? "[" + YO.call(e) + "]" : r === "RegExp" ? KO.call(e) : null;
}
function _r(e, t) {
  let n = d0(e, t);
  return n !== null ? n : JSON.stringify(e, function(r, a) {
    let i = d0(this[r], t);
    return i !== null ? i : a;
  }, 2);
}
let Un = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: e,
    type: t,
    value: n,
    originalValue: r
  }) => {
    let a = r != null && r !== n, i = `${e} must be a \`${t}\` type, but the final value was: \`${_r(n, !0)}\`` + (a ? ` (cast from the value \`${_r(r, !0)}\`).` : ".");
    return n === null && (i += '\n If "null" is intended as an empty value be sure to mark the schema as `.nullable()`'), i;
  },
  defined: "${path} must be defined"
}, Nt = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, Cn = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, _l = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, wl = {
  isValue: "${path} field must be ${value}"
}, Sl = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
}, Qa = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
};
const QO = Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed: Un,
  string: Nt,
  number: Cn,
  date: _l,
  object: Sl,
  array: Qa,
  boolean: wl
});
var eT = Object.prototype, tT = eT.hasOwnProperty;
function nT(e, t) {
  return e != null && tT.call(e, t);
}
var rT = nT, aT = Array.isArray, nn = aT, iT = typeof En == "object" && En && En.Object === Object && En, d4 = iT, sT = d4, oT = typeof self == "object" && self && self.Object === Object && self, lT = sT || oT || Function("return this")(), rn = lT, uT = rn, cT = uT.Symbol, Mr = cT, f0 = Mr, f4 = Object.prototype, dT = f4.hasOwnProperty, fT = f4.toString, jr = f0 ? f0.toStringTag : void 0;
function pT(e) {
  var t = dT.call(e, jr), n = e[jr];
  try {
    e[jr] = void 0;
    var r = !0;
  } catch {
  }
  var a = fT.call(e);
  return r && (t ? e[jr] = n : delete e[jr]), a;
}
var hT = pT, mT = Object.prototype, vT = mT.toString;
function gT(e) {
  return vT.call(e);
}
var bT = gT, p0 = Mr, $T = hT, yT = bT, xT = "[object Null]", _T = "[object Undefined]", h0 = p0 ? p0.toStringTag : void 0;
function wT(e) {
  return e == null ? e === void 0 ? _T : xT : h0 && h0 in Object(e) ? $T(e) : yT(e);
}
var kr = wT;
function ST(e) {
  return e != null && typeof e == "object";
}
var jn = ST, CT = kr, AT = jn, ET = "[object Symbol]";
function OT(e) {
  return typeof e == "symbol" || AT(e) && CT(e) == ET;
}
var wu = OT, TT = nn, MT = wu, kT = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, LT = /^\w*$/;
function FT(e, t) {
  if (TT(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || MT(e) ? !0 : LT.test(e) || !kT.test(e) || t != null && e in Object(t);
}
var Su = FT;
function zT(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Lr = zT, PT = kr, IT = Lr, NT = "[object AsyncFunction]", DT = "[object Function]", RT = "[object GeneratorFunction]", jT = "[object Proxy]";
function BT(e) {
  if (!IT(e))
    return !1;
  var t = PT(e);
  return t == DT || t == RT || t == NT || t == jT;
}
var p4 = BT, VT = rn, UT = VT["__core-js_shared__"], HT = UT, Es = HT, m0 = function() {
  var e = /[^.]+$/.exec(Es && Es.keys && Es.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function GT(e) {
  return !!m0 && m0 in e;
}
var qT = GT, WT = Function.prototype, YT = WT.toString;
function KT(e) {
  if (e != null) {
    try {
      return YT.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var h4 = KT, ZT = p4, XT = qT, JT = Lr, QT = h4, eM = /[\\^$.*+?()[\]{}|]/g, tM = /^\[object .+?Constructor\]$/, nM = Function.prototype, rM = Object.prototype, aM = nM.toString, iM = rM.hasOwnProperty, sM = RegExp(
  "^" + aM.call(iM).replace(eM, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function oM(e) {
  if (!JT(e) || XT(e))
    return !1;
  var t = ZT(e) ? sM : tM;
  return t.test(QT(e));
}
var lM = oM;
function uM(e, t) {
  return e == null ? void 0 : e[t];
}
var cM = uM, dM = lM, fM = cM;
function pM(e, t) {
  var n = fM(e, t);
  return dM(n) ? n : void 0;
}
var nr = pM, hM = nr, mM = hM(Object, "create"), Vi = mM, v0 = Vi;
function vM() {
  this.__data__ = v0 ? v0(null) : {}, this.size = 0;
}
var gM = vM;
function bM(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var $M = bM, yM = Vi, xM = "__lodash_hash_undefined__", _M = Object.prototype, wM = _M.hasOwnProperty;
function SM(e) {
  var t = this.__data__;
  if (yM) {
    var n = t[e];
    return n === xM ? void 0 : n;
  }
  return wM.call(t, e) ? t[e] : void 0;
}
var CM = SM, AM = Vi, EM = Object.prototype, OM = EM.hasOwnProperty;
function TM(e) {
  var t = this.__data__;
  return AM ? t[e] !== void 0 : OM.call(t, e);
}
var MM = TM, kM = Vi, LM = "__lodash_hash_undefined__";
function FM(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = kM && t === void 0 ? LM : t, this;
}
var zM = FM, PM = gM, IM = $M, NM = CM, DM = MM, RM = zM;
function Fr(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Fr.prototype.clear = PM;
Fr.prototype.delete = IM;
Fr.prototype.get = NM;
Fr.prototype.has = DM;
Fr.prototype.set = RM;
var jM = Fr;
function BM() {
  this.__data__ = [], this.size = 0;
}
var VM = BM;
function UM(e, t) {
  return e === t || e !== e && t !== t;
}
var Cu = UM, HM = Cu;
function GM(e, t) {
  for (var n = e.length; n--; )
    if (HM(e[n][0], t))
      return n;
  return -1;
}
var Ui = GM, qM = Ui, WM = Array.prototype, YM = WM.splice;
function KM(e) {
  var t = this.__data__, n = qM(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : YM.call(t, n, 1), --this.size, !0;
}
var ZM = KM, XM = Ui;
function JM(e) {
  var t = this.__data__, n = XM(t, e);
  return n < 0 ? void 0 : t[n][1];
}
var QM = JM, ek = Ui;
function tk(e) {
  return ek(this.__data__, e) > -1;
}
var nk = tk, rk = Ui;
function ak(e, t) {
  var n = this.__data__, r = rk(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
var ik = ak, sk = VM, ok = ZM, lk = QM, uk = nk, ck = ik;
function zr(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
zr.prototype.clear = sk;
zr.prototype.delete = ok;
zr.prototype.get = lk;
zr.prototype.has = uk;
zr.prototype.set = ck;
var Hi = zr, Os, g0;
function Au() {
  if (g0) return Os;
  g0 = 1;
  var e = nr, t = rn, n = e(t, "Map");
  return Os = n, Os;
}
var b0 = jM, dk = Hi, fk = Au();
function pk() {
  this.size = 0, this.__data__ = {
    hash: new b0(),
    map: new (fk || dk)(),
    string: new b0()
  };
}
var hk = pk;
function mk(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var vk = mk, gk = vk;
function bk(e, t) {
  var n = e.__data__;
  return gk(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
var Gi = bk, $k = Gi;
function yk(e) {
  var t = $k(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var xk = yk, _k = Gi;
function wk(e) {
  return _k(this, e).get(e);
}
var Sk = wk, Ck = Gi;
function Ak(e) {
  return Ck(this, e).has(e);
}
var Ek = Ak, Ok = Gi;
function Tk(e, t) {
  var n = Ok(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
var Mk = Tk, kk = hk, Lk = xk, Fk = Sk, zk = Ek, Pk = Mk;
function Pr(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Pr.prototype.clear = kk;
Pr.prototype.delete = Lk;
Pr.prototype.get = Fk;
Pr.prototype.has = zk;
Pr.prototype.set = Pk;
var Eu = Pr, m4 = Eu, Ik = "Expected a function";
function Ou(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(Ik);
  var n = function() {
    var r = arguments, a = t ? t.apply(this, r) : r[0], i = n.cache;
    if (i.has(a))
      return i.get(a);
    var s = e.apply(this, r);
    return n.cache = i.set(a, s) || i, s;
  };
  return n.cache = new (Ou.Cache || m4)(), n;
}
Ou.Cache = m4;
var Nk = Ou, Dk = Nk, Rk = 500;
function jk(e) {
  var t = Dk(e, function(r) {
    return n.size === Rk && n.clear(), r;
  }), n = t.cache;
  return t;
}
var Bk = jk, Vk = Bk, Uk = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Hk = /\\(\\)?/g, Gk = Vk(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(Uk, function(n, r, a, i) {
    t.push(a ? i.replace(Hk, "$1") : r || n);
  }), t;
}), qk = Gk;
function Wk(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, a = Array(r); ++n < r; )
    a[n] = t(e[n], n, e);
  return a;
}
var v4 = Wk, $0 = Mr, Yk = v4, Kk = nn, Zk = wu, y0 = $0 ? $0.prototype : void 0, x0 = y0 ? y0.toString : void 0;
function g4(e) {
  if (typeof e == "string")
    return e;
  if (Kk(e))
    return Yk(e, g4) + "";
  if (Zk(e))
    return x0 ? x0.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var Xk = g4, Jk = Xk;
function Qk(e) {
  return e == null ? "" : Jk(e);
}
var va = Qk, eL = nn, tL = Su, nL = qk, rL = va;
function aL(e, t) {
  return eL(e) ? e : tL(e, t) ? [e] : nL(rL(e));
}
var b4 = aL, iL = kr, sL = jn, oL = "[object Arguments]";
function lL(e) {
  return sL(e) && iL(e) == oL;
}
var uL = lL, _0 = uL, cL = jn, $4 = Object.prototype, dL = $4.hasOwnProperty, fL = $4.propertyIsEnumerable, pL = _0(/* @__PURE__ */ function() {
  return arguments;
}()) ? _0 : function(e) {
  return cL(e) && dL.call(e, "callee") && !fL.call(e, "callee");
}, y4 = pL, hL = 9007199254740991, mL = /^(?:0|[1-9]\d*)$/;
function vL(e, t) {
  var n = typeof e;
  return t = t ?? hL, !!t && (n == "number" || n != "symbol" && mL.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var x4 = vL, gL = 9007199254740991;
function bL(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= gL;
}
var Tu = bL, $L = wu;
function yL(e) {
  if (typeof e == "string" || $L(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var qi = yL, xL = b4, _L = y4, wL = nn, SL = x4, CL = Tu, AL = qi;
function EL(e, t, n) {
  t = xL(t, e);
  for (var r = -1, a = t.length, i = !1; ++r < a; ) {
    var s = AL(t[r]);
    if (!(i = e != null && n(e, s)))
      break;
    e = e[s];
  }
  return i || ++r != a ? i : (a = e == null ? 0 : e.length, !!a && CL(a) && SL(s, a) && (wL(e) || _L(e)));
}
var _4 = EL, OL = rT, TL = _4;
function ML(e, t) {
  return e != null && TL(e, t, OL);
}
var Wi = ML;
const fi = /* @__PURE__ */ yn(Wi), Yi = (e) => e && e.__isYupSchema__;
let kL = class {
  constructor(t, n) {
    if (this.fn = void 0, this.refs = t, this.refs = t, typeof n == "function") {
      this.fn = n;
      return;
    }
    if (!fi(n, "is")) throw new TypeError("`is:` is required for `when()` conditions");
    if (!n.then && !n.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: r,
      then: a,
      otherwise: i
    } = n, s = typeof r == "function" ? r : (...o) => o.every((l) => l === r);
    this.fn = function(...o) {
      let l = o.pop(), u = o.pop(), c = s(...o) ? a : i;
      if (c)
        return typeof c == "function" ? c(u) : u.concat(c.resolve(l));
    };
  }
  resolve(t, n) {
    let r = this.refs.map((i) => i.getValue(n == null ? void 0 : n.value, n == null ? void 0 : n.parent, n == null ? void 0 : n.context)), a = this.fn.apply(t, r.concat(t, n));
    if (a === void 0 || a === t) return t;
    if (!Yi(a)) throw new TypeError("conditions must return a schema object");
    return a.resolve(n);
  }
};
function w4(e) {
  return e == null ? [] : [].concat(e);
}
function Cl() {
  return Cl = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Cl.apply(this, arguments);
}
let LL = /\$\{\s*(\w+)\s*\}/g, Vt = class Al extends Error {
  static formatError(t, n) {
    const r = n.label || n.path || "this";
    return r !== n.path && (n = Cl({}, n, {
      path: r
    })), typeof t == "string" ? t.replace(LL, (a, i) => _r(n[i])) : typeof t == "function" ? t(n) : t;
  }
  static isError(t) {
    return t && t.name === "ValidationError";
  }
  constructor(t, n, r, a) {
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.errors = void 0, this.params = void 0, this.inner = void 0, this.name = "ValidationError", this.value = n, this.path = r, this.type = a, this.errors = [], this.inner = [], w4(t).forEach((i) => {
      Al.isError(i) ? (this.errors.push(...i.errors), this.inner = this.inner.concat(i.inner.length ? i.inner : i)) : this.errors.push(i);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0], Error.captureStackTrace && Error.captureStackTrace(this, Al);
  }
};
const FL = (e) => {
  let t = !1;
  return (...n) => {
    t || (t = !0, e(...n));
  };
};
function pi(e, t) {
  let {
    endEarly: n,
    tests: r,
    args: a,
    value: i,
    errors: s,
    sort: o,
    path: l
  } = e, u = FL(t), c = r.length;
  const d = [];
  if (s = s || [], !c) return s.length ? u(new Vt(s, i, l)) : u(null, i);
  for (let f = 0; f < r.length; f++) {
    const p = r[f];
    p(a, function(m) {
      if (m) {
        if (!Vt.isError(m))
          return u(m, i);
        if (n)
          return m.value = i, u(m, i);
        d.push(m);
      }
      if (--c <= 0) {
        if (d.length && (o && d.sort(o), s.length && d.push(...s), s = d), s.length) {
          u(new Vt(s, i, l), i);
          return;
        }
        u(null, i);
      }
    });
  }
}
var zL = nr, PL = function() {
  try {
    var e = zL(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), IL = PL, w0 = IL;
function NL(e, t, n) {
  t == "__proto__" && w0 ? w0(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var Ki = NL;
function DL(e) {
  return function(t, n, r) {
    for (var a = -1, i = Object(t), s = r(t), o = s.length; o--; ) {
      var l = s[e ? o : ++a];
      if (n(i[l], l, i) === !1)
        break;
    }
    return t;
  };
}
var RL = DL, jL = RL, BL = jL(), VL = BL;
function UL(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var HL = UL, hi = { exports: {} };
function GL() {
  return !1;
}
var qL = GL;
hi.exports;
(function(e, t) {
  var n = rn, r = qL, a = t && !t.nodeType && t, i = a && !0 && e && !e.nodeType && e, s = i && i.exports === a, o = s ? n.Buffer : void 0, l = o ? o.isBuffer : void 0, u = l || r;
  e.exports = u;
})(hi, hi.exports);
var Mu = hi.exports, WL = kr, YL = Tu, KL = jn, ZL = "[object Arguments]", XL = "[object Array]", JL = "[object Boolean]", QL = "[object Date]", eF = "[object Error]", tF = "[object Function]", nF = "[object Map]", rF = "[object Number]", aF = "[object Object]", iF = "[object RegExp]", sF = "[object Set]", oF = "[object String]", lF = "[object WeakMap]", uF = "[object ArrayBuffer]", cF = "[object DataView]", dF = "[object Float32Array]", fF = "[object Float64Array]", pF = "[object Int8Array]", hF = "[object Int16Array]", mF = "[object Int32Array]", vF = "[object Uint8Array]", gF = "[object Uint8ClampedArray]", bF = "[object Uint16Array]", $F = "[object Uint32Array]", je = {};
je[dF] = je[fF] = je[pF] = je[hF] = je[mF] = je[vF] = je[gF] = je[bF] = je[$F] = !0;
je[ZL] = je[XL] = je[uF] = je[JL] = je[cF] = je[QL] = je[eF] = je[tF] = je[nF] = je[rF] = je[aF] = je[iF] = je[sF] = je[oF] = je[lF] = !1;
function yF(e) {
  return KL(e) && YL(e.length) && !!je[WL(e)];
}
var xF = yF;
function _F(e) {
  return function(t) {
    return e(t);
  };
}
var ku = _F, mi = { exports: {} };
mi.exports;
(function(e, t) {
  var n = d4, r = t && !t.nodeType && t, a = r && !0 && e && !e.nodeType && e, i = a && a.exports === r, s = i && n.process, o = function() {
    try {
      var l = a && a.require && a.require("util").types;
      return l || s && s.binding && s.binding("util");
    } catch {
    }
  }();
  e.exports = o;
})(mi, mi.exports);
var Lu = mi.exports, wF = xF, SF = ku, S0 = Lu, C0 = S0 && S0.isTypedArray, CF = C0 ? SF(C0) : wF, S4 = CF, AF = HL, EF = y4, OF = nn, TF = Mu, MF = x4, kF = S4, LF = Object.prototype, FF = LF.hasOwnProperty;
function zF(e, t) {
  var n = OF(e), r = !n && EF(e), a = !n && !r && TF(e), i = !n && !r && !a && kF(e), s = n || r || a || i, o = s ? AF(e.length, String) : [], l = o.length;
  for (var u in e)
    (t || FF.call(e, u)) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    MF(u, l))) && o.push(u);
  return o;
}
var C4 = zF, PF = Object.prototype;
function IF(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || PF;
  return e === n;
}
var Fu = IF;
function NF(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var A4 = NF, DF = A4, RF = DF(Object.keys, Object), jF = RF, BF = Fu, VF = jF, UF = Object.prototype, HF = UF.hasOwnProperty;
function GF(e) {
  if (!BF(e))
    return VF(e);
  var t = [];
  for (var n in Object(e))
    HF.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
var qF = GF, WF = p4, YF = Tu;
function KF(e) {
  return e != null && YF(e.length) && !WF(e);
}
var zu = KF, ZF = C4, XF = qF, JF = zu;
function QF(e) {
  return JF(e) ? ZF(e) : XF(e);
}
var Ir = QF, ez = VL, tz = Ir;
function nz(e, t) {
  return e && ez(e, t, tz);
}
var E4 = nz, rz = Hi;
function az() {
  this.__data__ = new rz(), this.size = 0;
}
var iz = az;
function sz(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
var oz = sz;
function lz(e) {
  return this.__data__.get(e);
}
var uz = lz;
function cz(e) {
  return this.__data__.has(e);
}
var dz = cz, fz = Hi, pz = Au(), hz = Eu, mz = 200;
function vz(e, t) {
  var n = this.__data__;
  if (n instanceof fz) {
    var r = n.__data__;
    if (!pz || r.length < mz - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new hz(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
var gz = vz, bz = Hi, $z = iz, yz = oz, xz = uz, _z = dz, wz = gz;
function Nr(e) {
  var t = this.__data__ = new bz(e);
  this.size = t.size;
}
Nr.prototype.clear = $z;
Nr.prototype.delete = yz;
Nr.prototype.get = xz;
Nr.prototype.has = _z;
Nr.prototype.set = wz;
var Pu = Nr, Sz = "__lodash_hash_undefined__";
function Cz(e) {
  return this.__data__.set(e, Sz), this;
}
var Az = Cz;
function Ez(e) {
  return this.__data__.has(e);
}
var Oz = Ez, Tz = Eu, Mz = Az, kz = Oz;
function vi(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new Tz(); ++t < n; )
    this.add(e[t]);
}
vi.prototype.add = vi.prototype.push = Mz;
vi.prototype.has = kz;
var Lz = vi;
function Fz(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
var zz = Fz;
function Pz(e, t) {
  return e.has(t);
}
var Iz = Pz, Nz = Lz, Dz = zz, Rz = Iz, jz = 1, Bz = 2;
function Vz(e, t, n, r, a, i) {
  var s = n & jz, o = e.length, l = t.length;
  if (o != l && !(s && l > o))
    return !1;
  var u = i.get(e), c = i.get(t);
  if (u && c)
    return u == t && c == e;
  var d = -1, f = !0, p = n & Bz ? new Nz() : void 0;
  for (i.set(e, t), i.set(t, e); ++d < o; ) {
    var h = e[d], m = t[d];
    if (r)
      var v = s ? r(m, h, d, t, e, i) : r(h, m, d, e, t, i);
    if (v !== void 0) {
      if (v)
        continue;
      f = !1;
      break;
    }
    if (p) {
      if (!Dz(t, function(g, b) {
        if (!Rz(p, b) && (h === g || a(h, g, n, r, i)))
          return p.push(b);
      })) {
        f = !1;
        break;
      }
    } else if (!(h === m || a(h, m, n, r, i))) {
      f = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), f;
}
var O4 = Vz, Uz = rn, Hz = Uz.Uint8Array, T4 = Hz, Ts, A0;
function M4() {
  if (A0) return Ts;
  A0 = 1;
  function e(t) {
    var n = -1, r = Array(t.size);
    return t.forEach(function(a, i) {
      r[++n] = [i, a];
    }), r;
  }
  return Ts = e, Ts;
}
var Ms, E0;
function k4() {
  if (E0) return Ms;
  E0 = 1;
  function e(t) {
    var n = -1, r = Array(t.size);
    return t.forEach(function(a) {
      r[++n] = a;
    }), r;
  }
  return Ms = e, Ms;
}
var O0 = Mr, T0 = T4, Gz = Cu, qz = O4, Wz = M4(), Yz = k4(), Kz = 1, Zz = 2, Xz = "[object Boolean]", Jz = "[object Date]", Qz = "[object Error]", eP = "[object Map]", tP = "[object Number]", nP = "[object RegExp]", rP = "[object Set]", aP = "[object String]", iP = "[object Symbol]", sP = "[object ArrayBuffer]", oP = "[object DataView]", M0 = O0 ? O0.prototype : void 0, ks = M0 ? M0.valueOf : void 0;
function lP(e, t, n, r, a, i, s) {
  switch (n) {
    case oP:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case sP:
      return !(e.byteLength != t.byteLength || !i(new T0(e), new T0(t)));
    case Xz:
    case Jz:
    case tP:
      return Gz(+e, +t);
    case Qz:
      return e.name == t.name && e.message == t.message;
    case nP:
    case aP:
      return e == t + "";
    case eP:
      var o = Wz;
    case rP:
      var l = r & Kz;
      if (o || (o = Yz), e.size != t.size && !l)
        return !1;
      var u = s.get(e);
      if (u)
        return u == t;
      r |= Zz, s.set(e, t);
      var c = qz(o(e), o(t), r, a, i, s);
      return s.delete(e), c;
    case iP:
      if (ks)
        return ks.call(e) == ks.call(t);
  }
  return !1;
}
var uP = lP, Ls, k0;
function L4() {
  if (k0) return Ls;
  k0 = 1;
  function e(t, n) {
    for (var r = -1, a = n.length, i = t.length; ++r < a; )
      t[i + r] = n[r];
    return t;
  }
  return Ls = e, Ls;
}
var Fs, L0;
function F4() {
  if (L0) return Fs;
  L0 = 1;
  var e = L4(), t = nn;
  function n(r, a, i) {
    var s = a(r);
    return t(r) ? s : e(s, i(r));
  }
  return Fs = n, Fs;
}
var zs, F0;
function cP() {
  if (F0) return zs;
  F0 = 1;
  function e(t, n) {
    for (var r = -1, a = t == null ? 0 : t.length, i = 0, s = []; ++r < a; ) {
      var o = t[r];
      n(o, r, t) && (s[i++] = o);
    }
    return s;
  }
  return zs = e, zs;
}
var Ps, z0;
function z4() {
  if (z0) return Ps;
  z0 = 1;
  function e() {
    return [];
  }
  return Ps = e, Ps;
}
var Is, P0;
function Iu() {
  if (P0) return Is;
  P0 = 1;
  var e = cP(), t = z4(), n = Object.prototype, r = n.propertyIsEnumerable, a = Object.getOwnPropertySymbols, i = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(o) {
      return r.call(s, o);
    }));
  } : t;
  return Is = i, Is;
}
var Ns, I0;
function P4() {
  if (I0) return Ns;
  I0 = 1;
  var e = F4(), t = Iu(), n = Ir;
  function r(a) {
    return e(a, n, t);
  }
  return Ns = r, Ns;
}
var N0 = P4(), dP = 1, fP = Object.prototype, pP = fP.hasOwnProperty;
function hP(e, t, n, r, a, i) {
  var s = n & dP, o = N0(e), l = o.length, u = N0(t), c = u.length;
  if (l != c && !s)
    return !1;
  for (var d = l; d--; ) {
    var f = o[d];
    if (!(s ? f in t : pP.call(t, f)))
      return !1;
  }
  var p = i.get(e), h = i.get(t);
  if (p && h)
    return p == t && h == e;
  var m = !0;
  i.set(e, t), i.set(t, e);
  for (var v = s; ++d < l; ) {
    f = o[d];
    var g = e[f], b = t[f];
    if (r)
      var $ = s ? r(b, g, f, t, e, i) : r(g, b, f, e, t, i);
    if (!($ === void 0 ? g === b || a(g, b, n, r, i) : $)) {
      m = !1;
      break;
    }
    v || (v = f == "constructor");
  }
  if (m && !v) {
    var y = e.constructor, A = t.constructor;
    y != A && "constructor" in e && "constructor" in t && !(typeof y == "function" && y instanceof y && typeof A == "function" && A instanceof A) && (m = !1);
  }
  return i.delete(e), i.delete(t), m;
}
var mP = hP, Ds, D0;
function vP() {
  if (D0) return Ds;
  D0 = 1;
  var e = nr, t = rn, n = e(t, "DataView");
  return Ds = n, Ds;
}
var Rs, R0;
function gP() {
  if (R0) return Rs;
  R0 = 1;
  var e = nr, t = rn, n = e(t, "Promise");
  return Rs = n, Rs;
}
var js, j0;
function bP() {
  if (j0) return js;
  j0 = 1;
  var e = nr, t = rn, n = e(t, "Set");
  return js = n, js;
}
var Bs, B0;
function $P() {
  if (B0) return Bs;
  B0 = 1;
  var e = nr, t = rn, n = e(t, "WeakMap");
  return Bs = n, Bs;
}
var Vs, V0;
function ga() {
  if (V0) return Vs;
  V0 = 1;
  var e = vP(), t = Au(), n = gP(), r = bP(), a = $P(), i = kr, s = h4, o = "[object Map]", l = "[object Object]", u = "[object Promise]", c = "[object Set]", d = "[object WeakMap]", f = "[object DataView]", p = s(e), h = s(t), m = s(n), v = s(r), g = s(a), b = i;
  return (e && b(new e(new ArrayBuffer(1))) != f || t && b(new t()) != o || n && b(n.resolve()) != u || r && b(new r()) != c || a && b(new a()) != d) && (b = function($) {
    var y = i($), A = y == l ? $.constructor : void 0, E = A ? s(A) : "";
    if (E)
      switch (E) {
        case p:
          return f;
        case h:
          return o;
        case m:
          return u;
        case v:
          return c;
        case g:
          return d;
      }
    return y;
  }), Vs = b, Vs;
}
var Us = Pu, yP = O4, xP = uP, _P = mP, U0 = ga(), H0 = nn, G0 = Mu, wP = S4, SP = 1, q0 = "[object Arguments]", W0 = "[object Array]", Ma = "[object Object]", CP = Object.prototype, Y0 = CP.hasOwnProperty;
function AP(e, t, n, r, a, i) {
  var s = H0(e), o = H0(t), l = s ? W0 : U0(e), u = o ? W0 : U0(t);
  l = l == q0 ? Ma : l, u = u == q0 ? Ma : u;
  var c = l == Ma, d = u == Ma, f = l == u;
  if (f && G0(e)) {
    if (!G0(t))
      return !1;
    s = !0, c = !1;
  }
  if (f && !c)
    return i || (i = new Us()), s || wP(e) ? yP(e, t, n, r, a, i) : xP(e, t, l, n, r, a, i);
  if (!(n & SP)) {
    var p = c && Y0.call(e, "__wrapped__"), h = d && Y0.call(t, "__wrapped__");
    if (p || h) {
      var m = p ? e.value() : e, v = h ? t.value() : t;
      return i || (i = new Us()), a(m, v, n, r, i);
    }
  }
  return f ? (i || (i = new Us()), _P(e, t, n, r, a, i)) : !1;
}
var EP = AP, OP = EP, K0 = jn;
function I4(e, t, n, r, a) {
  return e === t ? !0 : e == null || t == null || !K0(e) && !K0(t) ? e !== e && t !== t : OP(e, t, n, r, I4, a);
}
var N4 = I4, TP = Pu, MP = N4, kP = 1, LP = 2;
function FP(e, t, n, r) {
  var a = n.length, i = a, s = !r;
  if (e == null)
    return !i;
  for (e = Object(e); a--; ) {
    var o = n[a];
    if (s && o[2] ? o[1] !== e[o[0]] : !(o[0] in e))
      return !1;
  }
  for (; ++a < i; ) {
    o = n[a];
    var l = o[0], u = e[l], c = o[1];
    if (s && o[2]) {
      if (u === void 0 && !(l in e))
        return !1;
    } else {
      var d = new TP();
      if (r)
        var f = r(u, c, l, e, t, d);
      if (!(f === void 0 ? MP(c, u, kP | LP, r, d) : f))
        return !1;
    }
  }
  return !0;
}
var zP = FP, PP = Lr;
function IP(e) {
  return e === e && !PP(e);
}
var D4 = IP, NP = D4, DP = Ir;
function RP(e) {
  for (var t = DP(e), n = t.length; n--; ) {
    var r = t[n], a = e[r];
    t[n] = [r, a, NP(a)];
  }
  return t;
}
var jP = RP;
function BP(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
var R4 = BP, VP = zP, UP = jP, HP = R4;
function GP(e) {
  var t = UP(e);
  return t.length == 1 && t[0][2] ? HP(t[0][0], t[0][1]) : function(n) {
    return n === e || VP(n, e, t);
  };
}
var qP = GP, WP = b4, YP = qi;
function KP(e, t) {
  t = WP(t, e);
  for (var n = 0, r = t.length; e != null && n < r; )
    e = e[YP(t[n++])];
  return n && n == r ? e : void 0;
}
var j4 = KP, ZP = j4;
function XP(e, t, n) {
  var r = e == null ? void 0 : ZP(e, t);
  return r === void 0 ? n : r;
}
var JP = XP;
function QP(e, t) {
  return e != null && t in Object(e);
}
var eI = QP, tI = eI, nI = _4;
function rI(e, t) {
  return e != null && nI(e, t, tI);
}
var aI = rI, iI = N4, sI = JP, oI = aI, lI = Su, uI = D4, cI = R4, dI = qi, fI = 1, pI = 2;
function hI(e, t) {
  return lI(e) && uI(t) ? cI(dI(e), t) : function(n) {
    var r = sI(n, e);
    return r === void 0 && r === t ? oI(n, e) : iI(t, r, fI | pI);
  };
}
var mI = hI;
function vI(e) {
  return e;
}
var gI = vI;
function bI(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var $I = bI, yI = j4;
function xI(e) {
  return function(t) {
    return yI(t, e);
  };
}
var _I = xI, wI = $I, SI = _I, CI = Su, AI = qi;
function EI(e) {
  return CI(e) ? wI(AI(e)) : SI(e);
}
var OI = EI, TI = qP, MI = mI, kI = gI, LI = nn, FI = OI;
function zI(e) {
  return typeof e == "function" ? e : e == null ? kI : typeof e == "object" ? LI(e) ? MI(e[0], e[1]) : TI(e) : FI(e);
}
var B4 = zI, PI = Ki, II = E4, NI = B4;
function DI(e, t) {
  var n = {};
  return t = NI(t), II(e, function(r, a, i) {
    PI(n, a, t(r, a, i));
  }), n;
}
var V4 = DI;
const U4 = /* @__PURE__ */ yn(V4);
function rr(e) {
  this._maxSize = e, this.clear();
}
rr.prototype.clear = function() {
  this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
};
rr.prototype.get = function(e) {
  return this._values[e];
};
rr.prototype.set = function(e, t) {
  return this._size >= this._maxSize && this.clear(), e in this._values || this._size++, this._values[e] = t;
};
var RI = /[^.^\]^[]+|(?=\[\]|\.\.)/g, H4 = /^\d+$/, jI = /^\d/, BI = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, VI = /^\s*(['"]?)(.*?)(\1)\s*$/, Nu = 512, Z0 = new rr(Nu), X0 = new rr(Nu), J0 = new rr(Nu), an = {
  Cache: rr,
  split: El,
  normalizePath: Hs,
  setter: function(e) {
    var t = Hs(e);
    return X0.get(e) || X0.set(e, function(r, a) {
      for (var i = 0, s = t.length, o = r; i < s - 1; ) {
        var l = t[i];
        if (l === "__proto__" || l === "constructor" || l === "prototype")
          return r;
        o = o[t[i++]];
      }
      o[t[i]] = a;
    });
  },
  getter: function(e, t) {
    var n = Hs(e);
    return J0.get(e) || J0.set(e, function(a) {
      for (var i = 0, s = n.length; i < s; )
        if (a != null || !t) a = a[n[i++]];
        else return;
      return a;
    });
  },
  join: function(e) {
    return e.reduce(function(t, n) {
      return t + (Du(n) || H4.test(n) ? "[" + n + "]" : (t ? "." : "") + n);
    }, "");
  },
  forEach: function(e, t, n) {
    UI(Array.isArray(e) ? e : El(e), t, n);
  }
};
function Hs(e) {
  return Z0.get(e) || Z0.set(
    e,
    El(e).map(function(t) {
      return t.replace(VI, "$2");
    })
  );
}
function El(e) {
  return e.match(RI) || [""];
}
function UI(e, t, n) {
  var r = e.length, a, i, s, o;
  for (i = 0; i < r; i++)
    a = e[i], a && (qI(a) && (a = '"' + a + '"'), o = Du(a), s = !o && /^\d+$/.test(a), t.call(n, a, o, s, i, e));
}
function Du(e) {
  return typeof e == "string" && e && ["'", '"'].indexOf(e.charAt(0)) !== -1;
}
function HI(e) {
  return e.match(jI) && !e.match(H4);
}
function GI(e) {
  return BI.test(e);
}
function qI(e) {
  return !Du(e) && (HI(e) || GI(e));
}
const ka = {
  context: "$",
  value: "."
};
let Ln = class {
  constructor(t, n = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof t != "string") throw new TypeError("ref must be a string, got: " + t);
    if (this.key = t.trim(), t === "") throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === ka.context, this.isValue = this.key[0] === ka.value, this.isSibling = !this.isContext && !this.isValue;
    let r = this.isContext ? ka.context : this.isValue ? ka.value : "";
    this.path = this.key.slice(r.length), this.getter = this.path && an.getter(this.path, !0), this.map = n.map;
  }
  getValue(t, n, r) {
    let a = this.isContext ? r : this.isValue ? t : n;
    return this.getter && (a = this.getter(a || {})), this.map && (a = this.map(a)), a;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(t, n) {
    return this.getValue(t, n == null ? void 0 : n.parent, n == null ? void 0 : n.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(t) {
    return t && t.__isYupRef;
  }
};
Ln.prototype.__isYupRef = !0;
function gi() {
  return gi = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, gi.apply(this, arguments);
}
function WI(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function La(e) {
  function t(n, r) {
    let {
      value: a,
      path: i = "",
      label: s,
      options: o,
      originalValue: l,
      sync: u
    } = n, c = WI(n, ["value", "path", "label", "options", "originalValue", "sync"]);
    const {
      name: d,
      test: f,
      params: p,
      message: h
    } = e;
    let {
      parent: m,
      context: v
    } = o;
    function g(E) {
      return Ln.isRef(E) ? E.getValue(a, m, v) : E;
    }
    function b(E = {}) {
      const L = U4(gi({
        value: a,
        originalValue: l,
        label: s,
        path: E.path || i
      }, p, E.params), g), D = new Vt(Vt.formatError(E.message || h, L), a, L.path, E.type || d);
      return D.params = L, D;
    }
    let $ = gi({
      path: i,
      parent: m,
      type: d,
      createError: b,
      resolve: g,
      options: o,
      originalValue: l
    }, c);
    if (!u) {
      try {
        Promise.resolve(f.call($, a, $)).then((E) => {
          Vt.isError(E) ? r(E) : E ? r(null, E) : r(b());
        }).catch(r);
      } catch (E) {
        r(E);
      }
      return;
    }
    let y;
    try {
      var A;
      if (y = f.call($, a, $), typeof ((A = y) == null ? void 0 : A.then) == "function")
        throw new Error(`Validation test of type: "${$.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
    } catch (E) {
      r(E);
      return;
    }
    Vt.isError(y) ? r(y) : y ? r(null, y) : r(b());
  }
  return t.OPTIONS = e, t;
}
let YI = (e) => e.substr(0, e.length - 1).substr(1);
function KI(e, t, n, r = n) {
  let a, i, s;
  return t ? (an.forEach(t, (o, l, u) => {
    let c = l ? YI(o) : o;
    if (e = e.resolve({
      context: r,
      parent: a,
      value: n
    }), e.innerType) {
      let d = u ? parseInt(c, 10) : 0;
      if (n && d >= n.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${o}, in the path: ${t}. because there is no value at that index. `);
      a = n, n = n && n[d], e = e.innerType;
    }
    if (!u) {
      if (!e.fields || !e.fields[c]) throw new Error(`The schema does not contain the path: ${t}. (failed at: ${s} which is a type: "${e._type}")`);
      a = n, n = n && n[c], e = e.fields[c];
    }
    i = c, s = l ? "[" + o + "]" : "." + o;
  }), {
    schema: e,
    parent: a,
    parentPath: i
  }) : {
    parent: a,
    parentPath: t,
    schema: e
  };
}
class bi {
  constructor() {
    this.list = void 0, this.refs = void 0, this.list = /* @__PURE__ */ new Set(), this.refs = /* @__PURE__ */ new Map();
  }
  get size() {
    return this.list.size + this.refs.size;
  }
  describe() {
    const t = [];
    for (const n of this.list) t.push(n);
    for (const [, n] of this.refs) t.push(n.describe());
    return t;
  }
  toArray() {
    return Array.from(this.list).concat(Array.from(this.refs.values()));
  }
  resolveAll(t) {
    return this.toArray().reduce((n, r) => n.concat(Ln.isRef(r) ? t(r) : r), []);
  }
  add(t) {
    Ln.isRef(t) ? this.refs.set(t.key, t) : this.list.add(t);
  }
  delete(t) {
    Ln.isRef(t) ? this.refs.delete(t.key) : this.list.delete(t);
  }
  clone() {
    const t = new bi();
    return t.list = new Set(this.list), t.refs = new Map(this.refs), t;
  }
  merge(t, n) {
    const r = this.clone();
    return t.list.forEach((a) => r.add(a)), t.refs.forEach((a) => r.add(a)), n.list.forEach((a) => r.delete(a)), n.refs.forEach((a) => r.delete(a)), r;
  }
}
function Lt() {
  return Lt = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Lt.apply(this, arguments);
}
class at {
  constructor(t) {
    this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this._typeError = void 0, this._whitelist = new bi(), this._blacklist = new bi(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(Un.notType);
    }), this.type = (t == null ? void 0 : t.type) || "mixed", this.spec = Lt({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      nullable: !1,
      presence: "optional"
    }, t == null ? void 0 : t.spec);
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  _typeCheck(t) {
    return !0;
  }
  clone(t) {
    if (this._mutate)
      return t && Object.assign(this.spec, t), this;
    const n = Object.create(Object.getPrototypeOf(this));
    return n.type = this.type, n._typeError = this._typeError, n._whitelistError = this._whitelistError, n._blacklistError = this._blacklistError, n._whitelist = this._whitelist.clone(), n._blacklist = this._blacklist.clone(), n.exclusiveTests = Lt({}, this.exclusiveTests), n.deps = [...this.deps], n.conditions = [...this.conditions], n.tests = [...this.tests], n.transforms = [...this.transforms], n.spec = xl(Lt({}, this.spec, t)), n;
  }
  label(t) {
    let n = this.clone();
    return n.spec.label = t, n;
  }
  meta(...t) {
    if (t.length === 0) return this.spec.meta;
    let n = this.clone();
    return n.spec.meta = Object.assign(n.spec.meta || {}, t[0]), n;
  }
  // withContext<TContext extends AnyObject>(): BaseSchema<
  //   TCast,
  //   TContext,
  //   TOutput
  // > {
  //   return this as any;
  // }
  withMutation(t) {
    let n = this._mutate;
    this._mutate = !0;
    let r = t(this);
    return this._mutate = n, r;
  }
  concat(t) {
    if (!t || t === this) return this;
    if (t.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${t.type}`);
    let n = this, r = t.clone();
    const a = Lt({}, n.spec, r.spec);
    return r.spec = a, r._typeError || (r._typeError = n._typeError), r._whitelistError || (r._whitelistError = n._whitelistError), r._blacklistError || (r._blacklistError = n._blacklistError), r._whitelist = n._whitelist.merge(t._whitelist, t._blacklist), r._blacklist = n._blacklist.merge(t._blacklist, t._whitelist), r.tests = n.tests, r.exclusiveTests = n.exclusiveTests, r.withMutation((i) => {
      t.tests.forEach((s) => {
        i.test(s.OPTIONS);
      });
    }), r.transforms = [...n.transforms, ...r.transforms], r;
  }
  isType(t) {
    return this.spec.nullable && t === null ? !0 : this._typeCheck(t);
  }
  resolve(t) {
    let n = this;
    if (n.conditions.length) {
      let r = n.conditions;
      n = n.clone(), n.conditions = [], n = r.reduce((a, i) => i.resolve(a, t), n), n = n.resolve(t);
    }
    return n;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */
  cast(t, n = {}) {
    let r = this.resolve(Lt({
      value: t
    }, n)), a = r._cast(t, n);
    if (t !== void 0 && n.assert !== !1 && r.isType(a) !== !0) {
      let i = _r(t), s = _r(a);
      throw new TypeError(`The value of ${n.path || "field"} could not be cast to a value that satisfies the schema type: "${r._type}". 

attempted value: ${i} 
` + (s !== i ? `result of cast: ${s}` : ""));
    }
    return a;
  }
  _cast(t, n) {
    let r = t === void 0 ? t : this.transforms.reduce((a, i) => i.call(this, a, t, this), t);
    return r === void 0 && (r = this.getDefault()), r;
  }
  _validate(t, n = {}, r) {
    let {
      sync: a,
      path: i,
      from: s = [],
      originalValue: o = t,
      strict: l = this.spec.strict,
      abortEarly: u = this.spec.abortEarly
    } = n, c = t;
    l || (c = this._cast(c, Lt({
      assert: !1
    }, n)));
    let d = {
      value: c,
      path: i,
      options: n,
      originalValue: o,
      schema: this,
      label: this.spec.label,
      sync: a,
      from: s
    }, f = [];
    this._typeError && f.push(this._typeError);
    let p = [];
    this._whitelistError && p.push(this._whitelistError), this._blacklistError && p.push(this._blacklistError), pi({
      args: d,
      value: c,
      path: i,
      tests: f,
      endEarly: u
    }, (h) => {
      if (h) return void r(h, c);
      pi({
        tests: this.tests.concat(p),
        args: d,
        path: i,
        sync: a,
        value: c,
        endEarly: u
      }, r);
    });
  }
  validate(t, n, r) {
    let a = this.resolve(Lt({}, n, {
      value: t
    }));
    return typeof r == "function" ? a._validate(t, n, r) : new Promise((i, s) => a._validate(t, n, (o, l) => {
      o ? s(o) : i(l);
    }));
  }
  validateSync(t, n) {
    let r = this.resolve(Lt({}, n, {
      value: t
    })), a;
    return r._validate(t, Lt({}, n, {
      sync: !0
    }), (i, s) => {
      if (i) throw i;
      a = s;
    }), a;
  }
  isValid(t, n) {
    return this.validate(t, n).then(() => !0, (r) => {
      if (Vt.isError(r)) return !1;
      throw r;
    });
  }
  isValidSync(t, n) {
    try {
      return this.validateSync(t, n), !0;
    } catch (r) {
      if (Vt.isError(r)) return !1;
      throw r;
    }
  }
  _getDefault() {
    let t = this.spec.default;
    return t == null ? t : typeof t == "function" ? t.call(this) : xl(t);
  }
  getDefault(t) {
    return this.resolve(t || {})._getDefault();
  }
  default(t) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: t
    });
  }
  strict(t = !0) {
    let n = this.clone();
    return n.spec.strict = t, n;
  }
  _isPresent(t) {
    return t != null;
  }
  defined(t = Un.defined) {
    return this.test({
      message: t,
      name: "defined",
      exclusive: !0,
      test(n) {
        return n !== void 0;
      }
    });
  }
  required(t = Un.required) {
    return this.clone({
      presence: "required"
    }).withMutation((n) => n.test({
      message: t,
      name: "required",
      exclusive: !0,
      test(r) {
        return this.schema._isPresent(r);
      }
    }));
  }
  notRequired() {
    let t = this.clone({
      presence: "optional"
    });
    return t.tests = t.tests.filter((n) => n.OPTIONS.name !== "required"), t;
  }
  nullable(t = !0) {
    return this.clone({
      nullable: t !== !1
    });
  }
  transform(t) {
    let n = this.clone();
    return n.transforms.push(t), n;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...t) {
    let n;
    if (t.length === 1 ? typeof t[0] == "function" ? n = {
      test: t[0]
    } : n = t[0] : t.length === 2 ? n = {
      name: t[0],
      test: t[1]
    } : n = {
      name: t[0],
      message: t[1],
      test: t[2]
    }, n.message === void 0 && (n.message = Un.default), typeof n.test != "function") throw new TypeError("`test` is a required parameters");
    let r = this.clone(), a = La(n), i = n.exclusive || n.name && r.exclusiveTests[n.name] === !0;
    if (n.exclusive && !n.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return n.name && (r.exclusiveTests[n.name] = !!n.exclusive), r.tests = r.tests.filter((s) => !(s.OPTIONS.name === n.name && (i || s.OPTIONS.test === a.OPTIONS.test))), r.tests.push(a), r;
  }
  when(t, n) {
    !Array.isArray(t) && typeof t != "string" && (n = t, t = ".");
    let r = this.clone(), a = w4(t).map((i) => new Ln(i));
    return a.forEach((i) => {
      i.isSibling && r.deps.push(i.key);
    }), r.conditions.push(new kL(a, n)), r;
  }
  typeError(t) {
    let n = this.clone();
    return n._typeError = La({
      message: t,
      name: "typeError",
      test(r) {
        return r !== void 0 && !this.schema.isType(r) ? this.createError({
          params: {
            type: this.schema._type
          }
        }) : !0;
      }
    }), n;
  }
  oneOf(t, n = Un.oneOf) {
    let r = this.clone();
    return t.forEach((a) => {
      r._whitelist.add(a), r._blacklist.delete(a);
    }), r._whitelistError = La({
      message: n,
      name: "oneOf",
      test(a) {
        if (a === void 0) return !0;
        let i = this.schema._whitelist, s = i.resolveAll(this.resolve);
        return s.includes(a) ? !0 : this.createError({
          params: {
            values: i.toArray().join(", "),
            resolved: s
          }
        });
      }
    }), r;
  }
  notOneOf(t, n = Un.notOneOf) {
    let r = this.clone();
    return t.forEach((a) => {
      r._blacklist.add(a), r._whitelist.delete(a);
    }), r._blacklistError = La({
      message: n,
      name: "notOneOf",
      test(a) {
        let i = this.schema._blacklist, s = i.resolveAll(this.resolve);
        return s.includes(a) ? this.createError({
          params: {
            values: i.toArray().join(", "),
            resolved: s
          }
        }) : !0;
      }
    }), r;
  }
  strip(t = !0) {
    let n = this.clone();
    return n.spec.strip = t, n;
  }
  describe() {
    const t = this.clone(), {
      label: n,
      meta: r
    } = t.spec;
    return {
      meta: r,
      label: n,
      type: t.type,
      oneOf: t._whitelist.describe(),
      notOneOf: t._blacklist.describe(),
      tests: t.tests.map((i) => ({
        name: i.OPTIONS.name,
        params: i.OPTIONS.params
      })).filter((i, s, o) => o.findIndex((l) => l.name === i.name) === s)
    };
  }
}
at.prototype.__isYupSchema__ = !0;
for (const e of ["validate", "validateSync"]) at.prototype[`${e}At`] = function(t, n, r = {}) {
  const {
    parent: a,
    parentPath: i,
    schema: s
  } = KI(this, t, n, r.context);
  return s[e](a && a[i], Lt({}, r, {
    parent: a,
    path: t
  }));
};
for (const e of ["equals", "is"]) at.prototype[e] = at.prototype.oneOf;
for (const e of ["not", "nope"]) at.prototype[e] = at.prototype.notOneOf;
at.prototype.optional = at.prototype.notRequired;
const G4 = at;
function Zi() {
  return new G4();
}
Zi.prototype = G4.prototype;
const Ye = (e) => e == null;
function ZI() {
  return new q4();
}
let q4 = class extends at {
  constructor() {
    super({
      type: "boolean"
    }), this.withMutation(() => {
      this.transform(function(t) {
        if (!this.isType(t)) {
          if (/^(true|1)$/i.test(String(t))) return !0;
          if (/^(false|0)$/i.test(String(t))) return !1;
        }
        return t;
      });
    });
  }
  _typeCheck(t) {
    return t instanceof Boolean && (t = t.valueOf()), typeof t == "boolean";
  }
  isTrue(t = wl.isValue) {
    return this.test({
      message: t,
      name: "is-value",
      exclusive: !0,
      params: {
        value: "true"
      },
      test(n) {
        return Ye(n) || n === !0;
      }
    });
  }
  isFalse(t = wl.isValue) {
    return this.test({
      message: t,
      name: "is-value",
      exclusive: !0,
      params: {
        value: "false"
      },
      test(n) {
        return Ye(n) || n === !1;
      }
    });
  }
};
ZI.prototype = q4.prototype;
let XI = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i, JI = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i, QI = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, eN = (e) => Ye(e) || e === e.trim(), tN = {}.toString();
function qt() {
  return new W4();
}
let W4 = class extends at {
  constructor() {
    super({
      type: "string"
    }), this.withMutation(() => {
      this.transform(function(t) {
        if (this.isType(t) || Array.isArray(t)) return t;
        const n = t != null && t.toString ? t.toString() : t;
        return n === tN ? t : n;
      });
    });
  }
  _typeCheck(t) {
    return t instanceof String && (t = t.valueOf()), typeof t == "string";
  }
  _isPresent(t) {
    return super._isPresent(t) && !!t.length;
  }
  length(t, n = Nt.length) {
    return this.test({
      message: n,
      name: "length",
      exclusive: !0,
      params: {
        length: t
      },
      test(r) {
        return Ye(r) || r.length === this.resolve(t);
      }
    });
  }
  min(t, n = Nt.min) {
    return this.test({
      message: n,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(r) {
        return Ye(r) || r.length >= this.resolve(t);
      }
    });
  }
  max(t, n = Nt.max) {
    return this.test({
      name: "max",
      exclusive: !0,
      message: n,
      params: {
        max: t
      },
      test(r) {
        return Ye(r) || r.length <= this.resolve(t);
      }
    });
  }
  matches(t, n) {
    let r = !1, a, i;
    return n && (typeof n == "object" ? {
      excludeEmptyString: r = !1,
      message: a,
      name: i
    } = n : a = n), this.test({
      name: i || "matches",
      message: a || Nt.matches,
      params: {
        regex: t
      },
      test: (s) => Ye(s) || s === "" && r || s.search(t) !== -1
    });
  }
  email(t = Nt.email) {
    return this.matches(XI, {
      name: "email",
      message: t,
      excludeEmptyString: !0
    });
  }
  url(t = Nt.url) {
    return this.matches(JI, {
      name: "url",
      message: t,
      excludeEmptyString: !0
    });
  }
  uuid(t = Nt.uuid) {
    return this.matches(QI, {
      name: "uuid",
      message: t,
      excludeEmptyString: !1
    });
  }
  //-- transforms --
  ensure() {
    return this.default("").transform((t) => t === null ? "" : t);
  }
  trim(t = Nt.trim) {
    return this.transform((n) => n != null ? n.trim() : n).test({
      message: t,
      name: "trim",
      test: eN
    });
  }
  lowercase(t = Nt.lowercase) {
    return this.transform((n) => Ye(n) ? n : n.toLowerCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      test: (n) => Ye(n) || n === n.toLowerCase()
    });
  }
  uppercase(t = Nt.uppercase) {
    return this.transform((n) => Ye(n) ? n : n.toUpperCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      test: (n) => Ye(n) || n === n.toUpperCase()
    });
  }
};
qt.prototype = W4.prototype;
let nN = (e) => e != +e;
function rN() {
  return new Y4();
}
let Y4 = class extends at {
  constructor() {
    super({
      type: "number"
    }), this.withMutation(() => {
      this.transform(function(t) {
        let n = t;
        if (typeof n == "string") {
          if (n = n.replace(/\s/g, ""), n === "") return NaN;
          n = +n;
        }
        return this.isType(n) ? n : parseFloat(n);
      });
    });
  }
  _typeCheck(t) {
    return t instanceof Number && (t = t.valueOf()), typeof t == "number" && !nN(t);
  }
  min(t, n = Cn.min) {
    return this.test({
      message: n,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(r) {
        return Ye(r) || r >= this.resolve(t);
      }
    });
  }
  max(t, n = Cn.max) {
    return this.test({
      message: n,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      test(r) {
        return Ye(r) || r <= this.resolve(t);
      }
    });
  }
  lessThan(t, n = Cn.lessThan) {
    return this.test({
      message: n,
      name: "max",
      exclusive: !0,
      params: {
        less: t
      },
      test(r) {
        return Ye(r) || r < this.resolve(t);
      }
    });
  }
  moreThan(t, n = Cn.moreThan) {
    return this.test({
      message: n,
      name: "min",
      exclusive: !0,
      params: {
        more: t
      },
      test(r) {
        return Ye(r) || r > this.resolve(t);
      }
    });
  }
  positive(t = Cn.positive) {
    return this.moreThan(0, t);
  }
  negative(t = Cn.negative) {
    return this.lessThan(0, t);
  }
  integer(t = Cn.integer) {
    return this.test({
      name: "integer",
      message: t,
      test: (n) => Ye(n) || Number.isInteger(n)
    });
  }
  truncate() {
    return this.transform((t) => Ye(t) ? t : t | 0);
  }
  round(t) {
    var n;
    let r = ["ceil", "floor", "round", "trunc"];
    if (t = ((n = t) == null ? void 0 : n.toLowerCase()) || "round", t === "trunc") return this.truncate();
    if (r.indexOf(t.toLowerCase()) === -1) throw new TypeError("Only valid options for round() are: " + r.join(", "));
    return this.transform((a) => Ye(a) ? a : Math[t](a));
  }
};
rN.prototype = Y4.prototype;
var aN = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function iN(e) {
  var t = [1, 4, 5, 6, 7, 10, 11], n = 0, r, a;
  if (a = aN.exec(e)) {
    for (var i = 0, s; s = t[i]; ++i) a[s] = +a[s] || 0;
    a[2] = (+a[2] || 1) - 1, a[3] = +a[3] || 1, a[7] = a[7] ? String(a[7]).substr(0, 3) : 0, (a[8] === void 0 || a[8] === "") && (a[9] === void 0 || a[9] === "") ? r = +new Date(a[1], a[2], a[3], a[4], a[5], a[6], a[7]) : (a[8] !== "Z" && a[9] !== void 0 && (n = a[10] * 60 + a[11], a[9] === "+" && (n = 0 - n)), r = Date.UTC(a[1], a[2], a[3], a[4], a[5] + n, a[6], a[7]));
  } else r = Date.parse ? Date.parse(e) : NaN;
  return r;
}
let K4 = /* @__PURE__ */ new Date(""), sN = (e) => Object.prototype.toString.call(e) === "[object Date]", oN = class extends at {
  constructor() {
    super({
      type: "date"
    }), this.withMutation(() => {
      this.transform(function(t) {
        return this.isType(t) ? t : (t = iN(t), isNaN(t) ? K4 : new Date(t));
      });
    });
  }
  _typeCheck(t) {
    return sN(t) && !isNaN(t.getTime());
  }
  prepareParam(t, n) {
    let r;
    if (Ln.isRef(t))
      r = t;
    else {
      let a = this.cast(t);
      if (!this._typeCheck(a)) throw new TypeError(`\`${n}\` must be a Date or a value that can be \`cast()\` to a Date`);
      r = a;
    }
    return r;
  }
  min(t, n = _l.min) {
    let r = this.prepareParam(t, "min");
    return this.test({
      message: n,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(a) {
        return Ye(a) || a >= this.resolve(r);
      }
    });
  }
  max(t, n = _l.max) {
    let r = this.prepareParam(t, "max");
    return this.test({
      message: n,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      test(a) {
        return Ye(a) || a <= this.resolve(r);
      }
    });
  }
};
oN.INVALID_DATE = K4;
function lN(e, t, n, r) {
  var a = -1, i = e == null ? 0 : e.length;
  for (r && i && (n = e[++a]); ++a < i; )
    n = t(n, e[a], a, e);
  return n;
}
var uN = lN;
function cN(e) {
  return function(t) {
    return e == null ? void 0 : e[t];
  };
}
var dN = cN, fN = dN, pN = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, hN = fN(pN), mN = hN, vN = mN, gN = va, bN = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, $N = "\\u0300-\\u036f", yN = "\\ufe20-\\ufe2f", xN = "\\u20d0-\\u20ff", _N = $N + yN + xN, wN = "[" + _N + "]", SN = RegExp(wN, "g");
function CN(e) {
  return e = gN(e), e && e.replace(bN, vN).replace(SN, "");
}
var AN = CN, EN = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function ON(e) {
  return e.match(EN) || [];
}
var TN = ON, MN = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function kN(e) {
  return MN.test(e);
}
var LN = kN, Z4 = "\\ud800-\\udfff", FN = "\\u0300-\\u036f", zN = "\\ufe20-\\ufe2f", PN = "\\u20d0-\\u20ff", IN = FN + zN + PN, X4 = "\\u2700-\\u27bf", J4 = "a-z\\xdf-\\xf6\\xf8-\\xff", NN = "\\xac\\xb1\\xd7\\xf7", DN = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", RN = "\\u2000-\\u206f", jN = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Q4 = "A-Z\\xc0-\\xd6\\xd8-\\xde", BN = "\\ufe0e\\ufe0f", e6 = NN + DN + RN + jN, t6 = "['’]", Q0 = "[" + e6 + "]", VN = "[" + IN + "]", n6 = "\\d+", UN = "[" + X4 + "]", r6 = "[" + J4 + "]", a6 = "[^" + Z4 + e6 + n6 + X4 + J4 + Q4 + "]", HN = "\\ud83c[\\udffb-\\udfff]", GN = "(?:" + VN + "|" + HN + ")", qN = "[^" + Z4 + "]", i6 = "(?:\\ud83c[\\udde6-\\uddff]){2}", s6 = "[\\ud800-\\udbff][\\udc00-\\udfff]", cr = "[" + Q4 + "]", WN = "\\u200d", e2 = "(?:" + r6 + "|" + a6 + ")", YN = "(?:" + cr + "|" + a6 + ")", t2 = "(?:" + t6 + "(?:d|ll|m|re|s|t|ve))?", n2 = "(?:" + t6 + "(?:D|LL|M|RE|S|T|VE))?", o6 = GN + "?", l6 = "[" + BN + "]?", KN = "(?:" + WN + "(?:" + [qN, i6, s6].join("|") + ")" + l6 + o6 + ")*", ZN = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", XN = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", JN = l6 + o6 + KN, QN = "(?:" + [UN, i6, s6].join("|") + ")" + JN, eD = RegExp([
  cr + "?" + r6 + "+" + t2 + "(?=" + [Q0, cr, "$"].join("|") + ")",
  YN + "+" + n2 + "(?=" + [Q0, cr + e2, "$"].join("|") + ")",
  cr + "?" + e2 + "+" + t2,
  cr + "+" + n2,
  XN,
  ZN,
  n6,
  QN
].join("|"), "g");
function tD(e) {
  return e.match(eD) || [];
}
var nD = tD, rD = TN, aD = LN, iD = va, sD = nD;
function oD(e, t, n) {
  return e = iD(e), t = n ? void 0 : t, t === void 0 ? aD(e) ? sD(e) : rD(e) : e.match(t) || [];
}
var lD = oD, uD = uN, cD = AN, dD = lD, fD = "['’]", pD = RegExp(fD, "g");
function hD(e) {
  return function(t) {
    return uD(dD(cD(t).replace(pD, "")), e, "");
  };
}
var u6 = hD, mD = u6, vD = mD(function(e, t, n) {
  return e + (n ? "_" : "") + t.toLowerCase();
}), gD = vD;
const r2 = /* @__PURE__ */ yn(gD);
function bD(e, t, n) {
  var r = -1, a = e.length;
  t < 0 && (t = -t > a ? 0 : a + t), n = n > a ? a : n, n < 0 && (n += a), a = t > n ? 0 : n - t >>> 0, t >>>= 0;
  for (var i = Array(a); ++r < a; )
    i[r] = e[r + t];
  return i;
}
var $D = bD, yD = $D;
function xD(e, t, n) {
  var r = e.length;
  return n = n === void 0 ? r : n, !t && n >= r ? e : yD(e, t, n);
}
var _D = xD, wD = "\\ud800-\\udfff", SD = "\\u0300-\\u036f", CD = "\\ufe20-\\ufe2f", AD = "\\u20d0-\\u20ff", ED = SD + CD + AD, OD = "\\ufe0e\\ufe0f", TD = "\\u200d", MD = RegExp("[" + TD + wD + ED + OD + "]");
function kD(e) {
  return MD.test(e);
}
var c6 = kD;
function LD(e) {
  return e.split("");
}
var FD = LD, d6 = "\\ud800-\\udfff", zD = "\\u0300-\\u036f", PD = "\\ufe20-\\ufe2f", ID = "\\u20d0-\\u20ff", ND = zD + PD + ID, DD = "\\ufe0e\\ufe0f", RD = "[" + d6 + "]", Ol = "[" + ND + "]", Tl = "\\ud83c[\\udffb-\\udfff]", jD = "(?:" + Ol + "|" + Tl + ")", f6 = "[^" + d6 + "]", p6 = "(?:\\ud83c[\\udde6-\\uddff]){2}", h6 = "[\\ud800-\\udbff][\\udc00-\\udfff]", BD = "\\u200d", m6 = jD + "?", v6 = "[" + DD + "]?", VD = "(?:" + BD + "(?:" + [f6, p6, h6].join("|") + ")" + v6 + m6 + ")*", UD = v6 + m6 + VD, HD = "(?:" + [f6 + Ol + "?", Ol, p6, h6, RD].join("|") + ")", GD = RegExp(Tl + "(?=" + Tl + ")|" + HD + UD, "g");
function qD(e) {
  return e.match(GD) || [];
}
var WD = qD, YD = FD, KD = c6, ZD = WD;
function XD(e) {
  return KD(e) ? ZD(e) : YD(e);
}
var g6 = XD, JD = _D, QD = c6, eR = g6, tR = va;
function nR(e) {
  return function(t) {
    t = tR(t);
    var n = QD(t) ? eR(t) : void 0, r = n ? n[0] : t.charAt(0), a = n ? JD(n, 1).join("") : t.slice(1);
    return r[e]() + a;
  };
}
var rR = nR, aR = rR, iR = aR("toUpperCase"), sR = iR, oR = va, lR = sR;
function uR(e) {
  return lR(oR(e).toLowerCase());
}
var cR = uR, dR = cR, fR = u6, pR = fR(function(e, t, n) {
  return t = t.toLowerCase(), e + (n ? dR(t) : t);
}), hR = pR;
const mR = /* @__PURE__ */ yn(hR);
var vR = Ki, gR = E4, bR = B4;
function $R(e, t) {
  var n = {};
  return t = bR(t), gR(e, function(r, a, i) {
    vR(n, t(r, a, i), r);
  }), n;
}
var yR = $R;
const xR = /* @__PURE__ */ yn(yR);
var Ru = { exports: {} };
Ru.exports = function(e) {
  return b6(_R(e), e);
};
Ru.exports.array = b6;
function b6(e, t) {
  var n = e.length, r = new Array(n), a = {}, i = n, s = wR(t), o = SR(e);
  for (t.forEach(function(u) {
    if (!o.has(u[0]) || !o.has(u[1]))
      throw new Error("Unknown node. There is an unknown node in the supplied edges.");
  }); i--; )
    a[i] || l(e[i], i, /* @__PURE__ */ new Set());
  return r;
  function l(u, c, d) {
    if (d.has(u)) {
      var f;
      try {
        f = ", node was:" + JSON.stringify(u);
      } catch {
        f = "";
      }
      throw new Error("Cyclic dependency" + f);
    }
    if (!o.has(u))
      throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(u));
    if (!a[c]) {
      a[c] = !0;
      var p = s.get(u) || /* @__PURE__ */ new Set();
      if (p = Array.from(p), c = p.length) {
        d.add(u);
        do {
          var h = p[--c];
          l(h, o.get(h), d);
        } while (c);
        d.delete(u);
      }
      r[--n] = u;
    }
  }
}
function _R(e) {
  for (var t = /* @__PURE__ */ new Set(), n = 0, r = e.length; n < r; n++) {
    var a = e[n];
    t.add(a[0]), t.add(a[1]);
  }
  return Array.from(t);
}
function wR(e) {
  for (var t = /* @__PURE__ */ new Map(), n = 0, r = e.length; n < r; n++) {
    var a = e[n];
    t.has(a[0]) || t.set(a[0], /* @__PURE__ */ new Set()), t.has(a[1]) || t.set(a[1], /* @__PURE__ */ new Set()), t.get(a[0]).add(a[1]);
  }
  return t;
}
function SR(e) {
  for (var t = /* @__PURE__ */ new Map(), n = 0, r = e.length; n < r; n++)
    t.set(e[n], n);
  return t;
}
var CR = Ru.exports;
const $6 = /* @__PURE__ */ yn(CR);
function AR(e, t = []) {
  let n = [], r = /* @__PURE__ */ new Set(), a = new Set(t.map(([s, o]) => `${s}-${o}`));
  function i(s, o) {
    let l = an.split(s)[0];
    r.add(l), a.has(`${o}-${l}`) || n.push([o, l]);
  }
  for (const s in e) if (fi(e, s)) {
    let o = e[s];
    r.add(s), Ln.isRef(o) && o.isSibling ? i(o.path, s) : Yi(o) && "deps" in o && o.deps.forEach((l) => i(l, s));
  }
  return $6.array(Array.from(r), n).reverse();
}
function a2(e, t) {
  let n = 1 / 0;
  return e.some((r, a) => {
    var i;
    if (((i = t.path) == null ? void 0 : i.indexOf(r)) !== -1)
      return n = a, !0;
  }), n;
}
function y6(e) {
  return (t, n) => a2(e, t) - a2(e, n);
}
function hr() {
  return hr = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, hr.apply(this, arguments);
}
let i2 = (e) => Object.prototype.toString.call(e) === "[object Object]";
function ER(e, t) {
  let n = Object.keys(e.fields);
  return Object.keys(t).filter((r) => n.indexOf(r) === -1);
}
const OR = y6([]);
let x6 = class extends at {
  constructor(t) {
    super({
      type: "object"
    }), this.fields = /* @__PURE__ */ Object.create(null), this._sortErrors = OR, this._nodes = [], this._excludedEdges = [], this.withMutation(() => {
      this.transform(function(r) {
        if (typeof r == "string")
          try {
            r = JSON.parse(r);
          } catch {
            r = null;
          }
        return this.isType(r) ? r : null;
      }), t && this.shape(t);
    });
  }
  _typeCheck(t) {
    return i2(t) || typeof t == "function";
  }
  _cast(t, n = {}) {
    var r;
    let a = super._cast(t, n);
    if (a === void 0) return this.getDefault();
    if (!this._typeCheck(a)) return a;
    let i = this.fields, s = (r = n.stripUnknown) != null ? r : this.spec.noUnknown, o = this._nodes.concat(Object.keys(a).filter((d) => this._nodes.indexOf(d) === -1)), l = {}, u = hr({}, n, {
      parent: l,
      __validating: n.__validating || !1
    }), c = !1;
    for (const d of o) {
      let f = i[d], p = fi(a, d);
      if (f) {
        let h, m = a[d];
        u.path = (n.path ? `${n.path}.` : "") + d, f = f.resolve({
          value: m,
          context: n.context,
          parent: l
        });
        let v = "spec" in f ? f.spec : void 0, g = v == null ? void 0 : v.strict;
        if (v != null && v.strip) {
          c = c || d in a;
          continue;
        }
        h = !n.__validating || !g ? (
          // TODO: use _cast, this is double resolving
          f.cast(a[d], u)
        ) : a[d], h !== void 0 && (l[d] = h);
      } else p && !s && (l[d] = a[d]);
      l[d] !== a[d] && (c = !0);
    }
    return c ? l : a;
  }
  _validate(t, n = {}, r) {
    let a = [], {
      sync: i,
      from: s = [],
      originalValue: o = t,
      abortEarly: l = this.spec.abortEarly,
      recursive: u = this.spec.recursive
    } = n;
    s = [{
      schema: this,
      value: o
    }, ...s], n.__validating = !0, n.originalValue = o, n.from = s, super._validate(t, n, (c, d) => {
      if (c) {
        if (!Vt.isError(c) || l)
          return void r(c, d);
        a.push(c);
      }
      if (!u || !i2(d)) {
        r(a[0] || null, d);
        return;
      }
      o = o || d;
      let f = this._nodes.map((p) => (h, m) => {
        let v = p.indexOf(".") === -1 ? (n.path ? `${n.path}.` : "") + p : `${n.path || ""}["${p}"]`, g = this.fields[p];
        if (g && "validate" in g) {
          g.validate(d[p], hr({}, n, {
            // @ts-ignore
            path: v,
            from: s,
            // inner fields are always strict:
            // 1. this isn't strict so the casting will also have cast inner values
            // 2. this is strict in which case the nested values weren't cast either
            strict: !0,
            parent: d,
            originalValue: o[p]
          }), m);
          return;
        }
        m(null);
      });
      pi({
        tests: f,
        value: d,
        errors: a,
        endEarly: l,
        sort: this._sortErrors,
        path: n.path
      }, r);
    });
  }
  clone(t) {
    const n = super.clone(t);
    return n.fields = hr({}, this.fields), n._nodes = this._nodes, n._excludedEdges = this._excludedEdges, n._sortErrors = this._sortErrors, n;
  }
  concat(t) {
    let n = super.concat(t), r = n.fields;
    for (let [a, i] of Object.entries(this.fields)) {
      const s = r[a];
      s === void 0 ? r[a] = i : s instanceof at && i instanceof at && (r[a] = i.concat(s));
    }
    return n.withMutation(() => n.shape(r, this._excludedEdges));
  }
  getDefaultFromShape() {
    let t = {};
    return this._nodes.forEach((n) => {
      const r = this.fields[n];
      t[n] = "default" in r ? r.getDefault() : void 0;
    }), t;
  }
  _getDefault() {
    if ("default" in this.spec)
      return super._getDefault();
    if (this._nodes.length)
      return this.getDefaultFromShape();
  }
  shape(t, n = []) {
    let r = this.clone(), a = Object.assign(r.fields, t);
    return r.fields = a, r._sortErrors = y6(Object.keys(a)), n.length && (Array.isArray(n[0]) || (n = [n]), r._excludedEdges = [...r._excludedEdges, ...n]), r._nodes = AR(a, r._excludedEdges), r;
  }
  pick(t) {
    const n = {};
    for (const r of t)
      this.fields[r] && (n[r] = this.fields[r]);
    return this.clone().withMutation((r) => (r.fields = {}, r.shape(n)));
  }
  omit(t) {
    const n = this.clone(), r = n.fields;
    n.fields = {};
    for (const a of t)
      delete r[a];
    return n.withMutation(() => n.shape(r));
  }
  from(t, n, r) {
    let a = an.getter(t, !0);
    return this.transform((i) => {
      if (i == null) return i;
      let s = i;
      return fi(i, t) && (s = hr({}, i), r || delete s[t], s[n] = a(i)), s;
    });
  }
  noUnknown(t = !0, n = Sl.noUnknown) {
    typeof t == "string" && (n = t, t = !0);
    let r = this.test({
      name: "noUnknown",
      exclusive: !0,
      message: n,
      test(a) {
        if (a == null) return !0;
        const i = ER(this.schema, a);
        return !t || i.length === 0 || this.createError({
          params: {
            unknown: i.join(", ")
          }
        });
      }
    });
    return r.spec.noUnknown = t, r;
  }
  unknown(t = !0, n = Sl.noUnknown) {
    return this.noUnknown(!t, n);
  }
  transformKeys(t) {
    return this.transform((n) => n && xR(n, (r, a) => t(a)));
  }
  camelCase() {
    return this.transformKeys(mR);
  }
  snakeCase() {
    return this.transformKeys(r2);
  }
  constantCase() {
    return this.transformKeys((t) => r2(t).toUpperCase());
  }
  describe() {
    let t = super.describe();
    return t.fields = U4(this.fields, (n) => n.describe()), t;
  }
};
function _6(e) {
  return new x6(e);
}
_6.prototype = x6.prototype;
function $i() {
  return $i = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, $i.apply(this, arguments);
}
function TR(e) {
  return new w6(e);
}
let w6 = class extends at {
  constructor(t) {
    super({
      type: "array"
    }), this.innerType = void 0, this.innerType = t, this.withMutation(() => {
      this.transform(function(n) {
        if (typeof n == "string") try {
          n = JSON.parse(n);
        } catch {
          n = null;
        }
        return this.isType(n) ? n : null;
      });
    });
  }
  _typeCheck(t) {
    return Array.isArray(t);
  }
  get _subType() {
    return this.innerType;
  }
  _cast(t, n) {
    const r = super._cast(t, n);
    if (!this._typeCheck(r) || !this.innerType) return r;
    let a = !1;
    const i = r.map((s, o) => {
      const l = this.innerType.cast(s, $i({}, n, {
        path: `${n.path || ""}[${o}]`
      }));
      return l !== s && (a = !0), l;
    });
    return a ? i : r;
  }
  _validate(t, n = {}, r) {
    var a, i;
    let s = [];
    n.sync;
    let o = n.path, l = this.innerType, u = (a = n.abortEarly) != null ? a : this.spec.abortEarly, c = (i = n.recursive) != null ? i : this.spec.recursive, d = n.originalValue != null ? n.originalValue : t;
    super._validate(t, n, (f, p) => {
      if (f) {
        if (!Vt.isError(f) || u)
          return void r(f, p);
        s.push(f);
      }
      if (!c || !l || !this._typeCheck(p)) {
        r(s[0] || null, p);
        return;
      }
      d = d || p;
      let h = new Array(p.length);
      for (let m = 0; m < p.length; m++) {
        let v = p[m], g = `${n.path || ""}[${m}]`, b = $i({}, n, {
          path: g,
          strict: !0,
          parent: p,
          index: m,
          originalValue: d[m]
        });
        h[m] = ($, y) => l.validate(v, b, y);
      }
      pi({
        path: o,
        value: p,
        errors: s,
        endEarly: u,
        tests: h
      }, r);
    });
  }
  clone(t) {
    const n = super.clone(t);
    return n.innerType = this.innerType, n;
  }
  concat(t) {
    let n = super.concat(t);
    return n.innerType = this.innerType, t.innerType && (n.innerType = n.innerType ? (
      // @ts-expect-error Lazy doesn't have concat()
      n.innerType.concat(t.innerType)
    ) : t.innerType), n;
  }
  of(t) {
    let n = this.clone();
    if (!Yi(t)) throw new TypeError("`array.of()` sub-schema must be a valid yup schema not: " + _r(t));
    return n.innerType = t, n;
  }
  length(t, n = Qa.length) {
    return this.test({
      message: n,
      name: "length",
      exclusive: !0,
      params: {
        length: t
      },
      test(r) {
        return Ye(r) || r.length === this.resolve(t);
      }
    });
  }
  min(t, n) {
    return n = n || Qa.min, this.test({
      message: n,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      // FIXME(ts): Array<typeof T>
      test(r) {
        return Ye(r) || r.length >= this.resolve(t);
      }
    });
  }
  max(t, n) {
    return n = n || Qa.max, this.test({
      message: n,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      test(r) {
        return Ye(r) || r.length <= this.resolve(t);
      }
    });
  }
  ensure() {
    return this.default(() => []).transform((t, n) => this._typeCheck(t) ? t : n == null ? [] : [].concat(n));
  }
  compact(t) {
    let n = t ? (r, a, i) => !t(r, a, i) : (r) => !!r;
    return this.transform((r) => r != null ? r.filter(n) : r);
  }
  describe() {
    let t = super.describe();
    return this.innerType && (t.innerType = this.innerType.describe()), t;
  }
  nullable(t = !0) {
    return super.nullable(t);
  }
  defined() {
    return super.defined();
  }
  required(t) {
    return super.required(t);
  }
};
TR.prototype = w6.prototype;
function MR(e) {
  Object.keys(e).forEach((t) => {
    Object.keys(e[t]).forEach((n) => {
      QO[t][n] = e[t][n];
    });
  });
}
function Yt(e, t, n) {
  if (!e || !Yi(e.prototype)) throw new TypeError("You must provide a yup schema constructor function");
  if (typeof t != "string") throw new TypeError("A Method name must be provided");
  if (typeof n != "function") throw new TypeError("Method function must be provided");
  e.prototype[t] = n;
}
const kR = { key: 1 }, LR = { class: "mb-3 font-semibold" }, FR = {
  key: 0,
  class: "max-w-[380px] w-fit"
}, zR = {
  key: 1,
  class: "max-w-[380px] mb-4"
}, PR = /* @__PURE__ */ re({
  __name: "CallMeBack",
  props: {
    modelValue: {},
    isFetching: { type: Boolean },
    isCompleted: { type: Boolean, default: !1 },
    availableOptions: { default: void 0 },
    message: { default: "Laat hieronder uw gegevens achter zodat wij contact met u kunnen opnemen." },
    nameLabel: { default: "Uw naam:" },
    phoneLabel: { default: "Bel mij terug op:" },
    pickDateLabel: { default: "Kies datum:" },
    pickTimeLabel: { default: "Kies tijd:" },
    buttonLabel: { default: "Bel mij terug" },
    summaryMessage: { default: "Beste {name}, hartelijk dank voor uw terugbelverzoek." },
    summaryPhoneLabel: { default: "Telefoonnummer" },
    summaryDateLabel: { default: "Datum" },
    summaryTimeLabel: { default: "Tijd" },
    summaryTime: { default: "" },
    nameRequiredLabel: { default: "Naam is een verplicht veld" },
    phoneRequiredLabel: { default: "Telefoonnummer is verplicht" },
    phoneInvalidLabel: { default: "Geen geldig telefoonnummer" },
    locale: { default: "nl" }
  },
  emits: ["closeModal", "createCallBack"],
  setup(e, { emit: t }) {
    G.locale("nl"), G.extend(Pi);
    const n = e, r = t, a = of(), i = G().utcOffset(nu), s = P(() => n.availableOptions ? [...n.availableOptions.map((h) => h.date)] : null), o = Fn({
      name: n.modelValue ? n.modelValue.name : "",
      phone: n.modelValue ? n.modelValue.phone : "",
      callback_date: n.modelValue ? n.modelValue.callback_date : "",
      callback_time: n.modelValue ? n.modelValue.callback_time : "",
      via: a ? a.meta.callMeBack : ""
    }), l = P(() => i.day() >= 1 && i.day() <= 5), u = P(() => l.value && (i.hour() > 8 || i.hour() === 8 && i.minute() >= 30) && (i.hour() < 17 || i.hour() === 17 && i.minute() <= 15)), c = P(() => {
      var h;
      return n.availableOptions && o.callback_date ? (h = n.availableOptions.find((m) => m.date === o.callback_date)) == null ? void 0 : h.times : null;
    }), d = P(() => {
      var h, m;
      return !n.availableOptions || !o.callback_date || !o.callback_time ? !0 : ((h = n.availableOptions.map((v) => v.date)) == null ? void 0 : h.includes(o.callback_date)) && ((m = n.availableOptions.find((v) => v.date === o.callback_date)) == null ? void 0 : m.times.includes(o.callback_time));
    }), f = (h) => {
      var m;
      o.callback_date = h, n.availableOptions && (o.callback_time = ((m = c.value) == null ? void 0 : m[0]) ?? "08:30");
    }, p = P(() => ({
      validation: _6().shape({
        name: qt().required(n.nameRequiredLabel),
        phone: qt().required(n.phoneRequiredLabel).matches(sb, n.phoneInvalidLabel)
      })
    }));
    return Ue(() => {
      var h;
      s.value && (o.callback_date = s.value[0], o.callback_time = ((h = c.value) == null ? void 0 : h[0]) ?? "08:30");
    }), (h, m) => h.isCompleted ? (C(), ve(PO, {
      key: 0,
      callback: o,
      message: n.summaryMessage,
      "phone-label": n.summaryPhoneLabel,
      "date-label": n.summaryDateLabel,
      "time-label": n.summaryTimeLabel,
      time: n.summaryTime,
      locale: n.locale
    }, null, 8, ["callback", "message", "phone-label", "date-label", "time-label", "time", "locale"])) : (C(), T("div", kR, [
      S("p", LR, H(h.message), 1),
      U(R3, {
        class: "mb-2 flex flex-col",
        schema: p.value,
        "button-text": n.buttonLabel,
        "button-theme": "primary",
        "is-active": d.value,
        loading: h.isFetching,
        onSubmit: m[3] || (m[3] = (v) => {
          r("createCallBack", o);
        })
      }, {
        default: fe(() => [
          U(ui, {
            modelValue: o.name,
            "onUpdate:modelValue": m[0] || (m[0] = (v) => o.name = v),
            name: "name",
            autocomplete: "name",
            label: n.nameLabel,
            "validate-on-value-update": !0
          }, null, 8, ["modelValue", "label"]),
          U(ui, {
            modelValue: o.phone,
            "onUpdate:modelValue": m[1] || (m[1] = (v) => o.phone = v),
            name: "phone",
            type: "tel",
            autocomplete: "tel",
            label: n.phoneLabel,
            "validate-on-value-update": !0
          }, {
            "icon-start": fe(() => [
              U(x(te), { icon: ["fad", "phone"] })
            ]),
            _: 1
          }, 8, ["modelValue", "label"]),
          !u.value || !l.value ? (C(), T("div", FR, [
            (C(), ve(E3, {
              key: o.callback_date,
              name: "date-picker",
              label: n.pickDateLabel,
              inline: !1,
              "model-value": o.callback_date ? o.callback_date : x(i).format("DD-MM-YYYY"),
              "available-dates": s.value,
              locale: h.locale,
              "onUpdate:modelValue": f
            }, null, 8, ["label", "model-value", "available-dates", "locale"]))
          ])) : K("", !0),
          !u.value || !l.value ? (C(), T("div", zR, [
            (C(), ve(u4, {
              key: o.callback_date,
              "model-value": o.callback_time,
              inline: "",
              "available-times": c.value,
              label: n.pickTimeLabel,
              "onUpdate:modelValue": m[2] || (m[2] = (v) => o.callback_time = v)
            }, null, 8, ["model-value", "available-times", "label"]))
          ])) : K("", !0)
        ]),
        _: 1
      }, 8, ["schema", "button-text", "is-active", "loading"])
    ]));
  }
}), IR = ["aria-labelledby"], NR = ["id"], DR = { class: "flex gap-x-2" }, RR = /* @__PURE__ */ re({
  __name: "Document",
  props: {
    document: {}
  },
  emits: ["download"],
  setup(e) {
    return (t, n) => (C(), T("div", {
      class: "w-full grid grid-cols-[min-content_auto_min-content] grid-rows-1 border border-blue-500 rounded-2xl px-6 py-7 items-center mb-4",
      role: "group",
      "aria-labelledby": `document-${t.document.id}`
    }, [
      U(x(te), {
        icon: ["fas", "file"],
        size: "3x",
        class: "mr-4 text-blue-700",
        "aria-hidden": "true"
      }),
      S("p", {
        id: `document-${t.document.id}`,
        class: "truncate pr-4"
      }, H(t.document.name ?? t.document.filename), 9, NR),
      S("div", DR, [
        U(St, {
          "data-test-id": `document-${t.document.id}`,
          title: "Download",
          type: "secondary",
          color: "blue",
          "is-icon": "",
          class: "size-12",
          onClick: n[0] || (n[0] = (r) => t.$emit("download"))
        }, {
          default: fe(() => [
            U(x(te), {
              icon: ["fas", "eye"],
              size: "1x",
              "aria-hidden": "true"
            })
          ]),
          _: 1
        }, 8, ["data-test-id"])
      ])
    ], 8, IR));
  }
}), jR = { class: "flex border border-blue-500 rounded-2xl px-6 py-7 mb-4 gap-4 justify-between bg-white" }, BR = { class: "truncate overflow-hidden lg:max-w-40 2xl:max-w-none" }, VR = { class: "text-gray-700 truncate text-sm" }, UR = {
  key: 0,
  class: "flex flex-row items-center gap-x-2"
}, HR = /* @__PURE__ */ re({
  __name: "Record",
  props: {
    record: {},
    deletable: { type: Boolean, default: !1 },
    downloadable: { type: Boolean, default: !1 }
  },
  emits: ["download", "delete"],
  setup(e, { emit: t }) {
    const n = t, r = () => n("delete");
    return (a, i) => (C(), T("div", jR, [
      U(x(te), {
        icon: ["fas", "file"],
        size: "3x",
        class: z(["text-blue-700", { "blur-sm": !a.downloadable }])
      }, null, 8, ["class"]),
      S("div", {
        class: z(["truncate overflow-hidden flex-1", [
          { "blur-sm": !a.downloadable }
        ]])
      }, [
        S("p", BR, H(a.downloadable ? a.record.name ?? a.record.filename : "placeholder naam"), 1),
        S("p", VR, H(a.downloadable ? `${a.record.asset.extension} - ${a.record.asset.filesize.human}` : "extension"), 1)
      ], 2),
      a.deletable || a.downloadable && a.record.asset.absolute_url ? (C(), T("div", UR, [
        a.downloadable && a.record.asset.absolute_url ? (C(), ve(St, {
          key: 0,
          "data-test-id": `document-download-${a.record.id}`,
          title: "Download",
          type: "secondary",
          "is-icon": "",
          color: "blue",
          onClick: i[0] || (i[0] = (s) => a.$emit("download"))
        }, {
          default: fe(() => [
            U(x(te), {
              icon: ["fas", "file-arrow-down"],
              size: "1x"
            })
          ]),
          _: 1
        }, 8, ["data-test-id"])) : K("", !0),
        a.deletable ? (C(), ve(St, {
          key: 1,
          "data-test-id": `document-delete-${a.record.id}`,
          title: "Verwijder",
          type: "secondary",
          "is-icon": "",
          color: "blue",
          onClick: i[1] || (i[1] = (s) => r())
        }, {
          default: fe(() => [
            U(x(te), {
              icon: ["fas", "trash-can"],
              size: "1x"
            })
          ]),
          _: 1
        }, 8, ["data-test-id"])) : K("", !0)
      ])) : K("", !0)
    ]));
  }
}), GR = /* @__PURE__ */ re({
  __name: "SlideDown",
  props: {
    isActive: { type: Boolean, default: !1 },
    duration: { default: "300" }
  },
  setup(e) {
    const t = e, n = N(t.isActive), r = P(() => ({
      "overflow-visible": n.value,
      "overflow-hidden": !n.value
    }));
    return De(() => t.isActive, () => {
      t.isActive ? setTimeout(() => {
        n.value = !0;
      }, Number(t.duration)) : n.value = !1;
    }), (a, i) => (C(), T("div", {
      "data-test-id": "slide-down",
      class: z(["grid transition-all ease-in-out", {
        "!grid-rows-[1fr]": a.isActive,
        "!grid-rows-[0fr]": !a.isActive,
        "duration-150": a.duration === "150",
        "duration-300": a.duration === "300"
      }])
    }, [
      S("div", zn({ class: r.value }, a.$attrs), [
        Ce(a.$slots, "default")
      ], 16)
    ], 2));
  }
}), qR = (e, t) => {
  const n = document.createElement("script");
  n.setAttribute("type", "text/javascript"), n.src = e, t && n.addEventListener("load", t), document.head.append(n);
}, gY = (e) => {
  const t = document.createElement("link");
  t.setAttribute("rel", "stylesheet"), t.setAttribute("type", "text/css"), t.setAttribute("href", e), document.head.append(t);
}, WR = "https://sdk.onfido.com/v14.39", YR = /* @__PURE__ */ re({
  __name: "Onfido",
  props: {
    sdkToken: {},
    workflowId: {},
    isModal: { type: Boolean, default: !1 },
    locale: { default: "nl_NL" }
  },
  emits: ["onfido:completed"],
  setup(e, { emit: t }) {
    const n = t, r = e, a = N(null), i = () => {
      window.Onfido.init({
        token: r.sdkToken,
        workflowRunId: r.workflowId,
        language: r.locale,
        containerId: "onfido-mount",
        translations: {
          nl: {
            complete: {
              outro: {
                body: "Dit is alles wat we nodig hebben om uw identiteit te verifiëren. U kunt deze pagina nu sluiten."
              }
            }
          },
          en: {
            complete: {
              outro: {
                body: "This is all we need to verify your identity. You can now close this page."
              }
            }
          }
        },
        theme: {
          name: "light",
          config: {
            // General styles
            borderRadiusButton: "50px",
            borderStyleSurfaceModal: "0px",
            colorBackgroundIcon: "transparent",
            colorBackgroundSurfaceModal: "rgba(255,255,255,0.75)",
            colorBackgroundLinkActive: "transparent",
            colorBackgroundLinkHover: "transparent",
            colorBackgroundDocTypeButton: "transparent",
            colorBorderLinkUnderline: "1px solid #87bb3e",
            colorContentBody: "#263238",
            colorContentTitle: "#263238",
            colorContentSubtitle: "#263238",
            fontFamilyBody: "Poppins, 'Open Sans', sans-serif",
            fontFamilyTitle: "Poppins, 'Open Sans', sans-serif",
            fontFamilySubtitle: "Poppins, 'Open Sans', sans-serif",
            fontSizeBody: "15px",
            fontSizeSubtitle: "16px",
            fontSizeTitle: "20px",
            fontWeightBody: 400,
            fontWeightTitle: 700,
            // Primary button
            colorBackgroundButtonPrimary: "#87bb3e",
            colorBackgroundButtonPrimaryHover: "#5f9b0b",
            colorBackgroundButtonPrimaryActive: "#5f9b0b",
            colorBackgroundButtonIconActive: "#f3f8fa",
            colorBorderButtonPrimary: "#87bb3e",
            colorBorderButtonPrimaryHover: "#5f9b0b",
            colorBorderButtonPrimaryActive: "#5f9b0b",
            colorContentButtonPrimaryText: "#ffffff",
            // Secondary button
            colorBackgroundButtonSecondary: "#ffffff",
            colorBackgroundButtonSecondaryHover: "#f3f8fa",
            colorBackgroundButtonSecondaryActive: "#ffffff",
            colorBorderButtonSecondary: "#87bb3e",
            colorBorderButtonSecondaryHover: "#5f9b0b",
            colorBorderButtonSecondaryActive: "#87bb3e",
            colorContentButtonSecondaryText: "#87bb3e",
            colorContentLinkTextHover: "#1a5ea5",
            // Document type button
            colorBorderDocTypeButton: "#83bfe7",
            colorBackgroundDocTypeButtonHover: "#f3f8fa",
            colorBackgroundDocTypeButtonActive: "#ffffff",
            colorBorderDocTypeButtonHover: "#004388",
            colorBorderDocTypeButtonActive: "#1a5ea5",
            colorContentDocTypeButton: "#263238",
            // Disclaimer
            colorBackgroundDisclaimer: "#f3f8fa",
            colorIcon: "#263238",
            colorContentInfoPill: "#263238",
            colorBackgroundInfoPill: "#f5f5f5",
            colorBackgroundSelector: "#ffffff",
            colorBackgroundDropdownItemHover: "#e6f4ff",
            colorContentDropdownItemHover: "#ffffff",
            colorInputOutline: "#83bfe7",
            colorContentButtonTertiaryText: "#004388",
            colorContentInput: "#263238",
            colorBackgroundInput: "#ffffff",
            colorBorderInput: "#83bfe7",
            colorBorderInputHover: "#87bb3e",
            colorBorderActionFocus: "#83bfe7"
          }
        },
        onComplete: () => n("onfido:completed")
      });
    }, s = () => {
      a.value && window.Onfido ? i() : setTimeout(() => {
        s();
      }, 20);
    };
    return Ue(() => {
      qR(WR), s();
    }), (o, l) => (C(), T("div", {
      id: "onfido-mount",
      ref_key: "onfidoElement",
      ref: a,
      "data-test-id": "onfido",
      class: z(["min-h-[600px] sm:min-h-[700px]", { "onfido-modal": o.isModal }])
    }, null, 2));
  }
}), KR = { class: "w-full max-w-screen p-4 gap-4 text-blue-700 mx-auto flex flex-col text-center justify-center lg:flex-row lg:justify-between lg:text-start 3xl:max-w-screen-2xl" }, ZR = { class: "mb-2 flex flex-wrap justify-center lg:justify-start" }, XR = ["innerHTML"], JR = /* @__PURE__ */ re({
  __name: "Footer",
  props: {
    links: { default: () => [
      {
        href: "https://www.mogelijk.nl/privacy/",
        text: "privacyverklaring"
      },
      {
        href: "https://www.mogelijk.nl/cookieverklaring/",
        text: "cookieverklaring"
      },
      {
        href: "https://www.mogelijk.nl/disclaimer/",
        text: "disclaimer"
      },
      {
        href: "https://www.mogelijk.nl/voorwaarden/",
        text: "voorwaarden"
      }
    ] },
    message: { default: "Met ♥ door Mogelijk Technologies" }
  },
  setup(e) {
    const t = e, n = (r) => {
      window.open(r, "_blank");
    };
    return (r, a) => (C(), T("footer", KR, [
      S("div", ZR, [
        (C(!0), T(Oe, null, Fe(t.links, (i, s) => (C(), T("span", {
          key: i.text,
          class: "flex items-center"
        }, [
          s > 0 ? (C(), ve(x(te), {
            key: 0,
            icon: ["fas", "circle-small"],
            size: "xs",
            class: "mx-3"
          })) : K("", !0),
          U(St, {
            "data-test-id": `${i.text}-footer-link`,
            type: "tertiary",
            class: "!text-base",
            onClick: (o) => n(i.href)
          }, {
            default: fe(() => [
              rt(H(i.text), 1)
            ]),
            _: 2
          }, 1032, ["data-test-id", "onClick"])
        ]))), 128))
      ]),
      S("span", {
        innerHTML: t.message
      }, null, 8, XR)
    ]));
  }
}), s2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AppAutocompleteInput: Ry,
  AppButton: St,
  AppCard: j3,
  AppCardContent: B3,
  AppCardGalleryHeader: DC,
  AppCardHeader: zC,
  AppCardSeperator: VC,
  AppCheckbox: uy,
  AppCurrencyInput: Ay,
  AppFinanceRange: sx,
  AppGallery: gu,
  AppGalleryLightbox: V3,
  AppGallerySwiper: vu,
  AppHamburger: SA,
  AppImage: $r,
  AppInput: ui,
  AppLightbox: MC,
  AppLtvBar: bA,
  AppMarkDown: GA,
  AppModal: dA,
  AppNumberInput: _A,
  AppOfferCard: fw,
  AppPhoneInput: pO,
  AppPill: hA,
  AppProgressBar: ZC,
  AppRulesCheckList: ux,
  AppSelect: a_,
  AppSidebar: Yy,
  AppSidebarNavOption: Xy,
  AppSkeleton: yt,
  AppSpecification: qn,
  AppTextAreaInput: rA,
  AppTimer: l_,
  AppToast: gl,
  AppToasts: y_,
  AppToggle: XA,
  AppTooltip: D3,
  AppTooltips: pA,
  BreadCrumbs: $O,
  CallMeBack: PR,
  Confirmation: tE,
  DatePicker: E3,
  Document: RR,
  DragAndDrop: SO,
  DropDown: l4,
  FontAwesomeIcon: te,
  Footer: JR,
  FormWrapper: R3,
  InfiniteScroll: rE,
  MobileMenu: BE,
  MogelijkLoader: U$,
  Onfido: YR,
  Radio: cE,
  RadioSelect: bE,
  RadioSquare: AE,
  Record: HR,
  SearchBar: zE,
  SidebarMenu: KE,
  SlideDown: GR,
  TimePicker: u4
}, Symbol.toStringTag, { value: "Module" }));
function Ke() {
  return Ke = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ke.apply(null, arguments);
}
function oa(e) {
  "@babel/helpers - typeof";
  return oa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, oa(e);
}
function QR(e, t) {
  if (oa(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (oa(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function ej(e) {
  var t = QR(e, "string");
  return oa(t) == "symbol" ? t : t + "";
}
function tj(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, ej(r.key), r);
  }
}
function nj(e, t, n) {
  return t && tj(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
var rj = Object.prototype, aj = rj.hasOwnProperty;
function ij(e, t) {
  return e != null && aj.call(e, t);
}
var Wt = Array.isArray, S6 = typeof global == "object" && global && global.Object === Object && global, sj = typeof self == "object" && self && self.Object === Object && self, sn = S6 || sj || Function("return this")(), zt = sn.Symbol, C6 = Object.prototype, oj = C6.hasOwnProperty, lj = C6.toString, Br = zt ? zt.toStringTag : void 0;
function uj(e) {
  var t = oj.call(e, Br), n = e[Br];
  try {
    e[Br] = void 0;
    var r = !0;
  } catch {
  }
  var a = lj.call(e);
  return r && (t ? e[Br] = n : delete e[Br]), a;
}
var cj = Object.prototype, dj = cj.toString;
function fj(e) {
  return dj.call(e);
}
var pj = "[object Null]", hj = "[object Undefined]", o2 = zt ? zt.toStringTag : void 0;
function ar(e) {
  return e == null ? e === void 0 ? hj : pj : o2 && o2 in Object(e) ? uj(e) : fj(e);
}
function vn(e) {
  return e != null && typeof e == "object";
}
var mj = "[object Symbol]";
function ju(e) {
  return typeof e == "symbol" || vn(e) && ar(e) == mj;
}
var vj = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, gj = /^\w*$/;
function Bu(e, t) {
  if (Wt(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || ju(e) ? !0 : gj.test(e) || !vj.test(e) || t != null && e in Object(t);
}
function ba(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var bj = "[object AsyncFunction]", $j = "[object Function]", yj = "[object GeneratorFunction]", xj = "[object Proxy]";
function A6(e) {
  if (!ba(e))
    return !1;
  var t = ar(e);
  return t == $j || t == yj || t == bj || t == xj;
}
var Gs = sn["__core-js_shared__"], l2 = function() {
  var e = /[^.]+$/.exec(Gs && Gs.keys && Gs.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function _j(e) {
  return !!l2 && l2 in e;
}
var wj = Function.prototype, Sj = wj.toString;
function ir(e) {
  if (e != null) {
    try {
      return Sj.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Cj = /[\\^$.*+?()[\]{}|]/g, Aj = /^\[object .+?Constructor\]$/, Ej = Function.prototype, Oj = Object.prototype, Tj = Ej.toString, Mj = Oj.hasOwnProperty, kj = RegExp(
  "^" + Tj.call(Mj).replace(Cj, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Lj(e) {
  if (!ba(e) || _j(e))
    return !1;
  var t = A6(e) ? kj : Aj;
  return t.test(ir(e));
}
function Fj(e, t) {
  return e == null ? void 0 : e[t];
}
function sr(e, t) {
  var n = Fj(e, t);
  return Lj(n) ? n : void 0;
}
var la = sr(Object, "create");
function zj() {
  this.__data__ = la ? la(null) : {}, this.size = 0;
}
function Pj(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Ij = "__lodash_hash_undefined__", Nj = Object.prototype, Dj = Nj.hasOwnProperty;
function Rj(e) {
  var t = this.__data__;
  if (la) {
    var n = t[e];
    return n === Ij ? void 0 : n;
  }
  return Dj.call(t, e) ? t[e] : void 0;
}
var jj = Object.prototype, Bj = jj.hasOwnProperty;
function Vj(e) {
  var t = this.__data__;
  return la ? t[e] !== void 0 : Bj.call(t, e);
}
var Uj = "__lodash_hash_undefined__";
function Hj(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = la && t === void 0 ? Uj : t, this;
}
function Jn(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Jn.prototype.clear = zj;
Jn.prototype.delete = Pj;
Jn.prototype.get = Rj;
Jn.prototype.has = Vj;
Jn.prototype.set = Hj;
function Gj() {
  this.__data__ = [], this.size = 0;
}
function Vu(e, t) {
  return e === t || e !== e && t !== t;
}
function Xi(e, t) {
  for (var n = e.length; n--; )
    if (Vu(e[n][0], t))
      return n;
  return -1;
}
var qj = Array.prototype, Wj = qj.splice;
function Yj(e) {
  var t = this.__data__, n = Xi(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : Wj.call(t, n, 1), --this.size, !0;
}
function Kj(e) {
  var t = this.__data__, n = Xi(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function Zj(e) {
  return Xi(this.__data__, e) > -1;
}
function Xj(e, t) {
  var n = this.__data__, r = Xi(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
function xn(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
xn.prototype.clear = Gj;
xn.prototype.delete = Yj;
xn.prototype.get = Kj;
xn.prototype.has = Zj;
xn.prototype.set = Xj;
var ua = sr(sn, "Map");
function Jj() {
  this.size = 0, this.__data__ = {
    hash: new Jn(),
    map: new (ua || xn)(),
    string: new Jn()
  };
}
function Qj(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function Ji(e, t) {
  var n = e.__data__;
  return Qj(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function eB(e) {
  var t = Ji(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function tB(e) {
  return Ji(this, e).get(e);
}
function nB(e) {
  return Ji(this, e).has(e);
}
function rB(e, t) {
  var n = Ji(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
function _n(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
_n.prototype.clear = Jj;
_n.prototype.delete = eB;
_n.prototype.get = tB;
_n.prototype.has = nB;
_n.prototype.set = rB;
var aB = "Expected a function";
function Uu(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(aB);
  var n = function() {
    var r = arguments, a = t ? t.apply(this, r) : r[0], i = n.cache;
    if (i.has(a))
      return i.get(a);
    var s = e.apply(this, r);
    return n.cache = i.set(a, s) || i, s;
  };
  return n.cache = new (Uu.Cache || _n)(), n;
}
Uu.Cache = _n;
var iB = 500;
function sB(e) {
  var t = Uu(e, function(r) {
    return n.size === iB && n.clear(), r;
  }), n = t.cache;
  return t;
}
var oB = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, lB = /\\(\\)?/g, uB = sB(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(oB, function(n, r, a, i) {
    t.push(a ? i.replace(lB, "$1") : r || n);
  }), t;
});
function E6(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, a = Array(r); ++n < r; )
    a[n] = t(e[n], n, e);
  return a;
}
var u2 = zt ? zt.prototype : void 0, c2 = u2 ? u2.toString : void 0;
function O6(e) {
  if (typeof e == "string")
    return e;
  if (Wt(e))
    return E6(e, O6) + "";
  if (ju(e))
    return c2 ? c2.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
function $a(e) {
  return e == null ? "" : O6(e);
}
function T6(e, t) {
  return Wt(e) ? e : Bu(e, t) ? [e] : uB($a(e));
}
var cB = "[object Arguments]";
function d2(e) {
  return vn(e) && ar(e) == cB;
}
var M6 = Object.prototype, dB = M6.hasOwnProperty, fB = M6.propertyIsEnumerable, k6 = d2(/* @__PURE__ */ function() {
  return arguments;
}()) ? d2 : function(e) {
  return vn(e) && dB.call(e, "callee") && !fB.call(e, "callee");
}, pB = 9007199254740991, hB = /^(?:0|[1-9]\d*)$/;
function L6(e, t) {
  var n = typeof e;
  return t = t ?? pB, !!t && (n == "number" || n != "symbol" && hB.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var mB = 9007199254740991;
function Hu(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= mB;
}
function Qi(e) {
  if (typeof e == "string" || ju(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
function F6(e, t, n) {
  t = T6(t, e);
  for (var r = -1, a = t.length, i = !1; ++r < a; ) {
    var s = Qi(t[r]);
    if (!(i = e != null && n(e, s)))
      break;
    e = e[s];
  }
  return i || ++r != a ? i : (a = e == null ? 0 : e.length, !!a && Hu(a) && L6(s, a) && (Wt(e) || k6(e)));
}
function Qt(e, t) {
  return e != null && F6(e, t, ij);
}
function vB() {
  this.__data__ = new xn(), this.size = 0;
}
function gB(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
function bB(e) {
  return this.__data__.get(e);
}
function $B(e) {
  return this.__data__.has(e);
}
var yB = 200;
function xB(e, t) {
  var n = this.__data__;
  if (n instanceof xn) {
    var r = n.__data__;
    if (!ua || r.length < yB - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new _n(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
function tn(e) {
  var t = this.__data__ = new xn(e);
  this.size = t.size;
}
tn.prototype.clear = vB;
tn.prototype.delete = gB;
tn.prototype.get = bB;
tn.prototype.has = $B;
tn.prototype.set = xB;
function _B(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1; )
    ;
  return e;
}
var f2 = function() {
  try {
    var e = sr(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}();
function Gu(e, t, n) {
  t == "__proto__" && f2 ? f2(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var wB = Object.prototype, SB = wB.hasOwnProperty;
function CB(e, t, n) {
  var r = e[t];
  (!(SB.call(e, t) && Vu(r, n)) || n === void 0 && !(t in e)) && Gu(e, t, n);
}
function AB(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
function EB() {
  return !1;
}
var z6 = typeof exports == "object" && exports && !exports.nodeType && exports, p2 = z6 && typeof module == "object" && module && !module.nodeType && module, OB = p2 && p2.exports === z6, h2 = OB ? sn.Buffer : void 0, TB = h2 ? h2.isBuffer : void 0, yi = TB || EB, MB = "[object Arguments]", kB = "[object Array]", LB = "[object Boolean]", FB = "[object Date]", zB = "[object Error]", PB = "[object Function]", IB = "[object Map]", NB = "[object Number]", DB = "[object Object]", RB = "[object RegExp]", jB = "[object Set]", BB = "[object String]", VB = "[object WeakMap]", UB = "[object ArrayBuffer]", HB = "[object DataView]", GB = "[object Float32Array]", qB = "[object Float64Array]", WB = "[object Int8Array]", YB = "[object Int16Array]", KB = "[object Int32Array]", ZB = "[object Uint8Array]", XB = "[object Uint8ClampedArray]", JB = "[object Uint16Array]", QB = "[object Uint32Array]", Be = {};
Be[GB] = Be[qB] = Be[WB] = Be[YB] = Be[KB] = Be[ZB] = Be[XB] = Be[JB] = Be[QB] = !0;
Be[MB] = Be[kB] = Be[UB] = Be[LB] = Be[HB] = Be[FB] = Be[zB] = Be[PB] = Be[IB] = Be[NB] = Be[DB] = Be[RB] = Be[jB] = Be[BB] = Be[VB] = !1;
function eV(e) {
  return vn(e) && Hu(e.length) && !!Be[ar(e)];
}
function qu(e) {
  return function(t) {
    return e(t);
  };
}
var P6 = typeof exports == "object" && exports && !exports.nodeType && exports, Xr = P6 && typeof module == "object" && module && !module.nodeType && module, tV = Xr && Xr.exports === P6, qs = tV && S6.process, wr = function() {
  try {
    var e = Xr && Xr.require && Xr.require("util").types;
    return e || qs && qs.binding && qs.binding("util");
  } catch {
  }
}(), m2 = wr && wr.isTypedArray, I6 = m2 ? qu(m2) : eV, nV = Object.prototype, rV = nV.hasOwnProperty;
function aV(e, t) {
  var n = Wt(e), r = !n && k6(e), a = !n && !r && yi(e), i = !n && !r && !a && I6(e), s = n || r || a || i, o = s ? AB(e.length, String) : [], l = o.length;
  for (var u in e)
    rV.call(e, u) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    L6(u, l))) && o.push(u);
  return o;
}
var iV = Object.prototype;
function N6(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || iV;
  return e === n;
}
function D6(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var sV = D6(Object.keys, Object), oV = Object.prototype, lV = oV.hasOwnProperty;
function uV(e) {
  if (!N6(e))
    return sV(e);
  var t = [];
  for (var n in Object(e))
    lV.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
function R6(e) {
  return e != null && Hu(e.length) && !A6(e);
}
function es(e) {
  return R6(e) ? aV(e) : uV(e);
}
var j6 = typeof exports == "object" && exports && !exports.nodeType && exports, v2 = j6 && typeof module == "object" && module && !module.nodeType && module, cV = v2 && v2.exports === j6, g2 = cV ? sn.Buffer : void 0;
g2 && g2.allocUnsafe;
function dV(e, t) {
  return e.slice();
}
function fV(e, t) {
  var n = -1, r = e.length;
  for (t || (t = Array(r)); ++n < r; )
    t[n] = e[n];
  return t;
}
function pV(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, a = 0, i = []; ++n < r; ) {
    var s = e[n];
    t(s, n, e) && (i[a++] = s);
  }
  return i;
}
function hV() {
  return [];
}
var mV = Object.prototype, vV = mV.propertyIsEnumerable, b2 = Object.getOwnPropertySymbols, gV = b2 ? function(e) {
  return e == null ? [] : (e = Object(e), pV(b2(e), function(t) {
    return vV.call(e, t);
  }));
} : hV;
function bV(e, t) {
  for (var n = -1, r = t.length, a = e.length; ++n < r; )
    e[a + n] = t[n];
  return e;
}
var $V = D6(Object.getPrototypeOf, Object);
function yV(e, t, n) {
  var r = t(e);
  return Wt(e) ? r : bV(r, n(e));
}
function Ml(e) {
  return yV(e, es, gV);
}
var kl = sr(sn, "DataView"), Ll = sr(sn, "Promise"), Fl = sr(sn, "Set"), zl = sr(sn, "WeakMap"), $2 = "[object Map]", xV = "[object Object]", y2 = "[object Promise]", x2 = "[object Set]", _2 = "[object WeakMap]", w2 = "[object DataView]", _V = ir(kl), wV = ir(ua), SV = ir(Ll), CV = ir(Fl), AV = ir(zl), Ft = ar;
(kl && Ft(new kl(new ArrayBuffer(1))) != w2 || ua && Ft(new ua()) != $2 || Ll && Ft(Ll.resolve()) != y2 || Fl && Ft(new Fl()) != x2 || zl && Ft(new zl()) != _2) && (Ft = function(e) {
  var t = ar(e), n = t == xV ? e.constructor : void 0, r = n ? ir(n) : "";
  if (r)
    switch (r) {
      case _V:
        return w2;
      case wV:
        return $2;
      case SV:
        return y2;
      case CV:
        return x2;
      case AV:
        return _2;
    }
  return t;
});
var EV = Object.prototype, OV = EV.hasOwnProperty;
function TV(e) {
  var t = e.length, n = new e.constructor(t);
  return t && typeof e[0] == "string" && OV.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var xi = sn.Uint8Array;
function Wu(e) {
  var t = new e.constructor(e.byteLength);
  return new xi(t).set(new xi(e)), t;
}
function MV(e, t) {
  var n = Wu(e.buffer);
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var kV = /\w*$/;
function LV(e) {
  var t = new e.constructor(e.source, kV.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var S2 = zt ? zt.prototype : void 0, C2 = S2 ? S2.valueOf : void 0;
function FV(e) {
  return C2 ? Object(C2.call(e)) : {};
}
function zV(e, t) {
  var n = Wu(e.buffer);
  return new e.constructor(n, e.byteOffset, e.length);
}
var PV = "[object Boolean]", IV = "[object Date]", NV = "[object Map]", DV = "[object Number]", RV = "[object RegExp]", jV = "[object Set]", BV = "[object String]", VV = "[object Symbol]", UV = "[object ArrayBuffer]", HV = "[object DataView]", GV = "[object Float32Array]", qV = "[object Float64Array]", WV = "[object Int8Array]", YV = "[object Int16Array]", KV = "[object Int32Array]", ZV = "[object Uint8Array]", XV = "[object Uint8ClampedArray]", JV = "[object Uint16Array]", QV = "[object Uint32Array]";
function eU(e, t, n) {
  var r = e.constructor;
  switch (t) {
    case UV:
      return Wu(e);
    case PV:
    case IV:
      return new r(+e);
    case HV:
      return MV(e);
    case GV:
    case qV:
    case WV:
    case YV:
    case KV:
    case ZV:
    case XV:
    case JV:
    case QV:
      return zV(e);
    case NV:
      return new r();
    case DV:
    case BV:
      return new r(e);
    case RV:
      return LV(e);
    case jV:
      return new r();
    case VV:
      return FV(e);
  }
}
var A2 = Object.create, tU = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!ba(t))
      return {};
    if (A2)
      return A2(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}();
function nU(e) {
  return typeof e.constructor == "function" && !N6(e) ? tU($V(e)) : {};
}
var rU = "[object Map]";
function aU(e) {
  return vn(e) && Ft(e) == rU;
}
var E2 = wr && wr.isMap, iU = E2 ? qu(E2) : aU, sU = "[object Set]";
function oU(e) {
  return vn(e) && Ft(e) == sU;
}
var O2 = wr && wr.isSet, lU = O2 ? qu(O2) : oU, B6 = "[object Arguments]", uU = "[object Array]", cU = "[object Boolean]", dU = "[object Date]", fU = "[object Error]", V6 = "[object Function]", pU = "[object GeneratorFunction]", hU = "[object Map]", mU = "[object Number]", U6 = "[object Object]", vU = "[object RegExp]", gU = "[object Set]", bU = "[object String]", $U = "[object Symbol]", yU = "[object WeakMap]", xU = "[object ArrayBuffer]", _U = "[object DataView]", wU = "[object Float32Array]", SU = "[object Float64Array]", CU = "[object Int8Array]", AU = "[object Int16Array]", EU = "[object Int32Array]", OU = "[object Uint8Array]", TU = "[object Uint8ClampedArray]", MU = "[object Uint16Array]", kU = "[object Uint32Array]", Ie = {};
Ie[B6] = Ie[uU] = Ie[xU] = Ie[_U] = Ie[cU] = Ie[dU] = Ie[wU] = Ie[SU] = Ie[CU] = Ie[AU] = Ie[EU] = Ie[hU] = Ie[mU] = Ie[U6] = Ie[vU] = Ie[gU] = Ie[bU] = Ie[$U] = Ie[OU] = Ie[TU] = Ie[MU] = Ie[kU] = !0;
Ie[fU] = Ie[V6] = Ie[yU] = !1;
function ei(e, t, n, r, a, i) {
  var s;
  if (n && (s = a ? n(e, r, a, i) : n(e)), s !== void 0)
    return s;
  if (!ba(e))
    return e;
  var o = Wt(e);
  if (o)
    s = TV(e);
  else {
    var l = Ft(e), u = l == V6 || l == pU;
    if (yi(e))
      return dV(e);
    if (l == U6 || l == B6 || u && !a)
      s = u ? {} : nU(e);
    else {
      if (!Ie[l])
        return a ? e : {};
      s = eU(e, l);
    }
  }
  i || (i = new tn());
  var c = i.get(e);
  if (c)
    return c;
  i.set(e, s), lU(e) ? e.forEach(function(p) {
    s.add(ei(p, t, n, p, e, i));
  }) : iU(e) && e.forEach(function(p, h) {
    s.set(h, ei(p, t, n, h, e, i));
  });
  var d = Ml, f = o ? void 0 : d(e);
  return _B(f || e, function(p, h) {
    f && (h = p, p = e[h]), CB(s, h, ei(p, t, n, h, e, i));
  }), s;
}
var LU = 1, FU = 4;
function T2(e, t) {
  return t = typeof t == "function" ? t : void 0, ei(e, LU | FU, t);
}
var zU = "[object String]";
function PU(e) {
  return typeof e == "string" || !Wt(e) && vn(e) && ar(e) == zU;
}
function IU(e) {
  for (var t, n = []; !(t = e.next()).done; )
    n.push(t.value);
  return n;
}
function H6(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, a) {
    n[++t] = [a, r];
  }), n;
}
function G6(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = r;
  }), n;
}
function NU(e) {
  return e.split("");
}
var DU = "\\ud800-\\udfff", RU = "\\u0300-\\u036f", jU = "\\ufe20-\\ufe2f", BU = "\\u20d0-\\u20ff", VU = RU + jU + BU, UU = "\\ufe0e\\ufe0f", HU = "\\u200d", GU = RegExp("[" + HU + DU + VU + UU + "]");
function q6(e) {
  return GU.test(e);
}
var W6 = "\\ud800-\\udfff", qU = "\\u0300-\\u036f", WU = "\\ufe20-\\ufe2f", YU = "\\u20d0-\\u20ff", KU = qU + WU + YU, ZU = "\\ufe0e\\ufe0f", XU = "[" + W6 + "]", Pl = "[" + KU + "]", Il = "\\ud83c[\\udffb-\\udfff]", JU = "(?:" + Pl + "|" + Il + ")", Y6 = "[^" + W6 + "]", K6 = "(?:\\ud83c[\\udde6-\\uddff]){2}", Z6 = "[\\ud800-\\udbff][\\udc00-\\udfff]", QU = "\\u200d", X6 = JU + "?", J6 = "[" + ZU + "]?", eH = "(?:" + QU + "(?:" + [Y6, K6, Z6].join("|") + ")" + J6 + X6 + ")*", tH = J6 + X6 + eH, nH = "(?:" + [Y6 + Pl + "?", Pl, K6, Z6, XU].join("|") + ")", rH = RegExp(Il + "(?=" + Il + ")|" + nH + tH, "g");
function aH(e) {
  return e.match(rH) || [];
}
function Q6(e) {
  return q6(e) ? aH(e) : NU(e);
}
function iH(e, t) {
  return E6(t, function(n) {
    return e[n];
  });
}
function sH(e) {
  return e == null ? [] : iH(e, es(e));
}
var oH = "[object Map]", lH = "[object Set]", Ws = zt ? zt.iterator : void 0;
function M2(e) {
  if (!e)
    return [];
  if (R6(e))
    return PU(e) ? Q6(e) : fV(e);
  if (Ws && e[Ws])
    return IU(e[Ws]());
  var t = Ft(e), n = t == oH ? H6 : t == lH ? G6 : sH;
  return n(e);
}
var uH = Object.prototype.toString, cH = Error.prototype.toString, dH = RegExp.prototype.toString, fH = typeof Symbol < "u" ? Symbol.prototype.toString : function() {
  return "";
}, pH = /^Symbol\((.*)\)(.*)$/;
function hH(e) {
  if (e != +e) return "NaN";
  var t = e === 0 && 1 / e < 0;
  return t ? "-0" : "" + e;
}
function k2(e, t) {
  if (t === void 0 && (t = !1), e == null || e === !0 || e === !1) return "" + e;
  var n = typeof e;
  if (n === "number") return hH(e);
  if (n === "string") return t ? '"' + e + '"' : e;
  if (n === "function") return "[Function " + (e.name || "anonymous") + "]";
  if (n === "symbol") return fH.call(e).replace(pH, "Symbol($1)");
  var r = uH.call(e).slice(8, -1);
  return r === "Date" ? isNaN(e.getTime()) ? "" + e : e.toISOString(e) : r === "Error" || e instanceof Error ? "[" + cH.call(e) + "]" : r === "RegExp" ? dH.call(e) : null;
}
function Sr(e, t) {
  var n = k2(e, t);
  return n !== null ? n : JSON.stringify(e, function(r, a) {
    var i = k2(this[r], t);
    return i !== null ? i : a;
  }, 2);
}
var Hn = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: function(t) {
    var n = t.path, r = t.type, a = t.value, i = t.originalValue, s = i != null && i !== a, o = n + " must be a `" + r + "` type, " + ("but the final value was: `" + Sr(a, !0) + "`") + (s ? " (cast from the value `" + Sr(i, !0) + "`)." : ".");
    return a === null && (o += '\n If "null" is intended as an empty value be sure to mark the schema as `.nullable()`'), o;
  },
  defined: "${path} must be defined"
}, Dt = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, An = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  notEqual: "${path} must be not equal to ${notEqual}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, Nl = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, mH = {}, Dl = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
}, Rl = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items"
};
const vH = {
  mixed: Hn,
  string: Dt,
  number: An,
  date: Nl,
  object: Dl,
  array: Rl,
  boolean: mH
}, gn = function(e) {
  return e && e.__isYupSchema__;
};
var gH = /* @__PURE__ */ function() {
  function e(n, r) {
    if (this.refs = n, typeof r == "function") {
      this.fn = r;
      return;
    }
    if (!Qt(r, "is")) throw new TypeError("`is:` is required for `when()` conditions");
    if (!r.then && !r.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    var a = r.is, i = r.then, s = r.otherwise, o = typeof a == "function" ? a : function() {
      for (var l = arguments.length, u = new Array(l), c = 0; c < l; c++)
        u[c] = arguments[c];
      return u.every(function(d) {
        return d === a;
      });
    };
    this.fn = function() {
      for (var l = arguments.length, u = new Array(l), c = 0; c < l; c++)
        u[c] = arguments[c];
      var d = u.pop(), f = u.pop(), p = o.apply(void 0, u) ? i : s;
      if (p)
        return typeof p == "function" ? p(f) : f.concat(p.resolve(d));
    };
  }
  var t = e.prototype;
  return t.resolve = function(r, a) {
    var i = this.refs.map(function(o) {
      return o.getValue(a);
    }), s = this.fn.apply(r, i.concat(r, a));
    if (s === void 0 || s === r) return r;
    if (!gn(s)) throw new TypeError("conditions must return a schema object");
    return s.resolve(a);
  }, e;
}();
function Yu(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.indexOf(r) !== -1) continue;
    n[r] = e[r];
  }
  return n;
}
function ts(e) {
  return Array.prototype.slice.apply(e);
}
var ep = "pending", L2 = "resolved", F2 = "rejected";
function Me(e) {
  this.status = ep, this._continuations = [], this._parent = null, this._paused = !1, e && e.call(
    this,
    this._continueWith.bind(this),
    this._failWith.bind(this)
  );
}
function qr(e) {
  return e && typeof e.then == "function";
}
function bH(e) {
  return e;
}
Me.prototype = {
  then: function(e, t) {
    var n = Me.unresolved()._setParent(this);
    if (this._isRejected()) {
      if (this._paused)
        return this._continuations.push({
          promise: n,
          nextFn: e,
          catchFn: t
        }), n;
      if (t)
        try {
          var r = t(this._error);
          return qr(r) ? (this._chainPromiseData(r, n), n) : Me.resolve(r)._setParent(this);
        } catch (a) {
          return Me.reject(a)._setParent(this);
        }
      return Me.reject(this._error)._setParent(this);
    }
    return this._continuations.push({
      promise: n,
      nextFn: e,
      catchFn: t
    }), this._runResolutions(), n;
  },
  catch: function(e) {
    if (this._isResolved())
      return Me.resolve(this._data)._setParent(this);
    var t = Me.unresolved()._setParent(this);
    return this._continuations.push({
      promise: t,
      catchFn: e
    }), this._runRejections(), t;
  },
  finally: function(e) {
    var t = !1;
    function n(r, a) {
      if (!t) {
        t = !0, e || (e = bH);
        var i = e(r);
        return qr(i) ? i.then(function() {
          if (a)
            throw a;
          return r;
        }) : r;
      }
    }
    return this.then(function(r) {
      return n(r);
    }).catch(function(r) {
      return n(null, r);
    });
  },
  pause: function() {
    return this._paused = !0, this;
  },
  resume: function() {
    var e = this._findFirstPaused();
    return e && (e._paused = !1, e._runResolutions(), e._runRejections()), this;
  },
  _findAncestry: function() {
    return this._continuations.reduce(function(e, t) {
      if (t.promise) {
        var n = {
          promise: t.promise,
          children: t.promise._findAncestry()
        };
        e.push(n);
      }
      return e;
    }, []);
  },
  _setParent: function(e) {
    if (this._parent)
      throw new Error("parent already set");
    return this._parent = e, this;
  },
  _continueWith: function(e) {
    var t = this._findFirstPending();
    t && (t._data = e, t._setResolved());
  },
  _findFirstPending: function() {
    return this._findFirstAncestor(function(e) {
      return e._isPending && e._isPending();
    });
  },
  _findFirstPaused: function() {
    return this._findFirstAncestor(function(e) {
      return e._paused;
    });
  },
  _findFirstAncestor: function(e) {
    for (var t = this, n; t; )
      e(t) && (n = t), t = t._parent;
    return n;
  },
  _failWith: function(e) {
    var t = this._findFirstPending();
    t && (t._error = e, t._setRejected());
  },
  _takeContinuations: function() {
    return this._continuations.splice(0, this._continuations.length);
  },
  _runRejections: function() {
    if (!(this._paused || !this._isRejected())) {
      var e = this._error, t = this._takeContinuations(), n = this;
      t.forEach(function(r) {
        if (r.catchFn)
          try {
            var a = r.catchFn(e);
            n._handleUserFunctionResult(a, r.promise);
          } catch (i) {
            r.promise.reject(i);
          }
        else
          r.promise.reject(e);
      });
    }
  },
  _runResolutions: function() {
    if (!(this._paused || !this._isResolved() || this._isPending())) {
      var e = this._takeContinuations(), t = this._data, n = this;
      if (e.forEach(function(r) {
        if (r.nextFn)
          try {
            var a = r.nextFn(t);
            n._handleUserFunctionResult(a, r.promise);
          } catch (i) {
            n._handleResolutionError(i, r);
          }
        else r.promise && r.promise.resolve(t);
      }), qr(this._data))
        return this._handleWhenResolvedDataIsPromise(this._data);
    }
  },
  _handleResolutionError: function(e, t) {
    if (this._setRejected(), t.catchFn)
      try {
        t.catchFn(e);
        return;
      } catch (n) {
        e = n;
      }
    t.promise && t.promise.reject(e);
  },
  _handleWhenResolvedDataIsPromise: function(e) {
    var t = this;
    return e.then(function(n) {
      t._data = n, t._runResolutions();
    }).catch(function(n) {
      t._error = n, t._setRejected(), t._runRejections();
    });
  },
  _handleUserFunctionResult: function(e, t) {
    qr(e) ? this._chainPromiseData(e, t) : t.resolve(e);
  },
  _chainPromiseData: function(e, t) {
    e.then(function(n) {
      t.resolve(n);
    }).catch(function(n) {
      t.reject(n);
    });
  },
  _setResolved: function() {
    this.status = L2, this._paused || this._runResolutions();
  },
  _setRejected: function() {
    this.status = F2, this._paused || this._runRejections();
  },
  _isPending: function() {
    return this.status === ep;
  },
  _isResolved: function() {
    return this.status === L2;
  },
  _isRejected: function() {
    return this.status === F2;
  }
};
Me.resolve = function(e) {
  return new Me(function(t, n) {
    qr(e) ? e.then(function(r) {
      t(r);
    }).catch(function(r) {
      n(r);
    }) : t(e);
  });
};
Me.reject = function(e) {
  return new Me(function(t, n) {
    n(e);
  });
};
Me.unresolved = function() {
  return new Me(function(e, t) {
    this.resolve = e, this.reject = t;
  });
};
Me.all = function() {
  var e = ts(arguments);
  return Array.isArray(e[0]) && (e = e[0]), e.length ? new Me(function(t, n) {
    var r = [], a = 0, i = function() {
      a === e.length && t(r);
    }, s = !1, o = function(l) {
      s || (s = !0, n(l));
    };
    e.forEach(function(l, u) {
      Me.resolve(l).then(function(c) {
        r[u] = c, a += 1, i();
      }).catch(function(c) {
        o(c);
      });
    });
  }) : Me.resolve([]);
};
function z2(e) {
  return typeof window < "u" && "AggregateError" in window ? new window.AggregateError(e) : { errors: e };
}
Me.any = function() {
  var e = ts(arguments);
  return Array.isArray(e[0]) && (e = e[0]), e.length ? new Me(function(t, n) {
    var r = [], a = 0, i = function() {
      a === e.length && n(z2(r));
    }, s = !1, o = function(l) {
      s || (s = !0, t(l));
    };
    e.forEach(function(l, u) {
      Me.resolve(l).then(function(c) {
        o(c);
      }).catch(function(c) {
        r[u] = c, a += 1, i();
      });
    });
  }) : Me.reject(z2([]));
};
Me.allSettled = function() {
  var e = ts(arguments);
  return Array.isArray(e[0]) && (e = e[0]), e.length ? new Me(function(t) {
    var n = [], r = 0, a = function() {
      r += 1, r === e.length && t(n);
    };
    e.forEach(function(i, s) {
      Me.resolve(i).then(function(o) {
        n[s] = {
          status: "fulfilled",
          value: o
        }, a();
      }).catch(function(o) {
        n[s] = {
          status: "rejected",
          reason: o
        }, a();
      });
    });
  }) : Me.resolve([]);
};
if (Promise === Me)
  throw new Error("Please use SynchronousPromise.installGlobally() to install globally");
var $H = Promise;
Me.installGlobally = function(e) {
  if (Promise === Me)
    return e;
  var t = yH(e);
  return Promise = Me, t;
};
Me.uninstallGlobally = function() {
  Promise === Me && (Promise = $H);
};
function yH(e) {
  if (typeof e > "u" || e.__patched)
    return e;
  var t = e;
  return e = function() {
    t.apply(this, ts(arguments));
  }, e.__patched = !0, e;
}
var ya = {
  SynchronousPromise: Me
}, xH = /\$\{\s*(\w+)\s*\}/g, _H = function(t) {
  return function(n) {
    return t.replace(xH, function(r, a) {
      return Sr(n[a]);
    });
  };
};
function Pt(e, t, n, r) {
  var a = this;
  this.name = "ValidationError", this.value = t, this.path = n, this.type = r, this.errors = [], this.inner = [], e && [].concat(e).forEach(function(i) {
    a.errors = a.errors.concat(i.errors || i), i.inner && (a.inner = a.inner.concat(i.inner.length ? i.inner : i));
  }), this.message = this.errors.length > 1 ? this.errors.length + " errors occurred" : this.errors[0], Error.captureStackTrace && Error.captureStackTrace(this, Pt);
}
Pt.prototype = Object.create(Error.prototype);
Pt.prototype.constructor = Pt;
Pt.isError = function(e) {
  return e && e.name === "ValidationError";
};
Pt.formatError = function(e, t) {
  typeof e == "string" && (e = _H(e));
  var n = function(a) {
    return a.path = a.label || a.path || "this", typeof e == "function" ? e(a) : e;
  };
  return arguments.length === 1 ? n : n(t);
};
var tp = function(t) {
  return t ? ya.SynchronousPromise : Promise;
}, wH = function(t) {
  return t === void 0 && (t = []), t.inner && t.inner.length ? t.inner : [].concat(t);
};
function SH(e, t, n) {
  var r = tp(n).all(e), a = r.catch(function(s) {
    throw s.name === "ValidationError" && (s.value = t), s;
  }), i = a.then(function() {
    return t;
  });
  return i;
}
function np(e, t) {
  return e ? null : function(n) {
    return t.push(n), n.value;
  };
}
function CH(e, t) {
  var n = tp(t);
  return n.all(e.map(function(r) {
    return n.resolve(r).then(function(a) {
      return {
        fulfilled: !0,
        value: a
      };
    }, function(a) {
      return {
        fulfilled: !1,
        value: a
      };
    });
  }));
}
function AH(e) {
  var t = e.validations, n = e.value, r = e.path, a = e.sync, i = e.errors, s = e.sort;
  return i = wH(i), CH(t, a).then(function(o) {
    var l = o.filter(function(u) {
      return !u.fulfilled;
    }).reduce(function(u, c) {
      var d = c.value;
      if (!Pt.isError(d))
        throw d;
      return u.concat(d);
    }, []);
    if (s && l.sort(s), i = l.concat(i), i.length) throw new Pt(i, n, r);
    return n;
  });
}
function _i(e) {
  var t = e.endEarly, n = Yu(e, ["endEarly"]);
  return t ? SH(n.validations, n.value, n.sync) : AH(n);
}
var P2 = function(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
};
function rp(e, t) {
  for (var n in t)
    if (Qt(t, n)) {
      var r = t[n], a = e[n];
      if (a === void 0)
        e[n] = r;
      else {
        if (a === r)
          continue;
        gn(a) ? gn(r) && (e[n] = r.concat(a)) : P2(a) ? P2(r) && (e[n] = rp(a, r)) : Array.isArray(a) && Array.isArray(r) && (e[n] = r.concat(a));
      }
    }
  return e;
}
function EH(e) {
  return function(t, n, r) {
    for (var a = -1, i = Object(t), s = r(t), o = s.length; o--; ) {
      var l = s[++a];
      if (n(i[l], l, i) === !1)
        break;
    }
    return t;
  };
}
var OH = EH();
function ap(e, t) {
  return e && OH(e, t, es);
}
var TH = "__lodash_hash_undefined__";
function MH(e) {
  return this.__data__.set(e, TH), this;
}
function kH(e) {
  return this.__data__.has(e);
}
function wi(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new _n(); ++t < n; )
    this.add(e[t]);
}
wi.prototype.add = wi.prototype.push = MH;
wi.prototype.has = kH;
function LH(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
function FH(e, t) {
  return e.has(t);
}
var zH = 1, PH = 2;
function ip(e, t, n, r, a, i) {
  var s = n & zH, o = e.length, l = t.length;
  if (o != l && !(s && l > o))
    return !1;
  var u = i.get(e), c = i.get(t);
  if (u && c)
    return u == t && c == e;
  var d = -1, f = !0, p = n & PH ? new wi() : void 0;
  for (i.set(e, t), i.set(t, e); ++d < o; ) {
    var h = e[d], m = t[d];
    if (r)
      var v = s ? r(m, h, d, t, e, i) : r(h, m, d, e, t, i);
    if (v !== void 0) {
      if (v)
        continue;
      f = !1;
      break;
    }
    if (p) {
      if (!LH(t, function(g, b) {
        if (!FH(p, b) && (h === g || a(h, g, n, r, i)))
          return p.push(b);
      })) {
        f = !1;
        break;
      }
    } else if (!(h === m || a(h, m, n, r, i))) {
      f = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), f;
}
var IH = 1, NH = 2, DH = "[object Boolean]", RH = "[object Date]", jH = "[object Error]", BH = "[object Map]", VH = "[object Number]", UH = "[object RegExp]", HH = "[object Set]", GH = "[object String]", qH = "[object Symbol]", WH = "[object ArrayBuffer]", YH = "[object DataView]", I2 = zt ? zt.prototype : void 0, Ys = I2 ? I2.valueOf : void 0;
function KH(e, t, n, r, a, i, s) {
  switch (n) {
    case YH:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case WH:
      return !(e.byteLength != t.byteLength || !i(new xi(e), new xi(t)));
    case DH:
    case RH:
    case VH:
      return Vu(+e, +t);
    case jH:
      return e.name == t.name && e.message == t.message;
    case UH:
    case GH:
      return e == t + "";
    case BH:
      var o = H6;
    case HH:
      var l = r & IH;
      if (o || (o = G6), e.size != t.size && !l)
        return !1;
      var u = s.get(e);
      if (u)
        return u == t;
      r |= NH, s.set(e, t);
      var c = ip(o(e), o(t), r, a, i, s);
      return s.delete(e), c;
    case qH:
      if (Ys)
        return Ys.call(e) == Ys.call(t);
  }
  return !1;
}
var ZH = 1, XH = Object.prototype, JH = XH.hasOwnProperty;
function QH(e, t, n, r, a, i) {
  var s = n & ZH, o = Ml(e), l = o.length, u = Ml(t), c = u.length;
  if (l != c && !s)
    return !1;
  for (var d = l; d--; ) {
    var f = o[d];
    if (!(s ? f in t : JH.call(t, f)))
      return !1;
  }
  var p = i.get(e), h = i.get(t);
  if (p && h)
    return p == t && h == e;
  var m = !0;
  i.set(e, t), i.set(t, e);
  for (var v = s; ++d < l; ) {
    f = o[d];
    var g = e[f], b = t[f];
    if (r)
      var $ = s ? r(b, g, f, t, e, i) : r(g, b, f, e, t, i);
    if (!($ === void 0 ? g === b || a(g, b, n, r, i) : $)) {
      m = !1;
      break;
    }
    v || (v = f == "constructor");
  }
  if (m && !v) {
    var y = e.constructor, A = t.constructor;
    y != A && "constructor" in e && "constructor" in t && !(typeof y == "function" && y instanceof y && typeof A == "function" && A instanceof A) && (m = !1);
  }
  return i.delete(e), i.delete(t), m;
}
var eG = 1, N2 = "[object Arguments]", D2 = "[object Array]", Fa = "[object Object]", tG = Object.prototype, R2 = tG.hasOwnProperty;
function nG(e, t, n, r, a, i) {
  var s = Wt(e), o = Wt(t), l = s ? D2 : Ft(e), u = o ? D2 : Ft(t);
  l = l == N2 ? Fa : l, u = u == N2 ? Fa : u;
  var c = l == Fa, d = u == Fa, f = l == u;
  if (f && yi(e)) {
    if (!yi(t))
      return !1;
    s = !0, c = !1;
  }
  if (f && !c)
    return i || (i = new tn()), s || I6(e) ? ip(e, t, n, r, a, i) : KH(e, t, l, n, r, a, i);
  if (!(n & eG)) {
    var p = c && R2.call(e, "__wrapped__"), h = d && R2.call(t, "__wrapped__");
    if (p || h) {
      var m = p ? e.value() : e, v = h ? t.value() : t;
      return i || (i = new tn()), a(m, v, n, r, i);
    }
  }
  return f ? (i || (i = new tn()), QH(e, t, n, r, a, i)) : !1;
}
function Ku(e, t, n, r, a) {
  return e === t ? !0 : e == null || t == null || !vn(e) && !vn(t) ? e !== e && t !== t : nG(e, t, n, r, Ku, a);
}
var rG = 1, aG = 2;
function iG(e, t, n, r) {
  var a = n.length, i = a;
  if (e == null)
    return !i;
  for (e = Object(e); a--; ) {
    var s = n[a];
    if (s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++a < i; ) {
    s = n[a];
    var o = s[0], l = e[o], u = s[1];
    if (s[2]) {
      if (l === void 0 && !(o in e))
        return !1;
    } else {
      var c = new tn(), d;
      if (!(d === void 0 ? Ku(u, l, rG | aG, r, c) : d))
        return !1;
    }
  }
  return !0;
}
function sp(e) {
  return e === e && !ba(e);
}
function sG(e) {
  for (var t = es(e), n = t.length; n--; ) {
    var r = t[n], a = e[r];
    t[n] = [r, a, sp(a)];
  }
  return t;
}
function op(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
function oG(e) {
  var t = sG(e);
  return t.length == 1 && t[0][2] ? op(t[0][0], t[0][1]) : function(n) {
    return n === e || iG(n, e, t);
  };
}
function lp(e, t) {
  t = T6(t, e);
  for (var n = 0, r = t.length; e != null && n < r; )
    e = e[Qi(t[n++])];
  return n && n == r ? e : void 0;
}
function lG(e, t, n) {
  var r = e == null ? void 0 : lp(e, t);
  return r === void 0 ? n : r;
}
function uG(e, t) {
  return e != null && t in Object(e);
}
function cG(e, t) {
  return e != null && F6(e, t, uG);
}
var dG = 1, fG = 2;
function pG(e, t) {
  return Bu(e) && sp(t) ? op(Qi(e), t) : function(n) {
    var r = lG(n, e);
    return r === void 0 && r === t ? cG(n, e) : Ku(t, r, dG | fG);
  };
}
function hG(e) {
  return e;
}
function mG(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
function vG(e) {
  return function(t) {
    return lp(t, e);
  };
}
function gG(e) {
  return Bu(e) ? mG(Qi(e)) : vG(e);
}
function up(e) {
  return typeof e == "function" ? e : e == null ? hG : typeof e == "object" ? Wt(e) ? pG(e[0], e[1]) : oG(e) : gG(e);
}
function cp(e, t) {
  var n = {};
  return t = up(t), ap(e, function(r, a, i) {
    Gu(n, a, t(r, a, i));
  }), n;
}
var za = {
  context: "$",
  value: "."
}, bn = /* @__PURE__ */ function() {
  function e(n, r) {
    if (r === void 0 && (r = {}), typeof n != "string") throw new TypeError("ref must be a string, got: " + n);
    if (this.key = n.trim(), n === "") throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === za.context, this.isValue = this.key[0] === za.value, this.isSibling = !this.isContext && !this.isValue;
    var a = this.isContext ? za.context : this.isValue ? za.value : "";
    this.path = this.key.slice(a.length), this.getter = this.path && an.getter(this.path, !0), this.map = r.map;
  }
  var t = e.prototype;
  return t.getValue = function(r) {
    var a = this.isContext ? r.context : this.isValue ? r.value : r.parent;
    return this.getter && (a = this.getter(a || {})), this.map && (a = this.map(a)), a;
  }, t.cast = function(r, a) {
    return this.getValue(Ke({}, a, {
      value: r
    }));
  }, t.resolve = function() {
    return this;
  }, t.describe = function() {
    return {
      type: "ref",
      key: this.key
    };
  }, t.toString = function() {
    return "Ref(" + this.key + ")";
  }, e.isRef = function(r) {
    return r && r.__isYupRef;
  }, e;
}();
bn.prototype.__isYupRef = !0;
var bG = Pt.formatError, $G = function(t) {
  return t && typeof t.then == "function" && typeof t.catch == "function";
};
function yG(e, t, n, r) {
  var a = e.call(t, n);
  if (!r) return Promise.resolve(a);
  if ($G(a))
    throw new Error('Validation test of type: "' + t.type + '" returned a Promise during a synchronous validate. This test will finish after the validate call has returned');
  return ya.SynchronousPromise.resolve(a);
}
function xG(e, t, n) {
  return cp(Ke({}, e, t), n);
}
function _G(e) {
  var t = e.value, n = e.label, r = e.resolve, a = e.originalValue, i = Yu(e, ["value", "label", "resolve", "originalValue"]);
  return function(o) {
    var l = o === void 0 ? {} : o, u = l.path, c = u === void 0 ? i.path : u, d = l.message, f = d === void 0 ? i.message : d, p = l.type, h = p === void 0 ? i.name : p, m = l.params;
    return m = Ke({
      path: c,
      value: t,
      originalValue: a,
      label: n
    }, xG(i.params, m, r)), Ke(new Pt(bG(f, m), t, c, h), {
      params: m
    });
  };
}
function Pa(e) {
  var t = e.name, n = e.message, r = e.test, a = e.params;
  function i(s) {
    var o = s.value, l = s.path, u = s.label, c = s.options, d = s.originalValue, f = s.sync, p = Yu(s, ["value", "path", "label", "options", "originalValue", "sync"]), h = c.parent, m = function($) {
      return bn.isRef($) ? $.getValue({
        value: o,
        parent: h,
        context: c.context
      }) : $;
    }, v = _G({
      message: n,
      path: l,
      value: o,
      originalValue: d,
      params: a,
      label: u,
      resolve: m,
      name: t
    }), g = Ke({
      path: l,
      parent: h,
      type: t,
      createError: v,
      resolve: m,
      options: c
    }, p);
    return yG(r, g, o, f).then(function(b) {
      if (Pt.isError(b)) throw b;
      if (!b) throw v();
    });
  }
  return i.OPTIONS = e, i;
}
var wG = function(t) {
  return t.substr(0, t.length - 1).substr(1);
};
function dp(e, t, n, r) {
  r === void 0 && (r = n);
  var a, i, s;
  return t ? (an.forEach(t, function(o, l, u) {
    var c = l ? wG(o) : o;
    if (e = e.resolve({
      context: r,
      parent: a,
      value: n
    }), e.innerType) {
      var d = u ? parseInt(c, 10) : 0;
      if (n && d >= n.length)
        throw new Error("Yup.reach cannot resolve an array item at index: " + o + ", in the path: " + t + ". because there is no value at that index. ");
      a = n, n = n && n[d], e = e.innerType;
    }
    if (!u) {
      if (!e.fields || !e.fields[c]) throw new Error("The schema does not contain the path: " + t + ". " + ("(failed at: " + s + ' which is a type: "' + e._type + '")'));
      a = n, n = n && n[c], e = e.fields[c];
    }
    i = c, s = l ? "[" + o + "]" : "." + o;
  }), {
    schema: e,
    parent: a,
    parentPath: i
  }) : {
    parent: a,
    parentPath: t,
    schema: e
  };
}
var SG = function(t, n, r, a) {
  return dp(t, n, r, a).schema;
};
function j2(e, t) {
  var n;
  if (typeof Symbol > "u" || e[Symbol.iterator] == null) {
    if (Array.isArray(e) || (n = CG(e)) || t) {
      n && (e = n);
      var r = 0;
      return function() {
        return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  return n = e[Symbol.iterator](), n.next.bind(n);
}
function CG(e, t) {
  if (e) {
    if (typeof e == "string") return B2(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return B2(e, t);
  }
}
function B2(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var V2 = /* @__PURE__ */ function() {
  function e() {
    this.list = /* @__PURE__ */ new Set(), this.refs = /* @__PURE__ */ new Map();
  }
  var t = e.prototype;
  return t.describe = function() {
    for (var r = [], a = j2(this.list), i; !(i = a()).done; ) {
      var s = i.value;
      r.push(s);
    }
    for (var o = j2(this.refs), l; !(l = o()).done; ) {
      var u = l.value, c = u[1];
      r.push(c.describe());
    }
    return r;
  }, t.toArray = function() {
    return M2(this.list).concat(M2(this.refs.values()));
  }, t.add = function(r) {
    bn.isRef(r) ? this.refs.set(r.key, r) : this.list.add(r);
  }, t.delete = function(r) {
    bn.isRef(r) ? this.refs.delete(r.key) : this.list.delete(r);
  }, t.has = function(r, a) {
    if (this.list.has(r)) return !0;
    for (var i, s = this.refs.values(); i = s.next(), !i.done; )
      if (a(i.value) === r) return !0;
    return !1;
  }, t.clone = function() {
    var r = new e();
    return r.list = new Set(this.list), r.refs = new Map(this.refs), r;
  }, t.merge = function(r, a) {
    var i = this.clone();
    return r.list.forEach(function(s) {
      return i.add(s);
    }), r.refs.forEach(function(s) {
      return i.add(s);
    }), a.list.forEach(function(s) {
      return i.delete(s);
    }), a.refs.forEach(function(s) {
      return i.delete(s);
    }), i;
  }, nj(e, [{
    key: "size",
    get: function() {
      return this.list.size + this.refs.size;
    }
  }]), e;
}();
function Ne(e) {
  var t = this;
  if (e === void 0 && (e = {}), !(this instanceof Ne)) return new Ne();
  this._deps = [], this._conditions = [], this._options = {
    abortEarly: !0,
    recursive: !0
  }, this._exclusive = /* @__PURE__ */ Object.create(null), this._whitelist = new V2(), this._blacklist = new V2(), this.tests = [], this.transforms = [], this.withMutation(function() {
    t.typeError(Hn.notType);
  }), Qt(e, "default") && (this._defaultDefault = e.default), this.type = e.type || "mixed", this._type = e.type || "mixed";
}
var Qn = Ne.prototype = {
  __isYupSchema__: !0,
  constructor: Ne,
  clone: function() {
    var t = this;
    return this._mutate ? this : T2(this, function(n) {
      if (gn(n) && n !== t) return n;
    });
  },
  label: function(t) {
    var n = this.clone();
    return n._label = t, n;
  },
  meta: function(t) {
    if (arguments.length === 0) return this._meta;
    var n = this.clone();
    return n._meta = Ke(n._meta || {}, t), n;
  },
  withMutation: function(t) {
    var n = this._mutate;
    this._mutate = !0;
    var r = t(this);
    return this._mutate = n, r;
  },
  concat: function(t) {
    if (!t || t === this) return this;
    if (t._type !== this._type && this._type !== "mixed") throw new TypeError("You cannot `concat()` schema's of different types: " + this._type + " and " + t._type);
    var n = rp(t.clone(), this);
    return Qt(t, "_default") && (n._default = t._default), n.tests = this.tests, n._exclusive = this._exclusive, n._whitelist = this._whitelist.merge(t._whitelist, t._blacklist), n._blacklist = this._blacklist.merge(t._blacklist, t._whitelist), n.withMutation(function(r) {
      t.tests.forEach(function(a) {
        r.test(a.OPTIONS);
      });
    }), n;
  },
  isType: function(t) {
    return this._nullable && t === null ? !0 : !this._typeCheck || this._typeCheck(t);
  },
  resolve: function(t) {
    var n = this;
    if (n._conditions.length) {
      var r = n._conditions;
      n = n.clone(), n._conditions = [], n = r.reduce(function(a, i) {
        return i.resolve(a, t);
      }, n), n = n.resolve(t);
    }
    return n;
  },
  cast: function(t, n) {
    n === void 0 && (n = {});
    var r = this.resolve(Ke({}, n, {
      value: t
    })), a = r._cast(t, n);
    if (t !== void 0 && n.assert !== !1 && r.isType(a) !== !0) {
      var i = Sr(t), s = Sr(a);
      throw new TypeError("The value of " + (n.path || "field") + " could not be cast to a value " + ('that satisfies the schema type: "' + r._type + `". 

`) + ("attempted value: " + i + ` 
`) + (s !== i ? "result of cast: " + s : ""));
    }
    return a;
  },
  _cast: function(t) {
    var n = this, r = t === void 0 ? t : this.transforms.reduce(function(a, i) {
      return i.call(n, a, t);
    }, t);
    return r === void 0 && Qt(this, "_default") && (r = this.default()), r;
  },
  _validate: function(t, n) {
    var r = this;
    n === void 0 && (n = {});
    var a = t, i = n.originalValue != null ? n.originalValue : t, s = this._option("strict", n), o = this._option("abortEarly", n), l = n.sync, u = n.path, c = this._label;
    s || (a = this._cast(a, Ke({
      assert: !1
    }, n)));
    var d = {
      value: a,
      path: u,
      schema: this,
      options: n,
      label: c,
      originalValue: i,
      sync: l
    };
    n.from && (d.from = n.from);
    var f = [];
    return this._typeError && f.push(this._typeError(d)), this._whitelistError && f.push(this._whitelistError(d)), this._blacklistError && f.push(this._blacklistError(d)), _i({
      validations: f,
      endEarly: o,
      value: a,
      path: u,
      sync: l
    }).then(function(p) {
      return _i({
        path: u,
        sync: l,
        value: p,
        endEarly: o,
        validations: r.tests.map(function(h) {
          return h(d);
        })
      });
    });
  },
  validate: function(t, n) {
    n === void 0 && (n = {});
    var r = this.resolve(Ke({}, n, {
      value: t
    }));
    return r._validate(t, n);
  },
  validateSync: function(t, n) {
    n === void 0 && (n = {});
    var r = this.resolve(Ke({}, n, {
      value: t
    })), a, i;
    if (r._validate(t, Ke({}, n, {
      sync: !0
    })).then(function(s) {
      return a = s;
    }).catch(function(s) {
      return i = s;
    }), i) throw i;
    return a;
  },
  isValid: function(t, n) {
    return this.validate(t, n).then(function() {
      return !0;
    }).catch(function(r) {
      if (r.name === "ValidationError") return !1;
      throw r;
    });
  },
  isValidSync: function(t, n) {
    try {
      return this.validateSync(t, n), !0;
    } catch (r) {
      if (r.name === "ValidationError") return !1;
      throw r;
    }
  },
  getDefault: function(t) {
    t === void 0 && (t = {});
    var n = this.resolve(t);
    return n.default();
  },
  default: function(t) {
    if (arguments.length === 0) {
      var n = Qt(this, "_default") ? this._default : this._defaultDefault;
      return typeof n == "function" ? n.call(this) : T2(n);
    }
    var r = this.clone();
    return r._default = t, r;
  },
  strict: function(t) {
    t === void 0 && (t = !0);
    var n = this.clone();
    return n._options.strict = t, n;
  },
  _isPresent: function(t) {
    return t != null;
  },
  required: function(t) {
    return t === void 0 && (t = Hn.required), this.test({
      message: t,
      name: "required",
      exclusive: !0,
      test: function(r) {
        return this.schema._isPresent(r);
      }
    });
  },
  notRequired: function() {
    var t = this.clone();
    return t.tests = t.tests.filter(function(n) {
      return n.OPTIONS.name !== "required";
    }), t;
  },
  nullable: function(t) {
    t === void 0 && (t = !0);
    var n = this.clone();
    return n._nullable = t, n;
  },
  transform: function(t) {
    var n = this.clone();
    return n.transforms.push(t), n;
  },
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test: function() {
    var t;
    if (arguments.length === 1 ? typeof (arguments.length <= 0 ? void 0 : arguments[0]) == "function" ? t = {
      test: arguments.length <= 0 ? void 0 : arguments[0]
    } : t = arguments.length <= 0 ? void 0 : arguments[0] : arguments.length === 2 ? t = {
      name: arguments.length <= 0 ? void 0 : arguments[0],
      test: arguments.length <= 1 ? void 0 : arguments[1]
    } : t = {
      name: arguments.length <= 0 ? void 0 : arguments[0],
      message: arguments.length <= 1 ? void 0 : arguments[1],
      test: arguments.length <= 2 ? void 0 : arguments[2]
    }, t.message === void 0 && (t.message = Hn.default), typeof t.test != "function") throw new TypeError("`test` is a required parameters");
    var n = this.clone(), r = Pa(t), a = t.exclusive || t.name && n._exclusive[t.name] === !0;
    if (t.exclusive && !t.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return n._exclusive[t.name] = !!t.exclusive, n.tests = n.tests.filter(function(i) {
      return !(i.OPTIONS.name === t.name && (a || i.OPTIONS.test === r.OPTIONS.test));
    }), n.tests.push(r), n;
  },
  when: function(t, n) {
    arguments.length === 1 && (n = t, t = ".");
    var r = this.clone(), a = [].concat(t).map(function(i) {
      return new bn(i);
    });
    return a.forEach(function(i) {
      i.isSibling && r._deps.push(i.key);
    }), r._conditions.push(new gH(a, n)), r;
  },
  typeError: function(t) {
    var n = this.clone();
    return n._typeError = Pa({
      message: t,
      name: "typeError",
      test: function(a) {
        return a !== void 0 && !this.schema.isType(a) ? this.createError({
          params: {
            type: this.schema._type
          }
        }) : !0;
      }
    }), n;
  },
  oneOf: function(t, n) {
    n === void 0 && (n = Hn.oneOf);
    var r = this.clone();
    return t.forEach(function(a) {
      r._whitelist.add(a), r._blacklist.delete(a);
    }), r._whitelistError = Pa({
      message: n,
      name: "oneOf",
      test: function(i) {
        if (i === void 0) return !0;
        var s = this.schema._whitelist;
        return s.has(i, this.resolve) ? !0 : this.createError({
          params: {
            values: s.toArray().join(", ")
          }
        });
      }
    }), r;
  },
  notOneOf: function(t, n) {
    n === void 0 && (n = Hn.notOneOf);
    var r = this.clone();
    return t.forEach(function(a) {
      r._blacklist.add(a), r._whitelist.delete(a);
    }), r._blacklistError = Pa({
      message: n,
      name: "notOneOf",
      test: function(i) {
        var s = this.schema._blacklist;
        return s.has(i, this.resolve) ? this.createError({
          params: {
            values: s.toArray().join(", ")
          }
        }) : !0;
      }
    }), r;
  },
  strip: function(t) {
    t === void 0 && (t = !0);
    var n = this.clone();
    return n._strip = t, n;
  },
  _option: function(t, n) {
    return Qt(n, t) ? n[t] : this._options[t];
  },
  describe: function() {
    var t = this.clone(), n = {
      type: t._type,
      meta: t._meta,
      label: t._label,
      tests: t.tests.map(function(r) {
        return {
          name: r.OPTIONS.name,
          params: r.OPTIONS.params
        };
      }).filter(function(r, a, i) {
        return i.findIndex(function(s) {
          return s.name === r.name;
        }) === a;
      })
    };
    return t._whitelist.size && (n.oneOf = t._whitelist.describe()), t._blacklist.size && (n.notOneOf = t._blacklist.describe()), n;
  },
  defined: function(t) {
    return t === void 0 && (t = Hn.defined), this.nullable().test({
      message: t,
      name: "defined",
      exclusive: !0,
      test: function(r) {
        return r !== void 0;
      }
    });
  }
}, AG = function() {
  var t = fp[jl];
  Qn[t + "At"] = function(n, r, a) {
    a === void 0 && (a = {});
    var i = dp(this, n, r, a.context), s = i.parent, o = i.parentPath, l = i.schema;
    return l[t](s && s[o], Ke({}, a, {
      parent: s,
      path: n
    }));
  };
};
for (var jl = 0, fp = ["validate", "validateSync"]; jl < fp.length; jl++)
  AG();
for (var Ks = 0, U2 = ["equals", "is"]; Ks < U2.length; Ks++) {
  var EG = U2[Ks];
  Qn[EG] = Qn.oneOf;
}
for (var Zs = 0, H2 = ["not", "nope"]; Zs < H2.length; Zs++) {
  var OG = H2[Zs];
  Qn[OG] = Qn.notOneOf;
}
Qn.optional = Qn.notRequired;
function Dr(e, t, n) {
  e.prototype = Object.create(t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), Ke(e.prototype, n);
}
function ca() {
  var e = this;
  if (!(this instanceof ca)) return new ca();
  Ne.call(this, {
    type: "boolean"
  }), this.withMutation(function() {
    e.transform(function(t) {
      if (!this.isType(t)) {
        if (/^(true|1)$/i.test(t)) return !0;
        if (/^(false|0)$/i.test(t)) return !1;
      }
      return t;
    });
  });
}
Dr(ca, Ne, {
  _typeCheck: function(t) {
    return t instanceof Boolean && (t = t.valueOf()), typeof t == "boolean";
  }
});
const Je = function(e) {
  return e == null;
};
var TG = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i, MG = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i, kG = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i, LG = function(t) {
  return Je(t) || t === t.trim();
};
function Cr() {
  var e = this;
  if (!(this instanceof Cr)) return new Cr();
  Ne.call(this, {
    type: "string"
  }), this.withMutation(function() {
    e.transform(function(t) {
      return this.isType(t) ? t : t != null && t.toString ? t.toString() : t;
    });
  });
}
Dr(Cr, Ne, {
  _typeCheck: function(t) {
    return t instanceof String && (t = t.valueOf()), typeof t == "string";
  },
  _isPresent: function(t) {
    return Ne.prototype._isPresent.call(this, t) && t.length > 0;
  },
  length: function(t, n) {
    return n === void 0 && (n = Dt.length), this.test({
      message: n,
      name: "length",
      exclusive: !0,
      params: {
        length: t
      },
      test: function(a) {
        return Je(a) || a.length === this.resolve(t);
      }
    });
  },
  min: function(t, n) {
    return n === void 0 && (n = Dt.min), this.test({
      message: n,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test: function(a) {
        return Je(a) || a.length >= this.resolve(t);
      }
    });
  },
  max: function(t, n) {
    return n === void 0 && (n = Dt.max), this.test({
      name: "max",
      exclusive: !0,
      message: n,
      params: {
        max: t
      },
      test: function(a) {
        return Je(a) || a.length <= this.resolve(t);
      }
    });
  },
  matches: function(t, n) {
    var r = !1, a, i;
    return n && (typeof n == "object" ? (r = n.excludeEmptyString, a = n.message, i = n.name) : a = n), this.test({
      name: i || "matches",
      message: a || Dt.matches,
      params: {
        regex: t
      },
      test: function(o) {
        return Je(o) || o === "" && r || o.search(t) !== -1;
      }
    });
  },
  email: function(t) {
    return t === void 0 && (t = Dt.email), this.matches(TG, {
      name: "email",
      message: t,
      excludeEmptyString: !0
    });
  },
  url: function(t) {
    return t === void 0 && (t = Dt.url), this.matches(MG, {
      name: "url",
      message: t,
      excludeEmptyString: !0
    });
  },
  uuid: function(t) {
    return t === void 0 && (t = Dt.uuid), this.matches(kG, {
      name: "uuid",
      message: t,
      excludeEmptyString: !1
    });
  },
  //-- transforms --
  ensure: function() {
    return this.default("").transform(function(t) {
      return t === null ? "" : t;
    });
  },
  trim: function(t) {
    return t === void 0 && (t = Dt.trim), this.transform(function(n) {
      return n != null ? n.trim() : n;
    }).test({
      message: t,
      name: "trim",
      test: LG
    });
  },
  lowercase: function(t) {
    return t === void 0 && (t = Dt.lowercase), this.transform(function(n) {
      return Je(n) ? n : n.toLowerCase();
    }).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      test: function(r) {
        return Je(r) || r === r.toLowerCase();
      }
    });
  },
  uppercase: function(t) {
    return t === void 0 && (t = Dt.uppercase), this.transform(function(n) {
      return Je(n) ? n : n.toUpperCase();
    }).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      test: function(r) {
        return Je(r) || r === r.toUpperCase();
      }
    });
  }
});
var FG = function(t) {
  return t != +t;
};
function Si() {
  var e = this;
  if (!(this instanceof Si)) return new Si();
  Ne.call(this, {
    type: "number"
  }), this.withMutation(function() {
    e.transform(function(t) {
      var n = t;
      if (typeof n == "string") {
        if (n = n.replace(/\s/g, ""), n === "") return NaN;
        n = +n;
      }
      return this.isType(n) ? n : parseFloat(n);
    });
  });
}
Dr(Si, Ne, {
  _typeCheck: function(t) {
    return t instanceof Number && (t = t.valueOf()), typeof t == "number" && !FG(t);
  },
  min: function(t, n) {
    return n === void 0 && (n = An.min), this.test({
      message: n,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test: function(a) {
        return Je(a) || a >= this.resolve(t);
      }
    });
  },
  max: function(t, n) {
    return n === void 0 && (n = An.max), this.test({
      message: n,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      test: function(a) {
        return Je(a) || a <= this.resolve(t);
      }
    });
  },
  lessThan: function(t, n) {
    return n === void 0 && (n = An.lessThan), this.test({
      message: n,
      name: "max",
      exclusive: !0,
      params: {
        less: t
      },
      test: function(a) {
        return Je(a) || a < this.resolve(t);
      }
    });
  },
  moreThan: function(t, n) {
    return n === void 0 && (n = An.moreThan), this.test({
      message: n,
      name: "min",
      exclusive: !0,
      params: {
        more: t
      },
      test: function(a) {
        return Je(a) || a > this.resolve(t);
      }
    });
  },
  positive: function(t) {
    return t === void 0 && (t = An.positive), this.moreThan(0, t);
  },
  negative: function(t) {
    return t === void 0 && (t = An.negative), this.lessThan(0, t);
  },
  integer: function(t) {
    return t === void 0 && (t = An.integer), this.test({
      name: "integer",
      message: t,
      test: function(r) {
        return Je(r) || Number.isInteger(r);
      }
    });
  },
  truncate: function() {
    return this.transform(function(t) {
      return Je(t) ? t : t | 0;
    });
  },
  round: function(t) {
    var n = ["ceil", "floor", "round", "trunc"];
    if (t = t && t.toLowerCase() || "round", t === "trunc") return this.truncate();
    if (n.indexOf(t.toLowerCase()) === -1) throw new TypeError("Only valid options for round() are: " + n.join(", "));
    return this.transform(function(r) {
      return Je(r) ? r : Math[t](r);
    });
  }
});
var zG = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function PG(e) {
  var t = [1, 4, 5, 6, 7, 10, 11], n = 0, r, a;
  if (a = zG.exec(e)) {
    for (var i = 0, s; s = t[i]; ++i)
      a[s] = +a[s] || 0;
    a[2] = (+a[2] || 1) - 1, a[3] = +a[3] || 1, a[7] = a[7] ? String(a[7]).substr(0, 3) : 0, (a[8] === void 0 || a[8] === "") && (a[9] === void 0 || a[9] === "") ? r = +new Date(a[1], a[2], a[3], a[4], a[5], a[6], a[7]) : (a[8] !== "Z" && a[9] !== void 0 && (n = a[10] * 60 + a[11], a[9] === "+" && (n = 0 - n)), r = Date.UTC(a[1], a[2], a[3], a[4], a[5] + n, a[6], a[7]));
  } else r = Date.parse ? Date.parse(e) : NaN;
  return r;
}
var IG = /* @__PURE__ */ new Date(""), NG = function(t) {
  return Object.prototype.toString.call(t) === "[object Date]";
};
function Ci() {
  var e = this;
  if (!(this instanceof Ci)) return new Ci();
  Ne.call(this, {
    type: "date"
  }), this.withMutation(function() {
    e.transform(function(t) {
      return this.isType(t) ? t : (t = PG(t), isNaN(t) ? IG : new Date(t));
    });
  });
}
Dr(Ci, Ne, {
  _typeCheck: function(t) {
    return NG(t) && !isNaN(t.getTime());
  },
  min: function(t, n) {
    n === void 0 && (n = Nl.min);
    var r = t;
    if (!bn.isRef(r) && (r = this.cast(t), !this._typeCheck(r)))
      throw new TypeError("`min` must be a Date or a value that can be `cast()` to a Date");
    return this.test({
      message: n,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test: function(i) {
        return Je(i) || i >= this.resolve(r);
      }
    });
  },
  max: function(t, n) {
    n === void 0 && (n = Nl.max);
    var r = t;
    if (!bn.isRef(r) && (r = this.cast(t), !this._typeCheck(r)))
      throw new TypeError("`max` must be a Date or a value that can be `cast()` to a Date");
    return this.test({
      message: n,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      test: function(i) {
        return Je(i) || i <= this.resolve(r);
      }
    });
  }
});
function xa(e, t) {
  return t || (t = e.slice(0)), e.raw = t, e;
}
function DG(e, t, n, r) {
  for (var a = -1, i = e == null ? 0 : e.length; ++a < i; )
    n = t(n, e[a], a, e);
  return n;
}
function RG(e) {
  return function(t) {
    return e == null ? void 0 : e[t];
  };
}
var jG = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, BG = RG(jG), VG = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, UG = "\\u0300-\\u036f", HG = "\\ufe20-\\ufe2f", GG = "\\u20d0-\\u20ff", qG = UG + HG + GG, WG = "[" + qG + "]", YG = RegExp(WG, "g");
function KG(e) {
  return e = $a(e), e && e.replace(VG, BG).replace(YG, "");
}
var ZG = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function XG(e) {
  return e.match(ZG) || [];
}
var JG = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function QG(e) {
  return JG.test(e);
}
var pp = "\\ud800-\\udfff", eq = "\\u0300-\\u036f", tq = "\\ufe20-\\ufe2f", nq = "\\u20d0-\\u20ff", rq = eq + tq + nq, hp = "\\u2700-\\u27bf", mp = "a-z\\xdf-\\xf6\\xf8-\\xff", aq = "\\xac\\xb1\\xd7\\xf7", iq = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", sq = "\\u2000-\\u206f", oq = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", vp = "A-Z\\xc0-\\xd6\\xd8-\\xde", lq = "\\ufe0e\\ufe0f", gp = aq + iq + sq + oq, bp = "['’]", G2 = "[" + gp + "]", uq = "[" + rq + "]", $p = "\\d+", cq = "[" + hp + "]", yp = "[" + mp + "]", xp = "[^" + pp + gp + $p + hp + mp + vp + "]", dq = "\\ud83c[\\udffb-\\udfff]", fq = "(?:" + uq + "|" + dq + ")", pq = "[^" + pp + "]", _p = "(?:\\ud83c[\\udde6-\\uddff]){2}", wp = "[\\ud800-\\udbff][\\udc00-\\udfff]", dr = "[" + vp + "]", hq = "\\u200d", q2 = "(?:" + yp + "|" + xp + ")", mq = "(?:" + dr + "|" + xp + ")", W2 = "(?:" + bp + "(?:d|ll|m|re|s|t|ve))?", Y2 = "(?:" + bp + "(?:D|LL|M|RE|S|T|VE))?", Sp = fq + "?", Cp = "[" + lq + "]?", vq = "(?:" + hq + "(?:" + [pq, _p, wp].join("|") + ")" + Cp + Sp + ")*", gq = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", bq = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", $q = Cp + Sp + vq, yq = "(?:" + [cq, _p, wp].join("|") + ")" + $q, xq = RegExp([
  dr + "?" + yp + "+" + W2 + "(?=" + [G2, dr, "$"].join("|") + ")",
  mq + "+" + Y2 + "(?=" + [G2, dr + q2, "$"].join("|") + ")",
  dr + "?" + q2 + "+" + W2,
  dr + "+" + Y2,
  bq,
  gq,
  $p,
  yq
].join("|"), "g");
function _q(e) {
  return e.match(xq) || [];
}
function wq(e, t, n) {
  return e = $a(e), t = t, t === void 0 ? QG(e) ? _q(e) : XG(e) : e.match(t) || [];
}
var Sq = "['’]", Cq = RegExp(Sq, "g");
function Ap(e) {
  return function(t) {
    return DG(wq(KG(t).replace(Cq, "")), e, "");
  };
}
var K2 = Ap(function(e, t, n) {
  return e + (n ? "_" : "") + t.toLowerCase();
});
function Aq(e, t, n) {
  var r = -1, a = e.length;
  t < 0 && (t = -t > a ? 0 : a + t), n = n > a ? a : n, n < 0 && (n += a), a = t > n ? 0 : n - t >>> 0, t >>>= 0;
  for (var i = Array(a); ++r < a; )
    i[r] = e[r + t];
  return i;
}
function Eq(e, t, n) {
  var r = e.length;
  return n = n === void 0 ? r : n, !t && n >= r ? e : Aq(e, t, n);
}
function Oq(e) {
  return function(t) {
    t = $a(t);
    var n = q6(t) ? Q6(t) : void 0, r = n ? n[0] : t.charAt(0), a = n ? Eq(n, 1).join("") : t.slice(1);
    return r[e]() + a;
  };
}
var Tq = Oq("toUpperCase");
function Mq(e) {
  return Tq($a(e).toLowerCase());
}
var kq = Ap(function(e, t, n) {
  return t = t.toLowerCase(), e + (n ? Mq(t) : t);
});
function Lq(e, t) {
  var n = {};
  return t = up(t), ap(e, function(r, a, i) {
    Gu(n, t(r, a, i), r);
  }), n;
}
function Z2(e, t) {
  t === void 0 && (t = []);
  var n = [], r = [];
  function a(o, l) {
    var u = an.split(o)[0];
    ~r.indexOf(u) || r.push(u), ~t.indexOf(l + "-" + u) || n.push([l, u]);
  }
  for (var i in e)
    if (Qt(e, i)) {
      var s = e[i];
      ~r.indexOf(i) || r.push(i), bn.isRef(s) && s.isSibling ? a(s.path, i) : gn(s) && s._deps && s._deps.forEach(function(o) {
        return a(o, i);
      });
    }
  return $6.array(r, n).reverse();
}
function X2(e, t) {
  var n = 1 / 0;
  return e.some(function(r, a) {
    if (t.path.indexOf(r) !== -1)
      return n = a, !0;
  }), n;
}
function Fq(e) {
  var t = Object.keys(e);
  return function(n, r) {
    return X2(t, n) - X2(t, r);
  };
}
function Jr(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  var a = e.reduce(function(i, s) {
    var o = n.shift();
    return i + (o ?? "") + s;
  });
  return a.replace(/^\./, "");
}
function Ep() {
  var e = xa(["", '["', '"]']);
  return Ep = function() {
    return e;
  }, e;
}
function Op() {
  var e = xa(["", ".", ""]);
  return Op = function() {
    return e;
  }, e;
}
function Tp() {
  var e = xa(["", ".", ""]);
  return Tp = function() {
    return e;
  }, e;
}
var J2 = function(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}, zq = function(t) {
  return t ? ya.SynchronousPromise : Promise;
};
function Pq(e, t) {
  var n = Object.keys(e.fields);
  return Object.keys(t).filter(function(r) {
    return n.indexOf(r) === -1;
  });
}
function Ai(e) {
  var t = this;
  if (!(this instanceof Ai)) return new Ai(e);
  Ne.call(this, {
    type: "object",
    default: function() {
      var r = this;
      if (this._nodes.length) {
        var a = {};
        return this._nodes.forEach(function(i) {
          a[i] = r.fields[i].default ? r.fields[i].default() : void 0;
        }), a;
      }
    }
  }), this.fields = /* @__PURE__ */ Object.create(null), this._nodes = [], this._excludedEdges = [], this.withMutation(function() {
    t.transform(function(r) {
      if (typeof r == "string")
        try {
          r = JSON.parse(r);
        } catch {
          r = null;
        }
      return this.isType(r) ? r : null;
    }), e && t.shape(e);
  });
}
Dr(Ai, Ne, {
  _typeCheck: function(t) {
    return J2(t) || typeof t == "function";
  },
  _cast: function(t, n) {
    var r = this;
    n === void 0 && (n = {});
    var a = Ne.prototype._cast.call(this, t, n);
    if (a === void 0) return this.default();
    if (!this._typeCheck(a)) return a;
    var i = this.fields, s = this._option("stripUnknown", n) === !0, o = this._nodes.concat(Object.keys(a).filter(function(d) {
      return r._nodes.indexOf(d) === -1;
    })), l = {}, u = Ke({}, n, {
      parent: l,
      __validating: n.__validating || !1
    }), c = !1;
    return o.forEach(function(d) {
      var f = i[d], p = Qt(a, d);
      if (f) {
        var h, m = f._options && f._options.strict;
        if (u.path = Jr(Tp(), n.path, d), u.value = a[d], f = f.resolve(u), f._strip === !0) {
          c = c || d in a;
          return;
        }
        h = !n.__validating || !m ? f.cast(a[d], u) : a[d], h !== void 0 && (l[d] = h);
      } else p && !s && (l[d] = a[d]);
      l[d] !== a[d] && (c = !0);
    }), c ? l : a;
  },
  _validate: function(t, n) {
    var r = this;
    n === void 0 && (n = {});
    var a, i, s = n.sync, o = [], l = n.originalValue != null ? n.originalValue : t, u = [{
      schema: this,
      value: l
    }].concat(n.from || []);
    return a = this._option("abortEarly", n), i = this._option("recursive", n), n = Ke({}, n, {
      __validating: !0,
      originalValue: l,
      from: u
    }), Ne.prototype._validate.call(this, t, n).catch(np(a, o)).then(function(c) {
      if (!i || !J2(c)) {
        if (o.length) throw o[0];
        return c;
      }
      u = l ? [].concat(u) : [{
        schema: r,
        value: l || c
      }].concat(n.from || []), l = l || c;
      var d = r._nodes.map(function(f) {
        var p = f.indexOf(".") === -1 ? Jr(Op(), n.path, f) : Jr(Ep(), n.path, f), h = r.fields[f], m = Ke({}, n, {
          path: p,
          from: u,
          parent: c,
          originalValue: l[f]
        });
        return h && h.validate ? (m.strict = !0, h.validate(c[f], m)) : zq(s).resolve(!0);
      });
      return _i({
        sync: s,
        validations: d,
        value: c,
        errors: o,
        endEarly: a,
        path: n.path,
        sort: Fq(r.fields)
      });
    });
  },
  concat: function(t) {
    var n = Ne.prototype.concat.call(this, t);
    return n._nodes = Z2(n.fields, n._excludedEdges), n;
  },
  shape: function(t, n) {
    n === void 0 && (n = []);
    var r = this.clone(), a = Ke(r.fields, t);
    if (r.fields = a, n.length) {
      Array.isArray(n[0]) || (n = [n]);
      var i = n.map(function(s) {
        var o = s[0], l = s[1];
        return o + "-" + l;
      });
      r._excludedEdges = r._excludedEdges.concat(i);
    }
    return r._nodes = Z2(a, r._excludedEdges), r;
  },
  from: function(t, n, r) {
    var a = an.getter(t, !0);
    return this.transform(function(i) {
      if (i == null) return i;
      var s = i;
      return Qt(i, t) && (s = Ke({}, i), r || delete s[t], s[n] = a(i)), s;
    });
  },
  noUnknown: function(t, n) {
    t === void 0 && (t = !0), n === void 0 && (n = Dl.noUnknown), typeof t == "string" && (n = t, t = !0);
    var r = this.test({
      name: "noUnknown",
      exclusive: !0,
      message: n,
      test: function(i) {
        if (i == null) return !0;
        var s = Pq(this.schema, i);
        return !t || s.length === 0 || this.createError({
          params: {
            unknown: s.join(", ")
          }
        });
      }
    });
    return r._options.stripUnknown = t, r;
  },
  unknown: function(t, n) {
    return t === void 0 && (t = !0), n === void 0 && (n = Dl.noUnknown), this.noUnknown(!t, n);
  },
  transformKeys: function(t) {
    return this.transform(function(n) {
      return n && Lq(n, function(r, a) {
        return t(a);
      });
    });
  },
  camelCase: function() {
    return this.transformKeys(kq);
  },
  snakeCase: function() {
    return this.transformKeys(K2);
  },
  constantCase: function() {
    return this.transformKeys(function(t) {
      return K2(t).toUpperCase();
    });
  },
  describe: function() {
    var t = Ne.prototype.describe.call(this);
    return t.fields = cp(this.fields, function(n) {
      return n.describe();
    }), t;
  }
});
function Mp() {
  var e = xa(["", "[", "]"]);
  return Mp = function() {
    return e;
  }, e;
}
function kp() {
  var e = xa(["", "[", "]"]);
  return kp = function() {
    return e;
  }, e;
}
function Ei(e) {
  var t = this;
  if (!(this instanceof Ei)) return new Ei(e);
  Ne.call(this, {
    type: "array"
  }), this._subType = void 0, this.innerType = void 0, this.withMutation(function() {
    t.transform(function(n) {
      if (typeof n == "string") try {
        n = JSON.parse(n);
      } catch {
        n = null;
      }
      return this.isType(n) ? n : null;
    }), e && t.of(e);
  });
}
Dr(Ei, Ne, {
  _typeCheck: function(t) {
    return Array.isArray(t);
  },
  _cast: function(t, n) {
    var r = this, a = Ne.prototype._cast.call(this, t, n);
    if (!this._typeCheck(a) || !this.innerType) return a;
    var i = !1, s = a.map(function(o, l) {
      var u = r.innerType.cast(o, Ke({}, n, {
        path: Jr(kp(), n.path, l)
      }));
      return u !== o && (i = !0), u;
    });
    return i ? s : a;
  },
  _validate: function(t, n) {
    var r = this;
    n === void 0 && (n = {});
    var a = [], i = n.sync, s = n.path, o = this.innerType, l = this._option("abortEarly", n), u = this._option("recursive", n), c = n.originalValue != null ? n.originalValue : t;
    return Ne.prototype._validate.call(this, t, n).catch(np(l, a)).then(function(d) {
      if (!u || !o || !r._typeCheck(d)) {
        if (a.length) throw a[0];
        return d;
      }
      c = c || d;
      for (var f = new Array(d.length), p = 0; p < d.length; p++) {
        var h = d[p], m = Jr(Mp(), n.path, p), v = Ke({}, n, {
          path: m,
          strict: !0,
          parent: d,
          index: p,
          originalValue: c[p]
        });
        f[p] = o.validate ? o.validate(h, v) : !0;
      }
      return _i({
        sync: i,
        path: s,
        value: d,
        errors: a,
        endEarly: l,
        validations: f
      });
    });
  },
  _isPresent: function(t) {
    return Ne.prototype._isPresent.call(this, t) && t.length > 0;
  },
  of: function(t) {
    var n = this.clone();
    if (t !== !1 && !gn(t)) throw new TypeError("`array.of()` sub-schema must be a valid yup schema, or `false` to negate a current sub-schema. not: " + Sr(t));
    return n._subType = t, n.innerType = t, n;
  },
  min: function(t, n) {
    return n = n || Rl.min, this.test({
      message: n,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test: function(a) {
        return Je(a) || a.length >= this.resolve(t);
      }
    });
  },
  max: function(t, n) {
    return n = n || Rl.max, this.test({
      message: n,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      test: function(a) {
        return Je(a) || a.length <= this.resolve(t);
      }
    });
  },
  ensure: function() {
    var t = this;
    return this.default(function() {
      return [];
    }).transform(function(n, r) {
      return t._typeCheck(n) ? n : r == null ? [] : [].concat(r);
    });
  },
  compact: function(t) {
    var n = t ? function(r, a, i) {
      return !t(r, a, i);
    } : function(r) {
      return !!r;
    };
    return this.transform(function(r) {
      return r != null ? r.filter(n) : r;
    });
  },
  describe: function() {
    var t = Ne.prototype.describe.call(this);
    return this.innerType && (t.innerType = this.innerType.describe()), t;
  }
});
var Lp = /* @__PURE__ */ function() {
  function e(n) {
    this._resolve = function(r, a) {
      var i = n(r, a);
      if (!gn(i)) throw new TypeError("lazy() functions must return a valid schema");
      return i.resolve(a);
    };
  }
  var t = e.prototype;
  return t.resolve = function(r) {
    return this._resolve(r.value, r);
  }, t.cast = function(r, a) {
    return this._resolve(r, a).cast(r, a);
  }, t.validate = function(r, a) {
    return this._resolve(r, a).validate(r, a);
  }, t.validateSync = function(r, a) {
    return this._resolve(r, a).validateSync(r, a);
  }, t.validateAt = function(r, a, i) {
    return this._resolve(a, i).validateAt(r, a, i);
  }, t.validateSyncAt = function(r, a, i) {
    return this._resolve(a, i).validateSyncAt(r, a, i);
  }, e;
}();
Lp.prototype.__isYupSchema__ = !0;
function Iq(e) {
  Object.keys(e).forEach(function(t) {
    Object.keys(e[t]).forEach(function(n) {
      vH[t][n] = e[t][n];
    });
  });
}
var Nq = ca, Dq = function(t, n) {
  return new bn(t, n);
}, Rq = function(t) {
  return new Lp(t);
};
function Zu(e, t, n) {
  if (!e || !gn(e.prototype)) throw new TypeError("You must provide a yup schema constructor function");
  if (typeof t != "string") throw new TypeError("A Method name must be provided");
  if (typeof n != "function") throw new TypeError("Method function must be provided");
  e.prototype[t] = n;
}
const jq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ValidationError: Pt,
  addMethod: Zu,
  array: Ei,
  bool: ca,
  boolean: Nq,
  date: Ci,
  isSchema: gn,
  lazy: Rq,
  mixed: Ne,
  number: Si,
  object: Ai,
  reach: SG,
  ref: Dq,
  setLocale: Iq,
  string: Cr
}, Symbol.toStringTag, { value: "Module" }));
function Q2(e, t) {
  const n = {};
  return (e || []).forEach((r) => {
    const a = t(r);
    n[a] || (n[a] = []), n[a].push(r);
  }), n;
}
function Bq(e) {
  return Object.keys(e).map((t) => [t, e[t]]);
}
function Vq(e) {
  return typeof e == "number" && !isNaN(e);
}
function Uq(e, t) {
  return (e || []).reduce((n, r) => n && t(r), !0);
}
function Hq(e) {
  return e;
}
function Gq(e) {
  e = e || [];
  const t = e.length - 1;
  return t >= 0 ? e[t] : null;
}
function qq(e, t = !1, n = !1) {
  e = String(e);
  const r = e.split("");
  if (e.length !== 11 || e[0] === "0")
    return !1;
  const a = r.map((u) => parseInt(u, 10));
  if (!Uq(a, Vq))
    return !1;
  const i = a.slice(0, 10), s = Bq(Q2(i, Hq)), o = Q2(s, (u) => u[1].length);
  let l = !1;
  if ((!t && s.length === 9 && o[2] && o[2].length === 1 && o[1] && o[1].length === 8 || !n && s.length === 8 && o[3] && o[3].length === 1 && o[1] && o[1].length === 7) && (l = !0), l) {
    let u = 0, c = 10;
    for (let f = 0; f <= 9; f++)
      u = (i[f] + c) % 10, u === 0 && (u = 10), c = u * 2 % 11;
    let d = 11 - c;
    if (d === 10 && (d = 0), d === Gq(a))
      return !0;
  }
  return !1;
}
const Wq = { validate: qq };
var ed = { exports: {} }, Fp = { exports: {} };
(function(e) {
  function t(n) {
    return n && n.__esModule ? n : {
      default: n
    };
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Fp);
var on = Fp.exports, Ia = { exports: {} }, Xs = { exports: {} }, td;
function ns() {
  return td || (td = 1, function(e) {
    function t() {
      return e.exports = t = Object.assign ? Object.assign.bind() : function(n) {
        for (var r = 1; r < arguments.length; r++) {
          var a = arguments[r];
          for (var i in a) ({}).hasOwnProperty.call(a, i) && (n[i] = a[i]);
        }
        return n;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t.apply(null, arguments);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Xs)), Xs.exports;
}
var nd;
function Yq() {
  return nd || (nd = 1, function(e, t) {
    var n = on;
    t.__esModule = !0, t.default = a;
    var r = n(ns());
    function a(i, s, o) {
      i.prototype = Object.create(s.prototype, {
        constructor: {
          value: i,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), (0, r.default)(i.prototype, o);
    }
    e.exports = t.default;
  }(Ia, Ia.exports)), Ia.exports;
}
var Na = { exports: {} }, Js = { exports: {} }, Qs = { exports: {} }, eo = { exports: {} }, rd;
function zp() {
  return rd || (rd = 1, function(e) {
    function t(n) {
      "@babel/helpers - typeof";
      return e.exports = t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
        return typeof r;
      } : function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t(n);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(eo)), eo.exports;
}
var to = { exports: {} }, ad;
function Kq() {
  return ad || (ad = 1, function(e) {
    var t = zp().default;
    function n(r, a) {
      if (t(r) != "object" || !r) return r;
      var i = r[Symbol.toPrimitive];
      if (i !== void 0) {
        var s = i.call(r, a || "default");
        if (t(s) != "object") return s;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (a === "string" ? String : Number)(r);
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(to)), to.exports;
}
var id;
function Zq() {
  return id || (id = 1, function(e) {
    var t = zp().default, n = Kq();
    function r(a) {
      var i = n(a, "string");
      return t(i) == "symbol" ? i : i + "";
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Qs)), Qs.exports;
}
var sd;
function Xq() {
  return sd || (sd = 1, function(e) {
    var t = Zq();
    function n(a, i) {
      for (var s = 0; s < i.length; s++) {
        var o = i[s];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(a, t(o.key), o);
      }
    }
    function r(a, i, s) {
      return i && n(a.prototype, i), s && n(a, s), Object.defineProperty(a, "prototype", {
        writable: !1
      }), a;
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Js)), Js.exports;
}
var no, od;
function Jq() {
  if (od) return no;
  od = 1;
  function e(t, n) {
    for (var r = -1, a = t == null ? 0 : t.length; ++r < a && n(t[r], r, t) !== !1; )
      ;
    return t;
  }
  return no = e, no;
}
var ro, ld;
function Pp() {
  if (ld) return ro;
  ld = 1;
  var e = Ki, t = Cu, n = Object.prototype, r = n.hasOwnProperty;
  function a(i, s, o) {
    var l = i[s];
    (!(r.call(i, s) && t(l, o)) || o === void 0 && !(s in i)) && e(i, s, o);
  }
  return ro = a, ro;
}
var ao, ud;
function rs() {
  if (ud) return ao;
  ud = 1;
  var e = Pp(), t = Ki;
  function n(r, a, i, s) {
    var o = !i;
    i || (i = {});
    for (var l = -1, u = a.length; ++l < u; ) {
      var c = a[l], d = s ? s(i[c], r[c], c, i, r) : void 0;
      d === void 0 && (d = r[c]), o ? t(i, c, d) : e(i, c, d);
    }
    return i;
  }
  return ao = n, ao;
}
var io, cd;
function Qq() {
  if (cd) return io;
  cd = 1;
  var e = rs(), t = Ir;
  function n(r, a) {
    return r && e(a, t(a), r);
  }
  return io = n, io;
}
var so, dd;
function eW() {
  if (dd) return so;
  dd = 1;
  function e(t) {
    var n = [];
    if (t != null)
      for (var r in Object(t))
        n.push(r);
    return n;
  }
  return so = e, so;
}
var oo, fd;
function tW() {
  if (fd) return oo;
  fd = 1;
  var e = Lr, t = Fu, n = eW(), r = Object.prototype, a = r.hasOwnProperty;
  function i(s) {
    if (!e(s))
      return n(s);
    var o = t(s), l = [];
    for (var u in s)
      u == "constructor" && (o || !a.call(s, u)) || l.push(u);
    return l;
  }
  return oo = i, oo;
}
var lo, pd;
function Xu() {
  if (pd) return lo;
  pd = 1;
  var e = C4, t = tW(), n = zu;
  function r(a) {
    return n(a) ? e(a, !0) : t(a);
  }
  return lo = r, lo;
}
var uo, hd;
function nW() {
  if (hd) return uo;
  hd = 1;
  var e = rs(), t = Xu();
  function n(r, a) {
    return r && e(a, t(a), r);
  }
  return uo = n, uo;
}
var Wr = { exports: {} };
Wr.exports;
var md;
function rW() {
  return md || (md = 1, function(e, t) {
    var n = rn, r = t && !t.nodeType && t, a = r && !0 && e && !e.nodeType && e, i = a && a.exports === r, s = i ? n.Buffer : void 0, o = s ? s.allocUnsafe : void 0;
    function l(u, c) {
      if (c)
        return u.slice();
      var d = u.length, f = o ? o(d) : new u.constructor(d);
      return u.copy(f), f;
    }
    e.exports = l;
  }(Wr, Wr.exports)), Wr.exports;
}
var co, vd;
function Ip() {
  if (vd) return co;
  vd = 1;
  function e(t, n) {
    var r = -1, a = t.length;
    for (n || (n = Array(a)); ++r < a; )
      n[r] = t[r];
    return n;
  }
  return co = e, co;
}
var fo, gd;
function aW() {
  if (gd) return fo;
  gd = 1;
  var e = rs(), t = Iu();
  function n(r, a) {
    return e(r, t(r), a);
  }
  return fo = n, fo;
}
var po, bd;
function Np() {
  if (bd) return po;
  bd = 1;
  var e = A4, t = e(Object.getPrototypeOf, Object);
  return po = t, po;
}
var ho, $d;
function Dp() {
  if ($d) return ho;
  $d = 1;
  var e = L4(), t = Np(), n = Iu(), r = z4(), a = Object.getOwnPropertySymbols, i = a ? function(s) {
    for (var o = []; s; )
      e(o, n(s)), s = t(s);
    return o;
  } : r;
  return ho = i, ho;
}
var mo, yd;
function iW() {
  if (yd) return mo;
  yd = 1;
  var e = rs(), t = Dp();
  function n(r, a) {
    return e(r, t(r), a);
  }
  return mo = n, mo;
}
var vo, xd;
function sW() {
  if (xd) return vo;
  xd = 1;
  var e = F4(), t = Dp(), n = Xu();
  function r(a) {
    return e(a, n, t);
  }
  return vo = r, vo;
}
var go, _d;
function oW() {
  if (_d) return go;
  _d = 1;
  var e = Object.prototype, t = e.hasOwnProperty;
  function n(r) {
    var a = r.length, i = new r.constructor(a);
    return a && typeof r[0] == "string" && t.call(r, "index") && (i.index = r.index, i.input = r.input), i;
  }
  return go = n, go;
}
var bo, wd;
function Ju() {
  if (wd) return bo;
  wd = 1;
  var e = T4;
  function t(n) {
    var r = new n.constructor(n.byteLength);
    return new e(r).set(new e(n)), r;
  }
  return bo = t, bo;
}
var $o, Sd;
function lW() {
  if (Sd) return $o;
  Sd = 1;
  var e = Ju();
  function t(n, r) {
    var a = r ? e(n.buffer) : n.buffer;
    return new n.constructor(a, n.byteOffset, n.byteLength);
  }
  return $o = t, $o;
}
var yo, Cd;
function uW() {
  if (Cd) return yo;
  Cd = 1;
  var e = /\w*$/;
  function t(n) {
    var r = new n.constructor(n.source, e.exec(n));
    return r.lastIndex = n.lastIndex, r;
  }
  return yo = t, yo;
}
var xo, Ad;
function cW() {
  if (Ad) return xo;
  Ad = 1;
  var e = Mr, t = e ? e.prototype : void 0, n = t ? t.valueOf : void 0;
  function r(a) {
    return n ? Object(n.call(a)) : {};
  }
  return xo = r, xo;
}
var _o, Ed;
function dW() {
  if (Ed) return _o;
  Ed = 1;
  var e = Ju();
  function t(n, r) {
    var a = r ? e(n.buffer) : n.buffer;
    return new n.constructor(a, n.byteOffset, n.length);
  }
  return _o = t, _o;
}
var wo, Od;
function fW() {
  if (Od) return wo;
  Od = 1;
  var e = Ju(), t = lW(), n = uW(), r = cW(), a = dW(), i = "[object Boolean]", s = "[object Date]", o = "[object Map]", l = "[object Number]", u = "[object RegExp]", c = "[object Set]", d = "[object String]", f = "[object Symbol]", p = "[object ArrayBuffer]", h = "[object DataView]", m = "[object Float32Array]", v = "[object Float64Array]", g = "[object Int8Array]", b = "[object Int16Array]", $ = "[object Int32Array]", y = "[object Uint8Array]", A = "[object Uint8ClampedArray]", E = "[object Uint16Array]", L = "[object Uint32Array]";
  function D(ne, I, B) {
    var ae = ne.constructor;
    switch (I) {
      case p:
        return e(ne);
      case i:
      case s:
        return new ae(+ne);
      case h:
        return t(ne, B);
      case m:
      case v:
      case g:
      case b:
      case $:
      case y:
      case A:
      case E:
      case L:
        return a(ne, B);
      case o:
        return new ae();
      case l:
      case d:
        return new ae(ne);
      case u:
        return n(ne);
      case c:
        return new ae();
      case f:
        return r(ne);
    }
  }
  return wo = D, wo;
}
var So, Td;
function pW() {
  if (Td) return So;
  Td = 1;
  var e = Lr, t = Object.create, n = /* @__PURE__ */ function() {
    function r() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (t)
        return t(a);
      r.prototype = a;
      var i = new r();
      return r.prototype = void 0, i;
    };
  }();
  return So = n, So;
}
var Co, Md;
function hW() {
  if (Md) return Co;
  Md = 1;
  var e = pW(), t = Np(), n = Fu;
  function r(a) {
    return typeof a.constructor == "function" && !n(a) ? e(t(a)) : {};
  }
  return Co = r, Co;
}
var Ao, kd;
function mW() {
  if (kd) return Ao;
  kd = 1;
  var e = ga(), t = jn, n = "[object Map]";
  function r(a) {
    return t(a) && e(a) == n;
  }
  return Ao = r, Ao;
}
var Eo, Ld;
function vW() {
  if (Ld) return Eo;
  Ld = 1;
  var e = mW(), t = ku, n = Lu, r = n && n.isMap, a = r ? t(r) : e;
  return Eo = a, Eo;
}
var Oo, Fd;
function gW() {
  if (Fd) return Oo;
  Fd = 1;
  var e = ga(), t = jn, n = "[object Set]";
  function r(a) {
    return t(a) && e(a) == n;
  }
  return Oo = r, Oo;
}
var To, zd;
function bW() {
  if (zd) return To;
  zd = 1;
  var e = gW(), t = ku, n = Lu, r = n && n.isSet, a = r ? t(r) : e;
  return To = a, To;
}
var Mo, Pd;
function $W() {
  if (Pd) return Mo;
  Pd = 1;
  var e = Pu, t = Jq(), n = Pp(), r = Qq(), a = nW(), i = rW(), s = Ip(), o = aW(), l = iW(), u = P4(), c = sW(), d = ga(), f = oW(), p = fW(), h = hW(), m = nn, v = Mu, g = vW(), b = Lr, $ = bW(), y = Ir, A = Xu(), E = 1, L = 2, D = 4, ne = "[object Arguments]", I = "[object Array]", B = "[object Boolean]", ae = "[object Date]", we = "[object Error]", Q = "[object Function]", W = "[object GeneratorFunction]", O = "[object Map]", _ = "[object Number]", w = "[object Object]", F = "[object RegExp]", j = "[object Set]", Y = "[object String]", ie = "[object Symbol]", Ae = "[object WeakMap]", ge = "[object ArrayBuffer]", Pe = "[object DataView]", ee = "[object Float32Array]", ue = "[object Float64Array]", ye = "[object Int8Array]", $e = "[object Int16Array]", be = "[object Int32Array]", qe = "[object Uint8Array]", He = "[object Uint8ClampedArray]", Kt = "[object Uint16Array]", it = "[object Uint32Array]", ke = {};
  ke[ne] = ke[I] = ke[ge] = ke[Pe] = ke[B] = ke[ae] = ke[ee] = ke[ue] = ke[ye] = ke[$e] = ke[be] = ke[O] = ke[_] = ke[w] = ke[F] = ke[j] = ke[Y] = ke[ie] = ke[qe] = ke[He] = ke[Kt] = ke[it] = !0, ke[we] = ke[Q] = ke[Ae] = !1;
  function It(Ee, Mt, pt, V, X, Z) {
    var _e, gt = Mt & E, wn = Mt & L, Bn = Mt & D;
    if (pt && (_e = X ? pt(Ee, V, X, Z) : pt(Ee)), _e !== void 0)
      return _e;
    if (!b(Ee))
      return Ee;
    var ln = m(Ee);
    if (ln) {
      if (_e = f(Ee), !gt)
        return s(Ee, _e);
    } else {
      var Zt = d(Ee), or = Zt == Q || Zt == W;
      if (v(Ee))
        return i(Ee, gt);
      if (Zt == w || Zt == ne || or && !X) {
        if (_e = wn || or ? {} : h(Ee), !gt)
          return wn ? l(Ee, a(_e, Ee)) : o(Ee, r(_e, Ee));
      } else {
        if (!ke[Zt])
          return X ? Ee : {};
        _e = p(Ee, Zt, gt);
      }
    }
    Z || (Z = new e());
    var un = Z.get(Ee);
    if (un)
      return un;
    Z.set(Ee, _e), $(Ee) ? Ee.forEach(function(R) {
      _e.add(It(R, Mt, pt, R, Ee, Z));
    }) : g(Ee) && Ee.forEach(function(R, J) {
      _e.set(J, It(R, Mt, pt, J, Ee, Z));
    });
    var k = Bn ? wn ? c : u : wn ? A : y, M = ln ? void 0 : k(Ee);
    return t(M || Ee, function(R, J) {
      M && (J = R, R = Ee[J]), n(_e, J, It(R, Mt, pt, J, Ee, Z));
    }), _e;
  }
  return Mo = It, Mo;
}
var ko, Id;
function yW() {
  if (Id) return ko;
  Id = 1;
  var e = $W(), t = 1, n = 4;
  function r(a, i) {
    return i = typeof i == "function" ? i : void 0, e(a, t | n, i);
  }
  return ko = r, ko;
}
var Lo, Nd;
function xW() {
  if (Nd) return Lo;
  Nd = 1;
  var e = kr, t = nn, n = jn, r = "[object String]";
  function a(i) {
    return typeof i == "string" || !t(i) && n(i) && e(i) == r;
  }
  return Lo = a, Lo;
}
var Fo, Dd;
function _W() {
  if (Dd) return Fo;
  Dd = 1;
  function e(t) {
    for (var n, r = []; !(n = t.next()).done; )
      r.push(n.value);
    return r;
  }
  return Fo = e, Fo;
}
var zo, Rd;
function wW() {
  if (Rd) return zo;
  Rd = 1;
  var e = v4;
  function t(n, r) {
    return e(r, function(a) {
      return n[a];
    });
  }
  return zo = t, zo;
}
var Po, jd;
function SW() {
  if (jd) return Po;
  jd = 1;
  var e = wW(), t = Ir;
  function n(r) {
    return r == null ? [] : e(r, t(r));
  }
  return Po = n, Po;
}
var Io, Bd;
function CW() {
  if (Bd) return Io;
  Bd = 1;
  var e = Mr, t = Ip(), n = ga(), r = zu, a = xW(), i = _W(), s = M4(), o = k4(), l = g6, u = SW(), c = "[object Map]", d = "[object Set]", f = e ? e.iterator : void 0;
  function p(h) {
    if (!h)
      return [];
    if (r(h))
      return a(h) ? l(h) : t(h);
    if (f && h[f])
      return i(h[f]());
    var m = n(h), v = m == c ? s : m == d ? o : u;
    return v(h);
  }
  return Io = p, Io;
}
var Qe = {}, Da = { exports: {} }, Vd;
function Qu() {
  return Vd || (Vd = 1, function(e, t) {
    t.__esModule = !0, t.default = u;
    var n = Object.prototype.toString, r = Error.prototype.toString, a = RegExp.prototype.toString, i = typeof Symbol < "u" ? Symbol.prototype.toString : function() {
      return "";
    }, s = /^Symbol\((.*)\)(.*)$/;
    function o(c) {
      if (c != +c) return "NaN";
      var d = c === 0 && 1 / c < 0;
      return d ? "-0" : "" + c;
    }
    function l(c, d) {
      if (d === void 0 && (d = !1), c == null || c === !0 || c === !1) return "" + c;
      var f = typeof c;
      if (f === "number") return o(c);
      if (f === "string") return d ? '"' + c + '"' : c;
      if (f === "function") return "[Function " + (c.name || "anonymous") + "]";
      if (f === "symbol") return i.call(c).replace(s, "Symbol($1)");
      var p = n.call(c).slice(8, -1);
      return p === "Date" ? isNaN(c.getTime()) ? "" + c : c.toISOString(c) : p === "Error" || c instanceof Error ? "[" + r.call(c) + "]" : p === "RegExp" ? a.call(c) : null;
    }
    function u(c, d) {
      var f = l(c, d);
      return f !== null ? f : JSON.stringify(c, function(p, h) {
        var m = l(this[p], d);
        return m !== null ? m : h;
      }, 2);
    }
    e.exports = t.default;
  }(Da, Da.exports)), Da.exports;
}
var Ud;
function Rp() {
  if (Ud) return Qe;
  Ud = 1;
  var e = on;
  Qe.__esModule = !0, Qe.default = Qe.array = Qe.object = Qe.boolean = Qe.date = Qe.number = Qe.string = Qe.mixed = void 0;
  var t = e(Qu()), n = {
    default: "${path} is invalid",
    required: "${path} is a required field",
    oneOf: "${path} must be one of the following values: ${values}",
    notOneOf: "${path} must not be one of the following values: ${values}",
    notType: function(d) {
      var f = d.path, p = d.type, h = d.value, m = d.originalValue, v = m != null && m !== h, g = f + " must be a `" + p + "` type, " + ("but the final value was: `" + (0, t.default)(h, !0) + "`") + (v ? " (cast from the value `" + (0, t.default)(m, !0) + "`)." : ".");
      return h === null && (g += '\n If "null" is intended as an empty value be sure to mark the schema as `.nullable()`'), g;
    },
    defined: "${path} must be defined"
  };
  Qe.mixed = n;
  var r = {
    length: "${path} must be exactly ${length} characters",
    min: "${path} must be at least ${min} characters",
    max: "${path} must be at most ${max} characters",
    matches: '${path} must match the following: "${regex}"',
    email: "${path} must be a valid email",
    url: "${path} must be a valid URL",
    uuid: "${path} must be a valid UUID",
    trim: "${path} must be a trimmed string",
    lowercase: "${path} must be a lowercase string",
    uppercase: "${path} must be a upper case string"
  };
  Qe.string = r;
  var a = {
    min: "${path} must be greater than or equal to ${min}",
    max: "${path} must be less than or equal to ${max}",
    lessThan: "${path} must be less than ${less}",
    moreThan: "${path} must be greater than ${more}",
    notEqual: "${path} must be not equal to ${notEqual}",
    positive: "${path} must be a positive number",
    negative: "${path} must be a negative number",
    integer: "${path} must be an integer"
  };
  Qe.number = a;
  var i = {
    min: "${path} field must be later than ${min}",
    max: "${path} field must be at earlier than ${max}"
  };
  Qe.date = i;
  var s = {};
  Qe.boolean = s;
  var o = {
    noUnknown: "${path} field has unspecified keys: ${unknown}"
  };
  Qe.object = o;
  var l = {
    min: "${path} field must have at least ${min} items",
    max: "${path} field must have less than or equal to ${max} items"
  };
  Qe.array = l;
  var u = {
    mixed: n,
    string: r,
    number: a,
    date: i,
    object: o,
    array: l,
    boolean: s
  };
  return Qe.default = u, Qe;
}
var Ra = { exports: {} }, ja = { exports: {} }, Hd;
function e1() {
  return Hd || (Hd = 1, function(e, t) {
    t.__esModule = !0, t.default = void 0;
    var n = function(a) {
      return a && a.__isYupSchema__;
    };
    t.default = n, e.exports = t.default;
  }(ja, ja.exports)), ja.exports;
}
var Gd;
function AW() {
  return Gd || (Gd = 1, function(e, t) {
    var n = on;
    t.__esModule = !0, t.default = void 0;
    var r = n(Wi), a = n(e1()), i = /* @__PURE__ */ function() {
      function o(u, c) {
        if (this.refs = u, typeof c == "function") {
          this.fn = c;
          return;
        }
        if (!(0, r.default)(c, "is")) throw new TypeError("`is:` is required for `when()` conditions");
        if (!c.then && !c.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
        var d = c.is, f = c.then, p = c.otherwise, h = typeof d == "function" ? d : function() {
          for (var m = arguments.length, v = new Array(m), g = 0; g < m; g++)
            v[g] = arguments[g];
          return v.every(function(b) {
            return b === d;
          });
        };
        this.fn = function() {
          for (var m = arguments.length, v = new Array(m), g = 0; g < m; g++)
            v[g] = arguments[g];
          var b = v.pop(), $ = v.pop(), y = h.apply(void 0, v) ? f : p;
          if (y)
            return typeof y == "function" ? y($) : $.concat(y.resolve(b));
        };
      }
      var l = o.prototype;
      return l.resolve = function(c, d) {
        var f = this.refs.map(function(h) {
          return h.getValue(d);
        }), p = this.fn.apply(c, f.concat(c, d));
        if (p === void 0 || p === c) return c;
        if (!(0, a.default)(p)) throw new TypeError("conditions must return a schema object");
        return p.resolve(d);
      }, o;
    }(), s = i;
    t.default = s, e.exports = t.default;
  }(Ra, Ra.exports)), Ra.exports;
}
var Vn = {}, No = { exports: {} }, qd;
function jp() {
  return qd || (qd = 1, function(e) {
    function t(n, r) {
      if (n == null) return {};
      var a = {};
      for (var i in n) if ({}.hasOwnProperty.call(n, i)) {
        if (r.indexOf(i) !== -1) continue;
        a[i] = n[i];
      }
      return a;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(No)), No.exports;
}
var Ba = { exports: {} }, Wd;
function Bp() {
  return Wd || (Wd = 1, function(e, t) {
    var n = on;
    t.__esModule = !0, t.default = s;
    var r = n(Qu()), a = /\$\{\s*(\w+)\s*\}/g, i = function(l) {
      return function(u) {
        return l.replace(a, function(c, d) {
          return (0, r.default)(u[d]);
        });
      };
    };
    function s(o, l, u, c) {
      var d = this;
      this.name = "ValidationError", this.value = l, this.path = u, this.type = c, this.errors = [], this.inner = [], o && [].concat(o).forEach(function(f) {
        d.errors = d.errors.concat(f.errors || f), f.inner && (d.inner = d.inner.concat(f.inner.length ? f.inner : f));
      }), this.message = this.errors.length > 1 ? this.errors.length + " errors occurred" : this.errors[0], Error.captureStackTrace && Error.captureStackTrace(this, s);
    }
    s.prototype = Object.create(Error.prototype), s.prototype.constructor = s, s.isError = function(o) {
      return o && o.name === "ValidationError";
    }, s.formatError = function(o, l) {
      typeof o == "string" && (o = i(o));
      var u = function(d) {
        return d.path = d.label || d.path || "this", typeof o == "function" ? o(d) : o;
      };
      return arguments.length === 1 ? u : u(l);
    }, e.exports = t.default;
  }(Ba, Ba.exports)), Ba.exports;
}
var Yd;
function EW() {
  if (Yd) return Vn;
  Yd = 1;
  var e = on;
  Vn.__esModule = !0, Vn.propagateErrors = o, Vn.settled = l, Vn.collectErrors = u, Vn.default = c;
  var t = e(jp()), n = ya, r = e(Bp()), a = function(f) {
    return f ? n.SynchronousPromise : Promise;
  }, i = function(f) {
    return f === void 0 && (f = []), f.inner && f.inner.length ? f.inner : [].concat(f);
  };
  function s(d, f, p) {
    var h = a(p).all(d), m = h.catch(function(g) {
      throw g.name === "ValidationError" && (g.value = f), g;
    }), v = m.then(function() {
      return f;
    });
    return v;
  }
  function o(d, f) {
    return d ? null : function(p) {
      return f.push(p), p.value;
    };
  }
  function l(d, f) {
    var p = a(f);
    return p.all(d.map(function(h) {
      return p.resolve(h).then(function(m) {
        return {
          fulfilled: !0,
          value: m
        };
      }, function(m) {
        return {
          fulfilled: !1,
          value: m
        };
      });
    }));
  }
  function u(d) {
    var f = d.validations, p = d.value, h = d.path, m = d.sync, v = d.errors, g = d.sort;
    return v = i(v), l(f, m).then(function(b) {
      var $ = b.filter(function(y) {
        return !y.fulfilled;
      }).reduce(function(y, A) {
        var E = A.value;
        if (!r.default.isError(E))
          throw E;
        return y.concat(E);
      }, []);
      if (g && $.sort(g), v = $.concat(v), v.length) throw new r.default(v, p, h);
      return p;
    });
  }
  function c(d) {
    var f = d.endEarly, p = (0, t.default)(d, ["endEarly"]);
    return f ? s(p.validations, p.value, p.sync) : u(p);
  }
  return Vn;
}
var Va = { exports: {} }, Kd;
function OW() {
  return Kd || (Kd = 1, function(e, t) {
    var n = on;
    t.__esModule = !0, t.default = s;
    var r = n(Wi), a = n(e1()), i = function(l) {
      return Object.prototype.toString.call(l) === "[object Object]";
    };
    function s(o, l) {
      for (var u in l)
        if ((0, r.default)(l, u)) {
          var c = l[u], d = o[u];
          if (d === void 0)
            o[u] = c;
          else {
            if (d === c)
              continue;
            (0, a.default)(d) ? (0, a.default)(c) && (o[u] = c.concat(d)) : i(d) ? i(c) && (o[u] = s(d, c)) : Array.isArray(d) && Array.isArray(c) && (o[u] = c.concat(d));
          }
        }
      return o;
    }
    e.exports = t.default;
  }(Va, Va.exports)), Va.exports;
}
var Vr = {}, Ua = { exports: {} }, Zd;
function Vp() {
  return Zd || (Zd = 1, function(e, t) {
    var n = on;
    t.__esModule = !0, t.default = void 0;
    var r = n(ns()), a = an, i = {
      context: "$",
      value: "."
    }, s = /* @__PURE__ */ function() {
      function o(u, c) {
        if (c === void 0 && (c = {}), typeof u != "string") throw new TypeError("ref must be a string, got: " + u);
        if (this.key = u.trim(), u === "") throw new TypeError("ref must be a non-empty string");
        this.isContext = this.key[0] === i.context, this.isValue = this.key[0] === i.value, this.isSibling = !this.isContext && !this.isValue;
        var d = this.isContext ? i.context : this.isValue ? i.value : "";
        this.path = this.key.slice(d.length), this.getter = this.path && (0, a.getter)(this.path, !0), this.map = c.map;
      }
      var l = o.prototype;
      return l.getValue = function(c) {
        var d = this.isContext ? c.context : this.isValue ? c.value : c.parent;
        return this.getter && (d = this.getter(d || {})), this.map && (d = this.map(d)), d;
      }, l.cast = function(c, d) {
        return this.getValue((0, r.default)({}, d, {
          value: c
        }));
      }, l.resolve = function() {
        return this;
      }, l.describe = function() {
        return {
          type: "ref",
          key: this.key
        };
      }, l.toString = function() {
        return "Ref(" + this.key + ")";
      }, o.isRef = function(c) {
        return c && c.__isYupRef;
      }, o;
    }();
    t.default = s, s.prototype.__isYupRef = !0, e.exports = t.default;
  }(Ua, Ua.exports)), Ua.exports;
}
var Xd;
function TW() {
  if (Xd) return Vr;
  Xd = 1;
  var e = on;
  Vr.__esModule = !0, Vr.createErrorFactory = d, Vr.default = f;
  var t = e(jp()), n = e(ns()), r = e(V4), a = e(Bp()), i = e(Vp()), s = ya, o = a.default.formatError, l = function(h) {
    return h && typeof h.then == "function" && typeof h.catch == "function";
  };
  function u(p, h, m, v) {
    var g = p.call(h, m);
    if (!v) return Promise.resolve(g);
    if (l(g))
      throw new Error('Validation test of type: "' + h.type + '" returned a Promise during a synchronous validate. This test will finish after the validate call has returned');
    return s.SynchronousPromise.resolve(g);
  }
  function c(p, h, m) {
    return (0, r.default)((0, n.default)({}, p, h), m);
  }
  function d(p) {
    var h = p.value, m = p.label, v = p.resolve, g = p.originalValue, b = (0, t.default)(p, ["value", "label", "resolve", "originalValue"]);
    return function(y) {
      var A = y === void 0 ? {} : y, E = A.path, L = E === void 0 ? b.path : E, D = A.message, ne = D === void 0 ? b.message : D, I = A.type, B = I === void 0 ? b.name : I, ae = A.params;
      return ae = (0, n.default)({
        path: L,
        value: h,
        originalValue: g,
        label: m
      }, c(b.params, ae, v)), (0, n.default)(new a.default(o(ne, ae), h, L, B), {
        params: ae
      });
    };
  }
  function f(p) {
    var h = p.name, m = p.message, v = p.test, g = p.params;
    function b($) {
      var y = $.value, A = $.path, E = $.label, L = $.options, D = $.originalValue, ne = $.sync, I = (0, t.default)($, ["value", "path", "label", "options", "originalValue", "sync"]), B = L.parent, ae = function(O) {
        return i.default.isRef(O) ? O.getValue({
          value: y,
          parent: B,
          context: L.context
        }) : O;
      }, we = d({
        message: m,
        path: A,
        value: y,
        originalValue: D,
        params: g,
        label: E,
        resolve: ae,
        name: h
      }), Q = (0, n.default)({
        path: A,
        parent: B,
        type: h,
        createError: we,
        resolve: ae,
        options: L
      }, I);
      return u(v, Q, y, ne).then(function(W) {
        if (a.default.isError(W)) throw W;
        if (!W) throw we();
      });
    }
    return b.OPTIONS = p, b;
  }
  return Vr;
}
var ur = {}, Jd;
function MW() {
  if (Jd) return ur;
  Jd = 1, ur.__esModule = !0, ur.getIn = n, ur.default = void 0;
  var e = an, t = function(s) {
    return s.substr(0, s.length - 1).substr(1);
  };
  function n(i, s, o, l) {
    l === void 0 && (l = o);
    var u, c, d;
    return s ? ((0, e.forEach)(s, function(f, p, h) {
      var m = p ? t(f) : f;
      if (i = i.resolve({
        context: l,
        parent: u,
        value: o
      }), i.innerType) {
        var v = h ? parseInt(m, 10) : 0;
        if (o && v >= o.length)
          throw new Error("Yup.reach cannot resolve an array item at index: " + f + ", in the path: " + s + ". because there is no value at that index. ");
        u = o, o = o && o[v], i = i.innerType;
      }
      if (!h) {
        if (!i.fields || !i.fields[m]) throw new Error("The schema does not contain the path: " + s + ". " + ("(failed at: " + d + ' which is a type: "' + i._type + '")'));
        u = o, o = o && o[m], i = i.fields[m];
      }
      c = m, d = p ? "[" + f + "]" : "." + f;
    }), {
      schema: i,
      parent: u,
      parentPath: c
    }) : {
      parent: u,
      parentPath: s,
      schema: i
    };
  }
  var r = function(s, o, l, u) {
    return n(s, o, l, u).schema;
  }, a = r;
  return ur.default = a, ur;
}
var Qd;
function kW() {
  return Qd || (Qd = 1, function(e, t) {
    var n = on;
    t.__esModule = !0, t.default = A;
    var r = n(ns()), a = n(Xq()), i = n(Wi), s = n(yW()), o = n(CW()), l = Rp(), u = n(AW()), c = n(EW()), d = n(OW()), f = n(e1()), p = n(TW()), h = n(Qu()), m = n(Vp()), v = MW();
    function g(O, _) {
      var w;
      if (typeof Symbol > "u" || O[Symbol.iterator] == null) {
        if (Array.isArray(O) || (w = b(O)) || _) {
          w && (O = w);
          var F = 0;
          return function() {
            return F >= O.length ? { done: !0 } : { done: !1, value: O[F++] };
          };
        }
        throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }
      return w = O[Symbol.iterator](), w.next.bind(w);
    }
    function b(O, _) {
      if (O) {
        if (typeof O == "string") return $(O, _);
        var w = Object.prototype.toString.call(O).slice(8, -1);
        if (w === "Object" && O.constructor && (w = O.constructor.name), w === "Map" || w === "Set") return Array.from(O);
        if (w === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(w)) return $(O, _);
      }
    }
    function $(O, _) {
      (_ == null || _ > O.length) && (_ = O.length);
      for (var w = 0, F = new Array(_); w < _; w++)
        F[w] = O[w];
      return F;
    }
    var y = /* @__PURE__ */ function() {
      function O() {
        this.list = /* @__PURE__ */ new Set(), this.refs = /* @__PURE__ */ new Map();
      }
      var _ = O.prototype;
      return _.describe = function() {
        for (var F = [], j = g(this.list), Y; !(Y = j()).done; ) {
          var ie = Y.value;
          F.push(ie);
        }
        for (var Ae = g(this.refs), ge; !(ge = Ae()).done; ) {
          var Pe = ge.value, ee = Pe[1];
          F.push(ee.describe());
        }
        return F;
      }, _.toArray = function() {
        return (0, o.default)(this.list).concat((0, o.default)(this.refs.values()));
      }, _.add = function(F) {
        m.default.isRef(F) ? this.refs.set(F.key, F) : this.list.add(F);
      }, _.delete = function(F) {
        m.default.isRef(F) ? this.refs.delete(F.key) : this.list.delete(F);
      }, _.has = function(F, j) {
        if (this.list.has(F)) return !0;
        for (var Y, ie = this.refs.values(); Y = ie.next(), !Y.done; )
          if (j(Y.value) === F) return !0;
        return !1;
      }, _.clone = function() {
        var F = new O();
        return F.list = new Set(this.list), F.refs = new Map(this.refs), F;
      }, _.merge = function(F, j) {
        var Y = this.clone();
        return F.list.forEach(function(ie) {
          return Y.add(ie);
        }), F.refs.forEach(function(ie) {
          return Y.add(ie);
        }), j.list.forEach(function(ie) {
          return Y.delete(ie);
        }), j.refs.forEach(function(ie) {
          return Y.delete(ie);
        }), Y;
      }, (0, a.default)(O, [{
        key: "size",
        get: function() {
          return this.list.size + this.refs.size;
        }
      }]), O;
    }();
    function A(O) {
      var _ = this;
      if (O === void 0 && (O = {}), !(this instanceof A)) return new A();
      this._deps = [], this._conditions = [], this._options = {
        abortEarly: !0,
        recursive: !0
      }, this._exclusive = /* @__PURE__ */ Object.create(null), this._whitelist = new y(), this._blacklist = new y(), this.tests = [], this.transforms = [], this.withMutation(function() {
        _.typeError(l.mixed.notType);
      }), (0, i.default)(O, "default") && (this._defaultDefault = O.default), this.type = O.type || "mixed", this._type = O.type || "mixed";
    }
    for (var E = A.prototype = {
      __isYupSchema__: !0,
      constructor: A,
      clone: function() {
        var _ = this;
        return this._mutate ? this : (0, s.default)(this, function(w) {
          if ((0, f.default)(w) && w !== _) return w;
        });
      },
      label: function(_) {
        var w = this.clone();
        return w._label = _, w;
      },
      meta: function(_) {
        if (arguments.length === 0) return this._meta;
        var w = this.clone();
        return w._meta = (0, r.default)(w._meta || {}, _), w;
      },
      withMutation: function(_) {
        var w = this._mutate;
        this._mutate = !0;
        var F = _(this);
        return this._mutate = w, F;
      },
      concat: function(_) {
        if (!_ || _ === this) return this;
        if (_._type !== this._type && this._type !== "mixed") throw new TypeError("You cannot `concat()` schema's of different types: " + this._type + " and " + _._type);
        var w = (0, d.default)(_.clone(), this);
        return (0, i.default)(_, "_default") && (w._default = _._default), w.tests = this.tests, w._exclusive = this._exclusive, w._whitelist = this._whitelist.merge(_._whitelist, _._blacklist), w._blacklist = this._blacklist.merge(_._blacklist, _._whitelist), w.withMutation(function(F) {
          _.tests.forEach(function(j) {
            F.test(j.OPTIONS);
          });
        }), w;
      },
      isType: function(_) {
        return this._nullable && _ === null ? !0 : !this._typeCheck || this._typeCheck(_);
      },
      resolve: function(_) {
        var w = this;
        if (w._conditions.length) {
          var F = w._conditions;
          w = w.clone(), w._conditions = [], w = F.reduce(function(j, Y) {
            return Y.resolve(j, _);
          }, w), w = w.resolve(_);
        }
        return w;
      },
      cast: function(_, w) {
        w === void 0 && (w = {});
        var F = this.resolve((0, r.default)({}, w, {
          value: _
        })), j = F._cast(_, w);
        if (_ !== void 0 && w.assert !== !1 && F.isType(j) !== !0) {
          var Y = (0, h.default)(_), ie = (0, h.default)(j);
          throw new TypeError("The value of " + (w.path || "field") + " could not be cast to a value " + ('that satisfies the schema type: "' + F._type + `". 

`) + ("attempted value: " + Y + ` 
`) + (ie !== Y ? "result of cast: " + ie : ""));
        }
        return j;
      },
      _cast: function(_) {
        var w = this, F = _ === void 0 ? _ : this.transforms.reduce(function(j, Y) {
          return Y.call(w, j, _);
        }, _);
        return F === void 0 && (0, i.default)(this, "_default") && (F = this.default()), F;
      },
      _validate: function(_, w) {
        var F = this;
        w === void 0 && (w = {});
        var j = _, Y = w.originalValue != null ? w.originalValue : _, ie = this._option("strict", w), Ae = this._option("abortEarly", w), ge = w.sync, Pe = w.path, ee = this._label;
        ie || (j = this._cast(j, (0, r.default)({
          assert: !1
        }, w)));
        var ue = {
          value: j,
          path: Pe,
          schema: this,
          options: w,
          label: ee,
          originalValue: Y,
          sync: ge
        };
        w.from && (ue.from = w.from);
        var ye = [];
        return this._typeError && ye.push(this._typeError(ue)), this._whitelistError && ye.push(this._whitelistError(ue)), this._blacklistError && ye.push(this._blacklistError(ue)), (0, c.default)({
          validations: ye,
          endEarly: Ae,
          value: j,
          path: Pe,
          sync: ge
        }).then(function($e) {
          return (0, c.default)({
            path: Pe,
            sync: ge,
            value: $e,
            endEarly: Ae,
            validations: F.tests.map(function(be) {
              return be(ue);
            })
          });
        });
      },
      validate: function(_, w) {
        w === void 0 && (w = {});
        var F = this.resolve((0, r.default)({}, w, {
          value: _
        }));
        return F._validate(_, w);
      },
      validateSync: function(_, w) {
        w === void 0 && (w = {});
        var F = this.resolve((0, r.default)({}, w, {
          value: _
        })), j, Y;
        if (F._validate(_, (0, r.default)({}, w, {
          sync: !0
        })).then(function(ie) {
          return j = ie;
        }).catch(function(ie) {
          return Y = ie;
        }), Y) throw Y;
        return j;
      },
      isValid: function(_, w) {
        return this.validate(_, w).then(function() {
          return !0;
        }).catch(function(F) {
          if (F.name === "ValidationError") return !1;
          throw F;
        });
      },
      isValidSync: function(_, w) {
        try {
          return this.validateSync(_, w), !0;
        } catch (F) {
          if (F.name === "ValidationError") return !1;
          throw F;
        }
      },
      getDefault: function(_) {
        _ === void 0 && (_ = {});
        var w = this.resolve(_);
        return w.default();
      },
      default: function(_) {
        if (arguments.length === 0) {
          var w = (0, i.default)(this, "_default") ? this._default : this._defaultDefault;
          return typeof w == "function" ? w.call(this) : (0, s.default)(w);
        }
        var F = this.clone();
        return F._default = _, F;
      },
      strict: function(_) {
        _ === void 0 && (_ = !0);
        var w = this.clone();
        return w._options.strict = _, w;
      },
      _isPresent: function(_) {
        return _ != null;
      },
      required: function(_) {
        return _ === void 0 && (_ = l.mixed.required), this.test({
          message: _,
          name: "required",
          exclusive: !0,
          test: function(F) {
            return this.schema._isPresent(F);
          }
        });
      },
      notRequired: function() {
        var _ = this.clone();
        return _.tests = _.tests.filter(function(w) {
          return w.OPTIONS.name !== "required";
        }), _;
      },
      nullable: function(_) {
        _ === void 0 && (_ = !0);
        var w = this.clone();
        return w._nullable = _, w;
      },
      transform: function(_) {
        var w = this.clone();
        return w.transforms.push(_), w;
      },
      /**
       * Adds a test function to the schema's queue of tests.
       * tests can be exclusive or non-exclusive.
       *
       * - exclusive tests, will replace any existing tests of the same name.
       * - non-exclusive: can be stacked
       *
       * If a non-exclusive test is added to a schema with an exclusive test of the same name
       * the exclusive test is removed and further tests of the same name will be stacked.
       *
       * If an exclusive test is added to a schema with non-exclusive tests of the same name
       * the previous tests are removed and further tests of the same name will replace each other.
       */
      test: function() {
        var _;
        if (arguments.length === 1 ? typeof (arguments.length <= 0 ? void 0 : arguments[0]) == "function" ? _ = {
          test: arguments.length <= 0 ? void 0 : arguments[0]
        } : _ = arguments.length <= 0 ? void 0 : arguments[0] : arguments.length === 2 ? _ = {
          name: arguments.length <= 0 ? void 0 : arguments[0],
          test: arguments.length <= 1 ? void 0 : arguments[1]
        } : _ = {
          name: arguments.length <= 0 ? void 0 : arguments[0],
          message: arguments.length <= 1 ? void 0 : arguments[1],
          test: arguments.length <= 2 ? void 0 : arguments[2]
        }, _.message === void 0 && (_.message = l.mixed.default), typeof _.test != "function") throw new TypeError("`test` is a required parameters");
        var w = this.clone(), F = (0, p.default)(_), j = _.exclusive || _.name && w._exclusive[_.name] === !0;
        if (_.exclusive && !_.name)
          throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
        return w._exclusive[_.name] = !!_.exclusive, w.tests = w.tests.filter(function(Y) {
          return !(Y.OPTIONS.name === _.name && (j || Y.OPTIONS.test === F.OPTIONS.test));
        }), w.tests.push(F), w;
      },
      when: function(_, w) {
        arguments.length === 1 && (w = _, _ = ".");
        var F = this.clone(), j = [].concat(_).map(function(Y) {
          return new m.default(Y);
        });
        return j.forEach(function(Y) {
          Y.isSibling && F._deps.push(Y.key);
        }), F._conditions.push(new u.default(j, w)), F;
      },
      typeError: function(_) {
        var w = this.clone();
        return w._typeError = (0, p.default)({
          message: _,
          name: "typeError",
          test: function(j) {
            return j !== void 0 && !this.schema.isType(j) ? this.createError({
              params: {
                type: this.schema._type
              }
            }) : !0;
          }
        }), w;
      },
      oneOf: function(_, w) {
        w === void 0 && (w = l.mixed.oneOf);
        var F = this.clone();
        return _.forEach(function(j) {
          F._whitelist.add(j), F._blacklist.delete(j);
        }), F._whitelistError = (0, p.default)({
          message: w,
          name: "oneOf",
          test: function(Y) {
            if (Y === void 0) return !0;
            var ie = this.schema._whitelist;
            return ie.has(Y, this.resolve) ? !0 : this.createError({
              params: {
                values: ie.toArray().join(", ")
              }
            });
          }
        }), F;
      },
      notOneOf: function(_, w) {
        w === void 0 && (w = l.mixed.notOneOf);
        var F = this.clone();
        return _.forEach(function(j) {
          F._blacklist.add(j), F._whitelist.delete(j);
        }), F._blacklistError = (0, p.default)({
          message: w,
          name: "notOneOf",
          test: function(Y) {
            var ie = this.schema._blacklist;
            return ie.has(Y, this.resolve) ? this.createError({
              params: {
                values: ie.toArray().join(", ")
              }
            }) : !0;
          }
        }), F;
      },
      strip: function(_) {
        _ === void 0 && (_ = !0);
        var w = this.clone();
        return w._strip = _, w;
      },
      _option: function(_, w) {
        return (0, i.default)(w, _) ? w[_] : this._options[_];
      },
      describe: function() {
        var _ = this.clone(), w = {
          type: _._type,
          meta: _._meta,
          label: _._label,
          tests: _.tests.map(function(F) {
            return {
              name: F.OPTIONS.name,
              params: F.OPTIONS.params
            };
          }).filter(function(F, j, Y) {
            return Y.findIndex(function(ie) {
              return ie.name === F.name;
            }) === j;
          })
        };
        return _._whitelist.size && (w.oneOf = _._whitelist.describe()), _._blacklist.size && (w.notOneOf = _._blacklist.describe()), w;
      },
      defined: function(_) {
        return _ === void 0 && (_ = l.mixed.defined), this.nullable().test({
          message: _,
          name: "defined",
          exclusive: !0,
          test: function(F) {
            return F !== void 0;
          }
        });
      }
    }, L = function() {
      var _ = ne[D];
      E[_ + "At"] = function(w, F, j) {
        j === void 0 && (j = {});
        var Y = (0, v.getIn)(this, w, F, j.context), ie = Y.parent, Ae = Y.parentPath, ge = Y.schema;
        return ge[_](ie && ie[Ae], (0, r.default)({}, j, {
          parent: ie,
          path: w
        }));
      };
    }, D = 0, ne = ["validate", "validateSync"]; D < ne.length; D++)
      L();
    for (var I = 0, B = ["equals", "is"]; I < B.length; I++) {
      var ae = B[I];
      E[ae] = E.oneOf;
    }
    for (var we = 0, Q = ["not", "nope"]; we < Q.length; we++) {
      var W = Q[we];
      E[W] = E.notOneOf;
    }
    E.optional = E.notRequired, e.exports = t.default;
  }(Na, Na.exports)), Na.exports;
}
var Ha = { exports: {} }, ef;
function LW() {
  return ef || (ef = 1, function(e, t) {
    t.__esModule = !0, t.default = void 0;
    var n = function(a) {
      return a == null;
    };
    t.default = n, e.exports = t.default;
  }(Ha, Ha.exports)), Ha.exports;
}
(function(e, t) {
  var n = on;
  t.__esModule = !0, t.default = d;
  var r = n(Yq()), a = n(kW()), i = Rp(), s = n(LW()), o = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i, l = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i, u = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i, c = function(p) {
    return (0, s.default)(p) || p === p.trim();
  };
  function d() {
    var f = this;
    if (!(this instanceof d)) return new d();
    a.default.call(this, {
      type: "string"
    }), this.withMutation(function() {
      f.transform(function(p) {
        return this.isType(p) ? p : p != null && p.toString ? p.toString() : p;
      });
    });
  }
  (0, r.default)(d, a.default, {
    _typeCheck: function(p) {
      return p instanceof String && (p = p.valueOf()), typeof p == "string";
    },
    _isPresent: function(p) {
      return a.default.prototype._isPresent.call(this, p) && p.length > 0;
    },
    length: function(p, h) {
      return h === void 0 && (h = i.string.length), this.test({
        message: h,
        name: "length",
        exclusive: !0,
        params: {
          length: p
        },
        test: function(v) {
          return (0, s.default)(v) || v.length === this.resolve(p);
        }
      });
    },
    min: function(p, h) {
      return h === void 0 && (h = i.string.min), this.test({
        message: h,
        name: "min",
        exclusive: !0,
        params: {
          min: p
        },
        test: function(v) {
          return (0, s.default)(v) || v.length >= this.resolve(p);
        }
      });
    },
    max: function(p, h) {
      return h === void 0 && (h = i.string.max), this.test({
        name: "max",
        exclusive: !0,
        message: h,
        params: {
          max: p
        },
        test: function(v) {
          return (0, s.default)(v) || v.length <= this.resolve(p);
        }
      });
    },
    matches: function(p, h) {
      var m = !1, v, g;
      return h && (typeof h == "object" ? (m = h.excludeEmptyString, v = h.message, g = h.name) : v = h), this.test({
        name: g || "matches",
        message: v || i.string.matches,
        params: {
          regex: p
        },
        test: function($) {
          return (0, s.default)($) || $ === "" && m || $.search(p) !== -1;
        }
      });
    },
    email: function(p) {
      return p === void 0 && (p = i.string.email), this.matches(o, {
        name: "email",
        message: p,
        excludeEmptyString: !0
      });
    },
    url: function(p) {
      return p === void 0 && (p = i.string.url), this.matches(l, {
        name: "url",
        message: p,
        excludeEmptyString: !0
      });
    },
    uuid: function(p) {
      return p === void 0 && (p = i.string.uuid), this.matches(u, {
        name: "uuid",
        message: p,
        excludeEmptyString: !1
      });
    },
    //-- transforms --
    ensure: function() {
      return this.default("").transform(function(p) {
        return p === null ? "" : p;
      });
    },
    trim: function(p) {
      return p === void 0 && (p = i.string.trim), this.transform(function(h) {
        return h != null ? h.trim() : h;
      }).test({
        message: p,
        name: "trim",
        test: c
      });
    },
    lowercase: function(p) {
      return p === void 0 && (p = i.string.lowercase), this.transform(function(h) {
        return (0, s.default)(h) ? h : h.toLowerCase();
      }).test({
        message: p,
        name: "string_case",
        exclusive: !0,
        test: function(m) {
          return (0, s.default)(m) || m === m.toLowerCase();
        }
      });
    },
    uppercase: function(p) {
      return p === void 0 && (p = i.string.uppercase), this.transform(function(h) {
        return (0, s.default)(h) ? h : h.toUpperCase();
      }).test({
        message: p,
        name: "string_case",
        exclusive: !0,
        test: function(m) {
          return (0, s.default)(m) || m === m.toUpperCase();
        }
      });
    }
  }), e.exports = t.default;
})(ed, ed.exports);
const FW = /[^a-zA-Z0-9]/g;
function zW(e) {
  return this.withMutation(() => {
    this.transform((t) => t.replace(FW, ""));
  }), this.test({
    name: "germanTaxId",
    message: e || "Invalid TIN",
    exclusive: !0,
    test: (t) => Wq.validate(t)
  });
}
/*!
 * @license
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */
/**
 * Validation, extraction and creation of IBAN, BBAN, BIC/SWIFT numbers plus some other helpful stuff
 * @packageDocumentation
 * @author Saša Jovanić
 * @module ibantools
 * @version 3.3.1
 * @license MPL-2.0
 * @preferred
 */
function PW(e) {
  if (e != null) {
    var t = new RegExp("^[0-9]{2}$", ""), n = RW[e.slice(0, 2)];
    if (n !== void 0 && n.bban_regexp && n.bban_regexp !== null && n.chars && n.chars === e.length && t.test(e.slice(2, 4)) && IW(e.slice(4), n.bban_regexp) && DW(e))
      return !0;
  }
  return !1;
}
var tf;
(function(e) {
  e[e.NoIBANProvided = 0] = "NoIBANProvided", e[e.NoIBANCountry = 1] = "NoIBANCountry", e[e.WrongBBANLength = 2] = "WrongBBANLength", e[e.WrongBBANFormat = 3] = "WrongBBANFormat", e[e.ChecksumNotNumber = 4] = "ChecksumNotNumber", e[e.WrongIBANChecksum = 5] = "WrongIBANChecksum";
})(tf || (tf = {}));
function IW(e, t) {
  var n = new RegExp(t, "");
  return n.test(e);
}
function NW(e) {
  return typeof e != "string" ? null : e.replace(/[-\ ]/g, "").toUpperCase();
}
function DW(e) {
  for (var t = parseInt(e.slice(2, 4), 10), n = e.slice(3) + e.slice(0, 2) + "00", r = "", a = 1; a < n.length; a++) {
    var i = n.charCodeAt(a);
    i >= 65 ? r += (i - 55).toString() : r += n[a];
  }
  for (; r.length > 2; ) {
    var s = r.slice(0, 6);
    r = (parseInt(s, 10) % 97).toString() + r.slice(s.length);
  }
  var o = parseInt(r, 10) % 97;
  return 98 - o === t;
}
var nf;
(function(e) {
  e[e.NoBICProvided = 0] = "NoBICProvided", e[e.NoBICCountry = 1] = "NoBICCountry", e[e.WrongBICFormat = 2] = "WrongBICFormat";
})(nf || (nf = {}));
var RW = {
  AD: {
    chars: 24,
    bban_regexp: "^[0-9]{8}[A-Z0-9]{12}$",
    IBANRegistry: !0,
    SEPA: !0
  },
  AE: {
    chars: 23,
    bban_regexp: "^[0-9]{3}[0-9]{16}$",
    IBANRegistry: !0
  },
  AF: {},
  AG: {},
  AI: {},
  AL: {
    chars: 28,
    bban_regexp: "^[0-9]{8}[A-Z0-9]{16}$",
    IBANRegistry: !0
  },
  AM: {},
  AO: {
    chars: 25,
    bban_regexp: "^[0-9]{21}$"
  },
  AQ: {},
  AR: {},
  AS: {},
  AT: { chars: 20, bban_regexp: "^[0-9]{16}$", IBANRegistry: !0, SEPA: !0 },
  AU: {},
  AW: {},
  AX: {
    chars: 18,
    bban_regexp: "^[0-9]{14}$",
    IBANRegistry: !0
  },
  AZ: {
    chars: 28,
    bban_regexp: "^[A-Z]{4}[A-Z0-9]{20}$",
    IBANRegistry: !0
  },
  BA: {
    chars: 20,
    bban_regexp: "^[0-9]{16}$",
    IBANRegistry: !0
  },
  BB: {},
  BD: {},
  BE: { chars: 16, bban_regexp: "^[0-9]{12}$", IBANRegistry: !0, SEPA: !0 },
  BF: {
    chars: 28,
    bban_regexp: "^[A-Z0-9]{2}[0-9]{22}$"
  },
  BG: {
    chars: 22,
    bban_regexp: "^[A-Z]{4}[0-9]{6}[A-Z0-9]{8}$",
    IBANRegistry: !0,
    SEPA: !0
  },
  BH: {
    chars: 22,
    bban_regexp: "^[A-Z]{4}[A-Z0-9]{14}$",
    IBANRegistry: !0
  },
  BI: {
    chars: 16,
    bban_regexp: "^[0-9]{12}$"
  },
  BJ: {
    chars: 28,
    bban_regexp: "^[A-Z0-9]{2}[0-9]{22}$"
  },
  BL: {
    chars: 27,
    bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
    IBANRegistry: !0
  },
  BM: {},
  BN: {},
  BO: {},
  BQ: {},
  BR: {
    chars: 29,
    bban_regexp: "^[0-9]{23}[A-Z]{1}[A-Z0-9]{1}$",
    IBANRegistry: !0
  },
  BS: {},
  BT: {},
  BV: {},
  BW: {},
  BY: {
    chars: 28,
    bban_regexp: "^[A-Z]{4}[0-9]{4}[A-Z0-9]{16}$",
    IBANRegistry: !0
  },
  BZ: {},
  CA: {},
  CC: {},
  CD: {},
  CF: {
    chars: 27,
    bban_regexp: "^[0-9]{23}$"
  },
  CG: {
    chars: 27,
    bban_regexp: "^[0-9]{23}$"
  },
  CH: {
    chars: 21,
    bban_regexp: "^[0-9]{5}[A-Z0-9]{12}$",
    IBANRegistry: !0,
    SEPA: !0
  },
  CI: {
    chars: 28,
    bban_regexp: "^[A-Z]{1}[0-9]{23}$"
  },
  CK: {},
  CL: {},
  CM: {
    chars: 27,
    bban_regexp: "^[0-9]{23}$"
  },
  CN: {},
  CO: {},
  CR: {
    chars: 22,
    bban_regexp: "^[0-9]{18}$",
    IBANRegistry: !0
  },
  CU: {},
  CV: { chars: 25, bban_regexp: "^[0-9]{21}$" },
  CW: {},
  CX: {},
  CY: {
    chars: 28,
    bban_regexp: "^[0-9]{8}[A-Z0-9]{16}$",
    IBANRegistry: !0,
    SEPA: !0
  },
  CZ: { chars: 24, bban_regexp: "^[0-9]{20}$", IBANRegistry: !0, SEPA: !0 },
  DE: { chars: 22, bban_regexp: "^[0-9]{18}$", IBANRegistry: !0, SEPA: !0 },
  DJ: {
    chars: 27,
    bban_regexp: "^[0-9]{23}$"
  },
  DK: { chars: 18, bban_regexp: "^[0-9]{14}$", IBANRegistry: !0, SEPA: !0 },
  DM: {},
  DO: {
    chars: 28,
    bban_regexp: "^[A-Z]{4}[0-9]{20}$",
    IBANRegistry: !0
  },
  DZ: {
    chars: 26,
    bban_regexp: "^[0-9]{22}$"
  },
  EC: {},
  EE: { chars: 20, bban_regexp: "^[0-9]{16}$", IBANRegistry: !0, SEPA: !0 },
  EG: { chars: 29, bban_regexp: "^[0-9]{25}", IBANRegistry: !0 },
  EH: {},
  ER: {},
  ES: { chars: 24, bban_regexp: "^[0-9]{20}$", IBANRegistry: !0, SEPA: !0 },
  ET: {},
  FI: { chars: 18, bban_regexp: "^[0-9]{14}$", IBANRegistry: !0, SEPA: !0 },
  FJ: {},
  FK: {},
  FM: {},
  FO: { chars: 18, bban_regexp: "^[0-9]{14}$", IBANRegistry: !0 },
  FR: {
    chars: 27,
    bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
    IBANRegistry: !0,
    SEPA: !0
  },
  GA: {
    chars: 27,
    bban_regexp: "^[0-9]{23}$"
  },
  GB: {
    chars: 22,
    bban_regexp: "^[A-Z]{4}[0-9]{14}$",
    IBANRegistry: !0,
    SEPA: !0
  },
  GD: {},
  GE: {
    chars: 22,
    bban_regexp: "^[A-Z0-9]{2}[0-9]{16}$",
    IBANRegistry: !0
  },
  GF: {
    chars: 27,
    bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
    IBANRegistry: !0
  },
  GG: {},
  GH: {},
  GI: {
    chars: 23,
    bban_regexp: "^[A-Z]{4}[A-Z0-9]{15}$",
    IBANRegistry: !0,
    SEPA: !0
  },
  GL: { chars: 18, bban_regexp: "^[0-9]{14}$", IBANRegistry: !0 },
  GM: {},
  GN: {},
  GP: {
    chars: 27,
    bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
    IBANRegistry: !0
  },
  GQ: {
    chars: 27,
    bban_regexp: "^[0-9]{23}$"
  },
  GR: {
    chars: 27,
    bban_regexp: "^[0-9]{7}[A-Z0-9]{16}$",
    IBANRegistry: !0,
    SEPA: !0
  },
  GS: {},
  GT: {
    chars: 28,
    bban_regexp: "^[A-Z0-9]{24}$",
    IBANRegistry: !0
  },
  GU: {},
  GW: {
    chars: 25,
    bban_regexp: "^[A-Z]{2}[0-9]{19}$"
  },
  GY: {},
  HK: {},
  HM: {},
  HN: {
    chars: 28,
    bban_regexp: "^[A-Z]{4}[0-9]{20}$"
  },
  HR: { chars: 21, bban_regexp: "^[0-9]{17}$", IBANRegistry: !0, SEPA: !0 },
  HT: {},
  HU: { chars: 28, bban_regexp: "^[0-9]{24}$", IBANRegistry: !0, SEPA: !0 },
  ID: {},
  IE: {
    chars: 22,
    bban_regexp: "^[A-Z0-9]{4}[0-9]{14}$",
    IBANRegistry: !0,
    SEPA: !0
  },
  IL: {
    chars: 23,
    bban_regexp: "^[0-9]{19}$",
    IBANRegistry: !0
  },
  IM: {},
  IN: {},
  IO: {},
  IQ: {
    chars: 23,
    bban_regexp: "^[A-Z]{4}[0-9]{15}$",
    IBANRegistry: !0
  },
  IR: {
    chars: 26,
    bban_regexp: "^[0-9]{22}$"
  },
  IS: { chars: 26, bban_regexp: "^[0-9]{22}$", IBANRegistry: !0, SEPA: !0 },
  IT: {
    chars: 27,
    bban_regexp: "^[A-Z]{1}[0-9]{10}[A-Z0-9]{12}$",
    IBANRegistry: !0,
    SEPA: !0
  },
  JE: {},
  JM: {},
  JO: {
    chars: 30,
    bban_regexp: "^[A-Z]{4}[0-9]{4}[A-Z0-9]{18}$",
    IBANRegistry: !0
  },
  JP: {},
  KE: {},
  KG: {},
  KH: {},
  KI: {},
  KM: {
    chars: 27,
    bban_regexp: "^[0-9]{23}$"
  },
  KN: {},
  KP: {},
  KR: {},
  KW: {
    chars: 30,
    bban_regexp: "^[A-Z]{4}[A-Z0-9]{22}$",
    IBANRegistry: !0
  },
  KY: {},
  KZ: {
    chars: 20,
    bban_regexp: "^[0-9]{3}[A-Z0-9]{13}$",
    IBANRegistry: !0
  },
  LA: {},
  LB: {
    chars: 28,
    bban_regexp: "^[0-9]{4}[A-Z0-9]{20}$",
    IBANRegistry: !0
  },
  LC: {
    chars: 32,
    bban_regexp: "^[A-Z]{4}[A-Z0-9]{24}$",
    IBANRegistry: !0
  },
  LI: {
    chars: 21,
    bban_regexp: "^[0-9]{5}[A-Z0-9]{12}$",
    IBANRegistry: !0,
    SEPA: !0
  },
  LK: {},
  LR: {},
  LS: {},
  LT: { chars: 20, bban_regexp: "^[0-9]{16}$", IBANRegistry: !0, SEPA: !0 },
  LU: {
    chars: 20,
    bban_regexp: "^[0-9]{3}[A-Z0-9]{13}$",
    IBANRegistry: !0,
    SEPA: !0
  },
  LV: {
    chars: 21,
    bban_regexp: "^[A-Z]{4}[A-Z0-9]{13}$",
    IBANRegistry: !0,
    SEPA: !0
  },
  LY: {
    chars: 25,
    bban_regexp: "^[0-9]{21}$",
    IBANRegistry: !0
  },
  MA: {
    chars: 28,
    bban_regexp: "^[0-9]{24}$"
  },
  MC: {
    chars: 27,
    bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
    IBANRegistry: !0,
    SEPA: !0
  },
  MD: {
    chars: 24,
    bban_regexp: "^[A-Z0-9]{2}[A-Z0-9]{18}$",
    IBANRegistry: !0
  },
  ME: {
    chars: 22,
    bban_regexp: "^[0-9]{18}$",
    IBANRegistry: !0
  },
  MF: {
    chars: 27,
    bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
    IBANRegistry: !0
  },
  MG: {
    chars: 27,
    bban_regexp: "^[0-9]{23}$"
  },
  MH: {},
  MK: {
    chars: 19,
    bban_regexp: "^[0-9]{3}[A-Z0-9]{10}[0-9]{2}$",
    IBANRegistry: !0
  },
  ML: {
    chars: 28,
    bban_regexp: "^[A-Z0-9]{2}[0-9]{22}$"
  },
  MM: {},
  MN: {},
  MO: {},
  MP: {},
  MQ: {
    chars: 27,
    bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
    IBANRegistry: !0
  },
  MR: {
    chars: 27,
    bban_regexp: "^[0-9]{23}$",
    IBANRegistry: !0
  },
  MS: {},
  MT: {
    chars: 31,
    bban_regexp: "^[A-Z]{4}[0-9]{5}[A-Z0-9]{18}$",
    IBANRegistry: !0,
    SEPA: !0
  },
  MU: {
    chars: 30,
    bban_regexp: "^[A-Z]{4}[0-9]{19}[A-Z]{3}$",
    IBANRegistry: !0
  },
  MV: {},
  MW: {},
  MX: {},
  MY: {},
  MZ: {
    chars: 25,
    bban_regexp: "^[0-9]{21}$"
  },
  NA: {},
  NC: {
    chars: 27,
    bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
    IBANRegistry: !0
  },
  NE: {
    chars: 28,
    bban_regexp: "^[A-Z]{2}[0-9]{22}$"
  },
  NF: {},
  NG: {},
  NI: {
    chars: 32,
    bban_regexp: "^[A-Z]{4}[0-9]{24}$"
  },
  NL: {
    chars: 18,
    bban_regexp: "^[A-Z]{4}[0-9]{10}$",
    IBANRegistry: !0,
    SEPA: !0
  },
  NO: { chars: 15, bban_regexp: "^[0-9]{11}$", IBANRegistry: !0, SEPA: !0 },
  NP: {},
  NR: {},
  NU: {},
  NZ: {},
  OM: {},
  PA: {},
  PE: {},
  PF: {
    chars: 27,
    bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
    IBANRegistry: !0
  },
  PG: {},
  PH: {},
  PK: {
    chars: 24,
    bban_regexp: "^[A-Z0-9]{4}[0-9]{16}$",
    IBANRegistry: !0
  },
  PL: { chars: 28, bban_regexp: "^[0-9]{24}$", IBANRegistry: !0, SEPA: !0 },
  PM: {
    chars: 27,
    bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
    IBANRegistry: !0
  },
  PN: {},
  PR: {},
  PS: {
    chars: 29,
    bban_regexp: "^[A-Z0-9]{4}[0-9]{21}$",
    IBANRegistry: !0
  },
  PT: { chars: 25, bban_regexp: "^[0-9]{21}$", IBANRegistry: !0, SEPA: !0 },
  PW: {},
  PY: {},
  QA: {
    chars: 29,
    bban_regexp: "^[A-Z]{4}[A-Z0-9]{21}$",
    IBANRegistry: !0
  },
  RE: {
    chars: 27,
    bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
    IBANRegistry: !0
  },
  RO: {
    chars: 24,
    bban_regexp: "^[A-Z]{4}[A-Z0-9]{16}$",
    IBANRegistry: !0,
    SEPA: !0
  },
  RS: {
    chars: 22,
    bban_regexp: "^[0-9]{18}$",
    IBANRegistry: !0
  },
  RU: {},
  RW: {},
  SA: {
    chars: 24,
    bban_regexp: "^[0-9]{2}[A-Z0-9]{18}$",
    IBANRegistry: !0
  },
  SB: {},
  SC: {
    chars: 31,
    bban_regexp: "^[A-Z]{4}[0-9]{20}[A-Z]{3}$",
    IBANRegistry: !0
  },
  SD: {},
  SE: { chars: 24, bban_regexp: "^[0-9]{20}$", IBANRegistry: !0, SEPA: !0 },
  SG: {},
  SH: {},
  SI: { chars: 19, bban_regexp: "^[0-9]{15}$", IBANRegistry: !0, SEPA: !0 },
  SJ: {},
  SK: { chars: 24, bban_regexp: "^[0-9]{20}$", IBANRegistry: !0, SEPA: !0 },
  SL: {},
  SM: {
    chars: 27,
    bban_regexp: "^[A-Z]{1}[0-9]{10}[A-Z0-9]{12}$",
    IBANRegistry: !0,
    SEPA: !0
  },
  SN: {
    chars: 28,
    bban_regexp: "^[A-Z]{1}[0-9]{23}$"
  },
  SO: {},
  SR: {},
  SS: {},
  ST: {
    chars: 25,
    bban_regexp: "^[0-9]{21}$",
    IBANRegistry: !0
  },
  SV: {
    chars: 28,
    bban_regexp: "^[A-Z]{4}[0-9]{20}$",
    IBANRegistry: !0
  },
  SX: {},
  SY: {},
  SZ: {},
  TC: {},
  TD: {
    chars: 27,
    bban_regexp: "^[0-9]{23}$"
  },
  TF: {
    chars: 27,
    bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
    IBANRegistry: !0
  },
  TG: {
    chars: 28,
    bban_regexp: "^[A-Z]{2}[0-9]{22}$"
  },
  TH: {},
  TJ: {},
  TK: {},
  TL: {
    chars: 23,
    bban_regexp: "^[0-9]{19}$",
    IBANRegistry: !0
  },
  TM: {},
  TN: {
    chars: 24,
    bban_regexp: "^[0-9]{20}$",
    IBANRegistry: !0
  },
  TO: {},
  TR: {
    chars: 26,
    bban_regexp: "^[0-9]{5}[A-Z0-9]{17}$",
    IBANRegistry: !0
  },
  TT: {},
  TV: {},
  TW: {},
  TZ: {},
  UA: {
    chars: 29,
    bban_regexp: "^[0-9]{6}[A-Z0-9]{19}$",
    IBANRegistry: !0
  },
  UG: {},
  UM: {},
  US: {},
  UY: {},
  UZ: {},
  VA: { chars: 22, bban_regexp: "^[0-9]{18}", IBANRegistry: !0 },
  VC: {},
  VE: {},
  VG: {
    chars: 24,
    bban_regexp: "^[A-Z0-9]{4}[0-9]{16}$",
    IBANRegistry: !0
  },
  VI: {},
  VN: {},
  VU: {},
  WF: {
    chars: 27,
    bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
    IBANRegistry: !0
  },
  WS: {},
  XK: {
    chars: 20,
    bban_regexp: "^[0-9]{16}$",
    IBANRegistry: !0
  },
  YE: {},
  YT: {
    chars: 27,
    bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$",
    IBANRegistry: !0
  },
  ZA: {},
  ZM: {},
  ZW: {}
};
function jW(e) {
  return this.withMutation(() => {
    this.transform((t) => this.isType(t) ? NW(t) : t);
  }), this.test({
    name: "iban",
    message: e || "Invalid IBAN",
    exclusive: !0,
    test: (t) => this.isType(t) ? PW(t) : t
  });
}
Zu(Cr, "germanTaxId", zW);
Zu(Cr, "iban", jW);
Yt(Zi, "currencyMinValue", function(t, n) {
  return this.test(
    "currencyMinValue",
    t,
    function(a) {
      const { path: i, createError: s } = this, o = typeof a == "string" ? Number(a.replace(/\D/g, "")) : a;
      return a ? o >= t ? !0 : s({
        path: i,
        message: n ?? `De minimale waarde is ${ra(t)}`
      }) : s({
        path: i,
        message: "${path} is een verplicht veld"
      });
    }
  );
});
Yt(Zi, "currencyMaxValue", function(t, n) {
  return this.test(
    "currencyMaxValue",
    t,
    function(a) {
      const { path: i, createError: s } = this;
      return (typeof a == "string" ? Number(a.replace(/\D/g, "")) : a) <= t ? !0 : s({
        path: i,
        message: n ?? `De maximale waarde is ${ra(t)}`
      });
    }
  );
});
Yt(Zi, "isMultitudeOfThousand", function(t) {
  return this.test("testMultitudeOfThousand", async function(r) {
    if (!r) return !1;
    const { createError: a } = this;
    return /0{3}$/.test(r.toString()) ? !0 : a({
      message: t || "Moet een veelvoud zijn van duizend"
    });
  });
});
Yt(qt, "exclude", function(t) {
  return this.test("exclude-option", t, function(r) {
    const { path: a, createError: i } = this;
    return r !== t || i({ path: a, message: "${path} is een verplicht veld" });
  });
});
Yt(qt, "isMinLength", function(t, n) {
  return this.test("testMinimumLength", t, function(a = "") {
    const { createError: i } = this;
    return a.length >= t ? !0 : i({
      message: n || "Ongeldige invoer"
    });
  });
});
Yt(qt, "containsSpecialChar", function(t) {
  return this.test("testContainsSpecialChar", function(r = "") {
    const { createError: a } = this;
    return /[!"#$%&'()*+,./:;<=>?@[\\\]^_{|}~-]+/.test(r) ? !0 : a({
      message: t || "Ongeldige invoer"
    });
  });
});
Yt(qt, "containsNumber", function(t) {
  return this.test("testContainsNumber", function(r = "") {
    const { createError: a } = this;
    return /(?=.*\d)/.test(r) ? !0 : a({
      message: t || "Ongeldige invoer"
    });
  });
});
Yt(qt, "containsCapital", function(t) {
  return this.test("testContainsCapital", function(r = "") {
    const { createError: a } = this;
    return /(?=.*[A-Z])/.test(r) ? !0 : a({
      message: t || "Ongeldige invoer"
    });
  });
});
Yt(qt, "containsLowercase", function(t) {
  return this.test("testContainsLowercase", function(r = "") {
    const { createError: a } = this;
    return /(?=.*[a-z])/.test(r) ? !0 : a({
      message: t || "Ongeldige invoer"
    });
  });
});
const BW = jq.string().iban();
Yt(qt, "isValidIban", function(t) {
  return this.test("testValidIban", async function(r) {
    const { createError: a } = this;
    if (await BW.isValid(r)) return !0;
    const s = r && r.length > 0 ? "Ongeldige IBAN" : "IBAN is een verplicht veld";
    return a({
      message: t || s
    });
  });
});
Yt(qt, "isValidPhoneNumber", function(t) {
  return this.test("testIsValidPhoneNumber", function(r = "") {
    var l;
    const { path: a, createError: i } = this, s = Za(r, {
      defaultCallingCode: ((l = this.parent[`${a}_countrycode`]) == null ? void 0 : l.replace("+", "")) ?? "31"
    });
    if (s != null && s.isValid())
      return !0;
    const o = r && r.length > 0 ? "Ongeldig telefoonnummer" : "Telefoonnummer is een verplicht veld";
    return i({
      message: t || o
    });
  });
});
MR({
  mixed: {
    required: "${path} is een verplicht veld"
  },
  string: {
    email: "Vul een geldig e-mailadres in",
    min: "${path} moet minstens ${min} karakters bevatten",
    max: "${path} moet minstens ${max} karakters bevatten"
  }
});
const bY = async (e, t) => {
  const n = t ? {
    headers: {
      Authorization: t ? `Bearer ${t}` : ""
    }
  } : void 0, a = await (await fetch(e, n)).blob();
  return new Promise((i) => {
    const s = new FileReader();
    s.readAsArrayBuffer(a), s.addEventListener("load", (o) => {
      var c;
      const l = (c = o.target) == null ? void 0 : c.result, u = new Blob([l], { type: "application/pdf" });
      i(window.URL.createObjectURL(u));
    });
  });
}, $Y = async (e, t, n = !0, r) => {
  let a;
  if (n) {
    const s = t ? {
      headers: {
        Authorization: `Bearer ${t}`
      }
    } : void 0, o = await fetch(e, s);
    a = URL.createObjectURL(await o.blob());
  }
  const i = document.createElement("a");
  i.href = n && a ? a : e, i.target = "_blank", r && (i.download = r), document.body.append(i), i.dispatchEvent(
    new MouseEvent("click", {
      bubbles: !0,
      cancelable: !0,
      view: window
    })
  ), i.remove();
};
rm.add(Mv);
const yY = {
  install(e) {
    for (const t in s2)
      e.use(s2[t]);
  }
};
export {
  Ry as AppAutocompleteInput,
  St as AppButton,
  j3 as AppCard,
  B3 as AppCardContent,
  DC as AppCardGalleryHeader,
  zC as AppCardHeader,
  VC as AppCardSeperator,
  uy as AppCheckbox,
  Ay as AppCurrencyInput,
  sx as AppFinanceRange,
  gu as AppGallery,
  V3 as AppGalleryLightbox,
  vu as AppGallerySwiper,
  SA as AppHamburger,
  $r as AppImage,
  ui as AppInput,
  MC as AppLightbox,
  bA as AppLtvBar,
  GA as AppMarkDown,
  dA as AppModal,
  _A as AppNumberInput,
  fw as AppOfferCard,
  pO as AppPhoneInput,
  hA as AppPill,
  ZC as AppProgressBar,
  ux as AppRulesCheckList,
  a_ as AppSelect,
  Yy as AppSidebar,
  Xy as AppSidebarNavOption,
  yt as AppSkeleton,
  qn as AppSpecification,
  rA as AppTextAreaInput,
  l_ as AppTimer,
  gl as AppToast,
  y_ as AppToasts,
  XA as AppToggle,
  D3 as AppTooltip,
  pA as AppTooltips,
  $O as BreadCrumbs,
  PR as CallMeBack,
  tE as Confirmation,
  nu as DSTorST,
  E3 as DatePicker,
  RR as Document,
  SO as DragAndDrop,
  l4 as DropDown,
  te as FontAwesomeIcon,
  JR as Footer,
  R3 as FormWrapper,
  rE as InfiniteScroll,
  BE as MobileMenu,
  U$ as MogelijkLoader,
  YR as Onfido,
  cE as Radio,
  bE as RadioSelect,
  AE as RadioSquare,
  HR as Record,
  zE as SearchBar,
  KE as SidebarMenu,
  GR as SlideDown,
  u4 as TimePicker,
  qR as appendScriptToDocument,
  gY as appendStyleToDocument,
  TR as array,
  ZI as bool,
  tY as containsCapital,
  nY as containsLowercase,
  eY as containsNumber,
  QW as containsSpecialChar,
  U_ as debounce,
  yY as default,
  $Y as downloadPdf,
  aY as emailRegExp,
  Mv as fontAwesomeIcons,
  YW as formatDate,
  KW as formatDateDutch,
  ZW as formatDateLong,
  XW as formatDateLongWithTime,
  rY as formatIBAN,
  ra as formatMoney,
  WW as formatMonths,
  qW as formatMonthsToYears,
  GW as formatPercentage,
  bY as getBlobUrl,
  iY as getComponentHtml,
  ib as getCountryCodes,
  Cc as getFlagEmoji,
  JW as isMinLength,
  Zi as mixed,
  rN as number,
  _6 as object,
  sb as phoneRegExp,
  lu as randomString,
  MR as setLocale,
  Te as slugify,
  qt as string,
  lY as useModal,
  oY as useToast,
  g_ as useToasts,
  pr as useTooltip
};
